{
  "ar": {
    "active_admin": {
      "access_denied": {
        "message": "لم يُصرّح لك بهذا الإجراء."
      },
      "any": "أي",
      "batch_actions": {
        "action_label": "اُختير %{title}",
        "button_label": "إجراءات متعددة",
        "default_confirmation": "هل أنت متأكّد؟",
        "delete_confirmation": "هل أنت متأكّد من حذف هذه %{plural_model}؟",
        "labels": {
          "destroy": "حذف"
        },
        "selection_toggle_explanation": "(تتبيث الخيار)",
        "succesfully_destroyed": {
          "one": "حُذف بنجاح 1 %{model}",
          "other": "حُذف بنجاح %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "لايوجد %{resource_name} بعد.",
        "link": "إنشاء"
      },
      "cancel": "إلغاء",
      "comments": {
        "add": "إضافة تعليق",
        "author": "مؤلّف",
        "author_missing": "مجهول",
        "author_type": "نوع الؤلّف",
        "body": "هيكل",
        "created_at": "أُنشئ",
        "delete": "حذف تعليق",
        "delete_confirmation": "هل أنت متأكّد من حذف هذه التعليقات؟",
        "errors": {
          "empty_text": "لم يُحفظ التعليق، النص فارغ."
        },
        "no_comments_yet": "لا يوجد تعليقات بعد.",
        "resource": "مصدر",
        "resource_type": "نوع المصدر",
        "title_content": "تعليقات (%{count})"
      },
      "dashboard": "لوحة تحكم",
      "dashboard_welcome": {
        "call_to_action": "لإضافة أقسام إلى  لوحة التحكم, راجع: 'app/admin/dashboard.rb'",
        "welcome": "مرحبًا بك في في صفحة الإدارة، وهذه هي الصفحة الإفتراضيّة."
      },
      "delete": "حذف",
      "delete_confirmation": "هل تريد تأكيد الحذف؟",
      "delete_model": "حذف %{model}",
      "details": "تفاصيل %{model}",
      "devise": {
        "change_password": {
          "submit": "تغير كلمة المرور خاصتي",
          "title": "تغير كلمة المرور خاصتك"
        },
        "email": {
          "title": "البريد الإلكترونيّ"
        },
        "links": {
          "forgot_your_password": "هل نسيت كلمة المرور؟",
          "resend_confirmation_instructions": "إعادة إرسال تعليمات تأكيد الحساب",
          "resend_unlock_instructions": "إعادة إرسال تعليمات تنشيط الحساب",
          "sign_in": "تسجيل الدخول",
          "sign_in_with_omniauth_provider": "تسجيل الدخول بـ %{provider}",
          "sign_up": "التسجيل"
        },
        "login": {
          "remember_me": "تذكرني",
          "submit": "تسجيل الدخول",
          "title": "تسجيل الدخول"
        },
        "password": {
          "title": "كلمة المرور"
        },
        "resend_confirmation_instructions": {
          "submit": "إعادة ارسال تعليمات التأكيد",
          "title": "إعادة ارسال تعليمات التأكيد"
        },
        "reset_password": {
          "submit": "استرجاع كلمة المرور",
          "title": "هل نسيت كلمة المرور؟"
        },
        "sign_up": {
          "submit": "تسجيل",
          "title": "تسجيل"
        },
        "subdomain": {
          "title": "مجال فرعي"
        },
        "unlock": {
          "submit": "إعادة إرسال تعليمات فك الحظر",
          "title": "إعادة إرسال تعليمات فك الحظر"
        },
        "username": {
          "title": "اسم المستخدم"
        }
      },
      "download": "تحميل",
      "dropdown_actions": {
        "button_label": "إجراءات"
      },
      "edit": "تعديل",
      "edit_model": "تعديل %{model}",
      "empty": "فارغ",
      "filters": {
        "buttons": {
          "clear": "تفريغ التصفية",
          "filter": "تصفية"
        }
      },
      "has_many_delete": "حذف",
      "has_many_new": "إضافة %{model} جديد",
      "has_many_remove": "إزالة",
      "index_list": {
        "block": "قائمة",
        "blog": "مدونة",
        "grid": "شبكة",
        "table": "جدول"
      },
      "logout": "تسجيل الخروج",
      "main_content": "الرجاء تنفيذ %{model}#main_content لعرض المحتوى.",
      "new_model": "%{model} جديد",
      "next": "التالي",
      "pagination": {
        "empty": "لا يوجد %{model} ",
        "entry": {
          "one": "مدخل",
          "other": "مدخلات"
        },
        "multiple": "عرض %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> من <b>%{total}</b> بالمجمل",
        "multiple_without_total": "عرض %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "عرض <b>1</b> %{model}",
        "one_page": "عرض <b>all %{n}</b> %{model}"
      },
      "powered_by": "تنفيذ %{active_admin} %{version}",
      "previous": "السابق",
      "search_status": {
        "current_filters": "المُرشحات الحاليّة:",
        "current_scope": "المجال:",
        "headline": "حالات البحث:",
        "no_current_filters": "بدون"
      },
      "sidebars": {
        "filters": "المُرشحات",
        "search_status": "حالات البحث"
      },
      "status_tag": {
        "no": "لا",
        "unset": "لا",
        "yes": "نعم"
      },
      "unsupported_browser": {
        "headline": "يُرجى مُلاحظة أن (أكتف أدمن) لم تعد تدعم المُتصفّح إنترنت اكسبلوررالإصدار الثامن وما قبله",
        "recommendation": "ننصح بالتحديث إلى الإصدارات الأخيرة من: <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, أو <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "إن كنت تستخدم الإصدار التاسع وما يليه من إنترنت إكسبلورر تأكّد من <a href=\"https://support.microsoft.com/ar-ae/help/17471\">تعطيل \"Compatibility View\"</a>."
      },
      "view": "عرض"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "كلمة المرور الحالية",
          "email": "البريد الإلكتروني",
          "password": "كلمة المرود",
          "password_confirmation": "تأكيد كلمة المرور",
          "remember_me": "تذكرني"
        }
      },
      "models": {
        "user": "المستخدم"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "أعدْ إرسال تعليمات التأكيد"
        }
      },
      "failure": {
        "invited": "لديك دعوة معلّقة، يجب عليك قبولها للإنتهاء من إنشاء حسابك."
      },
      "invitations": {
        "edit": {
          "header": "تحديد كلمة المرور",
          "submit_button": "حدد كلمة المرور"
        },
        "invitation_removed": "تم حذف دعوتك.",
        "invitation_token_invalid": "كود الدعوة غير صحيح",
        "new": {
          "header": "ارسال الدعوة",
          "submit_button": "ارسل الدعوة"
        },
        "no_invitations_remaining": "لم يبق لديك دعوات",
        "send_instructions": "تم إرسال الدعوة إلى البريد الإلكتروني %{email}.",
        "updated": "تم تحديد كلمة المرور الخاص بك، انت الآن مسجل دخول."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "أكّد حسابي",
          "greeting": "مرحبا %{recipient}",
          "instruction": "يمكن تأكيد حساب بريدك الإلكتروني من خلال الرابط التّالي:"
        },
        "invitation_instructions": {
          "accept": "قبول الدعوة",
          "hello": "مرحبا %{email}",
          "ignore": "إذا كنت لا تريد قبول الدعوة، الرجاء تجاهل هذا البريد.<br />لن يتم إنشاء حساب خاص بك إلا إذا دخلت على الرابط أعلاه وحددت كلمة مرور خاص بك.",
          "someone_invited_you": "تم إرسال دعوة لك إلى %{url}, يمكنك الموافقة من خلال الرابط في الأسفل",
          "subject": "تعليمات الدعوة"
        },
        "reset_password_instructions": {
          "action": "غيّر كلمة السر",
          "greeting": "مرحبا %{recipient}",
          "instruction": "طلب أحدهم رابطًا لتغيير كلمة السر الخاصة بك، ويُمكن عمل ذلك من خلال الرابط التالي.",
          "instruction_2": "إن لم تكن أنت من طلب هذا، من فضلك تجاهل هذه الرسالة.",
          "instruction_3": "لن تتغيّر كلمة السر الخاصة بك حتى تتبع الرابط السابق وتُنشئ كلمة سر جديدة."
        },
        "unlock_instructions": {
          "action": "أزلْ الحظر عن حسابي",
          "greeting": "مرحبًا %{recipient}",
          "instruction": "انقرْ الرابط على الرابط التالي لفك الحظر عن حسابك:",
          "message": "قُفل حسابك بسبب المحاولات الفاشلة في تسجيل الدخول."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "غيّر كلمة المرور خاصتي",
          "change_your_password": "غيّر كلمة المرور الخاصة بك",
          "confirm_new_password": "أكّد كلمة السر الجديدة",
          "new_password": "كلمة سر جديدة"
        },
        "new": {
          "forgot_your_password": "هل نسيت كلمة المرور؟",
          "send_me_reset_password_instructions": "أرسلْ لي تعليمات تصفير كلمة المرور"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "هل أنت متأكّد؟",
          "cancel_my_account": "ألغِ حسابي",
          "currently_waiting_confirmation_for_email": "في انتظار تفعيل البريد الإلكتروني %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "أبقه فارغًا إن كنت لا ترغب في تغييره",
          "title": "تعديل %{resource}",
          "unhappy": "غير راضٍ؟",
          "update": "تحديث",
          "we_need_your_current_password_to_confirm_your_changes": "نحتاج كلمة المرور الحالية خاصتك لتأكيد تغيراتك"
        },
        "new": {
          "sign_up": "سجّلْ"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "سجّلْ الدخول"
        }
      },
      "shared": {
        "links": {
          "back": "عودة",
          "didn_t_receive_confirmation_instructions": "ألم تستلم تعليمات التأكيد؟",
          "didn_t_receive_unlock_instructions": "ألم تستلم تعليمات فك الحظر؟",
          "forgot_your_password": "هل نسيت كلمة المرور؟",
          "sign_in": "سجّلْ الدخول",
          "sign_in_with_provider": "سجّلْ الدخول عن طريق %{provider}",
          "sign_up": "سجّلْ"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "أعدْ إرسال تعليمات فك الحظر"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "صفحات",
          "many": "صفحات",
          "one": "صفحة",
          "other": "صفحات",
          "two": "صفحتين",
          "zero": "لا يوجد صفحات"
        },
        "next": "التالي",
        "previous": "السابق"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "عرض %{item_name} %{from}-%{to} من اجمالي %{count}",
        "no_count": "الصفحة %{page} من %{pages}",
        "no_items": "لا يوجد %{item_name}",
        "single_page": "عرض %{count} %{item_name}"
      },
      "input_nav_js": "الصفحة %{page_input} من %{pages}",
      "item_name": {
        "few": "قليل",
        "many": "كثير",
        "one": "عنصر",
        "other": "عناصر",
        "two": "عنصرين",
        "zero": "صفر"
      },
      "limit_tag_js": "عرض %{limit_input} %{item_name} لكل صفحة",
      "next": "&gt;",
      "p11n": "Arabic",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "كل",
      "and": "و",
      "any": "أيُّ",
      "asc": "تصاعدي",
      "attribute": "خاصية",
      "combinator": "دالة توافقية",
      "condition": "شرط",
      "desc": "تنازلي",
      "or": "أو",
      "predicate": "فاعل",
      "predicates": {
        "blank": "فراغ",
        "cont": "محتو",
        "cont_all": "محتو لجميع",
        "cont_any": "محتو لواحد على اﻷقل",
        "does_not_match": "لا يتواءم",
        "does_not_match_all": "لا يتواءم مع الجميع",
        "does_not_match_any": "لا يتواءم مع واحد على اﻷقل",
        "end": "ينتهي بـ",
        "end_all": "ينتهي بالجميع",
        "end_any": "ينتهي بواحد على اﻷقل",
        "eq": "معادل",
        "eq_all": "معادل للجميع",
        "eq_any": "معادل على اﻷقل لواحد",
        "false": "خطأ",
        "gt": "أكبر من",
        "gt_all": "أكبر من الجميع",
        "gt_any": "أكبر من واحد على اﻷقل",
        "gteq": "أكبر أو مساو لـ",
        "gteq_all": "أكبر أو مساو للجميع",
        "gteq_any": "أكبر أو مساو لواحد على اﻷقل",
        "in": "متضمن لـ",
        "in_all": "متضمن للجميع",
        "in_any": "متضمن لواحد على اﻷقل",
        "lt": "أصغر من",
        "lt_all": "أصغر من الجميع",
        "lt_any": "أصغر لواحد على اﻷقل",
        "lteq": "أصغر أو مساو لـ",
        "lteq_all": "أصغر أو مساو للجميع",
        "lteq_any": "أصغر أو مساو لواحد على اﻷقل",
        "matches": "موائم",
        "matches_all": "موائم للجميع",
        "matches_any": "موائم لواحد على اﻷقل",
        "not_cont": "غير محتو",
        "not_cont_all": "غير محتو للجميع",
        "not_cont_any": "غير محتو لواحد على اﻷقل",
        "not_end": "لا ينتهي بـ",
        "not_end_all": "لا ينتهي بالجميع",
        "not_end_any": "لا ينتهي بواحد على اﻷقل",
        "not_eq": "ليس معادلا لـ",
        "not_eq_all": "ليس معادلا للجميع",
        "not_eq_any": "ليس معادلا على اﻷقل لواحد",
        "not_in": "غير متضمن",
        "not_in_all": "غير متضمن للجميع",
        "not_in_any": "غير متضمن لواحد على اﻷقل",
        "not_null": "غير مساو لقيمة عدم",
        "not_start": "لا يبدأ بـ",
        "not_start_all": "لا يبدأ بالجميع",
        "not_start_any": "لا يبدأ بواحد على اﻷقل",
        "null": "عدم",
        "present": "مستقبل",
        "start": "يبدأ بـ",
        "start_all": "يبدأ بالجميع",
        "start_any": "يبدأ بواحد على اﻷقل",
        "true": "صحيح"
      },
      "search": "بحث",
      "sort": "ترتيب",
      "value": "قيمة"
    }
  },
  "az": {
    "active_admin": {
      "access_denied": {
        "message": "Bunu etmək üçün daxil olmalısınız."
      },
      "any": "İstənilən",
      "batch_actions": {
        "action_label": "%{title} seçilmiş",
        "button_label": "Qrup əməliyyatları",
        "default_confirmation": "Siz bunu etməyinizə əminsiniz?",
        "delete_confirmation": "Siz %{plural_model} silməyə əminsiniz?",
        "labels": {
          "destroy": "Sil"
        },
        "selection_toggle_explanation": "(Hamısını seç / Seçilmişləri sıfırla)",
        "succesfully_destroyed": {
          "few": "Uğurla silindi: %{count} %{plural_model}",
          "many": "Uğurla silindi: %{count} %{plural_model}",
          "one": "Uğurla silindi: 1 %{model}",
          "other": "Uğurla silindi: %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "%{resource_name} hələ yoxdur.",
        "link": "Yarat"
      },
      "cancel": "İmtina",
      "comments": {
        "add": "Şərh əlavə et",
        "author": "Müəllif",
        "author_missing": "Naməlum",
        "author_type": "Müəllifin tipi",
        "body": "Mətn",
        "created_at": "Yaranma tarixi",
        "delete": "Şərhi sil",
        "delete_confirmation": "Siz bu şərhi silmək istədiyinizdən əminsiniz?",
        "errors": {
          "empty_text": "Şərh yadda saxlanılmadı, mətn boş ola bilməz."
        },
        "no_comments_yet": "Hələ şərhlər yoxdur.",
        "resource": "Resurs",
        "resource_type": "Resursun tipi",
        "title_content": "Şərhlər (%{count})"
      },
      "dashboard": "İdarəetmə paneli",
      "dashboard_welcome": {
        "call_to_action": "Buraya nə isə əlavə etmək üçün 'app/admin/dashboard.rb' sənədini dəyişin",
        "welcome": "Active Admin-ə xoş gəlmişsiniz. Bu saytla idarəetmənin standart səhifəsidir."
      },
      "delete": "Sil",
      "delete_confirmation": "Siz bunu silmək istədiyinizdən əminsiniz?",
      "delete_model": "%{model} sil",
      "details": "%{model} haqqında",
      "devise": {
        "change_password": {
          "submit": "Şifrəni dəyiş",
          "title": "Şifrənin dəyişdirilməsi"
        },
        "email": {
          "title": "E-poçt"
        },
        "links": {
          "forgot_your_password": "Şifrəni unutmusunuz?",
          "resend_confirmation_instructions": "Aktivləşdirmə ismarışını yenidən göndərilməsi",
          "resend_unlock_instructions": "Blokdan çıxarma üzrə təlimatı yenidən göndərilməsi",
          "sign_in": "Giriş",
          "sign_in_with_omniauth_provider": "%{provider} vasitəsilə daxil ol",
          "sign_up": "Qeydiyyat"
        },
        "login": {
          "remember_me": "Məni yadda saxla",
          "submit": "Daxil ol",
          "title": "Giriş"
        },
        "password": {
          "title": "Şifrə"
        },
        "resend_confirmation_instructions": {
          "submit": "Aktivləşdirmə ismarışını yenidən göndərmək",
          "title": "Aktivləşdirmə ismarışını yenidən göndərmək"
        },
        "reset_password": {
          "submit": "Şifrəni sıfırla",
          "title": "Şifrəni unutmusunuz?"
        },
        "sign_up": {
          "submit": "Qeydiyyatdan keç",
          "title": "Qeydiyyat"
        },
        "subdomain": {
          "title": "Subdomen"
        },
        "unlock": {
          "submit": "Blokdan çıxarma üzrə təlimatı yenidən göndərmək",
          "title": "Blokdan çıxarma üzrə təlimatı yenidən göndərmək"
        },
        "username": {
          "title": "İstifadəçi adı"
        }
      },
      "download": "Yüklənmə:",
      "dropdown_actions": {
        "button_label": "Əməliyyatlar"
      },
      "edit": "Dəyiş",
      "edit_model": "%{model} dəyiş",
      "empty": "Boş",
      "filters": {
        "buttons": {
          "clear": "Təmizlə",
          "filter": "Filtrlə"
        }
      },
      "has_many_delete": "Sil",
      "has_many_new": "%{model} əlavə et",
      "has_many_remove": "Yığışdır",
      "index_list": {
        "block": "Siyahı",
        "blog": "Bloq",
        "grid": "Tor",
        "table": "Cədvəl"
      },
      "logout": "Çıxış",
      "main_content": "Создайте %{model}#main_content для отображения содержимого.",
      "new_model": "%{model} yarat",
      "next": "İrəli",
      "pagination": {
        "empty": "%{model} tapılmadı",
        "entry": {
          "few": "yazı",
          "many": "yazı",
          "one": "yazı",
          "other": "yazı"
        },
        "multiple": "Nəticə: %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> <b>%{total}</b>",
        "multiple_without_total": "Nəticə: %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Nəticə: <b>1</b> %{model}",
        "one_page": "Nəticə: <b>%{n}</b> %{model}"
      },
      "powered_by": "Работает на %{active_admin} %{version}",
      "previous": "Geri",
      "search_status": {
        "current_filters": "Cari filter:",
        "current_scope": "Sahə:",
        "headline": "Axtarışın statusu:",
        "no_current_filters": "Heç biri"
      },
      "sidebars": {
        "filters": "Filterlə",
        "search_status": "Axtarışın statusu"
      },
      "status_tag": {
        "no": "Xeyr",
        "yes": "Bəli"
      },
      "unsupported_browser": {
        "headline": "Zəhmət olmasa, bilin ki, Active Admin artıq Internet Explorer-in köhnə versiyalarını daha dəstəkləmir və yalnız IE 8 versiyasından başlayaraq dəstəkləyir",
        "recommendation": "Biz sizin brauzerinizin versiyasını yeniləməyi məsləhət görürük (<a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, və ya <a href=\"https://mozilla.org/firefox/\">Firefox</a>).",
        "turn_off_compatibility_view": "Əgər siz IE 9  və ya daha yeni versiya istifadə edirsinizsə, əmin olun ki, <a href=\"https://support.microsoft.com/ru-ru/help/17471\">\"Uyğunluğun rejimində baxış\"</a> seçimini söndürmüsünüz."
      },
      "view": "Aç"
    },
    "ransack": {
      "all": "hamısı",
      "and": "və",
      "any": "hər hansı",
      "asc": "artan",
      "attribute": "xüsusiyyət",
      "combinator": "birləşdirici",
      "condition": "şərt",
      "desc": "azalan",
      "or": "və ya",
      "predicate": "təsdiqlə",
      "predicates": {
        "blank": "boş",
        "cont": "ehtiva edən",
        "cont_all": "hamısını ehtiva edən",
        "cont_any": "hər hansı birini ehtiva edən",
        "does_not_match": "uyğunlaşmayan",
        "does_not_match_all": "heç biri ilə uyğunlaşmayan",
        "does_not_match_any": "hər hansı biri ilə uyğunlaşmayan",
        "end": "ilə bitən",
        "end_all": "hamısı ilə bitən",
        "end_any": "hər hansı biri ilə bitən",
        "eq": "bərabər",
        "eq_all": "hamısına bərabər",
        "eq_any": "hər hansı birinə bərabər",
        "false": "yanlış",
        "gt": "daha böyük ",
        "gt_all": "hamısından daha böyük",
        "gt_any": "hər hansı birindən daha böyük",
        "gteq": "daha böyük və ya bərabər",
        "gteq_all": "daha böyük və ya hamısıne bərabər",
        "gteq_any": "daha böyük və ya hər hansı birine bərabər",
        "in": "içində",
        "in_all": "hamısında",
        "in_any": "hər hansı birində",
        "lt": "daha kiçik",
        "lt_all": "hamısından kiçik",
        "lt_any": "hər hansı birindən kiçik",
        "lteq": "daha kiçik və ya bərabər",
        "lteq_all": "daha kiçik və ya hamısına bərabər",
        "lteq_any": "daha kiçik və ya hər hansı birinə bərabər",
        "matches": "uyğunlaşan",
        "matches_all": "hamısı ilə uyğunlaşan",
        "matches_any": "hər hansı biri ilə uyğunlaşan",
        "not_cont": "ehtiva etməyən",
        "not_cont_all": "heç birini birini ehtiva etməyən",
        "not_cont_any": "hər hansı birini ehtiva etməyən",
        "not_end": "ilə bitməyən",
        "not_end_all": "heç biri ilə bitməyən",
        "not_end_any": "hər hansı biri ilə bitməyən",
        "not_eq": "bərabər deyil",
        "not_eq_all": "heç birinə bərabər deyil",
        "not_eq_any": "hər hansı birinə bərabər deyil",
        "not_in": "içində deyil",
        "not_in_all": "heç birində deyil",
        "not_in_any": "hər hansı birində deyil",
        "not_null": "keçərli",
        "not_start": "ilə başlamayan",
        "not_start_all": "hiçbiri ilə başlamayan",
        "not_start_any": "hər hansı biri ilə başlamayan",
        "null": "keçərsiz",
        "present": "mövcüd",
        "start": "ilə başlayan",
        "start_all": "hamısı ilə başlayan",
        "start_any": "hər hansı biri ilə başlayan",
        "true": "doğru"
      },
      "search": "axtar",
      "sort": "sırala",
      "value": "dəyər"
    }
  },
  "be": {
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Старонкi",
          "many": "Старонкi",
          "one": "Старонка",
          "other": "Старонкi"
        },
        "next": "Наперад",
        "previous": "Назад"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Усяго %{count} %{item_name}, паказаны з %{from} па %{to}",
        "no_count": "Старонка %{page} з %{pages}",
        "no_items": "Пакуль %{item_name} няма",
        "single_page": "%{count} %{item_name}"
      },
      "input_nav_js": "Старонка %{page_input} з %{pages}",
      "item_name": {
        "few": "запісы",
        "many": "запісаў",
        "one": "запіс",
        "other": "запісаў"
      },
      "limit_tag_js": "Паказаць %{limit_input} %{item_name} на старонцы",
      "next": "&gt;",
      "p11n": "EastSlavic",
      "previous": "&lt;"
    }
  },
  "bg": {
    "active_admin": {
      "access_denied": {
        "message": "Нямате права да извършите това действие."
      },
      "any": "Без значение",
      "batch_actions": {
        "action_label": "%{title} избран",
        "button_label": "Масови действия",
        "default_confirmation": "Наистина ли искате да направите това?",
        "delete_confirmation": "Сигурни ли сте, че искате да изтриете тези %{plural_model}?",
        "labels": {
          "destroy": "Изтриване"
        },
        "selection_toggle_explanation": "(Инвертиране на маркирането)",
        "succesfully_destroyed": {
          "one": "Успешно изтриване на 1 %{model}",
          "other": "Успешно изтриване на %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Все още няма добавени %{resource_name}.",
        "link": "Създаване"
      },
      "cancel": "Отказ",
      "comments": {
        "add": "Добавяне на коментар",
        "author": "Автор",
        "author_missing": "Анонимен",
        "author_type": "Тип автор",
        "body": "Текст",
        "errors": {
          "empty_text": "Коментарът с празен текст не беше запазен."
        },
        "no_comments_yet": "Все още няма коментари.",
        "resource": "Ресурс",
        "resource_type": "Тип ресурс",
        "title_content": "Коментари (%{count})"
      },
      "dashboard": "Табло",
      "dashboard_welcome": {
        "call_to_action": "За да добавите секции, редактирайте 'app/admin/dashboard.rb'",
        "welcome": "Добре дошли в Active Admin. Това е таблото по подразбиране."
      },
      "delete": "Изтриване",
      "delete_confirmation": "Сигурни ли сте, че искате да изтриете това?",
      "delete_model": "Изтриване на %{model}",
      "details": "%{model} детайли",
      "devise": {
        "change_password": {
          "submit": "Промяна на паролата",
          "title": "Промяна на паролата"
        },
        "email": {
          "title": "Поща"
        },
        "links": {
          "forgot_your_password": "Забравена парола?",
          "sign_in": "Вход",
          "sign_in_with_omniauth_provider": "Влез с %{provider}"
        },
        "login": {
          "remember_me": "Запомни ме",
          "submit": "Вход",
          "title": "Вход"
        },
        "password": {
          "title": "Парола"
        },
        "resend_confirmation_instructions": {
          "submit": "Изпрати отново инструкциите за потвърждаване",
          "title": "Изпрати отново инструкциите за потвърждаване"
        },
        "reset_password": {
          "submit": "Изпращане на нова парола",
          "title": "Забравена парола?"
        },
        "sign_up": {
          "submit": "Регистрация",
          "title": "Регистрация"
        },
        "subdomain": {
          "title": "Поддомейн"
        },
        "unlock": {
          "submit": "Изпрати отново инструкциите за отключване",
          "title": "Изпрати отново инструкциите за отключване"
        },
        "username": {
          "title": "Потребителско име"
        }
      },
      "download": "Изтегляне:",
      "dropdown_actions": {
        "button_label": "действия"
      },
      "edit": "Редакция",
      "edit_model": "Редакция на %{model}",
      "empty": "Празно",
      "filters": {
        "buttons": {
          "clear": "Изчистване",
          "filter": "Филтриране"
        }
      },
      "has_many_delete": "Изтриване",
      "has_many_new": "Добавяне на %{model}",
      "has_many_remove": "Премахване",
      "index_list": {
        "block": "Списък",
        "blog": "Блог",
        "grid": "Грид",
        "table": "Таблица"
      },
      "logout": "Изход",
      "main_content": "Добавете %{model}#main_content за да видите съдържание.",
      "new_model": "Създаване на %{model}",
      "next": "Следващо",
      "pagination": {
        "empty": "Не са намерени %{model}",
        "entry": {
          "one": "запис",
          "other": "записи"
        },
        "multiple": "Показване %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> от общо <b>%{total}</b>",
        "multiple_without_total": "Показване %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Показване на <b>1</b> %{model}",
        "one_page": "Показване на <b>всички %{n}</b> %{model}"
      },
      "powered_by": "Задвижва се от %{active_admin} %{version}",
      "previous": "Предишно",
      "sidebars": {
        "filters": "Филтри"
      },
      "status_tag": {
        "no": "не",
        "unset": "не",
        "yes": "Да"
      },
      "view": "Преглед"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Текуща парола",
          "email": "Емейл",
          "password": "Парола",
          "password_confirmation": "Потвърждаване на паролата",
          "remember_me": "Запомни ме"
        }
      },
      "models": {
        "user": "Потребител"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Повторно изпращане на инструкции за потвърждаване"
        }
      },
      "failure": {
        "expired": "Вашия акаунт е затворен поради неактивност. Моля свържете се с администратор.",
        "session_limited": "Вашето потребителско име и парола са използвани в друг браузър. Моля влезте отново за да продължите в този браузър."
      },
      "invalid_captcha": "Кодът е грешен.",
      "invalid_security_question": "Отговора на тайния въпрос е грешен.",
      "mailer": {
        "confirmation_instructions": {
          "action": "Потвърждаване на профил",
          "greeting": "Добре дошли, %{recipient}!",
          "instruction": "Можете да потвърдите Вашия имейл адрес чрез долния линка:"
        },
        "reset_password_instructions": {
          "action": "Смяна на парола",
          "greeting": "Здравей, %{recipient}!",
          "instruction": "Някой е поискал линк за смяна на парола. Можете да смените паролата си чрез долния линк.",
          "instruction_2": "В случай, че не сте поискали смяна на паролата, моля игнорирайте настоящия имейл.",
          "instruction_3": "Паролата Ви няма да бъде сменена докато не използвате горния линк, за да създадете новва."
        },
        "unlock_instructions": {
          "action": "Отключване на профил",
          "greeting": "Здравей, %{recipient}!",
          "instruction": "Натиснете върху донлия линк, за да отключите профила си:",
          "message": "Профилът Ви е заключен поради надвишаване броя на неуспешните опити за вход."
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Изпрати",
          "submit_verification_code": "Изпрати код за потвърждение",
          "verification_code": "Код за потвърждение"
        },
        "updated": "Кодът за потвърждение е приет"
      },
      "paranoid_verify": {
        "code_required": "Моля въведете кода, който нашия екип по поддръжката Ви е предоставил"
      },
      "password_expired": {
        "change_required": "Вашата парола е изтекла. Моля подновете паролата си.",
        "show": {
          "change_my_password": "Промени паролата ми",
          "current_password": "Настояща парола",
          "new_password": "Нова парола",
          "new_password_confirmation": "Потвърждение на нова парола",
          "renew_your_password": "Подновете паролата си"
        },
        "updated": "Вашата нова парола е запазена."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Смяна на парола",
          "change_your_password": "Смяна на парола",
          "confirm_new_password": "Потвърждение на нова парола",
          "new_password": "Нова парола"
        },
        "new": {
          "forgot_your_password": "Забравена парола?",
          "send_me_reset_password_instructions": "Изпрати инструкции за възстановяване на парола"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Сигурни ли сте?",
          "cancel_my_account": "Закриване на профил",
          "currently_waiting_confirmation_for_email": "Очаква се потвърждение за: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "оставете празно, ако не искате да го променяте",
          "title": "Редакция на %{resource}",
          "unhappy": "Недоволни",
          "update": "Обновяване",
          "we_need_your_current_password_to_confirm_your_changes": "въведете настоящата си парола за потвърждаване на промените"
        },
        "new": {
          "sign_up": "Регистрация"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Вход"
        }
      },
      "shared": {
        "links": {
          "back": "Назад",
          "didn_t_receive_confirmation_instructions": "Не сте получили инструкции за потвърждаване?",
          "didn_t_receive_unlock_instructions": "Не сте получили инструкции за отключване?",
          "forgot_your_password": "Забравена парола?",
          "sign_in": "Вход",
          "sign_in_with_provider": "Вход с %{provider}",
          "sign_up": "Регистрация"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Повторно изпращане на инструкции за отключване"
        }
      }
    },
    "errors": {
      "messages": {
        "equal_to_current_password": "трябва да е различна от настоящата парола.",
        "equal_to_email": "трябва да е различна от e-mail адреса.",
        "password_complexity": {
          "digit": {
            "one": "трябва да съдържа поне една цифра",
            "other": "трябва да съдържа %{count} цифри"
          },
          "lower": {
            "one": "трябва да съдържа поне една малка буква",
            "other": "трябва да съдържа поне %{count} малки букви"
          },
          "symbol": {
            "one": "трябва да съдържа поне един пунктоационен знак или символ",
            "other": "трябва да съдържа поне %{count} пунктоационни знака или символи"
          },
          "upper": {
            "one": "трябва да съдържа поне една главна буква",
            "other": "трябва да съдържа поне %{count} главни букви"
          }
        },
        "taken_in_past": "е използвана и преди."
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Страница",
          "other": "Страници"
        },
        "next": "Следваща",
        "previous": "Предишна"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Показани са %{item_name} %{from}-%{to} от %{count} общо",
        "no_count": "Страница %{page} от %{pages}",
        "no_items": "Няма намерени %{item_name}",
        "single_page": "Показани са %{count} %{item_name}"
      },
      "input_nav_js": "Страница %{page_input} от %{pages}",
      "item_name": {
        "one": "резултат",
        "other": "резултати"
      },
      "limit_tag_js": "Покажи %{limit_input} %{item_name} на страница",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "всички",
      "and": "и",
      "any": "всякакво",
      "asc": "възходящ",
      "attribute": "атрибут",
      "combinator": "комбинатор",
      "condition": "условие",
      "desc": "низходящ",
      "or": "или",
      "predicate": "предикат",
      "predicates": {
        "blank": "е празно",
        "cont": "съдържа",
        "cont_all": "съдържа всички",
        "cont_any": "съдържа всякое",
        "does_not_match": "не съвпада",
        "does_not_match_all": "не съвпада с всички",
        "does_not_match_any": "не съвпада с никое",
        "end": "завършва с",
        "end_all": "завършва с всички",
        "end_any": "завършва с всякое",
        "eq": "се равнява на",
        "eq_all": "се равнява на всички",
        "eq_any": "се равнява на всяко",
        "false": "неистина",
        "gt": "по-голямо от",
        "gt_all": "по-голямо от всички",
        "gt_any": "по-голямо от всякое",
        "gteq": "по-голямо или равно на",
        "gteq_all": "по-голямо или равно на всички",
        "gteq_any": "по-голямо или равно на всякое",
        "in": "в",
        "in_all": "във всички",
        "in_any": "във всякое",
        "lt": "по-малко от",
        "lt_all": "по-малко от всички",
        "lt_any": "по-малко от някое",
        "lteq": "по-малко или равно на",
        "lteq_all": "по-малко или равно на всички",
        "lteq_any": "по-малко или равно на някое",
        "matches": "съвпада",
        "matches_all": "съвпада с всички",
        "matches_any": "съвпада с някое",
        "not_cont": "не съдържа",
        "not_cont_all": "не съдържа всички",
        "not_cont_any": "не съдържа никое",
        "not_end": "не завършва с",
        "not_end_all": "не завършва с всички",
        "not_end_any": "не завършва с никое",
        "not_eq": "не е равно на",
        "not_eq_all": "не е равно на всички",
        "not_eq_any": "не е равно на никое от",
        "not_in": "не в",
        "not_in_all": "не във всички",
        "not_in_any": "не в никое",
        "not_null": "не е нула",
        "not_start": "не започва с",
        "not_start_all": "не започва с всички",
        "not_start_any": "не започва с никое",
        "null": "е нула",
        "present": "присъства",
        "start": "започва с",
        "start_all": "започва с всички",
        "start_any": "започва с всякое",
        "true": "истина"
      },
      "search": "търсене",
      "sort": "сортиране",
      "value": "стойност"
    }
  },
  "bs": {
    "active_admin": {
      "access_denied": {
        "message": "Nemaš dopuštenja."
      },
      "any": "Bilo koji",
      "batch_actions": {
        "action_label": "%{title} označene",
        "button_label": "Grupne akcije",
        "default_confirmation": "Jeste li sigurni da želite to učiniti?",
        "delete_confirmation": "Jeste li sigurni da želite obrisati %{plural_model}?",
        "labels": {
          "destroy": "Obriši"
        },
        "selection_toggle_explanation": "(Izmijeni odabir)",
        "succesfully_destroyed": {
          "few": "Uspješno su obrisana %{count} %{plural_model}",
          "many": "Uspješno je obrisano %{count} %{plural_model}",
          "one": "Uspješno je obrisan 1 %{model}",
          "other": "Uspješno je obrisano %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Još uvijek ne postoji niti jedan zapis tipa %{resource_name}.",
        "link": "Izradi jedan"
      },
      "cancel": "Odustani",
      "comments": {
        "add": "Dodaj komentar",
        "author": "Autor",
        "author_missing": "Anoniman",
        "author_type": "Tip autora",
        "body": "Sadržaj",
        "errors": {
          "empty_text": "Komentar nije spremljen, sadržaj je prazan."
        },
        "no_comments_yet": "Još nema komentara.",
        "resource": "Objekt",
        "resource_type": "Tip objekta",
        "title_content": "Komentari (%{count})"
      },
      "dashboard": "Upravljačka ploča",
      "dashboard_welcome": {
        "call_to_action": "Da biste dodali nove odjeljke na upravljačku ploču, pogledajte 'app/admin/dashboard.rb'",
        "welcome": "Dobrodošli u Active Admin. Ovo je početna upravljačka ploča."
      },
      "delete": "Obriši",
      "delete_confirmation": "Jeste li sigurni da želite ovo obrisati?",
      "delete_model": "Obriši %{model}",
      "details": "%{model} detalji",
      "devise": {
        "change_password": {
          "submit": "Izmijeni lozinku",
          "title": "Izmjena lozinke"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Zaboravljena lozinka?",
          "sign_in": "Prijavi se",
          "sign_in_with_omniauth_provider": "Prijavite se za %{provider}"
        },
        "login": {
          "remember_me": "Zapamti me",
          "submit": "Prijavi se",
          "title": "Prijava"
        },
        "password": {
          "title": "Lozinka"
        },
        "resend_confirmation_instructions": {
          "submit": "Pošalji",
          "title": "Ponovno slanje uputstva za potvrdu"
        },
        "reset_password": {
          "submit": "Resetuj lozinku",
          "title": "Zaboravljena lozinka?"
        },
        "sign_up": {
          "submit": "Registruj",
          "title": "Registracija"
        },
        "subdomain": {
          "title": "Poddomena"
        },
        "unlock": {
          "submit": "Pošalji",
          "title": "Ponovno slanje uputstva za otključavanje"
        },
        "username": {
          "title": "Korisničko ime"
        }
      },
      "download": "Spremi na računalo:",
      "edit": "Uredi",
      "edit_model": "Uredi %{model}",
      "empty": "Prazno",
      "filters": {
        "buttons": {
          "clear": "Ukloni filtere",
          "filter": "Filtriraj"
        }
      },
      "has_many_delete": "Obriši",
      "has_many_new": "Dodaj novi %{model}",
      "has_many_remove": "Ukloniti",
      "index_list": {
        "block": "Lista",
        "blog": "Blog",
        "grid": "Rešetka",
        "table": "Tabela"
      },
      "logout": "Odjavi se",
      "main_content": "Molim Vas, implementirajte %{model}#main_content da biste prikazali sadržaj.",
      "new_model": "Novi %{model}",
      "next": "Sljedeći",
      "pagination": {
        "empty": "Nije pronađen niti jedan %{model}.",
        "entry": {
          "few": "zapisa",
          "many": "zapisa",
          "one": "zapis",
          "other": "zapisa"
        },
        "multiple": "Prikazani %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> od ukupno <b>%{total}</b>",
        "multiple_without_total": "Prikazani %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Prikazan <b>1</b> %{model}",
        "one_page": "Prikazano <b>svih %{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Prethodni",
      "sidebars": {
        "filters": "Filtriranje"
      },
      "status_tag": {
        "no": "Nema",
        "unset": "Nema",
        "yes": "Da"
      },
      "view": "Pregledaj"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Stranice",
          "many": "Stranica",
          "one": "Stranica",
          "other": "Stranice"
        },
        "next": "Sljedeća",
        "previous": "Prethodna"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Prikaz %{item_name} %{from}-%{to} od %{count} ukupno",
        "no_count": "Stranica %{page} od %{pages}",
        "no_items": "Nije pronađena %{item_name}",
        "single_page": "Prikazuje se %{count} %{item_name}"
      },
      "input_nav_js": "Stranica %{page_input} od %{pages}",
      "item_name": {
        "few": "stavke",
        "many": "stavki",
        "one": "stavka",
        "other": "stavki"
      },
      "limit_tag_js": "Prikaži %{limit_input} %{item_name} po stranici",
      "next": "&gt;",
      "p11n": "EastSlavic",
      "previous": "&lt;"
    }
  },
  "by": {
    "devise": {
      "failure": {
        "expired": "Ваш уліковы запіс састарэў з-за неактыўнасці. Калі ласка, звяжыцеся з адміністратарам.",
        "session_limited": "Вашы параметры ўваходу выкарыстоўваюцца ў іншым браўзэры. Калі ласка, аўтарызуйцеся зноў, каб працягнуць у гэтым браўзэры."
      },
      "invalid_captcha": "Уведзены няправільны код капчы.",
      "invalid_security_question": "Адказ на сакрэтнае пытанне быў няправільны.",
      "paranoid_verification_code": {
        "show": {
          "submit": "Адправіць",
          "submit_verification_code": "Увод кода пацверджання",
          "verification_code": "Код пацверджання"
        },
        "updated": "Код спраўджання прыняты"
      },
      "paranoid_verify": {
        "code_required": "Калі ласка, увядзіце код, атрыманы ад нашай каманды падтрымкі"
      },
      "password_expired": {
        "change_required": "Ваш пароль састарэў. Калі ласка, усталюйце новы.",
        "show": {
          "change_my_password": "Змяніць пароль",
          "current_password": "Сучасны пароль",
          "new_password": "Новы пароль",
          "new_password_confirmation": "Пацвердзіце новы пароль",
          "renew_your_password": "Змена пароля"
        },
        "updated": "Ваш новы пароль захаваны."
      }
    },
    "errors": {
      "messages": {
        "equal_to_current_password": "павінен адрознівацца ад сучаснага пароля.",
        "equal_to_email": "павінна адрознівацца ад электроннай пошты.",
        "password_complexity": {
          "digit": {
            "few": "павінен утрымліваць хоць %{count} лічбы",
            "many": "павінен утрымліваць хоць %{count} лічбы",
            "one": "павінен утрымліваць хоць адну лічбу",
            "other": "павінен утрымліваць хоць %{count} лічбы"
          },
          "lower": {
            "few": "павінен утрымліваць хоць %{count} малыx літары",
            "many": "павінен утрымліваць хоць %{count} малыx літары",
            "one": "павінен утрымліваць хоць адну маленькую літару",
            "other": "павінен утрымліваць хоць %{count} малыx літары"
          },
          "symbol": {
            "few": "павінен утрымліваць хоць %{count} знака пунктуацыі або сімвала",
            "many": "павінен утрымліваць хоць %{count} знака пунктуацыі або сімвала",
            "one": "павінен утрымліваць хоць адзін знак пунктуацыі або сімвал",
            "other": "павінен утрымліваць хоць %{count} знака пунктуацыі або сімвала"
          },
          "upper": {
            "few": "павінен утрымліваць хоць %{count} вялікіx літары",
            "many": "павінен утрымліваць хоць %{count} вялікіx літары",
            "one": "павінен утрымліваць хоць адну вялікую літару",
            "other": "павінен утрымліваць хоць %{count} вялікіx літары"
          }
        },
        "taken_in_past": "ужо раней выкарыстоўваўся."
      }
    }
  },
  "ca": {
    "active_admin": {
      "access_denied": {
        "message": "No esta autoritzat a realitzar aquesta acció."
      },
      "any": "Qualsevol",
      "batch_actions": {
        "action_label": "%{title} seleccionat",
        "button_label": "les accions per lots",
        "default_confirmation": "¿Esteu segur que voleu fer-ho?",
        "delete_confirmation": "¿Està segur que desitja eliminar aquests %{plural_model}?",
        "labels": {
          "destroy": "esborrar"
        },
        "selection_toggle_explanation": "(Selecció de Canviar)",
        "succesfully_destroyed": {
          "one": "Va destruir amb èxit 1 %{model}",
          "other": "Va destruir amb èxit %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Encara no hi ha cap %{resource_name}.",
        "link": "Crea'n un/a"
      },
      "cancel": "Cancel·lar",
      "comments": {
        "add": "Afegeix comentari",
        "author": "autor",
        "body": "Cos",
        "errors": {
          "empty_text": "El comentari no es va salvar, el text estava buida."
        },
        "no_comments_yet": "No hi ha comentaris",
        "resource": "Recurs",
        "title_content": "comentaris (%{count})"
      },
      "dashboard": "Tauler",
      "dashboard_welcome": {
        "call_to_action": "Mira l'arxiu 'app/admin/dashboard.rb' per afegir seccions al tauler",
        "welcome": "Benvingut a Active Admin. Aquest és el tauler per defecte."
      },
      "delete": "Elimina",
      "delete_confirmation": "Segur que vols eliminar-ho?",
      "delete_model": "Eliminar %{model}",
      "details": "Detalls de %{model}",
      "devise": {
        "change_password": {
          "submit": "Canviar la contrasenya",
          "title": "Canvieu la contrasenya"
        },
        "links": {
          "forgot_your_password": "Heu perdut la contrasenya?",
          "sign_in": "Registrar",
          "sign_in_with_omniauth_provider": "Connecta't amb %{provider}"
        },
        "login": {
          "remember_me": "Recordar",
          "submit": "iniciar sessió",
          "title": "iniciar sessió"
        },
        "resend_confirmation_instructions": {
          "submit": "Reenviar instruccions de confirmació",
          "title": "Reenviar instruccions de confirmació"
        },
        "reset_password": {
          "submit": "Restablir la contrasenya",
          "title": "Heu perdut la contrasenya?"
        },
        "unlock": {
          "submit": "Reenvia instruccions per a desbloquejar",
          "title": "Reenvia instruccions per a desbloquejar"
        }
      },
      "download": "Descarregar:",
      "dropdown_actions": {
        "button_label": "accions"
      },
      "edit": "Edita",
      "edit_model": "Editar %{model}",
      "empty": "Buit",
      "filters": {
        "buttons": {
          "clear": "Treure filtres",
          "filter": "Filtrar"
        }
      },
      "has_many_delete": "Eliminar",
      "has_many_new": "Afegir %{model}",
      "has_many_remove": "Treure",
      "index_list": {
        "block": "Llista",
        "blog": "Bloc",
        "grid": "Graella",
        "table": "Taula"
      },
      "logout": "Desconnecta't",
      "main_content": "Implementa %{model}#main_content per mostrar contingut.",
      "new_model": "Crear %{model}",
      "next": "Següent",
      "pagination": {
        "empty": "No hi ha %{model}",
        "entry": {
          "one": "entrada",
          "other": "entrades"
        },
        "multiple": "S'estan mostrant %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> de <b>%{total}</b> en total",
        "multiple_without_total": "S'estan mostrant %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "S'està mostrant <b>1</b> %{model}",
        "one_page": "S'estan mostrant <b>tots %{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Anterior",
      "sidebars": {
        "filters": "Filtres"
      },
      "status_tag": {
        "no": "No",
        "unset": "No",
        "yes": "Sí"
      },
      "view": "Mostra"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Contrasenya actual",
          "email": "Email",
          "password": "Contrasenya",
          "password_confirmation": "Confirmar contrasenya",
          "remember_me": "Recordar-me"
        }
      },
      "models": {
        "user": "Usuari"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Reenviar instruccions de confirmació"
        }
      },
      "failure": {
        "invited": "Tens una invitació pendent, accepta-la per acabar de crear el teu compte."
      },
      "invitations": {
        "edit": {
          "header": "Establir contrasenya",
          "submit_button": "Guardar la meva contrasenya"
        },
        "invitation_removed": "S'ha retirat la seva invitació",
        "invitation_token_invalid": "La invitació no es vàlida!",
        "new": {
          "header": "Enviar Invitació",
          "submit_button": "Envia una invitació"
        },
        "no_invitations_remaining": "No queden invitacions",
        "send_instructions": "S'ha enviat una invitació a %{email}.",
        "updated": "S'ha configurat la seva contrasenya i s'ha ingressat al sistema",
        "updated_not_active": "La seva contrasenya s'ha configurat correctament."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar el meu compte",
          "greeting": "Benvingut %{recipient}!",
          "instruction": "Pots confirmar el correu electrònic del teu compte a través d'aquest enllaç:"
        },
        "invitation_instructions": {
          "accept": "Aceptar la invitació",
          "accept_until": "Aquesta invitació expirarà en %{due_date}.",
          "hello": "Hola %{email}",
          "ignore": "Si no li interessa aquesta invitació, simplement ignori aquest correu. No es crearà el teu compte fins que accedeixis a l'anterior enllaç i creïs una contrasenya",
          "someone_invited_you": "Has estat invitat a %{url}, pots acceptar-ho seguint el següent enllaç",
          "subject": "Instruccions de la invitació"
        },
        "reset_password_instructions": {
          "action": "Canviar la meva contrasenya",
          "greeting": "Hola %{recipient}!",
          "instruction": "Algú ha sol·licitat un enllaç per a canviar la teva contrasenya, pots fer-ho amb el següent enllaç.",
          "instruction_2": "Si tu no ho has sol·licitat, si us plau ignora aquest email.",
          "instruction_3": "La teva contrasenya no serà canviada fins que accedeixis a l'enllaç i en creïs una nova."
        },
        "unlock_instructions": {
          "action": "Desbloquejar el meu compte",
          "greeting": "Hola %{recipient}!",
          "instruction": "Obre el següent enllaç per a desbloquejar el teu compte:",
          "message": "El teu compte s'ha bloquejat a causa d'una quantitat excessiva d'intents fallits per a accedir-hi."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Canviar la meva contrasenya",
          "change_your_password": "Canviar la teva contrasenya",
          "confirm_new_password": "Confirmar nova contrasenya",
          "new_password": "Nova contrasenya"
        },
        "new": {
          "forgot_your_password": "Has oblidat la teva contrasenya?",
          "send_me_reset_password_instructions": "Enviar les instruccions per a regenerar la meva contrasenya"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Estàs segur?",
          "cancel_my_account": "Cancel·lar el meu compte",
          "currently_waiting_confirmation_for_email": "Esperant confirmació de: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "deixa'l en blanc si no el vols canviar",
          "title": "Editar %{resource}",
          "unhappy": "Descontent",
          "update": "Actualitzar",
          "we_need_your_current_password_to_confirm_your_changes": "necessitem la teva contrasenya actual per a confirmar els canvis"
        },
        "new": {
          "sign_up": "Registrar-se"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Iniciar sessió"
        }
      },
      "shared": {
        "links": {
          "back": "Tornar",
          "didn_t_receive_confirmation_instructions": "No has rebut les instruccions de confirmació?",
          "didn_t_receive_unlock_instructions": "No has rebut les instruccions de desbloqueig?",
          "forgot_your_password": "Has oblidat la teva contrasenya?",
          "sign_in": "Iniciar sessió",
          "sign_in_with_provider": "Iniciar sessió amb %{provider}",
          "sign_up": "Registrar-se"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instruccions de desbloqueig"
        }
      }
    },
    "formtastic": {
      "cancel": "Cancel·lar",
      "create": "Crear %{model}",
      "no": "No",
      "required": "obligatori",
      "reset": "Restablir %{model}",
      "submit": "Acceptar",
      "update": "Actualitzar %{model}",
      "yes": "Sí"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Pàgina",
          "other": "Pàgines"
        },
        "next": "Següent",
        "previous": "Anterior"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Mostrant %{item_name} %{from}-%{to} de %{count} en total",
        "no_count": "Pàgina %{page} de %{pages}",
        "no_items": "No s'ha trobat cap resultat",
        "single_page": "Mostrant %{count} %{item_name}"
      },
      "input_nav_js": "Pàgina %{page_input} de %{pages}",
      "item_name": {
        "one": "element",
        "other": "elements"
      },
      "limit_tag_js": "Mostra %{limit_input} %{item_name} per pàgina",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "tots",
      "and": "i",
      "any": "qualsevol",
      "asc": "ascendent",
      "attribute": "atribut",
      "combinator": "combinador",
      "condition": "condició",
      "desc": "descendent",
      "or": "o",
      "predicate": "predicat",
      "predicates": {
        "blank": "està en blanc",
        "cont": "conté",
        "cont_all": "conté tots",
        "cont_any": "conté qualsevol",
        "does_not_match": "no coincideix",
        "does_not_match_all": "no coincideix amb tots",
        "does_not_match_any": "no coincideix amb cap",
        "end": "acaba en",
        "end_all": "acaba en tot",
        "end_any": "acaba en qualsevol",
        "eq": "és igual a",
        "eq_all": "és igual a tots",
        "eq_any": "és igual a qualsevol",
        "false": "és fals",
        "gt": "major que",
        "gt_all": "major que tots",
        "gt_any": "major que qualsevol",
        "gteq": "major que o igual a",
        "gteq_all": "major que o igual a tots",
        "gteq_any": "major que o igual a qualsevol",
        "in": "en",
        "in_all": "en tots",
        "in_any": "en qualsevol",
        "lt": "menor que",
        "lt_all": "menor o igual a",
        "lt_any": "menor que qualsevol",
        "lteq": "menor que o igual a",
        "lteq_all": "menor o igual a tots",
        "lteq_any": "menor o igual a qualsevol",
        "matches": "coincideix",
        "matches_all": "coincideix a tots",
        "matches_any": "coincideix a qualsevol",
        "not_cont": "no conté",
        "not_cont_all": "no conté tota",
        "not_cont_any": "no conté cap",
        "not_end": "no acaba en",
        "not_end_all": "no acaba en tot",
        "not_end_any": "no acaba en qualsevol",
        "not_eq": "no és igual a",
        "not_eq_all": "no és igual a tots",
        "not_eq_any": "no és igual a qualsevol",
        "not_in": "no en",
        "not_in_all": "no en tots",
        "not_in_any": "no en qualsevol",
        "not_null": "no és nul",
        "not_start": "no comença per",
        "not_start_all": "no comença per tot",
        "not_start_any": "no comença per qualsevol",
        "null": "és nul",
        "present": "és present",
        "start": "comença per",
        "start_all": "comença per tot",
        "start_any": "comença per qualsevol",
        "true": "és verdader"
      },
      "search": "cercar",
      "sort": "ordenar",
      "value": "valor"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d de %B de %Y, %H:%M"
            }
          }
        }
      }
    }
  },
  "ckb": {
    "pagy": {
      "aria_label": {
        "nav": "پەڕەکان",
        "next": "پێش",
        "previous": "پاش"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "پشاندانی %{item_name}ی %{from}-%{to} لە کۆی %{count} بە گشتی",
        "no_count": "پەڕی %{page} لە %{pages}",
        "no_items": "هیچ %{item_name}ێک نەدۆزرایەوە",
        "single_page": "پیشاندانی %{count} %{item_name}"
      },
      "input_nav_js": "پەڕی %{page_input} لە %{pages}",
      "item_name": "بابەت",
      "limit_tag_js": "نیشاندانی %{limit_input} %{item_name} لە هەر پەڕێک",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    }
  },
  "cs": {
    "active_admin": {
      "access_denied": {
        "message": "Nemáte oprávnění k provedení této akce."
      },
      "any": "Kterákoliv",
      "batch_actions": {
        "action_label": "%{title}",
        "button_label": "Hromadné akce",
        "default_confirmation": "Jste si jisti, že chcete provést?",
        "delete_confirmation": "Jste si jisti, že chcete smazat tyto %{plural_model}?",
        "labels": {
          "destroy": "Vymazat"
        },
        "selection_toggle_explanation": "(Změnit výběr)",
        "succesfully_destroyed": {
          "few": "Úspěšně smazány %{count} %{plural_model}",
          "one": "Úspěšně smazán %{model}",
          "other": "Úspěšně smazáno %{count} %{plural_model}",
          "zero": "Nebyl smazán žádný %{model}"
        }
      },
      "blank_slate": {
        "content": "Zatím zde není žádný obsah.",
        "link": "Vytvořit"
      },
      "cancel": "Zrušit",
      "comments": {
        "add": "Přidat komentář",
        "author": "Autor",
        "author_missing": "Anonymní",
        "author_type": "Typ autora",
        "body": "Tělo",
        "errors": {
          "empty_text": "Komentář nebyl uložen, je prázdný."
        },
        "no_comments_yet": "Žádný komentář",
        "resource": "Zdroj",
        "resource_type": "Typ zdroje",
        "title_content": "Komentáře administrátorů (%{count})"
      },
      "dashboard": "Úvod",
      "dashboard_welcome": {
        "call_to_action": "Pro přidání sekcí na nástěnku se podívejte do souboru 'app/admin/dashboard.rb'",
        "welcome": "Vítejte v Active Admin. Toto je nástěnka."
      },
      "delete": "Smazat",
      "delete_confirmation": "Jste si jistí, že chcete tuto položku smazat?",
      "delete_model": "Smazat",
      "details": "Detaily",
      "devise": {
        "change_password": {
          "submit": "Změnit své heslo",
          "title": "Změnit heslo"
        },
        "links": {
          "forgot_your_password": "Zapomněli jste heslo?",
          "sign_in": "Přihlásit se",
          "sign_in_with_omniauth_provider": "Přihlásit se přes %{provider}",
          "sign_up": "Registrovat se"
        },
        "login": {
          "remember_me": "Zapamatovat si mě",
          "submit": "Přihlásit",
          "title": "Přihlášení"
        },
        "reset_password": {
          "submit": "Obnovit heslo",
          "title": "Zapomněli jste heslo?"
        },
        "unlock": {
          "submit": "Zaslat instrukce k odemčení účtu",
          "title": "Zaslání instrukcí k odemčení účtu"
        }
      },
      "download": "Stáhnout:",
      "dropdown_actions": {
        "button_label": "Akce"
      },
      "edit": "Upravit",
      "edit_model": "Upravit",
      "empty": "Prázdné",
      "filters": {
        "buttons": {
          "clear": "Vyčistit filtry",
          "filter": "Filtrovat"
        }
      },
      "has_many_delete": "Smazat",
      "has_many_new": "Přidat nový",
      "has_many_remove": "Odstranit",
      "index_list": {
        "block": "Seznam",
        "blog": "Blog",
        "grid": "Tabulka",
        "table": "Tabulka"
      },
      "logout": "Odhlásit",
      "main_content": "Implementujte prosím %{model}#main_content pro zobrazení obsahu.",
      "new_model": "Vytvořit",
      "next": "Následující",
      "pagination": {
        "empty": "Nenalezen.",
        "entry": {
          "few": "položky",
          "one": "položka",
          "other": "položky"
        },
        "multiple": "<b>%{from}&nbsp;-&nbsp;%{to}</b> z <b>%{total}</b>",
        "multiple_without_total": "<b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Zobrazena  <b>1</b> položka",
        "one_page": "Počet zobrazených položek %{n}"
      },
      "powered_by": "%{active_admin} %{version}",
      "previous": "Předchozí",
      "sidebars": {
        "filters": "Filtry"
      },
      "status_tag": {
        "no": "Ne",
        "unset": "Ne",
        "yes": "Ano"
      },
      "view": "Zobrazit"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Současné heslo",
          "email": "Email",
          "password": "Heslo",
          "password_confirmation": "Potvrzení hesla",
          "remember_me": "Zapamatuj si mě"
        }
      },
      "models": {
        "user": "Uživatel"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Opět poslat instrukce pro potvrzení"
        }
      },
      "failure": {
        "expired": "Platnost Vašeho účtu vypršela z důvodu nečinnosti. Obraťte se na správce webu.",
        "session_limited": "Vaše přihlašovací údaje byly použity v jiném prohlížeči. Chcete-li pokračovat v tomto prohlížeči, znovu se přihlaste."
      },
      "invalid_captcha": "Chybná captcha.",
      "invalid_security_question": "Chybná odpověď na bezpečnostní otázku.",
      "mailer": {
        "confirmation_instructions": {
          "action": "Potvrdit můj účet",
          "greeting": "Vítejte, %{recipient}!",
          "instruction": "Můžete potvrdit svůj účet pomocí odkazu níže"
        },
        "reset_password_instructions": {
          "action": "Změnit mé heslo",
          "greeting": "Ahoj %{recipient}!",
          "instruction": "Někdo si vyžádal odkaz pro změnu vašeho hesla, to můžete udělat pomocí odkazu níže.",
          "instruction_2": "Pokud jste si toto nevyžádali, můžete tento e-mail ignorovat.",
          "instruction_3": "Vaše heslo se nezmění dokud nepřejdete na výše uvedený odkaz a nevytvoříte nové heslo"
        },
        "unlock_instructions": {
          "action": "Odblokovat můj účet",
          "greeting": "Ahoj %{recipient}!",
          "instruction": "Přejděte na odkaz níže pro odblokování účtu:",
          "message": "Váš účet byl zablokován pro nadměrný počet neúspěšných pokusů o přihlášení."
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Odeslat",
          "submit_verification_code": "Odeslat ověřovací kód",
          "verification_code": "Ověřovací kód"
        },
        "updated": "Ověřovací kód přijat"
      },
      "paranoid_verify": {
        "code_required": "Zadejte kód, který poskytla naše podpora"
      },
      "password_expired": {
        "change_required": "Platnost Vašeho hesla vypršela. Prosím, obnovte si jej.",
        "show": {
          "change_my_password": "Změnit moje heslo",
          "current_password": "Současné heslo",
          "new_password": "Nové heslo",
          "new_password_confirmation": "Potvrďte nové heslo",
          "renew_your_password": "Obnovit heslo"
        },
        "updated": "Vaše nové heslo bylo uloženo."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Změnit mé heslo",
          "change_your_password": "Změnit mé heslo",
          "confirm_new_password": "Potvrdit nové heslo",
          "new_password": "Nové heslo"
        },
        "new": {
          "forgot_your_password": "Zapomněl jste své heslo?",
          "send_me_reset_password_instructions": "Poslat instrukce pro obnovení hesla"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Jste si jistý?",
          "cancel_my_account": "Zrušit můj účet",
          "currently_waiting_confirmation_for_email": "Momentálně čekám na potvrzení pro: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "nech prázdné, pokud to nechceš měnit",
          "title": "Upravit %{resource}",
          "unhappy": "Nešťastný",
          "update": "Aktualizovat",
          "we_need_your_current_password_to_confirm_your_changes": "Potřebujeme vaše současné heslo pro potvrzení změn"
        },
        "new": {
          "sign_up": "Registrovat"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Přihlásit"
        }
      },
      "shared": {
        "links": {
          "back": "Zpět",
          "didn_t_receive_confirmation_instructions": "Nedostali jste informace pro potvrzení?",
          "didn_t_receive_unlock_instructions": "Nedostali jste instrukce pro odblokování?",
          "forgot_your_password": "Zapomněli jste heslo?",
          "sign_in": "Přihlásit",
          "sign_in_with_provider": "Přihlásit se s %{provider}",
          "sign_up": "Registrovat"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Znovu odeslat instrukce pro odblokování"
        }
      }
    },
    "errors": {
      "messages": {
        "equal_to_current_password": "se musí lišit od aktuálního hesla.",
        "equal_to_email": "musí být jiný než e-mail.",
        "password_complexity": {
          "digit": {
            "few": "musí obsahovat alespoň %{count} číslice",
            "one": "musí obsahovat alespoň jednu číslici",
            "other": "musí obsahovat alespoň %{count} číslice"
          },
          "lower": {
            "few": "musí obsahovat alespoň %{count} malé písmena",
            "one": "musí obsahovat alespoň jedno malé písmeno",
            "other": "musí obsahovat alespoň %{count} malé písmena"
          },
          "symbol": {
            "few": "musí obsahovat alespoň %{count} interpunkční znaménka nebo symboly",
            "one": "musí obsahovat alespoň jedno interpunkční znaménko nebo symbol",
            "other": "musí obsahovat alespoň %{count} interpunkční znaménka nebo symboly"
          },
          "upper": {
            "few": "musí obsahovat alespoň %{count} velké písmena",
            "one": "musí obsahovat alespoň jedno velké písmeno",
            "other": "musí obsahovat alespoň %{count} velké písmena"
          }
        },
        "taken_in_past": "bylo již použito v minulosti."
      }
    },
    "i18n": {
      "plural": {}
    },
    "numbers": {
      "billions": {
        "few": "miliardy",
        "many": "miliard",
        "one": "miliarda"
      },
      "billionths": {
        "few": "miliardtiny",
        "many": "miliardtin",
        "one": "miliardtina"
      },
      "hundreds": [
        "_",
        "jedno sto",
        "dvě stě",
        "tři sta",
        "čtyři sta",
        "pět set",
        "šest set",
        "sedm set",
        "osm set",
        "devět set"
      ],
      "hundredths": {
        "few": "setiny",
        "many": "setin",
        "one": "setina"
      },
      "integral": "celých",
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillions",
        "sextillions",
        "septillions",
        "octillions"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths"
      ],
      "micro_prefix": {
        "hundreds": "sto",
        "tens": "deseti",
        "union": ""
      },
      "micro_separator": "",
      "millions": {
        "few": "milióny",
        "many": "miliónů",
        "one": "milión"
      },
      "millionths": {
        "few": "milióntiny",
        "many": "milióntin",
        "one": "milióntina"
      },
      "octillions": {
        "few": "kvadriliardy",
        "many": "kvadriliard",
        "one": "kvadriliarda"
      },
      "ones": {
        "female": [
          "nula",
          "jedna",
          "dvě",
          "tři",
          "čtyři",
          "pět",
          "šest",
          "sedm",
          "osm",
          "devět"
        ],
        "male": [
          "nula",
          "jeden",
          "dva",
          "tři",
          "čtyři",
          "pět",
          "šest",
          "sedm",
          "osm",
          "devět"
        ],
        "neuter": [
          "nula",
          "jedno",
          "dvě",
          "tři",
          "čtyři",
          "pět",
          "šest",
          "sedm",
          "osm",
          "devět"
        ]
      },
      "ordinal": {
        "hundreds": {
          "female": [
            "_",
            "stá",
            "dvoustá",
            "třístá",
            "čtyřstá",
            "pětistá",
            "šestistá",
            "sedmistá",
            "osmistá",
            "devítistá"
          ],
          "male": [
            "_",
            "stý",
            "dvoustý",
            "třístý",
            "čtyřstý",
            "pětistý",
            "šestistý",
            "sedmistý",
            "osmistý",
            "devítistý"
          ],
          "neuter": [
            "_",
            "sté",
            "dvousté",
            "třísté",
            "čtyřsté",
            "pětisté",
            "šestisté",
            "sedmisté",
            "osmisté",
            "devítisté"
          ]
        },
        "ones": {
          "female": [
            "nultá",
            "první",
            "druhá",
            "třetí",
            "čtvrtá",
            "pátá",
            "šestá",
            "sedmá",
            "osmá",
            "devátá"
          ],
          "male": [
            "nultý",
            "první",
            "druhý",
            "třetí",
            "čtvrtý",
            "pátý",
            "šestý",
            "sedmý",
            "osmý",
            "devátý"
          ],
          "neuter": [
            "nulté",
            "první",
            "druhé",
            "třetí",
            "čtvrté",
            "páté",
            "šesté",
            "sedmé",
            "osmé",
            "deváté"
          ]
        },
        "teens": {
          "female": [
            "_",
            "jedenáctá",
            "dvanáctá",
            "třináctá",
            "čtrnáctá",
            "patnáctá",
            "šestnáctá",
            "sedmnáctá",
            "osmnáctá",
            "devatenáctá"
          ],
          "male": [
            "_",
            "jedenáctý",
            "dvanáctý",
            "třináctý",
            "čtrnáctý",
            "patnáctý",
            "šestnáctý",
            "sedmnáctý",
            "osmnáctý",
            "devatenáctý"
          ],
          "neuter": [
            "_",
            "jedenácté",
            "dvanácté",
            "třinácté",
            "čtrnácté",
            "patnácté",
            "šestnácté",
            "sedmnácté",
            "osmnácté",
            "devatenácté"
          ]
        },
        "tens": {
          "female": [
            "_",
            "desátá",
            "dvacátá",
            "třicátá",
            "čtyřicátá",
            "padesátá",
            "šedesátá",
            "sedmdesátá",
            "osmdesátá",
            "devadesátá"
          ],
          "male": [
            "_",
            "desátý",
            "dvacátý",
            "třicátý",
            "čtyřicátý",
            "padesátý",
            "šedesátý",
            "sedmdesátý",
            "osmdesátý",
            "devadesátý"
          ],
          "neuter": [
            "_",
            "desáté",
            "dvacáté",
            "třicáté",
            "čtyřicáté",
            "padesáté",
            "šedesáté",
            "sedmdesáté",
            "osmdesáté",
            "devadesáté"
          ]
        }
      },
      "quadrillions": {
        "few": "biliardy",
        "many": "biliard",
        "one": "biliarda"
      },
      "quintillion": {
        "few": "triliony",
        "many": "trilionů",
        "one": "trilion"
      },
      "septillions": {
        "few": "kvadriliony",
        "many": "kvadrilionů",
        "one": "kvadrilion"
      },
      "sextillions": {
        "few": "triliardy",
        "many": "triliard",
        "one": "triliarda"
      },
      "teens": [
        "_",
        "jedenáct",
        "dvanáct",
        "třináct",
        "čtrnáct",
        "patnáct",
        "šestnáct",
        "sedmnáct",
        "osmnáct",
        "devatenáct"
      ],
      "tens": [
        "_",
        "deset",
        "dvacet",
        "třicet",
        "čtyřicet",
        "padesát",
        "šedesát",
        "sedmdesát",
        "osmdesát",
        "devadesát"
      ],
      "tenths": {
        "few": "desetiny",
        "many": "desetin",
        "one": "desetina"
      },
      "thousands": {
        "few": "tisíce",
        "many": "tisíc",
        "one": "tisíc"
      },
      "thousandths": {
        "few": "tisíciny",
        "many": "tisícin",
        "one": "tisícina"
      },
      "trillions": {
        "few": "biliony",
        "many": "bilionů",
        "one": "bilion"
      },
      "trillionths": {
        "few": "bilióntiny",
        "many": "bilióntin",
        "one": "bilióntina"
      },
      "union": ""
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Stránky",
          "one": "Stránka",
          "other": "Stránky"
        },
        "next": "Další",
        "previous": "Předchozí"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Zobrazeny položky %{from}-%{to} z %{count} celkem",
        "no_count": "Strana %{page} z %{pages}",
        "no_items": "Nic nebylo nalezeno",
        "single_page": "Zobrazeno %{count} %{item_name}"
      },
      "input_nav_js": "Strana %{page_input} z %{pages}",
      "item_name": {
        "few": "položky",
        "one": "položka",
        "other": "položek"
      },
      "limit_tag_js": "Zobrazit %{limit_input} %{item_name} na stránce",
      "next": "&gt;",
      "p11n": "WestSlavic",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "každou",
      "and": "a",
      "any": "kteroukoliv",
      "asc": "vzestupné",
      "attribute": "atribut",
      "combinator": "kombinátor",
      "condition": "podmínka",
      "desc": "sestupné",
      "or": "nebo",
      "predicate": "predikát",
      "predicates": {
        "blank": "je prázdné",
        "cont": "obsahuje",
        "cont_all": "obsahuje všechny",
        "cont_any": "obsahuje kterékoliv",
        "does_not_match": "neodpovídá",
        "does_not_match_all": "neodpovídá všem",
        "does_not_match_any": "neodpovídá kterékoliv",
        "end": "končí s",
        "end_all": "končí se všemi",
        "end_any": "končí s kteroukoliv",
        "eq": "rovno",
        "eq_all": "rovno všem",
        "eq_any": "rovno kterékoliv",
        "false": "není pravdivé",
        "gt": "větší než",
        "gt_all": "větší než všechny",
        "gt_any": "větší než kterákoliv",
        "gteq": "větší nebo rovno než",
        "gteq_all": "větší nebo rovno než všechny",
        "gteq_any": "větší nebo rovno než kterákoliv",
        "in": "v",
        "in_all": "ve všech",
        "in_any": "v kterékoliv",
        "lt": "menší než",
        "lt_all": "menší než všechny",
        "lt_any": "menší než kterákoliv",
        "lteq": "menší nebo rovno než",
        "lteq_all": "menší nebo rovno než všechny",
        "lteq_any": "menší nebo rovno než kterákoliv",
        "matches": "odpovídá",
        "matches_all": "odpovídá všem",
        "matches_any": "odpovídá kterékoliv",
        "not_cont": "neobsahuje",
        "not_cont_all": "neobsahuje všechny",
        "not_cont_any": "neobsahuje kteroukoliv",
        "not_end": "nekončí s",
        "not_end_all": "nekončí se všemi",
        "not_end_any": "nekončí s kteroukoliv",
        "not_eq": "nerovno",
        "not_eq_all": "nerovno všem",
        "not_eq_any": "nerovno kterékoliv",
        "not_in": "není v",
        "not_in_all": "není ve všech",
        "not_in_any": "není v kterékoliv",
        "not_null": "není null",
        "not_start": "nezačíná s",
        "not_start_all": "nezačíná se všemi",
        "not_start_any": "nezačíná s kteroukoliv",
        "null": "je null",
        "present": "je vyplněné",
        "start": "začíná s",
        "start_all": "začíná se všemi",
        "start_any": "začíná s kteroukoliv",
        "true": "je pravdivé"
      },
      "search": "vyhledávání",
      "sort": "řazení",
      "value": "hodnota"
    }
  },
  "da": {
    "active_admin": {
      "access_denied": {
        "message": "Du har ikke rettigheder til at udføre denne handling."
      },
      "any": "Alle",
      "batch_actions": {
        "action_label": "%{title} Valgte",
        "button_label": "Batch Handlinger",
        "default_confirmation": "Er du sikker på du vil gøre dette?",
        "delete_confirmation": "Er du sikker på du vil slette disse %{plural_model}?",
        "labels": {
          "destroy": "Slet"
        },
        "selection_toggle_explanation": "(Skift valg)",
        "succesfully_destroyed": {
          "one": "Vellykket ødelagt 1 %{model}",
          "other": "Vellykket ødelagt %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Der er ingen %{resource_name} endnu.",
        "link": "Opret"
      },
      "cancel": "Fortryd",
      "comments": {
        "add": "Tilføj Kommentar",
        "author": "Forfatter",
        "author_missing": "Anonym",
        "author_type": "Forfatter type",
        "body": "Krop",
        "created_at": "Oprettet",
        "delete": "Slet kommentar",
        "delete_confirmation": "Er du sikker på du vil slette disse kommentarer?",
        "errors": {
          "empty_text": "Kommentar blev ikke gemt, tekst var tom."
        },
        "no_comments_yet": "Ingen kommentarer endnu.",
        "resource": "Resource",
        "resource_type": "Resource type",
        "title_content": "Kommentarer (%{count})"
      },
      "create_another": "Opret endnu en %{model}",
      "dashboard": "Kontrolpanel",
      "dashboard_welcome": {
        "call_to_action": "Rediger 'app/admin/dashboard.rb' for at tilføje nye elementer til oversigtssiden.",
        "welcome": "Velkommen til Active Admin. Dette er standardoversigtssiden."
      },
      "delete": "Slet",
      "delete_confirmation": "Er du sikker på, at du ønsker at slette?",
      "delete_model": "Slet %{model}",
      "details": "%{model} detaljer",
      "devise": {
        "change_password": {
          "submit": "Skift min adgangskode",
          "title": "Skift din adgangskode"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Glemt din adgangskode?",
          "resend_confirmation_instructions": "Send oplåsningsinstruktioner igen",
          "resend_unlock_instructions": "Send oplåsningsinstruktioner igen",
          "sign_in": "Log ind",
          "sign_in_with_omniauth_provider": "Log ind med %{provider}",
          "sign_up": "Opret bruger"
        },
        "login": {
          "remember_me": "Husk mig",
          "submit": "Login",
          "title": "Login"
        },
        "password": {
          "title": "Kodeord"
        },
        "resend_confirmation_instructions": {
          "submit": "Send bekræftigelsesinstruktioner igen",
          "title": "Send bekræftigelsesinstruktioner igen"
        },
        "reset_password": {
          "submit": "Nulstille min adgangskode",
          "title": "Glemt din adgangskode?"
        },
        "sign_up": {
          "submit": "Opret bruger",
          "title": "Opret bruger"
        },
        "subdomain": {
          "title": "Underdomæne"
        },
        "unlock": {
          "submit": "Send oplåsningsinstruktioner igen",
          "title": "Send oplåsningsinstruktioner igen"
        },
        "username": {
          "title": "Brugernavn"
        }
      },
      "download": "Download:",
      "dropdown_actions": {
        "button_label": "Handlinger"
      },
      "edit": "Rediger",
      "edit_model": "Rediger %{model}",
      "empty": "Tom",
      "filters": {
        "buttons": {
          "clear": "Ryd filtre",
          "filter": "Filtrer"
        }
      },
      "has_many_delete": "Slet",
      "has_many_new": "Tilføj ny(t) %{model}",
      "has_many_remove": "Fjern",
      "index_list": {
        "block": "Liste",
        "blog": "Blog",
        "grid": "Gitter",
        "table": "Tabel"
      },
      "logout": "Log ud",
      "main_content": "Implementer venligst %{model}#main_content for at vise noget indhold.",
      "new_model": "Ny(t) %{model}",
      "next": "Næste",
      "pagination": {
        "empty": "Ingen %{model} fundet",
        "entry": {
          "one": "post",
          "other": "poster"
        },
        "multiple": "Viser %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> af <b>%{total}</b> i alt",
        "multiple_without_total": "Viser %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Viser <b>1</b> %{model}",
        "one_page": "Viser <b>alle %{n}</b> %{model}",
        "per_page": "Per side: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Forrige",
      "search_status": {
        "current_filters": "Valgte filtre:",
        "current_scope": "Perspektiv:",
        "headline": "Søgestatus:",
        "no_current_filters": "Ingen"
      },
      "sidebars": {
        "filters": "Filtre",
        "search_status": "Søgestatus"
      },
      "status_tag": {
        "no": "Nej",
        "unset": "Nej",
        "yes": "Ja"
      },
      "unsupported_browser": {
        "headline": "Vær venligst opmærksom på, at ActiveAdmin ikke længere understøtter Internet Explorer version 8 eller tidligere.",
        "recommendation": "Vi anbefaler at du opgraderer til den nyeste <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, eller <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Hvis du bruger IE 9 eller senere, så vær sikker på, at du <a href=\"https://support.microsoft.com/da-dk/help/17471\">slår \"Compatibility View\" fra</a>."
      },
      "view": "Vis"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "invitation_accepted_at": "Invitation accepteret",
          "invitation_created_at": "Invitation oprettet",
          "invitation_limit": "Invitationsbegrænsning",
          "invitation_sent_at": "Invitation sendt",
          "invitation_token": "Invitationsnøgle",
          "invitations_count": "Antal invitationer",
          "invited_by": "Inviteret af"
        }
      }
    },
    "devise": {
      "failure": {
        "invited": "Du har allerede en ventende invitation, som du bedes acceptere for at oprette en konto."
      },
      "invitations": {
        "edit": {
          "header": "Vælg din adgangskode",
          "submit_button": "Gem adgangskode"
        },
        "invitation_removed": "Din invitation er blevet fjernet.",
        "invitation_token_invalid": "Den angivne invitationsnøgle er ikke gyldig.",
        "new": {
          "header": "Send en invitation",
          "submit_button": "Send mail"
        },
        "no_invitations_remaining": "Ikke flere invitationer tilbage",
        "send_instructions": "Der er sendt en invitationsmail til %{email}.",
        "updated": "Din adgangskode er gemt, og du er nu logget ind.",
        "updated_not_active": "Din adgangskode er gemt, og du kan nu logge ind på din konto."
      },
      "mailer": {
        "invitation_instructions": {
          "accept": "Accepter invitation",
          "accept_until": "Invitation gælder indtil %{due_date}.",
          "hello": "Hej %{email}",
          "ignore": "Hvis du ikke vil tage imod invitationen om at oprette en konto, kan du blot ignorere denne mail.<br />\nDer vil ikke blive oprettet nogen konto, medmindre du følger linket herover og derefter opretter en adgangskode.",
          "someone_invited_you": "Du er blevet inviteret til at oprette en konto på %{url}, og du kan gøre det via linket herunder.",
          "subject": "Invitation til at oprette en konto"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "har et ugyldigt aspektforhold (gyldige aspektforhold er %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "skal være landskab (nuværende fil er %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "skal være portræt (nuværende fil er %{width}x%{height}px)",
        "aspect_ratio_not_square": "skal være firkantet (nuværende fil er %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "skal være %{authorized_aspect_ratios} (nuværende fil er %{width}x%{height}px)",
        "attachment_missing": "har ingen vedhæftet fil",
        "audio_missing": "skal have et lydspor",
        "audio_present": "må ikke have et lydspor",
        "content_type_invalid": {
          "one": "har en ugyldig indholdstype (autoriseret indholdstype er %{authorized_human_content_types})",
          "other": "har en ugyldig indholdstype (autoriserede indholdstyper er %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "har en indholdstype, der ikke svarer til den, der registreres gennem dens indhold (autoriseret indholdstype er %{authorized_human_content_types})",
          "other": "har en indholdstype, der ikke svarer til den, der registreres gennem dens indhold (autoriserede indholdstyper er %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "højden skal være lig med %{length} pixel",
        "dimension_height_not_greater_than_or_equal_to": "højden skal være større end eller lig med %{length} pixel",
        "dimension_height_not_included_in": "højden er ikke inkluderet mellem %{min} og %{max} pixel",
        "dimension_height_not_less_than_or_equal_to": "højden skal være mindre end eller lig med %{length} pixel",
        "dimension_max_not_included_in": "skal være mindre end eller lig med %{width} x %{height} pixel",
        "dimension_min_not_included_in": "skal være større end eller lig med %{width} x %{height} pixel",
        "dimension_width_not_equal_to": "bredden skal være lig med %{length} pixel",
        "dimension_width_not_greater_than_or_equal_to": "bredden skal være større end eller lig med %{length} pixel",
        "dimension_width_not_included_in": "bredden er ikke inkluderet mellem %{min} og %{max} pixel",
        "dimension_width_not_less_than_or_equal_to": "bredden skal være mindre end eller lig med %{length} pixel",
        "duration_not_between": "varighed skal være mellem %{min} og %{max} (den aktuelle varighed er %{duration})",
        "duration_not_equal_to": "varighed skal være lig med %{exact} (den aktuelle varighed er %{duration})",
        "duration_not_greater_than": "varigheden skal være større end %{min} (den aktuelle varighed er %{duration})",
        "duration_not_greater_than_or_equal_to": "varigheden skal være større end eller lig med %{min} (den aktuelle varighed er %{duration})",
        "duration_not_less_than": "varighed skal være mindre end %{max} (nuværende varighed er %{duration})",
        "duration_not_less_than_or_equal_to": "varighed skal være mindre end eller lig med %{max} (nuværende varighed er %{duration})",
        "file_not_processable": "identificeres ikke som en gyldig mediefil",
        "file_size_not_between": "filstørrelsen skal være mellem %{min} og %{max} (den nuværende størrelse er %{file_size})",
        "file_size_not_equal_to": "filstørrelsen skal være lig med %{exact} (den nuværende størrelse er %{file_size})",
        "file_size_not_greater_than": "filstørrelsen skal være større end %{min} (den nuværende størrelse er %{file_size})",
        "file_size_not_greater_than_or_equal_to": "filstørrelsen skal være større end eller lig med %{min} (den nuværende størrelse er %{file_size})",
        "file_size_not_less_than": "filstørrelsen skal være mindre end %{max} (den nuværende størrelse er %{file_size})",
        "file_size_not_less_than_or_equal_to": "filstørrelsen skal være mindre end eller lig med %{max} (den nuværende størrelse er %{file_size})",
        "limit_max_exceeded": {
          "one": "for mange vedhæftede filer (maks. er %{max} filer, fik %{count})",
          "other": "for mange vedhæftede filer (maks. er %{max} filer, fik %{count})",
          "zero": "ingen filer vedhæftet (maks. er %{max} filer)"
        },
        "limit_min_not_reached": {
          "one": "kun 1 fil vedhæftet (skal have mindst %{min} filer)",
          "other": "%{count} filer vedhæftet (skal have mindst %{min} filer)",
          "zero": "ingen filer vedhæftet (skal have mindst %{min} filer)"
        },
        "limit_out_of_range": {
          "one": "kun 1 fil vedhæftet (skal have mellem %{min} og %{max} filer)",
          "other": "det samlede antal filer skal være mellem %{min} og %{max} filer (der er %{count} filer vedhæftet)",
          "zero": "ingen filer vedhæftet (skal have mellem %{min} og %{max} filer)"
        },
        "media_metadata_missing": "er ikke en gyldig mediefil",
        "pages_not_between": "sideantal skal være mellem %{min} og %{max} (aktuelt sideantal er %{pages})",
        "pages_not_equal_to": "sideantal skal være lig med %{exact} (aktuelt sideantal er %{pages})",
        "pages_not_greater_than": "sideantal skal være større end %{min} (aktuelt sideantal er %{pages})",
        "pages_not_greater_than_or_equal_to": "sideantal skal være større end eller lig med %{min} (aktuelt sideantal er %{pages})",
        "pages_not_less_than": "sideantal skal være mindre end %{max} (aktuelt sideantal er %{pages})",
        "pages_not_less_than_or_equal_to": "sideantal skal være mindre end eller lig med %{max} (aktuelt sideantal er %{pages})",
        "total_file_size_not_between": "den samlede filstørrelse skal være mellem %{min} og %{max} (aktuel størrelse er %{total_file_size})",
        "total_file_size_not_equal_to": "den samlede filstørrelse skal være lig med %{exact} (aktuel størrelse er %{total_file_size})",
        "total_file_size_not_greater_than": "den samlede filstørrelse skal være større end %{min} (aktuel størrelse er %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "den samlede filstørrelse skal være større end eller lig med %{min} (aktuel størrelse er %{total_file_size})",
        "total_file_size_not_less_than": "den samlede filstørrelse skal være mindre end %{max} (aktuel størrelse er %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "den samlede filstørrelse skal være mindre end eller lig med %{max} (aktuel størrelse er %{total_file_size})"
      }
    },
    "numbers": {
      "billiard": {
        "one": "billiard",
        "other": "billiarder"
      },
      "billion": {
        "one": "billion",
        "other": "billioner"
      },
      "common": [
        "nul",
        "en",
        "to",
        "tre",
        "fire",
        "fem",
        "seks",
        "syv",
        "otte",
        "ni"
      ],
      "hundreds": [
        "_",
        "et hundrede",
        "to hundrede",
        "tre hundrede",
        "fire hundrede",
        "fem hundrede",
        "seks hundrede",
        "syv hundrede",
        "otte hundrede",
        "ni hundrede"
      ],
      "hundredths": {
        "one": "hundrededel",
        "other": "hundrededele"
      },
      "mega": [
        "_",
        "tusinde",
        "million",
        "milliard",
        "billion",
        "billiard",
        "trillion"
      ],
      "micro": [
        "_",
        "tiendedele",
        "hundrededele",
        "tusindedele",
        "milliontedele"
      ],
      "micro_prefix": {
        "hundreds": "hundrede",
        "tens": "ti",
        "union": "-"
      },
      "micro_separator": "og",
      "milliard": {
        "one": "milliard",
        "other": "milliarder"
      },
      "million": {
        "one": "million",
        "other": "millioner"
      },
      "millionths": {
        "one": "milliontedel",
        "other": "milliontedele"
      },
      "neuter": [
        "nul",
        "et",
        "to",
        "tre",
        "fire",
        "fem",
        "seks",
        "syv",
        "otte",
        "ni"
      ],
      "one_hundred": "et hundrede",
      "ones": [
        "nul",
        "et",
        "to",
        "tre",
        "fire",
        "fem",
        "seks",
        "syv",
        "otte",
        "ni"
      ],
      "ordinal": {
        "hundreds": "hundredende",
        "ones": [
          "nulte",
          "første",
          "anden",
          "tredje",
          "fjerde",
          "femte",
          "sjette",
          "syvende",
          "ottende",
          "niende"
        ],
        "teens": [
          "tiende",
          "ellevte",
          "tolvte",
          "trettende",
          "fjortende",
          "femtende",
          "sekstende",
          "syttende",
          "attende",
          "nittende"
        ],
        "tens": [
          "_",
          "tiende",
          "tyvende",
          "tredive",
          "fyrre",
          "halvtreds",
          "tres",
          "halvfjerds",
          "firs",
          "halvfems"
        ]
      },
      "teens": [
        "_",
        "elleve",
        "tolv",
        "tretten",
        "fjorten",
        "femten",
        "seksten",
        "sytten",
        "atten",
        "nitten"
      ],
      "tens": [
        "_",
        "ti",
        "tyve",
        "tredive",
        "fyrre",
        "halvtreds",
        "tres",
        "halvfjerds",
        "firs",
        "halvfems"
      ],
      "tenths": {
        "one": "tiendedel",
        "other": "tiendedele"
      },
      "thousandths": {
        "one": "tusindedel",
        "other": "tusindedele"
      },
      "trillion": {
        "one": "trillion",
        "other": "trillioner"
      },
      "tusinde": {
        "one": "tusinde",
        "other": "tusinde"
      },
      "union": "og"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Side",
          "other": "Sider"
        },
        "next": "Næste",
        "previous": "Forrige"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Viser %{item_name} %{from}-%{to} af %{count} totalt",
        "no_count": "Side %{page} af %{pages}",
        "no_items": "Ingen %{item_name} fundet",
        "single_page": "Viser %{count} %{item_name}"
      },
      "input_nav_js": "Side %{page_input} af %{pages}",
      "item_name": {
        "one": "resultat",
        "other": "resultater"
      },
      "limit_tag_js": "Antal %{limit_input} %{item_name} per side",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "alle",
      "and": "og",
      "any": "anhver",
      "asc": "opstigende",
      "attribute": "attribut",
      "combinator": "kombinering",
      "condition": "betingelse",
      "desc": "faldende",
      "or": "eller",
      "predicate": "predicate",
      "predicates": {
        "blank": "er blank",
        "cont": "indeholder",
        "cont_all": "indeholder alle",
        "cont_any": "indeholder nogen",
        "does_not_match": "matcher ikke",
        "does_not_match_all": "matcher ikke alle",
        "does_not_match_any": "matcher ikke nogen",
        "end": "slutter med",
        "end_all": "slutter med alle",
        "end_any": "slutter med nogen",
        "eq": "lig med",
        "eq_all": "lig med alle",
        "eq_any": "lig med enhver",
        "false": "er falsk",
        "gt": "større end",
        "gt_all": "større end alle",
        "gt_any": "større end nogen",
        "gteq": "større end eller lig med",
        "gteq_all": "større end eller lig med alle",
        "gteq_any": "større end eller lig med nogen",
        "in": "i",
        "in_all": "i alle",
        "in_any": "i nogen",
        "lt": "mindre end",
        "lt_all": "mindre end alle",
        "lt_any": "mindre end nogen",
        "lteq": "mindre end eller lig med",
        "lteq_all": "mindre end eller lig med alle",
        "lteq_any": "mindre end eller lig med nogen",
        "matches": "matcher",
        "matches_all": "matcher alle",
        "matches_any": "matcher enhver",
        "not_cont": "indeholder ikke",
        "not_cont_all": "indeholder ikke alle",
        "not_cont_any": "indeholder ikke nogen",
        "not_end": "slutter ikke med",
        "not_end_all": "slutter ikke med alle",
        "not_end_any": "slutter ikke med nogen",
        "not_eq": "ikke lig med",
        "not_eq_all": "ikke lig med alle",
        "not_eq_any": "ikke lig med nogen",
        "not_in": "ikke i",
        "not_in_all": "ikke i alle",
        "not_in_any": "ikke i nogen",
        "not_null": "er ikke nul",
        "not_start": "starter ikke med",
        "not_start_all": "starter ikke med alle",
        "not_start_any": "starter ikke med nogen",
        "null": "er nul",
        "present": "er til stede",
        "start": "starter med",
        "start_all": "starter med alle",
        "start_any": "starter med nogen",
        "true": "er sand"
      },
      "search": "søg",
      "sort": "sorter",
      "value": "værdi"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%e. %B %Y kl. %H.%M"
            }
          }
        }
      }
    }
  },
  "da-DK": {
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": null,
          "email": null,
          "password": null,
          "password_confirmation": null,
          "remember_me": null
        }
      },
      "models": {
        "user": null
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Få tilsendt bekræftelses-instruktioner"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Bekræft min konto",
          "greeting": "Velkommen %{recipient}!",
          "instruction": "Du kan bekræfte din email-konto igennem linket herunder:"
        },
        "reset_password_instructions": {
          "action": "Ændre mit kodeord",
          "greeting": "Hej %{recipient}!",
          "instruction": "Der er blevet anmodet om, at få tilsendt et link til ændring af dit kodeord. Det kan gøres ved hjælp af linket herunder.",
          "instruction_2": "Hvis du ikke har anmodet om dette, så se venligst bort fra denne email.",
          "instruction_3": "Dit kodeord forbliver uændret indtil du laver et nyt, ved hjælp af linket foroven."
        },
        "unlock_instructions": {
          "action": "Aktivér min konto",
          "greeting": "Hej %{recipient}!",
          "instruction": "Klik på linket herunder for at aktivere din konto:",
          "message": "Din konto er blevet låst efter for mange forkerte log-ind forsøg."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": "Glemt kodeord?",
          "send_me_reset_password_instructions": "Send mig instruktioner til gendannelse af password"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Er du sikker?",
          "cancel_my_account": "Slet min konto",
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": "efterlades blankt hvis det ikke ønskes ændret ",
          "title": "Rediger %{resource}",
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": "vi skal bruge dit nuværende kodeord for at bekræfte ændringerne."
        },
        "new": {
          "sign_up": "Registrer"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Log-ind"
        }
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": "Har du ikke modtaget bekræftelses-instruktioner?",
          "didn_t_receive_unlock_instructions": "Har du ikke modtaget aktiverings-instruktioner?",
          "forgot_your_password": "Glemt kodeord?",
          "sign_in": "Log-ind",
          "sign_in_with_provider": "Log-ind med %{provider}",
          "sign_up": "Registrer"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Få tilsendt aktiverings-instruktioner"
        }
      }
    }
  },
  "de": {
    "active_admin": {
      "access_denied": {
        "message": "Sie haben nicht die Berechtigung um diese Aktion auszuführen."
      },
      "any": "Alle",
      "batch_actions": {
        "action_label": "%{title} ausgewählte",
        "button_label": "Stapelverarbeitung",
        "default_confirmation": "Bist du sicher, dass Sie dies tun wollen?",
        "delete_confirmation": "Sind Sie sicher dass sie diese %{plural_model} löschen wollen?",
        "labels": {
          "destroy": "Lösche"
        },
        "selection_toggle_explanation": "(Auswahl umschalten)",
        "succesfully_destroyed": {
          "one": "Erfolgreich 1 %{model} gelöscht",
          "other": "Erfolgreich %{count} %{plural_model} gelöscht"
        }
      },
      "blank_slate": {
        "content": "Es gibt noch keine %{resource_name}.",
        "link": "Erstellen"
      },
      "cancel": "Abbrechen",
      "comments": {
        "add": "Kommentar hinzufügen",
        "author": "Autor",
        "author_missing": "Unbekannt",
        "author_type": "Autor-Typ",
        "body": "Inhalt",
        "created_at": "Erstellt",
        "delete": "Löschen",
        "delete_confirmation": "Sind Sie sicher dass sie diesen Kommentar löschen wollen?",
        "errors": {
          "empty_text": "Der Kommentar wurde nicht gespeichert, da der Text fehlt."
        },
        "no_comments_yet": "Es gibt noch keine Kommentare.",
        "resource": "Res­sour­ce",
        "resource_type": "Res­sour­cen-Typ",
        "title_content": "Kommentare (%{count})"
      },
      "create_another": "Mehr %{model} erstellen",
      "dashboard": "Übersicht",
      "dashboard_welcome": {
        "call_to_action": "Siehe 'app/admin/dashboard.rb', um Übersichts-Bereiche hinzuzufügen.",
        "welcome": "Willkommen in Active Admin. Dies ist die Standard-Übersichtsseite."
      },
      "delete": "Löschen",
      "delete_confirmation": "Wollen Sie dieses Element wirklich löschen?",
      "delete_model": "%{model} löschen",
      "details": "%{model} Details",
      "devise": {
        "change_password": {
          "submit": "Mein Passwort ändern",
          "title": "Ändern Sie Ihr Passwort"
        },
        "email": {
          "title": "E-Mail-Adresse"
        },
        "links": {
          "forgot_your_password": "Passwort vergessen?",
          "resend_confirmation_instructions": "Bestätigungsanweisung erneut senden",
          "resend_unlock_instructions": "Entsperrungsanweisung erneut senden",
          "sign_in": "Anmeldung",
          "sign_in_with_omniauth_provider": "Anmeldung mit %{provider}",
          "sign_up": "Registrieren"
        },
        "login": {
          "remember_me": "Angemeldet bleiben",
          "submit": "Login",
          "title": "Login"
        },
        "password": {
          "title": "Passwort"
        },
        "password_confirmation": {
          "title": "Passwort Bestätigung"
        },
        "resend_confirmation_instructions": {
          "submit": "Anleitung zur Bestätigung noch mal schicken",
          "title": "Anleitung zur Bestätigung noch mal schicken"
        },
        "reset_password": {
          "submit": "Mein Passwort zurücksetzen",
          "title": "Passwort vergessen?"
        },
        "sign_up": {
          "submit": "Registrieren",
          "title": "Registrieren"
        },
        "subdomain": {
          "title": "Subdomain"
        },
        "unlock": {
          "submit": "Entsperrungsanweisung erneut senden",
          "title": "Entsperrungsanweisung erneut senden"
        },
        "username": {
          "title": "Benutzername"
        }
      },
      "download": "Herunterladen:",
      "dropdown_actions": {
        "button_label": "Aktionen"
      },
      "edit": "Bearbeiten",
      "edit_model": "%{model} bearbeiten",
      "empty": "Leer",
      "filters": {
        "buttons": {
          "clear": "Filter entfernen",
          "filter": "Filtern"
        },
        "predicates": {
          "from": "Von",
          "to": "Bis"
        }
      },
      "has_many_delete": "Löschen",
      "has_many_new": "%{model} hinzufügen",
      "has_many_remove": "Entfernen",
      "index_list": {
        "block": "Liste",
        "blog": "Blog",
        "grid": "Gitter",
        "table": "Tabelle"
      },
      "logout": "Abmelden",
      "main_content": "Bitte implementieren Sie %{model}#main_content, um Inhalte anzuzeigen.",
      "move": "Bewegen",
      "new_model": "%{model} erstellen",
      "next": "Weiter",
      "pagination": {
        "empty": "Keine %{model} gefunden",
        "entry": {
          "one": "Eintrag",
          "other": "Einträge"
        },
        "multiple": "Zeige %{model} <b>%{from}&nbsp;–&nbsp;%{to}</b> von <b>%{total}</b>",
        "multiple_without_total": "Zeige %{model} <b>%{from}&nbsp;–&nbsp;%{to}</b>",
        "one": "Zeige <b>1</b> %{model}",
        "one_page": "Zeige <b>alle %{n}</b> %{model}",
        "per_page": "Pro Seite: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Zurück",
      "scopes": {
        "all": "Alle"
      },
      "search_status": {
        "current_filters": "Aktuelle Filter:",
        "current_scope": "Anwendungsbereich:",
        "headline": "Filter",
        "no_current_filters": "Keine"
      },
      "sidebars": {
        "filters": "Filter",
        "search_status": "Suchstatus"
      },
      "status_tag": {
        "no": "Nein",
        "unset": "Nein",
        "yes": "Ja"
      },
      "unsupported_browser": {
        "headline": "ActiveAdmin unterstützt nicht länger den Internet Explorer in Version 8 oder niedriger.",
        "recommendation": "Wir empfehlen die Nutzung von <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, oder <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Wenn sie IE 9 oder neuer benutzen, stellen sie sicher das sie den <a href=\"https://support.microsoft.com/de-de/help/17471\">\"Kompatibilitätsansicht\" ausgeschaltet</a> haben."
      },
      "view": "Anzeigen"
    },
    "activerecord": {
      "attributes": {
        "active_admin/comment": {
          "author_type": "Autortyp",
          "body": "Inhalt",
          "created_at": "Erstellt",
          "namespace": "Namensraum",
          "resource_type": "Ressourcentyp",
          "updated_at": "Aktualisiert"
        },
        "user": {
          "current_password": "Bisheriges Passwort",
          "email": "E-Mail",
          "password": "Passwort",
          "password_confirmation": "Passwortbestätigung",
          "remember_me": "Angemeldet bleiben"
        }
      },
      "models": {
        "active_admin/comment": {
          "one": "Kommentar",
          "other": "Kommentare"
        },
        "comment": {
          "one": "Kommentar",
          "other": "Kommentare"
        },
        "user": "Benutzer"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Anleitung zur Bestätigung noch mal schicken"
        }
      },
      "failure": {
        "expired": "Ihr Account ist aufgrund zu langer Inaktivität abgelaufen. Bitte kontaktieren Sie den Administrator.",
        "invited": "Du hast bereits eine Einladung erhalten. Nimm die Einladung an um dein Nutzerkonto zu erstellen.",
        "session_limited": "Ihre Anmeldedaten wurden in einem anderen Browser genutzt. Bitte melden Sie sich erneut an, um in diesem Browser fortzufahren."
      },
      "invalid_captcha": "Die Captcha-Eingabe ist nicht gültig.",
      "invalid_security_question": "Die Antwort auf die Sicherheitsfrage war ungültig.",
      "invitations": {
        "edit": {
          "header": "Setze ein Passwort",
          "submit_button": "Passwort setzen"
        },
        "invitation_removed": "Deine Einladung wurde gelöscht.",
        "invitation_token_invalid": "Der Einladungs-Code ist ungültig!",
        "new": {
          "header": "Einladung schicken",
          "submit_button": "Einladung schicken"
        },
        "no_invitations_remaining": "Es gibt keine weiteren Einladungen",
        "send_instructions": "Eine Einladung wurde an %{email} verschickt.",
        "updated": "Dein Passwort wurde gesetzt. Du bist nun angemeldet.",
        "updated_not_active": "Dein Passwort wurde gesetzt."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Mein Konto bestätigen",
          "greeting": "Willkommen %{recipient}!",
          "instruction": "Folgen Sie dem untenstehenden Link, um Ihr Konto zu bestätigen:"
        },
        "invitation_instructions": {
          "accept": "Einladung annehmen",
          "accept_until": "Diese Einladung ist gültig bis zum %{due_date}.",
          "hello": "Hallo %{email}",
          "ignore": "Wenn du die Einladung nicht annehmen willst, ignoriere diese E-Mail einfach. Es wird kein Benutzerkonto erstellt solange du nicht die Einladung mittels des Links oben annimmst.",
          "someone_invited_you": "Jemand hat dich zu %{url} eingeladen. Du kannst die Einladung mit dem Link unten annehmen.",
          "subject": "Einladung"
        },
        "reset_password_instructions": {
          "action": "Passwort ändern",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Jemand hat einen Link angefordert, um Ihr Passwort zu ändern. Klicken Sie auf den unten aufgeführten Link um das Passwort zu ändern.",
          "instruction_2": "Bitte ignorieren Sie diese E-Mail, wenn Sie kein neues Passwort angefordert haben.",
          "instruction_3": "Das Passwort wird nicht geändert bis Sie den obenstehenden Link abrufen und ein neues Passwort bestimmen."
        },
        "unlock_instructions": {
          "action": "Mein Konto entsperren",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Folgen Sie dem untenstehenden Link, um Ihr Konto zu entsperren:",
          "message": "Ihr Konto wurde aufgrund einer großen Anzahl von fehlgeschlagenen Anmeldeversuchen gesperrt."
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Bestätigen",
          "submit_verification_code": "Bestätigungscode eingeben",
          "verification_code": "Bestätigungscode"
        },
        "updated": "Bestätigungscode akzeptiert"
      },
      "paranoid_verify": {
        "code_required": "Bitte geben Sie den Code ein, den unser Support-Team zur Verfügung gestellt hat."
      },
      "password_expired": {
        "change_required": "Ihr Passwort ist abgelaufen. Bitte vergeben Sie ein neues Passwort.",
        "show": {
          "change_my_password": "Passwort ändern",
          "current_password": "Aktuelles Passwort",
          "new_password": "Neues Passwort",
          "new_password_confirmation": "Passwort bestätigen",
          "renew_your_password": "Vergeben Sie ein neues Passwort"
        },
        "updated": "Das neue Passwort wurde übernommen."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Ändere mein Passwort",
          "change_your_password": "Passwort ändern",
          "confirm_new_password": "Neues Passwort bestätigen",
          "new_password": "Neues Passwort"
        },
        "new": {
          "forgot_your_password": "Haben Sie Ihr Passwort vergessen?",
          "send_me_reset_password_instructions": "Schicken Sie mir die Anleitung, mein Passwort zurückzusetzen"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Sind Sie sicher?",
          "cancel_my_account": "Konto löschen",
          "currently_waiting_confirmation_for_email": "Warte auf Bestätigung von %{email}.",
          "leave_blank_if_you_don_t_want_to_change_it": "freilassen, wenn Sie das nicht ändern wollen",
          "title": "%{resource} bearbeiten",
          "unhappy": "Unglücklich",
          "update": "Aktualisieren",
          "we_need_your_current_password_to_confirm_your_changes": "wir benötigen Ihr aktuelles Passwort, um die Änderung zu bestätigen"
        },
        "new": {
          "sign_up": "Registrieren"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Anmelden"
        }
      },
      "shared": {
        "links": {
          "back": "Zurück",
          "didn_t_receive_confirmation_instructions": "Keine Anleitung zur Bestätigung erhalten?",
          "didn_t_receive_unlock_instructions": "Keine Anleitung zum Entsperren erhalten?",
          "forgot_your_password": "Passwort vergessen?",
          "sign_in": "Anmelden",
          "sign_in_with_provider": "Mit %{provider} anmelden",
          "sign_up": "Registrieren"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Anleitung zum Entsperren noch mal schicken"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "hat ein ungültiges Seitenverhältnis (gültige Seitenverhältnisse sind %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "muss landschaftlich sein (aktuelle Datei ist %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "muss Porträt sein (aktuelle Datei ist %{width}x%{height}px)",
        "aspect_ratio_not_square": "muss quadratisch sein (aktuelle Datei ist %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "muss %{authorized_aspect_ratios} sein (aktuelle Datei ist %{width}x%{height}px)",
        "attachment_missing": "hat keine angehängte Datei",
        "audio_missing": "muss eine Audiospur enthalten",
        "audio_present": "darf keine Audiospur enthalten",
        "content_type_invalid": {
          "one": "hat einen ungültigen Inhaltstyp (autorisierter Inhaltstyp ist %{authorized_human_content_types})",
          "other": "hat einen ungültigen Inhaltstyp (autorisierte Inhaltstypen sind %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "hat einen Inhaltstyp, der nicht dem entspricht, der durch seinen Inhalt erkannt wird (autorisierter Inhaltstyp ist %{authorized_human_content_types})",
          "other": "hat einen Inhaltstyp, der nicht dem entspricht, der durch seinen Inhalt erkannt wird (autorisierte Inhaltstypen sind %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "Bildhöhe muss genau %{length} Pixel sein",
        "dimension_height_not_greater_than_or_equal_to": "Bildhöhe muss größer oder gleich %{length} Pixel sein",
        "dimension_height_not_included_in": "Bildhöhe muss zwischen %{min} und %{max} Pixel liegen",
        "dimension_height_not_less_than_or_equal_to": "Höhe muss kleiner oder gleich %{length} Pixel sein",
        "dimension_max_not_included_in": "muss kleiner oder gleich %{width} x %{height} Pixel sein",
        "dimension_min_not_included_in": "muss größer oder gleich %{width} x %{height} Pixel sein",
        "dimension_width_not_equal_to": "Bildbreite muss genau %{length} Pixel sein",
        "dimension_width_not_greater_than_or_equal_to": "Bildbreite muss größer oder gleich %{length} Pixel sein",
        "dimension_width_not_included_in": "Bildbreite muss zwischen %{min} und %{max} Pixel liegen",
        "dimension_width_not_less_than_or_equal_to": "Breite muss kleiner oder gleich %{length} Pixel sein",
        "duration_not_between": "Die Dauer muss zwischen %{min} und %{max} liegen (die aktuelle Dauer beträgt %{duration})",
        "duration_not_equal_to": "Die Dauer muss gleich %{exact} sein (die aktuelle Dauer beträgt %{duration})",
        "duration_not_greater_than": "Die Dauer muss größer als %{min} sein (die aktuelle Dauer beträgt %{duration})",
        "duration_not_greater_than_or_equal_to": "Die Dauer muss größer oder gleich %{min} sein (die aktuelle Dauer beträgt %{duration})",
        "duration_not_less_than": "Die Dauer muss kleiner als %{max} sein (die aktuelle Dauer beträgt %{duration})",
        "duration_not_less_than_or_equal_to": "Die Dauer muss kleiner oder gleich %{max} sein (die aktuelle Dauer beträgt %{duration})",
        "equal_to_current_password": "darf nicht dem aktuellen Passwort entsprechen.",
        "equal_to_email": "darf nicht dem E-mail entsprechen.",
        "file_not_processable": "wird nicht als gültige Mediendatei identifiziert",
        "file_size_not_between": "Dateigröße muss zwischen %{min} und %{max} liegen (aktuelle Dateigröße ist %{file_size})",
        "file_size_not_equal_to": "Dateigröße muss gleich %{exact} sein (aktuelle Dateigröße ist %{file_size})",
        "file_size_not_greater_than": "Dateigröße muss größer als %{min} sein (aktuelle Dateigröße ist %{file_size})",
        "file_size_not_greater_than_or_equal_to": "Dateigröße muss größer oder gleich %{min} sein (aktuelle Dateigröße ist %{file_size})",
        "file_size_not_less_than": "Dateigröße muss kleiner als %{max} sein (aktuelle Dateigröße ist %{file_size})",
        "file_size_not_less_than_or_equal_to": "Dateigröße muss kleiner oder gleich %{max} sein (aktuelle Dateigröße ist %{file_size})",
        "limit_max_exceeded": {
          "one": "zu viele angehängte Dateien (maximal %{max} Dateien, %{count})",
          "other": "Zu viele angehängte Dateien (maximal %{max} Dateien, %{count})",
          "zero": "Keine Dateien angehängt (maximal %{max} Dateien)"
        },
        "limit_min_not_reached": {
          "one": "Nur 1 Datei ist angehängt (müssen mindestens %{min} Dateien haben)",
          "other": "%{count} Dateien angehängt (müssen mindestens %{min} Dateien haben)",
          "zero": "Keine Dateien angehängt (müssen mindestens %{min} Dateien haben)"
        },
        "limit_out_of_range": {
          "one": "Nur 1 Datei ist angehängt (müssen zwischen %{min} und %{max} Dateien haben)",
          "other": "Die Gesamtzahl der Dateien muss zwischen %{min} und %{max} liegen (es sind Dateien mit %{count} angehängt).",
          "zero": "Keine Dateien angehängt (müssen zwischen %{min} und %{max} Dateien haben)"
        },
        "media_metadata_missing": "ist keine gültige Mediendatei",
        "pages_not_between": "Die Seitenanzahl muss zwischen %{min} und %{max} liegen (die aktuelle Seitenanzahl beträgt %{pages}).",
        "pages_not_equal_to": "Die Seitenanzahl muss gleich %{exact} sein (die aktuelle Seitenanzahl beträgt %{pages}).",
        "pages_not_greater_than": "Die Seitenanzahl muss größer als %{min} sein (die aktuelle Seitenanzahl beträgt %{pages}).",
        "pages_not_greater_than_or_equal_to": "Die Seitenanzahl muss größer oder gleich %{min} sein (die aktuelle Seitenanzahl beträgt %{pages}).",
        "pages_not_less_than": "Die Seitenanzahl muss kleiner als %{max} sein (die aktuelle Seitenanzahl beträgt %{pages}).",
        "pages_not_less_than_or_equal_to": "Die Seitenanzahl muss kleiner oder gleich %{max} sein (die aktuelle Seitenanzahl beträgt %{pages}).",
        "password_complexity": {
          "digit": {
            "one": "muss mindestens eine Ziffer enthalten",
            "other": "muss mindestens %{count} Ziffern enthalten"
          },
          "lower": {
            "one": "muss mindestens einen Kleinbuchstaben enthalten",
            "other": "muss mindestens %{count} Kleinbuchstaben enthalten"
          },
          "symbol": {
            "one": "muss mindestens ein Sonderzeichen enthalten",
            "other": "muss mindestens %{count} Sonderzeichen enthalten"
          },
          "upper": {
            "one": "muss mindestens einen Großbuchstaben enthalten",
            "other": "muss mindestens %{count} Großbuchstaben enthalten"
          }
        },
        "taken_in_past": "wurde bereits in der Vergangenheit verwendet.",
        "total_file_size_not_between": "Die gesamte Dateigröße muss zwischen %{min} und %{max} liegen (aktuelle Dateigröße ist %{total_file_size})",
        "total_file_size_not_equal_to": "Die gesamte Dateigröße muss gleich %{exact} sein (aktuelle Dateigröße ist %{total_file_size})",
        "total_file_size_not_greater_than": "Die gesamte Dateigröße muss größer als %{min} sein (aktuelle Dateigröße ist %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "Die gesamte Dateigröße muss größer oder gleich %{min} sein (aktuelle Dateigröße ist %{total_file_size})",
        "total_file_size_not_less_than": "Die gesamte Dateigröße muss kleiner als %{max} sein (aktuelle Dateigröße ist %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "Die gesamte Dateigröße muss kleiner oder gleich %{max} sein (aktuelle Dateigröße ist %{total_file_size})"
      }
    },
    "formtastic": {
      "cancel": "Abbrechen",
      "create": "%{model} anlegen",
      "no": "Nein",
      "required": "Pflichtfeld",
      "reset": "%{model} zurücksetzen",
      "submit": "Abschicken",
      "update": "%{model} aktualisieren",
      "yes": "Ja"
    },
    "numbers": {
      "billions": {
        "one": "Milliarde",
        "other": "Milliarden"
      },
      "decillions": {
        "one": "Quintilliarde",
        "other": "Quintilliarden"
      },
      "hundreds": "hundert",
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillion",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "millions": {
        "one": "Million",
        "other": "Millionen"
      },
      "nonillions": {
        "one": "Quintillion",
        "other": "Quintillionen"
      },
      "octillions": {
        "one": "Quadrilliarde",
        "other": "Quadrilliarden"
      },
      "ones": {
        "combine": [
          "null",
          "ein",
          "zwei",
          "drei",
          "vier",
          "fünf",
          "sechs",
          "sieben",
          "acht",
          "neun"
        ],
        "default": [
          "null",
          "eins",
          "zwei",
          "drei",
          "vier",
          "fünf",
          "sechs",
          "sieben",
          "acht",
          "neun"
        ],
        "gender": [
          "null",
          "eine",
          "zwei",
          "drei",
          "vier",
          "fünf",
          "sechs",
          "sieben",
          "acht",
          "neun"
        ]
      },
      "quadrillions": {
        "one": "Billiarde",
        "other": "Billiaden"
      },
      "quintillions": {
        "one": "Trillion",
        "other": "Trillionen"
      },
      "septillions": {
        "one": "Quadrillion",
        "other": "Quadrillionen"
      },
      "sextillions": {
        "one": "Trilliarde",
        "other": "Trilliarden"
      },
      "teens": [
        "_",
        "elf",
        "zwölf",
        "dreizehn",
        "vierzehn",
        "fünfzehn",
        "sechzehn",
        "siebzehn",
        "achtzehn",
        "neunzehn"
      ],
      "tens": [
        "_",
        "zehn",
        "zwanzig",
        "dreißig",
        "vierzig",
        "fünfzig",
        "sechzig",
        "siebzig",
        "achtzig",
        "neunzig"
      ],
      "thousands": {
        "one": "tausend",
        "other": "tausend"
      },
      "trillions": {
        "one": "Billion",
        "other": "Billionen"
      },
      "union": "und"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Seite",
          "other": "Seiten"
        },
        "next": "Weiter",
        "previous": "Zurück"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Zeige %{item_name} %{from}-%{to} von %{count} gesamt",
        "no_count": "Seite %{page} von %{pages}",
        "no_items": "Keine %{item_name} gefunden",
        "single_page": "Zeige %{count} %{item_name}"
      },
      "input_nav_js": "Seite %{page_input} von %{pages}",
      "item_name": {
        "one": "Eintrag",
        "other": "Einträge"
      },
      "limit_tag_js": "Zeige %{limit_input} %{item_name} pro Seite",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "alle",
      "and": "und",
      "any": "beliebige",
      "asc": "aufsteigend",
      "attribute": "Attribut",
      "combinator": "Kombinator",
      "condition": "Bedingung",
      "desc": "absteigend",
      "or": "oder",
      "predicate": "Eigenschaft",
      "predicates": {
        "blank": "ist leer",
        "cont": "enthält",
        "cont_all": "enthält alle",
        "cont_any": "enthält beliebige",
        "does_not_match": "stimmt nicht überein",
        "does_not_match_all": "stimmt nicht mit allen überein",
        "does_not_match_any": "erfüllt ein beliebiger/s nicht",
        "end": "endet mit",
        "end_all": "endet mit allen",
        "end_any": "endet mit beliebigen",
        "eq": "gleicht",
        "eq_all": "gleicht allen",
        "eq_any": "gleicht beliebigen",
        "false": "ist falsch",
        "gt": "größer als",
        "gt_all": "größer als alle",
        "gt_any": "größer als ein beliebiger/s",
        "gteq": "größer oder gleich",
        "gteq_all": "größer oder gleich alle",
        "gteq_any": "größer oder gleich als ein beliebiger/s",
        "in": "in",
        "in_all": "in allen",
        "in_any": "ist nicht in einem beliebigen",
        "lt": "kleiner als",
        "lt_all": "kleiner als alle als alle",
        "lt_any": "kleiner als ein beliebiger/s",
        "lteq": "kleiner oder gleich",
        "lteq_all": "kleiner oder gleich allen",
        "lteq_any": "kleiner oder gleich beliebige",
        "matches": "entspricht",
        "matches_all": "stimmt mit allen überein",
        "matches_any": "stimmt überein mit einem beliebigen",
        "not_cont": "enthält nicht",
        "not_cont_all": "enthält keine/s",
        "not_cont_any": "enthält ein beliebiger/s nicht",
        "not_end": "endet nicht mit",
        "not_end_all": "endet nicht mit allen",
        "not_end_any": "endet nicht mit beliebigen",
        "not_eq": "ungleich",
        "not_eq_all": "ungleich allen",
        "not_eq_any": "ungleich beliebigen",
        "not_in": "nicht in",
        "not_in_all": "nicht in allen",
        "not_in_any": "nicht in beliebige",
        "not_null": "ist nicht null",
        "not_start": "beginnt nicht mit",
        "not_start_all": "beginnt nicht mit allen",
        "not_start_any": "beginnt nicht mit beliebigen",
        "null": "ist null",
        "present": "ist vorhanden",
        "start": "beginnt mit",
        "start_all": "beginnt mit allen",
        "start_any": "beginnt mit beliebigen",
        "true": "ist wahr"
      },
      "search": "suchen",
      "sort": "sortieren",
      "value": "Wert"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, wir konnten Ihre reCAPTCHA-Antwort nicht validieren. Bitte versuchen Sie es erneut.",
        "verification_failed": "Die reCAPTCHA-Überprüfung ist fehlgeschlagen, bitte versuchen Sie es erneut."
      }
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d. %B %Y %H:%M"
            }
          }
        }
      }
    }
  },
  "de-CH": {
    "active_admin": {
      "any": "Alle",
      "batch_actions": {
        "action_label": "%{title} ausgewählte",
        "button_label": "Stapelverarbeitung",
        "default_confirmation": "Bist du sicher, dass Sie dies tun wollen?",
        "delete_confirmation": "Sind Sie sicher dass sie diese %{plural_model} löschen wollen?",
        "labels": {
          "destroy": "Lösche"
        },
        "selection_toggle_explanation": "(Auswahl umschalten)",
        "succesfully_destroyed": {
          "one": "Erfolgreich 1 %{model} gelöscht",
          "other": "Erfolgreich %{count} %{plural_model} gelöscht"
        }
      },
      "blank_slate": {
        "content": "Es gibt noch keine %{resource_name}.",
        "link": "Erstellen"
      },
      "cancel": "Abbrechen",
      "comments": {
        "add": "Kommentar hinzufügen",
        "author": "Autor",
        "body": "Inhalt",
        "delete": "Löschen",
        "delete_confirmation": "Sind Sie sicher dass sie diesen Kommentar löschen wollen?",
        "errors": {
          "empty_text": "Der Kommentar wurde nicht gespeichert, da der Text fehlt."
        },
        "no_comments_yet": "Es gibt noch keine Kommentare.",
        "resource": "Resource",
        "title_content": "Kommentare (%{count})"
      },
      "dashboard": "Übersicht",
      "dashboard_welcome": {
        "call_to_action": "Siehe 'app/admin/dashboards.rb', um Übersichts-Bereiche hinzuzufügen.",
        "welcome": "Willkommen in Active Admin. Dies ist die Standard-Übersichtsseite."
      },
      "delete": "Löschen",
      "delete_confirmation": "Wollen Sie dieses Element wirklich löschen?",
      "delete_model": "%{model} löschen",
      "details": "%{model} Details",
      "devise": {
        "change_password": {
          "submit": "Mein Passwort ändern",
          "title": "Ändern Sie Ihr Passwort"
        },
        "links": {
          "forgot_your_password": "Passwort vergessen?",
          "resend_confirmation_instructions": "Bestätigungsanweisung erneut senden",
          "resend_unlock_instructions": "Entsperrungsanweisung erneut senden",
          "sign_in": "Anmeldung",
          "sign_in_with_omniauth_provider": "Anmeldung mit %{provider}",
          "sign_up": "Registrieren"
        },
        "login": {
          "remember_me": "erinnere dich an mich",
          "submit": "Login",
          "title": "Login"
        },
        "reset_password": {
          "submit": "Mein Passwort zurücksetzen",
          "title": "Passwort vergessen?"
        }
      },
      "download": "Herunterladen:",
      "dropdown_actions": {
        "button_label": "Aktionen"
      },
      "edit": "Bearbeiten",
      "edit_model": "%{model} bearbeiten",
      "empty": "Leer",
      "filters": {
        "buttons": {
          "clear": "Filter entfernen",
          "filter": "Filtern"
        }
      },
      "has_many_delete": "Löschen",
      "has_many_new": "%{model} hinzufügen",
      "has_many_remove": "Entfernen",
      "logout": "Abmelden",
      "main_content": "Bitte implementieren Sie %{model}#main_content, um Inhalte anzuzeigen.",
      "new_model": "%{model} erstellen",
      "next": "Weiter",
      "pagination": {
        "empty": "Keine %{model} gefunden",
        "entry": {
          "one": "Eintrag",
          "other": "Einträge"
        },
        "multiple": "Zeige %{model} <b>%{from}&nbsp;–&nbsp;%{to}</b> von <b>%{total}</b>",
        "multiple_without_total": "Zeige %{model} <b>%{from}&nbsp;–&nbsp;%{to}</b>",
        "one": "Zeige <b>1</b> %{model}",
        "one_page": "Zeige <b>alle %{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Zurück",
      "sidebars": {
        "filters": "Filter"
      },
      "status_tag": {
        "no": "Nicht",
        "unset": "Nicht",
        "yes": "Ja"
      },
      "unsupported_browser": {
        "headline": "ActiveAdmin unterstützt nicht länger den Internet Explorer in Version 8 oder niedriger.",
        "recommendation": "Wir empfehlen die Nutzung von <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, oder <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Wenn sie IE 9 oder neuer benutzen, stellen sie sicher das sie den <a href=\"https://support.microsoft.com/de-ch/help/17471\">\"Kompatibilitätsansicht\" ausgeschaltet</a> haben."
      },
      "view": "Anzeigen"
    }
  },
  "dz": {
    "pagy": {
      "aria_label": {
        "nav": "ཤོག་ལེབ་",
        "next": "ཤུལ༌མ་",
        "previous": "སྔོན་མ་"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "བསྡོམས་ཀྱིས་ %{count} ལས་%{item_name} %{from}-%{to} བཀྲམ་སྟོན་འབད་དོ།",
        "no_count": "ཤོག་ལེབ་ %{pages} ལས་ %{page}།",
        "no_items": "%{item_name}གཅིག་ཡང་འཚོལ་མ་འཐོབ།",
        "single_page": "%{item_name} %{count} བཀྲམ་སྟོན་འབད་དོ།"
      },
      "input_nav_js": "ཤོག་ལེབ་ %{pages} ལས་ %{page_input}།",
      "item_name": "རྣམ་གྲངས་",
      "limit_tag_js": "ཤོག་ལེབ་རེ་ལུ་%{item_name} %{limit_input} སྟོན།",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    }
  },
  "el": {
    "active_admin": {
      "access_denied": {
        "message": "Δεν έχετε πρόσβαση για αυτή την ενέργεια."
      },
      "any": "Όλες οι εγγραφές",
      "batch_actions": {
        "action_label": "%{title} επιλεγμένων",
        "button_label": "Μαζικές Ενέργειες",
        "default_confirmation": "Είστε σίγουρος πως θέλετε να το κάνετε αυτό;",
        "delete_confirmation": "Είστε σίγουρος πως θέλετε να διαγράψετε αυτά τα %{plural_model}?",
        "labels": {
          "destroy": "Διαγραφή"
        },
        "selection_toggle_explanation": "(Αντιστροφή επιλογών)",
        "succesfully_destroyed": {
          "one": "Διαγράφηκε επιτυχώς 1 %{model}",
          "other": "Διαγράφηκαν επιτυχώς %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Δεν υπάρχουν %{resource_name} ακόμα.",
        "link": "Δημιουργήστε μία εγγραφή"
      },
      "cancel": "Ακύρωση",
      "comments": {
        "add": "Προσθήκη Σχολίου",
        "author": "Συγγραφέας",
        "author_missing": "Ανώνυμος",
        "author_type": "Τύπος Συγγραφέα",
        "body": "Κείμενο",
        "errors": {
          "empty_text": "Το σχόλιο δε σώθηκε, το κείμενο ήταν κενό."
        },
        "no_comments_yet": "Δεν υπάρχει κανένα σχόλιο.",
        "resource": "Εγγραφή",
        "resource_type": "Τύπος Εγγραφής",
        "title_content": "Σχόλια (%{count})"
      },
      "dashboard": "Σελίδα διαχείρισης",
      "dashboard_welcome": {
        "call_to_action": "Για να προσθέσετε ενότητες, ανατρέξτε στο αρχείο 'app/admin/dashboard.rb'",
        "welcome": "Καλωσορίσατε στο Active Admin. Αυτή είναι η αρχική σελίδα διαχείρισης."
      },
      "delete": "Διαγραφή",
      "delete_confirmation": "Είστε σίγουρος πως θέλετε να το διαγράψετε;",
      "delete_model": "Διαγραφή %{model}",
      "details": "Λεπτομέρειες %{model}",
      "devise": {
        "change_password": {
          "submit": "Αλλαγή του κωδικού",
          "title": "Αλλάξτε τον κωδικό σας"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Ξεχάσατε τον κωδικό σας;",
          "resend_confirmation_instructions": "Αποστολή οδηγιών επιβεβαίωσης",
          "resend_unlock_instructions": "Αποστολή οδηγιών ξεκλειδώματος",
          "sign_in": "Σύνδεση",
          "sign_in_with_omniauth_provider": "Σύνδεση με %{provider}",
          "sign_up": "Εγγραφή"
        },
        "login": {
          "remember_me": "Να με θυμάσαι",
          "submit": "Σύνδεση",
          "title": "Σύνδεση"
        },
        "password": {
          "title": "Κωδικός"
        },
        "resend_confirmation_instructions": {
          "submit": "Αποστολή οδηγιών επιβεβαίωσης",
          "title": "Αποστολή οδηγιών επιβεβαίωσης"
        },
        "reset_password": {
          "submit": "Επαναφορά κωδικού",
          "title": "Ξεχάσατε τον κωδικό σας;"
        },
        "sign_up": {
          "submit": "Εγγραφή",
          "title": "Εγγραφή"
        },
        "subdomain": {
          "title": "Subdomain"
        },
        "unlock": {
          "submit": "Αποστολή οδηγιών ξεκλειδώματος",
          "title": "Αποστολή οδηγιών ξεκλειδώματος"
        },
        "username": {
          "title": "Όνομα χρήστη"
        }
      },
      "download": "Κατέβασμα:",
      "dropdown_actions": {
        "button_label": "Ενέργειες"
      },
      "edit": "Επεξεργασία",
      "edit_model": "Επεξεργασία %{model}",
      "empty": "Άδειο",
      "filters": {
        "buttons": {
          "clear": "Καθαρισμός Φίλτρων",
          "filter": "Φίλτρα"
        }
      },
      "has_many_delete": "Διαγραφή",
      "has_many_new": "Προσθήκη Νέου %{model}",
      "has_many_remove": "Αφαίρεση",
      "index_list": {
        "block": "Λίστα",
        "blog": "Blog",
        "grid": "Πλέγμα",
        "table": "Πίνακας"
      },
      "logout": "Αποσύνδεση",
      "main_content": "Παρακαλώ υλοποιήστε την %{model}#main_content για να εμφανίσετε περιεχόμενο.",
      "new_model": "Δημιουργία %{model}",
      "next": "Επόμενη",
      "pagination": {
        "empty": "Δε βρέθηκαν %{model}",
        "entry": {
          "one": "εγγραφή",
          "other": "εγγραφές"
        },
        "multiple": "Εμφανίζονται %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> από <b>%{total}</b> συνολικά",
        "multiple_without_total": "Εμφανίζονται %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Εμφάνιζεται <b>1</b> %{model}",
        "one_page": "Εμφανίζονται <b>όλες οι %{n}</b> εγγραφές %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Προηγούμενη",
      "sidebars": {
        "filters": "Φίλτρα"
      },
      "status_tag": {
        "no": "Όχι",
        "unset": "Όχι",
        "yes": "Ναι"
      },
      "unsupported_browser": {
        "headline": "Το ActiveAdmin δεν υποστηρίζει πλεον τον Internet Explorer έκδοση 8 η μικρότερη.",
        "recommendation": "Σας προτείνουμε να αναβαθμίσετε στην τελευταία <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, or <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Αν χρησιμοποιείτε IE 9 ή μεγαλύτερη έκδοση, σιγουρευτείτε ότι <a href=\"https://support.microsoft.com/el-gr/help/17471\">turn off \"Compatibility View\"</a>."
      },
      "view": "Προβολή"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Τρέχων κωδικός πρόσβασης",
          "email": "Ηλεκτρονική διεύθυνση",
          "password": "Κωδικός πρόσβασης",
          "password_confirmation": "Επιβεβαίωση κωδικού πρόσβασης",
          "remember_me": "Απομνημόνευση"
        }
      },
      "models": {
        "user": "Χρήστης"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Επανάληψη αποστολής οδηγιών επιβεβαίωσης"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Επιβεβαίωση του λογαριασμού μου",
          "greeting": "Καλώς ήρθατε %{recipient}!",
          "instruction": "Μπορείτε να επιβεβαιώσετε τον λογαριασμό σας μέσω του συνδέσμου παρακάτω:"
        },
        "reset_password_instructions": {
          "action": "Αλλαγή του κωδικού πρόσβασης",
          "greeting": "Γεια σας %{recipient}!",
          "instruction": "Κάποις έχει αιτηθεί ένα σύνδεσμο για αλλαγή του κωδικού πρόσβασής σας και εσείς μπορείτε να το κάνετε αυτό μέσω του συνδέσμου παρακάτω.",
          "instruction_2": "Αν δεν κάνατε εσείς αυτή την αίτηση, αγνοήστε αυτή την ηλεκτρονική επιστολή.",
          "instruction_3": "Ο κωδικός πρόσβασης δεν θα αλλάξει μέχρι να χρησιμοποιήσετε αυτό το σύνδεσμο παραπάνω και δημιουργήσετε ένα νέο."
        },
        "unlock_instructions": {
          "action": "Ξεκλείδωμα του λογαριασμού μου",
          "greeting": "Γεια σας %{recipient}!",
          "instruction": "Πατήστε το σύνδεσμο παρακάτω για ξεκλείδωμα του λογαριασμού σας:",
          "message": "Ο λογαριασμός σας έχει κλειδώσει λόγω μεγάλου αριθμού ανεπιτυχών προσθαθειών σύνδεσης."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Αλλαγή του κωδικού πρόσβασής μου",
          "change_your_password": "Αλλάξτε τον κωδικό πρόσβασής σας",
          "confirm_new_password": "Επιβεβαίωση νέου κωδικού πρόσβασης",
          "new_password": "Νέος κωδικός πρόσβασης"
        },
        "new": {
          "forgot_your_password": "Ξεχάσατε τον κωδικό σας;",
          "send_me_reset_password_instructions": "Στείλτε μου οδηγίες επαναφοράς κωδικού πρόσβασης"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Είστε σίγουρος/η;",
          "cancel_my_account": "Ακύρωση του λογαρισμού μου",
          "currently_waiting_confirmation_for_email": "Αναμένεται επιβεβαίωση για: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "αφήστε το κενό, αν δεν θέλετε να το αλλάξετε",
          "title": "Επεξεργασία %{resource}",
          "unhappy": "Δυστυχής",
          "update": "Ενημέρωση",
          "we_need_your_current_password_to_confirm_your_changes": "χρειαζόμαστε τον τρέχων κωδικό πρόσβασής σας για να επιβεβαιώσουμε τις αλλαγές σας"
        },
        "new": {
          "sign_up": "Εγγραφή"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Σύνδεση"
        }
      },
      "shared": {
        "links": {
          "back": "Πίσω",
          "didn_t_receive_confirmation_instructions": "Δεν λάβατε οδηγίες επιβεβαίωσης;",
          "didn_t_receive_unlock_instructions": "Δεν λάβατε οδηγίες ξεκλειδώματος;",
          "forgot_your_password": "Ξεχάσατε τον κωδικό πρόσβασης;",
          "sign_in": "Σύνδεση",
          "sign_in_with_provider": "Σύνδεση με τον πάροχο %{provider}",
          "sign_up": "Εγγραφή"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Επανάληψη αποστολής οδηγιών ξεκλειδώματος"
        }
      }
    },
    "ransack": {
      "all": "όλα",
      "and": "και",
      "any": "οποιοδήποτε",
      "asc": "αύξουσα",
      "attribute": "ιδιότητα",
      "combinator": "συνδυαστής",
      "condition": "συνθήκη",
      "desc": "φθίνουσα",
      "or": "ή",
      "predicate": "κατηγορούμενο",
      "predicates": {
        "blank": "είναι κενό",
        "cont": "περιέχει",
        "cont_all": "περιέχει όλα",
        "cont_any": "περιέχει οποιοδήποτε",
        "does_not_match": "δεν αντιστοιχεί",
        "does_not_match_all": "δεν αντιστοιχεί με όλα",
        "does_not_match_any": "δεν αντιστοιχεί με οποιοδήποτε",
        "end": "τελειώνει με",
        "end_all": "τελειώνει με όλα",
        "end_any": "τελειώνει οποιοδήποτε",
        "eq": "ίσον",
        "eq_all": "ισούται με όλα",
        "eq_any": "ισούται με οποιοδήποτε",
        "false": "ψευδές",
        "gt": "μεγαλύτερο από",
        "gt_all": "μεγαλύτερο από όλα\"",
        "gt_any": "μεγαλύτερο από οποιοδήποτε",
        "gteq": "μεγαλύτερο ή ίσον από",
        "gteq_all": "μεγαλύτερο ή ίσον από όλα",
        "gteq_any": "μεγαλύτερο ή ίσον από οποιοδήποτε",
        "in": "περιέχεται",
        "in_all": "περιέχεται σε όλα",
        "in_any": "περιέχεται σε οποιοδήποτε",
        "lt": "μικρότερο από",
        "lt_all": "μικρότερο από όλα",
        "lt_any": "μικρότερο από οποιοδήποτε",
        "lteq": "μικρότερο ή ίσον",
        "lteq_all": "μικρότερο ή ίσον από όλα",
        "lteq_any": "μικρότερο ή ίσον από οποιοδήποτε",
        "matches": "αντιστοιχεί",
        "matches_all": "αντιστοιχεί με όλα",
        "matches_any": "αντιστοιχεί με οποιοδήποτε",
        "not_cont": "δεν περιέχει",
        "not_cont_all": "δεν περιέχει όλα",
        "not_cont_any": "δεν περιέχει οποιοδήποτε",
        "not_end": "δεν τελειώνει με",
        "not_end_all": "δεν τελειώνει με όλα",
        "not_end_any": "δεν τελειώνει οποιοδήποτε",
        "not_eq": "άνισο",
        "not_eq_all": "άνισο με όλα",
        "not_eq_any": "άνισο με οποιοδήποτε",
        "not_in": "δεν περιέχεται",
        "not_in_all": "δεν περιέχεται σε όλα",
        "not_in_any": "δεν περιέχεται σε οποιοδήποτε",
        "not_null": "δεν είναι άκυρο",
        "not_start": "δεν αρχίζει με",
        "not_start_all": "δεν αρχίζει με όλα",
        "not_start_any": "δεν αρχίζει με οποιοδήποτε",
        "null": "άκυρο",
        "present": "υπάρχει",
        "start": "αρχίζει με",
        "start_all": "αρχίζει με όλα",
        "start_any": "αρχίζει με οποιοδήποτε",
        "true": "αληθές"
      },
      "search": "αναζήτηση",
      "sort": "ταξινόμηση",
      "value": "τιμή"
    }
  },
  "en": {
    "active_admin": {
      "access_denied": {
        "message": "You are not authorized to perform this action."
      },
      "any": "Any",
      "batch_actions": {
        "action_label": "%{title} Selected",
        "button_label": "Batch Actions",
        "default_confirmation": "Are you sure you want to do this?",
        "delete_confirmation": "Are you sure you want to delete these %{plural_model}?",
        "labels": {
          "destroy": "Delete"
        },
        "selection_toggle_explanation": "(Toggle Selection)",
        "succesfully_destroyed": {
          "one": "Successfully deleted 1 %{model}",
          "other": "Successfully deleted %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "There are no %{resource_name} yet.",
        "link": "Create one"
      },
      "cancel": "Cancel",
      "comments": {
        "add": "Add Comment",
        "author": "Author",
        "author_missing": "Anonymous",
        "author_type": "Author Type",
        "body": "Body",
        "created_at": "Created",
        "delete": "Delete Comment",
        "delete_confirmation": "Are you sure you want to delete these comments?",
        "errors": {
          "empty_text": "Comment wasn't saved, text was empty."
        },
        "no_comments_yet": "No comments yet.",
        "resource": "Resource",
        "resource_type": "Resource Type",
        "title_content": "Comments (%{count})"
      },
      "create_another": "Create another %{model}",
      "dashboard": "Dashboard",
      "dashboard_welcome": {
        "call_to_action": "To add dashboard sections, checkout 'app/admin/dashboard.rb'",
        "welcome": "Welcome to Active Admin. This is the default dashboard page."
      },
      "delete": "Delete",
      "delete_confirmation": "Are you sure you want to delete this?",
      "delete_model": "Delete %{model}",
      "details": "%{model} Details",
      "devise": {
        "change_password": {
          "submit": "Change my password",
          "title": "Change your password"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Forgot your password?",
          "resend_confirmation_instructions": "Resend confirmation instructions",
          "resend_unlock_instructions": "Resend unlock instructions",
          "sign_in": "Sign in",
          "sign_in_with_omniauth_provider": "Sign in with %{provider}",
          "sign_up": "Sign up"
        },
        "login": {
          "remember_me": "Remember me",
          "submit": "Login",
          "title": "Login"
        },
        "password": {
          "title": "Password"
        },
        "password_confirmation": {
          "title": "Confirm Password"
        },
        "resend_confirmation_instructions": {
          "submit": "Resend confirmation instructions",
          "title": "Resend confirmation instructions"
        },
        "reset_password": {
          "submit": "Reset My Password",
          "title": "Forgot your password?"
        },
        "sign_up": {
          "submit": "Sign up",
          "title": "Sign up"
        },
        "subdomain": {
          "title": "Subdomain"
        },
        "unlock": {
          "submit": "Resend unlock instructions",
          "title": "Resend unlock instructions"
        },
        "username": {
          "title": "Username"
        }
      },
      "download": "Download:",
      "dropdown_actions": {
        "button_label": "Actions"
      },
      "edit": "Edit",
      "edit_model": "Edit %{model}",
      "empty": "Empty",
      "filters": {
        "buttons": {
          "clear": "Clear Filters",
          "filter": "Filter"
        },
        "predicates": {
          "from": "From",
          "to": "To"
        }
      },
      "has_many_delete": "Delete",
      "has_many_new": "Add New %{model}",
      "has_many_remove": "Remove",
      "index_list": {
        "block": "List",
        "blog": "Blog",
        "grid": "Grid",
        "table": "Table"
      },
      "logout": "Logout",
      "main_content": "Please implement %{model}#main_content to display content.",
      "move": "Move",
      "new_model": "New %{model}",
      "next": "Next",
      "pagination": {
        "empty": "No %{model} found",
        "entry": {
          "one": "entry",
          "other": "entries"
        },
        "multiple": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{total}</b> in total",
        "multiple_without_total": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Displaying <b>1</b> %{model}",
        "one_page": "Displaying <b>all %{n}</b> %{model}",
        "per_page": "Per page: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Previous",
      "scopes": {
        "all": "All"
      },
      "search_status": {
        "current_filters": "Current filters:",
        "current_scope": "Scope:",
        "headline": "Search status:",
        "no_current_filters": "None"
      },
      "sidebars": {
        "filters": "Filters",
        "search_status": "Search Status"
      },
      "status_tag": {
        "no": "No",
        "unset": "No",
        "yes": "Yes"
      },
      "unsupported_browser": {
        "headline": "Please note that ActiveAdmin no longer supports Internet Explorer versions 8 or less.",
        "recommendation": "We recommend that you <a href=\"http://browsehappy.com/\">upgrade your browser</a> to improve your experience.",
        "turn_off_compatibility_view": "If you are using IE 9 or later, make sure you <a href=\"https://support.microsoft.com/en-us/help/17471\">turn off \"Compatibility View\"</a>."
      },
      "view": "View"
    },
    "activerecord": {
      "attributes": {
        "active_admin/comment": {
          "author_type": "Author type",
          "body": "Body",
          "created_at": "Created",
          "namespace": "Namespace",
          "resource_type": "Resource type",
          "updated_at": "Updated"
        },
        "user": {
          "current_password": "Current password",
          "email": "Email",
          "password": "Password",
          "password_confirmation": "Password confirmation",
          "remember_me": "Remember me"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        }
      },
      "models": {
        "active_admin/comment": {
          "one": "Comment",
          "other": "Comments"
        },
        "comment": {
          "one": "Comment",
          "other": "Comments"
        },
        "user": "User"
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about 1 hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about 1 month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about 1 year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost 1 year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than 1 second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over 1 year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "1 day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "1 minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "1 month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "1 second",
          "other": "%{count} seconds"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      },
      "relative": {
        "future": "in %{time}",
        "past": "%{time} ago"
      }
    },
    "devise": {
      "confirmations": {
        "confirmed": "Your email address has been successfully confirmed.",
        "new": {
          "resend_confirmation_instructions": "Resend confirmation instructions"
        },
        "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "expired": "Your account has expired due to inactivity. Please contact the site administrator.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "invited": "You have a pending invitation, accept it to finish creating your account.",
        "last_attempt": "You have one more attempt before your account is locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "session_limited": "Your login credentials were used in another browser. Please sign in again to continue in this browser.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your email address before continuing."
      },
      "invalid_captcha": "The captcha input was invalid.",
      "invalid_security_question": "The security question answer was invalid.",
      "invitations": {
        "edit": {
          "header": "Set your password",
          "submit_button": "Set my password"
        },
        "invitation_removed": "Your invitation was removed.",
        "invitation_token_invalid": "The invitation token provided is not valid!",
        "new": {
          "header": "Send invitation",
          "submit_button": "Send an invitation"
        },
        "no_invitations_remaining": "No invitations remaining",
        "send_instructions": "An invitation email has been sent to %{email}.",
        "updated": "Your password was set successfully. You are now signed in.",
        "updated_not_active": "Your password was set successfully."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirm my account",
          "greeting": "Welcome %{recipient}!",
          "instruction": "You can confirm your account email through the link below:",
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "subject": "Email Changed"
        },
        "invitation_instructions": {
          "accept": "Accept invitation",
          "accept_until": "This invitation will be due in %{due_date}.",
          "hello": "Hello %{email}",
          "ignore": "If you don't want to accept the invitation, please ignore this email. Your account won't be created until you access the link above and set your password.",
          "someone_invited_you": "Someone has invited you to %{url}, you can accept it through the link below.",
          "subject": "Invitation instructions"
        },
        "password_change": {
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "action": "Change my password",
          "greeting": "Hello %{recipient}!",
          "instruction": "Someone has requested a link to change your password, and you can do this through the link below.",
          "instruction_2": "If you didn't request this, please ignore this email.",
          "instruction_3": "Your password won't change until you access the link above and create a new one.",
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "action": "Unlock my account",
          "greeting": "Hello %{recipient}!",
          "instruction": "Click the link below to unlock your account:",
          "message": "Your account has been locked due to an excessive amount of unsuccessful sign in attempts.",
          "subject": "Unlock instructions"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Submit",
          "submit_verification_code": "Submit verification code",
          "verification_code": "Verification code"
        },
        "updated": "Verification code accepted"
      },
      "paranoid_verify": {
        "code_required": "Please enter the code our support team provided"
      },
      "password_expired": {
        "change_required": "Your password is expired. Please renew your password.",
        "show": {
          "change_my_password": "Change my password",
          "current_password": "Current password",
          "new_password": "New password",
          "new_password_confirmation": "Confirm new password",
          "renew_your_password": "Renew your password"
        },
        "updated": "Your new password is saved."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Change my password",
          "change_your_password": "Change your password",
          "confirm_new_password": "Confirm new password",
          "new_password": "New password"
        },
        "new": {
          "forgot_your_password": "Forgot your password?",
          "send_me_reset_password_instructions": "Send me reset password instructions"
        },
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "updated": "Your password has been changed successfully. You are now signed in.",
        "updated_not_active": "Your password has been changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
        "edit": {
          "are_you_sure": "Are you sure?",
          "cancel_my_account": "Cancel my account",
          "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
          "title": "Edit %{resource}",
          "unhappy": "Unhappy",
          "update": "Update",
          "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
        },
        "new": {
          "sign_up": "Sign up"
        },
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
        "update_needs_confirmation": "You updated your account successfully, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
        "updated": "Your account has been updated successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "new": {
          "sign_in": "Sign in"
        },
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "shared": {
        "links": {
          "back": "Back",
          "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
          "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
          "forgot_your_password": "Forgot your password?",
          "sign_in": "Sign in",
          "sign_in_with_provider": "Sign in with %{provider}",
          "sign_up": "Sign up"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Resend unlock instructions"
        },
        "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "errors": {
      "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "aspect_ratio_invalid": "has an invalid aspect ratio (valid aspect ratios are %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "must be landscape (current file is %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "must be portrait (current file is %{width}x%{height}px)",
        "aspect_ratio_not_square": "must be square (current file is %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "must be %{authorized_aspect_ratios} (current file is %{width}x%{height}px)",
        "attachment_missing": "is missing its attachment",
        "audio_missing": "must have an audio track",
        "audio_present": "must not have an audio track",
        "blank": "can't be blank",
        "confirmation": "doesn't match %{attribute}",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "content_type_invalid": {
          "one": "has an invalid content type (authorized content type is %{authorized_human_content_types})",
          "other": "has an invalid content type (authorized content types are %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "has a content type that is not equivalent to the one that is detected through its content (authorized content type is %{authorized_human_content_types})",
          "other": "has a content type that is not equivalent to the one that is detected through its content (authorized content types are %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "height must be equal to %{length} pixels",
        "dimension_height_not_greater_than_or_equal_to": "height must be greater than or equal to %{length} pixels",
        "dimension_height_not_included_in": "height is not included between %{min} and %{max} pixels",
        "dimension_height_not_less_than_or_equal_to": "height must be less than or equal to %{length} pixels",
        "dimension_max_not_included_in": "must be less than or equal to %{width} x %{height} pixels",
        "dimension_min_not_included_in": "must be greater than or equal to %{width} x %{height} pixels",
        "dimension_width_not_equal_to": "width must be equal to %{length} pixels",
        "dimension_width_not_greater_than_or_equal_to": "width must be greater than or equal to %{length} pixels",
        "dimension_width_not_included_in": "width is not included between %{min} and %{max} pixels",
        "dimension_width_not_less_than_or_equal_to": "width must be less than or equal to %{length} pixels",
        "duration_not_between": "duration must be between %{min} and %{max} (current duration is %{duration})",
        "duration_not_equal_to": "duration must be equal to %{exact} (current duration is %{duration})",
        "duration_not_greater_than": "duration must be greater than %{min} (current duration is %{duration})",
        "duration_not_greater_than_or_equal_to": "duration must be greater than or equal to %{min} (current duration is %{duration})",
        "duration_not_less_than": "duration must be less than %{max} (current duration is %{duration})",
        "duration_not_less_than_or_equal_to": "duration must be less than or equal to %{max} (current duration is %{duration})",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "equal_to_current_password": "must be different than the current password.",
        "equal_to_email": "must be different than the email.",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired, please request a new one",
        "file_not_processable": "is not identified as a valid media file",
        "file_size_not_between": "file size must be between %{min} and %{max} (current size is %{file_size})",
        "file_size_not_equal_to": "file size must be equal to %{exact} (current size is %{file_size})",
        "file_size_not_greater_than": "file size must be greater than %{min} (current size is %{file_size})",
        "file_size_not_greater_than_or_equal_to": "file size must be greater than or equal to %{min} (current size is %{file_size})",
        "file_size_not_less_than": "file size must be less than %{max} (current size is %{file_size})",
        "file_size_not_less_than_or_equal_to": "file size must be less than or equal to %{max} (current size is %{file_size})",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "limit_max_exceeded": {
          "one": "too many files attached (maximum is %{max} files, got %{count})",
          "other": "too many files attached (maximum is %{max} files, got %{count})",
          "zero": "no files attached (maximum is %{max} files)"
        },
        "limit_min_not_reached": {
          "one": "only 1 file attached (must have at least %{min} files)",
          "other": "%{count} files attached (must have at least %{min} files)",
          "zero": "no files attached (must have at least %{min} files)"
        },
        "limit_out_of_range": {
          "one": "only 1 file attached (must have between %{min} and %{max} files)",
          "other": "total number of files must be between %{min} and %{max} files (there are %{count} files attached)",
          "zero": "no files attached (must have between %{min} and %{max} files)"
        },
        "media_metadata_missing": "is not a valid media file",
        "model_invalid": "Validation failed: %{errors}",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "other_than": "must be other than %{count}",
        "pages_not_between": "page count must be between %{min} and %{max} (current page count is %{pages})",
        "pages_not_equal_to": "page count must be equal to %{exact} (current page count is %{pages})",
        "pages_not_greater_than": "page count must be greater than %{min} (current page count is %{pages})",
        "pages_not_greater_than_or_equal_to": "page count must be greater than or equal to %{min} (current page count is %{pages})",
        "pages_not_less_than": "page count must be less than %{max} (current page count is %{pages})",
        "pages_not_less_than_or_equal_to": "page count must be less than or equal to %{max} (current page count is %{pages})",
        "password_complexity": {
          "digit": {
            "one": "must contain at least one digit",
            "other": "must contain at least %{count} digits"
          },
          "lower": {
            "one": "must contain at least one lower-case letter",
            "other": "must contain at least %{count} lower-case letters"
          },
          "symbol": {
            "one": "must contain at least one punctuation mark or symbol",
            "other": "must contain at least %{count} punctuation marks or symbols"
          },
          "upper": {
            "one": "must contain at least one upper-case letter",
            "other": "must contain at least %{count} upper-case letters"
          }
        },
        "password_too_long": "is too long",
        "phone_country_not_allowed": "is from a country that is not allowed",
        "phone_extension_not_allowed": "must not include an extension",
        "phone_invalid": "is not a valid phone number",
        "phone_invalid_country_code": "has an invalid country calling code",
        "phone_invalid_length": "has an invalid length",
        "phone_not_a_number": "is not a phone number",
        "phone_not_possible": "is not a possible phone number",
        "phone_too_long": "is too long",
        "phone_too_short": "is too short",
        "phone_type_not_allowed": "has a phone type that is not allowed",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "taken_in_past": "was used previously.",
        "too_long": {
          "one": "is too long (maximum is 1 character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": {
          "one": "is too short (minimum is 1 character)",
          "other": "is too short (minimum is %{count} characters)"
        },
        "total_file_size_not_between": "total file size must be between %{min} and %{max} (current size is %{total_file_size})",
        "total_file_size_not_equal_to": "total file size must be equal to %{exact} (current size is %{total_file_size})",
        "total_file_size_not_greater_than": "total file size must be greater than %{min} (current size is %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "total file size must be greater than or equal to %{min} (current size is %{total_file_size})",
        "total_file_size_not_less_than": "total file size must be less than %{max} (current size is %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "total file size must be less than or equal to %{max} (current size is %{total_file_size})",
        "wrong_length": {
          "one": "is the wrong length (should be 1 character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "unacceptable_request": "A supported version is expected in the Accept header.\n",
      "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
    },
    "flash": {
      "actions": {
        "create": {
          "notice": "%{resource_name} was successfully created."
        },
        "destroy": {
          "alert": "%{resource_name} could not be destroyed.",
          "notice": "%{resource_name} was successfully destroyed."
        },
        "update": {
          "notice": "%{resource_name} was successfully updated."
        }
      }
    },
    "formtastic": {
      "cancel": "Cancel %{model}",
      "create": "Create %{model}",
      "no": "No",
      "required": "required",
      "reset": "Reset %{model}",
      "submit": "Submit %{model}",
      "update": "Update %{model}",
      "yes": "Yes"
    },
    "hello": "Hello world",
    "helpers": {
      "page_entries_info": {
        "entry": {
          "one": "entry",
          "other": "entries",
          "zero": "entries"
        },
        "more_pages": {
          "display_entries": "Displaying %{entry_name} <b>%{first}&nbsp;-&nbsp;%{last}</b> of <b>%{total}</b> in total"
        },
        "one_page": {
          "display_entries": {
            "one": "Displaying <b>1</b> %{entry_name}",
            "other": "Displaying <b>all %{count}</b> %{entry_name}",
            "zero": "No %{entry_name} found"
          }
        }
      },
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "create": "Create %{model}",
        "submit": "Save %{model}",
        "update": "Update %{model}"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "negative_format": "-%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB",
            "zb": "ZB"
          }
        }
      },
      "nth": {},
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "numbers": {
      "billionths": {
        "one": "billionth",
        "other": "billionths"
      },
      "decillionths": {
        "one": "decillionth",
        "other": "decillionths"
      },
      "duodecillionths": {
        "one": "duodecillionth",
        "other": "duodecillionths"
      },
      "hundreds": "hundred",
      "hundredths": {
        "one": "hundredth",
        "other": "hundredths"
      },
      "mega": [
        "_",
        "thousand",
        "million",
        "billion",
        "trillion",
        "quadrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
        "decillion",
        "undecillion",
        "duodecillion",
        "tredecillion",
        "quattuordecillion"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths",
        "quadrillionths",
        "quintillionths",
        "sextillionths",
        "septillionths",
        "octillionths",
        "nonillionths",
        "decillionths",
        "undecillionths",
        "duodecillionths",
        "tredecillionths",
        "quattuordecillionths"
      ],
      "micro_prefix": {
        "hundreds": "hundred",
        "tens": "ten",
        "union": "-"
      },
      "micro_separator": "and",
      "millionths": {
        "one": "millionth",
        "other": "millionths"
      },
      "nonillionths": {
        "one": "nonillionth",
        "other": "nonillionths"
      },
      "octillionths": {
        "one": "octillionth",
        "other": "octillionths"
      },
      "ones": [
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine"
      ],
      "ordinal": {
        "hundreds": "hundredth",
        "mega": [
          "_",
          "thousandth",
          "millionth",
          "billionth",
          "trillionth",
          "quadrillionth",
          "quintillionth",
          "sextillionth",
          "septillionth",
          "octillionth",
          "nonillionth",
          "decillionth",
          "undecillionth",
          "duodecillionth",
          "tredecillionth",
          "quattuordecillionth"
        ],
        "ones": [
          "zeroth",
          "first",
          "second",
          "third",
          "fourth",
          "fifth",
          "sixth",
          "seventh",
          "eighth",
          "ninth"
        ],
        "teens": [
          "tenth",
          "eleventh",
          "twelfth",
          "thirteenth",
          "fourteenth",
          "fifteenth",
          "sixteenth",
          "seventeenth",
          "eighteenth",
          "nineteenth"
        ],
        "tens": [
          "_",
          "tenth",
          "twentieth",
          "thirtieth",
          "fortieth",
          "fiftieth",
          "sixtieth",
          "seventieth",
          "eightieth",
          "ninetieth"
        ]
      },
      "quadrillionths": {
        "one": "quadrillionth",
        "other": "quadrillionths"
      },
      "quattuordecillionths": {
        "one": "quattuordecillionth",
        "other": "quattuordecillionths"
      },
      "quintillionths": {
        "one": "quintillionth",
        "other": "quintillionths"
      },
      "septillionths": {
        "one": "septillionth",
        "other": "septillionths"
      },
      "sextillionths": {
        "one": "sextillionth",
        "other": "sextillionths"
      },
      "teens": [
        "_",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen"
      ],
      "tens": [
        "_",
        "ten",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety"
      ],
      "tenths": {
        "one": "tenth",
        "other": "tenths"
      },
      "thousandths": {
        "one": "thousandth",
        "other": "thousandths"
      },
      "tredecillionths": {
        "one": "tredecillionth",
        "other": "tredecillionths"
      },
      "trillionths": {
        "one": "trillionth",
        "other": "trillionths"
      },
      "undecillionths": {
        "one": "undecillionth",
        "other": "undecillionths"
      },
      "union": "and"
    },
    "oauth": {
      "authorize": {
        "access_denied": "The user denied access",
        "access_scope": "Access",
        "application": "Application",
        "approve": "Authorize",
        "consent_subtitle_html": "%{client_name} is requesting access to ControlDoc with the account %{email}.",
        "consent_title": "Authorize access?",
        "customer": "Customer",
        "deny": "Cancel",
        "email": "Email",
        "error_title": "Authorization failed",
        "invalid_client": "Invalid or inactive OAuth client",
        "invalid_credentials": "Invalid credentials",
        "invalid_redirect_uri": "redirect_uri is not allowed for this client",
        "invalid_request": "Invalid OAuth request",
        "invalid_target": "The resource parameter is invalid or not allowed for this server",
        "invitation_pending": "You must accept the Controldoc invitation before authorizing this application",
        "login_subtitle": "To authorize \"%{client_name}\" with your ControlDoc account",
        "login_title": "Sign in",
        "no_membership": "Your user does not belong to the customer associated with this OAuth application",
        "no_platform_memberships": "Your user has no Controldoc accounts",
        "password": "Password",
        "pkce_incomplete": "code_challenge and code_challenge_method must be sent together",
        "pkce_method_unsupported": "Only code_challenge_method=S256 is supported",
        "pkce_required": "code_challenge is required for this OAuth client (PKCE)",
        "platform_access_scope": "All Controldoc accounts you belong to",
        "scopes": "Scopes",
        "sign_in": "Continue",
        "sign_in_required": "You must sign in to continue",
        "state_required": "The state parameter is required",
        "unsupported_response_type": "Only response_type=code is supported"
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Page",
          "other": "Pages"
        },
        "next": "Next",
        "previous": "Previous"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Displaying %{item_name} %{from}-%{to} of %{count} in total",
        "no_count": "Page %{page} of %{pages}",
        "no_items": "No %{item_name} found",
        "single_page": "Displaying %{count} %{item_name}"
      },
      "input_nav_js": "Page %{page_input} of %{pages}",
      "item_name": {
        "one": "item",
        "other": "items"
      },
      "limit_tag_js": "Show %{limit_input} %{item_name} per page",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "all",
      "and": "and",
      "any": "any",
      "asc": "ascending",
      "attribute": "attribute",
      "combinator": "combinator",
      "condition": "condition",
      "desc": "descending",
      "or": "or",
      "predicate": "predicate",
      "predicates": {
        "blank": "is blank",
        "cont": "contains",
        "cont_all": "contains all",
        "cont_any": "contains any",
        "does_not_match": "doesn't match",
        "does_not_match_all": "doesn't match all",
        "does_not_match_any": "doesn't match any",
        "end": "ends with",
        "end_all": "ends with all",
        "end_any": "ends with any",
        "eq": "equals",
        "eq_all": "equals all",
        "eq_any": "equals any",
        "false": "is false",
        "gt": "greater than",
        "gt_all": "greater than all",
        "gt_any": "greater than any",
        "gteq": "greater than or equal to",
        "gteq_all": "greater than or equal to all",
        "gteq_any": "greater than or equal to any",
        "in": "in",
        "in_all": "in all",
        "in_any": "in any",
        "lt": "less than",
        "lt_all": "less than all",
        "lt_any": "less than any",
        "lteq": "less than or equal to",
        "lteq_all": "less than or equal to all",
        "lteq_any": "less than or equal to any",
        "matches": "matches",
        "matches_all": "matches all",
        "matches_any": "matches any",
        "not_cont": "doesn't contain",
        "not_cont_all": "doesn't contain all",
        "not_cont_any": "doesn't contain any",
        "not_end": "doesn't end with",
        "not_end_all": "doesn't end with all",
        "not_end_any": "doesn't end with any",
        "not_eq": "not equal to",
        "not_eq_all": "not equal to all",
        "not_eq_any": "not equal to any",
        "not_in": "not in",
        "not_in_all": "not in all",
        "not_in_any": "not in any",
        "not_null": "is not null",
        "not_start": "doesn't start with",
        "not_start_all": "doesn't start with all",
        "not_start_any": "doesn't start with any",
        "null": "is null",
        "present": "is present",
        "start": "starts with",
        "start_all": "starts with all",
        "start_any": "starts with any",
        "true": "is true"
      },
      "search": "search",
      "sort": "sort",
      "value": "value"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, we failed to validate your reCAPTCHA response. Please try again.",
        "verification_failed": "reCAPTCHA verification failed, please try again."
      }
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%a, %d %b %Y %H:%M:%S %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        },
        "long": "%B %d, %Y %H:%M",
        "short": "%d %b %H:%M"
      },
      "pm": "pm"
    },
    "views": {
      "pagination": {
        "first": "&laquo; First",
        "last": "Last &raquo;",
        "next": "Next &rsaquo;",
        "previous": "&lsaquo; Prev",
        "truncate": "&hellip;"
      }
    }
  },
  "en-CA": {
    "active_admin": {
      "access_denied": {
        "message": "You are not authorized to perform this action."
      },
      "any": "Any",
      "batch_actions": {
        "action_label": "%{title} Selected",
        "button_label": "Batch Actions",
        "default_confirmation": "Are you sure you want to do this?",
        "delete_confirmation": "Are you sure you want to delete these %{plural_model}?",
        "labels": {
          "destroy": "Delete"
        },
        "selection_toggle_explanation": "(Toggle Selection)",
        "succesfully_destroyed": {
          "one": "Successfully deleted 1 %{model}",
          "other": "Successfully deleted %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "There are no %{resource_name} yet.",
        "link": "Create one"
      },
      "cancel": "Cancel",
      "comments": {
        "add": "Add Comment",
        "author": "Author",
        "author_missing": "Anonymous",
        "author_type": "Author Type",
        "body": "Body",
        "created_at": "Created",
        "delete": "Delete Comment",
        "delete_confirmation": "Are you sure you want to delete these comments?",
        "errors": {
          "empty_text": "Comment wasn't saved, text was empty."
        },
        "no_comments_yet": "No comments yet.",
        "resource": "Resource",
        "resource_type": "Resource Type",
        "title_content": "Comments (%{count})"
      },
      "create_another": "Create another %{model}",
      "dashboard": "Dashboard",
      "dashboard_welcome": {
        "call_to_action": "To add dashboard sections, checkout 'app/admin/dashboards.rb'",
        "welcome": "Welcome to Active Admin. This is the default dashboard page."
      },
      "delete": "Delete",
      "delete_confirmation": "Are you sure you want to delete this?",
      "delete_model": "Delete %{model}",
      "details": "%{model} Details",
      "devise": {
        "change_password": {
          "submit": "Change my password",
          "title": "Change your password"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Forgot your password?",
          "resend_confirmation_instructions": "Resend confirmation instructions",
          "resend_unlock_instructions": "Resend unlock instructions",
          "sign_in": "Sign in",
          "sign_in_with_omniauth_provider": "Sign in with %{provider}",
          "sign_up": "Sign up"
        },
        "login": {
          "remember_me": "Remember me",
          "submit": "Login",
          "title": "Login"
        },
        "password": {
          "title": "Password"
        },
        "password_confirmation": {
          "title": "Confirm Password"
        },
        "resend_confirmation_instructions": {
          "submit": "Resend confirmation instructions",
          "title": "Resend confirmation instructions"
        },
        "reset_password": {
          "submit": "Reset My Password",
          "title": "Forgot your password?"
        },
        "sign_up": {
          "submit": "Sign up",
          "title": "Sign up"
        },
        "subdomain": {
          "title": "Subdomain"
        },
        "unlock": {
          "submit": "Resend unlock instructions",
          "title": "Resend unlock instructions"
        },
        "username": {
          "title": "Username"
        }
      },
      "download": "Download:",
      "dropdown_actions": {
        "button_label": "Actions"
      },
      "edit": "Edit",
      "edit_model": "Edit %{model}",
      "empty": "Empty",
      "filters": {
        "buttons": {
          "clear": "Clear Filters",
          "filter": "Filter"
        }
      },
      "has_many_delete": "Delete",
      "has_many_new": "Add New %{model}",
      "has_many_remove": "Remove",
      "index_list": {
        "block": "List",
        "blog": "Blog",
        "grid": "Grid",
        "table": "Table"
      },
      "logout": "Logout",
      "main_content": "Please implement %{model}#main_content to display content.",
      "new_model": "New %{model}",
      "next": "Next",
      "pagination": {
        "empty": "No %{model} found",
        "entry": {
          "one": "entry",
          "other": "entries"
        },
        "multiple": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{total}</b> in total",
        "multiple_without_total": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Displaying <b>1</b> %{model}",
        "one_page": "Displaying <b>all %{n}</b> %{model}",
        "per_page": "Per page: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Previous",
      "search_status": {
        "current_filters": "Current filters:",
        "current_scope": "Scope:",
        "headline": "Search status:",
        "no_current_filters": "None"
      },
      "sidebars": {
        "filters": "Filters",
        "search_status": "Search Status"
      },
      "status_tag": {
        "no": "No",
        "unset": "No",
        "yes": "Yes"
      },
      "unsupported_browser": {
        "headline": "Please note that ActiveAdmin no longer supports Internet Explorer versions 8 or less.",
        "recommendation": "We recommend upgrading to the latest <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, or <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "If you are using IE 9 or later, make sure you <a href=\"https://support.microsoft.com/en-ca/help/17471\">turn off \"Compatibility View\"</a>."
      },
      "view": "View"
    }
  },
  "en-GB": {
    "active_admin": {
      "access_denied": {
        "message": "You are not authorised to perform this action."
      },
      "any": "Any",
      "batch_actions": {
        "action_label": "%{title} Selected",
        "button_label": "Batch Actions",
        "default_confirmation": "Are you sure you want to do this?",
        "delete_confirmation": "Are you sure you want to delete these %{plural_model}?",
        "labels": {
          "destroy": "Delete"
        },
        "selection_toggle_explanation": "(Toggle Selection)",
        "succesfully_destroyed": {
          "one": "Successfully deleted 1 %{model}",
          "other": "Successfully deleted %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "There are no %{resource_name} yet.",
        "link": "Create one"
      },
      "cancel": "Cancel",
      "comments": {
        "add": "Add Comment",
        "author": "Author",
        "author_missing": "Anonymous",
        "author_type": "Author Type",
        "body": "Body",
        "created_at": "Created",
        "delete": "Delete Comment",
        "delete_confirmation": "Are you sure you want to delete these comments?",
        "errors": {
          "empty_text": "Comment wasn't saved, text was empty."
        },
        "no_comments_yet": "No comments yet.",
        "resource": "Resource",
        "resource_type": "Resource Type",
        "title_content": "Comments (%{count})"
      },
      "create_another": "Create another %{model}",
      "dashboard": "Dashboard",
      "dashboard_welcome": {
        "call_to_action": "To add dashboard sections, checkout 'app/admin/dashboards.rb'",
        "welcome": "Welcome to Active Admin. This is the default dashboard page."
      },
      "delete": "Delete",
      "delete_confirmation": "Are you sure you want to delete this?",
      "delete_model": "Delete %{model}",
      "details": "%{model} Details",
      "devise": {
        "change_password": {
          "submit": "Change my password",
          "title": "Change your password"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Forgot your password?",
          "resend_confirmation_instructions": "Resend confirmation instructions",
          "resend_unlock_instructions": "Resend unlock instructions",
          "sign_in": "Sign in",
          "sign_in_with_omniauth_provider": "Sign in with %{provider}",
          "sign_up": "Sign up"
        },
        "login": {
          "remember_me": "Remember me",
          "submit": "Login",
          "title": "Login"
        },
        "password": {
          "title": "Password"
        },
        "password_confirmation": {
          "title": "Confirm Password"
        },
        "resend_confirmation_instructions": {
          "submit": "Resend confirmation instructions",
          "title": "Resend confirmation instructions"
        },
        "reset_password": {
          "submit": "Reset My Password",
          "title": "Forgot your password?"
        },
        "sign_up": {
          "submit": "Sign up",
          "title": "Sign up"
        },
        "subdomain": {
          "title": "Subdomain"
        },
        "unlock": {
          "submit": "Resend unlock instructions",
          "title": "Resend unlock instructions"
        },
        "username": {
          "title": "Username"
        }
      },
      "download": "Download:",
      "dropdown_actions": {
        "button_label": "Actions"
      },
      "edit": "Edit",
      "edit_model": "Edit %{model}",
      "empty": "Empty",
      "filters": {
        "buttons": {
          "clear": "Clear Filters",
          "filter": "Filter"
        }
      },
      "has_many_delete": "Delete",
      "has_many_new": "Add New %{model}",
      "has_many_remove": "Remove",
      "index_list": {
        "block": "List",
        "blog": "Blog",
        "grid": "Grid",
        "table": "Table"
      },
      "logout": "Logout",
      "main_content": "Please implement %{model}#main_content to display content.",
      "new_model": "New %{model}",
      "next": "Next",
      "pagination": {
        "empty": "No %{model} found",
        "entry": {
          "one": "entry",
          "other": "entries"
        },
        "multiple": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{total}</b> in total",
        "multiple_without_total": "Displaying %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Displaying <b>1</b> %{model}",
        "one_page": "Displaying <b>all %{n}</b> %{model}",
        "per_page": "Per page: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Previous",
      "search_status": {
        "current_filters": "Current filters:",
        "current_scope": "Scope:",
        "headline": "Search status:",
        "no_current_filters": "None"
      },
      "sidebars": {
        "filters": "Filters",
        "search_status": "Search Status"
      },
      "status_tag": {
        "no": "No",
        "unset": "No",
        "yes": "Yes"
      },
      "unsupported_browser": {
        "headline": "Please note that ActiveAdmin no longer supports Internet Explorer versions 8 or less.",
        "recommendation": "We recommend upgrading to the latest <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, or <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "If you are using IE 9 or later, make sure you <a href=\"https://support.microsoft.com/en-gb/help/17471\">turn off \"Compatibility View\"</a>."
      },
      "view": "View"
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "has an invalid aspect ratio (valid aspect ratios are %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "must be landscape (current file is %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "must be portrait (current file is %{width}x%{height}px)",
        "aspect_ratio_not_square": "must be square (current file is %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "must be %{authorized_aspect_ratios} (current file is %{width}x%{height}px)",
        "attachment_missing": "is missing its attachment",
        "audio_missing": "must have an audio track",
        "audio_present": "must not have an audio track",
        "content_type_invalid": {
          "one": "has an invalid content type (authorized content type is %{authorized_human_content_types})",
          "other": "has an invalid content type (authorized content types are %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "has a content type that is not equivalent to the one that is detected through its content (authorized content type is %{authorized_human_content_types})",
          "other": "has a content type that is not equivalent to the one that is detected through its content (authorized content types are %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "height must be equal to %{length} pixels",
        "dimension_height_not_greater_than_or_equal_to": "height must be greater than or equal to %{length} pixels",
        "dimension_height_not_included_in": "height is not included between %{min} and %{max} pixels",
        "dimension_height_not_less_than_or_equal_to": "height must be less than or equal to %{length} pixels",
        "dimension_max_not_included_in": "must be less than or equal to %{width} x %{height} pixels",
        "dimension_min_not_included_in": "must be greater than or equal to %{width} x %{height} pixels",
        "dimension_width_not_equal_to": "width must be equal to %{length} pixels",
        "dimension_width_not_greater_than_or_equal_to": "width must be greater than or equal to %{length} pixels",
        "dimension_width_not_included_in": "width is not included between %{min} and %{max} pixels",
        "dimension_width_not_less_than_or_equal_to": "width must be less than or equal to %{length} pixels",
        "duration_not_between": "duration must be between %{min} and %{max} (current duration is %{duration})",
        "duration_not_equal_to": "duration must be equal to %{exact} (current duration is %{duration})",
        "duration_not_greater_than": "duration must be greater than %{min} (current duration is %{duration})",
        "duration_not_greater_than_or_equal_to": "duration must be greater than or equal to %{min} (current duration is %{duration})",
        "duration_not_less_than": "duration must be less than %{max} (current duration is %{duration})",
        "duration_not_less_than_or_equal_to": "duration must be less than or equal to %{max} (current duration is %{duration})",
        "file_not_processable": "is not identified as a valid media file",
        "file_size_not_between": "file size must be between %{min} and %{max} (current size is %{file_size})",
        "file_size_not_equal_to": "file size must be equal to %{exact} (current size is %{file_size})",
        "file_size_not_greater_than": "file size must be greater than %{min} (current size is %{file_size})",
        "file_size_not_greater_than_or_equal_to": "file size must be greater than or equal to %{min} (current size is %{file_size})",
        "file_size_not_less_than": "file size must be less than %{max} (current size is %{file_size})",
        "file_size_not_less_than_or_equal_to": "file size must be less than or equal to %{max} (current size is %{file_size})",
        "limit_max_exceeded": {
          "one": "too many files attached (maximum is %{max} files, got %{count})",
          "other": "too many files attached (maximum is %{max} files, got %{count})",
          "zero": "no files attached (maximum is %{max} files)"
        },
        "limit_min_not_reached": {
          "one": "only 1 file attached (must have at least %{min} files)",
          "other": "%{count} files attached (must have at least %{min} files)",
          "zero": "no files attached (must have at least %{min} files)"
        },
        "limit_out_of_range": {
          "one": "only 1 file attached (must have between %{min} and %{max} files)",
          "other": "total number of files must be between %{min} and %{max} files (there are %{count} files attached)",
          "zero": "no files attached (must have between %{min} and %{max} files)"
        },
        "media_metadata_missing": "is not a valid media file",
        "pages_not_between": "page count must be between %{min} and %{max} (current page count is %{pages})",
        "pages_not_equal_to": "page count must be equal to %{exact} (current page count is %{pages})",
        "pages_not_greater_than": "page count must be greater than %{min} (current page count is %{pages})",
        "pages_not_greater_than_or_equal_to": "page count must be greater than or equal to %{min} (current page count is %{pages})",
        "pages_not_less_than": "page count must be less than %{max} (current page count is %{pages})",
        "pages_not_less_than_or_equal_to": "page count must be less than or equal to %{max} (current page count is %{pages})",
        "total_file_size_not_between": "total file size must be between %{min} and %{max} (current size is %{total_file_size})",
        "total_file_size_not_equal_to": "total file size must be equal to %{exact} (current size is %{total_file_size})",
        "total_file_size_not_greater_than": "total file size must be greater than %{min} (current size is %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "total file size must be greater than or equal to %{min} (current size is %{total_file_size})",
        "total_file_size_not_less_than": "total file size must be less than %{max} (current size is %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "total file size must be less than or equal to %{max} (current size is %{total_file_size})"
      }
    },
    "numbers": {
      "billionths": {
        "one": "billionth",
        "other": "billionths"
      },
      "decillionths": {
        "one": "decillionth",
        "other": "decillionths"
      },
      "duodecillionths": {
        "one": "duodecillionth",
        "other": "duodecillionths"
      },
      "hundreds": "hundred",
      "hundredths": {
        "one": "hundredth",
        "other": "hundredths"
      },
      "mega": [
        "_",
        "thousand",
        "million",
        "billion",
        "trillion",
        "quadrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
        "decillion",
        "undecillion",
        "duodecillion",
        "tredecillion",
        "quattuordecillion"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths",
        "quadrillionths",
        "quintillionths",
        "sextillionths",
        "septillionths",
        "octillionths",
        "nonillionths",
        "decillionths",
        "undecillionths",
        "duodecillionths",
        "tredecillionths",
        "quattuordecillionths"
      ],
      "micro_prefix": {
        "hundreds": "hundred",
        "tens": "ten",
        "union": "-"
      },
      "micro_separator": "point",
      "millionths": {
        "one": "millionth",
        "other": "millionths"
      },
      "nonillionths": {
        "one": "nonillionth",
        "other": "nonillionths"
      },
      "octillionths": {
        "one": "octillionth",
        "other": "octillionths"
      },
      "ones": [
        "zero",
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine"
      ],
      "ordinal": {
        "hundreds": "hundredth",
        "mega": [
          "_",
          "thousandth",
          "millionth",
          "billionth",
          "trillionth",
          "quadrillionth",
          "quintillionth",
          "sextillionth",
          "septillionth",
          "octillionth",
          "nonillionth",
          "decillionth",
          "undecillionth",
          "duodecillionth",
          "tredecillionth",
          "quattuordecillionth"
        ],
        "ones": [
          "zeroth",
          "first",
          "second",
          "third",
          "fourth",
          "fifth",
          "sixth",
          "seventh",
          "eighth",
          "ninth"
        ],
        "teens": [
          "tenth",
          "eleventh",
          "twelfth",
          "thirteenth",
          "fourteenth",
          "fifteenth",
          "sixteenth",
          "seventeenth",
          "eighteenth",
          "nineteenth"
        ],
        "tens": [
          "_",
          "tenth",
          "twentieth",
          "thirtieth",
          "fortieth",
          "fiftieth",
          "sixtieth",
          "seventieth",
          "eightieth",
          "ninetieth"
        ]
      },
      "quadrillionths": {
        "one": "quadrillionth",
        "other": "quadrillionths"
      },
      "quattuordecillionths": {
        "one": "quattuordecillionth",
        "other": "quattuordecillionths"
      },
      "quintillionths": {
        "one": "quintillionth",
        "other": "quintillionths"
      },
      "septillionths": {
        "one": "septillionth",
        "other": "septillionths"
      },
      "sextillionths": {
        "one": "sextillionth",
        "other": "sextillionths"
      },
      "teens": [
        "_",
        "eleven",
        "twelve",
        "thirteen",
        "fourteen",
        "fifteen",
        "sixteen",
        "seventeen",
        "eighteen",
        "nineteen"
      ],
      "tens": [
        "_",
        "ten",
        "twenty",
        "thirty",
        "forty",
        "fifty",
        "sixty",
        "seventy",
        "eighty",
        "ninety"
      ],
      "tenths": {
        "one": "tenth",
        "other": "tenths"
      },
      "thousandths": {
        "one": "thousandth",
        "other": "thousandths"
      },
      "tredecillionths": {
        "one": "tredecillionth",
        "other": "tredecillionths"
      },
      "trillionths": {
        "one": "trillionth",
        "other": "trillionths"
      },
      "undecillionths": {
        "one": "undecillionth",
        "other": "undecillionths"
      },
      "union": "and"
    }
  },
  "eo": {
    "active_admin": {
      "access_denied": {
        "message": "Vi ne rajtas fari tiun agon."
      },
      "any": "Ĉiuj",
      "batch_actions": {
        "action_label": "%{title} elektita",
        "button_label": "Amasagoj",
        "default_confirmation": "Ĉu vi certas, ke vi volas fari tion?",
        "delete_confirmation": "Ĉu vi certas, ke vi volas forigi tiujn %{plural_model}?",
        "labels": {
          "destroy": "Forigi"
        },
        "selection_toggle_explanation": "(Baskuligi elekton)",
        "succesfully_destroyed": {
          "one": "1 %{model} sukcese forigita",
          "other": "%{count} %{plural_model} sukcese forigitaj"
        }
      },
      "blank_slate": {
        "content": "Ankoraŭ ne estas %{resource_name}.",
        "link": "Krei novan"
      },
      "cancel": "Nuligi",
      "comments": {
        "add": "Aldoni komenton",
        "author": "Aŭtoro",
        "author_missing": "Anonimulo",
        "author_type": "Aŭtorotipo",
        "body": "Enhavo",
        "created_at": "Kreita",
        "delete": "Forigi komenton",
        "delete_confirmation": "Ĉu vi certas, ke vi volas forigi tiun komenton?",
        "errors": {
          "empty_text": "La komento ne estis konservita, la teksto estis malplena."
        },
        "no_comments_yet": "Ankoraŭ neniu komento.",
        "resource": "Resurso",
        "resource_type": "Resursotipo",
        "title_content": "Komentoj (%{count})"
      },
      "create_another": "Krei alian %{model}",
      "dashboard": "Panelo",
      "dashboard_welcome": {
        "call_to_action": "Por aldoni sekciojn al via panelo, vidu 'app/admin/dashboard.rb'",
        "welcome": "Bonvenon al Active Admin. Jen la defaŭlta panela paĝo."
      },
      "delete": "Forigi",
      "delete_confirmation": "Ĉu vi certas, ke vi volas forigi tion?",
      "delete_model": "Forigi %{model}",
      "details": "Detaloj de %{model}",
      "devise": {
        "change_password": {
          "submit": "Ŝanĝi mian pasvorton",
          "title": "Ŝanĝi vian pasvorton"
        },
        "email": {
          "title": "Retpoŝtadreso"
        },
        "links": {
          "forgot_your_password": "Ĉu vi forgesis vian pasvorton?",
          "resend_confirmation_instructions": "Resendi klarigojn por konfirmi",
          "resend_unlock_instructions": "Resendi klarigojn por malŝlosi",
          "sign_in": "Ensaluti",
          "sign_in_with_omniauth_provider": "Ensaluti per %{provider}",
          "sign_up": "Registriĝi"
        },
        "login": {
          "remember_me": "Memori min",
          "submit": "Ensaluti",
          "title": "Ensaluti"
        },
        "password": {
          "title": "Pasvorto"
        },
        "password_confirmation": {
          "title": "Konfirmi pasvorton"
        },
        "resend_confirmation_instructions": {
          "submit": "Resendi klarigojn por konfirmi",
          "title": "Resendi klarigojn por konfirmi"
        },
        "reset_password": {
          "submit": "Restarigi mian pasvorton",
          "title": "Ĉu vi forgesis vian pasvorton?"
        },
        "sign_up": {
          "submit": "Registriĝi",
          "title": "Registriĝi"
        },
        "subdomain": {
          "title": "Subdomajno"
        },
        "unlock": {
          "submit": "Resendi klarigojn por malŝlosi",
          "title": "Resendi klarigojn por malŝlosi"
        },
        "username": {
          "title": "Uzantnomo"
        }
      },
      "download": "Elŝuti:",
      "dropdown_actions": {
        "button_label": "Agoj"
      },
      "edit": "Redakti",
      "edit_model": "Redakti %{model}",
      "empty": "Malplena",
      "filters": {
        "buttons": {
          "clear": "Viŝi filtrilojn",
          "filter": "Filtri"
        },
        "predicates": {
          "from": "De",
          "to": "Al"
        }
      },
      "has_many_delete": "Forigi",
      "has_many_new": "Aldoni novan %{model}",
      "has_many_remove": "Forigi",
      "index_list": {
        "block": "Listo",
        "blog": "Blogo",
        "grid": "Krado",
        "table": "Tabelo"
      },
      "logout": "Elsaluti",
      "main_content": "Aldonu %{model}#main_content por montri la enhavon.",
      "move": "Movi",
      "new_model": "Nova %{model}",
      "next": "Sekva",
      "pagination": {
        "empty": "Neniu %{model} trovita",
        "entry": {
          "one": "ero",
          "other": "eroj"
        },
        "multiple": "Montras %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> de <b>%{total}</b> entute",
        "multiple_without_total": "Montras %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Montras <b>1</b> %{model}",
        "one_page": "Montras <b>ĉiujn %{n}</b> %{model}",
        "per_page": "Paĝe: "
      },
      "powered_by": "Povigita de %{active_admin} %{version}",
      "previous": "Antaŭa",
      "search_status": {
        "current_filters": "Nunaj filtriloj:",
        "current_scope": "Regiono:",
        "headline": "Serĉstato:",
        "no_current_filters": "Neniu"
      },
      "sidebars": {
        "filters": "Filtriloj",
        "search_status": "Serĉstato"
      },
      "status_tag": {
        "no": "Ne",
        "unset": "Ne",
        "yes": "Jes"
      },
      "unsupported_browser": {
        "headline": "Rimarku ke ActiveAdmin ne plu subtenas versiojn 8 kaj mal de Internet Explorer.",
        "recommendation": "Ni rekomendas, ke vi <a href=\"http://browsehappy.com/\">ĝisdatigu vian retumilon</a> por plibonigi vian sperton.",
        "turn_off_compatibility_view": "Se vi uzas version 8 aŭ pli novan de Internet Explorer, estu certa, ke vi <a href=\"https://support.microsoft.com/en-us/help/17471\">malŝaltu \"kongruecan reĝimon\"</a>."
      },
      "view": "Vidi"
    }
  },
  "es": {
    "abstract": {
      "activerecord": {
        "attributes": {
          "abstract/controldoc_form/document": {
            "aasm_state": {
              "blocked": "Bloqueado",
              "filled": "Completado",
              "one": "Estado",
              "partially_filled": "En proceso",
              "pending": "Pendiente"
            },
            "blocked_by": "Bloqueado por",
            "controldoc_state": "Estado de firma:",
            "created_at": "Fecha de creación",
            "created_by_id": "Creado por",
            "email": "Nombre"
          },
          "abstract/controldoc_form/template": {
            "content": "Contenido",
            "created_by_id": "Creado por",
            "name": "Nombre",
            "vars": "Variables"
          }
        },
        "errors": {
          "models": {
            "controldoc_form/template": {
              "attributes": {
                "name": {
                  "blank": "Debe ingresar el nombre de la plantilla",
                  "taken": "El nombre de la plantilla ya se encuentra en uso"
                }
              }
            },
            "corporate/agreement": {
              "attributes": null
            }
          }
        },
        "models": {
          "abstract/controldoc_form/document": {
            "one": "Documento",
            "other": "Documentos"
          },
          "abstract/controldoc_form/template": {
            "one": "Plantilla",
            "other": "Plantillas"
          }
        }
      },
      "bulk": {
        "load": {
          "document_items": null,
          "documents": {
            "create": {
              "succesfully": "La carga masiva de documentos ha sido creado correctamente"
            },
            "destroy": {
              "succesfully": "La carga masiva de documentos ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "by_document_type": "Tipo de documento",
              "created_by": "Creado por",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "require_signers": {
                "helper": {
                  "title": "Al solicitar firmantes, el sistema se integrará con ControlDoc Sign"
                }
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "items_filter": {
              "by_operation_type": "Acción",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Identificador</li> </ul>"
              }
            },
            "show": {
              "details": "Detalles",
              "hirings": "Contrataciones",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Carga simultáneamente hasta 100 documentos relacionados a varias contrataciones. El nombre del archivo debe ser el identificador de la contratación. Visualiza el estado y registro histórico de las cargas realizadas.",
            "update": {
              "succesfully": "La carga masiva de documentos ha sido actualizado correctamente"
            }
          },
          "entities": {
            "create": {
              "succesfully": "La carga masiva de %{entity} se encuentra procesando"
            },
            "destroy": {
              "succesfully": "%{entity} ha sido eliminada correctamente"
            },
            "filter": {
              "by_state": "Estado",
              "created_by": "Creado por",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación",
              "with_errors": "Con errores",
              "with_start_date": "Fecha inicio",
              "without_errors": "Sin errores"
            },
            "form": {
              "confirm": {
                "message": "¿Estás seguro de guardar %{entity}?",
                "title": "Guardar %{entity}"
              },
              "default_headers": {
                "controldoc_id": "CONTROLDOCID ( PELIGRO NO MODIFICAR, PARA NUEVOS REGISTROS DEJAR EN BLANCO)",
                "entity_id": "Identificador %{entity} ( PARA AUTOGENERACIÓN DEJAR EN BLANCO)"
              },
              "file_input": {
                "button": "Subir archivo",
                "download_template": "Descargar plantilla de %{entity}",
                "error": {
                  "icon": "error",
                  "text": "El documento debe ser en formato excel",
                  "title": "Oops..."
                }
              },
              "save": "Guardar",
              "table": {
                "title": "Registros sin errores"
              },
              "table_error": {
                "title": "Registros con errores",
                "title2": "Corregir antes de continuar"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles de %{entity}",
              "error": "Errores"
            },
            "tooltip_info": "Gestiona e importa listados de %{entity} en una plantilla excel. Visualiza el estado y registro histórico de las cargas realizadas.",
            "update": {
              "succesfully": "%{entity} ha sido actualizada correctamente"
            }
          },
          "entity_items": {
            "filter": {
              "by_operation_type": "Acción",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Identificador</li> </ul>"
              }
            },
            "list": {
              "operation_type": {
                "created": "Creado",
                "updated": "Actualizado",
                "without_changes": "Sin cambios"
              },
              "without_completed": "No hemos encontrado registros procesados",
              "without_completed_errors": "No hemos encontrado registros con errores",
              "without_pending": "No hemos encontrado registros pendientes",
              "without_processing": "No hemos encontrado registros en proceso"
            }
          }
        },
        "notification": {
          "sign_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "without_completed": "No hemos encontrado registros procesados",
              "without_completed_errors": "No hemos encontrado registros con errores",
              "without_pending": "No hemos encontrado registros pendientes",
              "without_processing": "No hemos encontrado registros en proceso"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "signs": {
            "create": {
              "succesfully": "Notificación masiva de firmas ha sido creada correctamente"
            },
            "destroy": {
              "succesfully": "Notificación masiva de firmas ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "cant_sign_selected": "Has seleccionado %{count} Firmas.",
              "confirm": {
                "message": "¿Estás seguro de realizar la notificación masiva?",
                "title": "Realizar notificación masiva"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "signs": "Firmas",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona varias firmantes pendientes para solicitar firma de documentación",
            "update": {
              "succesfully": "Notificación masiva de firmas ha sido actualizada correctamente"
            }
          }
        },
        "request": {
          "document_configs": {
            "document_type_battery_form_text": "Puedes seleccionar una batería de documentos configurada o agregar uno a uno los documentos que necesitas solicitar.",
            "document_type_battery_help": "Selecciona una batería de documentos para precargar los tipos de documentos en la solicitud.",
            "require_upload_deadline_help": "Si el documento tiene una fecha límite para ser subido, ingrésala para que cada trabajador tenga en consideración el límite de fecha para firmar el documento",
            "schedule_help": "Debe ingresar fecha y hora a la que desea programar el envío de los documentos."
          },
          "document_items": null,
          "documents": {
            "create": {
              "succesfully": "Solicitud masiva de documentos ha sido creada correctamente"
            },
            "destroy": {
              "succesfully": "Solicitud masiva de documentos ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "add_config": "Agregar nuevo documento",
              "cant_entities_selected": "Has seleccionado %{count} %{entity}.",
              "confirm": {
                "message": "¿Estás seguro de realizar la solicitud masiva?",
                "title": "Realizar solicitud masiva"
              },
              "require_signers": {
                "helper": {
                  "title": "Al solicitar firmantes, el sistema se integrará con ControlDoc"
                }
              },
              "tabs": {
                "config": "Configuración",
                "config_button": "Ir a Paso 2 Configuración",
                "config_title": "Paso 2 configuración de documentos",
                "entities": "%{entity}",
                "entities_button": "Volver a Paso 1 %{entity}",
                "entities_title": "Paso 1 seleccionar %{entity}"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "entities": "%{entity}",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona varios trabajadores para solicitar carga o firma de documentación. Puedes subir, solicitar que el trabajador suba o usar un archivo de ControlDoc Forms.",
            "update": {
              "succesfully": "Solicitud masiva de documentos ha sido actualizada correctamente"
            }
          },
          "entity_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> <li>Identificador del trabajador</li> <li>Identificador de la contratación</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "documents": "Documentos"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "zip": {
            "document_items": {
              "filter": {
                "by_aasm_state": "Estado",
                "end_date": "Hasta",
                "search_query": {
                  "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
                },
                "start_date": "Desde",
                "with_created_at": "Fecha de creación"
              },
              "list": {
                "without_results": "No hemos encontrado registros"
              },
              "show": {
                "errors": "Errores"
              }
            },
            "documents": {
              "create": {
                "succesfully": "Descarga de documentos ha sido creada correctamente"
              },
              "destroy": {
                "succesfully": "Descarga de documentos ha sido eliminada correctamente"
              },
              "filter": {
                "by_aasm_state": "Estado",
                "end_date": "Hasta",
                "start_date": "Desde",
                "with_created_at": "Fecha de creación"
              },
              "form": {
                "confirm": {
                  "message": "¿Estás seguro de realizar la descarga de documentos?",
                  "title": "Realizar descarga de documentos"
                }
              },
              "index": {
                "without_results": "No hemos encontrado registros"
              },
              "show": {
                "details": "Detalles",
                "documentos": "Firmas",
                "tabs": {
                  "all": "Todos",
                  "completed": "Procesados",
                  "completed_errors": "Procesados con errores",
                  "failed": "Fallido",
                  "pending": "Pendientes"
                },
                "without_results": "No hemos encontrado registros"
              },
              "tooltip_info": "Selecciona los documentos que requieres descargar",
              "update": {
                "succesfully": "Descarga de documentos ha sido actualizada correctamente"
              }
            }
          }
        }
      },
      "check_list": {
        "processes": {
          "create": {
            "succesfully": "El check list ha sido creado correctamente"
          },
          "destroy": {
            "succesfully": "El check list ha sido eliminada correctamente"
          },
          "filter": {
            "by_company": "Empresa",
            "end_date": "Hasta",
            "filter": null,
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del check list</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "form": {
            "create": {
              "confirm": {
                "message": "¿Estás seguro de crear el check list?",
                "title": "Crear check list"
              }
            },
            "document_types": {
              "without_results": "No hemos encontrado tipos de documentos"
            },
            "entities": {
              "without_results": "No hemos encontrado trabajadores"
            },
            "update": {
              "confirm": {
                "message": "¿Estás seguro de actualizar el check list?",
                "title": "Actualizar check list"
              }
            }
          },
          "index": {
            "without_results": "No hemos encontrado check list"
          },
          "messages": {
            "destroy": {
              "confirm": {
                "message": "¿Estás seguro de eliminar el check list?",
                "title": "Eliminar check list"
              }
            }
          },
          "show": {
            "details": "Detalles del check list"
          },
          "tooltip_info": "Revisa y controla documentos asociados a contrataciones para identificar documentación lista o pendiente",
          "update": {
            "succesfully": "El check list ha sido actualizado correctamente"
          }
        },
        "tasks": {
          "create": {
            "succesfully": "La tarea ha sido creado correctamente"
          },
          "destroy": {
            "succesfully": "La tarea ha sido eliminada correctamente"
          },
          "filter": {
            "by_document_type": "Tipo de documento",
            "by_entity": "Entidad",
            "by_is_reviewed": "Revisado",
            "by_process": "Proceso de cumplimiento"
          },
          "update": {
            "succesfully": "La tarea ha sido actualizado correctamente"
          }
        }
      },
      "controldoc_form": {
        "documents": {
          "block": {
            "error_block_document": "El documento no pudo bloquearse",
            "succesfully": "El documento ha sido bloqueado correctamente",
            "without_controldoc_form_integration": "Debes integrar tu cuenta con ControlDoc Forms <a href='%{url}'>aquí</a>"
          },
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la Plantilla</li> <li>Email</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha inicio",
            "with_group_by": "Rol"
          },
          "index": {
            "without_results": "No hemos encontrado documentos asociadas"
          },
          "list": {
            "send": "Enviado a"
          },
          "show": {
            "details": "Documento",
            "other_data": "Otros datos",
            "signers": "Firmantes"
          },
          "tooltip_info": "Visualiza los envíos realizados y completados en ControlDoc Forms"
        },
        "template_mapping_links": {
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la Plantilla</li> <li>Email</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha inicio",
            "with_group_by": "Rol"
          },
          "form": {
            "opt_group": {
              "adp_fields": {
                "one": "Campos de ADP"
              },
              "custom_fields": {
                "one": "Campos personalizados"
              },
              "resource_data": {
                "one": "Información del recurso"
              },
              "system_information": {
                "one": "Información de sistema"
              }
            },
            "resource": {
              "abstract_entity": {
                "one": "Entidad"
              },
              "system_resource": {
                "one": "Sistema"
              }
            }
          },
          "index": {
            "without_results": "No hemos encontrado documentos asociadas"
          },
          "list": {
            "send": "Enviado a"
          }
        },
        "templates": {
          "assign_mapping_links": {
            "successfully": "Mapeo de plantilla con éxito"
          },
          "create": {
            "succesfully": "Plantilla creada con éxito"
          },
          "destroy": {
            "succesfully": "Plantilla eliminada con éxito"
          },
          "filter": {
            "by_company": "Empresa",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la plantilla</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha inicio",
            "with_group_by": "Rol"
          },
          "form": {
            "confirm": {
              "message": "¿Estás seguro de guardar la plantilla?",
              "title": "Guardar plantilla"
            }
          },
          "index": {
            "without_results": "No hemos encontrado plantillas asociadas"
          },
          "list": {
            "homologize_fields": "Homologar campos",
            "mapping": "Mapear"
          },
          "show": {
            "details": "Plantilla",
            "details_vars": "Autocompletar Plantilla",
            "details_vars_info": "Determina con qué información completarás la plantilla",
            "map_fields": "Asignar campos",
            "var_blank": "Si la tabla se deja en blanco, se interpreta que los campos de la plantilla serán completados posteriormente por cada usuario."
          },
          "table": {
            "attribute": "Atributo",
            "info": {
              "attribute": "Dato a completar en la variable de la plantilla",
              "model": "El recurso desde donde se extraerá el dato para completar la plantilla",
              "name": "Nombre",
              "type": "Tipo",
              "var": "El campo a completar en la plantilla"
            },
            "map": "Mapeo",
            "model": "Módulo / Recurso",
            "name": "Nombre",
            "type": "Tipo",
            "value": "Valor",
            "var": "Variable"
          },
          "update": {
            "successfully": "Plantilla actualizada con éxito"
          }
        }
      },
      "custom_fields": {
        "create": {
          "successfully": "El campo personalizado ha sido creado correctamente"
        },
        "data_types": {
          "date": "Fecha",
          "text": "Texto"
        },
        "destroy": {
          "succesfully": "El campo personalizado ha sido eliminado correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del campo personalizado</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el campo personalizado?",
            "title": "Guardar campo personalizado"
          },
          "save": "Guardar"
        },
        "index": {
          "without_results": "No hemos encontrado campos personalizados"
        },
        "is_notification_email": {
          "help": "Permite utilizar el correo electrónico como medio de comunicación para ver documentación"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará el campo personalizado y todos los datos asociados. Esta es una acción no reversible. ¿Estás seguro de eliminar el campo personalizado?",
              "title": "Eliminar campo personalizado"
            }
          }
        },
        "show": {
          "details": "Detalles del campo personalizado"
        },
        "show_as_name": {
          "help": "Permite mostrar la información como parte del nombre para %{entity_type}"
        },
        "show_on_list": {
          "help": "Permite mostrar la información como parte de la lista para %{entity_type}"
        },
        "tooltip_info": "Agrega y gestiona campos de  información que consideres relevante para tu gestión de documentos",
        "update": {
          "succesfully": "El campo personalizado ha sido actualizado correctamente"
        },
        "update_order": {
          "successfully": "Los campo personalizado han sido ordenados correctamente"
        }
      },
      "document_type_batteries": {
        "create": {
          "succesfully": "La batería de documentos ha sido creada correctamente"
        },
        "data_types": {
          "date": "Fecha",
          "text": "Texto"
        },
        "destroy": {
          "succesfully": "La batería de documentos ha sido eliminada correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la batería</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar la batería de documentos?",
            "title": "Guardar batería de documentos"
          },
          "save": "Guardar batería de documentos"
        },
        "index": {
          "without_results": "No hemos encontrado baterías de documentos"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará la batería de documentos y todos los datos asociados. Esta es una acción no reversible. ¿Estás seguro de eliminar la batería de documentos?",
              "title": "Eliminar batería de documentos"
            }
          }
        },
        "show": {
          "details": "Detalles de la batería de documentos"
        },
        "tooltip_info": "Administra conjunto de tipos de documentos para realizar de forma óptima las acciones masivas.",
        "update": {
          "succesfully": "La batería de documentos ha sido actualizado correctamente"
        }
      },
      "document_types": {
        "create": {
          "succesfully": "El tipo de documento ha sido creado correctamente"
        },
        "destroy": {
          "succesfully": "El tipo de documento ha sido eliminada correctamente"
        },
        "filter": {
          "by_company": "Empresa",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del tipo de documento</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el tipo de documento?",
            "title": "Guardar tipo de documento"
          },
          "save": "Guardar"
        },
        "index": {
          "without_results": "No hemos encontrado tipos de documentos"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar el tipo de documento?",
              "title": "Eliminar Tipo de Documento"
            }
          }
        },
        "show": {
          "details": "Detalles del tipo de documento",
          "signer_details": "Detalles de los firmantes predeterminados"
        },
        "tooltip_info": "Crea tipos de documentos para categorizar la documentación de tu %{entity}",
        "update": {
          "succesfully": "El tipo de documento ha sido actualizado correctamente"
        }
      },
      "documents": {
        "block": {
          "description": "Descripción",
          "successfully": "El documento ha sido bloqueado correctamente"
        },
        "controldoc_state": {
          "blocked": "Bloqueado",
          "partially_signed": "Firmado parcialmente",
          "pending_shortlist": "Pendiente Shortlist",
          "pending_sign": "Pendiente por firmar",
          "pending_to_fill": "Pendiente por llenar",
          "pending_upload": "Pendiente por subir",
          "processing_sign": "Procesando firma",
          "rejected": "Rechazado",
          "review_uploaded_file": "En revisión de archivo",
          "signature_expired": "Plazo de firma vencido",
          "signed_by_all": "Firmado",
          "uploaded": "Archivo subido"
        },
        "create": {
          "successfully": "El documento ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El documento ha sido eliminado correctamente"
        },
        "filter": {
          "by_aasm_state": "Estado",
          "by_document_type": "Tipo de documento",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Identificador</li> <li>Nombre del documento</li> <li>Nombre del firmante</li> <li>Correo electrónico del firmante</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha de creación"
        },
        "form": {
          "allowed_format_file": "Archivos permitidos %{allowed_format_files}",
          "confirm": {
            "message": "¿Estás seguro de guardar el documento?",
            "title": "Guardar Documento"
          },
          "require_signers": {
            "helper": {
              "title": "Al solicitar firmantes, el sistema se integrará con ControlDoc Sign"
            }
          },
          "save": "Guardar"
        },
        "index": {
          "without_results": "No hemos encontrado registros"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar el documento?",
              "title": "Eliminar Documento"
            }
          }
        },
        "new": {
          "requirement_details": "Detalle del requerimiento",
          "tooltip_doc": "Los archivos '.docx, .doc' serán convertidos en .pdf"
        },
        "refresh": {
          "successfully": "El estado de la integracion ha sido actualizado correctamente"
        },
        "retry_controldoc_integration": {
          "successfully": "Se ha enviado la integración con ControlDoc Sign"
        },
        "show": {
          "controldoc_integration_data": "Datos de integración con ControlDoc Sign",
          "details": "Detalles del documento",
          "details_blocked": "Detalles del documento bloqueado",
          "signers": "Firmantes"
        },
        "signer_state": {
          "blocked": "Bloqueado",
          "pending": "Pendiente de firma",
          "rejected": "Rechazado",
          "signed": "Firmado"
        },
        "signers": {
          "email": "Correo Electrónico",
          "label": "ROL",
          "state": "Estado"
        },
        "tooltip_info": "Visualiza todos los documentos. Crea, carga y envía documentos con o sin solicitudes de firma.",
        "update": {
          "successfully": "El documento ha sido actualizado correctamente"
        }
      },
      "entities": {
        "create": {
          "succesfully": "El/la %{entity} ha sido creado correctamente"
        },
        "destroy": {
          "succesfully": "El/la %{entity} ha sido eliminada correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_by_key_custom_fields": "Campos Personalizados",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Identificador</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha de creación"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el/la %{entity}?",
            "title": "Guardar %{entity}"
          }
        },
        "identifier_help": "Es un código único y modificable con el que se identificará el/la %{entity} en la plataforma, el cual puede ser un código interno.",
        "index": {
          "without_results": "No hemos encontrado %{entity}"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": " <p> ¿Estás seguro de eliminar el/la %{entity}? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará el/la %{entity}.</li> <li>Eliminará los documentos asociados.</li> </ul> </div> ",
              "title": "Eliminar %{entity}"
            }
          }
        },
        "security_layer_help": "Esta opción segmenta a tu %{entity} y gestiona permisos específicos por esa área",
        "show": {
          "custom_fields": "Otros datos",
          "details": "Detalles %{entity}",
          "without_docs": "No hemos encontrado documentos"
        },
        "tooltip_info": "Administra todos/as los/las %{entity} y sus datos",
        "update": {
          "succesfully": "El/la %{entity} ha sido actualizado correctamente"
        }
      },
      "entity_types": {
        "index": null
      },
      "fao": {
        "mapping_configs": {
          "form": {
            "message": {
              "important": "<div> <p><strong>Información importante sobre la homologación:</strong></p> <ul> <li> El campo <strong> Correo electrónico </strong> corresponde al correo electrónico de la persona que se le notificará y deberá firmar el documento. </li> <li> Los siguientes campos corresponden a información necesaria del usuario para firmar con FAO. <ul> <li>RUT.</li> <li>Nombre.</li> <li>Primer Apellido.</li> <li>Segundo Apellido.</li> </ul> </li> </ul> </div>"
            }
          }
        }
      },
      "no_entry": "No ingresó valor",
      "processing_entry": "Procesando dato",
      "report": {
        "documents": {
          "create": {
            "successfully": "Tu reporte ha sido solicitado correctamente, una vez generado será enviado por correo electrónico."
          },
          "filter": {
            "end_date": "Hasta",
            "start_date": "Desde",
            "with_created_at": "Fecha de creación",
            "with_expires_at": "Fecha de caducidad"
          },
          "headers": {
            "created_at": "Fecha de creación",
            "document": "Documento",
            "document_created_by": "Creado por",
            "document_type": "Tipo de documento",
            "entity_name": "Entidad",
            "expires_at": "Fecha de caducidad",
            "rut": "Rut",
            "signature_deadline_at": "Fecha límite de firma",
            "state": "Estado"
          },
          "new": {
            "by_aasm_state": "Estado",
            "by_document_type": "Tipo de documento",
            "by_expire_state": "Estado de caducidad",
            "by_expires_at": "Fecha de caducidad",
            "by_signature_deadline_at": "Fecha límite de firma",
            "create_excel": "Crear excel",
            "end_date": "Hasta",
            "start_date": "Desde",
            "without_results": "No hemos encontrado registros"
          },
          "title": "Más información",
          "tooltip_info": "Filtra y genera archivo de reporte de todos los documentos de módulo %{entity}"
        },
        "signers": {
          "filter": {
            "end_date": "Hasta",
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "headers": {
            "document": "Documento",
            "document_created_by": "Documento creado por",
            "document_label": "Nombre de documento",
            "document_state": "Estado de documento",
            "document_type": "Tipo de documento",
            "entity": "Entidad",
            "expires_at": "Fecha de expiración",
            "identifier": "Identificador",
            "request_date": "Fecha de solicitud",
            "security_layer": "Capa de seguridad",
            "sign_date": "Fecha de firma",
            "sign_state": "Estado de firma",
            "signature_deadline_at": "Fecha límite de firma",
            "signer_email": "Firmante",
            "signer_role": "Rol en el documento",
            "template_name": "Nombre plantilla"
          },
          "new": {
            "aasm_state": "Estado de firma",
            "create_excel": "Crear excel",
            "email": "Correo firmante",
            "end_date": "Hasta",
            "search_by_key_custom_fields": "Campos personalizados",
            "sorted_by": "Ordenar por",
            "start_date": "Desde",
            "template_name": "Nombre plantilla",
            "without_results": "No hemos encontrado registros"
          },
          "title": "Más información",
          "tooltip_info": "Filtra y genera archivo de reporte de todos los firmantes de módulo %{entity}"
        }
      },
      "shortlist": {
        "assessment_loads": {
          "create": {
            "successfully": "La integración a Shortlist ha sido creada correctamente"
          },
          "retry_integration": {
            "confirmation": {
              "confirm": "¿Estás seguro de reintentar la integración con Shortlist?",
              "title": "Reintentar integración"
            },
            "one": "Reintentar integración"
          },
          "tooltip_info": "Administra los requerimientos que requieren de tu atención"
        }
      },
      "tabs": {
        "completed": "Procesados",
        "failed": "Con Errores",
        "pending": "Pendientes"
      },
      "without_results": "No hemos encontrado resultados",
      "workflow": {
        "processes": {
          "filter": {
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> </ul>"
            }
          }
        },
        "requirement_stage_mailer": {
          "moving_backward_html": "El requerimiento <strong>%{requirement_name}</strong> ha sido devuelto a la etapa <strong>%{to_stage_name}</strong>",
          "moving_forward_html": "El requerimiento <strong>%{requirement_name}</strong> ha avanzado a la etapa <strong>%{to_stage_name}</strong>",
          "new_requirement_html": "Se ha recepcionado el requerimiento <strong>%{requirement_name}</strong>"
        }
      }
    },
    "actions": {
      "access": "Acceder",
      "actions": "Acciones",
      "activate": "Activar",
      "active_account": "Activar Cuenta",
      "add": "Añadir",
      "apply": "Aplicar",
      "approve": "Aprobar",
      "back": "Volver",
      "back_to_dashboard": "Volver al Dashboard",
      "block": "Bloquear",
      "bulk_sign": "Firma Masiva",
      "clean": "Limpiar",
      "clean_filter": "Limpiar Filtros",
      "clone": "Clonar",
      "close": "Cerrar",
      "complete": "Completar",
      "configure": "Configurar",
      "continue": "Continuar",
      "create": "Nuevo",
      "create_a": "Nueva",
      "create_ao": "Nuevo/a",
      "destroy": "Eliminar",
      "download": "Descargar",
      "download_all": "Descargar todos",
      "download_excel": "Descargar excel",
      "download_pdf": "Descargar PDF",
      "download_report": "Descargar reporte",
      "download_template": "Descargar plantilla",
      "download_zip": "Descargar zip",
      "ecert_enroll": "Enrollar E-Cert",
      "edit": "Editar",
      "export_json": "Exportar JSON",
      "filter": "Buscar",
      "generate": "Generar",
      "generating": "Generando",
      "import_json": "Importar JSON",
      "into": "Ingresar",
      "login_account": "Ingresar",
      "notify": "Notificar",
      "order": "Ordenar",
      "preview": "Previsualizar",
      "publish": "Publicar",
      "query": "Consultar",
      "read_more": "Leer más",
      "refresh": "Refrescar",
      "reject": "Rechazar",
      "review": "Revisar",
      "save": "Guardar",
      "saving": "Guardando ...",
      "search": "Buscar",
      "select_all": "Seleccionar todo",
      "send": "Enviar",
      "send_data": "Enviar datos",
      "sending": "Enviando",
      "share": "Compartir",
      "show": "Ver",
      "show_all": "Ver todos",
      "show_more": "Ver más",
      "show_report": "Ver Reporte",
      "sign": "Firmar",
      "to_fill": "Llenar",
      "unpublish": "Despublicar",
      "update": "Actualizar",
      "upload": "Subir",
      "upload_file": "Subir archivo",
      "upload_template": "Subir plantilla"
    },
    "active_admin": {
      "access_denied": {
        "message": "No está autorizado/a a realizar esta acción."
      },
      "any": "Cualquiera",
      "batch_actions": {
        "action_label": "%{title} seleccionados",
        "button_label": "Acciones en masa",
        "default_confirmation": "¿Seguro que quieres hacer esto?",
        "delete_confirmation": "Se eliminarán %{plural_model}. ¿Desea continuar?",
        "labels": {
          "destroy": "Borrar"
        },
        "selection_toggle_explanation": "(Cambiar selección)",
        "succesfully_destroyed": {
          "one": "Se ha destruido 1 %{model} con éxito",
          "other": "Se han destruido %{count} %{plural_model} con éxito"
        }
      },
      "blank_slate": {
        "content": "No hay %{resource_name} aún.",
        "link": "Añadir"
      },
      "cancel": "Cancelar",
      "comments": {
        "add": "Comentar",
        "author": "Autor",
        "author_missing": "Anónimo",
        "author_type": "Tipo de autor",
        "body": "Cuerpo",
        "created_at": "Fecha de creación",
        "delete": "Borrar Comentario",
        "delete_confirmation": "¿Confirma que desea borrar este comentario?",
        "errors": {
          "empty_text": "El comentario no fue guardado, el texto estaba vacío."
        },
        "no_comments_yet": "No hay comentarios aún.",
        "resource": "Recurso",
        "resource_type": "Tipo de recurso",
        "title_content": "Comentarios (%{count})"
      },
      "create_another": "Crear otro %{model}",
      "dashboard": "Inicio",
      "dashboard_welcome": {
        "call_to_action": "Para agregar secciones edite 'app/admin/dashboard.rb'",
        "welcome": "Bienvenido a Active Admin. Esta es la página de inicio predeterminada."
      },
      "delete": "Eliminar",
      "delete_confirmation": "¿Confirma que desea borrar este elemento?",
      "delete_model": "Eliminar %{model}",
      "details": "Detalles de %{model}",
      "devise": {
        "change_password": {
          "submit": "Cambiar mi contraseña",
          "title": "Cambie su contraseña"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "¿Olvidó su contraseña?",
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación",
          "resend_unlock_instructions": "Reenviar instrucciones de desbloqueo",
          "sign_in": "Iniciar Sesión",
          "sign_in_with_omniauth_provider": "Conéctate con %{provider}",
          "sign_up": "Registrarse"
        },
        "login": {
          "remember_me": "Recordarme",
          "submit": "Iniciar Sesión",
          "title": "Iniciar Sesión"
        },
        "password": {
          "title": "Contraseña"
        },
        "password_confirmation": {
          "title": "Confirmar Contraseña"
        },
        "resend_confirmation_instructions": {
          "submit": "Reenviar instrucciones de confirmación",
          "title": "Reenviar instrucciones de confirmación"
        },
        "reset_password": {
          "submit": "Restablecer mi contraseña",
          "title": "¿Olvidó su contraseña?"
        },
        "sign_up": {
          "submit": "Registrarse",
          "title": "Registrarse"
        },
        "subdomain": {
          "title": "Subdominio"
        },
        "unlock": {
          "submit": "Reenviar instrucciones de desbloqueo",
          "title": "Reenviar instrucciones de desbloqueo"
        },
        "username": {
          "title": "Nombre de usuario"
        }
      },
      "download": "Descargar:",
      "dropdown_actions": {
        "button_label": "Acciones"
      },
      "edit": "Editar",
      "edit_model": "Editar %{model}",
      "empty": "Vacío",
      "filters": {
        "buttons": {
          "clear": "Quitar Filtros",
          "filter": "Filtrar"
        },
        "predicates": {
          "from": "Desde",
          "to": "Hasta"
        }
      },
      "has_many_delete": "Eliminar",
      "has_many_new": "Añadir %{model}",
      "has_many_remove": "Quitar",
      "index_list": {
        "block": "Lista",
        "blog": "Blog",
        "grid": "Grilla",
        "table": "Tabla"
      },
      "logout": "Salir",
      "main_content": "Por favor implemente %{model}#main_content para mostrar contenido.",
      "move": "Mover",
      "new_model": "Añadir %{model}",
      "next": "Siguiente",
      "pagination": {
        "empty": "No se han encontrado %{model}",
        "entry": {
          "one": "registro",
          "other": "registros"
        },
        "multiple": "Mostrando %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> de un total de <b>%{total}</b>",
        "multiple_without_total": "Mostrando %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Mostrando <b>1</b> %{model}",
        "one_page": "Mostrando <b>un total de %{n}</b> %{model}",
        "per_page": "Por página: "
      },
      "powered_by": "Funciona con %{active_admin} %{version}",
      "previous": "Anterior",
      "scopes": {
        "all": "Todos"
      },
      "search_status": {
        "current_filters": "Filtros actuales:",
        "current_scope": "Alcance:",
        "headline": "Estado de la búsqueda:",
        "no_current_filters": "Ninguno"
      },
      "sidebars": {
        "filters": "Filtros",
        "search_status": "Estado de la búsqueda"
      },
      "status_tag": {
        "no": "No",
        "unset": "No",
        "yes": "Sí"
      },
      "unsupported_browser": {
        "headline": "Por favor tenga en cuenta que Active Admin no soporta versiones de Internet Explorer menores a 8.",
        "recommendation": "Recomendamos que actualice a la última versión de <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, o <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Si está usando IE 9 o superior, asegúrese de <a href=\"https://support.microsoft.com/es-es/help/17471\">apagar la \"Vista de compatibilidad\"</a>."
      },
      "view": "Ver"
    },
    "activerecord": {
      "attributes": {
        "abstract/bulk/load/document": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "document_type": "Tipo de documento",
          "enable_controldoc_integration": "¿Requiere integración con firma electrónica?",
          "entity_identifier": "Identificador",
          "label": "Nombre del documento",
          "require_signature_deadline": "¿Requiere fecha límite de firma?",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "signature_deadline_at": "Fecha límite de firma"
        },
        "abstract/bulk/load/document_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          }
        },
        "abstract/bulk/load/entity": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "entity_identifier": "Identificador",
          "file": "Documento",
          "file_excel": "Documento"
        },
        "abstract/bulk/request/document": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "is_scheduled": "Programar el envío de los documentos",
          "requested_by": "Solicitado por",
          "scheduled_at": "Programado para"
        },
        "abstract/bulk/request/document_config": {
          "autocompleted_by_entity_false": "¿Deseas que el sistema autocomplete las variables que se encuentran homologadas en ControlDoc y que el firmante complete las que no se encuentran homologadas?",
          "autocompleted_by_entity_true": "¿Deseas que el sistema autocomplete TODAS las variables homologadas de la plantilla?",
          "document_type_battery": "Utiliza una batería de documentos",
          "document_type_id": "Tipo de Documento",
          "expires_at": "Caduca el",
          "expires_at_help": "La fecha en que el documento caducará.",
          "expires_at_label": "Fecha de expiración",
          "file": "Archivo",
          "help": "Requiere de un campo personalizado tipo Email habilitado como vía de comunicación.",
          "label": "Nombre",
          "require_fao": "¿Firmará con Firma Avanzada?",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_upload_deadline": "¿Requiere fecha límite de subida?",
          "requires_expire": "¿Tiene caducidad?",
          "templates": "Plantillas",
          "upload_deadline_at": "Fecha límite de subida",
          "uploaded_by": {
            "one": "",
            "upload_controldoc_form": "Utilizar plantilla de documento",
            "upload_file_employee": "Solicitar Documento al representante",
            "upload_file_user": "Subir Documento"
          }
        },
        "abstract/bulk/request/document_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          }
        },
        "abstract/bulk/request/entity_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación"
        },
        "abstract/custom_field": {
          "abstract_entity_type": "Módulo",
          "code": "Código",
          "created_at": "Fecha de creación",
          "data_type": "Tipo de dato",
          "label": "Etiqueta",
          "resource_type": "Recurso",
          "show_as_name": "¿Usar como nombre?",
          "show_on_list": "¿Usar como lista?"
        },
        "abstract/document": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending_shortlist": "Pendiente Shortlist",
            "pending_sign": "Pendiente por firmar",
            "pending_to_fill": "Pendiente por llenar",
            "pending_upload": "Pendiente por subir",
            "processing_sign": "Procesando firma",
            "rejected": "Rechazado",
            "review_uploaded_file": "En revisión de archivo",
            "signature_expired": "Plazo de firma vencido",
            "signed_by_all": "Firmado",
            "uploaded": "Archivo subido"
          },
          "blocked_at": "Bloqueado el",
          "blocked_by_id": "Bloqueado por",
          "blocked_description": "Descripción",
          "controldoc_form_file": "Documento de ControlDoc Forms",
          "controldoc_sign_delete_error": "Error de eliminación",
          "controldoc_sign_integration_enabled": "¿Requiere integración con firma electrónica?",
          "created_at": "Fecha de creación",
          "document_type": "Tipo de documento",
          "document_type_id": "Tipo de documento",
          "employee": "Trabajador",
          "entity": "Recurso",
          "entity_id": "Recurso",
          "expired": "Caducado",
          "expires_at": "Caduca el",
          "file": "Documento",
          "file_size": "Tamaño",
          "in_force": "Vigente",
          "label": "Nombre del documento",
          "rejected_reason": "Motivo de rechazo de documento",
          "require_fao": "¿Firmará con Firma Avanzada?",
          "require_signature_deadline": "¿Requiere fecha límite de firma?",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_upload_deadline": "¿Requiere fecha límite de subida?",
          "requires_expire": "¿Tiene caducidad?",
          "signature_deadline_at": "Fecha límite de firma",
          "signer_role": "Rol en el documento",
          "signers": "Firmantes",
          "to_expire": "Por caducar",
          "upload_deadline_at": "Fecha límite para subir documento",
          "without_expires_at": "Sin expirar"
        },
        "abstract/document_type": {
          "created_at": "Fecha de creación",
          "default_signers_help": "Establece firmantes por defecto a tu tipo de documento",
          "name": "Nombre del tipo de documento",
          "number_days_to_expire_documents": "Número de días por expirar los documentos",
          "number_days_to_expire_documents_help": "Esta opción permite configurar el número de dias para considerar los documentos que estan por caducar, el sistema configura por defecto 15 dias",
          "require_signers": "¿Requiere firmantes predeterminados?",
          "require_signers_order": "¿Requiere orden de firmantes?"
        },
        "abstract/document_type_batteries": {
          "created_at": "Fecha de creación",
          "name": "Nombre de la batería de documentos"
        },
        "abstract/entity": {
          "clone_folders": "¿Clonar carpetas?",
          "controldoc_id": "CONTROLDOCID ( PELIGRO NO MODIFICAR, PARA NUEVOS REGISTROS DEJAR EN BLANCO)",
          "created_at": "Fecha de creación",
          "identifier": "Identificador",
          "security_layer": "Capa de seguridad",
          "security_layer_id": "Capa de seguridad"
        },
        "abstract/entity_type": {
          "Label": "Etiqueta",
          "created_at": "Fecha de creación",
          "customer": "Cliente",
          "customer_id": "Cliente",
          "customer_name": "Cliente",
          "deleted_at": "Fecha de eliminación",
          "document_configuration_show_entity_name": "Mostrar nombre de la entidad en el documento",
          "entity_type_configs": "Configuración de módulos",
          "icon": "Icono",
          "module_icon": "Icono del módulo",
          "module_name": "Nombre del módulo",
          "namespace": "Nombre",
          "plural_name": "Nombre en plural",
          "singular_name": "Nombre en singular",
          "updated_at": "Fecha de actualización"
        },
        "abstract/entity_type_config": {
          "entity_type_id": "Módulo"
        },
        "abstract/report/document": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending": "Pendiente",
            "rejected": "Rechazado",
            "signature_expired": "Plazo de firma vencido",
            "signed": "Firmado",
            "signed_by_all": "Firmado por todos",
            "uploaded": "Archivo subido"
          }
        },
        "abstract/report/signer": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending": "Pendiente",
            "rejected": "Rechazado",
            "signature_expired": "Plazo de firma vencido",
            "signed": "Firmado",
            "signed_by_all": "Firmado por todos",
            "uploaded": "Archivo subido"
          }
        },
        "abstract/shortlist/assessment_load": {
          "aasm_state": {
            "approved": "Aprobado",
            "discarded": "Descartado",
            "invited": "Invitado",
            "inviting": "Invitar",
            "one": "Estado"
          },
          "additional_attributes": "Atributos adicionales",
          "answers": "Respuestas",
          "created_at": "Fecha de creación",
          "date": "Fecha",
          "email": "Correo electrónico",
          "name": "Nombre",
          "phone": "Teléfono",
          "points": "Puntaje",
          "project_id": "Evaluación",
          "questions": "Preguntas"
        },
        "active_admin/comment": {
          "author_type": "Tipo de autor",
          "body": "Cuerpo",
          "created_at": "Fecha de creación",
          "namespace": "Espacio de nombres",
          "resource_type": "Tipo de recurso",
          "updated_at": "Fecha de actualización"
        },
        "billing/account": {
          "company_address": "Dirección de la empresa",
          "company_name": "Nombre de la empresa",
          "contact_email": "Correo electrónico del contacto",
          "contact_name": "Nombre del contacto",
          "contact_phone": "Teléfono de contacto",
          "invoice_ends_date": "Fecha ultima factura",
          "invoice_period": "Periodo de facturación (meses)",
          "invoice_start_date": "Fecha primera factura",
          "invoiceable_on_accept": "¿Generar la fecha de facturación al confirmar los datos de facturación?",
          "tax_id": "Identificación fiscal (RUT)"
        },
        "billing/quote/active_employee": {
          "date": "Fecha",
          "qty": "Cantidad",
          "type": "Producto"
        },
        "billing/quote/advance_signature": {
          "date": "Fecha",
          "qty": "Cantidad",
          "type": "Firma"
        },
        "billing/quote/ecert_single_use": {
          "date": "Fecha",
          "qty": "Cantidad",
          "type": "Firma"
        },
        "billing/quote/gb_used": {
          "date": "Fecha",
          "qty": "Cantidad",
          "type": "Producto"
        },
        "billing/quote/inactive_employee": {
          "date": "Fecha",
          "qty": "Cantidad",
          "type": "Producto"
        },
        "billing/quote/member": {
          "date": "Fecha",
          "qty": "Cantidad",
          "type": "Producto"
        },
        "billing/quote/resource": {
          "date": "Fecha",
          "download": "Descarga",
          "qty": "Cantidad",
          "type": "Producto"
        },
        "billing/quote/signature_certificate": {
          "date": "Fecha",
          "qty": "Cantidad",
          "type": "Certificado"
        },
        "billing/quote/simple_signature": {
          "date": "Fecha",
          "qty": "Cantidad",
          "type": "Firmas"
        },
        "blog/post": {
          "content": "Contenido",
          "cover_image": "Fotografía portada",
          "created_at": "Fecha de creación",
          "preview_content": "Previsualización de contenido",
          "title": "Titulo"
        },
        "bulk/datatable/distribution_list_filter": {
          "name": "Nombre de la lista de distribución"
        },
        "bulk/load/docx_merge_field": {
          "aasm_state": {
            "completed": "Completado",
            "completed_errors": "Completado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "bulk_errors": "Errores",
          "created_at": "Creado el",
          "created_by": "Creado por",
          "data_file": "Archivo datos",
          "document_type": "Tipo de documento",
          "label": "Nombre del documento",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "template_file": "Archivo plantilla",
          "updated_at": "Actualizado el"
        },
        "bulk/load/docx_merge_field_item": {
          "aasm_state": {
            "completed": "Completado",
            "completed_errors": "Completado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Creado el",
          "name": "Nombre",
          "updated_at": "Actualizado el"
        },
        "bulk/my_filter": {
          "created_at": "Fecha creación",
          "created_by": "Creado por",
          "filters": "Filtros",
          "name": "Nombre del filtro"
        },
        "bulk/notification/fill": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "notified_by": "Solicitado por"
        },
        "bulk/notification/fill_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "controldoc_form_document_id": "Formulario",
          "created_at": "Fecha creación",
          "document_id": "Documento",
          "document_type": "Tipo de documento",
          "email": "Correo electrónico",
          "template_name": "Nombre del formulario"
        },
        "bulk/notification/sign": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "notified_by": "Solicitado por"
        },
        "bulk/notification/sign_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "document_id": "Documento",
          "document_type": "Tipo de documento",
          "email": "Correo electrónico",
          "name": "Nombre",
          "signer_id": "Firmante"
        },
        "bulk/rejection": {
          "description": "Descripción",
          "otp_code_token": "Pin"
        },
        "bulk/request/destroy_document": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "files": "Archivos",
          "requested_by": "Solicitado por"
        },
        "bulk/request/destroy_document_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "document": "Documento",
          "document_id": "Documento",
          "document_type": "Tipo de documento",
          "email": "Correo electrónico",
          "name": "Nombre"
        },
        "bulk/request/zip/document": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "files": "Archivos",
          "requested_by": "Solicitado por"
        },
        "bulk/request/zip/document_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "document": "Documento",
          "document_id": "Documento",
          "document_type": "Tipo de documento",
          "email": "Correo electrónico",
          "name": "Nombre"
        },
        "bulk/signing": {
          "pin_code": "Creado por",
          "skip_signed_document_notification": "No deseo recibir mas notificaciones de estos documentos"
        },
        "bulk_signer_config": null,
        "calendar/event": {
          "created_at": "Fecha de creación",
          "descriptions": "Descripción",
          "ends_at": "Fecha de fin",
          "starts_at": "Fecha de inicio",
          "title": "Título",
          "updated_at": "Fecha de actualización"
        },
        "calendar/holiday_event": {
          "starts_at": "Fecha"
        },
        "calendar/work_schedule": {
          "business_days": "Días laborales",
          "configuration": "Configuración",
          "created_at": "Fecha de creación",
          "description": "Descripción",
          "end_time": "Hora de fin",
          "start_time": "Hora de inicio",
          "title": "Título"
        },
        "check_list/process": {
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "document_type_ids": "Tipos de documentos",
          "name": "Nombre",
          "requires_autorefresh": "¿Require de actualización automática?",
          "requires_document_count_per_document_type": "¿Require una cantidad de documentos por tipo de documento?"
        },
        "check_list/shared_process": {
          "created_at": "Compartido el",
          "customer": "Cliente",
          "shared_by": "Compartido por"
        },
        "check_list/task": {
          "created_at": "Fecha de creación",
          "document_number": "Número de documento",
          "document_type": "Tipo de documento",
          "is_reviewed": "Revisado",
          "process": "Check list",
          "reviewed_by": "Revisado por"
        },
        "comment": {
          "body": "Comentario",
          "created_at": "Fecha de creación"
        },
        "communication_channel": {
          "categories": {
            "one": "Categorias"
          },
          "channel_type": {
            "email": "Correo electrónico",
            "one": "Tipo de canal"
          },
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "emails": "Correos electrónicos",
          "resource": "Recurso"
        },
        "compliance/activity": {
          "aasm_state": {
            "all": "Todos los estados",
            "completed": "Completada",
            "in_process": "En proceso",
            "one": "Estado",
            "overdue": "Atrasada",
            "pending": "Pendiente",
            "planned": "Planificada"
          },
          "all_groups": "Todos los grupos",
          "assign_uploaders_by_email_notification": "¿Asignar a un representante dentro del modulo?",
          "company": "Empresa",
          "completed_by": "Completado por",
          "compliance_risk_level_id": "Nivel de Riesgo",
          "consultant_groups": "Responsables de consultar",
          "count_evidences_pending_review": "Cantidad de evidencias pendientes de revisión",
          "created_at": "Creado en",
          "created_by": "Creado por",
          "days_for_perform": "Plazo para completar",
          "deadline": "Fecha de cumplimiento",
          "description": "Descripción",
          "id": "ID",
          "informer_groups": "Responsables de recibir notificaciones",
          "name": "Nombre",
          "overdue": "Atrasada",
          "pending_review": "¿Solo evidencias pendientes de revisión?",
          "progress": "Progreso",
          "project": "Proyecto",
          "recurrence": {
            "annual": "Anual",
            "biweekly": "Quincenal",
            "daily": "Diaria",
            "monthly": "Mensual",
            "one": "Recurrencia",
            "quarterly": "Trimestral",
            "semiannual": "Semestral",
            "spot": "Sin recurrencia",
            "weekly": "Semanal"
          },
          "resource": "Recurso",
          "resource_module_name": "Módulos",
          "reviewer_groups": "Responsables de revisar evidencias",
          "risk_level": "Nivel de Riesgo",
          "start_date": "Fecha de inicio",
          "uploader_groups": "Responsables de subir evidencias"
        },
        "compliance/activity_container": {
          "chat_file": "Archivo de chat",
          "compliance_activities": "Actividades",
          "created_at": "Creado en",
          "created_by": "Creado por",
          "id": "ID",
          "name": "Nombre"
        },
        "compliance/activity_group": {
          "compliance_group_id": "Grupo",
          "id": "ID",
          "mandatory": "Obligatorio",
          "name": "Nombre Del Grupo"
        },
        "compliance/activity_group_check": {
          "action": "Acción",
          "activity_group_id": "Grupo revisor",
          "checked_by": "Revisado por",
          "comment": "Observaciones",
          "created_at": "Revisado el"
        },
        "compliance/bulk/load/activity": {
          "aasm_state": {
            "completed": "Completada",
            "completed_errors": "Completada con errores",
            "failed": "Fallo",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "bulk_errors": "Errores",
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "details": "Detalle",
          "file": "Archivo",
          "id": "ID"
        },
        "compliance/context": {
          "created_at": "Creado el",
          "enabled_resource_config": "¿Habilitar configuración para relacionar actividades con recursos?",
          "icon": "Icono",
          "name": "Nombre del Módulo",
          "updated_at": "Actualizado el"
        },
        "compliance/custom_field": {
          "code": "Código",
          "created_at": "Creado en",
          "data_type": "Tipo de dato",
          "format": "Formato",
          "group_ids": "Grupos",
          "id": "ID",
          "label": "Etiqueta",
          "list_options": "Opciones de lista",
          "resource_type": "Recurso",
          "show_on_list": "Mostrar en lista",
          "updated_at": "Actualizado en"
        },
        "compliance/evidence": {
          "completed": "Completada",
          "is_recurrent": "¿Es recurrente?",
          "name": "Nombre",
          "no_completed": "Pendiente",
          "template": "Plantilla"
        },
        "compliance/evidence_file": {
          "aasm_state": {
            "accepted": "Aceptada",
            "in_review": "En revisión",
            "one": "Estado",
            "pending": "Pendiente",
            "rejected": "Rechazada"
          },
          "comment": "Observaciones",
          "name": "Nombre",
          "pending_review": "Pendientes por revisión"
        },
        "compliance/evidence_load": {
          "observations": "Observaciones"
        },
        "compliance/group": {
          "id": "ID",
          "name": "Nombre"
        },
        "compliance/risk_level": {
          "hex_color": "Color",
          "id": "ID",
          "name": "Nombre",
          "preview": "Previsualización",
          "value": "Ponderación"
        },
        "controldoc_form/document": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "filled": "Completado",
            "one": "Estado",
            "partially_filled": "En proceso",
            "pending": "Pendiente"
          },
          "blocked_at": "Bloqueado el",
          "blocked_by": "Bloqueado por",
          "blocked_by_id": "Bloqueado por",
          "blocked_description": "Descripción",
          "controldoc_state": "Estado de firma:",
          "created_at": "Fecha de creación",
          "created_by_id": "Creado por",
          "email": "Correo electrónico",
          "name": "Nombre"
        },
        "controldoc_form/template": {
          "content": "Contenido",
          "created_at": "Fecha de creación",
          "created_by_id": "Creado por",
          "document_type_id": "Tipo de documento",
          "is_controldoc_consent_annex": "Anexo de consentimiento de controldoc",
          "is_controldoc_consent_annex?": "¿Es anexo de consentimiento de controldoc?",
          "name": "Nombre",
          "require_uploaded_template": "¿Requiere cargar una plantilla?",
          "template_layout_id": "Diseño",
          "uploaded_file": "Archivo plantilla (RTF)",
          "vars": "Variables"
        },
        "controldoc_form/template_layout": {
          "created_at": "Creado el",
          "created_by_id": "Creado por",
          "footer": "Pie de página",
          "header": "Cabecera",
          "name": "Nombre"
        },
        "corporate/agreement": {
          "client": "Cliente",
          "client_hirings": "Contratos como Cliente",
          "company_client_name": "Nombre de la empresa Cliente",
          "company_provider_name": "Nombre de la empresa Proveedor",
          "created_at": "Fecha de creación",
          "end_date": "Fecha fin",
          "identifier": "Identificador del contrato",
          "name": "Nombre del contrato",
          "provider": "Proveedor",
          "provider_hirings": "Contratos como Proveedor",
          "start_date": "Fecha inicio"
        },
        "corporate/agreement_config": {
          "client_id": "Cliente",
          "client_identifier": "Identificador del cliente",
          "client_name": "Nombre del cliente",
          "end_date": "Fecha fin",
          "provider_id": "Proveedor",
          "provider_identifier": "Identificador del proveedor",
          "provider_name": "Nombre del proveedor",
          "start_date": "Fecha inicio"
        },
        "corporate/agreement_document": {
          "aasm_state": "Estado",
          "blocked_at": "Bloqueado el",
          "blocked_by_id": "Bloqueado por",
          "blocked_description": "Descripción",
          "client_collaborator": "Cliente",
          "controldoc_sign_delete_error": "Error de eliminación",
          "controldoc_sign_integration_enabled?": "¿Requiere integración con firma electrónica?",
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "document_type": "Tipo de documento",
          "document_type_id": "Tipo de documento",
          "entity_id": "Contrato",
          "expires_at": "Caduca el",
          "file": "Documento",
          "file_size": "Tamaño",
          "label": "Nombre del documento",
          "name": "Nombre del documento",
          "provider": "Proveedor",
          "provider_collaborator": "Proveedor",
          "rejected_reason": "Motivo de rechazo de documento",
          "request_date": "Fecha de solicitud",
          "require_fao": "¿Firmará con Firma Avanzada?",
          "require_signature_deadline": "¿Requiere fecha límite de firma?",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_upload_deadline": "¿Requiere fecha límite de subida?",
          "requires_expire": "¿Tiene caducidad?",
          "sign_date": "Fecha de firma",
          "sign_state": "Estado de firma",
          "signature_deadline_at": "Fecha límite de firma",
          "signer_email": "Firmante",
          "signer_role": "Rol en el documento",
          "signers": "Firmantes",
          "template_name": "Nombre plantilla",
          "upload_deadline_at": "Fecha límite para subir documento"
        },
        "corporate/branch": {
          "company": "Empresa",
          "identifier": "Identificador",
          "name": "Nombre"
        },
        "corporate/bulk/notification/sign": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "notified_by": "Solicitado por"
        },
        "corporate/bulk/notification/sign_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "document_id": "Documento",
          "document_type": "Tipo de documento",
          "email": "Correo electrónico",
          "name": "Nombre",
          "signer_id": "Firmante"
        },
        "corporate/bulk/request/agreement_document": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "is_scheduled": "Programar el envío de los documentos",
          "requested_by": "Solicitado por",
          "scheduled_at": "Programado para"
        },
        "corporate/bulk/request/agreement_document_config": {
          "autocompleted_by_entity_false": "¿Deseas que el sistema autocomplete las variables que se encuentran homologadas en ControlDoc y que el firmante complete las que no se encuentran homologadas?",
          "autocompleted_by_entity_true": "¿Deseas que el sistema autocomplete TODAS las variables homologadas de la plantilla?",
          "document_type_id": "Tipo de Documento",
          "file": "Archivo",
          "label": "Nombre",
          "requested_to": {
            "legal_representative_client": "Representante legal de la empresa cliente",
            "legal_representative_provider": "Representante legal de la empresa proveedora",
            "one": ""
          },
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_upload_deadline": "¿Requiere fecha límite de subida?",
          "templates": "Plantillas",
          "upload_deadline_at": "Fecha límite de subida",
          "uploaded_by": {
            "one": "",
            "upload_controldoc_form": "¿Desea solicitar el archivo vía Plantilla Controldoc Forms?",
            "upload_file_client": "¿Desea solicitar el archivo al cliente?",
            "upload_file_provider": "¿Desea solicitar el archivo al proveedor?",
            "upload_file_user": "¿Desea subir archivo?"
          }
        },
        "corporate/bulk/request/agreement_document_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          }
        },
        "corporate/bulk/request/agreement_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación"
        },
        "corporate/company": {
          "created_at": "Fecha de creación",
          "identifier": "Identificador de la empresa",
          "is_ours": "¿Esta empresa es administrada por tu organización?",
          "legal_representative_email": "Email del representante legal",
          "legal_representative_name": "Nombre del representante legal",
          "manager_email": "Email del gestor",
          "name": "Nombre de la empresa"
        },
        "corporate/company_config": {
          "legal_representative_email": "Email del representante legal",
          "legal_representative_name": "Nombre del representante legal",
          "manager_email": "Correo electrónico gestor",
          "name": "Nombre de la empresa"
        },
        "corporate/controldoc_form/document": {
          "aasm_state": {
            "filled": "Completado",
            "one": "Estado",
            "partially_filled": "En proceso",
            "pending": "Pendiente"
          },
          "controldoc_state": "Estado de firma:",
          "created_at": "Fecha de creación",
          "created_by_id": "Creado por",
          "email": "Nombre"
        },
        "corporate/document_type_batteries": {
          "created_at": "Fecha de creación",
          "name": "Nombre de la batería de documentos"
        },
        "crm/budget": {
          "aasm_state": {
            "draft": "Borrador",
            "one": "Estado",
            "sent": "Enviada"
          },
          "budget_template_id": "Plantilla",
          "created_at": "Creado en",
          "discount_percentage": "Porcentaje de descuento",
          "email_body": "Cuerpo del email",
          "email_subject": "Asunto del email",
          "expires_at": "Expira en"
        },
        "crm/budget_product": {
          "order": "Orden",
          "price": "Precio",
          "quantity": "Cantidad",
          "title": "Título"
        },
        "crm/budget_product_template": {
          "order": "Orden",
          "price": "Precio",
          "quantity": "Cantidad",
          "title": "Título"
        },
        "crm/budget_template": {
          "created_at": "Creado en",
          "email_body": "Cuerpo del email",
          "email_subject": "Asunto del email",
          "title": "Título"
        },
        "crm/lead": {
          "aasm_state": {
            "budget_pending": "Presupuesto pendiente",
            "budget_sent": "Presupuesto enviado",
            "closed": "Cerrado",
            "discarded": "Descartado",
            "lost": "Perdido",
            "one": "Estado",
            "pending": "Pendiente",
            "tour_sent": "Tour enviado"
          }
        },
        "custom_field": {
          "code": "Código",
          "created_at": "Fecha de creación",
          "data_type": "Tipo de dato",
          "date_format": "Formato de la fecha",
          "format": "Formato",
          "group_ids": "Roles con acceso",
          "group_name": "Nombre del grupo",
          "is_notification_email": "¿Usar como vía de comunicación?",
          "is_sensitive_data": "¿Usar como dato sensible?",
          "label": "Etiqueta",
          "list_options": "Lista de opciones",
          "order": "Orden",
          "resource_type": "Recurso",
          "show_as_name": "¿Usar como nombre?",
          "show_on_list": "¿Usar como lista?"
        },
        "customer": {
          "abstrct_module_ids": "Modulos",
          "adp_integration": "Habilitar integración ADP?",
          "attendance_control_system_name": "¿Cuál sistema de Control de Asistencia utilizas?",
          "attendance_control_system_name_help": "Nombre del sistema que utilizan en tu empresa para gestionar la asistencia. Si no cuentas con uno, escribe 'Ninguno'",
          "authorized_branch_layer": "Activar capa de gestión por sucursales",
          "authorized_document_types_layer": "Activar capa de gestión por tipos de documento",
          "billing_quote_resource_abstract_entity_enabled": "¿Habilitar entidades abstractas en histórico de consumo?",
          "billing_quote_resource_active_employee_enabled": "¿Habilitar trabajadores activos en histórico de consumo?",
          "billing_quote_resource_ecert_enrolled_enabled": "¿Habilitar F.E.A. enrolados en histórico de consumo?",
          "billing_quote_resource_ecert_single_use_enabled": "¿Habilitar F.E.A. un solo uso en histórico de consumo?",
          "billing_quote_resource_gb_used_enabled": "¿Habilitar gigabytes usados en histórico de consumo?",
          "billing_quote_resource_inactive_employee_enabled": "¿Habilitar trabajadores inactivos en histórico de consumo?",
          "billing_quote_resource_member_enabled": "¿Habilitar usuarios/miembros en histórico de consumo?",
          "billing_quote_resource_signature_certificate_enabled": "¿Habilitar certificados F.E.A. en histórico de consumo?",
          "billing_quote_resource_simple_signature_enabled": "¿Habilitar firmas simples en histórico de consumo?",
          "billing_quote_resource_storage_enabled": "¿Habilitar almacenamiento usado en histórico de consumo?",
          "calendars_work_schedules_enabled": "¿Habilitar calendario laboral?",
          "client_type_arauco": "¿Es Arauco?",
          "client_type_duoc": "¿Es Duoc?",
          "client_type_integra": "¿Es Integra?",
          "controldoc_ai_enabled": "¿Habilitar Chat IA?",
          "controldoc_api_enable_migration": "Habilitar para migración?",
          "controldoc_sign_api_customer_id": "ControldocSign CustomerId",
          "default_signer_automatic_signature_enabled": "¿Habilitar firma automática por defecto?",
          "demo_expires_at": "Fecha de expiración demo",
          "document_enable_notification_settings": "¿Activar configuración de notificaciones de documentos?",
          "document_validate_with_two_factor": "¿Requerir verificación en dos pasos para validar documentos?",
          "dt_document_type_enabled": "Habilitar configuración de tipo de documento DT (contrato/anexo)?",
          "dt_integration": "Habilitar integración DT?",
          "ecert_enable_enroll": "¿Habilitar enrolamiento en E-Cert?",
          "email_corporate_domains": "Dominios de correo corporativo",
          "email_display_name": "Nombre para mostrar en el correo electrónico",
          "email_from_local_part": "Parte local del correo electrónico",
          "enable_autofill_entity_fields": "Activar llenado automático de información desde Plantillas",
          "enable_create_abstract_entity_security_layer": "Habilitar crear entidades abstractas con capa de seguridad?",
          "enable_create_employee_security_layer": "Habilitar crear trabajadores con capa de seguridad?",
          "enable_fao": "Habilitar Firma Avanza?",
          "enable_migration_process": "En proceso de migración",
          "enable_reason_reject_private": "Activar motivo de rechazo de firma privada para el documento",
          "enabled_abstract_module": "¿Módulo abstracto habilitado?",
          "enabled_compliance_module": "¿Módulo Compliance habilitado?",
          "enabled_corporate_module": "¿Módulo corporativo habilitado?",
          "enabled_economic_crime_module": "¿Módulo Delitos económicos habilitado?",
          "enabled_karin_law_module": "¿Módulo Ley Karin habilitado?",
          "enabled_laboral_module": "¿Módulo laboral habilitado?",
          "inactive_reason": "Razón de desactivación cuenta",
          "industry": "Rubro Empresa",
          "name": "Nombre",
          "on_demo": "On Demo",
          "onboarding_process": "Proceso de onboarding",
          "only_abstract": "Habilitar solo modulo abstracto?",
          "payroll_system_name": "¿Cuál es tu sistema de ERP Remuneraciones?",
          "payroll_system_name_help": "Nombre del sistema que utilizan en tu empresa para gestionar los pagos de los colaboradores. Si no cuentas con uno, escribe 'Ninguno'",
          "primary_admin": "Administrador Principal",
          "primary_admin_help": "Esta persona será el contacto principal para actualizaciones, ofertas e información general de ControlDoc",
          "prospect": "Prospecto",
          "reason_to_user_controldoc": "Razon por la que el cliente prefiere ControlDoc",
          "security_layer": "Activar capa de seguridad",
          "skip_all_notifications": "¿Desactivar notificaciones?"
        },
        "customer_onboarding/comercial_condition": {
          "is_custom": "¿Es plan personalizado?"
        },
        "customer_onboarding/legal_representative": {
          "email": "Correo electrónico",
          "name": "Nombre"
        },
        "customer_onboarding/product": {
          "product_type": {
            "fea": "Firma Electrónica Avanzada",
            "gbs": "Espacio en disco",
            "one": "Tipos de productos",
            "other": "Otro",
            "users": "Usuarios"
          }
        },
        "customer_onboarding_process": {
          "aasm_state": {
            "accept_billing_account_step": "Completando información de facturación",
            "accept_comercial_conditions_step": "Aceptando condiciones comerciales",
            "accept_terms_and_conditions_step": "Aceptando términos y condiciones",
            "completed": "Completado",
            "one": "Estado"
          },
          "accept_billing_account": "Acepta la información de facturación",
          "accept_billing_account?": "¿Estás de acuerdo que la información de facturación es correcta?",
          "accept_comercial_conditions": "Acepta las condiciones comerciales",
          "accept_comercial_conditions?": "¿Estás de acuerdo con las condiciones comerciales del plan seleccionado?",
          "accept_terms_and_conditions": "Acepta los términos y condiciones",
          "accept_terms_and_conditions?": "¿Estás de acuerdo con los términos y condiciones?",
          "billing_account": "Información de facturación",
          "billing_account_completed_at": "Inforación de facturación completada el",
          "billing_account_completed_by": "Inforación de facturación completada por",
          "billing_account_invoice_ends_date": "Fecha ultima factura",
          "billing_account_invoice_period": "Periodo de facturación (meses)",
          "billing_account_invoice_start_date": "Fecha primera factura",
          "comercial_conditions": "Condiciones comerciales",
          "comercial_conditions_accepted_at": "Condiciones comerciales aceptada el",
          "comercial_conditions_accepted_by": "Condiciones comerciales aceptada por",
          "created_at": "Creado el",
          "customer": "Cliente",
          "general_conditions": "Condiciones Generales",
          "select_comercial_condition": "Seleccionar condición comercial",
          "selected_comercial_condition_id": "Condición comercial seleccionado",
          "seller_commission": "Comisión (%) del vendedor",
          "seller_email": "Correo electrónico del vendedor",
          "seller_information": "Información del vendedor",
          "seller_name": "Nombre del vendedor",
          "started_by_email": "Iniciado por",
          "terms_and_conditions_accepted_at": "Términos y condiciones aceptado el",
          "terms_and_conditions_accepted_by": "Términos y condiciones aceptado por",
          "terms_and_conditions_accepted_file": "Documento términos y condiciones"
        },
        "customer_success/interview": {
          "aasm_state": {
            "cancelled": "Cancelada",
            "completed": "Completada",
            "one": "Estado",
            "pending": "Pendiente"
          },
          "assessment": "Evaluación",
          "high": "Alta",
          "likert": "Satisfacción",
          "low": "Baja",
          "meeting_at": "Fecha de reunión",
          "normal": "Normal",
          "notes": "Notas",
          "priority": "Prioridad"
        },
        "default_bulk_request_config": {
          "template": "Plantilla",
          "template_id": "Plantilla"
        },
        "default_signer": {
          "automatic_signature": "¿Habilitar firma automática?",
          "automatic_signature_state": {
            "approved": "Aprobado",
            "disabled": "Deshabilitado",
            "one": "Estado de firma automática",
            "pending": "Pendiente",
            "rejected": "Rechazado"
          },
          "created_at": "Fecha de creación",
          "document": "Documento",
          "email": "Correo electrónico",
          "employee_sign": "Firma el trabajador",
          "first_surname": "Primer Apellido",
          "identification_number": "RUT",
          "last_surname": "Segundo Apellido",
          "name": "Nombre",
          "order": "Orden",
          "role": "Rol"
        },
        "document": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending_shortlist": "Pendiente Shortlist",
            "pending_sign": "Pendiente por firmar",
            "pending_to_fill": "Pendiente por llenar",
            "pending_upload": "Pendiente por subir",
            "processing_sign": "Procesando firma",
            "rejected": "Rechazado",
            "review_uploaded_file": "En revisión de archivo",
            "signature_expired": "Plazo de firma vencido",
            "signed_by_all": "Firmado",
            "uploaded": "Archivo subido"
          },
          "blocked_at": "Bloqueado el",
          "blocked_by_id": "Bloqueado por",
          "blocked_description": "Descripción",
          "controldoc_form_file": "Documento de ControlDoc Forms",
          "controldoc_sign_delete_error": "Error de eliminación",
          "controldoc_sign_integration_enabled": "¿Requiere integración con firma electrónica?",
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "document_type": "Tipo de documento",
          "document_type_battery": "Batería de documentos",
          "document_type_id": "Tipo de documento",
          "dt_triggered_integration": "Integración DT",
          "expired": "Caducado",
          "expires_at": "Caduca el",
          "file": "Documento",
          "file_size": "Tamaño",
          "generate_viewer_table": "¿Generar tabla de visadores?",
          "id": "ID",
          "in_force": "Vigente",
          "is_file_reviewed": "¿Está revisado?",
          "keep_format": "¿Mantener formato del archivo?",
          "label": "Nombre del documento",
          "migrated_from_external_platform": "Migrado desde plataforma externa",
          "openai_category": "IA Categorized",
          "openai_signature_deadline_at": "IA signature deadline",
          "rejected_reason": "Motivo de rechazo de documento",
          "rejection_notification_enabled": "¿Notificar rechazo de documento?",
          "rejection_notification_send_to_creator": "¿Notificar a creador?",
          "rejection_notification_send_to_signers": "¿Notificar a firmantes?",
          "require_fao": "¿Firmará con Firma Avanzada?",
          "require_signature_deadline": "¿Requiere fecha límite de firma?",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_upload_deadline": "¿Requiere fecha límite de subida?",
          "requires_expire": "¿Tiene caducidad?",
          "review": "Revisión del documento",
          "review_description": "Descripción",
          "signature_deadline_at": "Fecha límite de firma",
          "signers": "Firmantes",
          "to_expire": "Por caducar",
          "upload_deadline_at": "Fecha límite para subir documento",
          "with_expires_at": "Con fecha de expiración",
          "without_expires_at": "Sin fecha de expiración"
        },
        "document_compression": {
          "aasm_state": {
            "compressed": "Comprimido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "compressed_at": "Fecha de compresión",
          "document_ids": "Documentos",
          "documents": "Documentos",
          "expires_at": "Fecha de expiración",
          "requested_by": "Solicitado por",
          "zip_file": "Archivo comprimido"
        },
        "document_type": {
          "created_at": "Fecha de creación",
          "default_signers_help": "Establece firmantes por defecto a tu tipo de documento",
          "dt_hook_enabled": "¿Enlazar este tipo de documento con la Dirección del Trabajo?",
          "id": "ID",
          "name": "Nombre del tipo de documento",
          "number_days_to_expire_documents": "Número de días por expirar los documentos",
          "number_days_to_notify_signature_expire": "Número de días para notificar fecha límite de firma",
          "require_default_bulk_request_config": "¿Requiere configuración predeterminada?",
          "require_signers": "¿Requiere firmantes predeterminados?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_subscription_member": "¿Requiere notificar a otros miembros?"
        },
        "document_type_battery": {
          "created_at": "Fecha de creación",
          "name": "Nombre de la batería de documentos"
        },
        "document_type_signer": {
          "email": "Correo electrónico",
          "name": "Nombre",
          "order": "Orden",
          "role": "Rol en el documento"
        },
        "dt/bulk/load/annexe_record": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando",
            "waiting_server_status": "Esperando servidor"
          },
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "description": "Descripción",
          "file": "Documento"
        },
        "dt/bulk/load/contract_record": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando",
            "waiting_server_status": "Esperando servidor"
          },
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "description": "Descripción",
          "document": "Documento",
          "file": "Documento",
          "rut_company": "Rut de la empresa",
          "rut_person": "Rut del representante laboral",
          "title": "Título",
          "uniq_key": "Clave única"
        },
        "dt/credential": {
          "company_rut": "RUT de la empresa",
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "encrypted_password": "Clave encriptada",
          "manager_rut": "Rut",
          "password": "Clave",
          "representative_email": "Email del representante legal",
          "representative_phone_number": "Teléfono del representante legal",
          "representative_rut": "RUT del representante legal"
        },
        "dt/entity_integration": {
          "aasm_state": {
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando",
            "success": "Completado"
          },
          "annexe_date": "Fecha del anexo",
          "created_at": "Fecha de creación",
          "created_by": "Creado por"
        },
        "dt/mapping_field": {
          "employee_rut": "Rut Del Empleado",
          "field": "Campo DT",
          "source_method": "Valor"
        },
        "dt/record/info": {
          "employee_disability": "Discapacidad",
          "employee_disability_date": "Fecha situación discapacidad",
          "employee_email": "Correo electrónico",
          "employee_home_location_commune": "Comuna del domicilio",
          "employee_home_location_department_or_office": "Depto/Oficina del domicilio",
          "employee_home_location_region": "Región del domicilio",
          "employee_home_location_street": "Calle del domicilio",
          "employee_home_location_street_number": "Número del domicilio",
          "employee_invalidity": "Pensión invalidez",
          "employee_invalidity_date": "Fecha pensión invalidez",
          "employee_job_functions": "Funciones del cargo",
          "employee_nationality": "Nacionalidad",
          "employee_original_location_commune": "Comuna de procedencia",
          "employee_original_location_region": "Región de procedencia",
          "employee_phone_number": "Teléfono",
          "employee_position": "Cargo",
          "employee_rut": "RUT del trabajador",
          "hiring_contract_commune": "Comuna del contrato",
          "hiring_contract_end_date": "Fecha término contrato",
          "hiring_contract_est_rut": "RUT de la empresa usuaria (EST)",
          "hiring_contract_principal_rut": "RUT de la empresa principal",
          "hiring_contract_start_date": "Fecha inicio contrato",
          "hiring_contract_type": "Tipo de contrato",
          "hiring_contract_work_installation_type": "Tipo de instalación",
          "hiring_end_description": "Observaciones",
          "hiring_end_reason": "Causal de término de contrato",
          "hiring_other_stipulations": "Otras estipulaciones",
          "hiring_remuneration_and_allocation_clause": "Cláusula de remuneraciones y asignaciones",
          "hiring_remuneration_base_salary": "Sueldo base",
          "hiring_remuneration_gratification_type": "Tipo de gratificación",
          "hiring_remuneration_non_taxable_salary": "Sueldo no imponible",
          "hiring_remuneration_payment_method": "Forma de pago",
          "hiring_remuneration_payment_period": "Período de pago",
          "hiring_remuneration_taxable_salary": "Sueldo imponible",
          "hiring_work_location_commune": "Comuna del trabajo",
          "hiring_work_location_department_or_office": "Depto/Oficina del trabajo",
          "hiring_work_location_region": "Región del trabajo",
          "hiring_work_location_street": "Calle del trabajo",
          "hiring_work_location_street_number": "Número del trabajo",
          "hiring_working_days": "Días de trabajo",
          "hiring_working_days_count": "N° días de trabajo",
          "hiring_working_distribution_clause": "Cláusula de distribución",
          "hiring_working_distribution_system": "Sistema de distribución",
          "hiring_working_exceptional_resolution_date": "Fecha resolución excepcional",
          "hiring_working_exceptional_resolution_id": "ID resolución excepcional",
          "hiring_working_hours": "Duración horas semanales",
          "hiring_working_shift": "Horario y turnos",
          "hiring_working_sunday_rest_exception": "Excepción descanso dominical"
        },
        "dt/record/integration": {
          "aasm_state": {
            "completed": "Completado",
            "enqueued": "Encolado",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando",
            "waiting_approve": "Esperando Revisión"
          },
          "created_at": "Fecha de creación",
          "record": "Registro",
          "requested_by": "Solicitado por",
          "updated_at": "Fecha de actualización",
          "voucher_file": "Comprobante DT",
          "workflow_mode": {
            "base": "Registro de contracto/anexo",
            "one": "Flujo del proceso",
            "termination": "Término de contrato"
          },
          "workflow_step": {
            "dt_contract_termination_send": "Envío del termino de contracto a la DT",
            "dt_fetchexternalsourcedata": "Sincronización con fuente de datos externa",
            "dt_hiring_fetchinfo": "Obtención de información de la DT",
            "dt_login_credentialvalidation": "Validación de credenciales",
            "dt_middleware_syncrecordinfodata": "Sincronización con fuente de datos externa",
            "dt_record_info_create": "Creación de la información del registro",
            "dt_record_info_send": "Envío de información a la DT",
            "one": "Pasos del flujo de trabajo"
          }
        },
        "dt/setting/fetch_dt_info_request": {
          "alias": "Alias",
          "body": "Body (JSON)",
          "created_at": "Fecha de creación",
          "default": "Por defecto",
          "employee_rut_for_testing": "RUT del trabajador (solo para pruebas)",
          "headers": "Headers (JSON)",
          "query_params": "Query params (JSON)",
          "request_method": "Método",
          "url": "URL"
        },
        "ecert/bulk/signing": {
          "pin_code": "Creado por",
          "skip_signed_document_notification": "No deseo recibir mas notificaciones de estos documentos"
        },
        "ecert/signature_certificate": {
          "created_at": "Creado el",
          "created_by": "Creado por",
          "email": "Correo electrónico",
          "enrolled": "Certificado enrolado?",
          "enrolled_at": "Enrolado el",
          "first_name": "Nombre",
          "first_surname": "Primer Apellido",
          "identification_number": "RUT",
          "identification_type": "Tipo de Identificación",
          "last_surname": "Segundo Apellido"
        },
        "economic_crime/workflow/requirement": {
          "complaint_type": {
            "anonymous": "Anónima",
            "identified": "Identificada",
            "one": "Tipo de denuncia"
          },
          "informer_email": "Correo electrónico",
          "informer_identification_number": "Número de identificación",
          "informer_identification_type": {
            "one": "Tipo de identificación",
            "passport": "Pasaporte",
            "rut": "RUT"
          },
          "informer_name": "Nombre"
        },
        "email_provider/smtp_account": {
          "active": "Activa",
          "address": "Servidor",
          "authentication": "Autenticación",
          "created_at": "Fecha de creación",
          "customer": "Cliente",
          "customer_id": "Cliente",
          "deleted_at": "Fecha de eliminación",
          "domain": "Dominio",
          "enable_starttls_auto": "STARTTLS automático",
          "is_default": "Predeterminada",
          "ownership": "Propiedad",
          "password": "Contraseña",
          "port": "Puerto",
          "provider": "Proveedor",
          "updated_at": "Fecha de actualización",
          "user_name": "Usuario"
        },
        "email_provider/smtp_account/ownership": {
          "controldoc": "ControlDoc",
          "customer": "Cliente"
        },
        "entity": {
          "created_at": "Fecha de creación",
          "entity_id": "ENTITY ID",
          "id": "ID",
          "identifier": "Identificador",
          "security_layer_id": "Capa de Seguridad"
        },
        "entity_folder/check_list": {
          "allow_new_requirements": "Habilitar adición de otros documentos",
          "created_at": "Fecha de creación",
          "name": "Nombre",
          "parent_folder": "Carpeta padre",
          "parent_folder_id": "Carpeta padre"
        },
        "entity_folder/check_list_requirement": {
          "allow_clone": "¿Habilitar añadir nuevo documento?",
          "created_at": "Fecha de creación",
          "deadline_upload_at": "Fecha límite de subida",
          "deadline_upload_notification_at": "Días para iniciar notificaciones",
          "document_type": "Tipo de documento",
          "document_type_id": "Tipo de documento",
          "folder": "Carpeta",
          "is_recurrent": "¿Es recurrente?",
          "name": "Nombre",
          "recurrence_deadline_upload_days": "Días límite de subida",
          "recurrence_end_at": "Término de recurrencia",
          "recurrence_period": {
            "biweekly": "Quicenal",
            "monthly": "Mensual",
            "one": "Período de recurrencia"
          },
          "recurrence_start_at": "Comienzo de recurrencia",
          "require_deadline_upload": "¿Requiere deadline?",
          "template": "Plantilla"
        },
        "entity_folder/check_list_shared": {
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "created_by_id": "Creado por",
          "entity": "Recurso",
          "entity_id": "Recurso",
          "name": "Nombre",
          "notify_to": "Notificar a",
          "shared_access": {
            "one": "Método de acceso",
            "with_password": "Con contraseña",
            "without_password": "Sin contraseña"
          },
          "shared_link": "Enlace",
          "shared_method": {
            "one": "Compartir",
            "public": "Enlace",
            "user_email": "Correo electrónico"
          },
          "shared_password": "Contraseña",
          "shared_password_confirmation": "Confirmación de contraseña"
        },
        "entity_folder/check_list_task": {
          "aasm_state": {
            "approved": "Aprobado",
            "one": "Estado de tarea",
            "pending_review": "Pendiente por revisar",
            "pending_upload": "Pendiente por subir",
            "rejected": "Rechazado",
            "returned": "Solicitado nuevamente"
          },
          "created_at": "Fecha de creación",
          "document": "Documento",
          "file": "Archivo",
          "observations": "Observaciones",
          "uploaded_at": "Fecha de carga de archivo"
        },
        "fao/mapping_config": {
          "created_at": "Fecha de creación",
          "created_by": "Creado por"
        },
        "fao/mapping_field": {
          "email": "Correo electrónico",
          "fao_var": "Campo Firma Avanzada",
          "first_surname": "Primer Apellido",
          "identification_number": "RUT",
          "last_surname": "Segundo Apellido",
          "name": "Nombre",
          "resource_attribute": "Atributo",
          "resource_class": "Módulo / Recurso"
        },
        "group": {
          "created_at": "Fecha de creación",
          "memberships": "Miembros",
          "name": "Nombre del rol"
        },
        "karin_law/complaint": null,
        "karin_law/workflow/requirement": {
          "complaint_reason": {
            "one": "Motivo de denuncia",
            "sexual_harassment": "Acoso Sexual",
            "workplace_harassment": "Acoso Laboral",
            "workplace_violence": "Violencia en el Trabajo"
          },
          "perpetrator_email": "Correo electrónico del denunciado/a",
          "perpetrator_full_name": "Nombre del denunciado/a",
          "perpetrator_name": "Nombre completo del denunciado/a",
          "reported_by": {
            "one": "Reportado por",
            "representative": "Representante",
            "victim": "Afectado"
          },
          "representative_email": "Correo electrónico del representante",
          "representative_full_name": "Nombre del representante",
          "representative_identification_number": "RUT del representante",
          "representative_name": "Nombre completo del representante",
          "victim_email": "Correo electrónico del afectado/a",
          "victim_full_name": "Nombre del afectado/a",
          "victim_identification_number": "RUT del afectado/a",
          "victim_name": "Nombre completo del afectado/a"
        },
        "laboral/bulk/load/arauco/docx_merge_field": {
          "aasm_state": {
            "completed": "Completado",
            "completed_errors": "Completado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "bulk_errors": "Errores",
          "created_at": "Fecha creación",
          "created_by": "Creado por",
          "data_file": "Archivo datos",
          "document_type": "Tipo de documento",
          "label": "Nombre del documento",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "template_file": "Archivo plantilla"
        },
        "laboral/bulk/load/arauco/docx_merge_field_item": {
          "aasm_state": {
            "completed": "Completado",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          }
        },
        "laboral/bulk/load/employee": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con Errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "file": "Documento"
        },
        "laboral/bulk/load/hiring": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "file_excel": "Documento",
          "hiring_identifier": "Identificador"
        },
        "laboral/bulk/load/hiring_document": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "created_by": "Creado por",
          "document_type": "Tipo de documento",
          "enable_controldoc_integration": "¿Requiere integración con firma electrónica?",
          "expires_at": "Caduca el",
          "hirings": "Contrataciones",
          "label": "Nombre del documento",
          "require_signature_deadline": "¿Requiere fecha límite de firma?",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "requires_expire": "¿Tiene caducidad?",
          "signature_deadline_at": "Fecha límite de firma"
        },
        "laboral/bulk/load/hiring_document_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          }
        },
        "laboral/bulk/load/hiring_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Con errores",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "branch_name": "Sucursal",
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "employee_name": "Trabajador",
          "end_date": "Fecha termino",
          "hiring_identifier": "Identificador",
          "start_date": "Fecha inicio"
        },
        "laboral/bulk/notification/sign": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "notified_by": "Solicitado por"
        },
        "laboral/bulk/notification/sign_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "document_id": "Documento",
          "document_type": "Tipo de documento",
          "email": "Correo electrónico",
          "name": "Nombre",
          "signer_id": "Firmante"
        },
        "laboral/bulk/request/destroy_employee": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "requested_by": "Solicitado por"
        },
        "laboral/bulk/request/hiring_document": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación",
          "is_scheduled": "Programar el envío de los documentos",
          "requested_by": "Solicitado por",
          "scheduled_at": "Programado para"
        },
        "laboral/bulk/request/hiring_document_config": {
          "completed_by_entity": "Autocompletar con información disponible.",
          "completed_by_entity_help": "El sistema completará automáticamente los datos disponibles en ControlDoc y el firmante completará la información faltante.",
          "completed_by_system": "Autocompletar automáticamente.",
          "completed_by_system_help": "El sistema completará TODAS las variables configuradas en la plantilla con los datos disponibles en ControlDoc.",
          "completed_by_third_party": "Permitir que otra persona complete los datos.",
          "completed_by_third_party_help": "Un tercero podrá ingresar toda la información requerida en el documento.",
          "document_type_battery": "Utiliza una batería de documentos",
          "document_type_id": "Tipo de Documento",
          "expires_at": "Caduca el",
          "expires_at_help": "La fecha en que el documento caducará.",
          "expires_at_label": "Fecha de expiración",
          "file": "Archivo",
          "label": "Nombre",
          "require_signature_deadline": "¿Requiere fecha límite de firma?",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_upload_deadline": "¿Requiere fecha límite de subida?",
          "requires_expire": "¿Tiene caducidad?",
          "shortlist_project_id": "Proyecto Shortlist",
          "signature_deadline_at": "Fecha límite de firma",
          "templates": "Plantillas",
          "third_party_email": "Correo electrónico",
          "upload_deadline_at": "Fecha límite de subida",
          "uploaded_by": {
            "one": "",
            "upload_controldoc_form": "Utilizar plantilla de documento",
            "upload_file_employee": "Solicitar documento al trabajador",
            "upload_file_user": "Subir Documento",
            "upload_shortlist_project": "Generar el documento mediante Shortlist"
          }
        },
        "laboral/bulk/request/hiring_document_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          }
        },
        "laboral/bulk/request/hiring_item": {
          "aasm_state": {
            "completed": "Procesado",
            "completed_errors": "Procesado con errores",
            "failed": "Fallido",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Fecha creación"
        },
        "laboral/document_type": {
          "completed_by_entity": "¿Deseas que el sistema autocomplete las variables que se encuentran homologadas en ControlDoc y que el firmante complete las que no se encuentran homologadas?",
          "completed_by_system": "¿Deseas que el sistema autocomplete TODAS las variables homologadas de la plantilla?",
          "completed_by_third_party": "¿Deseas que otra persona complete las variables faltantes?",
          "created_at": "Fecha de creación",
          "default_signers_help": "Establece firmantes por defecto a tu tipo de documento",
          "membership_subscribed": "Miembros a notificar",
          "name": "Nombre del tipo de documento",
          "number_days_to_expire_documents": "Número de días por expirar los documentos",
          "require_default_bulk_request_config": "¿Requiere configuración predeterminada?",
          "require_signers": "¿Requiere firmantes predeterminados?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_subscription_member": "¿Requiere notificar a otros miembros?",
          "third_party_email": "Correo electrónico",
          "uploaded_by": {
            "one": "",
            "upload_controldoc_form": "Utilizar plantilla de documento",
            "upload_file_employee": "Solicitar documento al trabajador",
            "upload_file_user": "Subir Documento"
          }
        },
        "laboral/document_type_batteries": {
          "created_at": "Fecha de creación",
          "name": "Nombre de la batería de documentos"
        },
        "laboral/employee": {
          "created_at": "Fecha de creación",
          "customer": "Cliente",
          "customer_id": "Cliente",
          "deleted_at": "Fecha de eliminación",
          "email": "Correo electrónico del trabajador",
          "hiring_status": "Estado de contratación",
          "id": "ID",
          "identifier": "Identificador del trabajador",
          "name": "Nombre del trabajador",
          "security_layer_id": "Capa de Seguridad"
        },
        "laboral/employee_config": {
          "customer_id": "Cliente",
          "deleted_at": "Fecha de eliminación",
          "email": "Correo electrónico",
          "id": "ID",
          "name": "Nombre del trabajador"
        },
        "laboral/employee_document": {
          "entity": "Trabajador",
          "entity_id": "Trabajador"
        },
        "laboral/employee_email_change": {
          "aasm_state": "Estado",
          "created_at": "Fecha",
          "created_by": "Realizado por",
          "documents_action": "Acción sobre documentos",
          "new_email": "Correo Nuevo",
          "old_email": "Correo Actual",
          "recreate_documents": "Recrear documentos"
        },
        "laboral/employee_requirement_type": {
          "created_at": "Fecha de creación",
          "name": "Nombre"
        },
        "laboral/hiring": {
          "branch": "Sucursal",
          "company": "Empresa",
          "company_identifier": "Identificador de la Empresa",
          "company_name": "Nombre de la Empresa",
          "created_at": "Fecha de creación",
          "custom_fields": "Campos personalizados",
          "delete": "Eliminar",
          "employee": "Trabajador",
          "employee_email": "Correo electrónico",
          "employee_name": "Nombre del trabajador",
          "end_date": "Fecha fin",
          "identifier": "Identificador de la contratación",
          "start_date": "Fecha inicio",
          "state": {
            "active": "Activas",
            "expired": "Inactivas",
            "to_expire": "Por vencer"
          }
        },
        "laboral/hiring_config": {
          "branch_id": "Sucursal",
          "company_id": "Empresa",
          "employee_id": "Trabajador",
          "end_date": "Fecha fin",
          "identifier": "Identificador",
          "start_date": "Fecha inicio"
        },
        "laboral/hiring_document": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending_shortlist": "Pendiente Shortlist",
            "pending_sign": "Pendiente por firmar",
            "pending_to_fill": "Pendiente por llenar",
            "pending_upload": "Pendiente por subir",
            "processing_sign": "Procesando firma",
            "rejected": "Rechazado",
            "review_uploaded_file": "En revisión de archivo",
            "signature_expired": "Plazo de firma vencido",
            "signed_by_all": "Firmado",
            "uploaded": "Archivo subido"
          },
          "blocked_at": "Bloqueado el",
          "blocked_by_id": "Bloqueado por",
          "blocked_description": "Descripción",
          "controldoc_form_file": "Documento de ControlDoc Forms",
          "controldoc_sign_delete_error": "Error de eliminación",
          "controldoc_sign_integration_enabled": "¿Requiere integración con firma electrónica?",
          "created_at": "Fecha de creación",
          "document_type": "Tipo de documento",
          "document_type_id": "Tipo de documento",
          "employee": "Trabajador",
          "entity": "Contratación",
          "entity_id": "Contratación",
          "expired": "Caducado",
          "expires_at": "Caduca el",
          "file": "Documento",
          "file_size": "Tamaño",
          "in_force": "Vigente",
          "is_file_reviewed": "¿Está revisado?",
          "label": "Nombre del documento",
          "no_file": "Sin archivo",
          "rejected_reason": "Motivo de rechazo de documento",
          "require_fao": "¿Firmará con Firma Avanzada?",
          "require_signature_deadline": "¿Requiere fecha límite de firma?",
          "require_signers": "¿Requiere firmantes?",
          "require_signers_order": "¿Requiere orden de firmantes?",
          "require_upload_deadline": "¿Requiere fecha límite de subida?",
          "requires_expire": "¿Tiene caducidad?",
          "review_description": "Descripción",
          "signature_deadline_at": "Fecha límite de firma",
          "signers": "Firmantes",
          "template_id": "Plantilla",
          "to_expire": "Por caducar",
          "upload_deadline_at": "Fecha límite para subir documento",
          "with_expires_at": "Con fecha de expiración",
          "without_expires_at": "Sin fecha de expiración"
        },
        "laboral/shortlist/mapping_field": {
          "resources": {
            "laboral_employee": "Trabajador",
            "laboral_hiring": "Contratación",
            "one": "Recurso"
          }
        },
        "membership": {
          "created_at": "Fecha de creación",
          "group_id": "Rol",
          "is_admin": "Es Administrador",
          "is_developer": "Es desarrollador",
          "is_internal": "Es usuario de ControlDoc",
          "is_oauth_admin": "Es administrador de OAuth",
          "is_onboarding_process_responsible": "Es responsable del proceso de onboarding",
          "is_primary": "Es administrador principal",
          "user_email": "Usuario"
        },
        "nps/record": {
          "created_at": "Creado el",
          "created_by": "Creado por",
          "description": "Descripción",
          "name": "Nombre",
          "period": "Periodo (días)",
          "resource": "Recurso",
          "scale": "Escala",
          "start_at": "Comienza el",
          "updated_at": "Actualizado el"
        },
        "nps/result": {
          "observations": "Indique los motivos de la puntuación."
        },
        "portal/configuration": {
          "background_image": "Imagen de fondo",
          "bg_position_x": "Alinear imagen de fondo",
          "brand_color": "Color de marca",
          "custom_welcome_text": "Texto de Bienvenida",
          "enable_checklist_shared_processes": "",
          "enable_compliance": "¿Habilitar tareas de cumplimiento?",
          "enable_documents": "¿Habilitar la bandeja de documentos?",
          "enable_gradient_bg": "Activar efecto oscuro sobre la imagen de fondo",
          "enable_sign_documents": "¿Habilitar para firmar documentos?",
          "enable_sso_microsoft": "¿Habilitar SSO Microsoft?",
          "enable_workflow_requirements": "¿Habilitar requerimientos de Workflow?",
          "exception_use_personal_email": "¿Aplicar excepción SQL a la obligatoriedad de correo personal?",
          "exception_use_personal_email_sql": "Consulta SQL de excepción",
          "force_to_use_personal_email": "¿Modal de cambio de correo obligatorio?",
          "is_active": "¿Activar portal?",
          "logo": "Logo",
          "require_use_personal_email": "¿Habilitar cambio de correo corporativo a personal?",
          "tenant": "Nombre del portal",
          "watermark_color": "Color de marca de Agua ControlDoc"
        },
        "report": {
          "aasm_state": {
            "completed": "Completado",
            "one": "Estado",
            "pending": "Pendiente",
            "processing": "Procesando"
          },
          "created_at": "Solicitado el",
          "required_by": "Solicitado por"
        },
        "report/corporate/agreement_document": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending": "Pendiente",
            "rejected": "Rechazado",
            "signature_expired": "Plazo de firma vencido",
            "signed": "Firmado",
            "signed_by_all": "Firmado por todos",
            "uploaded": "Archivo subido"
          }
        },
        "report/corporate/signer": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending": "Pendiente",
            "rejected": "Rechazado",
            "signature_expired": "Plazo de firma vencido",
            "signed": "Firmado",
            "signed_by_all": "Firmado por todos",
            "uploaded": "Archivo subido"
          }
        },
        "report/laboral/hiring": {
          "company": "Empresa",
          "company_identifier": "Identificador de la Empresa",
          "company_name": "Nombre de la Empresa",
          "created_at": "Fecha de creación",
          "custom_fields": "Campos personalizados",
          "delete": "Eliminar",
          "employee": "Trabajador",
          "employee_email": "Correo electrónico",
          "employee_name": "Nombre del trabajador",
          "end_date": "Fecha fin",
          "identifier": "Identificador de la contratación",
          "start_date": "Fecha inicio",
          "state": {
            "active": "Activas",
            "expired": "Inactivas"
          }
        },
        "report/laboral/hiring_document": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending": "Pendiente",
            "rejected": "Rechazado",
            "signature_expired": "Plazo de firma vencido",
            "signed": "Firmado",
            "signed_by_all": "Firmado por todos",
            "uploaded": "Archivo subido"
          }
        },
        "report/laboral/signer": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "one": "Estado",
            "partially_signed": "Firmado parcialmente",
            "pending": "Pendiente",
            "rejected": "Rechazado",
            "signature_expired": "Plazo de firma vencido",
            "signed": "Firmado",
            "signed_by_all": "Firmado por todos",
            "uploaded": "Archivo subido"
          }
        },
        "security_layer": {
          "created_at": "Fecha de creación",
          "name": "Nombre de la capa de seguridad"
        },
        "shortlist/assessment_load": {
          "aasm_state": {
            "approved": "Aprobado",
            "discarded": "Descartado",
            "invited": "Invitado",
            "inviting": "Invitar",
            "one": "Estado"
          },
          "additional_attributes": "Atributos adicionales",
          "answers": "Respuestas",
          "created_at": "Fecha de creación",
          "date": "Fecha",
          "email": "Correo electrónico",
          "name": "Nombre",
          "phone": "Teléfono",
          "points": "Puntaje",
          "project_id": "Evaluación",
          "questions": "Preguntas"
        },
        "shortlist/mapping_config": {
          "created_at": "Fecha de creación",
          "created_by": "Creado por"
        },
        "shortlist/mapping_field": {
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "email": "Correo electrónico",
          "name": "Nombre",
          "phone": "Teléfono Celular"
        },
        "signer": {
          "aasm_state": {
            "blocked": "Bloqueado",
            "completed": "Completados",
            "one": "Estado",
            "pending": "Pendiente",
            "rejected": "Rechazado",
            "sign_skipped": "Firma omitida",
            "signed": "Firmado"
          },
          "client": "Cliente",
          "client_company_email": "Cliente",
          "company_email": "Correo electrónico de la empresa",
          "company_sign": "Firma la empresa",
          "created_at": "Fecha de solicitud",
          "current": "Firmante actual",
          "document": "Documento",
          "email": "Correo electrónico",
          "email_notification_sign": "Firma el correo electrónico del representante",
          "employee_sign": "Firma el trabajador",
          "first_surname": "Primer Apellido",
          "hide_signature_image": "Ocultar firma del documento",
          "identification_number": "RUT",
          "is_viewer": "¿Es visador?",
          "last_surname": "Segundo Apellido",
          "legal_rep_client": "Representante legal cliente",
          "legal_rep_provider": "Representante legal proveedor",
          "name": "Nombre",
          "order": "Orden",
          "provider": "Proveedor",
          "provider_company_email": "Proveedor",
          "require_identity_verification": "¿Requiere verificación de identidad?",
          "role": "Rol en el documento",
          "select_email_notification_sign": "Seleccionar firmante dentro de %{entityType}",
          "signature_mode": {
            "advance": "Firma Avanzada",
            "one": "Tipo de firma",
            "simple": "Firma Simple"
          },
          "signed_at": "Fecha de firma"
        },
        "signer_configuration": {
          "created_at": "Fecha de solicitud",
          "email": "Correo electrónico",
          "first_surname": "Primer Apellido",
          "identification_number": "RUT",
          "is_viewer": "¿Es visador?",
          "last_surname": "Segundo Apellido",
          "name": "Nombre",
          "order": "Orden",
          "role": "Rol en el documento"
        },
        "signer_group": {
          "document": "Documento",
          "minimun_signers": "Mínimo de firmantes",
          "name": "Nombre del grupo",
          "order": "Orden",
          "require_minimun_signers": "¿Requiere un mínimo de firmantes?",
          "signers": "Firmantes"
        },
        "signer_notification": {
          "document": "Documento",
          "notified_by": "Notificado por",
          "signer": "Firmante"
        },
        "unsubscribed/email": {
          "created_at": "Fecha de creación",
          "deleted_at": "Fecha de eliminación",
          "email": "Correo electrónico",
          "reason": "Razón",
          "resource": "Recurso",
          "resource_id": "ID del recurso",
          "resource_type": "Tipo de recurso",
          "updated_at": "Fecha de actualización"
        },
        "user": {
          "accept_personal_information_declaration": "Declaro que la información que he proporcionado es personal, verdadera, completa, correcta y fidedigna.",
          "address": "Dirección",
          "authentication_token": "Token de autenticación",
          "birthdate": "Fecha de nacimiento",
          "cellphone": "Teléfono Celular",
          "confirmation_sent_at": "Confirmación enviada a",
          "confirmation_token": "Código de confirmación",
          "confirmed_at": "Confirmado en",
          "controldoc_sign_api_token": "Controldoc Api Token",
          "created_at": "Fecha de creación",
          "current_password": "Contraseña actual",
          "current_sign_in_at": "Fecha del ingreso actual",
          "current_sign_in_ip": "IP del ingreso actual",
          "email": "Correo Electrónico",
          "encrypted_password": "Contraseña cifrada",
          "failed_attempts": "Intentos fallidos",
          "identification_number": "Número de identificación",
          "identification_type": {
            "one": "Tipo de identificación",
            "passport": "Pasaporte",
            "rut": "RUT"
          },
          "invitation_accepted_at": "Fecha de aceptación de invitación",
          "invitation_created_at": "Fecha de creación de invitación",
          "invitation_sent_at": "Fecha de envío de invitación",
          "invitation_token": "Token de invitación",
          "last_sign_in_at": "Fecha del último ingreso",
          "last_sign_in_ip": "IP del último inicio",
          "locked_at": "Fecha de bloqueo",
          "marital_status": {
            "civil_union": "Unión Civil",
            "divorced": "Divorciado/a",
            "married": "Casado/a",
            "one": "Estado Civil",
            "single": "Soltero/a",
            "widower": "Viudo/a"
          },
          "name": "Nombre Completo",
          "nationality": "Nacionalidad",
          "onboarding_process_token_confirmation": "Código",
          "password": "Contraseña",
          "password_confirmation": "Confirmación de la contraseña",
          "pin_code": "Pin de acceso",
          "remember_created_at": "Fecha de 'Recordarme'",
          "remember_me": "Recordarme",
          "reset_password_sent_at": "Fecha de envío de código para contraseña",
          "reset_password_token": "Código para restablecer contraseña",
          "sign_in_count": "Cantidad de ingresos",
          "signature_method": "Método de firma",
          "skip_document_notifications": "No quiero recibir notificaciones sobre documentos",
          "unconfirmed_email": "Email no confirmado",
          "unlock_token": "Código de desbloqueo",
          "updated_at": "Actualizado en"
        },
        "versioner/collaborator": {
          "user_email": "Correo electrónico"
        },
        "versioner/document/item": {
          "created_at": "Creado el",
          "created_by": "Creado por",
          "file": "Archivo"
        },
        "versioner/document/thread": {
          "created_at": "Creado el",
          "created_by": "Creado por",
          "items_count": "Número de versiones",
          "name": "Nombre"
        },
        "workflow/edge": {
          "enabled_source_file_item_overview_metadata": "¿Mostrar información vinculada de la etapa anterior?"
        },
        "workflow/group": {
          "group_users": "Emails de participantes",
          "name": "ROL",
          "users": "Emails de participantes"
        },
        "workflow/process": {
          "aasm_state": {
            "draft": "Borrador",
            "one": "Estado",
            "published": "Publicado"
          },
          "allowed_emails_to_see_ebooks": "Correos electrónicos permitidos para ver los ebooks",
          "assign_responsible_on_initial_stage": "¿Asignar responsable en la etapa inicial?",
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "created_by_id": "Creado por",
          "description": "Descripción",
          "disclaimer": "Términos de uso",
          "enabled_tracking_channel": "¿Mostrar canal de seguimiento?",
          "generate_ebook_automatically": "¿Quieres generar de forma automática un ebook al finalizar el proceso?",
          "identifier": "Identificador",
          "identifier_pattern": "Patrón de identificador",
          "limit_access_to_ebooks": "¿Quieres limitar el acceso a los ebooks del proceso?",
          "name": "Nombre",
          "require_custom_identifier": "¿Necesitas identificador personalizado para los requerimientos?",
          "require_disclaimer": "¿Requiere términos de uso?"
        },
        "workflow/requirement": {
          "accept_disclaimer": "Aceptar los Términos de uso",
          "created_at": "Fecha de creación",
          "current_requirement_stage": "Etapa actual",
          "customer": "Organización",
          "identifier": "Número de Seguimiento",
          "name": "Nombre",
          "process": "Proceso",
          "process_id": "Proceso",
          "review_status": {
            "finished": "Finalizados",
            "one": "Estado",
            "pending": "Pendientes"
          }
        },
        "workflow/requirement_ebook": {
          "aasm_state": {
            "draft": "Borrador",
            "one": "Estado",
            "published": "Publicado"
          },
          "created_at": "Fecha de creación",
          "created_by": "Creado por",
          "created_by_id": "Creado por",
          "id": "Versión"
        },
        "workflow/requirement_stage": {
          "aasm_state": {
            "completed": "Finalizado",
            "one": "Estado",
            "pending": "Pendiente",
            "proceeded": "Aceptado",
            "rejected": "Terminado",
            "returned": "Devuelto"
          },
          "completed_at": "Completado el",
          "created_at": "Fecha de creación",
          "current_requirement_stage": "Etapa actual",
          "deadline_stage_at": "Fecha límite de revisión",
          "interval_time_completed": "Tiempo de etapa",
          "observations": "Observaciones",
          "responsible": "Completada por",
          "review_status": {
            "one": "Estado",
            "pending": "Abiertos",
            "reviewed": "Revisados"
          },
          "stage_days_duration": "Duración de etapa (días)",
          "stage_name": "Etapa",
          "to_stage_authorized_emails": "La siguiente etapa la revisarán: ",
          "to_stage_id": {
            "one": "Siguiente Etapa",
            "to_proceeded": "Avanzar a",
            "to_returned": "Devolver a"
          }
        },
        "workflow/stage": {
          "body_request_content": "Body Request",
          "body_request_content_type": "Body Request Content Type",
          "calendar": "Calendario",
          "create_entity_on_approval": "Crear %{label} al aprobar etapa",
          "created_at": "Fecha de creación",
          "days_duration": "Duración de la etapa (días)",
          "description": "Descripción",
          "endpoint_url": "Endpoint URL",
          "header_request_content": "Header Request",
          "is_private_node": "¿Es una etapa privada?",
          "is_public": {
            "false": "¿Mediante rol específico?",
            "one": "Something",
            "true": "¿Cualquiera con el enlace?"
          },
          "name": "Nombre",
          "node_type": {
            "default": "Regular",
            "http_request": "HTTP Request",
            "input": "Entrada",
            "one": "Tipo de etapa",
            "output": "Salida",
            "shortlist": "Shortlist"
          },
          "request_method": "Método HTTP",
          "shortlist_project": "Projecto Shortlist"
        },
        "workflow/stage_field_item": {
          "data_type": {
            "cellphone": "Teléfono Celular",
            "date": "Fecha",
            "email": "Correo electrónico",
            "list": "Lista",
            "one": "Tipo de dato",
            "text": "Texto"
          },
          "group_name": "Grupo",
          "helping_text": "Texto de ayuda",
          "is_required": "¿Es obligatorio?",
          "list_option": "Lista de opciones",
          "name": "Nombre"
        },
        "workflow/stage_file_item": {
          "group_name": "Grupo",
          "helping_text": "Texto de ayuda",
          "is_required": "¿Es obligatorio?",
          "name": "Nombre",
          "template": "Documento plantilla"
        },
        "workflow/stage_form": null,
        "workflow/stage_output_file_item": {
          "document_type": "Tipo de documento",
          "document_type_id": "Tipo de documento"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "La validación falló: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
            "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
          }
        },
        "models": {
          "abstract/bulk/load/document": {
            "attributes": {
              "document_type": {
                "blank": "Debes seleccionar un tipo de documento",
                "required": "Debes seleccionar un tipo de documento"
              },
              "entities": {
                "blank": "Debe cargar al menos un documento"
              },
              "items": {
                "blank": "Debe cargar al menos un documento"
              },
              "signature_deadline_at": {
                "blank": "Debe ingresar la fecha de límite de firma",
                "invalid_date": "Debe ingresar la fecha de límite de firma",
                "on_or_after": "La fecha de límite de firma no puede ser anterior a la fecha actual"
              },
              "signers": {
                "at_least_one_signer": "Debes ingresar al menos un firmante que no sea un lector",
                "blank": "Debe ingresar al menos un firmante"
              }
            }
          },
          "abstract/bulk/load/document_item": {
            "attributes": null
          },
          "abstract/bulk/request/document": {
            "attributes": {
              "entity_items": {
                "blank": "Debe seleccionar al menos un registro"
              },
              "scheduled_at": {
                "invalid_datetime": "Debes ingresar una fecha y una hora válidas",
                "on_or_after": "La fecha debe ser mínimo 5 minutos después de la fecha y hora actual"
              }
            }
          },
          "abstract/bulk/request/document_config": {
            "attributes": {
              "custom_field": {
                "blank": "Debe selecciona una opción"
              },
              "custom_field_id": {
                "blank": "Debe seleccionar un representante"
              },
              "document_type_id": {
                "blank": "Debe seleccionar un tipo de documento"
              },
              "expires_at": {
                "blank": "Debe ingresar la fecha de caducidad",
                "invalid_date": "Debe ingresar la fecha de caducidad",
                "on_or_after": "La fecha de caducidad no puede ser anterior a la fecha actual"
              },
              "file": {
                "blank": "Debe subir un archivo"
              },
              "signature_deadline_at": {
                "blank": "Debe ingresar la fecha de límite de firma",
                "invalid_date": "Debe ingresar la fecha de límite de firma",
                "on_or_after": "La fecha de límite de firma no puede ser anterior a la fecha actual"
              },
              "signers": {
                "at_least_one_signer": "Debes ingresar al menos un firmante que no sea un lector",
                "blank": "Debe ingresar al menos un firmante"
              },
              "template": {
                "blank": "Debe seleccionar una plantilla"
              },
              "upload_deadline_at": {
                "blank": "Debe ingresar la fecha de límite de subida",
                "invalid_date": "Debe ingresar la fecha de límite de subida"
              }
            }
          },
          "abstract/bulk/request/document_item": {
            "attributes": {
              "config": {
                "required": "Problema al asignar la configuración"
              },
              "email_notification": {
                "empty": "El email de notificación del módulo '%{entity_type}' no puede estar vacío"
              },
              "responsible_entity": {
                "empty": "El '%{entity}', no esta asociado a un registro del módulo '%{entity_type}'"
              }
            }
          },
          "abstract/bulk/request/entity_item": {
            "attributes": {
              "entities": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "abstract/check_list/process": {
            "attributes": {
              "check_list_entities": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "abstract/custom_field": {
            "attributes": {
              "code": {
                "taken": "Ya éxiste uno con este Código"
              }
            }
          },
          "abstract/document": {
            "attributes": {
              "document_type_id": {
                "blank": "Debe seleccionar un tipo de documento",
                "no_related_entity_type": "Tipo de documento no corresponde al módulo %{module}"
              },
              "entity_id": {
                "blank": "Debe seleccionar un recurso",
                "no_related_entity_type": "El recurso no corresponde al módulo %{module}"
              },
              "expires_at": {
                "blank": "Debes ingresar la fecha de caducidad",
                "invalid_date": "Debes ingresar un formato válido para la fecha",
                "on_or_after": "La fecha de caducidad no puede ser menor a la fecha de creación"
              },
              "file": {
                "blank": "Debe cargar un documento"
              },
              "signature_deadline_at": {
                "invalid_date": "Debe ingresar la fecha de límite de firma",
                "on_or_after": "La fecha de límite de firma no puede ser anterior a la fecha actual"
              }
            }
          },
          "abstract/document_type": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar el nombre del tipo de documento",
                "taken": "El nombre del tipo de documento ya se encuentra en uso"
              }
            }
          },
          "abstract/entity": {
            "attributes": {
              "id": {
                "exist": "El id %{controldoc_id} no se encuentra en la base de datos"
              },
              "identifier": {
                "blank": "Debes ingresar el identificador %{entity}",
                "taken": "El identificador ya se encuentra en uso"
              },
              "related_entities": {
                "blank": "Debe ingresar el recurso del módulo %{module}"
              }
            }
          },
          "abstract/entity_config": {
            "attributes": {
              "entity_id": {
                "entity_no_related": "El recurso seleccionado no corresponde a la relación del módulo %{module}",
                "entity_type_no_related": "El tipo de entidad relacionada con corresponde"
              }
            }
          },
          "abstract/entity_type": {
            "attributes": null
          },
          "abstract/entity_type_config": {
            "attributes": {
              "entity_type": {
                "same_customer": "Los dos tipos de entidades deben ser del mismo cliente"
              }
            }
          },
          "abstract/report/document": {
            "attributes": null
          },
          "abstract/report/signer": {
            "attributes": null
          },
          "billing/account": {
            "attributes": {
              "company_address": {
                "blank": "Debe ingresar la dirección de la empresa"
              },
              "company_name": {
                "blank": "Debe ingresar el nombre de la empreas"
              },
              "contact_email": {
                "blank": "Debe ingresar el correo electrónico del contacto"
              },
              "contact_name": {
                "blank": "Debe ingresar el nombre del contacto"
              },
              "contact_phone": {
                "blank": "Debe ingresar el teléfono de contacto"
              },
              "invoice_period": {
                "blank": "Debe ingresar el periodo de facturación"
              },
              "invoice_start_date": {
                "blank": "Debe ingresar la fecha de facturación"
              },
              "tax_id": {
                "blank": "Debe ingresar la identificación de la empresa"
              }
            }
          },
          "blog/post": {
            "attributes": {
              "cover_image": {
                "blank": "debe estar presente",
                "content_type_invalid": "debe ser un formato de imagen válido (JPG, PNG, JPEG)",
                "file_size_not_less_than": "debe pesar menos de 5MB"
              }
            }
          },
          "bulk/datatable/distribution_list_filter": {
            "attributes": {
              "filters": {
                "blank": "Debes ingresar al menos un filtro"
              },
              "name": {
                "blank": "Debes ingresar el nombre de la lista de distribución",
                "taken": "El nombre de la lista de distribución ya está en uso"
              }
            }
          },
          "bulk/my_filter": {
            "attributes": {
              "name": {
                "blank": "Debes ingresar un nombre"
              }
            }
          },
          "bulk/notification/fill": {
            "attributes": {
              "fill_items": {
                "blank": "Debe seleccionar al menos un formulario pendiente por llenar"
              }
            }
          },
          "bulk/notification/fill_item": {
            "attributes": {
              "controldoc_form_documents": {
                "blank": "Debe seleccionar al menos un formulario"
              }
            }
          },
          "bulk/notification/sign": {
            "attributes": {
              "sign_items": {
                "blank": "Debe seleccionar al menos una firma pendiente"
              }
            }
          },
          "bulk/notification/sign_item": {
            "attributes": {
              "signs": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "bulk/rejection": {
            "attributes": {
              "bulk_rejection_documents": {
                "too_short": "Debes seleccionar al menos un documento"
              },
              "description": {
                "blank": "Debes agregar una descripción"
              },
              "otp_code_token": {
                "invalid": "El Pin es invalido"
              }
            }
          },
          "bulk/request/destroy_document": {
            "attributes": {
              "items": {
                "blank": "Debe seleccionar al menos un documento para Eliminar"
              }
            }
          },
          "bulk/request/destroy_document_item": {
            "attributes": {
              "documentos": {
                "blank": "Debe seleccionar al menos un documento"
              }
            }
          },
          "bulk/request/zip/document": {
            "attributes": {
              "items": {
                "blank": "Debe seleccionar al menos un documento para descargar"
              }
            }
          },
          "bulk/request/zip/document_item": {
            "attributes": {
              "documentos": {
                "blank": "Debe seleccionar al menos un documento"
              }
            }
          },
          "bulk/signing": {
            "attributes": {
              "bulk_signing_documents": {
                "too_short": "Debes seleccionar al menos un documento"
              },
              "otp_code_token": {
                "invalid": "El Pin es invalido"
              }
            }
          },
          "bulk_signer_config": {
            "attributes": {
              "email": {
                "blank": "Debe ingresar el correo electrónico",
                "duplicate": "El correo electrónico no se puede repetir",
                "invalid_format": "Debe ingresar un correo electrónico válido"
              },
              "first_surname": {
                "blank": "Debe ingresar el Primer Apellido."
              },
              "identification_number": {
                "blank": "Debe ingresar el RUT",
                "duplicate": "El RUT no se puede repetir"
              },
              "last_surname": {
                "blank": "Debe ingresar el Segundo Apellido"
              },
              "name": {
                "blank": "Debe ingresar el nombre"
              },
              "role": {
                "blank": "Debe ingresar el rol"
              }
            }
          },
          "calendar/work_schedule": {
            "attributes": {
              "business_days": {
                "blank": "Debes ingresar los días laborales del calendario laboral"
              },
              "description": {
                "blank": "Debes ingresar la descripción del calendario laboral"
              },
              "end_time": {
                "blank": "Debes ingresar la hora de fin del calendario laboral",
                "on_or_after": "La hora de fin debe ser después de la hora de inicio"
              },
              "start_time": {
                "blank": "Debes ingresar la hora de inicio del calendario laboral"
              },
              "title": {
                "blank": "Debes ingresar el título del calendario laboral"
              }
            }
          },
          "check_list/process": {
            "attributes": {
              "check_list_document_types": {
                "blank": "Debe seleccionar al menos un tipo de documento"
              },
              "check_list_entities": {
                "blank": "Debe seleccionar al menos una entidad"
              },
              "name": {
                "blank": "Debe ingresar el nombre del check list"
              }
            }
          },
          "check_list/tasks": null,
          "comment": {
            "attributes": {
              "body": {
                "blank": "Debes ingresar un comentario"
              }
            }
          },
          "communication_channel": {
            "attributes": null
          },
          "compliance/activity": {
            "attributes": {
              "description": {
                "blank": "Debes agregar una descripción"
              },
              "name": {
                "blank": "Debes agregar un nombre"
              },
              "recurrence": {
                "blank": "Debes seleccionar la recurrencia de la actividad."
              },
              "risk_level": {
                "required": "Debes seleccionar un nivel de riesgo"
              },
              "start_date": {
                "blank": "Debes agregar una fecha de inicio",
                "invalid_datetime": "La fecha de inicio no puede ser mayor a la fecha de cumplimiento",
                "on_or_before": "La fecha de inicio no puede ser mayor a la fecha de cumplimiento"
              }
            }
          },
          "compliance/activity_container": {
            "attributes": {
              "name": {
                "blank": "Debes agregar un nombre"
              }
            }
          },
          "compliance/activity_group": {
            "attributes": {
              "name": {
                "blank": "Debes agregar un nombre"
              }
            }
          },
          "compliance/activity_group_check": {
            "attributes": {
              "action": {
                "blank": "La acción es obligatoria"
              },
              "activity_group_id": {
                "blank": "El grupo revisor es obligatorio"
              },
              "checked_by": {
                "blank": "El revisor es obligatorio",
                "taken": "Ya revisó esta evidencia como parte de este grupo"
              },
              "comment": {
                "blank": "Debe ingresar una observación en caso de rechazar"
              }
            }
          },
          "compliance/context": {
            "attributes": {
              "name": {
                "blank": "Debes agregar un nombre",
                "taken": "El cliente ya tiene un módulo con este nombre"
              }
            }
          },
          "compliance/custom_field": {
            "attributes": {
              "code": {
                "taken": "Ya éxiste uno con este Código"
              }
            }
          },
          "compliance/evidence": {
            "attributes": {
              "is_recurrent": {
                "not_allowed": "No puede ser recurrente si el documento principal no es recurrente"
              },
              "name": {
                "blank": "Debes agregar un nombre",
                "taken": "El nombre de la evidencia ya se encuentra en uso"
              }
            }
          },
          "compliance/evidence_file": {
            "attributes": {
              "name": {
                "blank": "Debes agregar un nombre"
              }
            }
          },
          "compliance/evidence_load": {
            "attributes": {
              "name": {
                "blank": "Debes agregar un nombre"
              }
            }
          },
          "compliance/group": {
            "attributes": {
              "name": {
                "blank": "Debes agregar un nombre"
              }
            }
          },
          "compliance/reviewer_group": {
            "attributes": {
              "mandatory": {
                "single_reviewer_group_not_mandatory": "El grupo revisor no puede ser obligatorio si es el único grupo presente"
              }
            }
          },
          "compliance/risk_level": {
            "attributes": {
              "name": {
                "blank": "Debes agregar un nombre"
              }
            }
          },
          "controldoc_form/template": {
            "attributes": {
              "document_type_id": {
                "blank": "Debe seleccionar un tipo de documento"
              },
              "name": {
                "blank": "Debe ingresar el nombre de la plantilla",
                "taken": "El nombre de la plantilla ya se encuentra en uso"
              },
              "uploaded_file": {
                "blank": "Debe subir un archivo RTF",
                "invalid_type": "El archivo debe ser RTF",
                "invalid_variable": "Se detectaron variables inválidas en el archivo. Las variables deben estar entre % y % permitiendo solo letras, números, guión bajo y espacios. No use formato (como negrita, cursiva, etc.) dentro de la variable.",
                "too_large": "El archivo no debe superar %{max_mb} MB"
              },
              "vars": {
                "blank": "Debe existir al menos una variable para la plantilla"
              }
            }
          },
          "controldoc_form/template_layout": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar un nombre",
                "taken": "El nombre ya se encuentra en uso"
              }
            }
          },
          "controldoc_form/template_mapping_link": {
            "attributes": {
              "resource_attribute": {
                "invalid_custom_date": "Para seleccionar una fecha con formato personalizado, la variable debe ser de tipo 'text'"
              }
            }
          },
          "corporate/agreement": {
            "attributes": null
          },
          "corporate/agreement_config": {
            "attributes": {
              "client_id": {
                "blank": "Debes seleccionar la empresa cliente"
              },
              "provider_id": {
                "blank": "Debes seleccionar la empresa proveedora",
                "no_same_company": "El proveedor no puede ser igual a la empresa cliente"
              },
              "start_date": {
                "blank": "Debes ingresar la fecha de inicio del contrato",
                "invalid_date": "Debes ingresar un formato válido para la fecha",
                "on_or_before": "La fecha de inicio no puede ser mayor a la fecha de fin"
              }
            }
          },
          "corporate/agreement_document": {
            "attributes": {
              "document_type_id": {
                "blank": "Debe seleccionar un tipo de documeto"
              },
              "entity_id": {
                "blank": "Debe seleccionar un contrato"
              },
              "expires_at": {
                "blank": "Debes ingresar la fecha de caducidad",
                "invalid_date": "Debes ingresar un formato válido para la fecha",
                "on_or_after": "La fecha de caducidad no puede ser menor a la fecha de creación"
              },
              "file": {
                "blank": "Debe seleccionar un archivo"
              },
              "name": {
                "blank": "Debes ingresar el nombre del Proveedor"
              },
              "signature_deadline_at": {
                "invalid_date": "Debe ingresar la fecha de límite de firma",
                "on_or_after": "La fecha de límite de firma no puede ser anterior a la fecha actual"
              }
            }
          },
          "corporate/branch": {
            "attributes": {
              "company": {
                "required": "Debe seleccionar una empresa"
              },
              "identifier": {
                "taken": "El identificador ya se encuentra en uso"
              },
              "name": {
                "blank": "Debes ingresar el nombre de la sucursal",
                "taken": "El nombre de la sucursal ya se encuentra en uso"
              }
            }
          },
          "corporate/bulk/notification/sign": {
            "attributes": {
              "sign_items": {
                "blank": "Debe seleccionar al menos una firma pendiente"
              }
            }
          },
          "corporate/bulk/notification/sign_item": {
            "attributes": {
              "signs": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "corporate/bulk/request/agreement_document": {
            "attributes": {
              "agreement_items": {
                "blank": "Debe seleccionar al menos una contrato"
              },
              "scheduled_at": {
                "invalid_datetime": "Debes ingresar una fecha y una hora válidas",
                "on_or_after": "La fecha debe ser mínimo 5 minutos después de la fecha y hora actual"
              }
            }
          },
          "corporate/bulk/request/agreement_document_config": {
            "attributes": {
              "document_type_id": {
                "blank": "Debe seleccionar un tipo de documento"
              },
              "file": {
                "blank": "Debe subir un archivo"
              },
              "requested_to": {
                "blank": "Debe seleccionar un representante"
              },
              "signers": {
                "at_least_one_signer": "Debes ingresar al menos un firmante que no sea un lector",
                "blank": "Debe ingresar al menos un firmante"
              },
              "template": {
                "blank": "Debe seleccionar una plantilla"
              },
              "upload_deadline_at": {
                "blank": "Debe ingresar la fecha de límite de subida",
                "invalid_date": "Debe ingresar la fecha de límite de subida"
              }
            }
          },
          "corporate/bulk/request/agreement_document_item": {
            "attributes": {
              "config": {
                "required": "Problema al asignar la configuración"
              }
            }
          },
          "corporate/bulk/request/agreement_item": {
            "attributes": {
              "agreements": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "corporate/check_list/agreement_process": {
            "attributes": {
              "check_list_entities": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "corporate/company": {
            "attributes": {
              "config": "Se requiere completar información del representante legal",
              "identifier": {
                "blank": "Debes ingresar el identificador de la empresa",
                "taken": "El identificador ya se encuentra en uso"
              },
              "name": {
                "blank": "Debes ingresar el nombre de la empresa"
              }
            }
          },
          "corporate/company_config": {
            "attributes": {
              "name": {
                "blank": "Debes ingresar el nombre de la empresa"
              }
            }
          },
          "corporate/document_type_batteries": {
            "attributes": {
              "code": {
                "taken": "Ya éxiste una con este Código"
              }
            }
          },
          "custom_field": {
            "attributes": {
              "code": {
                "taken": "Ya éxiste uno con este Código"
              },
              "group_ids": {
                "blank": "Debe seleccionar al menos un Rol"
              },
              "list_options": {
                "blank": "No puedes agregar opciones vacías"
              }
            }
          },
          "customer": {
            "attributes": {
              "demo_expires_at": {
                "blank": "Debe ingresar la fecha de expiración para la demo",
                "invalid_date": "Debe ingresar la fecha de expiración para la demo",
                "on_or_after": "La fecha de expiración para la demo debe ser al menos 1 dia mayor a la fecha actual"
              },
              "email_display_name": {
                "invalid_characters": "El nombre para mostrar en el correo electrónico contiene caracteres inválidos"
              },
              "email_from_local_part": {
                "invalid_characters": "La parte local del correo electrónico contiene caracteres inválidos"
              },
              "name": {
                "blank": "Debes ingresar el nombre del cliente",
                "taken": "El nombre del cliente ya se encuentra en uso"
              },
              "on_demo": {
                "only": "Debe seleccionar uno ó ninguno"
              },
              "prospect": {
                "only": "Debe seleccionar uno ó ninguno"
              }
            }
          },
          "customer_onboarding/comercial_condition": {
            "attributes": {
              "is_custom": {
                "blank": "Debe seleccionar al menos un plan personalizado"
              }
            }
          },
          "customer_onboarding/legal_representative": {
            "attributes": {
              "email": {
                "duplicate": "El correo electrónico no se puede repetir"
              }
            }
          },
          "customer_onboarding_process": {
            "attributes": {
              "legal_representatives": {
                "blank": "Debes ingresar al menos un representante legal"
              }
            }
          },
          "customer_success/interview": {
            "attributes": {
              "meeting_at": {
                "on_or_after": "Debe ingresar una fecha mayor a la actual"
              }
            }
          },
          "default_signer": {
            "attributes": {
              "email": {
                "blank": "Debe ingresar el correo electrónico",
                "invalid_format": "Debe ingresar un correo electrónico válido",
                "taken": "El correo electrónico ya se encuentra en uso"
              },
              "name": {
                "blank": "Debe ingresar el nombre"
              },
              "role": {
                "blank": "Debe ingresar el rol"
              }
            }
          },
          "direct_link": {
            "attributes": {
              "created_by": {
                "taken": "Ya tienes un checklist anclado"
              }
            }
          },
          "document": {
            "attributes": {
              "certification_mode": {
                "require_per_signer_certification": "Si existe al menos un firmante avanzado, entonces el modo de certificación del documento debe ser por firmante."
              },
              "file": {
                "pdf_cannot_have_signatures": "El archivo contiene firmas digitales, por lo que no podemos procesarlo automáticamente.",
                "pdf_corrupted": "El archivo que estás subiendo no se pudo leer correctamente. Esto puede ocurrir si el archivo está incompleto o tiene algún error interno. Te sugerimos volver a guardarlo desde el programa original y subirlo nuevamente.",
                "pdf_encrypted": "El archivo que intentas subir tiene contraseña, por lo que no podemos procesarlo. Intenta subir una versión sin protección.",
                "pdf_encrypted_for_modifications": "El archivo tiene restricciones que impiden su lectura. Algunos documentos traen configuraciones que bloquean su análisis, aunque no tengan contraseña visible. Te recomendamos guardar una nueva copia del archivo sin restricciones y volver a subirlo."
              },
              "rejection_notification_enabled": {
                "at_least_one_recipient": "Debe notificar a al menos un destinatario",
                "must_be_enabled": "Debe estar habilitado para notificar a firmantes o creador"
              },
              "signature_deadline_at": {
                "blank": "Debe ingresar la fecha de límite de firma",
                "invalid_date": "Debe ingresar la fecha de límite de firma",
                "on_or_after": "La fecha de límite de firma debe ser al menos 5 minutos mayor a la fecha/hora actual"
              },
              "signers": {
                "at_least_one_signer": "Debe existir al menos un firmante que no sea visador que pueda firmar el documento",
                "blank": "Debe ingresar al menos un firmante"
              }
            }
          },
          "document_compression": {
            "attributes": {
              "base": {
                "duplicate": "Ya existe una solicitud de compresión en progreso"
              }
            }
          },
          "document_type": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar el nombre del tipo de documento",
                "taken": "El nombre del tipo de documento ya se encuentra en uso"
              },
              "number_days_to_expire_documents": {
                "blank": "Debe ingresar los días por expirar el documento",
                "greater_than_or_equal_to": "Debe ser mayor o igual a %{count}",
                "less_than_or_equal_to": "Debe ser menor o igual a %{count}"
              },
              "number_days_to_notify_signature_expire": {
                "blank": "Debe ingresar los días para notificar fecha límite de firma",
                "greater_than_or_equal_to": "Debe ser mayor o igual a %{count}",
                "less_than_or_equal_to": "Debe ser menor o igual a %{count}"
              }
            }
          },
          "document_type_battery": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar el nombre de la bateria"
              }
            }
          },
          "document_type_signer": {
            "attributes": {
              "email": {
                "blank": "Debe ingresar el correo electrónico",
                "duplicate": "El correo electrónico no se puede repetir",
                "invalid_format": "Debe ingresar un correo electrónico válido"
              },
              "name": {
                "blank": "Debe ingresar el nombre"
              },
              "role": {
                "blank": "Debe ingresar el rol"
              }
            }
          },
          "dt/credential": {
            "attributes": null
          },
          "dt/entity_integration": {
            "attributes": {
              "entity": {
                "blank": "Debe seleccionar un recurso",
                "unique": "Ya existe una solicitud de integración pendiente o en proceso"
              }
            }
          },
          "dt/record/info": {
            "attributes": {
              "employee_disability": {
                "blank": "Debe seleccionar si el trabajador tiene discapacidad"
              },
              "employee_disability_date": {
                "blank": "Debe ingresar la fecha de situación discapacidad",
                "not_allowed_date": "No debe ingresar una fecha"
              },
              "employee_home_location_commune": {
                "blank": "Debe seleccionar la comuna del domicilio"
              },
              "employee_home_location_department_or_office": {
                "blank": "Debe ingresar el depto/oficina del domicilio"
              },
              "employee_home_location_region": {
                "blank": "Debe seleccionar la región del domicilio"
              },
              "employee_home_location_street": {
                "blank": "Debe ingresar la calle del domicilio"
              },
              "employee_home_location_street_number": {
                "blank": "Debe ingresar el número del domicilio"
              },
              "employee_invalidity": {
                "blank": "Debe seleccionar si el trabajador tiene invalididad"
              },
              "employee_invalidity_date": {
                "blank": "Debe ingresar la fecha de situación invalididad",
                "not_allowed_date": "No debe ingresar una fecha"
              },
              "employee_original_location_commune": {
                "blank": "Debe seleccionar la comuna de procedencia"
              },
              "employee_original_location_region": {
                "blank": "Debe seleccionar la región de procedencia"
              },
              "employee_phone_number": {
                "blank": "Debe ingresar el teléfono del trabajador",
                "invalid": "Debe ingresar un teléfono válido"
              },
              "employee_rut": {
                "blank": "Debe ingresar el RUT del trabajador"
              },
              "hiring_contract_commune": {
                "not_in_region": "La comuna no corresponde a la región seleccionada",
                "not_valid_commune": "La comuna no es válida"
              },
              "hiring_contract_end_date": {
                "blank": "Debe ingresar la fecha de término del contrato",
                "not_allowed_date": "No debe ingresar una fecha cuando el contrato es indefinido"
              },
              "hiring_contract_est_rut": {
                "blank": "Debe ingresar el RUT de la empresa usuaria (EST)"
              },
              "hiring_contract_principal_rut": {
                "blank": "Debe ingresar el RUT de la empresa principal"
              },
              "hiring_contract_start_date": {
                "blank": "Debe ingresar la fecha de inicio del contrato"
              },
              "hiring_contract_type": {
                "blank": "Debe seleccionar el tipo de contrato"
              },
              "hiring_contract_work_installation_type": {
                "blank": "Debe seleccionar el tipo de instalación"
              },
              "hiring_end_description": {
                "blank": "Debe ingresar las observaciones"
              },
              "hiring_end_reason": {
                "blank": "Debe seleccionar la causal de término de contrato"
              },
              "hiring_other_stipulations": {
                "blank": "Debe ingresar las otras estipulaciones",
                "too_long": "Las otras estipulaciones no pueden superar %{count} caracteres"
              },
              "hiring_remuneration_and_allocation_clause": {
                "blank": "Debe ingresar la cláusula de remuneraciones y asignaciones",
                "too_long": "La cláusula de remuneraciones y asignaciones no puede superar %{count} caracteres"
              },
              "hiring_remuneration_base_salary": {
                "blank": "Debe ingresar el sueldo base"
              },
              "hiring_remuneration_gratification_type": {
                "blank": "Debe seleccionar el tipo de gratificación"
              },
              "hiring_remuneration_non_taxable_salary": {
                "blank": "Debe ingresar el sueldo no imponible"
              },
              "hiring_remuneration_payment_method": {
                "blank": "Debe seleccionar la forma de pago"
              },
              "hiring_remuneration_payment_period": {
                "blank": "Debe seleccionar el período de pago"
              },
              "hiring_remuneration_taxable_salary": {
                "blank": "Debe ingresar el sueldo imponible"
              },
              "hiring_work_location_commune": {
                "blank": "Debe seleccionar la comuna del trabajo"
              },
              "hiring_work_location_department_or_office": {
                "blank": "Debe ingresar el depto/oficina del trabajo"
              },
              "hiring_work_location_region": {
                "blank": "Debe seleccionar la región del trabajo"
              },
              "hiring_work_location_street": {
                "blank": "Debe ingresar la calle del trabajo"
              },
              "hiring_work_location_street_number": {
                "blank": "Debe ingresar el número del trabajo"
              },
              "hiring_working_days": {
                "blank": "Debe seleccionar los días de trabajo",
                "sunday_not_allowed": "El domingo solo es válido con excepción de descanso dominical"
              },
              "hiring_working_days_count": {
                "blank": "Debe ingresar el número de días de trabajo",
                "out_of_range": "Debe estar entre %{min} y %{max}"
              },
              "hiring_working_distribution_clause": {
                "blank": "Debe ingresar la cláusula de distribución",
                "too_long": "La cláusula de distribución no puede superar %{count} caracteres"
              },
              "hiring_working_distribution_system": {
                "blank": "Debe seleccionar el sistema de distribución"
              },
              "hiring_working_exceptional_resolution_date": {
                "blank": "Debe ingresar la fecha de la resolución excepcional"
              },
              "hiring_working_exceptional_resolution_id": {
                "blank": "Debe ingresar el ID de la resolución excepcional"
              },
              "hiring_working_hours": {
                "blank": "Debe ingresar la duración horas semanales",
                "invalid_format": "Debe tener formato HH:MM",
                "out_of_range": "Debe estar entre %{min} y %{max}"
              },
              "hiring_working_shift": {
                "blank": "Debe seleccionar el horario y turnos"
              },
              "hiring_working_sunday_rest_exception": {
                "blank": "Debe seleccionar la excepción descanso dominical"
              }
            }
          },
          "dt/record/integration": {
            "attributes": {
              "customer": {
                "required": "Debe asociar un cliente"
              },
              "record": {
                "required": "Debe asociar un registro"
              },
              "requested_by": {
                "blank": "Debe ingresar el usuario solicitante",
                "required": "Debe ingresar el usuario solicitante"
              },
              "workflow_mode": {
                "inclusion": "Debe ingresar un flujo de proceso válido"
              }
            }
          },
          "ecert/bulk/signing": {
            "attributes": {
              "signing_documents": {
                "too_short": "Debes seleccionar al menos un documento"
              },
              "user": {
                "presence": "El usuario debe existir"
              }
            }
          },
          "ecert/signature_certificate": {
            "attributes": {
              "first_name": {
                "blank": "Debe ingresar el nombre"
              },
              "first_surname": {
                "blank": "Debe ingresar el primer apellido"
              },
              "identification_number": {
                "blank": "Debe ingresar el RUT",
                "invalid": "Formato inválido",
                "taken": "Ya tiene un certificado asociado a este RUT, si desea eliminar este certificado debe contactarse a hola@controldoc.cl."
              },
              "last_surname": {
                "blank": "Debe ingresar el segundo apellido"
              },
              "user_email": {
                "blank": "Debe ingresar un email"
              }
            }
          },
          "economic_crime/workflow/requirement": {
            "attributes": {
              "complaint_type": {
                "blank": "Debe seleccionar un tipo de denuncia",
                "inclusion": "Debe seleccionar un tipo de denuncia válida"
              },
              "informer_email": {
                "blank": "Debe ingresar su correo electrónico",
                "invalid_format": "Debe ingresar un correo electrónico válido"
              },
              "informer_identification_type": {
                "blank": "Debe ingresar su número de identificación"
              },
              "informer_name": {
                "blank": "Debe ingresar su nombre"
              }
            }
          },
          "email_provider/smtp_account": {
            "attributes": {
              "address": {
                "blank": "debe estar presente"
              },
              "authentication": {
                "inclusion": "no está incluido en la lista"
              },
              "domain": {
                "blank": "debe estar presente"
              },
              "ownership": {
                "inclusion": "no está incluido en la lista"
              },
              "password": {
                "blank": "debe estar presente"
              },
              "port": {
                "blank": "debe estar presente",
                "greater_than": "debe ser mayor que %{count}",
                "less_than": "debe ser menor que %{count}",
                "not_an_integer": "debe ser un número entero"
              },
              "provider": {
                "blank": "debe estar presente",
                "inclusion": "no está incluido en la lista"
              },
              "user_name": {
                "blank": "debe estar presente"
              }
            }
          },
          "entity": {
            "attributes": {
              "custom_fields": {
                "invalid_list": "Debe seleccionar una opción válida",
                "invalid_number": "Debe ingresar un valor de tipo numérico"
              },
              "security_layer_id": {
                "blank": "Debe seleccionar una capa de seguridad"
              }
            }
          },
          "entity_folder/check_list": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar el nombre de la carpeta",
                "taken": "El nombre de la carpeta ya se encuentra en uso"
              },
              "requirements": {
                "blank": "Debe ingresar al menos un documento"
              },
              "shared_access": {
                "blank": "Debe seleccionar el método de acceso"
              },
              "shared_method": {
                "blank": "Debe seleccionar como compartir la carpeta"
              },
              "shared_password": {
                "blank": "Debe ingresar la contaseña de la carpeta"
              },
              "shared_password_confirmation": {
                "confirmation": "Las contraseñas no coinciden"
              }
            }
          },
          "entity_folder/check_list_requirement": {
            "attributes": {
              "deadline_upload_at": {
                "blank": "Debe indicar la fecha límite de subida"
              },
              "deadline_upload_notification_at": {
                "blank": "Debe indicar cuando se debe enviar recordatorio para subir el documento"
              },
              "document_type_id": {
                "blank": "Debe seleccionar un tipo de documento"
              },
              "recurrence_deadline_upload_days": {
                "blank": "Días de Deadline"
              },
              "recurrence_end_at": {
                "on_or_after": "El término de la recurrencia no puede ser anterior al inicio de esta."
              },
              "recurrence_period": {
                "blank": "Debe seleccionar el período de recurrencia"
              },
              "recurrence_start_at": {
                "after": "El inicio de la recurrencia debe ser mayor a la fecha de hoy",
                "blank": "Debe ingresar el comienzo de la recurrencia"
              }
            }
          },
          "entity_folder/check_list_shared": {
            "attributes": {
              "folders": {
                "blank": "Debe seleccionar al menos una carpeta para compartir"
              },
              "name": {
                "blank": "Nombre"
              },
              "notify_to": {
                "invalid_email": "Debe ingresar un correo válido (%{email})"
              },
              "shared_method": {
                "blank": "Debe seleccionar como quiere proteger las carpetas"
              },
              "shared_password": {
                "blank": "Debe ingresar la contraseña"
              },
              "shared_password_confirmation": {
                "confirmation": "Las contraseña no coinciden"
              }
            }
          },
          "entity_folder/check_list_task": {
            "attributes": null
          },
          "fao/mapping_config": {
            "attributes": null
          },
          "fao/mapping_field": {
            "attributes": {
              "resource_attribute": {
                "blank": "Debe seleccionar un atributo",
                "invalid_email": "El atributo no corresponde a un campo de notificación",
                "taken": "Ya existe otro registro que utiliza esta variable como email"
              },
              "resource_class": {
                "blank": "Debe seleccionar un recurso"
              }
            }
          },
          "group": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar un nombre para el rol",
                "taken": "Ya existe un rol con este nombre"
              }
            }
          },
          "karin_law/workflow/requirement": {
            "attributes": {
              "perpetrator_cost_center": {
                "blank": "Debe ingresar el departamento/área del denunciado/a"
              },
              "perpetrator_name": {
                "blank": "Debe ingresar el nombre del denunciado/a"
              },
              "perpetrator_position": {
                "blank": "Debe ingresar el cargo del denunciado/a"
              },
              "representative_cellphone": {
                "blank": "Debe ingresar su teléfono celular",
                "invalid": "Formato de teléfono celular inválido"
              },
              "representative_email": {
                "blank": "Debe ingresar su correo electrónico",
                "invalid_format": "Formato de correo electrónico inválido"
              },
              "representative_identification_number": {
                "blank": "Debe ingresar su RUT"
              },
              "representative_name": {
                "blank": "Debe ingresar su nombre completo"
              },
              "victim_cellphone": {
                "blank": "Debe ingresar su teléfono celular",
                "invalid": "Formato de teléfono celular inválido"
              },
              "victim_email": {
                "blank": "Debe ingresar su correo electrónico",
                "invalid_format": "Formato de correo electrónico inválido"
              },
              "victim_identification_number": {
                "blank": "Debe ingresar su RUT"
              },
              "victim_name": {
                "blank": "Debe ingresar su nombre completo"
              }
            }
          },
          "laboral/bulk/load/arauco/docx_merge_field": {
            "attributes": {
              "data_file": {
                "blank": "Debes subir el archivo de datos (excel)"
              },
              "document_type": {
                "blank": "Debes seleccionar un tipo de documento"
              },
              "document_type_id": {
                "blank": "Debes seleccionar un tipo de documento"
              },
              "template_file": {
                "blank": "Debes subir el archivo de plantilla"
              }
            }
          },
          "laboral/bulk/load/hiring_document": {
            "attributes": {
              "document_type": {
                "blank": "Debes seleccionar un tipo de documento",
                "required": "Debes seleccionar un tipo de documento"
              },
              "document_type_id": {
                "blank": "Debes seleccionar un tipo de documento",
                "required": "Debes seleccionar un tipo de documento"
              },
              "expires_at": {
                "blank": "Debe ingresar la fecha de caducidad",
                "invalid_date": "Debe ingresar la fecha de caducidad",
                "on_or_after": "La fecha de caducidad debe ser igual ó mayor a la fecha actual"
              },
              "hirings": {
                "blank": "Debe cargar al menos un documento asociado a una contratación"
              },
              "items": {
                "blank": "Debe cargar al menos un documento"
              },
              "signature_deadline_at": {
                "blank": "Debe ingresar la fecha de límite de firma",
                "invalid_date": "Debe ingresar la fecha de límite de firma",
                "on_or_after": "La fecha de límite de firma no puede ser anterior a la fecha actual"
              },
              "signers": {
                "at_least_one_signer": "Debes ingresar al menos un firmante que no sea un lector",
                "blank": "Debe ingresar al menos un firmante"
              }
            }
          },
          "laboral/bulk/load/hiring_document_item": {
            "attributes": null
          },
          "laboral/bulk/notification/sign": {
            "attributes": {
              "sign_items": {
                "blank": "Debe seleccionar al menos una firma pendiente"
              }
            }
          },
          "laboral/bulk/notification/sign_item": {
            "attributes": {
              "signs": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "laboral/bulk/request/destroy_employee": {
            "attributes": {
              "items": {
                "blank": "Debe seleccionar al menos un trabajador para eliminar"
              }
            }
          },
          "laboral/bulk/request/hiring_document": {
            "attributes": {
              "hiring_items": {
                "blank": "Debe seleccionar al menos una contratación"
              },
              "scheduled_at": {
                "invalid_datetime": "Debes ingresar una fecha y una hora válidas",
                "on_or_after": "La fecha debe ser mínimo 5 minutos después de la fecha y hora actual"
              }
            }
          },
          "laboral/bulk/request/hiring_document_config": {
            "attributes": {
              "document_type_id": {
                "blank": "Debe seleccionar un tipo de documento"
              },
              "expires_at": {
                "blank": "Debe ingresar la fecha de caducidad",
                "invalid_date": "Debe ingresar la fecha de caducidad",
                "on_or_after": "La fecha de caducidad no puede ser anterior a la fecha actual"
              },
              "file": {
                "blank": "Debe subir un archivo",
                "pdf_cannot_have_signatures": "El archivo que intentas subir ya contiene firmas digitales, no podemos procesarlo.",
                "pdf_corrupted": "Al parecer el archivo que intentas subir está corrupto, por favor verifícalo y vuelve a subirlo.",
                "pdf_encrypted": "Al parecer el archivo que intentas subir tiene contraseña, archivos con contraseña no son soportados.",
                "pdf_encrypted_for_modifications": "Al parecer el archivo que intentas subir no puede ser modificado sin contraseña, archivos con contraseña no son soportados."
              },
              "signature_deadline_at": {
                "blank": "Debe ingresar la fecha de límite de firma",
                "invalid_date": "Debe ingresar la fecha de límite de firma",
                "on_or_after": "La fecha de límite de firma no puede ser anterior a la fecha actual"
              },
              "signers": {
                "at_least_one_signer": "Debes ingresar al menos un firmante que no sea un lector",
                "blank": "Debes ingresar al menos un firmante"
              },
              "upload_deadline_at": {
                "blank": "Debe ingresar la fecha de límite de subida",
                "invalid_date": "Debe ingresar la fecha de límite de subida"
              }
            }
          },
          "laboral/bulk/request/hiring_document_item": {
            "attributes": {
              "config": {
                "required": "Problema al asignar la configuración"
              }
            }
          },
          "laboral/bulk/request/hiring_item": {
            "attributes": {
              "hirings": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "laboral/check_list/hiring_process": {
            "attributes": {
              "check_list_entities": {
                "blank": "Debe seleccionar al menos una contratación"
              }
            }
          },
          "laboral/document_type_batteries": {
            "attributes": {
              "code": {
                "taken": "Ya éxiste una con este Código"
              }
            }
          },
          "laboral/employee": {
            "attributes": {
              "deleted_at": {
                "failed_to_destroy": "No es posible eliminar el trabajador"
              },
              "document": {
                "error": "Tenemos un problema al eliminar un documento"
              },
              "id": {
                "exist": "El id %{controldoc_id} no se encuentra en la base de datos"
              },
              "identifier": {
                "blank": "Debes ingresar el identificador del trabajador",
                "taken": "El identificador ya se encuentra en uso"
              },
              "name": {
                "blank": "Debes ingresar el nombre del trabajador"
              }
            }
          },
          "laboral/employee_config": {
            "attributes": {
              "email": {
                "blank": "Debes ingresar el correo electrónico del trabajador",
                "invalid_format": "Debes ingresar un correo electrónico con formato válido",
                "taken": "El correo electrónico esta siendo usado por otro trabajador"
              },
              "name": {
                "blank": "Debes ingresar el nombre del trabajador"
              }
            }
          },
          "laboral/employee_email_change": {
            "attributes": {
              "documents_action": {
                "blank": "debes seleccionar una acción para los documentos",
                "inclusion": "no es una acción válida"
              },
              "new_email": {
                "blank": "no puede estar en blanco",
                "invalid": "no tiene un formato válido",
                "same_as_old": "debe ser diferente al correo actual",
                "taken": "Correo electrónico no disponible"
              }
            }
          },
          "laboral/employee_requirement_type": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar el nombre del requerimiento"
              }
            }
          },
          "laboral/hiring": {
            "attributes": {
              "deleted_at": {
                "failed_to_destroy": "No es posible eliminar la contratación",
                "with_documents": "No es posible eliminar una contratación con documentos"
              },
              "id": {
                "exist": "El id %{controldoc_id} no se encuentra en la base de datos"
              },
              "identifier": {
                "blank": "Debes ingresar el identificador de la contratación",
                "taken": "El identificador ya se encuentra en uso"
              },
              "name": {
                "blank": "Debes ingresar el nombre del trabajador"
              }
            }
          },
          "laboral/hiring_config": {
            "attributes": {
              "branch": {
                "required": "La sucursal debe existir"
              },
              "branch_id": {
                "blank": "Debes seleccionar la sucursal para la contratación"
              },
              "employee": {
                "required": "El trabajador debe existir"
              },
              "employee_id": {
                "blank": "Debes seleccionar el trabajador para la contratación"
              },
              "start_date": {
                "blank": "Debes ingresar la fecha de inicio del contrato",
                "invalid_date": "Debes ingresar un formato válido para la fecha",
                "on_or_before": "La fecha de inicio no puede ser mayor a la fecha de fin"
              }
            }
          },
          "laboral/hiring_document": {
            "attributes": {
              "document_type_id": {
                "blank": "Debe seleccionar un tipo de documento"
              },
              "entity": {
                "blank": "Debe seleccionar una contratación",
                "required": "Debe seleccionar una contratación"
              },
              "entity_id": {
                "blank": "Debe seleccionar una contratación"
              },
              "expires_at": {
                "blank": "Debes ingresar la fecha de caducidad",
                "invalid_date": "Debes ingresar un formato válido para la fecha",
                "on_or_after": "La fecha de caducidad no puede ser menor a la fecha de creación"
              },
              "file": {
                "blank": "Debe cargar un documento"
              },
              "signer_groups": {
                "invalid": "No se permite grupos de firmantes para FAO"
              },
              "template": {
                "blank": "No se ha seleccionado una plantilla para generar el documento"
              }
            }
          },
          "laboral/shortlist/assessment_load": {
            "attributes": {
              "email": {
                "invalid_format": "Formato de correo electrónico inválido para Shortlist"
              },
              "phone": {
                "invalid": "Formato de teléfono celular inválido para Shortlist"
              }
            }
          },
          "membership": {
            "attributes": {
              "group": {
                "blank": "Debe seleccionar un rol"
              },
              "group_id": {
                "invalid": "Rol no disponible"
              },
              "is_admin": {
                "blank": "Debe seleccionar al menos uno"
              },
              "is_onboarding_process_responsible": {
                "blank": "Debe seleccionar al menos un responsable",
                "duplicate": "Ya se encuentra en uso"
              },
              "is_primary": {
                "invalid": "Debe ser administrador",
                "taken": "Ya se designó un administrador principal"
              }
            }
          },
          "nps/record": {
            "attributes": null
          },
          "nps/result": {
            "attributes": {
              "observations": {
                "blank": "Debe ingresar un motivo de la puntuación",
                "too_short": {
                  "other": "Debe ingresar como mínimo %{count} caracteres"
                }
              },
              "result": {
                "invalid_value": "Debe ingresar una opción válida"
              }
            }
          },
          "portal/configuration": {
            "attributes": {
              "exception_use_personal_email_sql": {
                "blank": "Debe ingresar una consulta SQL si activa la excepción",
                "unsafe_sql": "La consulta no puede incluir sentencias peligrosas (DROP, DELETE, UPDATE, INSERT, ';', '--', etc.)"
              },
              "tenant": {
                "invalid": "Solo se permiten letras minúsculas y números, sin espacios en blanco"
              }
            }
          },
          "report": {
            "attributes": {
              "base": {
                "report_pendings": "Aún tienes reportes pendientes, una vez generados puede volver a solicitar otro."
              }
            }
          },
          "report/corporate/agreement_document": {
            "attributes": null
          },
          "report/corporate/signer": {
            "attributes": null
          },
          "report/laboral/hiring": {
            "attributes": null
          },
          "report/laboral/hiring_document": {
            "attributes": null
          },
          "report/laboral/signer": {
            "attributes": null
          },
          "security_layer": {
            "attributes": {
              "name": {
                "blank": "Debe ingresar un nombre para la capa de seguridad",
                "taken": "Ya existe una capa de seguridad con este nombre"
              }
            }
          },
          "shortlist/assessment_load": {
            "attributes": {
              "email": {
                "invalid_format": "Formato de correo electrónico inválido para Shortlist"
              },
              "phone": {
                "invalid": "Formato de teléfono celular inválido para Shortlist"
              }
            }
          },
          "shortlist/mapping_config": {
            "attributes": null
          },
          "shortlist/mapping_field": {
            "attributes": null
          },
          "signer": {
            "attributes": {
              "email": {
                "blank": "Debe ingresar el correo electrónico",
                "duplicate": "El correo electrónico no se puede repetir",
                "invalid_format": "Debe ingresar un correo electrónico válido"
              },
              "first_surname": {
                "blank": "Debe ingresar el Primer Apellido."
              },
              "hide_signature_image": {
                "forbidden": "No puedes ocultar la firma de un firmante. Solo funciona para visadores."
              },
              "identification_number": {
                "blank": "Debe ingresar el RUT",
                "duplicate": "El RUT no se puede repetir",
                "invalid_format": "Debe ingresar el RUT con guión"
              },
              "last_surname": {
                "blank": "Debe ingresar el Segundo Apellido"
              },
              "name": {
                "blank": "Debe ingresar el nombre",
                "invalid_windows_1252": "El nombre contiene caracteres no válidos."
              },
              "order": {
                "blank": "Debe ingresar el orden",
                "duplicate": "El orden de los firmantes no se puede repetir"
              },
              "role": {
                "blank": "Debe ingresar el rol"
              },
              "signature_mode": {
                "inclusion": "Tipo de firma inválido, debe ser \"simple\" o \"advance\""
              }
            }
          },
          "signer_configuration": {
            "attributes": {
              "email": {
                "blank": "Debe ingresar el correo electrónico",
                "duplicate": "El correo electrónico no se puede repetir",
                "invalid_format": "Debe ingresar un correo electrónico válido"
              },
              "first_surname": {
                "blank": "Debe ingresar el Primer Apellido."
              },
              "identification_number": {
                "blank": "Debe ingresar el RUT",
                "duplicate": "El RUT no se puede repetir",
                "invalid_format": "Debe ingresar el RUT con guión"
              },
              "last_surname": {
                "blank": "Debe ingresar el Segundo Apellido"
              },
              "name": {
                "blank": "Debe ingresar el nombre"
              },
              "order": {
                "blank": "Debe ingresar el orden",
                "duplicate": "El orden de los firmantes no se puede repetir"
              },
              "role": {
                "blank": "Debe ingresar el rol"
              }
            }
          },
          "signer_group": {
            "attributes": {
              "minimun_signers": {
                "blank": "Debes ingresar un minimo de firmantes",
                "greater_than_or_equal_to": "Debe ser mayor o igual a %{count}",
                "less_than": "Debe ser menor a %{count}"
              },
              "name": {
                "blank": "Debes ingresar un nombre",
                "duplicate": "Nombre del grupo no se puede repetir"
              },
              "order": {
                "duplicate": "El order no se puede repetir",
                "taken": "El orden ya esta en uso de un firmante"
              },
              "signers": {
                "blank": "Debes ingresar al menos un firmante"
              }
            }
          },
          "signer_notification": {
            "attributes": {
              "notified_by": {
                "blank": "Debe ingresar el usuario que notificará"
              },
              "signer": {
                "blank": "Debe ingresar el firmante"
              }
            }
          },
          "unsubscribed/email": {
            "attributes": {
              "email": {
                "blank": "debe estar presente",
                "invalid": "no es un correo electrónico válido",
                "taken": "ya existe en la lista de no suscritos"
              },
              "resource": {
                "invalid": "no es válido"
              }
            }
          },
          "user": {
            "attributes": {
              "accept_personal_information_declaration": {
                "accepted": "Debe declarar que su información es correcta y fidedigna"
              },
              "cellphone": {
                "invalid": "Formato de teléfono celular inválido"
              },
              "current_password": {
                "blank": "Debe ingresar su contraseña actual",
                "invalid": "La contraseña actual no corresponde"
              },
              "email": {
                "blank": "Debe ingresar un correo electrónico"
              },
              "identification_number": {
                "blank": "Debe ingresar el número de identificación"
              },
              "identification_type": {
                "blank": "Debe ingresar el tipo de identificación",
                "inclusion": "Debe ingresar un tipo de identificación válido"
              },
              "marital_status": {
                "inclusion": "Debe ingresar un estado civil válido"
              },
              "name": {
                "blank": "Debe ingresar su nombre",
                "invalid_windows_1252": "El nombre contiene caracteres no válidos."
              },
              "onboarding_process_token_confirmation": {
                "confirmation": "El código es inválido"
              },
              "password_confirmation": {
                "confirmation": "Las contraseñas no coinciden"
              },
              "signature_pin": {
                "blank": "Debe ingresar el PIN",
                "not_a_number": "El PIN debe ser numérico"
              },
              "signature_pin_confirmation": {
                "confirmation": "La confirmación de PIN no coincide"
              }
            }
          },
          "versioner/collaborator": {
            "attributes": {
              "user_email": {
                "blank": "El correo electrónico no puede estar en blanco",
                "duplicate": "El correo electrónico del colaborador no se puede repetir"
              }
            }
          },
          "versioner/document/item": {
            "file": {
              "invalid": "El archivo es inválido"
            }
          },
          "versioner/document/thread": {
            "attributes": {
              "name": {
                "taken": "El nombre ya se encuentra en uso"
              }
            }
          },
          "workflow/edge": null,
          "workflow/group": {
            "attributes": {
              "group_users": {
                "blank": "Debe ingresar al menos un email de participantes"
              },
              "name": {
                "blank": "Debe ingresar el rol",
                "taken": "El rol ya se encuentra en uso"
              }
            }
          },
          "workflow/process": {
            "attributes": {
              "allowed_emails_to_see_ebooks": {
                "invalid_format": "El formato del correo \"%{email}\" no es válido"
              },
              "description": {
                "blank": "Debe ingresar la descripción del proceso"
              },
              "disclaimer": {
                "blank": "Debe ingresar los Términos de uso"
              },
              "identifier_pattern": {
                "correlative_per_month_requires_month": "Los códigos correlative_per_month requieren la presencia de [month]",
                "correlative_per_year_requires_year": "Los códigos correlative_per_year requieren la presencia de [year]",
                "date_codes_require_correlative": "Los códigos de fecha [year], [month], [day] deben usarse con un código correlativo para evitar conflictos",
                "invalid_codes": "El patrón de identificador contiene códigos inválidos: %{codes}"
              },
              "name": {
                "blank": "Debes ingresar el nombre del proceso",
                "taken": "El nombre del proceso ya se encuentra en uso"
              }
            }
          },
          "workflow/requirement": {
            "attributes": {
              "accept_disclaimer": {
                "accepted": "Debe aceptar los Términos de uso"
              }
            }
          },
          "workflow/requirement_stage": {
            "attributes": {
              "to_stage_id": {
                "blank": "Debe seleccionar la etapa"
              }
            }
          },
          "workflow/requirement_stage_form_field_item": {
            "attributes": {
              "value": {
                "invalid_cellphone": "Debe ser un formato válido para teléfono celular ( 911111111 )"
              }
            }
          },
          "workflow/stage": {
            "attributes": {
              "description": {
                "blank": "Debe ingresar la descripción de la etapa"
              },
              "name": {
                "blank": "Debe ingresar el nombre de la etapa",
                "taken": "El nombre de la etapa ya se encuentra en uso"
              },
              "source_edges": {
                "blank": "La etapa '%{name}' debe tener una etapa de origen"
              },
              "target_edges": {
                "blank": "La etapa '%{name}' debe tener una etapa de destino"
              }
            }
          },
          "workflow/stage_field_item": {
            "attributes": {
              "data_type": {
                "blank": "Debe seleccionar el tipo de dato"
              },
              "name": {
                "blank": "Debe ingresar el nombre del campo",
                "taken": "El nombre del ya se encuentra en uso"
              }
            }
          },
          "workflow/stage_file_item": {
            "attributes": {
              "file": {
                "blank": "Debe subir un archivo",
                "file_size_not_less_than": "El archivo debe ser menor a %{max}"
              },
              "name": {
                "blank": "Debe ingresar el nombre del documento",
                "taken": "El nombre ya se encuentra en uso"
              }
            }
          },
          "workflow/stage_form": {
            "attributes": null
          },
          "workflow/stage_output_file_item": {
            "attributes": null
          }
        }
      },
      "events": {
        "crm/budget": {
          "to_sent": "Enviar"
        },
        "crm/budget_product": null,
        "crm/budget_product_template": null,
        "crm/budget_template": {
          "to_sent": "Enviar"
        },
        "crm/lead": {
          "create_budget": "Crear cotización",
          "to_budget_pending": "Marcar como presupuesto pendiente",
          "to_budget_sent": "Marcar como presupuesto enviado",
          "to_closed": "Cerrar",
          "to_discarded": "Descartar",
          "to_lost": "Marcar como perdido",
          "to_pending": "Marcar como pendiente",
          "to_tour_sent": "Enviar tour"
        },
        "entity_folder/check_list_task": {
          "to_approved": "Aprobar",
          "to_rejected": "Rechazar",
          "to_returned": "Solicitar nuevamente"
        },
        "workflow/requirement_stage": {
          "to_completed": "Finalizar",
          "to_proceeded": "Avanzar",
          "to_rejected": "Terminar",
          "to_returned": "Devolver"
        }
      },
      "help": {
        "compliance/activity": {
          "company": "Nombre de la empresa",
          "compliance_risk_level_id": "Nivel de riesgo de la actividad",
          "compliance_risk_level_id_html": "Nivel de riesgo de la actividad. Este puede ser el nombre o la ponderación. <a href='%{link}'>Crear un nivel de riesgo.</a>",
          "created_at": "Creado en",
          "created_by": "Creado por",
          "days_for_perform": "Plazo para completar la tarea que se creara a partir de la actividad. (Días)",
          "deadline": "Fecha en que la tarea debe estar completada. Formato: dia/mes/año. Ejemplo: 12/12/2025.",
          "description": "Descripción completa de la actividad",
          "evidences": "Listado de evidencias separadas por coma (,)",
          "name": "Nombre de la actividad",
          "project": "Nombre del proyecto",
          "recurrence": "Frecuencia con la que la actividad debe ser ejecutada. Posibles valores: Diaria, Semanal, Quincenal, Mensual, Trimestral, Semestral, Anual, Sin recurrencia.",
          "resource_module_name": "La actividad se asociará a un recurso de acuerdo al módulo seleccionado (pueden ser: Contrataciones, Trabajadores, etc.).",
          "start_date": "Fecha en que la tarea debe iniciar. Formato: dia/mes/año. Ejemplo: 12/12/2025."
        },
        "compliance/activity_container": {
          "created_at": "Creado en",
          "created_by": "Creado por",
          "name": "Nombre del contenedor"
        },
        "compliance/custom_field": {
          "code": "Código",
          "created_at": "Fecha de creación",
          "data_type": "Tipo de dato",
          "label": "Etiqueta",
          "resource_type": "Recurso"
        },
        "compliance/evidence_file": {
          "comment": "Deja tus observaciones aquí"
        },
        "compliance/reviewer_group": {
          "mandatory": "Si esta activada, la actividad debe ser completada obligatoriamente por al menos un integrante de este grupo."
        },
        "controldoc_form/template": {
          "preview_uploaded_template": "Esta plantilla usa un archivo base y no puede previsualizarse en el sistema como el resto. Descargue el archivo para ver su contenido.",
          "require_uploaded_template": "Si esta opción está activada, se debe subir un archivo RTF.",
          "uploaded_file": "Archivo plantilla (RTF). Máximo 5 MB."
        },
        "customer": {
          "dt_legal_representative_rut": "Rut del representante laboral registrado en el portal de la DT",
          "dt_unique_key": "Por seguridad, no se muestra la clave única del representante laboral"
        },
        "document_type": {
          "dt_hook_enabled": "Al habilitar esta opción, cuando un documento de este tipo quede firmado, se enviará automáticamente al portal de la DT. Actívala solo para tipos de documento que correspondan a contrato o anexo de contrato."
        },
        "workflow/process": {
          "allowed_emails_to_see_ebooks": "Ingresa los correos electrónicos separados por comas. Ejemplo: usuario1@dominio.com, usuario2@dominio.com",
          "identifier_pattern": {
            "placeholder": "Puedes dejarlo vacío si quieres que el sistema decida automáticamente."
          },
          "identifier_pattern_instructions": "<div style=\"display:flex; flex-wrap:wrap;\">\n  <div style=\"flex-basis:45%;\"><strong>[year]</strong>: Año actual</div>\n  <div style=\"flex-basis:45%;\"><strong>[month]</strong>: Mes actual</div>\n  <div style=\"flex-basis:45%;\"><strong>[day]</strong>: Día actual</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_0]</strong>: Número correlativo (ej. 1)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_00]</strong>: Número correlativo (ej. 01)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_000]</strong>: Número correlativo (ej. 001)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_0000]</strong>: Número correlativo (ej. 0001)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_per_month_0]</strong>: Correlativo por mes (ej. 1)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_per_month_00]</strong>: Correlativo por mes (ej. 01)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_per_month_000]</strong>: Correlativo por mes (ej. 001)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_per_month_0000]</strong>: Correlativo por mes (ej. 0001)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_per_year_0]</strong>: Correlativo por año (ej. 1)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_per_year_00]</strong>: Correlativo por año (ej. 01)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_per_year_000]</strong>: Correlativo por año (ej. 001)</div>\n  <div style=\"flex-basis:45%;\"><strong>[correlative_per_year_0000]</strong>: Correlativo por año (ej. 0001)</div>\n</div>\n<p><strong>Ejemplo:</strong> [year]-[month]-[correlative_per_month_0000] generará algo como \"2024-06-0023\".</p>\n"
        },
        "workflow/stage_field_item": {
          "data_type": "Tipo de dato para el campo que estás creando. Los tipos disponibles son: Correo electrónico, Texto, Fecha, Teléfono Celular y Lista.",
          "group_name": "Grupo al cual pertenece el campo. Los grupos son una forma de mantener ordenados los formularios.",
          "helping_text": "Texto de ayuda que aparecerá al momento de completar el formulario",
          "is_required": "Define si será requerido al momento de avanzar entre etapas",
          "list_options": null,
          "name": "Nombre del campo"
        },
        "workflow/stage_file_item": {
          "group_name": "Grupo al cual pertenece el archivo. Los grupos son una forma de mantener ordenados los formularios.",
          "helping_text": "Texto de ayuda que aparecerá al momento de completar el formulario",
          "is_required": "Define si será requerido al momento de avanzar entre etapas",
          "name": "Nombre del archivo"
        }
      },
      "models": {
        "abstract/bulk/load/document": {
          "one": "Carga de documento",
          "other": "Carga de documentos"
        },
        "abstract/bulk/load/document_item": null,
        "abstract/bulk/load/entity": {
          "one": "Carga de %{entity}",
          "other": "Carga de %{entity}"
        },
        "abstract/bulk/request/document": {
          "one": "Solicitud de documentos",
          "other": "Solicitud de documentos"
        },
        "abstract/bulk/request/document_config": {
          "one": "Solicitud de documentos",
          "other": "Solicitudes de documentos"
        },
        "abstract/bulk/request/document_item": null,
        "abstract/bulk/request/entity_item": null,
        "abstract/custom_field": {
          "one": "Campo personalizado",
          "other": "Campos personalizados"
        },
        "abstract/document": {
          "one": "Documento",
          "other": "Documentos"
        },
        "abstract/document_type": {
          "one": "Tipo de documento",
          "other": "Tipos de documentos"
        },
        "abstract/document_type_batteries": {
          "one": "Batería de documentos",
          "other": "Baterías de documentos"
        },
        "abstract/entity": {
          "one": "Entidad",
          "other": "Entidades"
        },
        "abstract/entity_type": {
          "one": "Módulo Abstracto",
          "other": "Módulos Abstractos"
        },
        "abstract/entity_type_config": {
          "one": "Configuración de módulo",
          "other": "Configuración de módulos"
        },
        "abstract/report/document": {
          "one": "Reporte de documento",
          "other": "Reporte de documentos"
        },
        "abstract/report/signer": {
          "one": "Reporte de firmante",
          "other": "Reporte de firmantes"
        },
        "abstract/shortlist/assessment_load": {
          "one": "Shortlist evaluación",
          "other": "Shortlist evaluaciones"
        },
        "active_admin/comment": {
          "one": "Comentario",
          "other": "Comentarios"
        },
        "billing/account": {
          "one": "Información de facturación",
          "other": "Información de facturación"
        },
        "billing/quote/active_employee": {
          "one": "Trabajador Activo",
          "other": "Trabajadores Activo"
        },
        "billing/quote/advance_signature": {
          "one": "Firma Avanzada",
          "other": "Firmas Avanzadas"
        },
        "billing/quote/ecert_enrolled": {
          "one": "F.E.A. Enrolado",
          "other": "F.E.A. Enrolados"
        },
        "billing/quote/ecert_single_use": {
          "one": "F.E.A. un Solo Uso",
          "other": "F.E.A. un Solo Uso"
        },
        "billing/quote/gb_used": {
          "one": "Gigabyte Usado",
          "other": "Gigabytes Usado"
        },
        "billing/quote/inactive_employee": {
          "one": "Trabajador Inactivo",
          "other": "Trabajadores Inactivo"
        },
        "billing/quote/member": {
          "one": "Usuario/Miembro",
          "other": "Usuarios/Miembros"
        },
        "billing/quote/resource": {
          "one": "Recurso",
          "other": "Recursos"
        },
        "billing/quote/signature_certificate": {
          "one": "Certificado F.E.A.",
          "other": "Certificados F.E.A."
        },
        "billing/quote/simple_signature": {
          "one": "Firma Simple",
          "other": "Firmas simples"
        },
        "billing/quote/storage": {
          "one": "Almacenamiento Usado (GB)",
          "other": "Almacenamiento Usado (GB)"
        },
        "blog/post": {
          "one": "Publicación",
          "other": "Publicaciones"
        },
        "bulk/datatable/distribution_list_filter": {
          "one": "Lista de distribución",
          "other": "Listas de distribución"
        },
        "bulk/load/docx_merge_field": {
          "one": "Combinar correspondencia",
          "other": "Combinar correspondencia"
        },
        "bulk/load/docx_merge_field_item": {
          "one": "Item de carga de documento",
          "other": "Items de carga de documento"
        },
        "bulk/my_filter": {
          "one": "Mis filtros",
          "other": "Mis filtros"
        },
        "bulk/notification/fill": {
          "one": "Aviso de formularios pendientes",
          "other": "Aviso de formularios pendientes"
        },
        "bulk/notification/fill_item": null,
        "bulk/notification/sign": {
          "one": "Notificación de firmas",
          "other": "Notificación de firmas"
        },
        "bulk/notification/sign_item": null,
        "bulk/rejection": {
          "one": "",
          "other": ""
        },
        "bulk/request/destroy_document": {
          "one": "Eliminación Masiva de documentos",
          "other": "Eliminación Masiva de documentos"
        },
        "bulk/request/destroy_document_item": null,
        "bulk/request/zip/document": {
          "one": "Descarga Masiva de documentos",
          "other": "Descargas Masivas de documentos"
        },
        "bulk/request/zip/document_item": null,
        "bulk/signing": {
          "one": "",
          "other": ""
        },
        "bulk_signer_config": null,
        "calendar/holiday_event": {
          "one": "Feriado",
          "other": "Feriados"
        },
        "calendar/work_schedule": {
          "one": "Calendario laboral",
          "other": "Calendarios laborales"
        },
        "change_log": {
          "one": "Actualización ControlDoc",
          "other": "Actualizaciones ControlDoc"
        },
        "check_list/process": {
          "one": "Check list",
          "other": "Check lists"
        },
        "check_list/shared_process": {
          "one": "Check list compartido",
          "other": "Check lists compartidos"
        },
        "check_list/task": {
          "one": "Tarea check list",
          "other": "Tareas check list"
        },
        "comment": {
          "one": "Comentario",
          "other": "Comentarios"
        },
        "communication_channel": {
          "one": "Canal de comunicación",
          "other": "Canal de comunicaciones"
        },
        "compliance/activity": {
          "one": "Actividad",
          "other": "Actividades"
        },
        "compliance/activity_container": {
          "one": "Grupo de actividades",
          "other": "Grupos de actividades"
        },
        "compliance/activity_group_check": {
          "one": "Revisión de Grupo",
          "other": "Revisiones de Grupo"
        },
        "compliance/bulk/load/activity": {
          "one": "Carga de actividades",
          "other": "Cargas de actividades"
        },
        "compliance/consultant_group": {
          "one": "Grupo Consultado",
          "other": "Grupos Consultados"
        },
        "compliance/context": {
          "one": "Módulo de Cumplimiento",
          "other": "Módulos de Cumplimiento"
        },
        "compliance/custom_field": {
          "one": "Campo personalizado",
          "other": "Campos personalizados"
        },
        "compliance/dashboard": {
          "one": "Tablero de Control",
          "other": "Tableros de Control"
        },
        "compliance/evidence": {
          "one": "Evidencia",
          "other": "Evidencias"
        },
        "compliance/evidence_file": {
          "one": "Evidencia",
          "other": "Evidencias"
        },
        "compliance/evidence_load": {
          "one": "Carga de evidencia",
          "other": "Carga de evidencias"
        },
        "compliance/group": {
          "one": "Grupo",
          "other": "Grupos"
        },
        "compliance/informer_group": {
          "one": "Grupo Informado",
          "other": "Grupos Informados"
        },
        "compliance/reviewer_group": {
          "one": "Grupo Encargado de Revisar Evidencia",
          "other": "Grupos Encargados de Revisar Evidencia"
        },
        "compliance/risk_level": {
          "one": "Nivel de riesgo",
          "other": "Niveles de riesgo"
        },
        "compliance/uploader_group": {
          "one": "Grupo Encargado de Subir Evidencia",
          "other": "Grupos Encargados de Subir Evidencia"
        },
        "controldoc_form/document": {
          "one": "Documento",
          "other": "Documentos"
        },
        "controldoc_form/template": {
          "one": "Plantilla",
          "other": "Plantillas"
        },
        "controldoc_form/template_layout": {
          "one": "Diseño",
          "other": "Diseños"
        },
        "corporate/agreement": {
          "one": "Contrato",
          "other": "Contratos"
        },
        "corporate/agreement_config": null,
        "corporate/agreement_document": {
          "one": "Documento",
          "other": "Documentos"
        },
        "corporate/branch": {
          "one": "Sucursal",
          "other": "Sucursales"
        },
        "corporate/bulk/notification/sign": {
          "one": "Notificación de firmas",
          "other": "Notificación de firmas"
        },
        "corporate/bulk/notification/sign_item": null,
        "corporate/bulk/request/agreement_document": {
          "one": "Solicitud de documentos",
          "other": "Solicitud de documentos"
        },
        "corporate/bulk/request/agreement_document_config": {
          "one": "Solicitud de documentos",
          "other": "Solicitudes de documentos"
        },
        "corporate/bulk/request/agreement_document_item": null,
        "corporate/bulk/request/agreement_item": null,
        "corporate/company": {
          "one": "Empresa",
          "other": "Empresas"
        },
        "corporate/company_config": null,
        "corporate/controldoc_form/document": {
          "one": "Documento",
          "other": "Documentos"
        },
        "corporate/document_type": {
          "one": "Tipo de documento",
          "other": "Tipos de documento"
        },
        "corporate/document_type_batteries": {
          "one": "Batería de documentos",
          "other": "Baterías de documentos"
        },
        "crm/budget": {
          "one": "Cotización",
          "other": "Cotizaciónes"
        },
        "crm/budget_product": {
          "one": "Producto",
          "other": "Productos"
        },
        "crm/budget_product_template": {
          "one": "Producto",
          "other": "Productos"
        },
        "crm/budget_template": {
          "one": "Plantilla de Cotización",
          "other": "Plantillas de Cotizaciónes"
        },
        "crm/lead": {
          "one": "Lead",
          "other": "Leads"
        },
        "custom_field": {
          "one": "Campo personalizado",
          "other": "Campos personalizados"
        },
        "customer": {
          "one": "Cliente",
          "other": "Clientes"
        },
        "customer_onboarding/comercial_condition": {
          "one": "Condición Comercial",
          "other": "Condiciones Comerciales"
        },
        "customer_onboarding/legal_representative": {
          "one": "Representante Legal",
          "other": "Representantes Legales"
        },
        "customer_onboarding/product": {
          "one": "Producto",
          "other": "Productos"
        },
        "customer_onboarding_process": {
          "one": "Proceso de onboarding",
          "other": "Procesos de onboarding"
        },
        "customer_success/interview": {
          "one": "CS Entrevista",
          "other": "CS Entrevistas"
        },
        "default_signer": {
          "one": "Firmante",
          "other": "Firmantes"
        },
        "direct_link": {
          "one": "Anclar recurso",
          "other": "Anclar recursos"
        },
        "document": {
          "one": "Documento",
          "other": "Documentos"
        },
        "document_compression": {
          "one": "Documentos comprimidos",
          "other": "Documentos comprimidos"
        },
        "document_type": {
          "one": "Tipo de documento",
          "other": "Tipos de documentos"
        },
        "document_type_battery": {
          "one": "Batería de documentos",
          "other": "Baterías de documentos"
        },
        "document_type_signer": {
          "one": "Firmante",
          "other": "Firmantes"
        },
        "dt/annexe/entity_integration": {
          "one": "Integración de anexo con DT",
          "other": "Integraciones de anexos con DT"
        },
        "dt/bulk/load/annexe_record": {
          "one": "Envío documento anexo MiDT",
          "other": "Envío documento anexos MiDT"
        },
        "dt/bulk/load/contract_record": {
          "one": "Envío documento contrato MiDT",
          "other": "Envío documento contratos MiDT"
        },
        "dt/contract/entity_integration": {
          "one": "Integración de contrato con DT",
          "other": "Integraciones de contratos con DT"
        },
        "dt/credential": {
          "one": "Credenciales DT",
          "other": "Credenciales DT"
        },
        "dt/entity_integration": {
          "one": "Integración con DT",
          "other": "Integraciones con DT"
        },
        "dt/mapping_field": {
          "one": "Campo de homologación DT",
          "other": "Campos de homologación DT"
        },
        "dt/record/info": {
          "one": "Información del registro",
          "other": "Informaciones del registro"
        },
        "dt/record/integration": {
          "one": "Integración con DT",
          "other": "Integraciones con DT"
        },
        "dt/setting/fetch_dt_info_request": {
          "one": "Configuración de consulta DT",
          "other": "Configuraciones de consulta DT"
        },
        "ecert/bulk/signing": {
          "one": "",
          "other": ""
        },
        "ecert/signature_certificate": {
          "one": "Certificado de FAO",
          "other": "Certificados de FAO"
        },
        "economic_crime/workflow/requirement": {
          "one": "Denuncia",
          "other": "Denuncias"
        },
        "economic_crime/workflow/requirement_stage": {
          "one": "Etapa de la denuncia",
          "other": "Etapas de la denuncia"
        },
        "email_provider/smtp_account": {
          "one": "Cuenta SMTP",
          "other": "Cuentas SMTP"
        },
        "entity_folder/check_list": {
          "one": "Carpeta",
          "other": "Carpetas"
        },
        "entity_folder/check_list_requirement": {
          "one": "Documento requerido",
          "other": "Documentos requeridos"
        },
        "entity_folder/check_list_shared": {
          "one": "Compartir carpeta",
          "other": "Compartir carpetas"
        },
        "entity_folder/check_list_task": {
          "one": "Revisión de documento",
          "other": "Revisión de documentos"
        },
        "fao/mapping_config": {
          "one": "Homologación FAO",
          "other": "Homologación FAO"
        },
        "fao/mapping_field": {
          "one": "Campos Homologación FAO",
          "other": "Campos Homologación FAO"
        },
        "group": {
          "one": "Rol",
          "other": "Roles"
        },
        "karin_law/complaint": {
          "one": "Denuncia",
          "other": "Denuncias"
        },
        "karin_law/workflow/requirement": {
          "one": "Denuncia",
          "other": "Denuncias"
        },
        "karin_law/workflow/requirement_stage": {
          "one": "Etapa de la denuncia",
          "other": "Etapas de la denuncia"
        },
        "laboral/bulk/load/arauco/docx_merge_field": {
          "one": "Combinar correspondencia",
          "other": "Combinar correspondencia"
        },
        "laboral/bulk/load/arauco/docx_merge_field_item": {
          "one": "Item de combinación de correspondencia",
          "other": "Items de combinación de correspondencia"
        },
        "laboral/bulk/load/employee": {
          "one": "Carga de trabajadores",
          "other": "Carga de trabajadores"
        },
        "laboral/bulk/load/hiring": {
          "one": "Carga de contrataciones",
          "other": "Carga de contrataciones"
        },
        "laboral/bulk/load/hiring_document": {
          "one": "Carga Masiva de documentos",
          "other": "Carga Masiva de documentos"
        },
        "laboral/bulk/load/hiring_document_item": null,
        "laboral/bulk/load/hiring_item": {
          "one": "Carga masiva de contrataciones",
          "other": "Carga de Contrataciones"
        },
        "laboral/bulk/notification/sign": {
          "one": "Aviso de firmas pendientes",
          "other": "Aviso de firmas pendientes"
        },
        "laboral/bulk/notification/sign_item": null,
        "laboral/bulk/request/destroy_employee": {
          "one": "Eliminación Masiva de trabajadores",
          "other": "Eliminación Masiva de trabajadores"
        },
        "laboral/bulk/request/hiring_document": {
          "one": "Solicitud Masiva de documentos",
          "other": "Solicitud Masiva de documentos"
        },
        "laboral/bulk/request/hiring_document_config": {
          "one": "Solicitud de documentos",
          "other": "Solicitudes de documentos"
        },
        "laboral/bulk/request/hiring_document_item": null,
        "laboral/bulk/request/hiring_item": null,
        "laboral/document_type": {
          "one": "Tipo de documento",
          "other": "Tipos de documentos"
        },
        "laboral/document_type_batteries": {
          "one": "Batería de documentos",
          "other": "Baterías de documentos"
        },
        "laboral/employee": {
          "one": "Trabajador",
          "other": "Trabajadores"
        },
        "laboral/employee_config": null,
        "laboral/employee_document": {
          "one": "Documento",
          "other": "Documentos"
        },
        "laboral/employee_email_change": {
          "one": "Cambio de correo",
          "other": "Cambios de correo"
        },
        "laboral/employee_requirement_type": {
          "one": "Tipo de requerimiento",
          "other": "Tipos de requerimientos"
        },
        "laboral/hiring": {
          "one": "Contratación",
          "other": "Contrataciones"
        },
        "laboral/hiring_config": null,
        "laboral/hiring_document": {
          "one": "Documento",
          "other": "Documentos"
        },
        "membership": {
          "one": "Miembro",
          "other": "Miembros"
        },
        "portal/configuration": {
          "one": "Configuración del portal",
          "other": "Configuración del portal"
        },
        "report": {
          "one": "Reporte",
          "other": "Reportes"
        },
        "report/corporate/agreement_document": {
          "one": "Reporte de documento",
          "other": "Reporte de documentos"
        },
        "report/corporate/signer": {
          "one": "Reporte de firmante",
          "other": "Reporte de firmantes"
        },
        "report/laboral/hiring": {
          "one": "Reporte de contratación",
          "other": "Reporte de contrataciones"
        },
        "report/laboral/hiring_document": {
          "one": "Reporte de documento",
          "other": "Reporte de documentos"
        },
        "report/laboral/signer": {
          "one": "Reporte de firmante",
          "other": "Reporte de firmantes"
        },
        "security_layer": {
          "one": "Capa de seguridad",
          "other": "Capas de seguridad"
        },
        "shortlist/assessment_load": {
          "one": "Shortlist evaluación",
          "other": "Shortlist evaluaciones"
        },
        "shortlist/mapping_config": {
          "one": "Homologación Shortlist",
          "other": "Homologación Shortlist"
        },
        "shortlist/mapping_field": {
          "one": "Homologación Shortlist",
          "other": "Homologación Shortlist"
        },
        "signer": {
          "one": "Firmante",
          "other": "Firmantes",
          "sign_viewer": "Firmantes/Visadores"
        },
        "signer_configuration": {
          "one": "Firmante",
          "other": "Firmantes"
        },
        "signer_group": {
          "one": "Grupo de Firmantes",
          "other": "Grupo de Firmantes"
        },
        "signer_notification": {
          "one": "Notificar",
          "other": "Notificar a los firmantes"
        },
        "unsubscribed/email": {
          "one": "Email no suscrito",
          "other": "Emails no suscritos"
        },
        "user": {
          "one": "Usuario",
          "other": "Usuarios"
        },
        "versioner/collaborator": {
          "one": "Colaborador",
          "other": "Colaboradores"
        },
        "versioner/document/item": {
          "one": "Versión",
          "other": "Versiones"
        },
        "versioner/document/thread": {
          "one": "Proyecto",
          "other": "Proyectos"
        },
        "workflow/edge": {
          "one": "Conector",
          "other": "Conectores"
        },
        "workflow/group": {
          "one": "Encargado de la etapa",
          "other": "Encargados de la etapa"
        },
        "workflow/input_stage_form": {
          "one": "Dato de entrada",
          "other": "Datos de entrada"
        },
        "workflow/output_stage_form": {
          "one": "Dato de salida",
          "other": "Datos de salida"
        },
        "workflow/process": {
          "one": "Proceso",
          "other": "Procesos"
        },
        "workflow/requirement": {
          "one": "Requerimiento",
          "other": "Requerimientos"
        },
        "workflow/requirement_ebook": {
          "one": "Ebook",
          "other": "Ebooks"
        },
        "workflow/requirement_stage": {
          "one": "Etapa del requerimiento",
          "other": "Etapas del requerimiento"
        },
        "workflow/stage": {
          "one": "Etapa",
          "other": "Etapas"
        },
        "workflow/stage_field_item": {
          "one": "Requerimiento de la etapa",
          "other": "Requerimientos de las etapas"
        },
        "workflow/stage_file_item": {
          "one": "Documentos de la etapa",
          "other": "Documentos de las etapas"
        },
        "workflow/stage_form": {
          "one": "Dato",
          "other": "Datos"
        },
        "workflow/stage_output_file_item": {
          "one": "Documento de salida",
          "other": "Documentos de salida"
        }
      }
    },
    "add_documentation": "Crear Documentación",
    "advanced_settings": "Configuración Avanzada",
    "ai": {
      "tools": {
        "compliance_activity_container_create_tool__create_container": "Creando contenedor para las actividades",
        "compliance_activity_container_lookup_tool__find_container": "Buscando contenedor",
        "compliance_activity_create_tool__create_activity": "Creando actividad",
        "compliance_activity_destroy_tool__destroy_activities": "Eliminando actividad",
        "compliance_context_index_tool__index_customer_contexts": "Cargando contextos de cumplimiento",
        "compliance_custom_field_create_tool__create_custom_field": "Creando campo personalizado",
        "compliance_custom_field_index_tool__index_custom_fields": "Cargando campos personalizados",
        "compliance_group_index_tool__index_compliance_groups": "Cargando los grupos de cumplimiento",
        "compliance_risk_level_create_tool__create_risk_level": "Creando nivel de riesgo",
        "compliance_risk_level_index_tool__index_risk_levels": "Cargando niveles de riesgo",
        "compliance_risk_level_update_tool__update_risk_level": "Actualizando nivel de riesgo",
        "conversation_tool__set_current_assistant_class": "Cambiando el asistente actual",
        "files_tool__get_file_content": "Obteniendo contenido de archivo",
        "files_tool__list_chat_files": "Listando archivos de chat",
        "laboral_document_type_lookup_tool__find_document_types": "Buscando tipos de documentos",
        "laboral_employee_lookup_tool__find_employees": "Buscando empleados",
        "laboral_hiring_document_create_tool__upload_document": "Subiendo documento",
        "laboral_hiring_lookup_tool__find_hirings": "Buscando contratos"
      }
    },
    "arauco": {
      "document_mailer": {
        "notify_to_employee": {
          "subject": "Documento disponible para consulta"
        }
      }
    },
    "audits": {
      "act": "(Actual)",
      "actions": {
        "create": {
          "by": "Creado por"
        },
        "update": {
          "by": "Modificado por"
        }
      },
      "history": "Historico de modificaciones",
      "no_entry": "Vacío",
      "prev": "(Previo)"
    },
    "billing": {
      "accounts": {
        "form": {
          "confirm": {
            "message": "¿Estás seguro de actualizar la información de facturación?",
            "title": "Actualizar información de facturación"
          },
          "table": {
            "body": "Descripción",
            "product_type": "Tipo",
            "quantity": "Cantidad",
            "title": "Recurso"
          }
        },
        "index": null,
        "update": {
          "successfully": "La información de facturación ha sido actualizada correctamente"
        }
      }
    },
    "block": {
      "block_doc": "Bloquear documento",
      "description": "Descripción"
    },
    "blog": {
      "posts": {
        "actions": {
          "view_more": "Ver más Publicaciones"
        },
        "create": {
          "successfully": "La publicación ha sido creada correctamente"
        },
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar esta publicación? Ya no podrás recuperarla.",
            "title": "Eliminar publicación"
          },
          "successfully": "La publicación ha sido eliminada correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar la publicación?",
            "title": "Guardar publicación"
          },
          "cover_image_help": "Formatos permitidos: JPG, PNG o JPEG. Máximo 5MB.",
          "preview_content_help": "Breve texto para resumir el contenido de la entrada que aparece en los listados de posts. No es visible en la entrada completa.",
          "save": "Guardar publicación"
        },
        "update": {
          "successfully": "La publicación ha sido actualizada correctamente"
        }
      }
    },
    "blog/post": {
      "landing": {
        "about": "sobre",
        "back": "Volver al Blog",
        "by": "por",
        "category": "Categorías",
        "clients": "Gestionamos al mes más de 1 millón de documentos y 400 mil firmas de más de +150 clientes",
        "content_news": "contenido, tendencias y noticias",
        "discover": "Descubre",
        "document_handler": "Gestor Documental",
        "documents": "gestión documental y firma electrónica",
        "dt": "DT",
        "follow_us": "¡Síguenos en nuestras redes sociales!",
        "laboral": "Laboral",
        "meta_description": "Descubre más contenido, tendencias y noticias sobre gestión documental y firma electrónica que queremos compartir contigo.",
        "meta_title": "Blog",
        "more": "más",
        "no_posts_html": "Por el momento no hay publicaciones en el blog de ControlDoc. Visita nuestras redes sociales para descubrir más contenido.",
        "published": "Publicado",
        "read_more": "Leer más",
        "related_posts": "Artículos relacionados",
        "show_controldoc": "Descubre ControlDoc",
        "sign_everything": "Suma a tu empresa la Firma Electrónica Simple y Avanzada de ControlDoc Sign",
        "simplify_documents": "Simplifica el almacenamiento de documentación de tu empresa con ControlDoc",
        "start_now": "Comienza Ahora",
        "subscribe": "¡Suscríbete al blog de ControlDoc!",
        "talk_to_us": "Habla con un Vendedor",
        "weekly_content": "Recibe contenido semanal sobre gestión documental y firma electrónica",
        "welcome_text": "¡Bienvenido al blog de ControlDoc!",
        "with_you": "que queremos compartir contigo."
      }
    },
    "bulk": {
      "datatable": {
        "distribution_list_filters": {
          "create": {
            "successfully": "Lista de distribución creada correctamente"
          },
          "destroy": {
            "successfully": "Lista de distribución eliminada correctamente",
            "text": "¿Estas seguro de eliminar la lista de distribución <strong>%{name}</strong>?",
            "title": "Eliminar lista de distribución"
          },
          "edit": {
            "button": "Editar lista de distribución"
          },
          "new": {
            "button": "Nueva lista de distribución"
          },
          "update": {
            "successfully": "Lista de distribución actualizada correctamente"
          }
        }
      },
      "my_filters": {
        "create": {
          "successfully": "El filtro ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El filtro ha sido eliminado correctamente"
        },
        "form": {
          "add_filter": "Añadir Filtro",
          "confirm": {
            "message": "¿Estás seguro de agregar el filtro?",
            "title": "Agregar filtro"
          },
          "filter_name": "Nombre del campo",
          "filter_value": "Valor del campo",
          "filters_title": "Filtros que se aplicarán para la lista de distribución"
        },
        "index": {
          "without_results": "No hemos encontrado registros"
        },
        "show": null,
        "title": "Listas de distribución",
        "tooltip_info": "Utiliza la lista de distribución para crear y aplicar automáticamente múltiples filtros de forma rápida.",
        "update": {
          "successfully": "El filtro ha sido actualizado correctamente"
        }
      },
      "notification": {
        "fill_items": {
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "list": {
            "without_completed": "No hemos encontrado registros procesados",
            "without_completed_errors": "No hemos encontrado registros con errores",
            "without_pending": "No hemos encontrado registros pendientes",
            "without_processing": "No hemos encontrado registros en proceso"
          },
          "show": {
            "errors": "Errores"
          }
        },
        "fills": {
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "form": {
            "cant_fill_selected": "Has seleccionado %{count} Formularios.",
            "confirm": {
              "message": "¿Estás seguro de realizar la notificación masiva?",
              "title": "Realizar notificación masiva"
            }
          },
          "index": {
            "without_results": "No hemos encontrado registros"
          },
          "show": {
            "details": "Detalles",
            "fills": "Formularios",
            "tabs": {
              "all": "Todos",
              "completed": "Procesados",
              "completed_errors": "Procesados con errores",
              "failed": "Fallido",
              "pending": "Pendientes"
            },
            "without_results": "No hemos encontrado registros"
          },
          "tooltip_info": "Selecciona varios formularios pendientes para notificar su completación"
        },
        "sign_items": {
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "list": {
            "without_completed": "No hemos encontrado registros procesados",
            "without_completed_errors": "No hemos encontrado registros con errores",
            "without_pending": "No hemos encontrado registros pendientes",
            "without_processing": "No hemos encontrado registros en proceso"
          },
          "show": {
            "errors": "Errores"
          }
        },
        "signs": {
          "create": {
            "succesfully": "Notificación masiva de firmas ha sido creada correctamente"
          },
          "destroy": {
            "succesfully": "Notificación masiva de firmas ha sido eliminada correctamente"
          },
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "form": {
            "cant_sign_selected": "Has seleccionado %{count} Firmas.",
            "confirm": {
              "message": "¿Estás seguro de realizar la notificación masiva?",
              "title": "Realizar notificación masiva"
            },
            "table": {
              "label": "Lista de firmas pendientes"
            }
          },
          "index": {
            "without_results": "No hemos encontrado registros"
          },
          "show": {
            "details": "Detalles",
            "signs": "Firmas",
            "tabs": {
              "all": "Todos",
              "completed": "Procesados",
              "completed_errors": "Procesados con errores",
              "failed": "Fallido",
              "pending": "Pendientes"
            },
            "without_results": "No hemos encontrado registros"
          },
          "tooltip_info": "Selecciona varios firmantes pendientes para solicitar firma de documentación",
          "update": {
            "succesfully": "Notificación masiva de firmas ha sido actualizada correctamente"
          }
        }
      },
      "rejection": {
        "create": {
          "successfully": "El firmado ha sido creado correctamente"
        }
      },
      "request": {
        "destroy_document_items": {
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "list": {
            "without_results": "No hemos encontrado registros"
          },
          "show": {
            "errors": "Errores"
          }
        },
        "destroy_documents": {
          "create": {
            "succesfully": "Eliminación masiva de documentos ha sido creado correctamente"
          },
          "destroy": {
            "succesfully": "Eliminación masiva de documentos ha sido eliminado correctamente"
          },
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "form": {
            "confirm": {
              "message": "¿Estás seguro de realizar la eliminación de documentos?",
              "title": "Realizar eliminación de documentos"
            }
          },
          "index": {
            "without_results": "No hemos encontrado registros"
          },
          "show": {
            "details": "Detalles",
            "documentos": "Firmas",
            "tabs": {
              "all": "Todos",
              "completed": "Procesados",
              "completed_errors": "Procesados con errores",
              "failed": "Fallido",
              "pending": "Pendientes"
            },
            "without_results": "No hemos encontrado registros"
          },
          "tooltip_info": "Selecciona los documentos que requieres eliminar",
          "update": {
            "succesfully": "Eliminación masiva de documentos ha sido actualizado correctamente"
          }
        },
        "zip": {
          "document_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "document_mailer": {
            "notify_to_requester": {
              "subject": "Descarga masiva de documentos"
            }
          },
          "documents": {
            "create": {
              "succesfully": "Descarga de documentos ha sido creado correctamente"
            },
            "destroy": {
              "succesfully": "Descarga de documentos ha sido eliminado correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "confirm": {
                "message": "¿Estás seguro de realizar la descarga de documentos?",
                "title": "Realizar descarga de documentos"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "documentos": "Firmas",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona los documentos que requieres descargar",
            "update": {
              "succesfully": "Descarga de documentos ha sido actualizado correctamente"
            }
          }
        }
      },
      "signing": {
        "create": {
          "successfully": "El firmado ha sido creado correctamente"
        }
      }
    },
    "calendar": {
      "holiday_events": {
        "create": {
          "succesfully": "El feriado ha sido creado correctamente"
        },
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar el feriado?",
            "title": "Eliminar feriado"
          },
          "succesfully": "El feriado ha sido eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el feriado?",
            "title": "Guardar feriado"
          }
        },
        "update": {
          "succesfully": "El feriado ha sido actualizado correctamente"
        }
      },
      "records": {
        "create": {
          "successfully": "El calendario ha sido creado correctamente"
        },
        "destroy": {
          "confirm": {
            "message": "Esta acción no se puede deshacer.",
            "title": "¿Estás seguro de querer eliminar este calendario?"
          },
          "successfully": "El calendario ha sido eliminado correctamente"
        },
        "update": {
          "successfully": "El calendario ha sido actualizado correctamente"
        }
      },
      "work_schedules": {
        "add_chilean_holidays": {
          "confirm": {
            "message": "¿Estás seguro de guardar los feriados chile?",
            "title": "Guardar feriados chile"
          }
        },
        "configuration": {
          "one": "Configuración"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el calendario laboral?",
            "title": "Guardar calendario laboral"
          }
        },
        "save_chilean_holidays": {
          "successfully": "Los feriados chile han sido guardados correctamente"
        },
        "show": {
          "details": "Detalles del calendario laboral"
        },
        "tooltip_info": "Administra los calendarios laborales de tu empresa"
      }
    },
    "change_log": {
      "index": {
        "back_to_dashboard": "Volver a dashboard ControlDoc",
        "description": "Descubre las nuevas funcionalidades y mejoras que hemos implementado para ti!",
        "go_to_accounts": "Ir a mis cuenta",
        "go_to_changelogs": "Actualizaciones",
        "go_to_wiki": "Centro De Ayuda",
        "no_posts_html": "Por el momento no hay publicaciones en ControlDoc News. Visita nuestro centro de ayuda para aprender a usar ControlDoc y nuestras redes sociales para descubrir más contenido.",
        "published": "Publicado",
        "read_more": "Descubre más",
        "title": "ControlDoc News"
      },
      "new": "Nuevo"
    },
    "check_list": {
      "processes": {
        "form": {
          "create": {
            "confirm": {
              "message": "¿Estás seguro de crear el check list?",
              "title": "Crear check list"
            }
          },
          "labels": {
            "add_document_type": "Agregar tipo de documento",
            "delete_document_type": "Eliminar tipo de documento",
            "document_count_amount": "Cantidad de documentos",
            "documents_per_document_type": "Cantidad de documentos por tipo de documento"
          },
          "share": {
            "confirm": {
              "message": "¿Estás seguro de compartir el check list?",
              "title": "Compartir check list"
            },
            "succesfully": "El check list ha sido compartido correctamente"
          },
          "update": {
            "confirm": {
              "message": "¿Estás seguro de actualizar el check list?",
              "title": "Actualizar check list"
            }
          }
        },
        "refresh": {
          "confirm": {
            "message": "¿Estás seguro de refrescar el check list?",
            "title": "Refrescar check list"
          }
        },
        "requires_autorefresh": {
          "tooltip_info": "Al marca esta opción el sistema por defecto actualizará las tareas del Check list una vez al día"
        },
        "requires_document_count_per_document_type": {
          "tooltip_info": "Por defecto, los tipos de documentos seleccionados están configurados para un solo documento. En la lista solo aparecerán aquellos que soliciten una cantidad mayor."
        },
        "select_all": "Seleccionar todos",
        "show": {
          "details": "Detalles del check list"
        },
        "tooltip_info": "Revisa y controla documentos asociados a contrataciones para identificar documentación lista o pendiente"
      },
      "shared_process_mailer": {
        "notify_shared_process": {
          "subject": "Check List Compartido"
        }
      },
      "shared_processes": {
        "form": {
          "select": {
            "placeholder": "Ingrese los correos electrónicos"
          }
        },
        "mailer": {
          "notify_shared_process": {
            "subjet": "Check List Compartido"
          }
        },
        "show": {
          "details": "Detalles"
        }
      },
      "tasks": {
        "form": {
          "details": "Detalles de la tarea",
          "new_document": "Vincular nuevo documento",
          "no_document_options": "No encontramos documentos que coincidan con el requerimiento"
        },
        "index": {
          "tabs": {
            "completed": "Completadas",
            "pending": "Pendientes",
            "reviewed": "Revisadas"
          },
          "without_results": "No hemos encontrado tareas"
        },
        "is_reviewed": {
          "false": "No",
          "true": "Sí"
        },
        "show": {
          "details": "Detalles del check list",
          "verify_task": "Verificación de la tarea",
          "without_documents": "No hemos encontrado documentos asociados"
        },
        "tooltip_info": "Solicitudes de revisión o auditoría de documentación"
      }
    },
    "comments": {
      "create": {
        "successfully": "El comentario ha sido creado correctamente"
      }
    },
    "common": {
      "dashboard": {
        "control_sidebar": {
          "title": "Aplicar Filtros"
        },
        "controldoc_app": {
          "apps": "Apps",
          "button_title": "Ir a",
          "compliance": "Gestor Documental",
          "forms": "Formularios",
          "my_documents": "Mis Documentos",
          "sign": "Firma",
          "user_portal": "Portal Usuario"
        },
        "footer": {
          "faq": "FAQ",
          "help_center": "Centro de Ayuda",
          "help_disclaimer": "Horario de Atención: Lunes a viernes de 9 a 18 hrs",
          "normative": "Normativa",
          "privacy-policy": "Política de Privacidad"
        },
        "header": {
          "billing": {
            "account": "Cuenta",
            "one": "Facturación"
          },
          "changelog": "Actualizaciones",
          "configuration": "Configuración",
          "help": "Ayuda",
          "help_center": "Centro de Ayuda",
          "help_info_html": "<span class='d-block'>Si necesitas Soporte o Ayuda escríbenos a </span><strong>hola@controldoc.cl</strong> o <strong>chat de Soporte</strong><span class='d-block small'>Lunes a viernes de 9 a 18 hrs.</span>",
          "ia": "ControlDoc +IA",
          "notifications": "Notificaciones",
          "portal": "Portal Empresa",
          "profile": {
            "edit": "Cambiar Método de Firma"
          },
          "suspension_message": "El acceso a su cuenta será suspendida el día %{date} por %{reason}"
        },
        "metrics": {
          "document": {
            "expired": "Caducados",
            "in_force": "Vigentes",
            "to_expire": "Por caducar",
            "with_expires_at": "Con fecha de expiración",
            "without_expires_at": "Sin fecha de expiración"
          },
          "hiring": {
            "active": "Activas",
            "expired": "inactivas"
          },
          "signer": {
            "blocked": "Bloqueos",
            "completed": "Completados",
            "pending": "Pendientes",
            "rejected": "Rechazados"
          }
        },
        "partners": {
          "coreone": {
            "benefits": {
              "item_1": {
                "description": "Entornos inmersivos para entrenar situaciones críticas.",
                "title": "Simulaciones realistas"
              },
              "item_2": {
                "description": "Desarrolla habilidades en un entorno seguro.",
                "title": "Aprendizaje práctico"
              },
              "item_3": {
                "description": "Evaluación y trazabilidad del aprendizaje.",
                "title": "Resultados medibles"
              }
            },
            "btn_cta": "Accede a esta promoción exclusiva CoreOne",
            "description": "Plataforma de entrenamiento inmersiva y realidad extendida. Prepara mejor a tus equipos, reduce riesgos y cumple con las normativas.",
            "normatives": {
              "item_1_html": "<p class='lh-sm mb-0'><strong class='d-block'>DS-44 Art. 16</strong>Condiciones sanitarias y ambientales en lugares de trabajo</p>",
              "item_2_html": "<p class='lh-sm mb-0'><strong class='d-block'>Circular SUSESO 3336</strong>Programas de capacitación en prevención de riesgos</p>",
              "item_3_html": "<p class='lh-sm mb-0'><strong class='d-block'>Ley 16.744</strong>Seguro social contra accidentes del trabajo</p>",
              "item_4_html": "<p class='lh-sm mb-0'><strong class='d-block'>NCh 2728</strong>Norma chilena de organismos técnicos de capacitación</p>",
              "item_5_html": "<p class='lh-sm mb-0'><strong class='d-block'>ISO 45001</strong>Sistema de gestión de seguridad y salud en el trabajo</p>",
              "item_6_html": "<p class='lh-sm mb-0'><strong class='d-block'>OSHA Standards</strong>Estándares internacionales de seguridad ocupacional</p>",
              "title": "Programas alineados a normativas Chilenas e Internacionales:"
            },
            "promo": {
              "btn": "Quiero este beneficio",
              "description": "Por ser cliente ControlDoc, accede a una beca especial 2x1. Por cada capacitación contratada para 1 colaborador, CoreOne bonifica la participación de 1 colaborador adicional gratis.",
              "fine_print": "Beneficio exclusivo para empresas con más de 100 colaboradores y aplicable a programas de capacitación diseñados para un mínimo de 100 participantes. Sujeto a evaluación comercial y condiciones del programa.",
              "subtitle": "Lleva tus capacitaciones al siguiente nivel",
              "title_html": "Capacita a 2 colaboradores <span class='text-coreone'>pagando solo 1</span><br> y con Franquicia tributaria <span class='text-coreone'>SENCE</span>"
            },
            "subtitle": "Transforma tus capacitaciones en experiencias de alto impacto",
            "tags": "Realidad Extendida + Gamificación",
            "title": "CoreOne - Cinder"
          },
          "description": "Complementa tu gestión con nuestras alianzas y partners.",
          "sence": "Beneficio con Franquicia Tributaria SENCE",
          "stephai": {
            "badge": "Reclutamiento y Selección",
            "benefits": {
              "attract_candidates": {
                "description": "Publica tus vacantes en distintos canales y centraliza todas las postulaciones en un solo lugar.",
                "title": "Atrae candidatos"
              },
              "filter_and_interview": {
                "description": "StephAI analiza CV y entrevista candidatos con preguntas contextualizadas al cargo para ayudarte a tomar mejores decisiones.",
                "title": "Filtra y entrevista con IA"
              },
              "simple_application": {
                "description": "Los candidatos cargan su CV, completan sus datos y conversan con StephAI para avanzar fácilmente en el proceso.",
                "title": "Postulación simple, sin registros eternos"
              },
              "video_interviews": {
                "description": "Evalúa candidatos mediante videoentrevistas, sin coordinar reuniones una por una. Agiliza el proceso y mantén el control.",
                "title": "Videoentrevistas sin coordinaciones"
              }
            },
            "cta": {
              "btn": "Quiero este beneficio",
              "description": "Aprovecha esta oferta exclusiva y atrae talento de manera rápida, masiva y accesible.",
              "detail": "La IA agiliza el proceso. Tú tomas las decisiones.",
              "discount": "30% descuento",
              "title": "¡Cierra tus procesos de selección más rápido y con un"
            },
            "description": "Publica tus vacantes, recibe candidatos, filtra automáticamente con IA y realiza videoentrevistas desde un mismo lugar.",
            "disclaimer": "Oferta Exclusiva para clientes ControlDoc que se contacten a través del formulario. Proceso ilimitado sin límite de Candidatos.",
            "discount": "Por ser cliente de ControlDoc tienes un 30% de descuento en StephAI.",
            "title": "¿Necesitas contratar rápido?",
            "title_highlight": "Haz todo el proceso más simple con StephAI"
          },
          "title": "Beneficios Exclusivos para clientes ControlDoc",
          "tooltip_info": "Accede a Promociones Exclusivas."
        },
        "sidebar": {
          "accounts": "Mis Cuentas",
          "audits": "Revisión de documentos",
          "billing": {
            "account": "Cuenta",
            "one": "Facturación"
          },
          "bulk": {
            "load": {
              "hiring": "Carga de contrataciones",
              "hiring_document": "Carga Masiva de documentos",
              "one": "Cargas masivas",
              "other": "Carga de"
            },
            "notification": {
              "sign": "Notificationes de firmas"
            },
            "request": {
              "one": "Solicitudes masivas"
            }
          },
          "bulk_load": {
            "hiring": "Carga de contrataciones",
            "hiring_document": "Carga Masiva de documentos",
            "one": "Acciones masivas"
          },
          "compliance": "Cumplimiento",
          "configuration": "Configuración del Módulo",
          "controldoc_form": "ControlDoc Forms",
          "controldoc_sign": "ControlDoc Sign",
          "corporate": "Corporativo",
          "corporate_controldoc_form": "ControlDoc Forms",
          "dashboard": "Dashboard",
          "document_managment": "Gestión de Documentos",
          "documents": "Todos los Documentos",
          "dt": "Dirección del Trabajo",
          "general_configuration": {
            "one": "Configuración General"
          },
          "karin_law": "Ley Karin",
          "karinlaw": "Ley Karin",
          "labor": "Laboral",
          "laboral": "Laboral",
          "laboral_controldoc_form": "ControlDoc Forms",
          "laboral_controldoc_sign": "ControlDoc Sign",
          "massive_actions": "Importadores Masivos",
          "notifications": "Notificaciones",
          "orgs": "Organizaciones",
          "report": "Reporte",
          "shortlist": {
            "one": "Shortlist"
          },
          "templates": "Plantillas",
          "trash": "Papelera",
          "versioner": "Versionador",
          "workflow": {
            "one": "Workflow"
          }
        },
        "tooltip_info": "Bienvenida, accesos rápidos y resumen de tu cuenta y documentos.",
        "workspace_upgrade": {
          "compliance": {
            "description": "Diseñado para equipos que quieren adelantarse al compliance 2025, automatizar flujos y mantener el control total de su operación. ¿Cumplir sigue siendo caótico en tu organización? Nosotros te ayudamos a cambiar eso.",
            "title": "Centraliza compromisos, tareas, evidencias y documentos normativos en una sola plataforma.",
            "tooltip_info": "Desbloquea el Módulo Cumplimiento."
          },
          "dt": {
            "description": "ControlDoc te permite visualizar el estado en tiempo real y acceder al historial completo desde una sola plataforma. Menos tareas manuales. Más cumplimiento sin estrés.",
            "title": "Automatiza tu cumplimiento y regulariza contratos y anexos conectando con el portal MiDT.",
            "tooltip_info": "Desbloquea el Módulo Dirección del Trabajo."
          },
          "economic_crime": {
            "description": "Gestiona denuncias, documentos y procesos con trazabilidad total y evidencia accesible en todo momento. Somos distintos, y te mostramos por qué nuestra tecnología marca la diferencia en empresas, instituciones y municipalidades. ¿Tus procesos resistirían una fiscalización hoy? Contáctanos",
            "title": "Gestiona procesos críticos desde una sola plataforma.",
            "tooltip_info": "Desbloquea el Módulo Ley de Delitos Económicos."
          },
          "karin_law": {
            "description": "Organiza casos, automatiza flujos de investigación y asegura la trazabilidad de cada etapa, incluyendo los tiempos en que se presenta y gestiona una denuncia. Somos tu aliado en el cumplimiento de la Ley N° 21.643, con un enfoque real en protección, eficiencia y respaldo documental.",
            "title": "Gestiona denuncias con cumplimiento normativo y tecnología de vanguardia.",
            "tooltip_info": "Desbloquea el Módulo Ley Karin."
          }
        }
      },
      "documentation_button": {
        "tutorial": "Instrucciones"
      },
      "documentation_modal": {
        "description": "Descripción",
        "tutorial": "Tutorial"
      },
      "landings": {
        "footer": {
          "complaint": "Canales de Denuncia: ",
          "contact": "Contacto: ",
          "contact_us": "Contáctanos",
          "corfo": {
            "description_html": "<b>CORFO</b> Ganadores <br/>Consolida y Expande 2021"
          },
          "dirtrab": {
            "description_html": "<b>Módulo laboral<br>Aprobado por la Dirección del Trabajo</b><br/>ORD Nº 4997 | 21 de octubre de 2019"
          },
          "economic_crime": "Delitos Económicos",
          "faq": "FAQ",
          "help_center": "Centro de Ayuda",
          "karin_law": "Ley Karin",
          "legal": "Legal:",
          "min": {
            "description_html": "<b>Firma Electronica Avanzada (FEA)<br>Aprobada por el ministerio de economía</b>"
          },
          "normative": "Normativa",
          "powered_by_html": "Un Servicio de <a href='https://4talent.cl/' class='font-weight-bold'>4Talent</a>.",
          "privacy-policy": "Política de Privacidad",
          "provided_by": {
            "address_html": "Av. Alonso de Córdova 6008, Oficina 201, Santiago. Chile",
            "description": "Empresa tecnológica especializada en la gestión de personas y recursos humanos."
          },
          "sales": "Ventas: ",
          "subtitle": "Sistema de gestión documental con firma electrónica. Rápido y simple.",
          "support": "Soporte / Ayuda: ",
          "terms-of-service": "Términos y Condiciones",
          "title": "ControlDoc"
        },
        "navbar": {
          "adp_config": "Configuración ADP",
          "avaliable_emails": "Emails disponibles",
          "blog": "Blog",
          "contact": "Contacto",
          "contact_us": "Contáctanos",
          "corporate": "Corporativo",
          "custom_brand": "Configurar mi marca",
          "demos": "Demos",
          "edit_my_account": "Configurar mi cuenta",
          "faq": "FAQS",
          "forms": "Formularios",
          "help": "Ayuda",
          "help_center": "Centro de Ayuda",
          "hi": "Hola %{name}",
          "home": "Inicio",
          "how_works": "¿Cómo funciona?",
          "laboral": "Laboral",
          "municipal": "Municipios",
          "normative": "Normativa",
          "pricing": "Precios",
          "products": "Productos",
          "purchases": "Mis compras",
          "questions": "Preguntas",
          "rates": "Tarifas",
          "services": "Servicios",
          "services_complaint": "Canales de Denuncias",
          "services_compliance": "Cumplimiento",
          "services_docs": "Gestión Documental",
          "services_sign": "Firma Electrónica",
          "sign": "Firma Electrónica",
          "sign_your_documents": "Firma tus documentos",
          "tutorial": "Tutorial",
          "what_is_it": "¿Qué es?",
          "what_is_it_for": "¿Para qué sirve?"
        }
      }
    },
    "communication_channel_mailer": {
      "communication_by_email": {
        "subject": "[ControlDoc] Nueva actualización disponible"
      }
    },
    "communication_channels": null,
    "compliance": {
      "activities": {
        "create": {
          "successfully": "La actividad ha sido creado correctamente",
          "successfully_with_resource": "Procesando actividades mientras se asocian los recursos del módulo"
        },
        "custom_fields": "Otros datos de la actividad",
        "destroy": {
          "confirm": {
            "message": " <p> ¿Estás seguro de eliminar la actividad? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará la actividad.</li> <li>Eliminará las evidencias asociadas a la actividad.</li> <li>Eliminará las tareas asociadas a la actividad.</li> </ul> </div> ",
            "title": "Eliminar actividad"
          },
          "successfully": "La actividad ha sido eliminado correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la actividad</li> <li>Descripción de la actividad</li> <li>Responsables de subir evidencias</li> <li>Responsables de revisar evidencias</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Creado en"
        },
        "form": {
          "alert_risk_level": "Es necesario que tengas al menos un nivel de riesgo configurado para poder crear una actividad.",
          "configuration": "Configuración de la actividad",
          "confirm": {
            "message": "¿Estás seguro de guardar la actividad?",
            "title": "Guardar actividad"
          },
          "help": {
            "days_for_perform": "Es el número de días que tienen los responsables para completar la tarea desde que se crea. Ejemplo: 30 días."
          },
          "title": "Información de la actividad"
        },
        "index": {
          "help": {
            "pending_review": "Si esta opción está activada, solo se mostrarán las actividades con evidencias pendientes de revisión."
          },
          "show": "Ver actividad completa",
          "without_results": "No has creado ninguna actividad aún."
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": " <p> ¿Estás seguro de eliminar la actividad? </p> <p class='text-danger'><strong>No es posible revertir esta acción.</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará las tareas.</li> <li>Eliminará las las evidencias relacionadas a las tareas.</li> </ul> </div> ",
              "title": "Eliminar Actividad"
            }
          },
          "resource_module": {
            "without_records": {
              "confirm": {
                "message": "Debe seleccionar un módulo que contenga al menos un registro para poder crear la actividad.",
                "title": "Módulo sin registros"
              }
            }
          }
        },
        "tooltip_assign_uploaders_by_email_notification": "Si esta opción está activada, se le solicitará subir la evidencia a un representante dentro del modulo seleccionado ó de su modulo relacionado.",
        "tooltip_evidences": {
          "documents": "Archivo principal u obligatorio que demuestra el cumplimiento, ejecución o resultado de la actividad.",
          "evidences": "Documentos complementarios al documento principal",
          "info": "Documentos que respaldan el cumplimiento, ejecución o resultado de la actividad"
        },
        "tooltip_groups": {
          "consultant_groups": "Estos grupos serán notificados cuando. <ul class='text-left pl-4'> <li>Se solicite cargar nueva evidencia</li> <li>El documento este listo para ser revisado</li> <li>El documento sea aprobado</li> <li>El documento sea rechazado</li> </ul>",
          "informer_groups": "Estos grupos serán notificados cuando <ul class='text-left pl-4'> <li>El documento este listo para ser revisado</li> <li>El documento sea aprobado</li> </ul>",
          "reviewer_groups": "Estos grupos serán notificados cuando <ul class='text-left pl-4'> <li>El documento este listo para ser revisado</li> </ul>",
          "uploader_groups": "Estos grupos serán notificados para <ul class='text-left pl-4'> <li>Subir evidencias</li> </ul>"
        },
        "tooltip_info": "Administra todas las actividades y sus datos",
        "tooltip_resource_module_name": "Selecciona los módulos donde la Actividad debe aplicarse con la misma frecuencia y responsables",
        "update": {
          "successfully": "La actividad ha sido actualizado correctamente"
        }
      },
      "activity_containers": {
        "destroy": {
          "confirm": {
            "message": " <p> ¿Estás seguro de eliminar el grupo de actividades? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará el grupo de actividades.</li> <li>Eliminará las actividades asociadas al grupo.</li> </ul> </div> ",
            "title": "Eliminar grupo de actividades"
          },
          "successfully": "El grupo de actividades ha sido eliminado correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del contenedor</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha de creación"
        },
        "index": {
          "without_results": "No se encontraron grupos de actividades."
        },
        "tooltip_info": "Administra todos los grupos de actividades generados por ControlDocIA"
      },
      "activity_group_checks": null,
      "activity_groups": {
        "create": {
          "successfully": "El Grupo ha sido creado correctamente"
        },
        "help": {
          "tooltip": {
            "mandatory": "Al menos un integrante de este grupo debe revisar la evidencia obligatoriamente."
          }
        }
      },
      "activity_mailer": {
        "deadline_reminder_to_reviewer": {
          "subject": "Fecha límite alcanzada - Evidencias pendientes de revisar"
        },
        "deadline_reminder_to_uploader": {
          "subject": "Fecha límite alcanzada - Evidencias pendientes de subir"
        },
        "document_approved_notification": {
          "subject": "Documento aprobado - ¡Gracias por tu trabajo!"
        },
        "document_ready_for_review": {
          "subject": "Documento listo para ser revisado"
        },
        "document_reupload_required": {
          "subject": "Documento no aprobado - Necesita revisión"
        },
        "new_activity_notification": {
          "subject": "Nueva actividad disponible para cargar evidencia"
        }
      },
      "bulk": {
        "load": {
          "activities": {
            "create": {
              "successfully": "La carga de actividades ha sido creado correctamente"
            },
            "destroy": {
              "successfully": "La Actividad ha sido eliminado correctamente"
            },
            "form": {
              "activity_field": "Campo Actividad",
              "custom_field_help": "Campo personalizado (%{data_type}).",
              "file_field": "Cabecera del archivo",
              "file_placeholder": "Archivo a importar",
              "help": "*Aquí debes asociar las columnas del archivo con los campos de las actividades.",
              "select_placeholder": "-- Selecciona la cabecera --",
              "title": "Información de la Actividad"
            },
            "new": {
              "title": "Nueva carga de actividades",
              "tooltip_info": "Crea una nueva carga masiva de actividades"
            },
            "steps": {
              "continue": {
                "confirm": {
                  "message": "¿Estás seguro de continuar con la carga de actividades?",
                  "title": "Continuar con la carga de actividades"
                }
              }
            },
            "tooltip_info": "Administra todas las cargas de actividades y sus datos",
            "update": {
              "successfully": "La carga de actividades ha sido actualizado correctamente"
            }
          }
        }
      },
      "consultant_groups": {
        "bulk": {
          "load": {
            "field_help": "Listado de grupos consultados separados por coma (,)."
          }
        }
      },
      "custom_fields": {
        "create": {
          "successfully": "El campo personalizado ha sido creado correctamente"
        },
        "destroy": {
          "confirm": {
            "message": " <p> ¿Estás seguro de eliminar el campo personalizado? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará el campo personalizado.</li> <li>Eliminará la información del campo personalizado asociada de las actividades.</li> </ul> </div> ",
            "title": "Eliminar campo personalizado"
          },
          "successfully": "El campo personalizado ha sido eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el campo personalizado?",
            "title": "Guardar campo personalizado"
          }
        },
        "index": {
          "without_results": "No hemos encontrado campos personalizados"
        },
        "list_options": {
          "help": "Para agregar opciones en la lista debe ingresar los campos separados por coma (,)"
        },
        "show": {
          "details": "Detalles del campo personalizado"
        },
        "show_on_list": {
          "help": "Permite mostrar la información como parte de la lista para trabajador o contratación según el recurso seleccionado"
        },
        "tooltip_info": "Agrega y gestiona campos de información que consideres relevante para tu gestión de actividades",
        "update": {
          "successfully": "El campo personalizado ha sido actualizado correctamente"
        },
        "update_order": {
          "successfully": "Los campo personalizado han sido ordenados correctamente"
        }
      },
      "dashboards": {
        "complete_overview": "Vista general de actividades",
        "current_risk_level": "Nivel de riesgo actual de actividades",
        "current_risk_level_to_evidences": "Nivel de riesgo actual de evidencias",
        "pending_review": "Evidencias pendientes por nivel de riesgo",
        "tooltip_info": "Mira el estado de general de tu módulo de cumplimiento."
      },
      "evidence_files": {
        "form": {
          "approve": "Aprobar",
          "confirm": {
            "message": "¿Estás seguro de guardar la actividad?",
            "title": "Guardar actividad"
          },
          "reject": "Rechazar",
          "title": "Información de la Actividad"
        },
        "review": {
          "successfully": "La evidencia ha sido revisada correctamente"
        }
      },
      "evidence_loads": {
        "create": {
          "successfully": "La Carga de evidencias ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "La Carga de evidencias ha sido eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de subir las evidencias que cargaste?",
            "title": "Subir evidencias"
          },
          "title": "Información de la Carga de evidencias"
        },
        "update": {
          "successfully": "La Carga de evidencias ha sido actualizado correctamente"
        }
      },
      "evidences": {
        "create": {
          "successfully": "La Actividad ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "La Actividad ha sido eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar la actividad?",
            "title": "Guardar actividad"
          },
          "title": "Información de la Actividad"
        },
        "show": {
          "detail": "Detalle de la Evidencia",
          "detail_activity": "Detalle de la Actividad",
          "detail_evidence_files_rejected": "Detalle de las evidencias rechazadas"
        },
        "tooltip_info": "Administra todas las evidencias y sus datos",
        "update": {
          "successfully": "La Actividad ha sido actualizado correctamente"
        }
      },
      "groups": {
        "create": {
          "successfully": "El Grupo ha sido creado correctamente"
        },
        "destroy": {
          "confirm": {
            "message": " <p> ¿Estás seguro de eliminar el grupo? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará el grupo de todas las actividades asociadas.</li> </ul> </div> ",
            "title": "Eliminar Grupo"
          },
          "successfully": "El Grupo ha sido eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de Crear el Grupo?",
            "title": "Crear el Grupo"
          },
          "title": "Grupo"
        },
        "tooltip_info": "Maneja los grupos",
        "update": {
          "successfully": "El Grupo ha sido actualizado correctamente"
        },
        "without_members": "Este grupo aun no tiene integrantes."
      },
      "informer_groups": {
        "bulk": {
          "load": {
            "field_help": "Listado de grupos informados separados por coma (,)."
          }
        }
      },
      "reviewer_groups": {
        "bulk": {
          "load": {
            "field_help": "Listado de grupos encargados de revisar la evidencia separados por coma (,)."
          }
        }
      },
      "risk_levels": {
        "create": {
          "successfully": "El nivel de riesgo ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El nivel de riesgo ha sido eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estas seguro de crear un nivel de riesgo con esta información?",
            "title": "Confirmación"
          },
          "title": "Datos del Nivel de Riesgo"
        },
        "modal_confirm_destroy": {
          "current": "Actual",
          "new": "Nuevo",
          "question": "¿Estás seguro de eliminar este nivel de riesgo?",
          "text_html": "Existen actividades relacionadas con el nivel de riesgo <strong>%{name}</strong>. Para continuar con la eliminación, selecciona un nuevo nivel de riesgo para dichas actividades.",
          "title": "Eliminar nivel de riesgo"
        },
        "tooltip_info": "Administra todos los niveles de riesgo y sus datos",
        "update": {
          "successfully": "El nivel de riesgo ha sido actualizado correctamente"
        }
      },
      "uploader_groups": {
        "bulk": {
          "load": {
            "field_help": "Listado de grupos encargados de subir la evidencia separados por coma (,)."
          }
        }
      }
    },
    "controldoc": {
      "datatable": {
        "distribution_list_filter": {
          "modal": {
            "title": "Configuración de la lista de distribución"
          },
          "new": "Nueva lista de distribución",
          "title": "Listas de distribución",
          "tooltip_info": "Utiliza la lista de distribución para crear y aplicar automáticamente múltiples filtros de forma rápida."
        }
      }
    },
    "controldoc_form": {
      "document_mailer": {
        "send_to_fill": {
          "subject": "Completar formulario"
        }
      },
      "documents": {
        "actions": {
          "fill": "Llenar"
        },
        "block": {
          "errors": "El documento no pudo bloquearse",
          "succesfully": "El documento ha sido bloqueado correctamente",
          "title": "Bloquear Documento"
        },
        "complete": {
          "confirm": {
            "message": "Una vez enviada la información no es posible editar",
            "title": "Enviar información"
          },
          "successfully": "Plantilla completada con éxito"
        },
        "filter": {
          "by_aasm_state": "Estado",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la Plantilla</li> <li>Email</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio",
          "with_group_by": "Rol"
        },
        "index": {
          "without_results": "No hemos encontrado documentos asociadas"
        },
        "list": {
          "send": "Enviado a"
        },
        "show": {
          "details": "Documento",
          "other_data": "Otros datos",
          "signers": "Firmantes"
        },
        "tooltip_info": "Visualiza los envíos realizados y completados en ControlDoc Forms"
      },
      "template_layouts": {
        "create": {
          "successfully": "Diseño creado con éxito"
        },
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar el diseño de la plantilla?",
            "title": "Eliminar diseño"
          },
          "successfully": "Diseño eliminado con éxito"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del diseño</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el diseño?",
            "title": "Guardar Diseño"
          },
          "error": "Problema con integración",
          "save": "Guardar"
        },
        "tooltip_info": "Personaliza tus plantillas creando tus diseños agregando cabecera y pie de página",
        "update": {
          "successfully": "Diseño actualizado con éxito"
        }
      },
      "template_mapping_links": {
        "filter": {
          "by_aasm_state": "Estado",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la Plantilla</li> <li>Email</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio",
          "with_group_by": "Rol"
        },
        "form": {
          "opt_group": {
            "adp_fields": {
              "one": "Campos de ADP"
            },
            "custom_fields": {
              "one": "Campos personalizados"
            },
            "hiring_custom_date_format": {
              "one": "Fechas de contrato"
            },
            "resource_data": {
              "one": "Información del recurso"
            },
            "system_information": {
              "one": "Información de sistema"
            }
          },
          "resource": {
            "corporate_agreement": {
              "one": "Contrato"
            },
            "corporate_company_client": {
              "one": "Empresa Cliente"
            },
            "corporate_company_provider": {
              "one": "Empresa Proveedora"
            },
            "laboral_employee": {
              "one": "Trabajador"
            },
            "laboral_hiring": {
              "one": "Contratación"
            },
            "system_resource": {
              "one": "Sistema"
            }
          }
        },
        "index": {
          "without_results": "No hemos encontrado documentos asociadas"
        },
        "list": {
          "send": "Enviado a"
        },
        "tooltip_info": "Visualiza los envíos realizados y completados en ControlDoc Forms"
      },
      "templates": {
        "assign_mapping_links": {
          "successfully": "Mapeo de plantilla con éxito"
        },
        "create": {
          "succesfully": "Plantilla creada con éxito"
        },
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar la plantilla?",
            "title": "Eliminar plantilla"
          },
          "succesfully": "Plantilla eliminada con éxito"
        },
        "filter": {
          "by_company": "Empresa",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la plantilla</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio",
          "with_group_by": "Rol"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar la plantilla?",
            "title": "Guardar plantilla"
          },
          "homologize_fields": "Homologar campos",
          "is_controldoc_consent_annex_help": "Si es un anexo de consentimiento, esta plantilla estará disponible para enviarle al trabajador dicho consentimiento."
        },
        "index": {
          "sync": "Sincronización",
          "without_results": "No hemos encontrado plantillas asociadas"
        },
        "list": {
          "homologize_fields": "Homologar campos",
          "mapping": "Mapear"
        },
        "show": {
          "details": "Plantilla",
          "details_vars": "Autocompletar Plantilla",
          "details_vars_info": "Determina con qué información completarás la plantilla",
          "homologize_fields": "Homologar campos",
          "map_fields": "Asignar campos",
          "var_blank": "Si la tabla se deja en blanco, se interpreta que los campos de la plantilla serán completados posteriormente por cada usuario."
        },
        "sync": {
          "message": "Sincronización exitosa"
        },
        "table": {
          "attribute": "Atributo",
          "info": {
            "attribute": "Dato a completar en la variable de la plantilla",
            "model": "El recurso desde donde se extraerá el dato para completar la plantilla",
            "name": "Nombre",
            "type": "Tipo",
            "var": "El campo a completar en la plantilla"
          },
          "map": "Mapeo",
          "model": "Módulo / Recurso",
          "name": "Nombre",
          "type": "Tipo",
          "value": "Valor",
          "var": "Variable"
        },
        "tooltip_info": "Crea y visualiza tus plantillas con campos abiertos. Homologa campos para que sean autocompletados por el sistema.",
        "update": {
          "successfully": "Plantilla actualizada con éxito"
        }
      }
    },
    "corporate": {
      "activerecord": {
        "attributes": {
          "bulk/request/zip/document": {
            "aasm_state": {
              "completed": "Procesado",
              "completed_errors": "Procesado con errores",
              "failed": "Fallido",
              "one": "Estado",
              "pending": "Pendiente",
              "processing": "Procesando"
            },
            "created_at": "Fecha creación",
            "files": "Archivos",
            "requested_by": "Solicitado por"
          },
          "corporate/controldoc_form/document": {
            "aasm_state": {
              "blocked": "Bloqueado",
              "filled": "Completado",
              "one": "Estado",
              "partially_filled": "En proceso",
              "pending": "Pendiente"
            },
            "blocked_by": "Bloqueado por",
            "controldoc_state": "Estado de firma:",
            "created_at": "Fecha de creación",
            "created_by_id": "Creado por",
            "email": "Nombre"
          },
          "corporate/controldoc_form/template": {
            "content": "Contenido",
            "created_by_id": "Creado por",
            "name": "Nombre",
            "vars": "Variables"
          },
          "corporate/custom_field": {
            "code": "Código",
            "created_at": "Fecha de creación",
            "data_type": "Tipo de dato",
            "label": "Etiqueta",
            "resource_type": "Recurso"
          }
        },
        "errors": {
          "models": {
            "bulk/request/zip/document": {
              "attributes": {
                "items": {
                  "blank": "Debe seleccionar al menos un documento para descargar"
                }
              }
            },
            "controldoc_form/template": {
              "attributes": {
                "name": {
                  "blank": "Debe ingresar el nombre de la plantilla",
                  "taken": "El nombre de la plantilla ya se encuentra en uso"
                }
              }
            },
            "corporate/agreement": {
              "attributes": null
            },
            "corporate/custom_field": {
              "attributes": {
                "code": {
                  "taken": "Ya éxiste uno con este Código"
                }
              }
            }
          }
        },
        "models": {
          "bulk/request/zip/document": {
            "one": "Descarga de documentos",
            "other": "Descargas de documentos"
          },
          "corporate/controldoc_form/document": {
            "one": "Documento",
            "other": "Documentos"
          },
          "corporate/controldoc_form/template": {
            "one": "Plantilla",
            "other": "Plantillas"
          },
          "corporate/custom_field": {
            "one": "Campo personalizado",
            "other": "Campos personalizados"
          }
        }
      },
      "agreement_documents": {
        "block": {
          "description": "Descripción",
          "successfully": "El documento ha sido bloqueado correctamente"
        },
        "controldoc_state": {
          "blocked": "Bloqueado",
          "partially_signed": "Firmado parcialmente",
          "pending_sign": "Pendiente por firmar",
          "pending_to_fill": "Pendiente por llenar",
          "pending_upload": "Pendiente por subir",
          "rejected": "Rechazado",
          "signature_expired": "Plazo de firma vencido",
          "signed_by_all": "Firmado",
          "uploaded": "Archivo subido"
        },
        "create": {
          "successfully": "El documento ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El documento ha sido marcado para eliminación"
        },
        "filter": {
          "by_aasm_state": "Estado",
          "by_client": "Cliente",
          "by_document_type": "Tipo de documento",
          "by_provider": "Proveedor",
          "end_date": "Hasta",
          "start_date": "Desde",
          "with_created_at": "Fecha de creación"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el documento?",
            "title": "Guardar Documento"
          },
          "require_signers": {
            "helper": {
              "title": "Al solicitar firmantes, el sistema se integrará con ControlDoc Sign"
            }
          },
          "save": "Guardar"
        },
        "index": {
          "without_results": "No hemos encontrado documentos"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar el documento?",
              "title": "Eliminar Documento"
            }
          }
        },
        "refresh": {
          "successfully": "El estado de la integracion ha sido actualizado correctamente"
        },
        "show": {
          "controldoc_integration_data": "Datos de integración con ControlDoc Sign",
          "current_agreement": "Contrato existente",
          "details": "Detalles del documento",
          "details_blocked": "Detalles del documento bloqueado",
          "new_agreement": "Nuevo contrato",
          "set_to": "Vincular a"
        },
        "signer_state": {
          "blocked": "Bloqueado",
          "pending": "Pendiente de firma",
          "rejected": "Rechazado",
          "signed": "Firmado"
        },
        "tooltip_info": "Administra, busca y visualiza todos los documentos creados. Crea, carga y envía documentos con o sin solicitudes de firma",
        "update": {
          "successfully": "El documento ha sido actualizado correctamente"
        }
      },
      "agreements": {
        "agreement_docs": {
          "aasm_state": "Estado:",
          "date": "Fecha:",
          "signer_blank": "No encontrado",
          "title": "Firma:"
        },
        "client_help": "Selecciona la parte consumidora del servicio del contrato",
        "create": {
          "succesfully": "El contrato ha sido creado correctamente"
        },
        "destroy": {
          "succesfully": "El contrato ha sido eliminado correctamente"
        },
        "end_date_help": "Deja en blanco si aún está vigente",
        "filter": {
          "by_client": "Cliente",
          "by_provider": "Proveedor",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la empresa</li> <li>Identificador del contrato</li> </ul>"
          },
          "start_date": "Desde",
          "with_end_date": "Fecha fin",
          "with_start_date": "Fecha inicio"
        },
        "identifier_help": "Es un código único y modificable con el que se identificará el contrato en la plataforma, el cual puede ser el RUT o un código interno de tu empresa. Si se deja en blanco ControlDoc creará uno por ti.",
        "index": {
          "tabs": {
            "active": "Activos",
            "all": "Todos",
            "expired": "Inactivos"
          },
          "without_results": "No hemos encontrado contrataciones"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": " <p> ¿Estás seguro de eliminar el contrato? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará el contrato.</li> <li>Eliminará todos los documentos asociados al contrato.</li> </ul> </div> ",
              "title": "Eliminar Contrato"
            }
          }
        },
        "provider_help": "Selecciona la parte proveedora del servicio del contrato",
        "show": {
          "custom_fields": "Otros datos",
          "details": "Detalles del contrato",
          "without_docs": "No hay documentos vinculados al contrato",
          "without_documents": "No hemos encontrado documentos"
        },
        "tooltip_info": "Detalle de todos los acuerdos que tiene tu empresa con otras empresas diferenciadas por su vigencia",
        "update": {
          "succesfully": "El contrato ha sido actualizado correctamente"
        }
      },
      "bulk": {
        "notification": {
          "sign_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "without_completed": "No hemos encontrado registros procesados",
              "without_completed_errors": "No hemos encontrado registros con errores",
              "without_pending": "No hemos encontrado registros pendientes",
              "without_processing": "No hemos encontrado registros en proceso"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "signs": {
            "create": {
              "succesfully": "Notificación masiva de firmas ha sido creada correctamente"
            },
            "destroy": {
              "succesfully": "Notificación masiva de firmas ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "cant_sign_selected": "Has seleccionado %{count} Firmas.",
              "confirm": {
                "message": "¿Estás seguro de realizar la notificación masiva?",
                "title": "Realizar notificación masiva"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "signs": "Firmas",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona varias firmantes pendientes para solicitar firma de documentación",
            "update": {
              "succesfully": "Notificación masiva de firmas ha sido actualizada correctamente"
            }
          }
        },
        "request": {
          "agreement_document_configs": {
            "require_upload_deadline_help": "Si el documento tiene una fecha límite para ser subido, ingrésala para que cada trabajador tenga en consideración el límite de fecha para firmar el documento"
          },
          "agreement_document_items": null,
          "agreement_documents": {
            "create": {
              "succesfully": "Solicitud masiva de documentos ha sido creada correctamente"
            },
            "destroy": {
              "succesfully": "Solicitud masiva de documentos ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "add_config": "Agregar nuevo documento",
              "cant_agreement_selected": "Has seleccionado %{count} contratos.",
              "confirm": {
                "message": "¿Estás seguro de realizar la solicitud masiva?",
                "title": "Realizar solicitud masiva"
              },
              "require_signers": {
                "helper": {
                  "title": "Al solicitar firmantes, el sistema se integrará con ControlDoc"
                }
              },
              "tabs": {
                "agreements": "Contratos",
                "agreements_button": "Volver a Paso 1 Contratos",
                "agreements_title": "Paso 1 seleccionar contratos",
                "config": "Configuración",
                "config_button": "Ir a Paso 2 Configuración",
                "config_title": "Paso 2 configuración de documentos"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "agreements": "Contratos",
              "details": "Detalles",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona varios trabajadores para solicitar carga o firma de documentación. Puedes subir, solicitar que el trabajador suba o usar un archivo de ControlDoc Forms.",
            "update": {
              "succesfully": "Solicitud masiva de documentos ha sido actualizada correctamente"
            }
          },
          "agreement_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> <li>Identificador del trabajador</li> <li>Identificador de la contratación</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "documents": "Documentos"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "zip": {
            "documents": {
              "create": {
                "succesfully": "Descarga de documentos ha sido creada correctamente"
              },
              "destroy": {
                "succesfully": "Descarga de documentos ha sido eliminada correctamente"
              },
              "filter": {
                "by_aasm_state": "Estado",
                "end_date": "Hasta",
                "start_date": "Desde",
                "with_created_at": "Fecha de creación"
              },
              "form": {
                "confirm": {
                  "message": "¿Estás seguro de realizar la descarga de documentos?",
                  "title": "Realizar descarga de documentos"
                }
              },
              "index": {
                "without_results": "No hemos encontrado registros"
              },
              "show": {
                "details": "Detalles",
                "documentos": "Firmas",
                "tabs": {
                  "all": "Todos",
                  "completed": "Procesados",
                  "completed_errors": "Procesados con errores",
                  "failed": "Fallido",
                  "pending": "Pendientes"
                },
                "without_results": "No hemos encontrado registros"
              },
              "tooltip_info": "Selecciona los documentos que requieres descargar",
              "update": {
                "succesfully": "Descarga de documentos ha sido actualizada correctamente"
              }
            }
          }
        }
      },
      "check_list": {
        "agreement_processes": {
          "create": {
            "succesfully": "El check list ha sido creado correctamente"
          },
          "destroy": {
            "succesfully": "El check list ha sido eliminada correctamente"
          },
          "filter": {
            "by_company": "Empresa",
            "end_date": "Hasta",
            "filter": null,
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del check list</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "form": {
            "create": {
              "confirm": {
                "message": "¿Estás seguro de crear el check list?",
                "title": "Crear check list"
              }
            },
            "document_types": {
              "without_results": "No hemos encontrado tipos de documentos"
            },
            "entities": {
              "without_results": "No hemos encontrado trabajadores"
            },
            "update": {
              "confirm": {
                "message": "¿Estás seguro de actualizar el check list?",
                "title": "Actualizar check list"
              }
            }
          },
          "index": {
            "without_results": "No hemos encontrado check list"
          },
          "messages": {
            "destroy": {
              "confirm": {
                "message": "¿Estás seguro de eliminar el check list?",
                "title": "Eliminar check list"
              }
            }
          },
          "show": {
            "details": "Detalles del check list"
          },
          "tooltip_info": "Revisa y controla documentos asociados a contrataciones para identificar documentación lista o pendiente",
          "update": {
            "succesfully": "El check list ha sido actualizado correctamente"
          }
        },
        "agreement_tasks": {
          "filter": {
            "by_client": "Cliente",
            "by_document_type": "Tipo de documento",
            "by_is_reviewed": "Revisado",
            "by_process": "Proceso de cumplimiento",
            "by_provider": "Proveedor"
          }
        }
      },
      "companies": {
        "create": {
          "succesfully": "La empresa ha sido creada correctamente"
        },
        "destroy": {
          "succesfully": "La empresa ha sido eliminada correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la empresa</li> <li>Identificador de la empresa</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "identifier_help": "Es un código único con el cual se identificará la empresa en la plataforma. Puede ser cualquier texto, RUT o código interno de tu empresa. En caso que no asignes un identificador, ControlDoc te generará uno el cual después puedes modificar.",
        "index": {
          "tabs": {
            "not_ours": "Otras empresas",
            "ours": "Nuestras empresas"
          },
          "without_results": "No hemos encontrado Empresas"
        },
        "is_ours_help": "Es una empresa manejada por tu empresa",
        "manager_email_help": "Es el email del usuario que podrá subir y/o completar información dentro del portal corporativo.",
        "messages": {
          "destroy": {
            "confirm": {
              "message": " <p> ¿Estás seguro de eliminar la empresa? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará las contrataciones laborales y sus documentos asociados</li> <li>Eliminará los contratos corporativos y sus documentos asociados</li> </ul> </div> ",
              "title": "Eliminar Empresa"
            }
          }
        },
        "show": {
          "custom_fields": "Otros datos",
          "details": "Detalles de la empresa",
          "without_hirings": "No hemos encontrado contrataciones"
        },
        "tooltip_info": "Todas las empresas propias y las externas que prestan servicios a tu empresa",
        "update": {
          "succesfully": "La empresa ha sido actualizada correctamente"
        }
      },
      "controldoc_form": {
        "documents": {
          "block": {
            "error_block_document": "El documento no pudo bloquearse",
            "succesfully": "El documento ha sido bloqueado correctamente",
            "without_controldoc_form_integration": "Debes integrar tu cuenta con ControlDoc Forms <a href='%{url}'>aquí</a>"
          },
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la Plantilla</li> <li>Email</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha inicio",
            "with_group_by": "Rol"
          },
          "index": {
            "without_results": "No hemos encontrado documentos asociadas"
          },
          "list": {
            "send": "Enviado a"
          },
          "show": {
            "details": "Documento",
            "other_data": "Otros datos",
            "signers": "Firmantes"
          },
          "tooltip_info": "Visualiza los envíos realizados y completados en ControlDoc Forms"
        },
        "templates": {
          "assign_mapping_links": {
            "successfully": "Mapeo de plantilla con éxito"
          },
          "create": {
            "succesfully": "Plantilla creada con éxito"
          },
          "destroy": {
            "succesfully": "Plantilla eliminada con éxito"
          },
          "filter": {
            "by_company": "Empresa",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la plantilla</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha inicio",
            "with_group_by": "Rol"
          },
          "form": {
            "confirm": {
              "message": "¿Estás seguro de guardar la plantilla?",
              "title": "Guardar plantilla"
            },
            "homologize_fields": "Homologar campos"
          },
          "index": {
            "sync": "Sincronización",
            "without_results": "No hemos encontrado plantillas asociadas"
          },
          "list": {
            "homologize_fields": "Homologar campos",
            "mapping": "Mapear"
          },
          "show": {
            "details": "Plantilla",
            "details_vars": "Autocompletar Plantilla",
            "details_vars_info": "Determina con qué información completarás la plantilla",
            "map_fields": "Asignar campos",
            "var_blank": "Si la tabla se deja en blanco, se interpreta que los campos de la plantilla serán completados posteriormente por cada usuario."
          },
          "sync": {
            "message": "Sincronización exitosa"
          },
          "table": {
            "attribute": "Atributo",
            "info": {
              "attribute": "Dato a completar en la variable de la plantilla",
              "model": "El recurso desde donde se extraerá el dato para completar la plantilla",
              "name": "Nombre",
              "type": "Tipo",
              "var": "El campo a completar en la plantilla"
            },
            "map": "Mapeo",
            "model": "Módulo / Recurso",
            "name": "Nombre",
            "type": "Tipo",
            "value": "Valor",
            "var": "Variable"
          },
          "update": {
            "successfully": "Plantilla actualizada con éxito"
          }
        }
      },
      "custom_fields": {
        "create": {
          "succesfully": "El campo personalizado ha sido creado correctamente"
        },
        "data_types": {
          "date": "Fecha",
          "text": "Texto"
        },
        "destroy": {
          "succesfully": "El campo personalizado ha sido eliminada correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del campo personalizado</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el campo personalizado?",
            "title": "Guardar campo personalizado"
          },
          "save": "Guardar"
        },
        "index": {
          "without_results": "No hemos encontrado campos personalizados"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará el campo personalizado y todos los datos asociados. Esta es una acción no reversible. ¿Estás seguro de eliminar el campo personalizado?",
              "title": "Eliminar campo personalizado"
            }
          }
        },
        "show": {
          "details": "Detalles del campo personalizado"
        },
        "tooltip_info": "Agrega y gestiona campos de  información que consideres relevante para tu gestión de documentos",
        "update": {
          "succesfully": "El campo personalizado ha sido actualizado correctamente"
        }
      },
      "document_type_batteries": {
        "create": {
          "succesfully": "La batería de documentos ha sido creada correctamente"
        },
        "data_types": {
          "date": "Fecha",
          "text": "Texto"
        },
        "destroy": {
          "succesfully": "La batería de documentos ha sido eliminada correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la batería</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar la batería de documentos?",
            "title": "Guardar batería de documentos"
          },
          "save": "Guardar batería de documentos"
        },
        "index": {
          "without_results": "No hemos encontrado baterías de documentos"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará la batería de documentos y todos los datos asociados. Esta es una acción no reversible. ¿Estás seguro de eliminar la batería de documentos?",
              "title": "Eliminar batería de documentos"
            }
          }
        },
        "show": {
          "details": "Detalles de la batería de documentos"
        },
        "tooltip_info": "Administra todas las baterías de documentos y sus datos",
        "update": {
          "succesfully": "La batería de documentos ha sido actualizado correctamente"
        }
      },
      "document_types": {
        "create": {
          "succesfully": "El tipo de documento ha sido creado correctamente"
        },
        "destroy": {
          "succesfully": "El tipo de documento ha sido eliminada correctamente"
        },
        "filter": {
          "by_company": "Empresa",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del tipo de documento</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "index": {
          "without_results": "No hemos encontrado tipo de documento"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar el tipo de documento?",
              "title": "Eliminar tipo de documento"
            }
          }
        },
        "show": {
          "details": "Detalles del tipo de documento",
          "signer_details": "Detalles de los firmantes predeterminados"
        },
        "tooltip_info": "Administra los diversos tipos de documentos que manejan en tu empresa",
        "update": {
          "succesfully": "El tipo de documento ha sido actualizado correctamente"
        }
      }
    },
    "corporate/controldoc_form": {
      "template_mapping_links": {
        "filter": {
          "by_aasm_state": "Estado",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la Plantilla</li> <li>Email</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio",
          "with_group_by": "Rol"
        },
        "form": {
          "opt_group": {
            "adp_fields": {
              "one": "Campos de ADP"
            },
            "custom_fields": {
              "one": "Campos personalizados"
            },
            "resource_data": {
              "one": "Información del recurso"
            },
            "system_information": {
              "one": "Información de sistema"
            }
          },
          "resource": {
            "corporate_agreement": {
              "one": "Contrato"
            },
            "corporate_company": {
              "one": "Empresa"
            },
            "system_resource": {
              "one": "Sistema"
            }
          }
        },
        "index": {
          "without_results": "No hemos encontrado documentos asociadas"
        },
        "list": {
          "send": "Enviado a"
        },
        "tooltip_info": "Visualiza los envíos realizados y completados en ControlDoc Forms"
      }
    },
    "crm": {
      "budget_product": null,
      "budget_product_template": null,
      "budget_template": null,
      "lead_mailer": {
        "notify_budget_pending": {
          "subject": "Nueva Solicitud de Presupuesto"
        },
        "notify_new_lead": {
          "subject": "🚀🚀🚀 Ha llegado un nuevo lead 🚀🚀🚀"
        }
      },
      "leads": null,
      "tutorial": {
        "tour_mailer": {
          "send_tour_to_users": {
            "subject": "Tour enviado"
          }
        }
      }
    },
    "custom_fields": {
      "create": {
        "successfully": "El campo personalizado ha sido creado correctamente"
      },
      "data_types": {
        "currency": "Moneda",
        "date": "Fecha",
        "email": "Email",
        "list": "Lista",
        "number": "Número",
        "text": "Texto"
      },
      "destroy": {
        "confirm": {
          "message": " <p> ¿Estas seguro de eliminar el campo personalizado? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> ",
          "title": "Eliminar campo personalizado"
        },
        "successfully": "El campo personalizado ha sido eliminada correctamente"
      },
      "filter": {
        "end_date": "Hasta",
        "search_query": {
          "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del campo personalizado</li> </ul>"
        },
        "start_date": "Desde",
        "with_created_at": "Fecha inicio"
      },
      "form": {
        "confirm": {
          "message": "¿Estás seguro de guardar el campo personalizado?",
          "title": "Guardar campo personalizado"
        },
        "save": "Guardar"
      },
      "group_ids": {
        "help": "Los roles que selecciones aquí podrán visualizar el valor del campo personalizado."
      },
      "index": {
        "without_results": "No hemos encontrado campos personalizados"
      },
      "is_sensitive_data": {
        "tooltip_info": "Al habilitar esta opción, el valor del campo personalizado se ocultará y solo será visible para los roles que seleccione."
      },
      "list_options": {
        "tooltip_info": "Para agregar opciones en la lista debe ingresar los campos y presionar la tecla 'enter'"
      },
      "messages": {
        "destroy": {
          "confirm": {
            "message": "Se eliminará el campo personalizado y todos los datos asociados. Esta es una acción no reversible. ¿Estás seguro de eliminar el campo personalizado?",
            "title": "Eliminar campo personalizado"
          }
        }
      },
      "show": {
        "details": "Detalles del campo personalizado"
      },
      "tooltip_info": "Agrega y gestiona campos de  información que consideres relevante para tu gestión de documentos",
      "update": {
        "successfully": "El campo personalizado ha sido actualizado correctamente"
      }
    },
    "customer_mailer": {
      "notify_demo_expiring_to_controldoc_admin": {
        "subject": "[Controldoc Compliance] Clientes demo a expirar"
      },
      "notify_email_settings_validation": {
        "subject": "[Controldoc Compliance] Cliente cambiando configuraciones de email."
      },
      "notify_errors_to_developers": {
        "subject": "[Controldoc Compliance] Error al incorporar Empresa cliente"
      }
    },
    "customer_onboarding": {
      "comercial_conditions": null,
      "legal_representatives": null,
      "products": null
    },
    "customer_onboarding_process_mailer": {
      "notify_completed_process_to_contability": {
        "subject": "Proceso de Onboarding completado"
      }
    },
    "customer_onboarding_processes": {
      "calendar": {
        "appointment_demo": "Agendar una Demo"
      },
      "form": {
        "billing_account": {
          "confirm": {
            "message": "¿Estás seguro de la información de facturación?",
            "title": "Información de facturación"
          }
        },
        "comercial_conditions": {
          "confirm": {
            "message": "¿Estás seguro de aceptar los términos comerciales?",
            "title": "Aceptar términos comerciales"
          }
        },
        "terms_and_conditions": {
          "confirm": {
            "message": "¿Estás seguro de aceptar los términos y condiciones?",
            "title": "Aceptar términos y condiciones"
          }
        }
      },
      "next_step": {
        "invoice_init_date": "Tu primera facturación será el",
        "invoice_period": "Tu período de facturación es",
        "invoiceable_on_accept": "Tu primera facturación será el día siguiente de haber completado este proceso",
        "successfully": "Cambios guardados correctamente"
      },
      "product_types": {
        "fea": "Firma Electrónica Avanzada",
        "gbs": "Espacio en disco",
        "other": "Otro",
        "users": "Usuarios"
      },
      "steps": {
        "accept_billing_account_step": "3 Información de Facturación",
        "accept_comercial_conditions_step": "2 Arma tu plan",
        "accept_terms_and_conditions_step": "4 Términos y condiciones",
        "completed": "Onboarding Listo",
        "welcome_step": "1 Bienvenida"
      },
      "welcome": {
        "error_send_code": "No seleccionó ningun correo",
        "invalid_code": "Código inválido",
        "pin_form": "Ingresa el código que fue envíado a tu correo electrónico",
        "send_code": "Código enviado",
        "valid_code": "Código valido"
      }
    },
    "customer_success": {
      "interviews": null
    },
    "customers": {
      "account": "Cuenta",
      "form": {
        "configure_customer_id": "Si necesitas configurar el CustomerId para la integración con ControlDoc Sign, comunícate con <a href=\"mailto:hola@controldoc.cl\">hola@controldoc.cl</a>",
        "confirm": {
          "message": "¿Estás seguro de guardar las cambios?",
          "title": "Actualizar organización"
        },
        "document_types_layer_help": "Activa esta opción para dar permiso específico y gestionar accesos por tipo de documento a un rol de usuarios",
        "email_configuration": "Configuración de correo electrónico",
        "email_not_configured": "Estas configuraciones serán revisadas y aprobadas por un miembro del equipo antes de ser aplicadas.",
        "email_settings_approved": "Los cambios en la configuración de correo están aprobados y se reflejarán en tus correos electrónicos.",
        "email_settings_waiting_for_approval": "Esperando aprobación de los cambios realizados en la configuración de correo.",
        "email_settings_waiting_for_approval_helper": "Mientras los valores no estén aprobados, se usarán los valores por defecto.",
        "enable_autofill_entity_fields_help": "Activa esta opción para guardar la información que se completa en Plantillas donde los campos del formulario esten vinculados a los campos de un trabajador, contratación ó entidad",
        "enable_migration_process_help": "Activa esta opción si estas migrando documentos y quieres que estos sean marcados para identificarlos posteriormente.",
        "enable_reason_reject_private_help": "Activa esta opción para ocultar la razón por la que el documento fue rechazado al firmar",
        "save": "Actualizar organización",
        "security_layer_help": "Activa esta opción para segmentar usuarios, trabajadores y gestionar permisos específicos por área",
        "skip_all_notifications_help": "Activa esta opción para desactivar todas las notificaciones"
      },
      "form_data": {
        "confirm": {
          "message": "¿Estás seguro de guardar los datos proporcionados?",
          "title": "Guardar información"
        }
      },
      "index": {
        "without_results": "No existen cuentas creadas"
      },
      "integration": {
        "title": "Para fines de Integración y mejora continua",
        "tooltip_info": "Esta información nos permite desarrollar integraciones útiles y adaptadas a las necesidades de tu empresa."
      },
      "manage_documents": "Portal Organización",
      "manage_documents_tooltip": "Ingresa para revisar tus documentos asociados a la empresa.",
      "manage_organization": "Gestión Organización",
      "manage_organization_tooltip": "Ingresa para realizar gestión documental de la empresa",
      "my_account": "Mi Cuenta",
      "my_accounts": "Accede a tu cuenta ControlDoc",
      "my_accounts_description": "Haz clic en la cuenta donde quieres ingresar a gestionar o ver tus documentos.",
      "notification": {
        "demo_expired": "Tu cuenta demo expiró el %{date}. ¡Es hora de cerrar nuestro trato!. Contáctanos para discutir tu plan mensual y migrar a una cuenta activa. Escríbenos a ventas@controldoc.legal.",
        "demo_expired_html": "<div class='text-left'> <p>Tu cuenta demo expiró el %{date}.</p> <strong>¡Es hora de cerrar nuestro trato! 😉 </strong> <p>Contáctanos para discutir tu plan mensual y migrar a una cuenta activa.<p> <p>Escríbenos a <strong>ventas@controldoc.legal</strong>.</p> </div>",
        "demo_to_expires_html": "Tu cuenta tiene vigencia hasta el día <strong>%{date}</strong>, para mayor información comunícate con el equipo de ControlDoc al correo electrónico <strong>ventas@controldoc.legal</strong>."
      },
      "org": "Organización",
      "portal": "Portal Empresa",
      "tooltip_info": "Listado de empresas a las que puedes ingresar a gestionar (tus cuentas ControlDoc) o ver documentos.",
      "update": {
        "successfully": "La organización ha sido actualizada correctamente"
      },
      "update_data": {
        "successfully": "La organización ha sido actualizada correctamente"
      },
      "update_info_title_html": "<strong class='d-block'>¡Hola %{customer}!</strong><small>Por favor actualiza esta información para ofrecerte <strong>una mejor experiencia</strong>.</small>"
    },
    "dashboard": "Tablero de control",
    "date": {
      "abbr_day_names": [
        "dom",
        "lun",
        "mar",
        "mié",
        "jue",
        "vie",
        "sáb"
      ],
      "abbr_month_names": [
        null,
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ],
      "day_names": [
        "domingo",
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado"
      ],
      "formats": {
        "alternative": "%d-%m-%Y",
        "day": "%d",
        "default": "%d/%m/%Y",
        "full_long": "%A %d de %B de %Y",
        "large": "%d de %B de %Y",
        "long": "%d de %B de %Y",
        "medium": "%d de %B de %Y",
        "month": "%B",
        "only_date": "%d/%m/%Y",
        "only_year": "%Y",
        "period": "%Y%m",
        "semi_full": "%d del %m de %Y",
        "short": "%d de %b",
        "words": {
          "day": {
            "one": "%{count} día",
            "other": "%{count} días"
          },
          "month": {
            "one": "%{count} mes",
            "other": "%{count} meses"
          },
          "year": {
            "one": "%{count} año",
            "other": "%{count} años"
          }
        },
        "year": "%Y"
      },
      "month_names": [
        null,
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "order": [
        "day",
        "month",
        "year"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "alrededor de 1 hora",
          "other": "alrededor de %{count} horas"
        },
        "about_x_months": {
          "one": "alrededor de 1 mes",
          "other": "alrededor de %{count} meses"
        },
        "about_x_years": {
          "one": "alrededor de 1 año",
          "other": "alrededor de %{count} años"
        },
        "almost_x_years": {
          "one": "casi 1 año",
          "other": "casi %{count} años"
        },
        "each_x_months": {
          "one": "cada 1 mes",
          "other": "cada %{count} meses"
        },
        "half_a_minute": "medio minuto",
        "less_than_x_minutes": {
          "one": "menos de 1 minuto",
          "other": "menos de %{count} minutos"
        },
        "less_than_x_seconds": {
          "one": "menos de 1 segundo",
          "other": "menos de %{count} segundos"
        },
        "over_x_years": {
          "one": "más de 1 año",
          "other": "más de %{count} años"
        },
        "x_days": {
          "one": "1 día",
          "other": "%{count} días"
        },
        "x_minutes": {
          "one": "1 minuto",
          "other": "%{count} minutos"
        },
        "x_months": {
          "one": "1 mes",
          "other": "%{count} meses"
        },
        "x_seconds": {
          "one": "1 segundo",
          "other": "%{count} segundos"
        },
        "x_years": {
          "one": "1 año",
          "other": "%{count} años"
        }
      },
      "prompts": {
        "day": "Día",
        "hour": "Hora",
        "minute": "Minuto",
        "month": "Mes",
        "second": "Segundo",
        "year": "Año"
      }
    },
    "default_signer_mailer": {
      "notify_automatic_signature_pending": {
        "subject": "Activación firma automática para %{customer_name}"
      }
    },
    "default_signers": {
      "create": {
        "succesfully": "El firmante ha sido creado correctamente"
      },
      "destroy": {
        "succesfully": "El firmante ha sido eliminado correctamente"
      },
      "filter": {
        "end_date": "Hasta",
        "search_query": {
          "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del firmante</li> <li>Correo electrónico del firmante</li> <li>Rol del firmante</li> </ul>"
        },
        "start_date": "Desde",
        "with_created_at": "Fecha de creación"
      },
      "form": {
        "confirm": {
          "message": "¿Estás seguro de guardar el firmante?",
          "title": "Guardar Firmante"
        }
      },
      "messages": {
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar el firmante?",
            "title": "Eliminar Firmante"
          }
        }
      },
      "show": {
        "details": "Detalles del firmante"
      },
      "tooltip_info": "Crea y administra a los firmantes de tu organización",
      "update": {
        "succesfully": "El firmante ha sido actualizado correctamente"
      }
    },
    "details": "Detalles",
    "devise": {
      "confirmations": {
        "confirmed": "Tu cuenta ha sido confirmada satisfactoriamente.",
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        },
        "send_instructions": "Vas a recibir un correo con instrucciones sobre cómo confirmar tu cuenta en unos minutos.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, en unos minutos recibirás un correo con instrucciones sobre cómo confirmar tu cuenta."
      },
      "failure": {
        "already_authenticated": "Ya has iniciado sesión.",
        "expired": "Su cuenta ha expirado debido a inactividad. Por favor contacte al administrador de la aplicación.",
        "inactive": "Tu cuenta aún no ha sido activada.",
        "invalid": "%{authentication_keys} o contraseña inválidos.",
        "invited": "Tienes una invitación pendiente, acéptala para acabar de crear tu cuenta.",
        "last_attempt": "Tienes un intento más antes de que tu cuenta sea bloqueada.",
        "locked": "Tu cuenta está bloqueada.",
        "not_found_in_database": "%{authentication_keys} o contraseña inválidos.",
        "session_limited": "Sus credenciales de inicio de sesión fueron usadas en otro navegador. Por favor inicie sesión nuevamente para continuar en este navegador.",
        "timeout": "Tu sesión expiró. Por favor, inicia sesión nuevamente para continuar.",
        "unauthenticated": "Tienes que iniciar sesión o registrarte para poder continuar.",
        "unconfirmed": "Tienes que confirmar tu cuenta para poder continuar."
      },
      "invalid_captcha": "El captcha ingresado es inválido.",
      "invalid_security_question": "La respuesta a la pregunta de seguridad fue incorrecta.",
      "invitations": {
        "edit": {
          "header": "Establecer contraseña",
          "submit_button": "Guardar mi contraseña"
        },
        "invitation_removed": "Se ha retirado su invitación",
        "invitation_token_invalid": "¡La invitación no es válida!",
        "new": {
          "header": "Enviar Invitación",
          "submit_button": "Envía una invitación"
        },
        "no_invitations_remaining": "No quedan invitaciones",
        "send_instructions": "Se ha enviado una invitación a %{email}.",
        "updated": "Se ha configurado su contraseña y ha ingresado al sistema",
        "updated_not_active": "Su contraseña se ha configurado correctamente."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "¡Bienvenido %{recipient}!",
          "instruction": "Usted puede confirmar el correo electrónico de su cuenta a través de este enlace:",
          "subject": "Instrucciones de confirmación"
        },
        "email_changed": {
          "greeting": "¡Hola %{recipient}! ",
          "message": "Estamos contactando contigo para notificarte que tu email ha sido cambiado a %{email}.",
          "message_unconfirmed": null,
          "subject": "Email cambiado"
        },
        "invitation_instructions": {
          "accept": "Aceptar la invitación",
          "accept_until": "Esta invitación expirará en %{due_date}.",
          "hello": "Hola %{email}",
          "ignore": "Si no le interesa esta invitación, simplemente ignore este correo. No se creará tu cuenta hasta que accedas al enlace anterior y crees una contraseña.",
          "someone_invited_you": "Has sido invitado a %{url}, puedes aceptarlo siguiendo el siguiente enlace",
          "subject": "Instrucciones de la invitación"
        },
        "password_change": {
          "greeting": "¡Hola %{recipient}!",
          "message": "Lo estamos contactando para notificarle que su contraseña ha sido cambiada.",
          "subject": "Contraseña cambiada"
        },
        "reset_password_instructions": {
          "action": "Crear nueva contraseña",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Alguien ha solicitado un enlace para cambiar su contraseña, lo que se puede realizar a través del siguiente enlace.",
          "instruction_2": "Si tú no solicitaste esta acción favor ignora este correo.",
          "instruction_3": "Su contraseña no será cambiada hasta que usted acceda el enlace y cree uno nuevo.",
          "instruction_3_html": "Tu contraseña no será <strong>establecida ni cambiada</strong> hasta que ingreses al link y crees una nueva.",
          "instruction_html": "Hemos recibido una solicitud para <strong>recuperar tu ingreso a controldoc</strong>. Para continuar configura una nueva contraseña en el siguiente link.",
          "subject": "Instrucciones de configuración de contraseña de acceso"
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Haga click en el siguiente enlace para desbloquear su cuenta:",
          "message": "Su cuenta ha sido bloqueada debido a una cantidad excesiva de intentos infructuosos para ingresar.",
          "subject": "Instrucciones para desbloquear"
        }
      },
      "omniauth_callbacks": {
        "failure": "No has sido autorizado en la cuenta %{kind} porque \"%{reason}\".",
        "general_failure": "Hemos tenido un problema autenticándote con %{kind}",
        "success": "Has sido autorizado satisfactoriamente en la cuenta %{kind}."
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Entregar",
          "submit_verification_code": "Envíe el código de verificación",
          "verification_code": "Código de verificación"
        },
        "updated": "Se acepta el código de verificación"
      },
      "paranoid_verify": {
        "code_required": "Por favor ingrese el código provisto por nuestro equipo de soporte"
      },
      "password_expired": {
        "change_required": "Su contraseña ha expirado. Por favor renueve su contraseña.",
        "show": {
          "change_my_password": "Cambiar mi contraseña",
          "current_password": "Actual contraseña",
          "new_password": "Nueva contraseña",
          "new_password_confirmation": "Confirmar nueva contraseña",
          "renew_your_password": "Renueve su contraseña"
        },
        "updated": "Su nueva contraseña ha sido guardada."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambie su contraseña",
          "confirm_new_password": "Confirme la nueva contraseña",
          "new_password": "Nueva contraseña"
        },
        "new": {
          "forgot_your_password": "Olvidé mi contraseña",
          "password_recover_info": "Si olvidaste tu contraseña ingresa tu correo y te enviaremos instrucciones para que puedas crear una nueva contraseña.",
          "send_me_reset_password_instructions": "Enviar instrucciones al correo"
        },
        "no_token": "No puedes acceder a esta página si no es a través de un enlace para resetear tu contraseña. Si has llegado hasta aquí desde el email para resetear tu contraseña, por favor asegúrate de que la URL introducida está completa.",
        "send_instructions": "Recibirás un correo con instrucciones sobre cómo resetear tu contraseña en unos pocos minutos.",
        "send_paranoid_instructions": "Si tu correo existe en nuestra base de datos, recibirás un correo con instrucciones sobre cómo resetear tu contraseña en tu bandeja de entrada.",
        "updated": "Se ha cambiado tu contraseña. Ya iniciaste sesión.",
        "updated_not_active": "Tu contraseña fue cambiada."
      },
      "registrations": {
        "destroyed": "¡Adiós! Tu cuenta ha sido cancelada correctamente. Esperamos verte pronto.",
        "edit": {
          "are_you_sure": "¿Está usted seguro?",
          "cancel_my_account": "Anular mi cuenta",
          "currently_waiting_confirmation_for_email": "Actualmente esperando la confirmacion de: %{email} ",
          "leave_blank_if_you_don_t_want_to_change_it": "dejar en blanco si no desea cambiarla",
          "title": "Editar %{resource}",
          "unhappy": "¿Disconforme?",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos su contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        },
        "signed_up": "Bienvenido. Tu cuenta fue creada.",
        "signed_up_but_inactive": "Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque tu cuenta aún no está activada.",
        "signed_up_but_locked": "Tu cuenta ha sido creada correctamente. Sin embargo, no hemos podido iniciar la sesión porque que tu cuenta está bloqueada.",
        "signed_up_but_unconfirmed": "Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Abre el enlace para activar tu cuenta.",
        "update_needs_confirmation": "Has actualizado tu cuenta correctamente, pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo y sigue el enlace de confirmación para finalizar la comprobación del nuevo correo electrónico.",
        "updated": "Tu cuenta se ha actualizado.",
        "updated_but_not_signed_in": "Su cuenta se ha actualizado correctamente, pero como se cambió su contraseña, debe iniciar sesión nuevamente"
      },
      "sessions": {
        "active_account_btn": "Crea una contraseña de acceso aquí",
        "active_account_info": "Si recibiste correo para firmar documentos y no has activado tu cuenta",
        "already_signed_out": "Sesión finalizada.",
        "chat": "Chat de Soporte",
        "destroy": {
          "sign_out": "Cerrar sesión"
        },
        "help_info_html": "Si no puedes acceder a tu cuenta ControlDoc escríbenos al correo <a class=\"font-weight-bold alert-link text-dark\" href=\"mailto:hola@controldoc.legal\">hola@controldoc.legal</a>",
        "new": {
          "sign_in": "Iniciar sesión"
        },
        "signed_in": "Sesión iniciada.",
        "signed_out": "Sesión finalizada."
      },
      "shared": {
        "links": {
          "active_account": "Activar tu cuenta",
          "back": "Atrás",
          "didn_t_receive_confirmation_instructions": "¿No has recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "¿No has recibido instrucciones para desbloquear?",
          "forgot_your_password": "¿Olvidaste tu contraseña?",
          "sign_in": "Iniciar sesión",
          "sign_in_with_provider": "Iniciar sesión con %{provider}",
          "sign_up": "Registrarse"
        },
        "minimum_password_length": {
          "one": "(%{count} caractere como mínimo)",
          "other": "(%{count} caracteres como mínimo)"
        },
        "providers": {
          "entra_id": "Microsoft"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones para desbloquear"
        },
        "send_instructions": "Vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
        "send_paranoid_instructions": "Si tu cuenta existe, vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
        "unlocked": "Tu cuenta ha sido desbloqueada. Ya puedes iniciar sesión."
      },
      "welcome": {
        "carousel": {
          "item_1": {
            "title": "Gestiona y ordena tu documentación de forma inteligente y asegura el cumplimiento continuo de tu organización."
          },
          "item_2": {
            "title": "Respalda la disponibilidad y seguridad de tu información para Cumplimiento Normativo."
          },
          "item_3": {
            "title": "Define flujos para la recopilación de denuncias, evidencias y monitorea en línea."
          }
        },
        "greeting": "Todo en orden, centralizado y bajo control"
      }
    },
    "direct_links": {
      "create": {
        "successfully": "El checklist ha sido anclado con éxito"
      },
      "destroy": {
        "succesfully": "El checklist ha sido desanclado con éxito"
      },
      "form": {
        "pin": {
          "confirm": {
            "check_list": {
              "message": "¿Estás seguro de querer anclar este Check List en el menú lateral?",
              "title": "Anclar Check List"
            }
          }
        },
        "unpin": {
          "confirm": {
            "check_list": {
              "message": "¿Desea desanclar este Check List del menú lateral?",
              "title": "Desanclar Check List"
            }
          }
        }
      },
      "status": {
        "pin": "Anclar",
        "unpin": "Desanclar"
      }
    },
    "disable_with_html": "<i class='fas fa-spinner fa-spin'></i> %{text}",
    "document_compression_mailer": {
      "notify_compressed_ready": {
        "subject": "Zip de documentos disponibles para descargar"
      }
    },
    "document_compressions": {
      "form": {
        "confirm": {
          "message": "¿Estás seguro de generar los documentos comprimidos?",
          "title": "Generar documentos comprimidos"
        }
      },
      "zip": "zip de documentos"
    },
    "document_mailer": {
      "notify_blocked": {
        "subject": "Un documento pendiente de firma ha sido bloqueado."
      },
      "notify_blocked_by_system": {
        "subject": "Un documento ha sido bloqueado por sistema."
      },
      "notify_documents_to_expires": {
        "subject": "Reporte de documentos por expirar"
      },
      "notify_pending": {
        "subject": "Hay documentos esperando tu firma."
      },
      "notify_rejected": {
        "subject": "Un documento pendiente de firma ha sido rechazado"
      },
      "notify_signature_expires": {
        "subject": "Documentos pendientes por firmar"
      },
      "notify_signed": {
        "subject": "Los documentos ya se firmaron electrónicamente."
      }
    },
    "document_types": {
      "create": {
        "successfully": "El tipo de documento ha sido creado correctamente"
      },
      "destroy": {
        "confirm": {
          "message": " <p> ¿Estas seguro de eliminar el tipo de documento? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> ",
          "title": "Eliminar Tipo de Documento"
        },
        "successfully": "El tipo de documento ha sido eliminada correctamente"
      },
      "form": {
        "confirm": {
          "message": "¿Estás seguro de guardar el tipo de documento?",
          "title": "Guardar Tipo de Documento"
        },
        "default_bulk_request_config": {
          "tooltip_info": "Establece una configuración por defecto para la solicitud masiva de documentos."
        },
        "number_days_to_expire_documents": {
          "help": "Si no quieres notificar los documentos por caducar ingresa el valor en 0.",
          "tooltip_info": "Esta opción permite configurar con cuantos días previos a la fecha de caducidad se considera que el documento está en estado \"por caducar\"."
        },
        "number_days_to_notify_signature_expire": {
          "help": "Si no quieres notificar la fecha límite de firma ingresa el valor en 0.",
          "tooltip_info": "Esta opción permite configurar con cuántos días de antelación se debe notificar la fecha límite de firma."
        },
        "require_subscription_member": {
          "tooltip_info": "Esta opción habilita la notificación de documentos por expirar y con fecha límite de firma a los miembros seleccionados.",
          "tooltip_warning": "Solo se notificará a los usuarios agregados si estos tienen acceso al tipo de documento."
        }
      },
      "search_query": {
        "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del tipo de documento</li> </ul>"
      },
      "show": {
        "details": "Detalles del campo tipo de documento"
      },
      "tooltip_info": "Crea tipos de documentos para categorizar la documentación",
      "update": {
        "successfully": "El tipo de documento ha sido actualizado correctamente"
      }
    },
    "documentation": "Documentación",
    "documents": {
      "current_signer": "Firmante actual",
      "expires_at_info": "El documento expiró el %{expires_at}",
      "form": {
        "allowed_format": "Formatos permitidos %{allowed_format}",
        "confirm": {
          "message": "¿Estás seguro de guardar el documento?",
          "title": "Guardar Documento"
        },
        "label_tooltip": "Nombre con el que desea identificar individualmente el documento.",
        "max_size": "Peso máximo del archivo 10MB",
        "require_convert_to_pdf": "Si su archivo requiere conversión a PDF, el proceso de guardado puede tardar"
      },
      "headers": {
        "traceability": "Trazabilidad"
      },
      "icons_html": {
        "blocked": "<i class='far fa-times-circle text-danger fa-lg'></i>",
        "created": "<i class='far fa-file-alt text-info fa-lg'></i>",
        "rejected": "<i class='far fa-times-circle text-danger fa-lg'></i>",
        "sign_notification_sent": "<i class='far fa-envelope-open text-primary fa-lg'></i>",
        "signed": "<i class='fas fa-signature text-success fa-lg'></i>",
        "viewed": "<i class='fas fa-check text-success fa-lg'></i>",
        "visa_notification_sent": "<i class='far fa-envelope-open text-primary fa-lg'></i>"
      },
      "labels": {
        "advance_signature": "Firma Electrónica Avanzada",
        "blocked_by": "Documento bloqueado por %{user}",
        "created_by": "Documento creado por %{user}",
        "rejected_by": "Documento rechazado por %{user}",
        "sign_notification_sent_by": "Notificación de firma enviada a %{signer} por %{user}",
        "signed_at": "Documento firmado el %{created_at}",
        "signed_by": "Documento firmado por %{user}",
        "simple_signature": "Firma Electrónica Simple",
        "viewed_by": "Documento visado por %{user}",
        "visa_notification_sent_by": "Notificación de firma enviada al visador %{signer} por %{user}"
      },
      "list": {
        "signers_and_viewers": "Firmantes/Visadores"
      },
      "messages": {
        "number_html": "<p style='text-align: center; font-size: 8px'><b>Nº documento</b>: %{number}</p>",
        "require_signer_order": {
          "no_available": "Aún no puedes firmar este documento, ya que se ha configurado que alguien más debe firmar antes que tu."
        },
        "validate": "Puedes verificar la autenticidad de este documento escaneando el siguiente código qr con tu smartphone:"
      },
      "new": {
        "keep_format_help": "Si el archivo requiere firma, no se puede mantener su formato original, ya que debe ser obligatoriamente transformado a formato PDF."
      },
      "notification_settings": {
        "rejection": {
          "title": "Configuración de notificaciones de rechazo"
        }
      },
      "review_form": {
        "confirm": {
          "message": "¿Estás seguro de guardar la revisión del documento?",
          "title": "Revisión Documento"
        }
      },
      "show": {
        "details": "Detalles del documento"
      },
      "validate": {
        "document_preview": "Previsualización",
        "download": "Descargar Documento",
        "signers_and_viewers": "Firmantes/Visadores",
        "title": "Validación de Documento",
        "trazability": "Trazabilidad",
        "two_factor": {
          "back_to_email": "Usar otro correo",
          "confirm_otp": "Verificar y ver documento",
          "email_instructions": "Para continuar, ingresa tu correo electrónico. Si tu correo está autorizado para este documento, te enviaremos un código de verificación.",
          "email_label": "Correo electrónico",
          "email_required": "Debes ingresar un correo electrónico.",
          "email_sent_notice": "Si tu correo está autorizado para este documento, te enviaremos un código de verificación.",
          "invalid_otp": "El código de verificación no es válido o ha expirado.",
          "otp_instructions": "Ingresa el código de verificación que enviamos a tu correo.",
          "otp_label": "Código de verificación",
          "otp_sent_to": "Código enviado a %{email}",
          "request_otp": "Continuar",
          "title": "Verificación de acceso"
        }
      }
    },
    "dt": {
      "bulk": {
        "load": {
          "annexe_records": {
            "card_info": {
              "additional_info": {
                "company_rut": "Rut de la empresa",
                "employee_rut": "Rut del trabajador",
                "field": "Campo",
                "given_value": "Valor seleccionado",
                "given_value_not_in_options": "Valor no existe dentro de las opciones",
                "one": "Información adicional",
                "reason": "Motivo",
                "required_field": "Campo requerido",
                "row": "Fila",
                "selector_options_fetch_error": "Error al cargar las opciones en la DT",
                "total": "Total",
                "total_registered": "Total registrados",
                "total_with_errors": "Total con errores",
                "value": "Valor",
                "wrong_value": "Valor incorrecto"
              },
              "details": "Detalles del anexo",
              "details_integrations": "Detalles de la integración",
              "details_status": "Detalles del estado del registro",
              "details_validation": "Detalles del estado de la validación en MiDT",
              "error": "Errores",
              "error_detail": "Detalle del error",
              "errors_validation_excel": "Errores de validación en el Excel",
              "integration_result": "Resultado del envío",
              "loaded_contracts": {
                "company_rut": "Rut de la empresa",
                "contract_type": "Tipo de contrato",
                "employee_rut": "Rut del trabajador",
                "end": "Fecha fin",
                "registration_date": "Fecha de registro",
                "start": "Fecha inicio"
              },
              "message": "Mensaje",
              "query_state": "Consultar estado de la solicitud",
              "record_request": "La solicitud ha sido enviada a ControlBot",
              "record_request_error": "La solicitud no pudo ser enviada a Midt",
              "scheduled_at": "Programada para",
              "status": {
                "executed": "Ejecutado",
                "executed_with_error": "Ejecutado con errores",
                "executed_with_success": "Ejecución con éxito",
                "executing": "Ejecutando",
                "execution_error": "Error en ejecución",
                "execution_failed": "Ejecución fallida",
                "execution_in_progress": "Ejecución en progreso",
                "failed": "Fallido",
                "rescheduled_to_execute": "Reprogramado para ejecutarse",
                "scheduled_to_execute": "Programada para ejecutar"
              },
              "table": {
                "entered": "Usted ingresó",
                "message": "Mensaje"
              }
            },
            "create": {
              "succesfully": "El envío masivo de anexos a MiDT se encuentra procesando"
            },
            "destroy": {
              "succesfully": "El anexo ha sido eliminada correctamente"
            },
            "filter": {
              "created_by": "Creado por",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_start_date": "Fecha inicio"
            },
            "form": {
              "allowed_format": "Formatos permitidos .xlsx .xls",
              "confirm": {
                "message": "¿Estás seguro de enviar el anexo a MiDT?",
                "title": "Envío de anexo"
              },
              "save": "Guardar"
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "request_status": {
              "successfully": "Consulta exitosa"
            },
            "show": null,
            "status": "Estado de MiDT:",
            "tooltip_info": "Gestiona el listado de anexos asociados a MiDT. Visualiza el estado y registro histórico de los envíos realizados.",
            "update": {
              "succesfully": "El anexo ha sido actualizada correctamente"
            }
          },
          "contract_records": {
            "card_info": {
              "additional_info": {
                "company_rut": "Rut de la empresa",
                "employee_rut": "Rut del trabajador",
                "field": "Campo",
                "given_value": "Valor seleccionado",
                "given_value_not_in_options": "Valor no existe dentro de las opciones",
                "one": "Información adicional",
                "reason": "Motivo",
                "required_field": "Campo requerido",
                "row": "Fila",
                "selector_options_fetch_error": "Error al cargar las opciones en la DT",
                "total": "Total",
                "total_registered": "Total registrados",
                "total_with_errors": "Total con errores",
                "value": "Valor",
                "wrong_value": "Valor incorrecto"
              },
              "details": "Detalles de la contratación",
              "details_integrations": "Detalles de la integración",
              "details_status": "Detalles del estado del registro",
              "details_validation": "Detalles del estado de la validación en MiDT",
              "error": "Errores",
              "error_detail": "Detalle del error",
              "errors_validation_excel": "Errores de validación en el Excel",
              "integration_result": "Resultado del envío",
              "loaded_contracts": {
                "company_rut": "Rut de la empresa",
                "contract_type": "Tipo de contrato",
                "employee_rut": "Rut del trabajador",
                "end": "Fecha fin",
                "registration_date": "Fecha de registro",
                "start": "Fecha inicio"
              },
              "message": "Mensaje",
              "query_state": "Consultar estado de la solicitud",
              "record_request": "La solicitud ha sido enviada a ControlBot",
              "record_request_error": "La solicitud no pudo ser enviada a Midt",
              "scheduled_at": "Programada para",
              "status": {
                "executed": "Ejecutado",
                "executed_with_error": "Ejecutado con errores",
                "executed_with_success": "Ejecución con éxito",
                "executing": "Ejecutando",
                "execution_error": "Error en ejecución",
                "execution_failed": "Ejecución fallida",
                "execution_in_progress": "Ejecución en progreso",
                "failed": "Fallido",
                "rescheduled_to_execute": "Reprogramado para ejecutarse",
                "scheduled_to_execute": "Programada para ejecutar"
              },
              "table": {
                "entered": "Usted ingresó",
                "message": "Mensaje"
              }
            },
            "create": {
              "succesfully": "El envío masivo de contrataciones a MiDT se encuentra procesando"
            },
            "destroy": {
              "succesfully": "La contratación ha sido eliminada correctamente"
            },
            "filter": {
              "created_by": "Creado por",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_start_date": "Fecha inicio"
            },
            "form": {
              "allowed_format": "Formatos permitidos .xlsx .xls",
              "confirm": {
                "message": "¿Estás seguro de enviar el documento a MiDT?",
                "title": "Envío de documento"
              },
              "save": "Guardar"
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "request_status": {
              "successfully": "Consulta exitosa"
            },
            "show": {
              "details": "Detalles del documento"
            },
            "status": "Estado de MiDT:",
            "tooltip_info": "Gestiona el listado de documentos asociados a MiDT. Visualiza el estado y registro histórico de los envíos realizados.",
            "update": {
              "succesfully": "La contratación ha sido actualizada correctamente"
            }
          },
          "tabs": {
            "completed": "Procesados",
            "failed": "Con Errores",
            "pending": "Pendientes"
          }
        }
      },
      "connect": "Conectar MI DT",
      "credentials": {
        "card_info": {
          "details_validation": "Detalles validación credenciales MiDT",
          "legal_representative_data": "Datos del Representante legal",
          "login_data": "Credenciales DT",
          "message": "Mensaje",
          "scheduled_at": "Programada para",
          "status": {
            "executed": "Ejecutado",
            "executed_with_error": "Ejecutado con errores",
            "executed_with_success": "Ejecución con éxito",
            "executing": "Ejecutando",
            "execution_error": "Error en ejecución",
            "execution_failed": "Ejecución fallida",
            "execution_in_progress": "Ejecución en progreso",
            "failed": "Fallida",
            "one": "Estado",
            "pending": "Pendiente",
            "scheduled_to_execute": "Programada para ejecutar"
          }
        },
        "save": {
          "successfully": "Credenciales DT guardadas correctamente"
        }
      },
      "laboral": {
        "hiring": {
          "integrations": {
            "create": {
              "successfully": "Integración creada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "sorted_by": {
                "created_at_asc": "Fecha de creación (más antigua)",
                "created_at_desc": "Fecha de creación (más reciente)",
                "one": "Ordenar por"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación",
              "with_record_id": "ID de la contratación"
            },
            "index": {
              "title": "Integraciones DT de contrataciones",
              "without_results": "No se encontraron integraciones"
            },
            "title": "Integraciones DT de contrataciones",
            "tooltip_info": "Listado de integraciones con DT asociadas a contrataciones laborales"
          }
        }
      },
      "mapping_fields": {
        "batch_update": {
          "successfully": "Homologación DT guardada correctamente"
        },
        "tooltip_info": "Campos que deben ser homologados para hacer funcionar la integración con la DT."
      },
      "no_entry": "No ingresó valor",
      "processing_entry": "Procesando dato",
      "record": {
        "infos": {
          "form": {
            "boolean_options": {
              "false": "No",
              "true": "Sí"
            },
            "buttons": {
              "save": "Guardar información DT"
            },
            "sections": {
              "contract": "Contrato",
              "employee_data": "Datos del colaborador",
              "home_location": "Ubicación de domicilio",
              "other_stipulations": "Otras estipulaciones",
              "remuneration": "Remuneración",
              "work_location": "Ubicación de trabajo",
              "working_day": "Jornada de trabajo"
            }
          },
          "update": {
            "successfully": "Información DT actualizada correctamente"
          }
        },
        "integrations": {
          "show": {
            "source_data_modal": {
              "empty": "No hay fuente de datos externa disponible para esta contratación.",
              "field": "Campo",
              "open": "Ver datos",
              "title": "Fuente de datos externa sincronizada",
              "value": "Valor"
            }
          }
        }
      },
      "setting": {
        "fetch_dt_info_requests": {
          "create": {
            "successfully": "Configuración DT creada correctamente"
          },
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar esta configuración?",
              "title": "Eliminar configuración DT"
            },
            "successfully": "Configuración DT eliminada correctamente"
          },
          "form": {
            "employee_rut_for_testing_hint": "Solo para pruebas, no se guardará en la base de datos. Se enviará como RUT del trabajador al probar el endpoint.",
            "test_endpoint": "Probar endpoint",
            "testing_endpoint": "Probando..."
          },
          "index": {
            "without_results": "No hemos encontrado configuraciones"
          },
          "list": {
            "default_label": "Por defecto"
          },
          "tooltip_info": "Gestiona las configuraciones para obtener datos externos y sincronizar información con la DT.",
          "update": {
            "successfully": "Configuración DT actualizada correctamente"
          }
        }
      },
      "without_results": "No hemos encontrado resultados"
    },
    "dt_fields_integration": "Campos de integración DT",
    "ecert": {
      "bulk": {
        "signing": {
          "create": {
            "successfully": "El firmado ha sido creado correctamente"
          }
        }
      },
      "enrolled": "E-Cert",
      "signature_certificates": {
        "create": {
          "successfully": "El certificado ha sido creado correctamente"
        },
        "filter": {
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Correo electrónico del usuario</li> <li>Nombre del Usuario</li> </ul>"
          }
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el certificado?",
            "title": "Guardar Certificado"
          }
        },
        "index": {
          "without_results": "No hemos encontrado certificados de firma avanzada"
        },
        "show": {
          "details": "Detalles del Certificado"
        },
        "tooltip_info": "Crea y administra los certificados de firma avanzada de tu equipo.",
        "update": {
          "successfully": "El certificado ha sido actualizado correctamente"
        }
      }
    },
    "economic_crime": {
      "workflow": {
        "processes": {
          "destroy": {
            "confirm": {
              "message": " <p> ¿Estás seguro de eliminar el proceso? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará las denuncias asociadas y todas las evidencias.</li> </ul> </div> ",
              "title": "Eliminar Proceso"
            },
            "successfully": "El proceso ha sido eliminado correctamente"
          }
        },
        "requirement_stage_mailer": {
          "moving_backward_html": "La denuncia por delito económico <strong>%{requirement_name}</strong> ha sido devuelta a la etapa <strong>%{to_stage_name}</strong>",
          "moving_forward_html": "La denuncia por delito económico <strong>%{requirement_name}</strong> ha avanzado a la etapa <strong>%{to_stage_name}</strong>",
          "new_requirement_html": "Se ha recepcionado una denuncia por delito económico <strong>%{requirement_name}</strong>"
        },
        "requirements": {
          "form": {
            "informer": {
              "title": "Antecedentes del denunciante"
            }
          },
          "modal_confirm_destroy": {
            "deleted_reason_label": "Motivo de eliminación",
            "deleted_reason_placeholder": "Por favor, indique el motivo de la eliminación...",
            "question": "¿Estás seguro de eliminar esta denuncia?",
            "title": "Eliminar denuncia"
          },
          "show": {
            "details": "Detalle de la denuncia"
          }
        }
      }
    },
    "entities": {
      "dt_fields": {
        "alert": {
          "warning": " <strong>Precaución:</strong> Los campos para integrar con la DT permanecerán bloqueados para prevenir cualquier actualización debido a que ya se encuentra registrado en la DT, si desea actualizar alguno de los campos, debe considerar lo siguiente: <ul class='mb-0 mt-2'> <li>Haz click en el candado para habilitar los campos</li> <li>Cada actualización de la información la DT lo interpreta como anexo de contrato</li> <li>Al actualizar algunos de los campos se creará un anexo de contrato</li> </ul> "
        },
        "lock_button": {
          "disable": "Deshabilitar campos",
          "enable": "Habilitar campos"
        },
        "update": {
          "messages": {
            "confirm": {
              "message": " <p> ¿Estás seguro de actualizar los campos de la DT? </p> <p class='text-warning'><strong>Ten en cuenta que esta acción:</strong></p> <div class='callout callout-warning text-left'> <ul> <li>Actualizará los campos correspondientes de la DT.</li> <li>Generará un anexo de contrato en la Dirección del Trabajo.</li> <li>Los anexos se crearán cada vez que se actualicen los campos de la DT.</li> </ul> </div> <p class='text-info mt-2'><strong>Antes de continuar, asegúrate de que la información sea correcta.</strong></p> ",
              "title": "Actualizar los campos de la DT"
            }
          }
        }
      }
    },
    "entity_folder": {
      "check_list_requirements": {
        "create": {
          "successfully": "El requerimiento ha sido creado correctamente"
        },
        "deadline_upload_notification_at": {
          "info": "Cantidad de días para iniciar las notificaciones antes de llegar a la fecha de deadline"
        },
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar el requerimiento?",
            "title": "Eliminar requerido"
          },
          "successfully": "El requerimiento ha sido eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el requerimiento?",
            "title": "Guardar requerimiento"
          }
        },
        "recurrence_deadline_upload_days": {
          "info": "Los días de deadline comienzan desde que se crea el requerimiento"
        },
        "recurrence_end_at": {
          "info": "Si no ingresa una fecha de término, la generará el requerimiento continuamente"
        },
        "show": {
          "details": "Detalles del requerimiento"
        },
        "update": {
          "successfully": "El requerimiento ha sido actualizado correctamente"
        }
      },
      "check_list_shared_mailer": {
        "notify_new_spot_requirements": {
          "subject": "Nuevos documentos"
        },
        "notify_returned_task": {
          "subject": "Subir documento nuevamente"
        },
        "notify_tasks_to_expireds": {
          "subject": "Requerimientos por vencer"
        }
      },
      "check_list_shareds": {
        "create": {
          "successfully": "El acceso a las carpetas se ha creado correctamente"
        },
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar el acceso a las carpetas?",
            "title": "Eliminar acceso a carpetas"
          },
          "successfully": "El acceso a las carpetas se ha eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de compartir las carpetas?",
            "title": "Compartir"
          }
        },
        "show": {
          "details": "Detalles del acceso a carpeta"
        },
        "update": {
          "successfully": "El acceso a las carpetas se ha actualizado correctamente"
        }
      },
      "check_list_tasks": {
        "filter": {
          "by_document_type": "Tipo de documento",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Identificador del recurso</li> <li>Nombe de la carpeta</li> </ul>"
          }
        },
        "index": {
          "tabs": {
            "pending": "Pendientes",
            "reviewed": "Revisados"
          }
        },
        "show": {
          "details": "Detalles del requerimiento"
        },
        "tooltip_info": "Revisa y controla los requerimientos de carpetas asociados a tus recursos",
        "update": {
          "successfully": "Tarea revisada con éxito",
          "title": "Revisión de documento"
        },
        "update_file": {
          "successfully": "Archivo cargado con éxito en la tarea",
          "title": "Subir Archivo"
        }
      },
      "check_lists": {
        "create": {
          "successfully": "La carpeta ha sido creada correctamente"
        },
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar la carpeta?",
            "title": "Eliminar carpeta"
          },
          "successfully": "La carpeta ha sido eliminado correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar la carpeta?",
            "title": "Guardar carpeta"
          }
        },
        "show": {
          "details": "Detalles de la carpeta"
        },
        "tooltip_info": "Administra y gestiona documentos",
        "update": {
          "successfully": "La carpeta ha sido actualizada correctamente"
        }
      }
    },
    "errors": {
      "api": {
        "http": {
          "forbidden": "Acceso denegado. No tienes permisos para acceder a este recurso.",
          "not_found": "El recurso no fue encontrado.",
          "unauthorized": "No estás autorizado para realizar esta acción"
        }
      },
      "email": {
        "invalid_format": "Formato de correo inválido"
      },
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "debe ser aceptado",
        "already_confirmed": "ya ha sido confirmado, por favor intenta iniciar sesión",
        "aspect_ratio_invalid": "tiene una relación de aspecto inválida (las relaciones de aspecto válidas son %{authorized_aspect_ratios})",
        "aspect_ratio_is_not": "debe tener una relación de aspecto de %{aspect_ratio}",
        "aspect_ratio_not_landscape": "debe ser una imagen apaisada",
        "aspect_ratio_not_portrait": "debe ser una imagen vertical",
        "aspect_ratio_not_square": "debe ser una imagen cuadrada",
        "aspect_ratio_not_x_y": "debe ser %{authorized_aspect_ratios} (el archivo actual es %{width}x%{height}px)",
        "aspect_ratio_unknown": "tiene una relación de aspecto desconocida",
        "attachment_missing": "no tiene archivo adjunto",
        "audio_missing": "debe tener una pista de audio",
        "audio_present": "no debe tener una pista de audio",
        "blank": "no puede estar en blanco",
        "confirmation": "no coincide",
        "confirmation_period_expired": "necesita confirmarse dentro de %{period}, por favor solicita una nueva",
        "content_type_invalid": "El formato %{content_type} no está permitido",
        "content_type_spoofed": {
          "one": "tiene un tipo de contenido que no es equivalente al que se detecta a través de su contenido (el tipo de contenido autorizado es %{authorized_human_content_types})",
          "other": "tiene un tipo de contenido que no es equivalente al que se detecta a través de su contenido (los tipos de contenido autorizados son %{authorized_human_content_types})"
        },
        "dimension_height_equal_to": "la altura debe ser igual a %{length} pixel",
        "dimension_height_greater_than_or_equal_to": "la altura debe ser mayor o igual a %{length} pixel",
        "dimension_height_inclusion": "la altura no se incluye entre %{min} y %{max} pixel",
        "dimension_height_less_than_or_equal_to": "la altura debe ser menor o igual a %{length} pixel",
        "dimension_height_not_equal_to": "la altura debe ser igual a %{length} pixel",
        "dimension_height_not_greater_than_or_equal_to": "la altura debe ser mayor o igual a %{length} pixel",
        "dimension_height_not_included_in": "la altura no se incluye entre %{min} y %{max} pixel",
        "dimension_height_not_less_than_or_equal_to": "la altura debe ser menor o igual a %{length} pixel",
        "dimension_max_inclusion": "debe ser menor o igual a %{width} x %{height} pixel",
        "dimension_max_not_included_in": "debe ser menor o igual a %{width} x %{height} pixel",
        "dimension_min_inclusion": "debe ser mayor o igual a %{width} x %{height} pixel",
        "dimension_min_not_included_in": "debe ser mayor o igual a %{width} x %{height} pixel",
        "dimension_width_equal_to": "el ancho debe ser igual a %{length} pixel",
        "dimension_width_greater_than_or_equal_to": "el ancho debe ser mayor o igual a %{length} pixel",
        "dimension_width_inclusion": "el ancho no se incluye entre %{min} y %{max} pixel",
        "dimension_width_less_than_or_equal_to": "el ancho debe ser menor o igual a %{length} pixel",
        "dimension_width_not_equal_to": "el ancho debe ser igual a %{length} pixel",
        "dimension_width_not_greater_than_or_equal_to": "el ancho debe ser mayor o igual a %{length} pixel",
        "dimension_width_not_included_in": "el ancho no se incluye entre %{min} y %{max} pixel",
        "dimension_width_not_less_than_or_equal_to": "el ancho debe ser menor o igual a %{length} pixel",
        "duration_not_between": "la duración debe estar entre %{min} y %{max} (la duración actual es %{duration})",
        "duration_not_equal_to": "la duración debe ser igual a %{exact} (la duración actual es %{duration})",
        "duration_not_greater_than": "la duración debe ser mayor que %{min} (la duración actual es %{duration})",
        "duration_not_greater_than_or_equal_to": "la duración debe ser mayor o igual a %{min} (la duración actual es %{duration})",
        "duration_not_less_than": "la duración debe ser inferior a %{max} (la duración actual es %{duration})",
        "duration_not_less_than_or_equal_to": "la duración debe ser menor o igual a %{max} (la duración actual es %{duration})",
        "empty": "no puede estar vacío",
        "equal_to": "debe ser igual a %{count}",
        "equal_to_current_password": "tiene que ser diferente a la contraseña actual.",
        "equal_to_email": "tiene que ser diferente al email",
        "error_columns_excel": "<p>Al parecer el excel no es el indicado, las columnas no concuerdan con las permitidas por el sistema, por favor verifique si son las correctas y en el orden correspondiente.</p> <p>Se recomienda usar la <b>plantilla base</b>.</p>",
        "error_excel": "Error en el excel",
        "even": "debe ser par",
        "exclusion": "está reservado",
        "expired": "ha expirado, por favor solicita una nueva",
        "file_error": "Error en el archivo",
        "file_not_processable": "no se identifica como un archivo multimedia válido",
        "file_size_not_between": "el tamaño del archivo debe estar entre %{min} y %{max} (el tamaño actual es %{file_size})",
        "file_size_not_equal_to": "el tamaño del archivo debe ser igual a %{exact} (el tamaño actual es %{file_size})",
        "file_size_not_greater_than": "el tamaño del archivo debe ser mayor que %{min} (el tamaño actual es %{file_size})",
        "file_size_not_greater_than_or_equal_to": "el tamaño del archivo debe ser mayor o igual a %{min} (el tamaño actual es %{file_size})",
        "file_size_not_less_than": "el tamaño del archivo debe ser inferior a %{max} (el tamaño actual es %{file_size})",
        "file_size_not_less_than_or_equal_to": "el tamaño del archivo debe ser menor o igual a %{max} (el tamaño actual es %{file_size})",
        "file_size_out_of_range": "El tamaño del archivo no debe superar los %{max_size}.",
        "greater_than": "debe ser mayor que %{count}",
        "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
        "image_metadata_missing": "no es una imagen válida",
        "inclusion": "no está incluido en la lista",
        "invalid": "no es válido",
        "invalid_windows_1252": "El texto contiene caracteres no compatibles con la codificación Windows-1252.",
        "less_than": "debe ser menor que %{count}",
        "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
        "limit_max_exceeded": {
          "one": "demasiados archivos adjuntos (máximo es %{max} archivos, got %{count})",
          "other": "demasiados archivos adjuntos (máximo es %{max} archivos, got %{count})",
          "zero": "no hay archivos adjuntos (máximo es %{max} archivos)"
        },
        "limit_min_not_reached": {
          "one": "solo 1 archivo adjunto (debe tener al menos %{min} archivos)",
          "other": "%{count} archivos adjuntos (debe tener al menos %{min} archivos)",
          "zero": "no hay archivos adjuntos (debe tener al menos %{min} archivos)"
        },
        "limit_out_of_range": "el número total está fuera de rango",
        "media_metadata_missing": "no es un archivo multimedia válido",
        "model_invalid": "La validación falló: %{errors}",
        "multiple_max_count_exceeded": "No puedes cargar más de %{max_count} archivo(s)",
        "not_a_number": "no es un número",
        "not_an_integer": "debe ser un entero",
        "not_found": "no se ha encontrado",
        "not_locked": "no estaba bloqueada",
        "not_saved": {
          "one": "Ocurrió un error al tratar de guardar %{resource}:",
          "other": "Ocurrieron %{count} errores al tratar de guardar %{resource}:"
        },
        "odd": "debe ser impar",
        "other_than": "debe ser distinto de %{count}",
        "pages_not_between": "el número de páginas debe estar entre %{min} y %{max} (el número actual de páginas es %{pages})",
        "pages_not_equal_to": "el número de páginas debe ser igual a %{exact} (el número actual de páginas es %{pages})",
        "pages_not_greater_than": "el número de páginas debe ser mayor que %{min} (el número actual de páginas es %{pages})",
        "pages_not_greater_than_or_equal_to": "el número de páginas debe ser mayor o igual que %{min} (el número actual de páginas es %{pages})",
        "pages_not_less_than": "el número de páginas debe ser menor que %{max} (el número actual de páginas es %{pages})",
        "pages_not_less_than_or_equal_to": "el número de páginas debe ser menor o igual que %{max} (el número actual de páginas es %{pages})",
        "password_complexity": {
          "digit": {
            "one": "tiene que contener al menos un dígito",
            "other": "tiene que contener al menos %{count} dígitos"
          },
          "lower": {
            "one": "tiene que contener al menos una minúscula",
            "other": "tiene que contener al menos %{count} minúsculas"
          },
          "symbol": {
            "one": "tiene que contener al menos un signo de puntuación",
            "other": "tiene que contener al menos %{count} signos de puntuación"
          },
          "upper": {
            "one": "tiene que contener al menos una mayúscula",
            "other": "tiene que contener al menos %{count} mayúsculas"
          }
        },
        "pdf_cannot_have_signatures": "El archivo que intentas subir ya contiene firmas digitales, no podemos procesarlo.",
        "pdf_corrupted": "Al parecer el archivo que intentas subir está corrupto, por favor verifícalo y vuelve a subirlo.",
        "pdf_encrypted": "Al parecer el archivo que intentas subir tiene contraseña, archivos con contraseña no son soportados.",
        "pdf_encrypted_for_modifications": "Al parecer el archivo que intentas subir no puede ser modificado sin contraseña, archivos con contraseña no son soportados.",
        "present": "debe estar en blanco",
        "record_invalid": "La validación falló: %{errors}",
        "required": "debe existir",
        "restrict_dependent_destroy": {
          "many": "No se puede eliminar el registro porque existen %{record} dependientes",
          "one": "No se puede eliminar el registro porque existe un %{record} dependiente"
        },
        "taken": "ya está en uso",
        "taken_in_past": "la contraseña fue usada previamente, por favor elige otra.",
        "too_long": {
          "one": "es demasiado largo (1 carácter máximo)",
          "other": "es demasiado largo (%{count} caracteres máximo)"
        },
        "too_short": {
          "one": "es demasiado corto (1 carácter mínimo)",
          "other": "es demasiado corto (%{count} caracteres mínimo)"
        },
        "total_file_size_not_between": "el tamaño total del archivo debe estar entre %{min} y %{max} (el tamaño actual es %{total_file_size})",
        "total_file_size_not_equal_to": "el tamaño total del archivo debe ser igual a %{exact} (el tamaño actual es %{total_file_size})",
        "total_file_size_not_greater_than": "el tamaño total del archivo debe ser mayor que %{min} (el tamaño actual es %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "el tamaño total del archivo debe ser mayor o igual a %{min} (el tamaño actual es %{total_file_size})",
        "total_file_size_not_less_than": "el tamaño total del archivo debe ser inferior a %{max} (el tamaño actual es %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "el tamaño total del archivo debe ser menor o igual a %{max} (el tamaño actual es %{total_file_size})",
        "unsupported_file_type": "Formato del archivo no soportado",
        "wrong_length": {
          "one": "no tiene la longitud correcta (1 carácter exactos)",
          "other": "no tiene la longitud correcta (%{count} caracteres exactos)"
        }
      },
      "rut": {
        "invalid_format": "Formato de RUT inválido"
      },
      "template": {
        "body": "Se encontraron problemas con los siguientes campos:",
        "header": {
          "one": "No se pudo guardar este/a %{model} porque se encontró 1 error",
          "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
        }
      },
      "unprocessable_content": "Oops! Verifique que todos los datos sean correctos"
    },
    "fao": {
      "mapping_configs": {
        "create": {
          "succesfully": "La homologación de FAO ha sido creada correctamente"
        },
        "destroy": {
          "succesfully": "La homologación de FAO ha sido eliminada correctamente"
        },
        "form": {
          "confirm": {
            "confirm": "¿Estás seguro de guardar la homologación de FAO?",
            "title": "Guardar homologación FAO"
          }
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará la homologación de FAO. Esta es una acción no reversible. ¿Estás seguro de eliminar la homologación?",
              "title": "Eliminar homologación de FAO"
            }
          }
        },
        "tooltip_info": "Agrega y gestiona los campos para la homologación de FAO relevante para tu gestión de documentos",
        "update": {
          "succesfully": "La homologación de FAO ha sido actualizada correctamente"
        }
      },
      "mapping_fields": {
        "create": {
          "succesfully": "La homologación de FAO ha sido creada correctamente"
        },
        "destroy": {
          "succesfully": "La homologación de FAO ha sido eliminada correctamente"
        },
        "form": {
          "opt_group": {
            "custom_fields": {
              "one": "Campos personalizados"
            },
            "resource_data": {
              "one": "Información del recurso"
            }
          }
        },
        "update": {
          "succesfully": "La homologación de FAO ha sido actualizada correctamente"
        }
      },
      "messages": {
        "destroy": {
          "confirm": {
            "message": "Se eliminará la homologación de FAO. Esta es una acción no reversible. ¿Estás seguro de eliminar la homologación?",
            "title": "Eliminar homologación de FAO"
          }
        }
      },
      "tooltip_info": "Agrega y gestiona los campos para la homologación de FAO relevante para tu gestión de documentos"
    },
    "file_in_process_of_completion": "Archivo en proceso de completado",
    "filter": {
      "end_date": "Hasta",
      "search": "Buscar",
      "search_by_key_custom_fields": "Campos personalizados",
      "search_query": "Buscar",
      "start_date": "Desde",
      "with_created_at": {
        "end_date": "Hasta",
        "one": "Fecha de creación",
        "start_date": "Desde"
      }
    },
    "formtastic": {
      "cancel": "Cancelar",
      "create": "Guardar %{model}",
      "no": "No",
      "required": "requerido",
      "reset": "Restablecer %{model}",
      "submit": "Aceptar",
      "update": "Guardar %{model}",
      "yes": "Sí"
    },
    "groups": {
      "create": {
        "successfully": "Se ha creado el rol con éxito"
      },
      "destroy": {
        "successfully": "Rol eliminado con éxito"
      },
      "filter": {
        "end_date": "Hasta",
        "search_query": {
          "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del rol</li> </ul>"
        },
        "start_date": "Desde",
        "with_created_at": "Fecha de creación"
      },
      "form": {
        "branch_layer": "Capas de gestión por sucursal",
        "branch_layer_help": "Establece acceso por sucursal al rol. Los usuarios de este rol solo verán las sucursales que estén habilitados.",
        "confirm": {
          "message": "¿Estás seguro de guardar el rol?",
          "title": "Guardar rol"
        },
        "custom_field_permissions": {
          "corporate/custom_fields": {
            "model": {
              "name": "Corporativos"
            }
          },
          "laboral/custom_fields": {
            "model": {
              "name": "Laborales"
            }
          }
        },
        "custom_fields_layer": "Gestión de datos sensibles",
        "custom_fields_layer_help": "Establece la visibilidad por campo personalizado. Los usuarios de este rol verán la información de lo contrario se ocultará.",
        "disabled_abstract_bulk_load_entities_html": "Cuando la <strong>capa de seguridad</strong> se encuentra activa, no es posible asignar permiso de <strong>creación de cargas</strong>",
        "disabled_abstract_document_type_batteries_html": "Cuando la <strong>capa de gestión por tipo de documentos</strong> se encuentra activa, no es posible asignar permisos sobre el recurso baterias de documento, solo sobre <strong>tipos de documentos específicos</strong>.",
        "disabled_abstract_document_types_html": "Cuando la <strong>capa de gestión por tipo de documentos</strong> se encuentra activa, no es posible asignar permisos sobre el recurso tipos de documentos, solo sobre <strong>tipos de documentos específicos</strong>.",
        "disabled_abstract_entities_html": "Cuando la <strong>capa de seguridad</strong> se encuentra activa, no es posible asignar permiso de <strong>creación</strong>",
        "disabled_corporate_document_type_batteries_html": "Cuando la <strong>capa de gestión por tipo de documentos</strong> se encuentra activa, no es posible asignar permisos sobre el recurso baterias de documento, solo sobre <strong>tipos de documentos específicos</strong>.",
        "disabled_corporate_document_types_html": "Cuando la <strong>capa de gestión por tipo de documentos</strong> se encuentra activa, no es posible asignar permisos sobre el recurso tipos de documentos, solo sobre <strong>tipos de documentos específicos</strong>.",
        "disabled_laboral_bulk_load_employees_html": "Cuando la <strong>capa de seguridad</strong> se encuentra activa, no es posible asignar permiso de <strong>creación de cargas de trabajadores</strong>",
        "disabled_laboral_document_type_batteries_html": "Cuando la <strong>capa de gestión por tipo de documentos</strong> se encuentra activa, no es posible asignar permisos sobre el recurso baterias de documento, solo sobre <strong>tipos de documentos específicos</strong>.",
        "disabled_laboral_document_types_html": "Cuando la <strong>capa de gestión por tipo de documentos</strong> se encuentra activa, no es posible asignar permisos sobre el recurso tipos de documentos, solo sobre <strong>tipos de documentos específicos</strong>.",
        "disabled_laboral_employees_html": "Cuando la <strong>capa de seguridad</strong> se encuentra activa, no es posible asignar permiso de <strong>creación de trabajadores</strong>",
        "disabled_members": "Los miembros deshabilitados son administradores",
        "document_type_permissions": {
          "corporate/document_types": {
            "model": {
              "name": "Corporativos"
            }
          },
          "laboral/document_types": {
            "model": {
              "name": "Laborales"
            }
          }
        },
        "document_types_layer": "Capa de gestión por tipo de documentos",
        "document_types_layer_help": "Establece acceso por tipo de documento al rol. Los usuarios de este rol solo verán los documentos que estén habilitados.",
        "document_types_module": "Capa de Gestión por Tipos de Documento módulo %{module}",
        "permissions": {
          "abstract": "%{module}",
          "blog": "Blog Empresa",
          "compliance": "Cumplimiento %{compliance_context}",
          "controldoc_forms": "ControldocForms",
          "corporate": "Corporativo",
          "dt": "Dirección del Trabajo",
          "economic_crime": "Delitos Económicos",
          "karin_law": "Ley Karin",
          "laboral": "Laboral",
          "portal": "Portal Empresa",
          "role_name": {
            "all": "Todos",
            "block": "Bloquear",
            "create": "Crear",
            "destroy": "Eliminar",
            "index": "Listado",
            "show": "Ver",
            "update": "Editar"
          },
          "title": "Módulos y Permisos",
          "tooltip_info": "Establece permisos por Módulos para cada recurso",
          "without_results_permissions": "No existen permisos asociados"
        },
        "roles_module": "Permisos para módulo %{module}",
        "security_layer": "Capas de seguridad",
        "security_layer_help": "Establece acceso por capa de seguridad al rol. Los usuarios de este rol solo verán los trabajadores de las capas de seguridad seleccionadas."
      },
      "headers": {
        "delete": "Eliminar documento",
        "edit": "Editar Rol",
        "title": "Rol"
      },
      "index": {
        "new": "Nuevo Rol",
        "without_results": "No hemos encontrado roles"
      },
      "messages": {
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar el rol?",
            "title": "Eliminar rol"
          }
        }
      },
      "show": {
        "custom_fields_module": "Campos personalizados para módulo %{module}",
        "details": "Detalles",
        "document_types_module": "Tipos de documentos para módulo %{module}",
        "role_name": {
          "block": "Bloquear",
          "create": "Crear",
          "destroy": "Eliminar",
          "index": "Listado",
          "show": "Ver",
          "update": "Editar"
        },
        "roles_module": "Permisos para módulo %{module}",
        "without_branches": "No hay sucursales habilitadas",
        "without_members": "Rol sin miembros asignados"
      },
      "tooltip_info": "Gestiona roles de usuarios para asignar permisos de acceso a la plataforma",
      "update": {
        "successfully": "Se ha actualizado rol con éxito"
      }
    },
    "help": "Ayuda",
    "helpers": {
      "select": {
        "prompt": "Por favor seleccione"
      },
      "show_as_grid": "Ver como cuadrícula",
      "show_as_list": "Ver como lista",
      "submit": {
        "create": "Crear",
        "submit": "Guardar",
        "update": "Actualizar"
      }
    },
    "home": "Inicio",
    "http": {
      "forbidden": "No estás autorizado para realizar esta acción",
      "unauthorized": "Debes iniciar sesión"
    },
    "important": "¡Importante!",
    "important_info": "¡Información Importante!",
    "inputs": {
      "select": {
        "placeholder": "-- Seleccione una opción -- "
      },
      "select_a_option": "Selecciona una opción"
    },
    "karin_law": {
      "complaints": {
        "create": {
          "succesfully": "La denuncia ha sido creado correctamente"
        },
        "destroy": {
          "confirm": {
            "message": " <p> ¿Estás seguro de eliminar la denuncia? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará los documentos asociados.</li> </ul> </div> ",
            "title": "Eliminar denuncia"
          },
          "succesfully": "La denuncia ha sido eliminado correctamente"
        },
        "filter": {
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Identificador de la denuncia</li> </ul> "
          }
        },
        "identifier_help": "Es un código único y modificable con el que se identificará la denuncia en la plataforma, el cual puede ser un código interno de tu empresa. Si se deja en blanco ControlDoc creará uno por ti.",
        "index": {
          "show_profile": "Ver denuncia"
        },
        "show": {
          "custom_fields": "Otros datos de la denuncia",
          "details": "Detalles de la denuncia"
        },
        "tooltip_info": "Administra todas las denuncias y sus datos",
        "update": {
          "succesfully": "La denuncia ha sido actualizado correctamente"
        }
      },
      "custom_fields": {
        "create": {
          "succesfully": "El campo personalizado ha sido creado correctamente"
        },
        "destroy": {
          "succesfully": "El campo personalizado ha sido eliminada correctamente"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará el campo personalizado y todos los datos asociados. Esta es una acción no reversible. ¿Estás seguro de eliminar el campo personalizado?",
              "title": "Eliminar campo personalizado"
            }
          }
        },
        "show": {
          "details": "Detalles del campo personalizado"
        },
        "show_as_name": {
          "help": "Permite mostrar la información como parte del nombre para las denuncias"
        },
        "show_on_list": {
          "help": "Permite mostrar la información como parte de la lista para las denuncias"
        },
        "tooltip_info": "Agrega y gestiona campos de  información que consideres relevante para tu gestión de documentos",
        "update": {
          "succesfully": "El campo personalizado ha sido actualizado correctamente"
        }
      },
      "workflow": {
        "processes": {
          "destroy": {
            "confirm": {
              "message": " <p> ¿Estás seguro de eliminar el proceso? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará las denuncias asociadas y todas las evidencias.</li> </ul> </div> ",
              "title": "Eliminar Proceso"
            },
            "successfully": "El proceso ha sido eliminado correctamente"
          }
        },
        "requirement_mailer": {
          "notify_to_responsible": {
            "subject": "Denuncia creada!"
          }
        },
        "requirement_stage_mailer": {
          "moving_backward_html": "La denuncia de ley Karin <strong>%{requirement_name}</strong> ha sido devuelta a la etapa <strong>%{to_stage_name}</strong>",
          "moving_forward_html": "La denuncia de ley Karin <strong>%{requirement_name}</strong> ha avanzado a la etapa <strong>%{to_stage_name}</strong>",
          "new_requirement_html": "Se ha recepcionado una denuncia de ley Karin en <strong>%{requirement_name}</strong>",
          "notify_to_expire": {
            "subject": "Denuncia por cumplir plazo"
          }
        },
        "requirements": {
          "filter": {
            "perpetrator_data": "Datos del denunciado/a",
            "representative_data": "Datos del representante",
            "victim_data": "Datos del afectado/a"
          },
          "form": {
            "perpetrator": {
              "title": "Datos del denunciado/a"
            },
            "representative": {
              "title": "Datos del representante"
            },
            "victim": {
              "title": "Antecedentes del afectado"
            }
          },
          "modal_confirm_destroy": {
            "deleted_reason_label": "Motivo de eliminación",
            "deleted_reason_placeholder": "Por favor, indique el motivo de la eliminación...",
            "question": "¿Estás seguro de eliminar esta denuncia?",
            "title": "Eliminar denuncia"
          },
          "show": {
            "details": "Detalle de la denuncia"
          }
        }
      }
    },
    "laboral": {
      "activerecord": {
        "attributes": {
          "bulk/request/destroy_document": {
            "aasm_state": {
              "completed": "Procesado",
              "completed_errors": "Procesado con errores",
              "failed": "Fallido",
              "one": "Estado",
              "pending": "Pendiente",
              "processing": "Procesando"
            },
            "created_at": "Fecha creación",
            "files": "Archivos",
            "requested_by": "Solicitado por"
          },
          "bulk/request/destroy_document_item": {
            "aasm_state": {
              "completed": "Procesado",
              "completed_errors": "Procesado con errores",
              "failed": "Fallido",
              "one": "Estado",
              "pending": "Pendiente",
              "processing": "Procesando"
            },
            "created_at": "Fecha creación",
            "document": "Documento",
            "document_id": "Documento",
            "document_type": "Tipo de documento",
            "email": "Correo electrónico",
            "name": "Nombre"
          },
          "bulk/request/zip/document": {
            "aasm_state": {
              "completed": "Procesado",
              "completed_errors": "Procesado con errores",
              "failed": "Fallido",
              "one": "Estado",
              "pending": "Pendiente",
              "processing": "Procesando"
            },
            "created_at": "Fecha creación",
            "files": "Archivos",
            "requested_by": "Solicitado por"
          },
          "laboral/bulk/request/destroy_employee_items": {
            "aasm_state": {
              "completed": "Procesado",
              "completed_errors": "Procesado con errores",
              "failed": "Fallido",
              "one": "Estado",
              "pending": "Pendiente",
              "processing": "Procesando"
            }
          },
          "laboral/controldoc_form/document": {
            "aasm_state": {
              "blocked": "Bloqueado",
              "filled": "Completado",
              "one": "Estado",
              "partially_filled": "En proceso",
              "pending": "Pendiente"
            },
            "blocked_by": "Bloqueado por",
            "controldoc_state": "Estado de firma:",
            "created_at": "Fecha de creación",
            "created_by_id": "Creado por",
            "email": "Nombre"
          },
          "laboral/controldoc_form/template": {
            "content": "Contenido",
            "created_by_id": "Creado por",
            "name": "Nombre",
            "vars": "Variables"
          },
          "laboral/custom_field": {
            "code": "Código",
            "created_at": "Fecha de creación",
            "data_type": "Tipo de dato",
            "label": "Etiqueta",
            "resource_type": "Recurso"
          }
        },
        "errors": {
          "models": {
            "bulk/request/destroy_document": {
              "attributes": {
                "items": {
                  "blank": "Debe seleccionar al menos un documento para Eliminar"
                }
              }
            },
            "bulk/request/destroy_document_item": {
              "attributes": {
                "documentos": {
                  "blank": "Debe seleccionar al menos un documento"
                }
              }
            },
            "bulk/request/zip/document": {
              "attributes": {
                "items": {
                  "blank": "Debe seleccionar al menos un documento para descargar"
                }
              }
            },
            "controldoc_form/template": {
              "attributes": {
                "name": {
                  "blank": "Debe ingresar el nombre de la plantilla",
                  "taken": "El nombre de la plantilla ya se encuentra en uso"
                }
              }
            },
            "corporate/agreement": {
              "attributes": null
            },
            "laboral/bulk/request/destroy_employee_item": {
              "attributes": {
                "employees": {
                  "blank": "Debe seleccionar al menos un trabajador"
                }
              }
            },
            "laboral/custom_field": {
              "attributes": {
                "code": {
                  "taken": "Ya éxiste uno con este Código"
                }
              }
            }
          }
        },
        "models": {
          "bulk/request/destroy_document": {
            "one": "Eliminación de documentos",
            "other": "Eliminación de documentos"
          },
          "bulk/request/destroy_document_item": null,
          "bulk/request/zip/document": {
            "one": "Descarga Masiva de documentos",
            "other": "Descargas Masivas de documentos"
          },
          "laboral/bulk/request/destroy_employee_items": null,
          "laboral/controldoc_form/document": {
            "one": "Documento",
            "other": "Documentos"
          },
          "laboral/controldoc_form/template": {
            "one": "Plantilla",
            "other": "Plantillas"
          },
          "laboral/custom_field": {
            "one": "Campo personalizado",
            "other": "Campos personalizados"
          }
        }
      },
      "bulk": {
        "load": {
          "arauco": {
            "docx_merge_field_items": {
              "list": {
                "not_sent_to_sign": "No enviado",
                "send_to_sign_status": "Envío a firma",
                "sent_to_sign": "Enviado"
              }
            },
            "docx_merge_fields": {
              "filter": {
                "by_aasm_state": "Estado"
              },
              "filters_card": {
                "filter_by_branch_text": "Sucursal",
                "filter_by_branch_text_placeholder": "Identificador o nombre de sucursal",
                "filter_by_company_text": "Empresa",
                "filter_by_company_text_placeholder": "Identificador o razón social",
                "filter_by_employee_text": "Trabajador",
                "filter_by_employee_text_placeholder": "N° personal, nombre o correo",
                "title": "Filtros del listado"
              },
              "show": {
                "details": "Detalles"
              },
              "tooltip_info": "Carga de campos de merge de documentos DOCX de Arauco"
            }
          },
          "employee_items": {
            "filter": {
              "by_operation_type": "Acción",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> <li>Identificador del trabajador</li> </ul>"
              }
            },
            "list": {
              "operation_type": {
                "created": "Creado",
                "updated": "Actualizado",
                "without_changes": "Sin cambios"
              },
              "without_completed": "No hemos encontrado registros procesados",
              "without_completed_errors": "No hemos encontrado registros con errores",
              "without_pending": "No hemos encontrado registros pendientes",
              "without_processing": "No hemos encontrado registros en proceso"
            }
          },
          "employees": {
            "create": {
              "succesfully": "La carga masiva de trabajadores se encuentra procesando"
            },
            "filter": {
              "by_state": "Estado",
              "created_by": "Creado por",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha inicio",
              "with_errors": "Con errores",
              "without_errors": "Sin errores"
            },
            "form": {
              "config": {
                "delete": {
                  "cancel": "Cancelar",
                  "confirm": "Confirmar",
                  "text": "¿Estás seguro de eliminar la fila?",
                  "title": "Eliminar fila"
                }
              },
              "confirm": {
                "message": "¿Estás seguro de guardar los trabajadores?",
                "title": "Guardar Trabajadores"
              },
              "default_headers": {
                "controldoc_id": "CONTROLDOCID ( PELIGRO NO MODIFICAR, PARA NUEVOS REGISTROS DEJAR EN BLANCO)",
                "identifier": "Identificador del trabajador",
                "name": "Nombre del trabajador",
                "security_layer": "Capa de Seguridad",
                "value": "Correo electrónico del trabajador"
              },
              "file_input": {
                "button": "Subir archivo",
                "download_template": "Descargar plantilla de trabajadores",
                "error": {
                  "icon": "error",
                  "text": "El documento debe ser en formato excel",
                  "title": "Oops..."
                }
              },
              "save": "Guardar",
              "table": {
                "title": "Registros sin errores"
              },
              "table_error": {
                "title": "Registros con errores",
                "title2": "Corregir antes de continuar"
              },
              "table_new": {
                "title": "Registros nuevos"
              },
              "without_records": "No existen registros"
            },
            "index": {
              "tabs": {
                "mistakes": "Fallidos",
                "pendings": "Pendientes",
                "processed": "Procesados"
              },
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "tabs": {
                "completed_mistakes": "Procesados fallidos",
                "mistakes": "Con errores",
                "pendings": "Pendientes",
                "processed": "Procesados"
              }
            },
            "tooltip_info": "Gestiona e importa listados de trabajadores y sus datos en un archivo Excel. Visualiza el estado y registro histórico de las cargas realizadas."
          },
          "hiring_document_items": null,
          "hiring_documents": {
            "create": {
              "succesfully": "La carga masiva de documentos ha sido creado correctamente"
            },
            "destroy": {
              "succesfully": "La carga masiva de documentos ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "by_document_type": "Tipo de documento",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "require_signers": {
                "helper": {
                  "title": "Al solicitar firmantes, el sistema se integrará con ControlDoc Sign"
                }
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "hirings": "Contrataciones",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Carga simultáneamente hasta 100 documentos relacionados a varias contrataciones. El nombre del archivo debe ser el identificador de la contratación. Visualiza el estado y registro histórico de las cargas realizadas.",
            "update": {
              "succesfully": "La carga masiva de documentos ha sido actualizado correctamente"
            }
          },
          "hiring_items": {
            "list": {
              "created": "Creado",
              "updated": "Actualizado",
              "without_changes": "Sin cambios",
              "without_completed": "No hemos encontrado registros procesados",
              "without_completed_errors": "No hemos encontrado registros con errores",
              "without_pending": "No hemos encontrado registros pendientes",
              "without_processing": "No hemos encontrado registros en proceso"
            }
          },
          "hirings": {
            "create": {
              "succesfully": "La carga masiva de contrataciones se encuentra procesando"
            },
            "destroy": {
              "succesfully": "La contratación ha sido eliminada correctamente"
            },
            "filter": {
              "created_by": "Creado por",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_start_date": "Fecha inicio"
            },
            "form": {
              "confirm": {
                "message": "¿Estás seguro de guardar las contrataciones?",
                "title": "Guardar Contrataciones"
              },
              "default_headers": {
                "branch_id": "Sucursal",
                "controldoc_id": "CONTROLDOCID ( PELIGRO NO MODIFICAR, PARA NUEVOS REGISTROS DEJAR EN BLANCO)",
                "employee_id": "Trabajador",
                "end_date": "Fecha termino",
                "hiring_id": "Identificador contratacion ( PARA AUTOGENERACIÓN DEJAR EN BLANCO)",
                "security_layer_id": "Capa de Seguridad",
                "start_date": "Fecha inicio"
              },
              "file_input": {
                "download_template": "Descargar plantilla de contrataciones"
              },
              "save": "Guardar"
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles de la contratación",
              "error": "Errores"
            },
            "tooltip_info": "Gestiona e importa listados de contrataciones asociadas a los trabajadores en una plantilla excel. Visualiza el estado y registro histórico de las cargas realizadas.",
            "update": {
              "succesfully": "La contratación ha sido actualizada correctamente"
            }
          }
        },
        "notification": {
          "fill_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "fills": {
            "create": {
              "successfully": "Notificación masiva de formularios ha sido creada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "cant_fill_selected": "Has seleccionado %{count} Formularios.",
              "confirm": {
                "message": "¿Estás seguro de realizar la notificación masiva?",
                "title": "Realizar notificación masiva"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "fills": "Formularios",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_completed": "No hemos encontrado registros procesados",
              "without_completed_errors": "No hemos encontrado registros con errores",
              "without_pending": "No hemos encontrado registros pendientes",
              "without_processing": "No hemos encontrado registros en proceso",
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona varios formularios pendientes para notificar su completación"
          },
          "sign_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "without_completed": "No hemos encontrado registros procesados",
              "without_completed_errors": "No hemos encontrado registros con errores",
              "without_pending": "No hemos encontrado registros pendientes",
              "without_processing": "No hemos encontrado registros en proceso"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "signs": {
            "create": {
              "succesfully": "Notificación masiva de firmas ha sido creada correctamente"
            },
            "destroy": {
              "succesfully": "Notificación masiva de firmas ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "cant_sign_selected": "Has seleccionado %{count} Firmas.",
              "confirm": {
                "message": "¿Estás seguro de realizar la notificación masiva?",
                "title": "Realizar notificación masiva"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "signs": "Firmas",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona varios firmantes pendientes para solicitar firma de documentación",
            "update": {
              "succesfully": "Notificación masiva de firmas ha sido actualizada correctamente"
            }
          }
        },
        "request": {
          "destroy_document_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "destroy_documents": {
            "create": {
              "succesfully": "Eliminación masiva de documentos ha sido creado correctamente"
            },
            "destroy": {
              "succesfully": "Eliminación masiva de documentos ha sido eliminado correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "confirm": {
                "message": "¿Estás seguro de realizar la eliminación de documentos?",
                "title": "Realizar eliminación de documentos"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "documentos": "Firmas",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona los documentos que requieres eliminar",
            "update": {
              "succesfully": "Eliminación masiva de documentos ha sido actualizado correctamente"
            }
          },
          "destroy_employee_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "destroy_employees": {
            "create": {
              "succesfully": "Eliminación de trabajadores ha sido creada correctamente"
            },
            "destroy": {
              "succesfully": "Eliminación de trabajadores ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "confirm": {
                "message": " <p> ¿Estás seguro de eliminar los trabajadores? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará las contrataciones.</li> <li>Eliminará todos los documentos asociados a sus contrataciones.</li> <li>Esta acción no elimina el acceso del usuario al portal solamente elimina sus contrataciones y documentos.</li> </ul> </div> ",
                "title": "Realizar eliminación de trabajadores?"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "trabajadores": "Firmas",
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona los trabajadores que requieres eliminar",
            "update": {
              "succesfully": "Eliminación de trabajadores ha sido actualizada correctamente"
            }
          },
          "hiring_document_configs": {
            "require_upload_deadline_help": "Si el documento tiene una fecha límite para ser subido, ingrésala para que cada trabajador tenga en consideración el límite de fecha para firmar el documento",
            "tooltip_auto_help": "Si es autocompletada debe verificar que toda la información de las contrataciones se encuentran completada de lo contrario algunas solicitudes no podrán ser procesadas"
          },
          "hiring_document_items": null,
          "hiring_documents": {
            "create": {
              "succesfully": "Solicitud masiva de documentos ha sido creada correctamente"
            },
            "destroy": {
              "succesfully": "Solicitud masiva de documentos ha sido eliminada correctamente"
            },
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "form": {
              "add_config": "Agregar nuevo documento",
              "cant_hiring_selected": "Has seleccionado %{count} contrataciones.",
              "confirm": {
                "message": "¿Estás seguro de realizar la solicitud masiva?",
                "title": "Realizar solicitud masiva"
              },
              "remove_config": "Eliminar documento",
              "require_signers": {
                "helper": {
                  "title": "Al solicitar firmantes, el sistema se integrará con ControlDoc"
                }
              },
              "tabs": {
                "config": "Configuración",
                "config_button": "Ir a Paso 2 Configuración",
                "config_title": "Paso 2 configuración de documentos",
                "hiring": "Contratación",
                "hirings": "Contrataciones",
                "hirings_button": "Volver a Paso 1 Contrataciones",
                "hirings_title": "Paso 1 seleccionar contrataciones"
              }
            },
            "index": {
              "without_results": "No hemos encontrado registros"
            },
            "show": {
              "details": "Detalles",
              "hirings": "Contrataciones",
              "tabs": {
                "all": "Todos",
                "completed": "Procesados",
                "completed_errors": "Procesados con errores",
                "failed": "Fallido",
                "pending": "Pendientes"
              },
              "without_results": "No hemos encontrado registros"
            },
            "tooltip_info": "Selecciona varios trabajadores para solicitar carga o firma de documentación. Puedes subir, solicitar que el trabajador suba o usar una plantilla para completar.",
            "update": {
              "succesfully": "Solicitud masiva de documentos ha sido actualizada correctamente"
            }
          },
          "hiring_items": {
            "filter": {
              "by_aasm_state": "Estado",
              "end_date": "Hasta",
              "search_query": {
                "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> <li>Identificador del trabajador</li> <li>Identificador de la contratación</li> </ul>"
              },
              "start_date": "Desde",
              "with_created_at": "Fecha de creación"
            },
            "list": {
              "documents": "Documentos"
            },
            "show": {
              "errors": "Errores"
            }
          },
          "zip": {
            "documents": {
              "create": {
                "succesfully": "Descarga de documentos ha sido creada correctamente"
              },
              "destroy": {
                "succesfully": "Descarga de documentos ha sido eliminada correctamente"
              },
              "filter": {
                "by_aasm_state": "Estado",
                "end_date": "Hasta",
                "start_date": "Desde",
                "with_created_at": "Fecha de creación"
              },
              "form": {
                "confirm": {
                  "message": "¿Estás seguro de realizar la descarga de documentos?",
                  "title": "Realizar descarga de documentos"
                }
              },
              "index": {
                "without_results": "No hemos encontrado registros"
              },
              "show": {
                "details": "Detalles",
                "documentos": "Firmas",
                "tabs": {
                  "all": "Todos",
                  "completed": "Procesados",
                  "completed_errors": "Procesados con errores",
                  "failed": "Fallido",
                  "pending": "Pendientes"
                },
                "without_results": "No hemos encontrado registros"
              },
              "tooltip_info": "Selecciona los documentos que requieres descargar",
              "update": {
                "succesfully": "Descarga de documentos ha sido actualizada correctamente"
              }
            }
          }
        }
      },
      "bulk_signer_config": null,
      "by_client": "Cliente",
      "by_operation_type": "Acción",
      "by_provider": "Proveedor",
      "check_list": {
        "hiring_processes": {
          "create": {
            "succesfully": "El check list ha sido creado correctamente"
          },
          "destroy": {
            "succesfully": "El check list ha sido eliminada correctamente"
          },
          "filter": {
            "by_company": "Empresa",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del check list</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "form": {
            "create": {
              "confirm": {
                "message": "¿Estás seguro de crear el check list?",
                "title": "Crear check list"
              }
            },
            "document_types": {
              "without_results": "No hemos encontrado tipos de documentos"
            },
            "entities": {
              "without_results": "No hemos encontrado trabajadores"
            },
            "update": {
              "confirm": {
                "message": "¿Estás seguro de actualizar el check list?",
                "title": "Actualizar check list"
              }
            }
          },
          "index": {
            "without_results": "No hemos encontrado check list"
          },
          "messages": {
            "destroy": {
              "confirm": {
                "message": "¿Estás seguro de eliminar el check list?",
                "title": "Eliminar check list"
              }
            }
          },
          "refresh": {
            "successfully": "El check list ha sido refrescado correctamente"
          },
          "show": {
            "details": "Detalles del check list"
          },
          "show_filter": {
            "by_company": "Por empresa",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del trabajador</li> <li>Email del trabajador</li> </ul>"
            },
            "with_start_date": "Fecha inicio de contratación"
          },
          "tooltip_info": "Revisa y controla documentos asociados a contrataciones para identificar documentación lista o pendiente",
          "update": {
            "succesfully": "El check list ha sido actualizado correctamente"
          }
        },
        "hiring_tasks": {
          "create": {
            "succesfully": "El requerimiento ha sido creado correctamente"
          },
          "destroy": {
            "succesfully": "El requerimiento ha sido eliminada correctamente"
          },
          "filter": {
            "by_document_type": "Tipo de documento",
            "by_employee": "Trabajador",
            "by_is_reviewed": "Revisado",
            "by_process": "Proceso de cumplimiento"
          },
          "update": {
            "succesfully": "El requerimiento ha sido actualizado correctamente"
          }
        }
      },
      "controldoc_consent_annex": {
        "hiring_documents": {
          "create": {
            "succesfully": "El anexo de gestión de documentos ha sido creado correctamente"
          },
          "form": {
            "confirm": {
              "messages": "¿Estás seguro de enviar el anexo de gestión de documentos?",
              "title": "Enviar anexo de gestión de documentos"
            },
            "detail_consent": "Detalle del anexo de gestión de documentos",
            "preview_document": "Previsualización del documento",
            "without_content": "No hemos encontrado el contenido"
          },
          "help": "En este anexo el trabajador debe consentir expresamente que su documentación sea enviada y firmada electrónicamente.",
          "new": {
            "important_info_html": "Si tu empresa necesita un <strong>respaldo físico</strong> del <strong>consentimiento de gestión de documentos</strong>, te recomendamos obtener una versión <strong>firmada de forma física</strong> de este documento.",
            "title": "Anexo de gestión de documentos"
          }
        }
      },
      "controldoc_form": {
        "documents": {
          "block": {
            "error_block_document": "El documento no pudo bloquearse",
            "succesfully": "El documento ha sido bloqueado correctamente",
            "without_controldoc_form_integration": "Debes integrar tu cuenta con ControlDoc Forms <a href='%{url}'>aquí</a>"
          },
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la Plantilla</li> <li>Email</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha inicio",
            "with_group_by": "Rol"
          },
          "index": {
            "without_results": "No hemos encontrado documentos asociadas"
          },
          "list": {
            "send": "Enviado a"
          },
          "show": {
            "details": "Documento",
            "other_data": "Otros datos",
            "signers": "Firmantes"
          }
        },
        "template_mapping_links": {
          "filter": {
            "by_aasm_state": "Estado",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la Plantilla</li> <li>Email</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha inicio",
            "with_group_by": "Rol"
          },
          "form": {
            "opt_group": {
              "adp_fields": {
                "one": "Campos de ADP"
              },
              "custom_fields": {
                "one": "Campos personalizados"
              },
              "hiring_custom_date_format": {
                "one": "Fechas de contrato"
              },
              "resource_data": {
                "one": "Información del recurso"
              },
              "system_information": {
                "one": "Información de sistema"
              }
            },
            "resource": {
              "laboral_employee": {
                "one": "Trabajador"
              },
              "laboral_hiring": {
                "one": "Contratación"
              },
              "system_resource": {
                "one": "Sistema"
              }
            }
          },
          "index": {
            "without_results": "No hemos encontrado documentos asociadas"
          },
          "list": {
            "send": "Enviado a"
          },
          "tooltip_info": "Visualiza los envíos realizados y completados en ControlDoc Forms"
        },
        "templates": {
          "assign_mapping_links": {
            "successfully": "Mapeo de plantilla con éxito"
          },
          "create": {
            "succesfully": "Plantilla creada con éxito"
          },
          "destroy": {
            "succesfully": "Plantilla eliminada con éxito"
          },
          "filter": {
            "by_company": "Empresa",
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la plantilla</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha inicio",
            "with_group_by": "Rol"
          },
          "form": {
            "confirm": {
              "message": "¿Estás seguro de guardar la plantilla?",
              "title": "Guardar plantilla"
            },
            "homologize_fields": "Homologar campos"
          },
          "index": {
            "sync": "Sincronización",
            "without_results": "No hemos encontrado plantillas asociadas"
          },
          "list": {
            "homologize_fields": "Homologar campos",
            "mapping": "Mapear"
          },
          "show": {
            "details": "Plantilla",
            "details_vars": "Autocompletar Plantilla",
            "details_vars_info": "Determina con qué información completarás la plantilla",
            "map_fields": "Asignar campos",
            "var_blank": "Si la tabla se deja en blanco, se interpreta que los campos de la plantilla serán completados posteriormente por cada usuario."
          },
          "sync": {
            "message": "Sincronización exitosa"
          },
          "table": {
            "attribute": "Atributo",
            "info": {
              "attribute": "Dato a completar en la variable de la plantilla",
              "model": "El recurso desde donde se extraerá el dato para completar la plantilla",
              "name": "Nombre",
              "type": "Tipo",
              "var": "El campo a completar en la plantilla"
            },
            "map": "Mapeo",
            "model": "Módulo / Recurso",
            "name": "Nombre",
            "type": "Tipo",
            "value": "Valor",
            "var": "Variable"
          },
          "update": {
            "successfully": "Plantilla actualizada con éxito"
          }
        }
      },
      "custom_fields": {
        "create": {
          "successfully": "El campo personalizado ha sido creado correctamente"
        },
        "data_types": {
          "date": "Fecha",
          "text": "Texto"
        },
        "destroy": {
          "succesfully": "El campo personalizado ha sido eliminada correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del campo personalizado</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el campo personalizado?",
            "title": "Guardar campo personalizado"
          },
          "save": "Guardar"
        },
        "index": {
          "without_results": "No hemos encontrado campos personalizados"
        },
        "list_options": {
          "help": "Para agregar opciones en la lista debe ingresar los campos separados por coma (,)"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará el campo personalizado y todos los datos asociados. Esta es una acción no reversible. ¿Estás seguro de eliminar el campo personalizado?",
              "title": "Eliminar campo personalizado"
            }
          }
        },
        "order": {
          "form": {
            "confirm": {
              "message": "¿Estás seguro de ordenar los campos personalizados?",
              "title": "Ordenar campos personalizados"
            }
          }
        },
        "show": {
          "details": "Detalles del campo personalizado"
        },
        "show_on_list": {
          "help": "Permite mostrar la información como parte de la lista para trabajador o contratación según el recurso seleccionado"
        },
        "tooltip_info": "Agrega y gestiona campos de  información que consideres relevante para tu gestión de documentos",
        "update": {
          "succesfully": "El campo personalizado ha sido actualizado correctamente"
        },
        "update_order": {
          "successfully": "Los campo personalizado han sido ordenados correctamente"
        }
      },
      "document_type_batteries": {
        "create": {
          "succesfully": "La batería de documentos ha sido creada correctamente"
        },
        "data_types": {
          "date": "Fecha",
          "text": "Texto"
        },
        "destroy": {
          "succesfully": "La batería de documentos ha sido eliminada correctamente"
        },
        "filter": {
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la batería</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar la batería de documentos?",
            "title": "Guardar batería de documentos"
          },
          "save": "Guardar batería de documentos"
        },
        "index": {
          "without_results": "No hemos encontrado baterías de documentos"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará la batería de documentos y todos los datos asociados. Esta es una acción no reversible. ¿Estás seguro de eliminar la batería de documentos?",
              "title": "Eliminar batería de documentos"
            }
          }
        },
        "show": {
          "details": "Detalles de la batería de documentos"
        },
        "tooltip_info": "Administra conjunto de tipos de documentos para realizar de forma óptima las acciones masivas.",
        "update": {
          "succesfully": "La batería de documentos ha sido actualizado correctamente"
        }
      },
      "document_types": {
        "create": {
          "succesfully": "El tipo de documento ha sido creado correctamente"
        },
        "destroy": {
          "succesfully": "El tipo de documento ha sido eliminada correctamente"
        },
        "filter": {
          "by_company": "Empresa",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del tipo de documento</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha inicio"
        },
        "index": {
          "without_results": "No hemos encontrado tipos de documentos"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar el tipo de documento?",
              "title": "Eliminar Tipo de Documento"
            }
          }
        },
        "show": {
          "details": "Detalles del tipo de documento",
          "signer_details": "Detalles de los firmantes predeterminados"
        },
        "tooltip_info": "Crea tipos de documentos para categorizar la documentación laboral de tu empresa",
        "update": {
          "succesfully": "El tipo de documento ha sido actualizado correctamente"
        }
      },
      "employee_documents": {
        "block": {
          "description": "Descripción",
          "successfully": "El documento ha sido bloqueado correctamente"
        },
        "controldoc_state": {
          "blocked": "Bloqueado",
          "partially_signed": "Firmado parcialmente",
          "pending_shortlist": "Pendiente Shortlist",
          "pending_sign": "Pendiente por firmar",
          "pending_to_fill": "Pendiente por llenar",
          "pending_upload": "Pendiente por subir",
          "rejected": "Rechazado",
          "signature_expired": "Plazo de firma vencido",
          "signed_by_all": "Firmado",
          "uploaded": "Archivo subido"
        },
        "create": {
          "successfully": "El documento ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El documento ha sido marcado para eliminación"
        },
        "index": {
          "without_results": "No hemos encontrado documentos"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar el documento?",
              "title": "Eliminar Documento"
            }
          }
        },
        "refresh": {
          "successfully": "El estado de la integracion ha sido actualizado correctamente"
        },
        "retry_controldoc_integration": {
          "successfully": "Se ha enviado la integración con ControlDoc Sign"
        },
        "show": {
          "controldoc_integration_data": "Datos de integración con ControlDoc Sign",
          "details": "Detalles del documento",
          "details_blocked": "Detalles del documento bloqueado",
          "signers": "Firmantes"
        },
        "signer_state": {
          "blocked": "Bloqueado",
          "pending": "Pendiente de firma",
          "rejected": "Rechazado",
          "sign_skipped": "Firma omitida",
          "signed": "Firmado"
        },
        "update": {
          "error_block_document": "No es posible bloquear el documento",
          "successfully": "El documento ha sido actualizado correctamente"
        }
      },
      "employee_email_changes": {
        "create": {
          "successfully": "La solicitud de cambio de correo ha sido registrada y se procesará en breve."
        },
        "show": {
          "details": "Detalles del cambio",
          "documents_action": {
            "block": "Bloquear documentos",
            "delete": "Eliminar documentos",
            "remove": "Eliminar documentos"
          },
          "error_message": "Error al procesar el cambio de correo electrónico.",
          "new_doc": "Nuevo",
          "new_doc_pending": "Pendiente de creación",
          "original_doc": "Original",
          "recreated_documents": "Documentos recreados",
          "states": {
            "completed": "Completado",
            "failed": "Fallido",
            "pending": "Pendiente",
            "processing": "Procesando"
          }
        }
      },
      "employee_requirement_types": {
        "create": {
          "succesfully": "El tipo de requerimiento ha sido creado correctamente"
        },
        "destroy": {
          "succesfully": "El tipo de requerimiento ha sido eliminada correctamente"
        },
        "filter": {
          "by_company": "Empresa",
          "end_date": "Hasta",
          "filter": null,
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del requerimiento</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha de creación"
        },
        "index": {
          "without_results": "No hemos encontrado proceso de cumplimiento"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar el proceso de cumplimiento?",
              "title": "Eliminar Proceso de Cumplimiento"
            }
          }
        },
        "show": {
          "details": "Detalles del proceso de cumplimiento"
        },
        "update": {
          "succesfully": "El tipo de requerimiento ha sido actualizado correctamente"
        }
      },
      "employees": {
        "card_info": {
          "email_change_in_progress": "Hay un cambio de correo en proceso",
          "email_change_states": {
            "completed": "Cambio de correo completado",
            "failed": "Cambio de correo fallido",
            "pending": "Cambio de correo pendiente",
            "processing": "Cambio de correo en proceso"
          },
          "last_email_change": "Último cambio"
        },
        "create": {
          "succesfully": "El trabajador ha sido creado correctamente"
        },
        "custom_filter": {
          "end_date": "Hasta",
          "start_date": "Desde",
          "with_created_at": "Fecha de creación"
        },
        "destroy": {
          "succesfully": "El trabajador ha sido eliminado correctamente"
        },
        "filter": {
          "by_hiring_state": "Estado de contratación",
          "end_date": "Hasta",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> <li>Correo Electrónico</li> <li>Identificador del trabajador</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha de creación"
        },
        "identifier_help": "Es un código único y modificable con el que se identificará el trabajador en la plataforma, el cual puede ser el RUT o un código interno de tu empresa. Si se deja en blanco ControlDoc creará uno por ti.",
        "index": {
          "show_employee": "Ver perfil trabajador",
          "without_results": "No hemos encontrado trabajadores"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": " <p> ¿Estás seguro de eliminar al trabajador? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará al trabajador.</li> <li>Eliminará las contrataciones asociadas.</li> <li>Eliminará los documentos asociados.</li> </ul> </div> ",
              "title": "Eliminar Trabajador"
            }
          }
        },
        "show": {
          "active_hiring": "Activa",
          "custom_fields": "Otros datos del trabajador",
          "details": "Información del trabajador",
          "inactive_hiring": "Inactiva",
          "show_hiring": "Ver Contratación",
          "without_documents": "No hemos encontrado documentos vinculados",
          "without_hirings": "No hemos encontrado contrataciones"
        },
        "tooltip_info": "Administra todos los trabajadores y sus datos",
        "update": {
          "succesfully": "El trabajador ha sido actualizado correctamente"
        },
        "update_email_modal": {
          "block_documents": "Bloquear Documentos",
          "block_documents_hint": "Los documentos pendientes de firma no podrán editarse ni firmarse.",
          "delete_documents": "Eliminar Documentos",
          "documents_action_label": "¿Qué hacer con los documentos pendientes de firma?",
          "new_email": "Correo Nuevo",
          "new_email_placeholder": "nuevo@correo.com",
          "recreate_documents": "Recrear Documentos",
          "recreate_documents_hint_block": "Se crearán nuevos documentos con el correo actualizado. Los documentos originales quedarán bloqueados.",
          "recreate_documents_hint_remove": "Se crearán nuevos documentos con el correo actualizado. Los documentos originales se marcarán para eliminación.",
          "submit": "Confirmar cambio",
          "title": "Cambiar correo electrónico"
        }
      },
      "end_date": "Hasta",
      "error": "Sin procesar",
      "hiring_configs": null,
      "hiring_documents": {
        "block": {
          "description": "Descripción",
          "succesfully": "El documento ha sido bloqueado correctamente"
        },
        "controldoc_state": {
          "blocked": "Bloqueado",
          "partially_signed": "Firmado parcialmente",
          "pending_shortlist": "Pendiente Shortlist",
          "pending_sign": "Pendiente por firmar",
          "pending_to_fill": "Pendiente por llenar",
          "pending_upload": "Pendiente por subir",
          "processing_sign": "Procesando firma",
          "rejected": "Rechazado",
          "review_uploaded_file": "En revisión de archivo",
          "signature_expired": "Plazo de firma vencido",
          "signed_by_all": "Firmado",
          "uploaded": "Archivo subido"
        },
        "create": {
          "succesfully": "El documento ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El documento ha sido marcado para eliminación"
        },
        "filter": {
          "by_aasm_state": "Estado",
          "by_company": "Empresa",
          "by_document_type": "Tipo de documento",
          "by_employee": "Trabajador",
          "by_openain_category": "Categorización IA",
          "end_date": "Hasta",
          "search_company_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la empresa</li> <li>Identificador de la empresa</li> </ul>",
            "label": "Buscar empresa"
          },
          "search_employee_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del trabajador</li> <li>Email del trabajador</li> <li>Identificador del trabajador</li> </ul>",
            "label": "Buscar trabajador"
          },
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del trabajador</li> <li>Nombre del documento</li> </ul>"
          },
          "start_date": "Desde",
          "with_created_at": "Fecha de creación"
        },
        "form": {
          "allowed_format_file": "Archivos permitidos %{allowed_format_files}",
          "confirm": {
            "message": "¿Estás seguro de guardar el documento?",
            "title": "Guardar Documento"
          },
          "require_signers": {
            "helper": {
              "title": "Al solicitar firmantes, el sistema se integrará con ControlDoc Sign"
            }
          },
          "save": "Guardar"
        },
        "index": {
          "without_results": "No hemos encontrado documentos"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "¿Estás seguro de eliminar el documento?",
              "title": "Eliminar Documento"
            }
          }
        },
        "new": {
          "employee_sign_info": "Deja al trabajador como firmante por defecto del documento",
          "expires_date_help": "Si el documento tiene fecha de vencimiento o caducidad, ingrésala para poder tener en consideración su vigencia y poder reemplazarlo cuando sea necesario",
          "generate_viewer_table_info": "Genera una tabla con la trazabilidad de los visadores en el documento",
          "hide_signature_image_info": "Cuando está activa esta opción evitará que la firma de un visitante aparezca en el documento.",
          "is_viewer_info": "Permite visar o rechazar un documento sin necesidad de firmarlo",
          "member_sign_info": "Permite que una persona pueda firmar un documento sin tener que crearla como miembro",
          "require_fao_info": "Antes de utilizar FAO consulte los precios con nuestra área de ventas, ya que esto tendrá un costo adicional en su factura. Comunícate al correo ventas@controldoc.legal para consultar valores y formas de pago.",
          "require_signature_deadline_info": "Establece una fecha límite para firmar. Luego de esa fecha no es posible firmar el documento.",
          "require_signers_order_info": "Establece un orden en el que los miembros deben firmar un documento",
          "requirement_details": "Detalle del requerimiento",
          "tooltip_doc": "Los archivos '.docx, .doc, .xls, .xlsx' serán convertidos en .pdf"
        },
        "refresh": {
          "succesfully": "El estado de la integracion ha sido actualizado correctamente"
        },
        "retry_controldoc_integration": {
          "succesfully": "Se ha enviado la integración con ControlDoc Sign"
        },
        "reviewed": {
          "successfully": "El documento ha sido revisado satisfactoriamente"
        },
        "show": {
          "controldoc_integration_data": "Datos de integración con ControlDoc Sign",
          "details": "Detalles del documento",
          "details_blocked": "Detalles del documento bloqueado",
          "signers": "Firmantes"
        },
        "signer_state": {
          "blocked": "Bloqueado",
          "pending": "Pendiente de firma",
          "rejected": "Rechazado",
          "sign_skipped": "Firma omitida",
          "signed": "Firmado"
        },
        "signers": {
          "email": "Correo Electrónico",
          "label": "ROL",
          "state": "Estado"
        },
        "tooltip_info": "Visualiza todos los documentos. Crea, carga y envía documentos con o sin solicitudes de firma.",
        "update": {
          "error_block_document": "No es posible bloquear el documento",
          "succesfully": "El documento ha sido actualizado correctamente"
        }
      },
      "hirings": {
        "create": {
          "succesfully": "La contratación ha sido creada correctamente"
        },
        "destroy": {
          "succesfully": "La contratación ha sido eliminada correctamente",
          "with_documents": "No es posible eliminar una contratación con documentos"
        },
        "filter": {
          "by_company": "Empresa",
          "by_custom_field": "Campo personalizado",
          "by_employee": "Trabajador",
          "by_hiring": "Contratación",
          "employee_name": "Nombre",
          "end_date": "Hasta",
          "hiring_state": "Estado",
          "search_by_key_custom_fields": "Campos Personalizados",
          "search_company_query": "Buscar empresa",
          "search_employee_query": "Buscar trabajador",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Identificador de la contratación</li> </ul>"
          },
          "start_date": "Desde",
          "with_end_date": "Fecha fin contrato",
          "with_start_date": "Fecha inicio contrato"
        },
        "hiring_docs": {
          "aasm_state": "Estado:",
          "date": "Fecha:",
          "send_annex": "Enviar anexo de gestión de documentos",
          "signer_blank": "No encontrado",
          "title": "Firma:"
        },
        "identifier_help": "Es un código único y modificable con el que se identificará la contratación en la plataforma, el cual puede ser el RUT o un código interno de tu empresa. Si se deja en blanco ControlDoc creará uno por ti.",
        "index": {
          "tabs": {
            "active": "Activas",
            "all": "Todas",
            "expired": "Inactivas"
          },
          "without_results": "No hemos encontrado contrataciones"
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": " <p> ¿Estás seguro de eliminar la contratación? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará la contratación.</li> <li>Eliminará todos los documentos asociados a la contratación.</li> </ul> </div> ",
              "title": "Eliminar Contratación"
            }
          }
        },
        "show": {
          "abstract_entity_type_id": "Módulo",
          "adp_fields": "Campos de ADP",
          "adp_fields_info": "Todos los campos que estan disponibles via integración con el sistema ADP Expert",
          "company_id": "Empresa",
          "created_at": "Fecha de creación",
          "custom_fields": "Otros datos de la contratación",
          "customer_id": "Cliente",
          "deleted_at": "Eliminado",
          "deleted_by_id": "Eliminado por",
          "details": "Detalles de la contratación",
          "employee_id": "Trabajador",
          "end_date": "Fecha fin",
          "hiring_id": "Contratación",
          "identifier": "Identificador",
          "security_layer_id": "Capa de Seguridad",
          "start_date": "Fecha inicio",
          "sync_data": "Información",
          "without_docs": "No hay documentos vinculados a la contratación",
          "without_documents": "No hemos encontrado documentos"
        },
        "to_expire_info": "La contratación esta proxima a vencer",
        "tooltip_info": "Administra, crea y visualiza todos los detalles de los contratos creados con los trabajadores ordenados por vigencia",
        "update": {
          "succesfully": "La contratación ha sido actualizada correctamente"
        }
      },
      "laboral/check_list/hiring_processes": {
        "pin": {
          "tooltip_info": "¿Deseas anclar este checklist al menú lateral?"
        },
        "unpin": {
          "tooltip_info": "¿Deseas desanclar este checklist del menú lateral?"
        }
      },
      "no_entry": "No ingresó valor",
      "processing_entry": "Procesando dato",
      "search_query": {
        "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de trabajador</li> <li>Email del trabajador</li> <li>Identificador del contrato</li> </ul>"
      },
      "start_date": "Desde",
      "tabs": {
        "completed": "Procesados",
        "failed": "Con Errores",
        "pending": "Pendientes"
      },
      "with_end_date": "Fecha fin",
      "with_start_date": "Fecha inicio",
      "without_results": "No hemos encontrado resultados"
    },
    "landings": {
      "about_us": {
        "call_to_action": {
          "action_link": "Comienza Ahora",
          "title": "Gestiona y firma en línea documentos laborales de forma rápida y simple"
        },
        "title": "¿Por qué elegir ControlDoc?",
        "what_is_description_html": "ControlDoc es un Software de <strong>Gestión Documental con Firma Electrónica</strong> que apoya a las empresas y mejora el flujo de trabajo de colaboradores, contratistas, clientes y proveedores."
      },
      "canal_denuncias": {
        "call_to_action": {
          "title": "Cotiza Canal de Denuncias"
        },
        "subtitle": "Organiza carpetas de casos, aplica flujos de investigación y mantén la trazabilidad de todo el proceso.",
        "title_html": "De la denuncia al proceso: gestión investigativa con trazabilidad y control."
      },
      "corporate_info": {
        "functionalities": {
          "functionality_1": {
            "cta_btn": "Quiero saber más",
            "detail_html": "ControlDoc permite la creación modular de documentos, adaptándose a su fuente y al lenguaje específico de cada negocio.",
            "link_title": "Repositorio Digital",
            "title": "Repositorio Digital"
          },
          "functionality_2": {
            "cta_btn": "Habla con ventas",
            "detail_html": "Solicita documentos a tus proveedores,  contratistas y colaboradores de forma individual o masiva. Descarga los documentos que quieras para poder cumplir con tus procesos de auditorías, licitaciones, certificaciones, etc.",
            "link_title": "Envía, recibe y descarga todos los documentos",
            "title": "Envía, recibe y descarga todos los documentos que necesitas para agilizar tu negocio"
          },
          "functionality_3": {
            "cta_btn": "Agenda reunión",
            "detail_html": "Identifica rápidamente los documentos listos y solicita la documentación pendiente para cumplir con tus relaciones contractuales entre empresa y proveedores.",
            "link_title": "Visualiza y controla el estado documental",
            "title": "Check List: Visualiza y controla el estado documental de tus procesos"
          },
          "functionality_4": {
            "cta_btn": "Habla con ventas",
            "detail_html": "Firma de manera transversal los documentos y contratos de tu empresa. ControlDoc cuenta con la aprobación de la Dirección del Trabajo y el Ministerio de Economía.",
            "link_title": "Controla el ciclo de vida de los documentos",
            "title": "Controla el ciclo de vida de los documentos y contratos"
          },
          "functionality_5": {
            "cta_btn": "Hablar con ventas",
            "detail_html": "Firma de manera transversal los documentos y contratos de tu empresa. ControlDoc cuenta con la aprobación de la Dirección del Trabajo y el Ministerio de Economía",
            "link_title": "Firma Electrónica",
            "title": "Respalda tus documentos, acuerdos y contratos con Firma Electrónica"
          },
          "functionality_6": {
            "cta_btn": "Agenda reunión",
            "detail_html": "Si utilizas un software CRM, ERP o plataformas internas, integrate con ControlDoc y controla los documentos en un solo lugar.",
            "link_title": "Si usas distintas plataformas, no es un problema",
            "title": "Tener los documentos es distintas plataformas, no es un problema"
          }
        }
      },
      "info": {
        "benefit_1": {
          "detail_html": "Almacena de forma <strong>segura y en línea</strong> toda la documentación de tu empresa, manejando múltiples razones sociales para administrar de manera diferenciada la documentación. Olvídate de multas y atrasos de cobranza, nos encargamos de tener <strong>toda tu documentación al día</strong>.",
          "title": "Bóveda digital de documentos"
        },
        "benefit_2": {
          "detail_html": "<strong>Firma todo tipo de documentos</strong> con nuestra <strong>Firma Simple o Avanzada</strong>. Verifica la autenticidad de los documentos mediante su código QR, accediendo a todo el historial y trazabilidad de sus firmas con fechas, hora e IP.",
          "title": "Firma electrónica simple y avanzada"
        },
        "benefit_3": {
          "detail_html": "Almacena, gestiona y firma <strong>toda la documentación laboral de tu empresa</strong> con nuestro módulo laboral respaldado por la Dirección del Trabajo.",
          "title": "Gestiona y Firma documentos de tus colaboradores"
        },
        "benefit_4": {
          "detail_html": "Podrás <strong>almacenar, buscar y filtrar</strong> fácilmente a todos tus colaboradores para acceder a toda la información de cada uno en sus <strong>carpetas digitales</strong>.",
          "title": "Carpeta del colaborador"
        },
        "benefit_5": {
          "detail_html": "Vista simplificada de todas las contrataciones con <strong>indicadores de estado tipo semáforo</strong> para que puedas <strong>identificar facilmente</strong> la documentación lista o pendiente.",
          "title": "Panel de Contrataciones"
        },
        "benefit_6": {
          "detail_html": "Olvídate de reescribir cada documento y sus modificaciones. <strong>Diseña plantillas de todo tipo de documentos</strong>. Define su estructura, contenido y variables que deseas autocompletar o dejar abiertas para que estas sean completadas por el usuario.",
          "title": "Creación de plantillas"
        },
        "benefit_7": {
          "detail_html": "Crea plantillas con campos abiertos y envía a multiples receptores con el fin de que completen los campos y/o firmen el documento.",
          "title": "ControlDoc Forms"
        },
        "benefit_8": {
          "detail_html": "Sube todos los documentos que quieras en formato <strong>PDF, DOC o DOCX</strong> de forma individual y masiva. Además, determina quiénes y cuántas personas deben firmar.",
          "title": "Carga, envío y firma masiva"
        },
        "call_to_action_1": {
          "action_link": "Comienza Ahora",
          "title": "Gestiona y firma en línea documentos laborales de forma rápida y simple"
        },
        "call_to_action_2": {
          "action_link": "Usa ControlDoc",
          "title": "Implementa controldoc de manera inmediata en tu empresa."
        },
        "call_to_action_api_1": {
          "action_link": "¡Quiero saber más!",
          "title_html": "<small class='font-weight-bold'>¿Ya tienes un Gestor de Nómina?</small><br/> ControlDoc se integra con tu ERP favorito."
        },
        "call_to_action_api_2": {
          "action_link": "Asesórate con Ventas",
          "title_html": "<strong>Principales integraciones:</strong><br/>Conecta con ControlDoc y centraliza tu gestión."
        },
        "call_to_action_banner": {
          "action_link": "Realiza tu gestión aquí",
          "subtitle": "Gestiona los anexos y contratos de trabajadores de forma online",
          "title": "¡En tiempos de Covid-19 utiliza Firma Electrónica!"
        },
        "clients": "Ya confían en nosotros",
        "contact_direct": "Escríbenos",
        "contact_us": "Contacto Comercial",
        "doc_title": "Gestión documental para cumplimiento con firma electrónica.",
        "docs_section": {
          "description_html": "Cierra acuerdos con tus clientes internos y externos, proveedores y colaboradores, <strong>ahorrando tiempo, dinero y recursos</strong>.",
          "title_html": "Gestiona y firma de manera digital <strong>documentos de todo tipo</strong>."
        },
        "how_does_it_work_html": "<span class='gradient-text-4t'>Te respaldamos</span><span class='d-block'> con nuestra tecnología, para que tengas todo el </span><span class='gradient-text-4t'>control documental de tu empresa</span>",
        "important_area": {
          "item_1": {
            "description": "Solicita documentos de manera masiva y rápida para firma electrónica aprobada por la DT y el Ministerio de Economía.",
            "title_html": "<strong>Firma electrónica</strong> Simple y Avanzada"
          },
          "item_2": {
            "description": "Gestiona, almacena y mantén trazabilidad de todo tipo de documentos y contratos en la nube.",
            "title_html": "Repositorio <strong>inteligente</strong> de documentos"
          },
          "item_3": {
            "description": "Controla y firma Documentos masivamente: Prevención de Riesgos, RRHH, Capacitaciones, Outsourcing, etc.",
            "title_html": "<strong>Gestión</strong> documental laboral"
          },
          "item_4": {
            "description": "Implementa Canales de Denuncias para un cumplimiento proactivo de Ley Karin y Ley de Delitos Económicos.",
            "title_html": "<strong>Canales de denuncias</strong>"
          },
          "item_5": {
            "description": "Gestiona compromisos y actividades para asegurar el cumplimiento con monitoreo y trazabilidad en tiempo real.",
            "title_html": "<strong>Cumplimiento Normativo</strong>"
          },
          "title": "¿Cómo quieres utilizar ControlDoc?"
        },
        "integrations": "ControlDoc ya se integra con:",
        "integrations_approved": "Aprobado por",
        "integrations_caps": "Evaluaciones",
        "integrations_erp": "ERP",
        "integrations_sign": "Firma Avanzada",
        "meta_description": "Aumenta la productividad y optimiza la gestión de documentos, tareas y procesos con trazabilidad y cumplimiento normativo inteligente en una sola plataforma.",
        "meta_title": "Gestión documental para cumplimiento con firma electrónica.",
        "our_solutions": {
          "miterna": "Software de Reclutamiento",
          "somosempleos": "Portal Laboral Inclusivo",
          "title": "Conoce otras de nuestras soluciones"
        },
        "request_price": "Solicita Cotización",
        "sign_your_documents": "Firma tus documentos",
        "start_now": "¡Envíame una cotización!",
        "step_1": {
          "description_html": "Crea el trabajador. <b>Podrás buscar y filtrar fácilmente a todos tus trabajadores</b> para acceder a toda su información.",
          "title": "Registro de trabajadores"
        },
        "step_2": {
          "description_html": "<b>Registra una o más contrataciones por trabajador</b> y <b>carga los documentos</b> requeridos de acuerdo a tu proceso.",
          "title": "Registro de contrataciones"
        },
        "step_3": {
          "description_html": "Podrás visualizar qué <b>contrataciones</b> tienen toda su <b>documentación al día</b> y cuáles tienen <b>documentación pendiente</b>.",
          "title": "Panel de Contrataciones"
        },
        "step_dirtrab": {
          "description_html": "Aprobado por la Dirección del Trabajo con <b>ORD Nº 4997</b>, de fecha 21 de octubre de 2019."
        },
        "step_signature": {
          "description_html": "Selecciona cuáles documentos requieren <b>firma electrónica</b> y serán notificados a los involucrados."
        },
        "subtitle": "Software rápido, masivo, trazable e integrable.",
        "title_html": "Gestión Documental para cumplimiento normativo con Firma Electrónica",
        "video_section": {
          "description_html": "Descubre como facilitamos que empresas y personas <strong>completen, envíen y firmen documentos</strong> con total seguridad.",
          "title_html": "Un <strong>gestor documental con Firma Electrónica</strong> seguro y para <strong>todas las empresas</strong>."
        },
        "what_is_description_html": "ControlDoc es un Software de <strong>Gestión Documental con Firma Electrónica</strong> que apoya a las empresas y mejora el flujo de trabajo de colaboradores, contratistas, clientes y proveedores.",
        "what_is_it": "¿Qué es?"
      },
      "laboral": {
        "start_now": "¡Envíame una cotización!",
        "subtitle": "Aumenta la productividad de tu empresa y evoluciona la forma de cerrar acuerdos",
        "title": "Software #1 en Gestión de Documentos Laborales con Firma Electrónica"
      },
      "laboral_info": {
        "functionalities": {
          "functionality_1": {
            "cta_btn": "Agenda Reunión",
            "detail_html": "Crea, carga y envía documentos y contratos con solicitud de firma a todos los trabajadores de forma masiva o individual. Crea documentos en base a plantillas con campos abiertos y personalizados",
            "link_title": "Carpetas Digitales de Colaboradores",
            "title": "Carpetas Digitales de Colaboradores"
          },
          "functionality_2": {
            "cta_btn": "Habla con Ventas",
            "detail_html": "Configura la caducidad de los documentos o contratos de los colaboradores. Controla su vigencia y mantén todos los documentos al día.",
            "link_title": "Ciclo de vida de los documentos",
            "title": "Controla el ciclo de vida de los documentos y contratos"
          },
          "functionality_3": {
            "cta_btn": "Agenda reunión",
            "detail_html": "Revisa y controla documentos asociados a procesos de auditorías y compliance. Identifica rápidamente los documentos listos y solicita la documentación pendiente para cumplir con tus procesos internos o externos.",
            "link_title": "Trazabilidad y Control Documental",
            "title": "Trazabilidad y Control Documental"
          },
          "functionality_4": {
            "cta_btn": "Habla con Ventas",
            "detail_html": "Firma rápidamente tus acuerdos con tus colaboradores y solicita su firma de manera masiva. Cuenta con el respaldo legal de la dirección del trabajo así como el del ministerio de economía.",
            "link_title": "Firma electrónica",
            "title": "Respalda todos los documentos y contratos laborales con firma electrónica"
          },
          "functionality_5": {
            "cta_btn": "Agenda reunión",
            "detail_html": "Recopilamos la información de nuevos contratos de trabajadores y los subimos directamente al portal MiDT. Visualiza el estado de la documentación enviada, así como el registro histórico de esta",
            "link_title": "Regulariza contratos con la DT",
            "title": "Cumple y regulariza contratos con la Dirección del Trabajo gracias a ControlBot"
          },
          "step_dirtrab": {
            "description_html": "Aprobado por la Dirección del Trabajo con <b>ORD Nº 4997</b>, de fecha 21 de octubre de 2019."
          }
        }
      },
      "promo_forms": {
        "thanks": {
          "back_to": "Volver al Sitio",
          "message": "¡Gracias! Ya hemos recibido tu mensaje, pronto nos pondremos en contacto contigo."
        }
      },
      "sales_info": {
        "benefits": {
          "benefit_1": {
            "cta_btn": "Quiero saber más",
            "detail_html": "ControlDoc permite la creación modular de documentos, adaptándose a su fuente y al lenguaje específico de cada negocio.",
            "link_title": "Repositorio Digital",
            "title": "Repositorio Digital"
          },
          "benefit_2": {
            "cta_btn": "Solicita una demo",
            "detail_html": "Diseña plantillas y documentos personalizados con campos abiertos. Solicita a tus trabajadores, contratistas o proveedores la documentación necesaria para la gestión de tu empresa. Usa el respaldo de la firma electrónica.",
            "link_title": "Plantillas y Formularios",
            "title": "Creación de Plantillas y Formularios"
          },
          "benefit_3": {
            "cta_btn": "Agenda una reunión",
            "detail_html": "La tecnología de ControlDoc permite la <strong>indexación, búsqueda y acceso seguro</strong> a los documentos relevantes para procesos de auditorías o compliance. Cumple con las leyes y regulaciones y monitorea en línea el programa de cumplimiento de tu empresa.",
            "link_title": "Cumplimiento Normativo",
            "title": "Check List: Auditorías y Compliance en un software de gestión documental"
          },
          "benefit_4": {
            "cta_btn": "Habla con Ventas",
            "detail_html": "Firma de manera transversal los documentos y contratos de tu empresa. ControlDoc cuenta con la aprobación de la Dirección del Trabajo y el Ministerio de Economía.",
            "link_title": "Firma Electrónica",
            "title": "Respalda tus documentos, acuerdos y contratos con Firma Electrónica"
          },
          "benefit_5": {
            "cta_btn": "Cotiza Aquí",
            "detail_html": "<strong>Define permisos</strong> y controla los accesos de los usuarios dentro de los documentos, etapas de workflow y/o etapas de canales de denuncias, garantizando la seguridad de la información y tus procesos internos y externos.",
            "link_title": "Seguridad y Accesos",
            "title": "Seguridad y Accesos personalizados"
          },
          "benefit_6": {
            "cta_btn": "Agenda una reunión",
            "detail_html": "Olvídate de reescribir cada documento y sus modificaciones. Diseña <strong>plantillas de todo tipo de documentos</strong>. Define su estructura, contenido y variables que deseas autocompletar o dejar abiertas para completar por el usuario.",
            "link_title": "Creación de plantillas",
            "title": "Creación de plantillas"
          },
          "benefit_7": {
            "cta_btn": "Agenda una reunión",
            "detail_html": "Crea plantillas con campos abiertos y envía a multiples receptores con el fin de que completen los campos y/o firmen el documento.",
            "link_title": "ControlDoc Forms",
            "title": "ControlDoc Forms"
          },
          "benefit_8": {
            "cta_btn": "Agenda una reunión",
            "detail_html": "Sube todos los documentos que quieras en formato <strong>PDF, DOC o DOCX</strong> de forma individual y masiva. Además, determina quiénes y cuántas personas deben firmar. Todos serán notificados vía correo electrónico.",
            "link_title": "Carga, envío y firma masiva",
            "title": "Carga, envío y firma masiva"
          },
          "benefit_9": {
            "detail_html": "Optimiza tu proceso de documentación mediante el diseño de gráficos de flujo con <strong>etapas adaptables</strong>, <strong>tareas, tiempos de cumplimiento y responsables</strong>. Conecta a las áreas responsables y proporciona trazabilidad y transparencia a tus procesos.",
            "link_title": "Workflow",
            "title": "Workflows flexibles"
          }
        },
        "sign": {
          "fea": {
            "description_html": "La <strong>firma electrónica avanzada o FEA</strong> es un conjunto de datos que se integran a un mensaje electrónico cuyo propósito es identificar al autor del mensaje como autor legítimo, vale decir una firma autógrafa.",
            "title": "Firma Electrónica Avanzada (FEA)",
            "type_1": {
              "description_html": "Recomendada para gerentes o personas internas de la empresa que firmen una gran cantidad de documentos oficiales (notariales, para bancos, etc)",
              "title_html": "FEA Enrolada <br/>(asociada a un certificado de un año)"
            },
            "type_2": {
              "description_html": "Recomendada para ofrecer al cliente o proveedor externo al gestionar documentación compartida con ellos, como un contrato.",
              "title_html": "FEA de un sólo uso <br/>(asociada a un certificado de 1 sólo uso)"
            }
          },
          "fes": {
            "description_html": "La <strong>firma electrónica simple o FES</strong> es un conjunto de datos electrónicos que acompañan a una determinada información en formato electrónico. De este modo, quien recibe los documentos puede estar seguro del origen de ellos verificando la información del usuario, a través del registro de fecha y hora de la firma propuesta.",
            "title": "Firma Electrónica Simple (FES)",
            "type_1": {
              "description_html": "Recomendada para documentación interna de la empresa. Recomendada para firmar documentos de Recursos Humanos.",
              "title_html": "FES con factor de doble autenticación."
            },
            "type_2": {
              "description_html": "Recomendadas para procesos internos que requieran mayor seguridad o verificación.",
              "title_html": "FES reforzada con desafío de preguntas <br/>(conecta con el registro civil para agregar preguntas que sólo el firmante podría responder y firmar con clave única)"
            }
          }
        }
      },
      "signer_info": {
        "navbar": {
          "help": "Ayuda",
          "help_center": "Centro de Ayuda",
          "hi": "Hola %{name}",
          "tutorial": "Tutorial"
        }
      },
      "welcome": {
        "carousel": {
          "item_1": {
            "description": "Digitaliza y gestiona tus procesos en línea con el respaldo de ControlDoc.",
            "title": "Una solución adaptada a las diferentes áreas de negocio"
          },
          "item_2": {
            "description": "Respalda la disponibilidad y seguridad de tu información para Cumplimiento Normativo.",
            "title": "Control Documental, Firma Electrónica y Trazabilidad"
          },
          "item_3": {
            "description": "Define flujos para la recopilación de denuncias, evidencias y monitorea en línea.",
            "title": "Tecnología para la Gestión de Canales de Denuncias"
          }
        },
        "client_description": "Elimina el papeleo, organiza tus procesos y cierra tus acuerdos de forma más eficiente y en línea",
        "client_title": "Conoce el gestor documental para cumplimiento con firma electrónica",
        "sign_your_documents": "Firmar mis documentos",
        "signer_description": "Firma de documentos laborales, primer ingreso, información de ayuda y tutoriales",
        "signer_title": "Firmar y gestionar mis documentos",
        "start_now": "Conocer ControlDoc",
        "subtitle": "¿Qué quieres hacer?",
        "title": "Bienvenid@ a ControlDoc"
      }
    },
    "mailers": {
      "user_mailer": {
        "send_otp_code": {
          "disable_two_factor": {
            "copy_two_factor_instructions_html": "Debes copiar el siguiente código y pegarlo en la caja de texto para deshabilitar la verificación en dos pasos.",
            "set_up_your_account_html": "Hemos generado un PIN de verificación en dos pasos para deshabilitar tu cuenta en ControldDoc"
          },
          "enable_two_factor": {
            "copy_two_factor_instructions_html": "Debes copiar el siguiente código y pegarlo en la caja de texto para habilitar la verificación en dos pasos.",
            "set_up_your_account_html": "Hemos generado un PIN de verificación en dos pasos para habilitar tu cuenta en ControldDoc"
          }
        }
      }
    },
    "memberships": {
      "create": {
        "succesfully": "El miembro ha sido creado correctamente"
      },
      "destroy": {
        "succesfully": "El miembro ha sido eliminado correctamente"
      },
      "filter": {
        "by_company": "Empresa",
        "end_date": "Hasta",
        "search_query": {
          "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del miembro</li> </ul>"
        },
        "start_date": "Desde",
        "with_created_at": "Fecha inicio",
        "with_group_by": "Rol"
      },
      "index": {
        "on_limit": "Llegaste al límite de miembros, de ahora en adelante se cobrará extra por cada miembro nuevo agregado",
        "without_results": "No hemos encontrado miembros"
      },
      "messages": {
        "destroy": {
          "confirm": {
            "message": "¿Estás seguro de eliminar el miembro?",
            "title": "Eliminar miembro"
          }
        }
      },
      "show": {
        "details": "Detalles del miembro"
      },
      "tooltip_info": "Crea y administra los usuarios de tu equipo para la gestión de documentos",
      "update": {
        "succesfully": "El miembro ha sido actualizado correctamente"
      }
    },
    "messages": {
      "without_results": "No hemos encontrado registros",
      "without_results_custom": "No hemos encontrado %{resource}",
      "without_results_info": "En este momento tu cuenta asociada a la empresa %{current_customer} no tiene %{resource}"
    },
    "new": "Nuevo",
    "no_apply": "No aplica",
    "no_available": "No disponible",
    "no_data": "Sin Información",
    "no_entry": "No Ingresó",
    "no_file": "Sin archivo",
    "nope": "No",
    "nps": {
      "records": {
        "scales": {
          "emotions (1 - 10)": {
            "acceptable": "Aceptable",
            "bad": "Malo",
            "disappointed": "Decepcionado",
            "good": "Bueno",
            "i_dont_like": "No me gusta",
            "i_like": "Me gusta",
            "i_love": "Me encanta",
            "it_disgusts_me": "Me enoja",
            "neutral": "Neutral",
            "one": "Emociones (1 - 10)",
            "regular": "Regular"
          }
        }
      },
      "results": {
        "respond": {
          "succesfully": "Muchas gracias por tu respuesta."
        }
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ".",
          "format": "%n %u",
          "precision": 2,
          "separator": ",",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "€"
        }
      },
      "format": {
        "delimiter": ".",
        "precision": 3,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "mil millones",
            "million": {
              "one": "millón",
              "other": "millones"
            },
            "quadrillion": "mil billones",
            "thousand": "mil",
            "trillion": {
              "one": "billón",
              "other": "billones"
            },
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 1,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n %"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "numbers": {
      "billions": "mil millones",
      "billionths": {
        "one": "milmillonésima",
        "other": "milmillonésimas"
      },
      "decillions": "mil quintillones",
      "decillionths": {
        "one": "milquintillonésima",
        "other": "milquintillonésimas"
      },
      "duodecillions": "mil sextillones",
      "duodecillionths": {
        "one": "milsextillonésima",
        "other": "milsextillonésimas"
      },
      "hundreds": {
        "apocopated": "cien",
        "female": [
          "_",
          "ciento",
          "doscientas",
          "trescientas",
          "cuatrocientas",
          "quinientas",
          "seiscientas",
          "setecientas",
          "ochocientas",
          "novecientas"
        ],
        "male": [
          "_",
          "ciento",
          "doscientos",
          "trescientos",
          "cuatrocientos",
          "quinientos",
          "seiscientos",
          "setecientos",
          "ochocientos",
          "novecientos"
        ]
      },
      "hundredths": {
        "one": "centésima",
        "other": "centésimas"
      },
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillions",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions",
        "undecillions",
        "duodecillions",
        "tredecillions",
        "quattuordecillions"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths",
        "quadrillionths",
        "quintillionths",
        "sextillionths",
        "septillionths",
        "octillionths",
        "nonillionths",
        "decillionths",
        "undecillionths",
        "duodecillionths",
        "tredecillionths",
        "quattuordecillionths"
      ],
      "micro_prefix": {
        "hundreds": "cien",
        "tens": "diez",
        "union": ""
      },
      "micro_separator": "con",
      "millions": {
        "one": "millón",
        "other": "millones"
      },
      "millionths": {
        "one": "millonésima",
        "other": "millonésimas"
      },
      "nonillions": {
        "one": "quintillón",
        "other": "quintillones"
      },
      "nonillionths": {
        "one": "quintillonésima",
        "other": "quintillonésimas"
      },
      "octillions": "mil cuatrillones",
      "octillionths": {
        "one": "milcuatrillonésima",
        "other": "milcuatrillonésimas"
      },
      "ones": {
        "apocopated": "un",
        "female": [
          "cero",
          "una",
          "dos",
          "tres",
          "cuatro",
          "cinco",
          "seis",
          "siete",
          "ocho",
          "nueve"
        ],
        "male": [
          "cero",
          "uno",
          "dos",
          "tres",
          "cuatro",
          "cinco",
          "seis",
          "siete",
          "ocho",
          "nueve"
        ]
      },
      "quadrillions": "mil billones",
      "quadrillionths": {
        "one": "milbillonésima",
        "other": "milbillonésimas"
      },
      "quattuordecillions": "mil septillones",
      "quattuordecillionths": {
        "one": "milseptillonésima",
        "other": "milseptillonésimas"
      },
      "quintillions": {
        "one": "trillón",
        "other": "trillones"
      },
      "quintillionths": {
        "one": "trillonésima",
        "other": "trillonésimas"
      },
      "septillions": {
        "one": "cuatrillón",
        "other": "cuatrillones"
      },
      "septillionths": {
        "one": "cuatrillonésima",
        "other": "cuatrillonésimas"
      },
      "sextillions": "mil trillones",
      "sextillionths": {
        "one": "miltrillonésima",
        "other": "miltrillonésimas"
      },
      "teens": [
        "_",
        "once",
        "doce",
        "trece",
        "catorce",
        "quince",
        "dieciséis",
        "diecisiete",
        "dieciocho",
        "diecinueve"
      ],
      "tens": [
        "_",
        "diez",
        "veinte",
        "treinta",
        "cuarenta",
        "cincuenta",
        "sesenta",
        "setenta",
        "ochenta",
        "noventa"
      ],
      "tenths": {
        "one": "décima",
        "other": "décimas"
      },
      "thousands": "mil",
      "thousandths": {
        "one": "milésima",
        "other": "milésimas"
      },
      "tredecillions": {
        "one": "septillón",
        "other": "septillones"
      },
      "tredecillionths": {
        "one": "septillonésima",
        "other": "septillonésimas"
      },
      "trillions": {
        "one": "billón",
        "other": "billones"
      },
      "trillionths": {
        "one": "billonésima",
        "other": "billonésimas"
      },
      "twenties": {
        "apocopated": "veintiún",
        "female": [
          "_",
          "veintiuna",
          "veintidós",
          "veintitrés",
          "veinticuatro",
          "veinticinco",
          "veintiséis",
          "veintisiete",
          "veintiocho",
          "veintinueve"
        ],
        "male": [
          "_",
          "veintiuno",
          "veintidós",
          "veintitrés",
          "veinticuatro",
          "veinticinco",
          "veintiséis",
          "veintisiete",
          "veintiocho",
          "veintinueve"
        ]
      },
      "undecillions": {
        "one": "sextillón",
        "other": "sextillones"
      },
      "undecillionths": {
        "one": "sextillonésima",
        "other": "sextillonésimas"
      },
      "union": "y"
    },
    "oauth": {
      "authorize": {
        "access_denied": "El usuario denegó el acceso",
        "access_scope": "Alcance",
        "application": "Aplicación",
        "approve": "Autorizar",
        "consent_subtitle_html": "%{client_name} solicita acceder a ControlDoc con la cuenta %{email}.",
        "consent_title": "¿Autorizar acceso?",
        "customer": "Cliente",
        "deny": "Cancelar",
        "email": "Correo electrónico",
        "error_title": "No se pudo autorizar",
        "invalid_client": "Cliente OAuth inválido o inactivo",
        "invalid_credentials": "Credenciales inválidas",
        "invalid_redirect_uri": "redirect_uri no permitido para este cliente",
        "invalid_request": "Solicitud OAuth inválida",
        "invalid_target": "El parámetro resource no es válido o no está permitido para este servidor",
        "invitation_pending": "Debes aceptar la invitación de Controldoc antes de autorizar esta aplicación",
        "login_subtitle": "Para autorizar \"%{client_name}\" con tu cuenta ControlDoc",
        "login_title": "Inicia sesión",
        "no_membership": "Tu usuario no pertenece al cliente asociado a esta aplicación OAuth",
        "no_platform_memberships": "Tu usuario no tiene cuentas activas en Controldoc",
        "password": "Contraseña",
        "pkce_incomplete": "Debes enviar code_challenge y code_challenge_method juntos",
        "pkce_method_unsupported": "Solo se soporta code_challenge_method=S256",
        "pkce_required": "code_challenge es obligatorio para este cliente OAuth (PKCE)",
        "platform_access_scope": "Todas las cuentas Controldoc a las que perteneces",
        "scopes": "Permisos",
        "sign_in": "Continuar",
        "sign_in_required": "Debes iniciar sesión para continuar",
        "state_required": "El parámetro state es obligatorio",
        "unsupported_response_type": "Solo se soporta response_type=code"
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Página",
          "other": "Páginas"
        },
        "next": "Siguiente",
        "previous": "Anterior"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Mostrando %{item_name} %{from}-%{to} de %{count} en total",
        "no_count": "Página %{page} de %{pages}",
        "no_items": "No se encontraron %{item_name}",
        "single_page": "Mostrando %{count} %{item_name}"
      },
      "input_nav_js": "Página %{page_input} de %{pages}",
      "item_name": {
        "one": "elemento",
        "other": "elementos"
      },
      "limit_tag_js": "Mostrar %{limit_input} %{item_name} por página",
      "next": "Siguiente&nbsp;&rsaquo;",
      "p11n": "OneOther",
      "previous": "&lsaquo;&nbsp;Anterior"
    },
    "percent": "Porcentaje",
    "portal": {
      "configurations": {
        "default_welcome_text": "Bienvenid@! Gestiona y firma tus documentos en línea con ControlDoc.",
        "form": {
          "confirm": {
            "message": "¿Estás seguro de actualizar la configuración del portal?",
            "title": "Actualizar configuración del portal"
          },
          "enable_options": "Opciones visibles en el portal:",
          "preview_info": "Este es el preview de tu portal Empresa ControlDoc",
          "tooltip_info": "Las configuraciones de tu portal Empresa serán aplicadas de igual forma en los links públicos de los Workflows y Canales de Denuncias."
        },
        "help": {
          "custom_fields": "Estas configuraciones sólo se aplican en el Portal Empresa",
          "custom_welcome_text": "Deja en blanco si no quieres tener un texto de Bienvenida",
          "enable_compliance": "Habilitar para que el trabajador pueda completar y revisar tareas de cumplimiento",
          "enable_documents": "Habilita para que el trabajador revise sus documentos",
          "enable_gradient_bg": "Recomendado para mejorar contraste con el texto. Desmarca para quitar el efecto oscuro de la imagen del portal en pantallas desktop, en mobile se agrega para legibilidad",
          "enable_sign_documents": "Habilita para que el trabajador pueda gestionar los documentos pendientes por firmar",
          "enable_workflow_requirements": "Habilita para que el trabajador pueda revisar y crear nuevos requerimientos",
          "format_background": "Formato PNG JPEG. Dimensiones mínimas 1280×720 píxeles.",
          "format_logo": "Formato PNG transparente. Dimensiones mínimas 200x96 píxeles. Evite logos con degradés de color.",
          "open_portal_link": "Abrir link de portal empresa en nueva tab"
        },
        "update": {
          "successfully": "La configuración del portal ha sido actualizada correctamente"
        }
      },
      "custom_pins": {
        "edit": {
          "confirm_new_pin": "Confirma tu nuevo PIN personalizado",
          "invalid_token": "El enlace de recuperación es inválido o ha expirado",
          "new_pin": "Ingresa tu nuevo PIN personalizado",
          "title": "Restablecer PIN personalizado"
        },
        "reset": {
          "label": "Restablecer PIN personalizado",
          "send_instructions": "Recibirás un correo con instrucciones para restablecer tu PIN personalizado en unos pocos minutos."
        },
        "update": {
          "invalid": "No se ha podido actualizar el PIN",
          "successfully": "El PIN se ha actualizado exitosamente!"
        }
      },
      "dashboards": {
        "index": {
          "checklist_shared_processes": "Solicitud de Revisión",
          "compliance": {
            "description": "Subir y revisar evidencias en tareas pendientes",
            "one": "Cumplimiento"
          },
          "documents": {
            "description": "Revisa todos tus documentos",
            "one": "Mis Documentos"
          },
          "economic_crime": {
            "workflow": {
              "requirements": {
                "description": "Crea, revisa y gestiona tus denuncias",
                "one": "Gestiona tus denuncias de Delitos Económicos"
              }
            }
          },
          "karin_law": {
            "workflow": {
              "requirements": {
                "description": "Crea, revisa y gestiona tus denuncias",
                "one": "Gestiona tus denuncias de Ley Karin"
              }
            }
          },
          "options": "Opciones",
          "pending_shortlist": {
            "description": "Revisa y completa tus evaluaciones",
            "one": "Realiza tus evaluaciones"
          },
          "pending_to_fill": {
            "description": "Revisa y completa tus documentos",
            "one": "Completa tus documentos"
          },
          "pending_upload": {
            "description": "Revisa y sube tus documentos",
            "one": "Sube tus documentos"
          },
          "portal": "Portal Empresa",
          "sign_documents": {
            "description": "Todos tus documentos pendientes por firmar",
            "one": "Firmar Documentos"
          },
          "versioner": {
            "document": {
              "items": {
                "create": {
                  "successfully": "Versión creada correctamente"
                },
                "description": "Crea, revisa y gestiona tus documentos",
                "one": "Versiona tus documentos"
              },
              "threads": {
                "description": "Crea, revisa y gestiona tus documentos",
                "one": "Versiona tus documentos"
              }
            },
            "one": "Versionador"
          },
          "workflow_processes": {
            "description": "Crear un nuevo requerimiento",
            "one": "Crea un nuevo requerimiento"
          },
          "workflow_requirements": {
            "description": "Revisa y gestiona tus requerimientos",
            "one": "Gestiona tus requerimientos"
          }
        }
      },
      "document_compressions": {
        "create": {
          "error": "Error al iniciar la compresión de documentos - comunicate con el equipo de soporte técnico a hola@controldoc.cl",
          "success": "Se ha iniciado la compresión de documentos exitosamente, se le comunicará por correo electrónico cuando esté listo para su descarga"
        },
        "show": {
          "error": "Error al descargar los documentos comprimidos - comunicate con el equipo de soporte técnico a hola@controldoc.cl"
        }
      },
      "documents": {
        "filter": {
          "by_aasm_state": "Estado del documento",
          "by_document_type": "Tipo de documento",
          "end_date": "Fecha fin",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del documento</li> <li>correo del firmante</li> </ul>"
          },
          "sorted_by": "Ordenar por",
          "start_date": "Fecha inicio"
        },
        "index": {
          "without_results": "No hemos encontrado registros"
        },
        "save_upload": {
          "successfully": "Documento cargado con éxito"
        },
        "upload": {
          "confirm": {
            "message": "¿Estás seguro de subir el documento?",
            "title": "Subir documento"
          }
        }
      },
      "employee_email_change_mailer": {
        "confirmation_token": {
          "subject": "Código para confirmar tu nuevo correo"
        }
      },
      "employee_email_change_modal": {
        "confirmation_token": "Código de confirmación",
        "description_html": "Hemos identificado que tu cuenta tiene un correo corporativo (%{domains}). Para mantener acceso a tus documentos y por normativa, necesitamos que uses un <strong>correo personal</strong>.",
        "footer_hint": "Esta acción es necesaria para continuar usando ControlDoc",
        "new_email": "Correo electrónico personal",
        "resend_token": "Reenviar código",
        "save": "Actualizar correo",
        "send_token": "Enviar token",
        "title": "Actualiza tu Correo"
      },
      "employee_email_changes": {
        "confirm": {
          "message": "<p>Se actualizarán los documentos pendientes de firma asociados a %{old_email} para que queden con %{new_email}.</p> <p>Tras confirmar verás el avance del procesamiento. Al terminar actualizaremos tu sesión con tu nuevo correo electrónico.</p> <p>¿Deseas continuar?</p>",
          "processing": "Tu solicitud fue registrada. Estamos procesando el cambio de correo.",
          "title": "Confirmar actualización de correo"
        },
        "errors": {
          "change_in_progress": "Ya existe un cambio de correo en proceso.",
          "change_not_found": "No encontramos la solicitud de cambio de correo.",
          "corporate_domain": "Debes usar un correo personal, no un correo corporativo.",
          "employee_not_found": "No encontramos un trabajador activo asociado a tu cuenta.",
          "invalid_pin_code": "El PIN ingresado no es válido.",
          "invalid_token": "El código ingresado no es válido.",
          "token_already_requested": "Ya solicitaste un código de confirmación. Revisa tu correo o espera a que expire para solicitar uno nuevo.",
          "token_not_requested": "Debes solicitar un código de confirmación primero.",
          "token_pending_other_session": "Ya hay un código de confirmación pendiente en otra sesión. Completa el cambio allí o espera a que expire."
        },
        "finish": {
          "success": "Tu correo fue actualizado correctamente.",
          "user_not_found": "No encontramos una cuenta con el correo %{new_email}. Cerramos tu sesión actual; inicia sesión con tu correo personal cuando esté disponible."
        },
        "resend_token": {
          "success": "Hemos reenviado el código de confirmación a tu nuevo correo electrónico."
        },
        "send_pin_code_email": {
          "success": "Hemos enviado un PIN de verificación para confirmar el cambio de correo electrónico a tu nuevo correo electrónico."
        },
        "send_token": {
          "success": "Hemos enviado un código de confirmación a tu nuevo correo electrónico."
        },
        "show": {
          "completed_message": "Tu cambio de correo fue procesado. Actualizaremos tu sesión en unos segundos.",
          "failed_message": "No fue posible actualizar tu correo electrónico. Serás redirigido al inicio del portal.",
          "loading": "Cargando",
          "processing_message": "Estamos actualizando tu correo y los documentos asociados. Esto puede tardar unos minutos.",
          "session_hint": "Puedes mantener esta página abierta. Al finalizar te llevaremos al portal con tu correo actualizado.",
          "timer_dashboard_prefix": "Te redirigiremos al inicio en",
          "timer_prefix": "Actualizaremos tu sesión en",
          "timer_suffix": "segundos",
          "title": "Cambio de correo en proceso"
        }
      },
      "meta": {
        "description": "Revisa y firma todos tus documentos en línea con ControlDoc.",
        "title": "Portal Empresa %{customer_name}"
      },
      "session_mailer": {
        "send_confirmation_email": {
          "subject": "Confirmar correo electrónico"
        }
      },
      "sessions": {
        "form": {
          "pin_code": "Código"
        },
        "two_factor_authentication": {
          "pin_code_custom": "Ingresar con PIN personalizado",
          "pin_code_custom_help": "Solo si ya tienes configurado tu PIN personalizado en tu cuenta ControlDoc",
          "pin_code_email": "Enviar PIN a mi correo electrónico",
          "pin_code_gauth": "Ingresar con PIN desde App Google Auth",
          "pin_code_gauth_help": "Solo si ya tienes configurado Google Auth en tu cuenta ControlDoc"
        }
      },
      "sign_documents": {
        "index": {
          "without_results": "No hemos encontrado registros"
        },
        "rejection_form": {
          "confirm": {
            "message": "¿Estás seguro de recharzar los documentos seleccionados?",
            "title": "Rechazar documentos"
          },
          "help_description": "Para proceder es necesario que describa las razones por las cuales rechaza los documentos. Sin esta información, no será posible procesar su solicitud."
        }
      },
      "signature_method": {
        "update": "Actualiza tu PIN de firma electrónica"
      },
      "suspensions": {
        "executed": "El acceso a su cuenta fue suspendida el día %{execution_date}",
        "not_executed": "El acceso a su cuenta será suspendida el día %{execution_date}"
      },
      "user_configurations": {
        "automatic_signature_disable": {
          "confirm": {
            "message": "¿Estás seguro de querer deshabilitar la firma automática?",
            "title": "Deshabilitar firma automática"
          },
          "successfully": "Firma automática deshabilitada correctamente"
        },
        "automatic_signature_enable": {
          "confirm": {
            "message": "¿Estás seguro de activar la firma automática?",
            "title": "Activar firma automática"
          },
          "successfully": "Firma automática activada correctamente"
        }
      },
      "versioner": {
        "document": {
          "items": {
            "create": {
              "successfully": "Versión creada correctamente"
            }
          }
        }
      },
      "welcome": {
        "by_controldoc": "Portal Empresa %{customer_name} construido por ControlDoc",
        "greeting": "Bienvenid@!",
        "title_html": "Gestiona y firma tus <strong>documentos en línea</strong> con ControlDoc."
      }
    },
    "profiles": {
      "custom_pin": {
        "instructions_sent": "Se han enviado las instrucciones para restablecer tu PIN a tu correo",
        "invalid_token": "El enlace es inválido o ha expirado",
        "success": "Tu PIN ha sido actualizado exitosamente"
      },
      "edit": {
        "title": "Perfil"
      },
      "enable_custom_pin": {
        "successfully": "Verificación en dos pasos habilitada"
      },
      "enable_dynamic_pin": {
        "successfully": "Verificación en dos pasos habilitada"
      },
      "form": {
        "controldoc_sign_api_token_help": "Campo requerido para configurar firmantes en la creación de documentos",
        "submit": {
          "update": "Actualizar"
        },
        "title": "Perfil"
      },
      "navbar": {
        "title": "Perfil"
      },
      "update": {
        "successfully": "Información personal actualizada con éxito"
      },
      "update_cellphone": {
        "confirm": {
          "message": "¿Estás seguro de actualizar el teléfono celular?",
          "title": "Actualizar Teléfono Celular"
        },
        "successfully": "Información actualizada con éxito"
      },
      "update_personal_information": {
        "successfully": "Información personal actualizada con éxito"
      }
    },
    "quantity": "Cantidad",
    "ransack": {
      "all": "todos",
      "and": "y",
      "any": "cualquier",
      "asc": "ascendente",
      "attribute": "atributo",
      "combinator": "combinador",
      "condition": "condición",
      "desc": "descendente",
      "or": "o",
      "predicate": "predicado",
      "predicates": {
        "blank": "está en blanco",
        "cont": "contiene",
        "cont_all": "contiene todos",
        "cont_any": "contiene cualquier",
        "does_not_match": "no coincide con",
        "does_not_match_all": "no coincide con todos",
        "does_not_match_any": "no coincide con ninguno",
        "end": "termina en",
        "end_all": "termina en todos",
        "end_any": "termina en cualquier",
        "eq": "es igual a",
        "eq_all": "es igual a todos",
        "eq_any": "es igual a cualquier",
        "false": "es falso",
        "gt": "mayor que",
        "gt_all": "mayor que todos",
        "gt_any": "mayor que cualquier",
        "gteq": "mayor que o igual a",
        "gteq_all": "mayor que o igual a todos",
        "gteq_any": "mayor que o igual a cualquier",
        "in": "en",
        "in_all": "en todos",
        "in_any": "en cualquier",
        "lt": "menor que",
        "lt_all": "menor o igual a",
        "lt_any": "menor que cualquier",
        "lteq": "menor que o igual a",
        "lteq_all": "menor o igual a todos",
        "lteq_any": "menor o igual a cualquier",
        "matches": "coincide con",
        "matches_all": "coincide con todos",
        "matches_any": "coincide con cualquier",
        "not_cont": "no contiene",
        "not_cont_all": "no contiene todos",
        "not_cont_any": "no contiene ninguno",
        "not_end": "no termina en",
        "not_end_all": "no termina en todos",
        "not_end_any": "no termina en cualquier",
        "not_eq": "no es igual a",
        "not_eq_all": "no es igual a todos",
        "not_eq_any": "no es igual a cualquier",
        "not_in": "no en",
        "not_in_all": "no en todos",
        "not_in_any": "no en cualquier",
        "not_null": "no es nulo",
        "not_start": "no comienza con",
        "not_start_all": "no comienza con todos",
        "not_start_any": "no comienza con cualquier",
        "null": "es nulo",
        "present": "está presente",
        "start": "comienza con",
        "start_all": "comienza con todos",
        "start_any": "comienza con cualquier",
        "true": "es verdadero"
      },
      "search": "buscar",
      "sort": "ordenar",
      "value": "valor"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Ups, no pudimos validar su respuesta de reCAPTCHA. Por favor intente de nuevo.",
        "verification_failed": "La verificación de reCAPTCHA falló, por favor intente de nuevo."
      }
    },
    "report": {
      "corporate": {
        "agreement_documents": {
          "create": {
            "successfully": "Tu reporte ha sido solicitado correctamente, una vez generado será enviado por correo electrónico."
          },
          "filter": {
            "by_aasm_state": "Estado",
            "by_expire_state": "Estado de caducidad",
            "by_expires_at": "Fecha de caducidad",
            "by_signature_deadline_at": "Fecha límite de firma",
            "end_date": "Hasta",
            "start_date": "Desde"
          },
          "headers": {
            "agreement_identifier": "Identificador de contrato",
            "client_identifier": "Identificador de cliente",
            "client_name": "Cliente",
            "created_at": "Fecha de creación",
            "document": "Documento",
            "document_created_by": "Creado por",
            "document_type": "Tipo de documento",
            "expires_at": "Fecha de caducidad",
            "provider_identifier": "Identificador de proveedor",
            "provider_name": "Proveedor",
            "signature_deadline_at": "Fecha límite de firma",
            "start_date": "Fecha inicio contrato",
            "state": "Estado"
          },
          "new": {
            "create_excel": "Crear excel"
          },
          "title": "Más información"
        },
        "signers": {
          "headers": {
            "client_collaborator": "Cliente",
            "client_identifier": "Identificador de cliente",
            "document": "Documento",
            "document_created_by": "Documento creado por",
            "document_label": "Nombre de documento",
            "document_state": "Estado de documento",
            "document_type": "Tipo de documento",
            "expires_at": "Fecha de expiración",
            "provider_collaborator": "Proveedor",
            "provider_identifier": "Identificador de proveedor",
            "request_date": "Fecha de solicitud",
            "sign_date": "Fecha de firma",
            "sign_state": "Estado de firma",
            "signature_deadline_at": "Fecha límite de firma",
            "signer_email": "Firmante",
            "template_name": "Nombre plantilla"
          },
          "new": {
            "aasm_state": "Estado de firma",
            "create_excel": "Crear excel",
            "email": "Correo firmante",
            "end_date": "Hasta",
            "search_by_key_custom_fields": "Campos personalizados",
            "sorted_by": "Ordenar por",
            "start_date": "Desde",
            "template_name": "Nombre plantilla"
          },
          "title": "Más información"
        }
      },
      "laboral": {
        "hiring_documents": {
          "create": {
            "successfully": "Tu reporte ha sido solicitado correctamente, una vez generado será enviado por correo electrónico."
          },
          "headers": {
            "branch_name": "Sucursal",
            "company_name": "Empresa",
            "created_at": "Fecha de creación",
            "document": "Documento",
            "document_created_by": "Creado por",
            "document_type": "Tipo de documento",
            "expires_at": "Fecha de caducidad",
            "hiring_identifier": "Identificador de contratación",
            "hiring_state": "Estado de contratación",
            "name_employee": "Nombre trabajador",
            "reject_reason": "Razón de Rechazo",
            "rut": "Rut",
            "signature_deadline_at": "Fecha límite de firma",
            "start_date": "Fecha inicio contrato",
            "state": "Estado"
          },
          "new": {
            "by_aasm_state": "Estado",
            "by_company": "Empresa",
            "by_document_type": "Tipo de documento",
            "by_expire_state": "Estado de caducidad",
            "by_expires_at": "Fecha de caducidad",
            "by_hiring_state": "Estado de contratación",
            "by_signature_deadline_at": "Fecha límite de firma",
            "create_excel": "Crear excel",
            "end_date": "Hasta",
            "search_by_employee_identifier": "Identificador del trabajador",
            "start_date": "Desde"
          },
          "title": "Más información"
        },
        "hirings": {
          "headers": {
            "branch_name": "Nombre de la Sucursal",
            "collaborator": "Trabajador",
            "company_id": "Empresa",
            "employee_identifier": "Identificador de trabajador",
            "end_date": "Fecha fin",
            "identifier": "Identificador de contratación",
            "start_date": "Fecha inicio",
            "status": "Estado de contratación"
          },
          "new": {
            "company_name": "Nombre de la Empresa",
            "create_excel": "Crear excel",
            "end_date": "Hasta",
            "hiring_state": "Estado de contratación",
            "search_by_key_custom_fields": "Campos personalizados",
            "start_date": "Desde"
          },
          "title": "Más información"
        },
        "signers": {
          "headers": {
            "branch_name": "Nombre de la Sucursal",
            "collaborator": "Trabajador",
            "company_id": "Empresa",
            "document": "Documento",
            "document_created_by": "Documento creado por",
            "document_label": "Nombre de documento",
            "document_state": "Estado de documento",
            "document_type": "Tipo de documento",
            "employee_identifier": "Identificador de trabajador",
            "expires_at": "Fecha de expiración",
            "hiring_identifier": "Identificador de contratación",
            "hiring_status": "Estado de contratación",
            "request_date": "Fecha de solicitud",
            "security_layer": "Capa de seguridad",
            "sign_date": "Fecha de firma",
            "sign_state": "Estado de firma",
            "signature_deadline_at": "Fecha límite de firma",
            "signer_email": "Firmante",
            "signer_role": "Rol en el documento",
            "template_name": "Nombre plantilla"
          },
          "new": {
            "aasm_state": "Estado de firma",
            "company_id": "Empresa",
            "create_excel": "Crear excel",
            "email": "Correo firmante",
            "end_date": "Hasta",
            "hiring_identifier": "Identificador de contratación",
            "hiring_state": "Estado de contratación",
            "search_by_key_custom_fields": "Campos personalizados",
            "security_layer": "Capa de seguridad",
            "sorted_by": "Ordenar por",
            "start_date": "Desde",
            "template_name": "Nombre plantilla"
          },
          "title": "Más información"
        }
      }
    },
    "report_mailer": {
      "send_dt_active_workers": {
        "subject": "Reporte de trabajadores activos ELaboral"
      },
      "send_report": {
        "subject": "%{type}"
      }
    },
    "reports": {
      "agreement_document": {
        "tooltip_info": "Filtra y genera archivo de reporte de todos los documentos de módulo corporativo."
      },
      "create": {
        "successfully": "Tu reporte ha sido solicitado correctamente, una vez generado será enviado por correo electrónico."
      },
      "custom_fields": {
        "search_by_key_custom_fields": "Campos Personalizados",
        "tooltip_info": "Realiza una búsqueda más precisa para tu reporte utilizando los campos personalizados."
      },
      "filter": {
        "end_date": "Hasta",
        "start_date": "Desde",
        "with_created_at": "Fecha de creación"
      },
      "hiring": {
        "tooltip_info": "Filtra y genera archivo de reporte de todas las contrataciones de módulo laboral."
      },
      "hiring_document": {
        "tooltip_info": "Filtra y genera archivo de reporte de todos los documentos de módulo laboral"
      },
      "index": {
        "without_results": "No hemos encontrado registros"
      },
      "new": {
        "create_excel": "Enviarme reporte",
        "without_results": "No hemos encontrado registros"
      },
      "signer": {
        "tooltip_info": "Filtra y genera archivo de reporte de todos los firmantes"
      }
    },
    "request_document_mailer": {
      "request_document_mailer": {
        "subject": "Solicitud de documentos"
      }
    },
    "requested_by_template": "Solicitado por plantilla",
    "roles": {
      "abstract/bulk/load/documents": {
        "create": "Creación carga masiva de documentos",
        "index": "Listado de carga masiva de documentos",
        "show": "Ver carga masiva de documentos"
      },
      "abstract/bulk/load/entities": {
        "create": "Creación %{entity}",
        "index": "Listado %{entity}",
        "show": "Ver %{entity}"
      },
      "abstract/bulk/notification/signs": {
        "create": "Creación de notificación de firmas masivas",
        "index": "Listado de notificación de firmas masivas",
        "show": "Ver notificación de firmas masivas"
      },
      "abstract/bulk/request/documents": {
        "create": "Creación solicitud masiva de documentos",
        "index": "Listado de solicitudes masivas de documentos",
        "show": "Ver solicitudes masivas de documentos"
      },
      "abstract/bulk/request/zip/documents": {
        "block": "Bloquear Descargas Masivas de documentos",
        "create": "Creación de Descargas Masivas de documentos",
        "destroy": "Eliminación de Descargas Masivas de documentos",
        "index": "Listado de Descargas Masivas de documentos",
        "show": "Ver Descargas Masivas de documentos",
        "update": "Actualización de Descargas Masivas de documentos"
      },
      "abstract/check_list/processes": {
        "create": "Creación de Checklist",
        "destroy": "Eliminación de documentos",
        "index": "Listado de CheckList",
        "show": "Ver CheckList",
        "update": "Actualización de CheckList"
      },
      "abstract/check_list/tasks": {
        "index": "Listado de Tareas",
        "show": "Ver Tarea",
        "update": "Actualización de Tareas"
      },
      "abstract/controldoc_form/documents": {
        "block": "Bloqueo de documentos de Plantillas",
        "index": "Listado de envios de Plantillas",
        "show": "Ver envios de Plantillas",
        "update": "Actualización de envios de Plantillas"
      },
      "abstract/controldoc_form/template_layouts": {
        "block": "Bloquear Diseños de Plantillas",
        "create": "Creación de Diseños de Plantillas",
        "destroy": "Eliminación de Diseños de Plantillas",
        "index": "Listado de Diseños de Plantillas",
        "show": "Ver Diseños de Plantillas",
        "update": "Actualización de Diseños de Plantillas"
      },
      "abstract/controldoc_form/templates": {
        "create": "Creación Plantillas",
        "destroy": "Eliminación Plantillas",
        "index": "Listado Plantillas",
        "show": "Ver Plantillas",
        "update": "Actualización Plantillas"
      },
      "abstract/custom_fields": {
        "create": "Creación de campos personalizados",
        "destroy": "Eliminación de campos personalizados",
        "index": "Listado de campos personalizados",
        "show": "Ver campos personalizados",
        "update": "Actualización de campos personalizados"
      },
      "abstract/document_type_batteries": {
        "create": "Creación de baterias de documentos",
        "destroy": "Eliminación de baterias de documentos",
        "index": "Listado de baterias de documentos",
        "show": "Ver baterias de documentos",
        "update": "Actualización de baterias de documentos"
      },
      "abstract/document_types": {
        "create": "Creación de tipos de documentos",
        "destroy": "Eliminación tipos de documentos",
        "index": "Listado de tipos de documentos",
        "show": "Ver tipos de documento",
        "update": "Actualización tipos de documentos"
      },
      "abstract/documents": {
        "block": "Bloqueo de documentos",
        "create": "Creación de documentos",
        "destroy": "Eliminación de documentos",
        "index": "Listado de documentos",
        "show": "Ver documentos",
        "update": "Actualización de documentos"
      },
      "abstract/entities": {
        "create": "Creación %{entity}",
        "destroy": "Eliminación %{entity}",
        "index": "Listado %{entity}",
        "show": "Ver %{entity}",
        "update": "Actualización %{entity}"
      },
      "abstract/entity_folder/check_list_tasks": {
        "block": "Bloquear Revisión de documentos",
        "destroy": "Eliminación de Revisión de documentos",
        "index": "Listado de Revisión de documentos",
        "show": "Ver Revisión de documentos",
        "update": "Actualización de Revisión de documentos"
      },
      "abstract/entity_folder/check_lists": {
        "block": "Bloquear Carpetas",
        "create": "Creación de Carpetas",
        "destroy": "Eliminación de Carpetas",
        "index": "Listado de Carpetas",
        "show": "Ver Carpetas",
        "update": "Actualización de Carpetas"
      },
      "abstract/fao/mapping_configs": {
        "block": "Bloquear Homologación FAO",
        "create": "Creación de Diseños de Plantillas",
        "destroy": "Eliminación de Homologación FAO",
        "index": "Listado de Homologación FAO",
        "show": "Ver Homologación FAO",
        "update": "Actualización de Homologación FAO"
      },
      "abstract/workflow/processes": {
        "block": "Bloquear Procesos",
        "create": "Creación de Procesos",
        "destroy": "Eliminación de Procesos",
        "index": "Listado de Procesos",
        "show": "Ver Procesos",
        "update": "Actualización de Procesos"
      },
      "abstract/workflow/requirement_stages": {
        "index": "Listado de Etapas del requerimiento"
      },
      "abstract/workflow/requirements": {
        "block": "Bloquear Requerimientos",
        "create": "Creación de Requerimientos",
        "destroy": "Eliminación de Requerimientos",
        "index": "Listado de Requerimientos",
        "show": "Ver Requerimientos",
        "update": "Actualización de Requerimientos"
      },
      "block": "Bloquear",
      "blog/posts": {
        "create": "Creación de publicaciones del blog empresa",
        "destroy": "Eliminación de publicaciones del blog empresa",
        "index": "Listado de publicaciones del blog empresa",
        "show": "Ver publicación del blog empresa",
        "update": "Actualización de publicaciones del blog empresa"
      },
      "compliance/activities": {
        "create": "Creación de actividades",
        "destroy": "Eliminación de actividad",
        "index": "Listado de actividades",
        "show": "Ver actividad",
        "update": "Actualización de actividad"
      },
      "compliance/bulk/load/activities": {
        "create": "Creación de carga masiva de actividades",
        "destroy": "Eliminación de cargas masivas",
        "index": "Listado de cargas masivas de actividades",
        "show": "Ver cargas masivas",
        "update": "Actualización de cargas masivas"
      },
      "compliance/groups": {
        "create": "Creación de grupos",
        "destroy": "Eliminación de grupos",
        "index": "Listado de grupos",
        "show": "Ver grupos",
        "update": "Actualización de grupos"
      },
      "compliance/risk_levels": {
        "create": "Creación de niveles de riesgo",
        "destroy": "Eliminación de niveles de riesgo",
        "index": "Listado de niveles de riesgo",
        "show": "Ver niveles de riesgo",
        "update": "Actualización de niveles de riesgo"
      },
      "corporate/agreement_documents": {
        "block": "Bloqueo de documentos corporativo",
        "create": "Creación de documentos corporativo",
        "destroy": "Eliminación de documentos corporativo",
        "index": "Listado de documentos corporativo",
        "show": "Ver documentos corporativo",
        "update": "Actualización de documentos corporativo"
      },
      "corporate/agreements": {
        "create": "Creación de contratos corporativo",
        "destroy": "Eliminación contratos corporativo",
        "index": "Listado de contratos corporativo",
        "show": "Ver contratos corporativo",
        "update": "Actualización contratos corporativo"
      },
      "corporate/bulk/notification/signs": {
        "create": "Creación de notificación de firmas masivas",
        "index": "Listado de notificación de firmas masivas",
        "show": "Ver notificación de firmas masivas"
      },
      "corporate/bulk/request/agreement_documents": {
        "create": "Creación carga masiva de documentos corporativos",
        "index": "Listado de carga masiva de documentos corporativos",
        "show": "Ver carga masiva de documentos corporativos"
      },
      "corporate/bulk/request/zip/documents": {
        "create": "Creación descarga masiva de documentos corporativos",
        "index": "Listado de descargas masivas de documentos corporativos",
        "show": "Ver descargas masivas de documentos corporativos"
      },
      "corporate/check_list/agreement_processes": {
        "create": "Creación de Checklist",
        "destroy": "Eliminación de CheckList",
        "index": "Listado de CheckList",
        "show": "Ver CheckList",
        "update": "Actualización de CheckList"
      },
      "corporate/check_list/agreement_tasks": {
        "index": "Listado de Tareas",
        "show": "Ver Tarea",
        "update": "Actualización de Tareas"
      },
      "corporate/companies": {
        "create": "Creación de empresas",
        "destroy": "Eliminación de empresas",
        "index": "Listado de empresas",
        "show": "Ver empresa",
        "update": "Actualización de empresas"
      },
      "corporate/controldoc_form/documents": {
        "block": "Bloqueo de documentos de Plantillas",
        "index": "Listado de envios de Plantillas",
        "show": "Ver envios de Plantillas",
        "update": "Actualización de envios de Plantillas"
      },
      "corporate/controldoc_form/template_layouts": {
        "block": "Bloquear Diseños de Plantillas",
        "create": "Creación de Diseños de Plantillas",
        "destroy": "Eliminación de Diseños de Plantillas",
        "index": "Listado de Diseños de Plantillas",
        "show": "Ver Diseños de Plantillas",
        "update": "Actualización de Diseños de Plantillas"
      },
      "corporate/controldoc_form/templates": {
        "create": "Creación de plantillas",
        "destroy": "Eliminación de plantillas",
        "index": "Listado de plantillas",
        "show": "Ver plantillas",
        "update": "Actualización de plantillas"
      },
      "corporate/custom_fields": {
        "create": "Creación de campos personalizados corporativos",
        "destroy": "Eliminación de campos personalizados corporativos",
        "index": "Listado de campos personalizados corporativos",
        "show": "Ver campos personalizados corporativos",
        "update": "Actualización de campos personalizados corporativos"
      },
      "corporate/document_type_batteries": {
        "create": "Creación de baterias de documentos corporativo",
        "destroy": "Eliminación de baterias de documentos corporativo",
        "index": "Listado de baterias de documentos corporativo",
        "show": "Ver baterias de documentos corporativo",
        "update": "Actualización de baterias de documentos corporativo"
      },
      "corporate/document_types": {
        "create": "Creación de tipos de documentos corporativo",
        "destroy": "Eliminación tipos de documentos corporativo",
        "index": "Listado de tipos de documentos corporativo",
        "show": "Ver tipos de documento corporativo",
        "update": "Actualización tipos de documentos corporativo"
      },
      "create": "Crear",
      "destroy": "Eliminar",
      "dt/bulk/load/annexe_records": {
        "create": "Creación de envíos documento de anexos MiDT",
        "index": "Listado de envíos documento de anexos MiDT",
        "show": "Ver envíos documento de anexos MiDT"
      },
      "dt/bulk/load/contract_records": {
        "create": "Creación de envíos documentos MiDT",
        "index": "Listado de envíos documentos MiDT",
        "show": "Ver envíos documentos MiDT"
      },
      "economic_crime/workflow/processes": {
        "create": "Creación de Procesos",
        "destroy": "Eliminación de Procesos",
        "index": "Listado de Procesos",
        "show": "Ver Procesos",
        "update": "Actualización de Procesos"
      },
      "economic_crime/workflow/requirements": {
        "create": "Creación de Requerimientos",
        "destroy": "Eliminación de Requerimientos",
        "index": "Listado de Requerimientos",
        "show": "Ver Requerimientos",
        "update": "Actualización de Requerimientos"
      },
      "index": "Ver Listados",
      "karin_law/complaints": {
        "create": "Creación de una denuncia",
        "destroy": "Eliminación de denuncia",
        "index": "Listado de denuncia",
        "show": "Ver denuncia",
        "update": "Actualización de denuncia"
      },
      "karin_law/custom_fields": {
        "create": "Creación de campos personalizados",
        "destroy": "Eliminación de campo personalizado",
        "index": "Listado de campos personalizados",
        "show": "Ver campo personalizado",
        "update": "Actualización de campo personalizado"
      },
      "karin_law/document_types": {
        "create": "Creación de tipo de documento",
        "destroy": "Eliminación de tipo de documento",
        "index": "Listado de tipos de documentos",
        "show": "Ver tipo de documento",
        "update": "Actualización de tipo de documento"
      },
      "karin_law/workflow/processes": {
        "create": "Creación de procesos",
        "destroy": "Eliminación de proceso",
        "index": "Listado de procesos",
        "show": "Ver proceso",
        "update": "Actualización de proceso"
      },
      "karin_law/workflow/requirements": {
        "create": "Creación de denuncias",
        "destroy": "Eliminación de denuncia",
        "index": "Listado de denuncias",
        "show": "Ver denuncia",
        "update": "Actualización de denuncia"
      },
      "laboral/bulk/load/employees": {
        "create": "Creación carga masiva de trabajadores",
        "index": "Listado de carga masiva de trabajadores",
        "show": "Ver carga masiva de trabajadores"
      },
      "laboral/bulk/load/hiring_documents": {
        "create": "Creación carga masiva de documentos laborales",
        "index": "Listado de carga masiva de documentos laborales",
        "show": "Ver carga masiva de documentos laborales"
      },
      "laboral/bulk/load/hirings": {
        "create": "Creación carga masiva de contrataciones laborales",
        "index": "Listado de carga masiva de contrataciones laborales",
        "show": "Ver carga masiva de contrataciones laborales"
      },
      "laboral/bulk/notification/fills": {
        "create": "Creación de notificación de formularios masivos",
        "index": "Listado de notificación de formularios masivos",
        "show": "Ver notificación de formularios masivos"
      },
      "laboral/bulk/notification/signs": {
        "create": "Creación de notificación de firmas masivas",
        "index": "Listado de notificación de firmas masivas",
        "show": "Ver notificación de firmas masivas"
      },
      "laboral/bulk/request/destroy_documents": {
        "create": "Creación de eliminación de documentos masivo",
        "index": "Listado de eliminación de documentos masivo",
        "show": "Ver eliminación de documentos masivo"
      },
      "laboral/bulk/request/destroy_employees": {
        "create": "Creación de eliminación de trabajadores masiva",
        "index": "Listado de eliminación de trabajadores masiva",
        "show": "Ver eliminación de trabajadores masiva"
      },
      "laboral/bulk/request/hiring_documents": {
        "create": "Creación solicitud masiva de documentos laborales",
        "index": "Listado de solicitudes masivas de documentos laborales",
        "show": "Ver solicitudes masivas de documentos laborales"
      },
      "laboral/bulk/request/zip/documents": {
        "create": "Creación descarga masiva de documentos laborales",
        "index": "Listado de descargas masivas de documentos laborales",
        "show": "Ver descargas masivas de documentos laborales"
      },
      "laboral/check_list/hiring_processes": {
        "create": "Creación de Checklist",
        "destroy": "Eliminación de documentos laborales",
        "index": "Listado de CheckList",
        "show": "Ver CheckList",
        "update": "Actualización de CheckList"
      },
      "laboral/check_list/hiring_tasks": {
        "index": "Listado de Tareas",
        "show": "Ver Tarea",
        "update": "Actualización de Tareas"
      },
      "laboral/controldoc_form/documents": {
        "block": "Bloquear Documentos de Plantillas",
        "destroy": "Eliminación de Documentos laborales de Plantillas",
        "index": "Listado de Documentos laborales de Plantillas",
        "show": "Ver Documentos laborales de Plantillas",
        "update": "Actualización de Documentos laborales de Plantillas"
      },
      "laboral/controldoc_form/template_layouts": {
        "block": "Bloquear Diseños de Plantillas",
        "create": "Creación de Diseños en Plantillas",
        "destroy": "Eliminación de Diseños laborales de Plantillas",
        "index": "Listado de Diseños laborales de Plantillas",
        "show": "Ver Diseños laborales de Plantillas",
        "update": "Actualización de Diseños laborales de Plantillas"
      },
      "laboral/controldoc_form/templates": {
        "create": "Creación de Plantillas laborales",
        "destroy": "Eliminación de Plantillas laborales",
        "index": "Listado de Plantillas laborales",
        "show": "Ver Plantillas laborales",
        "update": "Actualización de Plantillas laborales"
      },
      "laboral/custom_fields": {
        "create": "Creación de campos personalizados laborales",
        "destroy": "Eliminación de campos personalizados laborales",
        "index": "Listado de campos personalizados laborales",
        "show": "Ver campos personalizados laborales",
        "update": "Actualización de campos personalizados laborales"
      },
      "laboral/document_type_batteries": {
        "create": "Creación de baterias de documentos laborales",
        "destroy": "Eliminación de baterias de documentos laborales",
        "index": "Listado de baterias de documentos laborales",
        "show": "Ver baterias de documentos laborales",
        "update": "Actualización de baterias de documentos laborales"
      },
      "laboral/document_types": {
        "create": "Creación de tipos de documentos labores",
        "destroy": "Eliminación tipos de documentos labores",
        "index": "Listado de tipos de documentos labores",
        "show": "Ver tipos de documento labores",
        "update": "Actualización tipos de documentos labores"
      },
      "laboral/employee_documents": {
        "block": "Bloqueo de documentos asociados al trabajador",
        "create": "Creación de documentos asociados al trabajador",
        "destroy": "Eliminación de documentos asociados al trabajador",
        "index": "Listado de documentos asociados al trabajador",
        "show": "Ver documentos asociados al trabajador",
        "update": "Actualización de documentos asociados al trabajador"
      },
      "laboral/employees": {
        "create": "Creación de trabajadores",
        "destroy": "Eliminación de trabajadores",
        "index": "Listado de trabajadores",
        "show": "Ver trabajadores",
        "update": "Actualización de trabajadores"
      },
      "laboral/hiring_documents": {
        "block": "Bloqueo de documentos laborales",
        "create": "Creación de documentos laborales",
        "destroy": "Eliminación de documentos laborales",
        "index": "Listado de documentos laborales",
        "show": "Ver documentos laborales",
        "update": "Actualización de documentos laborales"
      },
      "laboral/hirings": {
        "create": "Creación de contratos laborales",
        "destroy": "Eliminación contratos laborales",
        "index": "Listado de contratos laborales",
        "show": "Ver contratos laborales",
        "update": "Actualización contratos laborales"
      },
      "laboral/workflow/processes": {
        "create": "Creación de procesos laborales de workflow",
        "destroy": "Eliminación de procesos laborales de workflow",
        "index": "Listado de procesos laborales de workflow",
        "show": "Ver procesos laborales de workflow",
        "update": "Actualización de procesos laborales de workflow"
      },
      "laboral/workflow/requirements": {
        "create": "Creación de requerimientos laborales de workflow",
        "destroy": "Eliminación de requerimientos laborales de workflow",
        "index": "Listado de requerimientos laborales de workflow",
        "show": "Ver requerimientos laborales de workflow",
        "update": "Actualización de requerimientos laborales de workflow"
      },
      "portal/configurations": {
        "update": "Actualización de configuración de portal empresa"
      },
      "show": "Ver",
      "update": "Editar"
    },
    "search": {
      "advanced_search": "Búsqueda Avanzada",
      "edit_search": "Editar Búsqueda"
    },
    "security_layers": {
      "create": {
        "successfully": "Se ha creado la capa de seguridad con éxito"
      },
      "destroy": {
        "successfully": "Capa de seguridad eliminada con éxito"
      },
      "filter": {
        "end_date": "Hasta",
        "search_query": {
          "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre de la capa de seguridad</li> </ul>"
        },
        "start_date": "Desde",
        "with_created_at": "Fecha de creación"
      },
      "headers": {
        "delete": "Eliminar capa de seguridad",
        "edit": "Editar capa de seguridad",
        "title": "Capa de seguridad"
      },
      "index": {
        "new": "Nueva Capa de seguridad",
        "without_results": "No hemos encontrado capas de seguridad"
      },
      "messages": {
        "destroy": {
          "confirm": {
            "message": " <p> ¿Estás seguro de eliminar la capa de seguridad? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Dejara sin capa de seguridad a todos los trabajadores que se encuentren en ella, y por tanto solo podrán ser accedidos por un Admin</li> </ul> </div> ",
            "title": "Eliminar Capa de Seguridad"
          }
        }
      },
      "name_help": "Establece un nombre de la capa de seguridad, con esta podrás clasificar a tus trabajadores por áreas, departamentos o centros de costo y dar permisos específicos a miembros en roles",
      "show": {
        "details": "Detalles"
      },
      "tooltip_info": "Crea un perfil de capa de seguridad para clasificar a tus trabajadores por áreas o departamentos internos y dar acceso específico a los usuarios",
      "update": {
        "successfully": "Se ha actualizado la capa de seguridad con éxito"
      }
    },
    "shortlist": {
      "assessment_loads": {
        "actions": {
          "fill": "Evaluación"
        }
      },
      "mapping_configs": {
        "create": {
          "successfully": "La homologación de Shortlist ha sido creada correctamente"
        },
        "destroy": {
          "successfully": "La homologación de Shortlist ha sido eliminada correctamente"
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar la homologación de Shortlist?",
            "title": "Guardar homologación Shortlist"
          }
        },
        "messages": {
          "destroy": {
            "confirm": {
              "message": "Se eliminará la homologación de Shortlist. Esta es una acción no reversible. ¿Estás seguro de eliminar la homologación?",
              "title": "Eliminar homologación de Shortlist"
            }
          }
        },
        "tooltip_info": "Agrega y gestiona los campos para la homologación de Shortlist relevante para tu gestión de documentos",
        "update": {
          "successfully": "La homologación de Shortlist ha sido actualizada correctamente"
        }
      },
      "mapping_fields": {
        "form": {
          "opt_group": {
            "custom_fields": {
              "one": "Campos personalizados"
            },
            "resource_data": {
              "one": "Información del recurso"
            }
          }
        }
      }
    },
    "signer_groups": {
      "form": {
        "add_group": "Agregar Grupo",
        "destroy": {
          "confirm": {
            "message": "¿Esta seguro de eliminar el grupo de firmantes?",
            "title": "Eliminar grupo de firmantes"
          }
        },
        "order": "Orden",
        "remove_group": "Eliminar Grupo",
        "require_minimun_signers_info": "Permite una cantidad minima de firmantes (Sin necesidad de que todos firmen)"
      }
    },
    "signer_mailer": {
      "notify_viewer": {
        "subject": "Notificación del firmante en el documento"
      }
    },
    "signer_notifications": {
      "create": {
        "successfully": "Notificación enviada exitosamente"
      },
      "form": {
        "confirm": {
          "message": "¿Estás seguro de notificar al firmante?",
          "title": "Notificación pendiente de firma"
        }
      }
    },
    "signers": {
      "destroy": {
        "confirm": {
          "message": "¿Estás seguro de eliminar al firmante?",
          "title": "Eliminar Firmante"
        }
      },
      "form": {
        "add_signer": "Agregar firmante",
        "default_role_email_notification": "Representante",
        "email_notification_sign": "Firma el correo electrónico del representante",
        "legal_representative": "Representante legal",
        "member_sign": "Firma un integrante",
        "order": "Firmante N °",
        "remove_signer": "Eliminar Firmante",
        "send_doc_company": "El documento se enviará al correo electrónico del representante legal asociado a la empresa",
        "send_email_notification": "El documento se enviará al correo electrónico campo personalizado %{label}.",
        "worker": "Trabajador"
      },
      "signer_order": "%{order}° Firmante/Visador"
    },
    "support": {
      "array": {
        "last_word_connector": " y ",
        "two_words_connector": " y ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "custom": "%d/%m/%Y %H:%M",
        "date": "%d/%m/%Y",
        "default": "%A, %d de %B de %Y %H:%M:%S %z",
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d de %B de %Y, %H:%M"
            }
          }
        },
        "full_date": "%d/%m/%Y %H:%M:%S:%L %z",
        "hours_12_blank": "%l:%M %p",
        "long": "%d de %B de %Y %H:%M",
        "only_date": "%d/%m/%Y",
        "only_time": "%H:%M",
        "short": "%d de %b %H:%M"
      },
      "pm": "pm"
    },
    "unassigned": "Sin asignar",
    "undefined": "Indefinido",
    "unsubscribed": {
      "emails": {
        "messages": {
          "created": "Email agregado exitosamente a la lista de no suscritos",
          "deleted": "Email eliminado de la lista de no suscritos",
          "updated": "Email actualizado exitosamente"
        }
      }
    },
    "user_mailer": {
      "reset_custom_pin_instructions": {
        "subject": "Instrucciones para restablecer tu PIN personalizado"
      },
      "send_onboarding_process_token": {
        "subject": "Código de verificación"
      }
    },
    "users": {
      "profile": {
        "personal_information": {
          "skip_document_notifications": {
            "confirm": {
              "message": "<p><strong>¿Estás seguro de desactivar las notificaciones de documentos?</strong></p><p>Si desactivas las notificaciones, <strong><span class='text-danger'>no recibirás notificaciones</span></strong> relacionada a tus documentos.</p>",
              "title": "Desactivar notificaciones de documentos"
            }
          },
          "update": {
            "confirm": {
              "message": "¿Estás seguro de actualizar tu información personal?",
              "title": "Actualizar información personal"
            }
          }
        },
        "tooltip_info": "En esta sección podrás actualizar tus datos y habilitar tu cuenta para firmar electrónicamente tus documentos."
      }
    },
    "versioner": {
      "document": {
        "items": {
          "create": {
            "successfully": "Versión creada correctamente"
          },
          "no_previous_item": "Sin versión previa"
        },
        "thread_mailer": {
          "send_invitation_to_collaborators": {
            "subject": "Invitación al proyecto"
          }
        },
        "threads": {
          "create": {
            "successfully": "Proyecto creado exitosamente"
          },
          "destroy": {
            "confirm": {
              "message": "Eliminar este proyecto eliminará todas las versiones asociadas.",
              "title": "¿Estás seguro de eliminar este proyecto?"
            },
            "successfully": "Proyecto eliminado exitosamente"
          },
          "filter": {
            "end_date": "Hasta",
            "search_query": {
              "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del proyecto</li> </ul>"
            },
            "start_date": "Desde",
            "with_created_at": "Fecha de creación"
          },
          "form": {
            "button": {
              "add_collaborator": "Agregar colaborador"
            }
          },
          "show": {
            "without_results": "No hay versiones para mostrar"
          },
          "update": {
            "successfully": "El Proyecto ha sido actualizado correctamente"
          }
        }
      }
    },
    "workflow": {
      "edges": {
        "create": {
          "successfully": "El conector ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El conector ha sido eliminado correctamente"
        },
        "form": {
          "configuration": "Configuración del conector"
        },
        "help": {
          "enabled_source_file_item_overview_metadata": "Si marcas esta opción como '¿Mostrar información vinculada de la etapa anterior?', se mostrará la información de la etapa de origen en la etapa de destino."
        },
        "update": {
          "successfully": "El conector ha sido actualizado correctamente"
        }
      },
      "groups": {
        "create": {
          "successfully": "El grupo ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El grupo ha sido eliminado correctamente"
        },
        "form": {
          "configuration": "Configuración de la etapa"
        },
        "no_entry": "Sin Encargado de Etapa",
        "update": {
          "successfully": "El grupo ha sido actualizado correctamente"
        }
      },
      "processes": {
        "create": {
          "successfully": "El proceso ha sido creado correctamente"
        },
        "destroy": {
          "confirm": {
            "message": " <p> ¿Estás seguro de eliminar el proceso? </p> <p class='text-danger'><strong>Esta acción no es posible revertir</strong></p> <div class='callout callout-danger text-left'> <h5 class='font-weight-bold'>Esta acción:</h5> <ul> <li>Eliminará los requerimientos asociadas y todas las evidencias.</li> </ul> </div> ",
            "title": "Eliminar Workflow"
          },
          "successfully": "El proceso ha sido eliminada correctamente"
        },
        "filter": {
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre</li> </ul>"
          }
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el proceso?",
            "title": "Guardar Proceso"
          }
        },
        "import_json": {
          "successfully": "El proceso ha sido importado correctamente"
        },
        "qr": {
          "one": "Código QR"
        },
        "tooltip_info": "Crear workflows para gestionar mejor tu documentación",
        "update": {
          "successfully": "El proceso ha sido actualizado correctamente"
        }
      },
      "requirement_ebooks": {
        "create": {
          "successfully": "El ebook ha sido creado correctamente"
        },
        "error_tooltip": "La generación terminó con errores. Si la situación persiste, por favor contactar a soporte."
      },
      "requirement_stage_mailer": {
        "moving_backward_html": "El requerimiento <strong>%{requirement_name}</strong> ha sido devuelto a la etapa <strong>%{to_stage_name}</strong>",
        "moving_forward_html": "El requerimiento <strong>%{requirement_name}</strong> ha avanzado a la etapa <strong>%{to_stage_name}</strong>",
        "new_requirement_html": "Se ha recepcionado el requerimiento <strong>%{requirement_name}</strong>",
        "notify_authorized_emails": {
          "subject": "Requerimiento por revisar!"
        }
      },
      "requirement_stages": {
        "create": {
          "successfully": "El requerimiento ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El requerimiento ha sido eliminado correctamente"
        },
        "filter": {
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del proceso</li> </ul>"
          }
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el requerimiento?",
            "title": "Guardar Requerimiento"
          }
        },
        "tooltip_info": "Administra los requerimientos que requieren de tu atención",
        "update": {
          "successfully": "El requerimiento ha sido actualizado correctamente"
        },
        "without_authorization": "Sin autorización"
      },
      "requirements": {
        "attributes": {
          "identifier": {
            "help": "Este campo es opcional. Si lo dejas en blanco, el sistema generará automáticamente un número de seguimiento único para identificar el requerimiento"
          }
        },
        "create": {
          "successfully": "El requerimiento ha sido creado correctamente"
        },
        "destroy": {
          "successfully": "El requerimiento ha sido eliminado correctamente"
        },
        "ebook": {
          "creating": "Creando Ebook...",
          "download": "Descargar Ebook"
        },
        "filter": {
          "by_process_name": "Nombre del Proceso",
          "search_query": {
            "help": "Puedes buscar según los siguientes parámetros <ul class=\"text-left pl-4\"> <li>Nombre del proceso</li> <li>Número de seguimiento</li> </ul>"
          }
        },
        "form": {
          "confirm": {
            "message": "¿Estás seguro de guardar el requerimiento?",
            "title": "Guardar Requerimiento"
          }
        },
        "modal_confirm_destroy": {
          "deleted_reason_label": "Motivo de eliminación",
          "deleted_reason_placeholder": "Por favor, indique el motivo de la eliminación...",
          "question": "¿Estás seguro de eliminar este requerimiento?",
          "title": "Eliminar requerimiento"
        },
        "show": {
          "details": "Detalles del requerimiento"
        },
        "tooltip_info": "Crear y administra los requerimientos de los workflows",
        "update": {
          "successfully": "El requerimiento ha sido actualizado correctamente"
        }
      },
      "stage_field_items": {
        "form": {
          "complete_list_options": "Completar opciones",
          "config_list_options": "Configurar lista de opciones"
        }
      },
      "stage_file_items": null,
      "stage_forms": null,
      "stage_output_file_items": null,
      "stages": {
        "create": {
          "successfully": "La etapa ha sido creada correctamente"
        },
        "destroy": {
          "successfully": "La etapa ha sido eliminada correctamente"
        },
        "form": {
          "configuration": "Configuración de la etapa"
        },
        "help": {
          "is_private_node": "Si marcas esta opción como etapa privada, solo las personas asignadas podrán verla y acceder a su información."
        },
        "update": {
          "successfully": "La etapa ha sido actualizada correctamente"
        }
      }
    },
    "yep": "Sí"
  },
  "es-AR": {
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": null,
          "email": null,
          "password": null,
          "password_confirmation": null,
          "remember_me": null
        }
      },
      "models": {
        "user": null
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "Bienvenido %{recipient}!",
          "instruction": "Puedes confirmar tu cuenta a través del siguiente enlace:"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "Hola %{recipient}!",
          "instruction": "Alguien ha solicitado cambiar tu contraseña, puedes hacerlo a través del siguiente enlace.",
          "instruction_2": "Si no solicitaste esto, por favor ignora este e-mail.",
          "instruction_3": "Tu contraseña no cambiará hasta que accedas al siguiente enlace y crees una nueva."
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "Hola %{recipient}!",
          "instruction": "Haz click en el siguiente enlace para desbloquear tu contraseña:",
          "message": "Tu cuenta ha sido bloqueada debido a un excesivo número de intentos inválidos de acceso."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": "Olvidaste tu contraseña?",
          "send_me_reset_password_instructions": "Enviar instrucciones para resetear la contraseña"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Estás seguro/a?",
          "cancel_my_account": "Cancelar mi cuenta",
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": "deja en blanco si no deseas cambiarla",
          "title": "Editar %{resource}",
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos tu contraseña actual para confirmar tus cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Ingresar"
        }
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": "No recibiste instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "No recibiste instrucciones de desbloqueo?",
          "forgot_your_password": "Olvidaste tu contraseña?",
          "sign_in": "Ingresar",
          "sign_in_with_provider": "Ingresar con %{provider}",
          "sign_up": "Registrarse"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones de desbloqueo"
        }
      }
    }
  },
  "es-ES": {
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Contraseña actual",
          "email": "Email",
          "password": "Contraseña",
          "password_confirmation": "Confirmar contraseña",
          "remember_me": "Recordarme"
        }
      },
      "models": {
        "user": "Usuario"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "¡Bienvenid@ %{recipient}!",
          "instruction": "Puedes confirmar el email de tu cuenta a través de este enlace:"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Alguien ha solicitado un enlace para cambiar tu contraseña, lo que se puede realizar con el siguiente enlace.",
          "instruction_2": "Si tú no lo has solicitado, por favor ignora este email.",
          "instruction_3": "Tu contraseña no será cambiada hasta que accedas al enlace y crees una nueva."
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Haz click en el siguiente enlace para desbloquear tu cuenta:",
          "message": "Tu cuenta se ha bloqueado debido a una cantidad excesiva de intentos fallidos para acceder."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambiar tu contraseña",
          "confirm_new_password": "Confirmar nueva contraseña",
          "new_password": "Nueva contraseña"
        },
        "new": {
          "forgot_your_password": "¿Olvidaste tu contraseña?",
          "send_me_reset_password_instructions": "Enviar las instrucciones para resetear mi contraseña"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "¿Estás segur@?",
          "cancel_my_account": "Cancelar mi cuenta",
          "currently_waiting_confirmation_for_email": "Esperando confirmación de: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "déjalo en blanco si no lo quieres cambiar",
          "title": "Editar %{resource}",
          "unhappy": "Descontento",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos tu contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Iniciar sesión"
        }
      },
      "shared": {
        "links": {
          "back": "Volver",
          "didn_t_receive_confirmation_instructions": "¿No has recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "¿No has recibido las instrucciones de desbloqueo?",
          "forgot_your_password": "¿Olvidaste tu contraseña?",
          "sign_in": "Iniciar sesión",
          "sign_in_with_provider": "Iniciar sesión con %{provider}",
          "sign_up": "Registrarse"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones de desbloqueo"
        }
      }
    }
  },
  "es-MX": {
    "active_admin": {
      "any": "Cualquiera",
      "batch_actions": {
        "action_label": "%{title} seleccionados",
        "button_label": "Acciones en masa",
        "default_confirmation": "¿Seguro que quieres hacer esto?",
        "delete_confirmation": "Eliminar %{plural_model}: ¿Está seguro?",
        "labels": {
          "destroy": "Borrar"
        },
        "selection_toggle_explanation": "(Cambiar selección)",
        "succesfully_destroyed": {
          "one": "Se ha destruido 1 %{model} con éxito",
          "other": "Se han destruido %{count} %{plural_model} con éxito"
        }
      },
      "blank_slate": {
        "content": "No hay %{resource_name} aún.",
        "link": "Añadir"
      },
      "cancel": "Cancelar",
      "comments": {
        "add": "Comentar",
        "author": "Autor",
        "body": "Cuerpo",
        "errors": {
          "empty_text": "El comentario no fue guardado, el texto estaba vacío."
        },
        "no_comments_yet": "Aún sin comentarios.",
        "resource": "Recurso",
        "title_content": "Comentarios (%{count})"
      },
      "dashboard": "Inicio",
      "dashboard_welcome": {
        "call_to_action": "Para agregar secciones edite 'app/admin/dashboard.rb'",
        "welcome": "Bienvenido a Active Admin. Esta es la página de inicio predeterminada."
      },
      "delete": "Eliminar",
      "delete_confirmation": "¿Está seguro de que quiere eliminar esto?",
      "delete_model": "Eliminar %{model}",
      "details": "Detalles de %{model}",
      "devise": {
        "change_password": {
          "submit": "Cambiar mi contraseña",
          "title": "Cambie su contraseña"
        },
        "links": {
          "forgot_your_password": "¿Olvidó su contraseña?",
          "sign_in": "Iniciar Sesión",
          "sign_in_with_omniauth_provider": "Conéctate con %{provider}",
          "sign_up": "Registrarse"
        },
        "login": {
          "remember_me": "Recordarme",
          "submit": "Iniciar Sesión",
          "title": "Iniciar Sesión"
        },
        "reset_password": {
          "submit": "Restablecer mi contraseña",
          "title": "¿Olvidó su contraseña?"
        }
      },
      "download": "Descargar:",
      "dropdown_actions": {
        "button_label": "Acciones"
      },
      "edit": "Editar",
      "edit_model": "Editar %{model}",
      "empty": "Vacío",
      "filters": {
        "buttons": {
          "clear": "Quitar Filtros",
          "filter": "Filtrar"
        }
      },
      "has_many_delete": "Eliminar",
      "has_many_new": "Añadir %{model}",
      "has_many_remove": "Quitar",
      "index_list": {
        "block": "Lista",
        "blog": "Blog",
        "grid": "Cuadrícula",
        "table": "Tabla"
      },
      "logout": "Salir",
      "main_content": "Por favor implemente %{model}#main_content para mostrar contenido.",
      "new_model": "Añadir %{model}",
      "next": "Siguiente",
      "pagination": {
        "empty": "No se han encontrado %{model}",
        "entry": {
          "one": null,
          "other": null
        },
        "multiple": "Mostrando %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> de un total de <b>%{total}</b>",
        "one": "Mostrando <b>1</b> %{model}",
        "one_page": "Mostrando <b>un total de %{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Anterior",
      "sidebars": {
        "filters": "Filtros"
      },
      "status_tag": {
        "no": "No",
        "unset": "No",
        "yes": "Sí"
      },
      "view": "Ver"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Contraseña actual",
          "email": "Correo electrónico",
          "password": "Contraseña",
          "password_confirmation": "Confirmación de la contraseña",
          "remember_me": "Recuerdame"
        }
      },
      "models": {
        "user": "Usuario"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Reenviar instrucciones de confirmación"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar mi cuenta",
          "greeting": "¡Bienvenido %{recipient}!",
          "instruction": "Usted puede confirmar el correo electrónico de su cuenta a través de este enlace:"
        },
        "reset_password_instructions": {
          "action": "Cambiar mi contraseña",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Alguien ha solicitado una liga para cambiar su contraseña, lo que se puede realizar a través del siguiente enlace.",
          "instruction_2": "Si usted no lo ha solicitado, por favor ignore este correo electrónico.",
          "instruction_3": "Su contraseña no será cambiada hasta que usted acceda el enlace y cree una nueva contraseña."
        },
        "unlock_instructions": {
          "action": "Desbloquear mi cuenta",
          "greeting": "¡Hola %{recipient}!",
          "instruction": "Haga click en el siguiente enlace para desbloquear su cuenta:",
          "message": "Su cuenta ha sido bloqueada debido a una cantidad excesiva de intentos infructuosos para ingresar."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Cambiar mi contraseña",
          "change_your_password": "Cambie su contraseña",
          "confirm_new_password": "Confirme la nueva contraseña",
          "new_password": "Nueva contraseña"
        },
        "new": {
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "send_me_reset_password_instructions": "Envíame las instrucciones para establecer mi nueva contraseña"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "¿Está usted seguro?",
          "cancel_my_account": "Eliminar mi cuenta",
          "currently_waiting_confirmation_for_email": "Actualmente esperando la confirmacion de: %{email} ",
          "leave_blank_if_you_don_t_want_to_change_it": "dejar en blanco si no desea cambiarlo",
          "title": "Editar %{resource}",
          "unhappy": "No se encuentra feliz",
          "update": "Actualizar",
          "we_need_your_current_password_to_confirm_your_changes": "necesitamos su contraseña actual para confirmar los cambios"
        },
        "new": {
          "sign_up": "Registrarse"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Iniciar sésion"
        }
      },
      "shared": {
        "links": {
          "back": "Regresar",
          "didn_t_receive_confirmation_instructions": "¿No ha recibido las instrucciones de confirmación?",
          "didn_t_receive_unlock_instructions": "No ha recibido instrucciones para desbloquear?",
          "forgot_your_password": "¿Ha olvidado su contraseña?",
          "sign_in": "Iniciar sésion",
          "sign_in_with_provider": "Iniciar sésion con %{provider}",
          "sign_up": "Registrarse"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instrucciones para desbloquear"
        }
      }
    }
  },
  "et": {
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Praegune parool",
          "email": "E-post",
          "password": "Parool",
          "password_confirmation": "Parooli kinnitus",
          "remember_me": "Hoia mind meeles"
        }
      },
      "models": {
        "user": "Kasutaja"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Saada kinnitusjuhend uuesti"
        }
      },
      "failure": {
        "invited": "Sul on kutse ootel - aktsepteeri, et konto loomine lõpule viia."
      },
      "invitations": {
        "edit": {
          "header": "Salasõna sättimine",
          "submit_button": "Säti mu salasõna"
        },
        "invitation_removed": "Sinu kutse eemaldati.",
        "invitation_token_invalid": "Antud kutse ei ole kehtiv!",
        "new": {
          "header": "Kutse saatmine",
          "submit_button": "Saada kutse"
        },
        "no_invitations_remaining": "Kutseid pole rohkem järgi.",
        "send_instructions": "Kutse on saadetud emailile %{email}.",
        "updated": "Sinu salasõna on edukalt sätitud. Oled nüüd sisse logitud."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Kinnita konto",
          "greeting": "Teretulemast %{recipient}!",
          "instruction": "Oma konto saad kinnitada alloleva lingi kaudu:"
        },
        "invitation_instructions": {
          "accept": "Võta kutse vastu",
          "hello": "Tere, %{email}",
          "ignore": "Kui Sa ei soovi kutset vastu võtta, siis lihtsalt ignoreeri seda emaili.<br />Sinu kontot ei looda enne, kui oled ülalolevat linki külastanud ja oma salasõna määranud.",
          "someone_invited_you": "Keegi kutsus Sind aadressile %{url}. Kutse saad vastu võtta allolevalt lingilt.",
          "subject": "Kutse juhised"
        },
        "reset_password_instructions": {
          "action": "Muuda parooli",
          "greeting": "Tere %{recipient}!",
          "instruction": "Keegi on soovinud muuta sinu parooli, saad seda teha alloleva lingi kaudu.",
          "instruction_2": "Kui sa ei ole seda soovinud, palun ignoreeri seda kirja.",
          "instruction_3": "Sinu parool ei muutu enne kui sa oled külastanud eelolevat linki ja uue parooli sisestanud."
        },
        "unlock_instructions": {
          "action": "Ava konto",
          "greeting": "Tere %{recipient}!",
          "instruction": "Vajuta allolevale lingile, et oma konto avada",
          "message": "Sinu konto on lukustatud liigsete ebaõnnestunud sisselogimiskatsete tõttu"
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Muuda parooli",
          "change_your_password": "Muuda oma parool",
          "confirm_new_password": "Kinnita uus parool",
          "new_password": "Uus parool"
        },
        "new": {
          "forgot_your_password": "Unustasid oma parooli?",
          "send_me_reset_password_instructions": "Saada parooli ennistamise juhend"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Oled sa kindel?",
          "cancel_my_account": "Kustuta konto",
          "currently_waiting_confirmation_for_email": "Kinnituse ootel: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "jäta tühjaks, kui sa ei soovi seda muuta",
          "title": "Muuda %{resource}",
          "unhappy": "Õnnetu",
          "update": "Uuenda",
          "we_need_your_current_password_to_confirm_your_changes": "meil on vaja sinu praegust parooli, et muutused kinnitada"
        },
        "new": {
          "sign_up": "Loo konto"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Logi sisse"
        }
      },
      "shared": {
        "links": {
          "back": "Tagasi",
          "didn_t_receive_confirmation_instructions": "Ei saanud kinnitusjuhiseid?",
          "didn_t_receive_unlock_instructions": "Ei saanud konto avamise juhiseid?",
          "forgot_your_password": "Unustasid oma parooli?",
          "sign_in": "Logi sisse",
          "sign_in_with_provider": "Logi sisse %{provider}-ga",
          "sign_up": "Loo konto"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Saada konto avamise juhised uuesti"
        }
      }
    },
    "numbers": {
      "billions": {
        "one": "miljard",
        "other": "miljardit"
      },
      "decillions": {
        "one": "dekiljon",
        "other": "dekiljonit"
      },
      "hundreds": "sada",
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillion",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "millions": {
        "one": "miljon",
        "other": "miljonit"
      },
      "nonillions": {
        "one": "noniljon",
        "other": "noniljonit"
      },
      "octillions": {
        "one": "oktiljon",
        "other": "oktiljonit"
      },
      "ones": [
        "null",
        "üks",
        "kaks",
        "kolm",
        "neli",
        "viis",
        "kuus",
        "seitse",
        "kaheksa",
        "üheksa"
      ],
      "quadrillions": {
        "one": "kvadriljon",
        "other": "kvadriljonit"
      },
      "quintillions": {
        "one": "kvintiljon",
        "other": "kvintiljonit"
      },
      "septillions": {
        "one": "septiljon",
        "other": "septiljonit"
      },
      "sextillions": {
        "one": "sekstiljon",
        "other": "sekstiljonit"
      },
      "teens": [
        "_",
        "üksteist",
        "kaksteist",
        "kolmteist",
        "neliteist",
        "viisteist",
        "kuusteist",
        "seitseteist",
        "kaheksateist",
        "üheksateist"
      ],
      "tens": [
        "_",
        "kümme",
        "kakskümmend",
        "kolmkümmend",
        "nelikümmend",
        "viiskümmend",
        "kuuskümmend",
        "seitsekümmend",
        "kaheksakümmend",
        "üheksakümmend"
      ],
      "thousands": "tuhat",
      "trillions": {
        "one": "triljon",
        "other": "triljonit"
      }
    }
  },
  "fa": {
    "active_admin": {
      "access_denied": {
        "message": "شما دسترسی لازم برای انجام این عملیات را ندارید."
      },
      "any": "هرکدام",
      "batch_actions": {
        "action_label": "%{title} انتخاب شده است",
        "button_label": "عملیات‌های دسته‌ای",
        "default_confirmation": "آیا برای اجرای این عملیات اطمینان دارید؟",
        "delete_confirmation": "آیا برای حذف همه رکوردهای %{plural_model} اطمینان دارید؟",
        "labels": {
          "destroy": "حذف"
        },
        "selection_toggle_explanation": "(انتخاب‌ها برعکس شوند)",
        "succesfully_destroyed": {
          "one": "1 %{model} با موفقیت حذف شد",
          "other": "%{count} %{plural_model} با موفقت حذف شدند."
        }
      },
      "blank_slate": {
        "content": "هنوز هیچ رکوردی از %{resource_name} درج نشده.",
        "link": "درج اولین رکورد"
      },
      "cancel": "لغو",
      "comments": {
        "add": "افزودن کامنت",
        "author": "ایجاد کننده",
        "author_missing": "بی‌نام",
        "author_type": "نوع ایجاد کننده",
        "body": "بدنه",
        "errors": {
          "empty_text": "کامنت درج نشد، متن کامنت خالی بود."
        },
        "no_comments_yet": "هنوز هیچ کامنتی نوشته نشده.",
        "resource": "رکورد",
        "resource_type": "نوع رکورد",
        "title_content": "کامنت‌ها (%{count})"
      },
      "dashboard": "داشبرد",
      "dashboard_welcome": {
        "call_to_action": "برای اضافه کردن قسمت‌هایی به داشبرد اینجا را چک کنید: 'app/admin/dashboard.rb'",
        "welcome": "به اکتیو ادمین خوش آمدید. این صفحه اول داشبرد است."
      },
      "delete": "حذف",
      "delete_confirmation": "آیا برای حذف این آیتم اطمینان دارید؟",
      "delete_model": "حذف %{model}",
      "details": "جزئیات %{model}",
      "devise": {
        "change_password": {
          "submit": "تغییر کلمه عبور",
          "title": "تغییر کلمه عبور"
        },
        "email": {
          "title": "ایمیل"
        },
        "links": {
          "forgot_your_password": "کلمه عبور را فراموش کرده‌اید؟",
          "sign_in": "ورود",
          "sign_in_with_omniauth_provider": "ورود با حساب %{provider}"
        },
        "login": {
          "remember_me": "مرا به خاطر بسپار",
          "submit": "ورود",
          "title": "ورود"
        },
        "password": {
          "title": "کلمه‌عبور"
        },
        "resend_confirmation_instructions": {
          "submit": "ارسال مجدد تاییدیه ایمیل",
          "title": "ارسال مجدد تاییدیه ایمیل"
        },
        "reset_password": {
          "submit": "دریافت کلمه عبور جدید",
          "title": "کلمه عبور را فراموش کرده‌اید؟"
        },
        "sign_up": {
          "submit": "ثبت‌نام",
          "title": "ثبت‌نام"
        },
        "subdomain": {
          "title": "Subdomain"
        },
        "unlock": {
          "submit": "ارسال مجدد دستورالعمل بازگشایی حساب کاربری",
          "title": "ارسال مجدد دستورالعمل بازگشایی حساب کاربری"
        },
        "username": {
          "title": "نام کاربری"
        }
      },
      "download": "دریافت:",
      "dropdown_actions": {
        "button_label": "عملیات"
      },
      "edit": "ویرایش",
      "edit_model": "ویرایش %{model}",
      "empty": "خالی",
      "filters": {
        "buttons": {
          "clear": "پاک کردن فیلتر",
          "filter": "فیلتر"
        }
      },
      "has_many_delete": "حذف",
      "has_many_new": "اضافه کردن %{model} جدید",
      "has_many_remove": "حذف",
      "index_list": {
        "block": "لیست",
        "blog": "وبلاگ",
        "grid": "گرید",
        "table": "جدول"
      },
      "logout": "خروج",
      "main_content": "لطفا %{model}#main_content را پیاده سازی کنید تا محتوی نمایش داده شود.",
      "new_model": "%{model} جدید",
      "next": "بعدی",
      "pagination": {
        "empty": "هیچ رکورد %{model} یافت نشد",
        "entry": {
          "one": "آیتم",
          "other": "آیتم‌ها"
        },
        "multiple": "نمایش %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> از کل <b>%{total}</b> رکورد",
        "multiple_without_total": "نمایش %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "نمایش <b>1</b> %{model}",
        "one_page": "نمایش <b>همه %{n}</b> %{model}"
      },
      "powered_by": "قدرت گرفته از %{active_admin} %{version}",
      "previous": "قبلی",
      "sidebars": {
        "filters": "فیلتر‌ها"
      },
      "status_tag": {
        "no": "بدون",
        "unset": "بدون",
        "yes": "بله"
      },
      "view": "نمایش"
    },
    "devise": {
      "failure": {
        "expired": "حساب شما به دلیل عدم فعالیت منقضی شده است، لطفاً با مدیر سایت تماس بگیرید.",
        "invited": "شما یک دعوت نامه در حال انتظار دارید، با قبول آن حساب خود را بسازید.",
        "session_limited": "از اطلاعات ورود شما در مرورگر دیگری استفاده شده است، برای ادامه در این مرورگر لطفاً دوباره وارد سیستم شوید"
      },
      "invalid_captcha": "اطلاعات وارد شده در کپچا نامعتبر بود",
      "invalid_security_question": "پاسخ سوال امنیتی نامعتبر بود",
      "invitations": {
        "edit": {
          "header": "رمز عبور انتخاب کنید",
          "submit_button": "رمز عبور ذخیره کن"
        },
        "invitation_removed": "دعوت نامه شما حذف شده.",
        "invitation_token_invalid": "کد دعوت نامه معتبر نیست!",
        "new": {
          "header": "فرستادن دعوت نامه",
          "submit_button": "فرستادن دعوت نامه"
        },
        "no_invitations_remaining": "دعوت نامه ای نمانده",
        "send_instructions": "یک ایمیل دعوت نامه به %{email} ارسال شد.",
        "updated": "رمز عبور شما ذخیره شد. شما وارد سایت شدید!",
        "updated_not_active": "رمز عبور شما ذخیره شد."
      },
      "mailer": {
        "invitation_instructions": {
          "accept": "قبول دعوت",
          "accept_until": "این دعوت نامه تا تاریخ %{due_date} اعتبار دارد.",
          "hello": "سلام %{email}",
          "ignore": "اگر نمی خواهید این دعوت را قبول کنید, لطفا این ایمیل را نادیده بگیرید.<br />تا وقتی که بر روی لینک بالا کلیک نکنید، حساب شما ساخته نخواهد شد.",
          "someone_invited_you": "شما به %{url} دعوت شدید. لینک زیر را استفاده کنید تا حساب شما فعال شود.",
          "subject": "شما دعوت شدید!"
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "ارسال",
          "submit_verification_code": "ارسال کد تاییدیه",
          "verification_code": "کد تاییدیه"
        },
        "updated": "کد تأیید پذیرفته شد"
      },
      "paranoid_verify": {
        "code_required": "لطفاً کدی را که تیم پشتیبانی ما ارائه کرده است وارد کنید"
      },
      "password_expired": {
        "change_required": "رمز عبور شما منقضی شده است ،لطفاً رمز خود را تمدید کنید",
        "show": {
          "change_my_password": "تغییر رمز عبور",
          "current_password": "رمز عبور جاری",
          "new_password": "رمز عبور جدید",
          "new_password_confirmation": "تکرار رمز جدید",
          "renew_your_password": "ساختن رمز عبور جدید"
        },
        "updated": "رمز جدید شما ذخیره شده است"
      }
    },
    "errors": {
      "messages": {
        "equal_to_current_password": "باید متفاوت با رمز عبور فعلی باشد",
        "equal_to_email": "باید متفاوت از ایمیل باشد",
        "password_complexity": {
          "digit": {
            "one": "باید حداقل یک رقم داشته باشد",
            "other": "باید حداقل %{count} عدد داشته باشد"
          },
          "lower": {
            "one": "باید حداقل شامل یک حرف کوچک باشد",
            "other": "باید حداقل %{count} حروف کوچک داشته باشد"
          },
          "symbol": {
            "one": "باید حداقل دارای یک علامت یا کارکتر خاص باشد",
            "other": "باید حداقل دارای %{count} علائم یا کارکتر های خاص باشد"
          },
          "upper": {
            "one": "باید حداقل یک حرف بزرگ داشته باشد",
            "other": "باید حداقل %{count} حروف بزرگ داشته باشد"
          }
        },
        "taken_in_past": "قبلا استفاده شده است"
      }
    },
    "ransack": {
      "all": "همه",
      "and": "و",
      "any": "هر کدام",
      "asc": "صعودی",
      "attribute": "ویژگی",
      "combinator": "ترکیب کننده",
      "condition": "شرایط",
      "desc": "نزولی",
      "or": "یا",
      "predicate": "پیش فرض",
      "predicates": {
        "blank": "خالی است",
        "cont": "حاوی",
        "cont_all": "حاوی همه",
        "cont_any": "حاوی حداقل یکی",
        "does_not_match": "بدون شباهت",
        "does_not_match_all": "شبیه هیچ کدام نیست",
        "does_not_match_any": "شبیه یکی هم نیست",
        "end": "به پایان می رسد با",
        "end_all": "به پایان می رسد با  همه",
        "end_any": "به پایان می رسد با حداقل یکی",
        "eq": "مساوی با",
        "eq_all": "مساوی با همه",
        "eq_any": "مساوی با حداقل یکی",
        "false": "نادرست است",
        "gt": "بیشتر از",
        "gt_all": "بیشتر از همه",
        "gt_any": "بیشتر از حداقل یکی",
        "gteq": "بیشتر یا مساوی با",
        "gteq_all": "بیشتر یا مساوی با همه",
        "gteq_any": "بیشتر یا مساوی با حداقل یکی",
        "in": "در",
        "in_all": "در همه",
        "in_any": "در حداقل یکی",
        "lt": "کمتر از",
        "lt_all": "کمتر از همه",
        "lt_any": "کمتر از حداقل یکی",
        "lteq": "کمتر یا مساوی با",
        "lteq_all": "کمتر یا مساوی با همه",
        "lteq_any": "کمتر یا مساوی با حداقل یکی",
        "matches": "مشابهات",
        "matches_all": "شبیه همه",
        "matches_any": "شبیه حداقل یکی",
        "not_cont": "حاوی این نمیشود",
        "not_cont_all": "حاوی هیچ کدام نمیشود",
        "not_cont_any": "حاوی حتی یکی هم نمیشود",
        "not_end": "پایان نمی یابد با",
        "not_end_all": "پایان نمی یابد با هیچ کدام",
        "not_end_any": "پایان نمی یابد با حتی یکی",
        "not_eq": "غیر مساوی با",
        "not_eq_all": "غیر مساوی با همه",
        "not_eq_any": "غیر مساوی با هیچ کدام",
        "not_in": "نه در",
        "not_in_all": "در هیچ کدام",
        "not_in_any": "نه حتی در یکی",
        "not_null": "صفر نیست",
        "not_start": "شروع نمی شود با",
        "not_start_all": "شروع نمی شود با هیچ کدام",
        "not_start_any": "شروع نمی شود با حتی یکی",
        "null": "صفر است",
        "present": "موجود است",
        "start": "شروع می شود با",
        "start_all": "شروع می شود با همه",
        "start_any": "شروع می شود با حداقل یکی",
        "true": "درست است"
      },
      "search": "جستجو",
      "sort": "مرتب سازی",
      "value": "مقدار"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        }
      }
    }
  },
  "fi": {
    "active_admin": {
      "access_denied": {
        "message": "Sinulla ei ole oikeuksia suorittaa yrittämääsi toimintoa."
      },
      "any": "mikä vain",
      "batch_actions": {
        "action_label": "%{title} Valittu",
        "button_label": "Toimet",
        "default_confirmation": "Oletko varma, että haluat tehdä tämän?",
        "delete_confirmation": "Oletko varma, että haluat poistaa nämä %{plural_model}:t?",
        "labels": {
          "destroy": "Poista"
        },
        "selection_toggle_explanation": "(Vaihda valintaa)",
        "succesfully_destroyed": {
          "one": "1 %{model} poistettu",
          "other": "%{count} %{plural_model}:a poistettu"
        }
      },
      "blank_slate": {
        "content": "Järjestelmässä ei ole yhtään %{resource_name}:ia vielä.",
        "link": "Luo ensimmäinen"
      },
      "cancel": "Peruuta",
      "comments": {
        "add": "Lisää kommentti",
        "author": "Luoja",
        "author_type": "Luoja-tyyppi",
        "body": "Runko",
        "errors": {
          "empty_text": "Kommenttia ei pystytty tallentamaan, et kirjoittanut kommenttitekstiä."
        },
        "no_comments_yet": "Ei kommentteja.",
        "resource": "Resurssi",
        "resource_type": "Resurssityyppi",
        "title_content": "Kommentteja (%{count})"
      },
      "dashboard": "Etusivu",
      "dashboard_welcome": {
        "call_to_action": "Lisätäksesi etusivun osioita katso: 'app/admin/dashboard.rb'",
        "welcome": "Tervetuloa! Tämä on Active Adminin oletusetusivu."
      },
      "delete": "Poista",
      "delete_confirmation": "Oletko varma, että haluat poistaa tämän?",
      "delete_model": "Poista %{model}",
      "details": "%{model} Tiedot",
      "devise": {
        "change_password": {
          "submit": "Vaihda salasana",
          "title": "Vaihda salasana"
        },
        "email": {
          "title": "Sähköposti"
        },
        "links": {
          "forgot_your_password": "Unohtunut salasana?",
          "sign_in": "Kirjaudu sisään",
          "sign_in_with_omniauth_provider": "Kirjaudu sisään %{provider}:ia käyttäen"
        },
        "login": {
          "remember_me": "Muista minut",
          "submit": "Kirjaudu sisään",
          "title": "Sisäänkirjautuminen"
        },
        "password": {
          "title": "Salasana"
        },
        "reset_password": {
          "submit": "Resetoi salasana",
          "title": "Unohtunut salasana?"
        },
        "subdomain": {
          "title": "Subdomain"
        },
        "unlock": {
          "submit": "Lähetä ohjeet lukituksen poistoon",
          "title": "Lähetä ohjeet lukituksen poistoon"
        },
        "username": {
          "title": "Käyttäjänimi"
        }
      },
      "download": "Lataa:",
      "dropdown_actions": {
        "button_label": "Acciones"
      },
      "edit": "Muokkaa",
      "edit_model": "Muokkaa %{model}",
      "empty": "Tyhjä",
      "filters": {
        "buttons": {
          "clear": "Tyhjennä valinnat",
          "filter": "Hae"
        }
      },
      "has_many_delete": "Poista",
      "has_many_new": "Lisää uusi %{model}",
      "has_many_remove": "Poista",
      "index_list": {
        "block": "Lista",
        "blog": "Blogi",
        "grid": "Ruudukko",
        "table": "Taulukko"
      },
      "logout": "Kirjaudu ulos",
      "main_content": "Ole hyvä, käytä %{model}#main_content:ia nähdäksesi jotain.",
      "new_model": "Uusi %{model}",
      "next": "Seuraava",
      "pagination": {
        "empty": "%{model}:ia ei löytynyt",
        "entry": {
          "one": "syöte",
          "other": "syötteet"
        },
        "multiple": "Näytetään %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> (yhteensä <b>%{total}</b>)",
        "multiple_without_total": "Näytetään %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Näytetään <b>1</b> %{model}",
        "one_page": "Näytetään <b>kaikki %{n}</b> %{model}:it"
      },
      "powered_by": "Käyttää %{active_admin} %{version}:ia",
      "previous": "Edellinen",
      "sidebars": {
        "filters": "Haku"
      },
      "status_tag": {
        "no": "Ei",
        "unset": "Ei",
        "yes": "Kyllä"
      },
      "view": "Katso"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": null,
          "email": null,
          "password": null,
          "password_confirmation": null,
          "remember_me": null
        }
      },
      "models": {
        "user": null
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Uudelleenlähetä vahvistusohjeet"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Vahvista tilini",
          "greeting": "Tervetuloa, %{recipient}!",
          "instruction": "Vahvista sähköpostisi painamalla alla olevaa linkkiä:"
        },
        "reset_password_instructions": {
          "action": "Vaihda salasanani",
          "greeting": "Hei, %{recipient}!",
          "instruction": "Joku on pyytänyt tilisi salasanan vaihtoa. Tämä voidaan suorittaa painamalla linkkiä alla.",
          "instruction_2": "Jos et pyytänyt tätä, älä huomioi tätä sähköpostia.",
          "instruction_3": "Salasanaasi ei vaihdeta ennen kuin painat yllä olevaa linkkiä ja syötät uuden salasanan."
        },
        "unlock_instructions": {
          "action": "Poista tilini lukitus",
          "greeting": "Hei, %{recipient}!",
          "instruction": "Paina alla olevaa linkkiä poistaaksesi lukituksen:",
          "message": "Tilisi on lukittu johtuen liian useasta epäonnistuneesta kirjautumisyrityksestä."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": "Unohditko salasanasi?",
          "send_me_reset_password_instructions": "Lähetä minulle salasanan vaihto-ohjeet"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Oletko varma?",
          "cancel_my_account": "Poista tilini",
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": "jätä tämä tyhjäksi, mikäli et halua vaihtaa",
          "title": "Muokkaa %{resource}",
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": "syötä nykyinen salasanasi"
        },
        "new": {
          "sign_up": "Rekisteröidy"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Kirjaudu sisään"
        }
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": "Vahvistusviesti ei saapunut perille?",
          "didn_t_receive_unlock_instructions": "Salasanan vaihto -ohjeet eivät saapuneet perille?",
          "forgot_your_password": "Unohditko salasanasi?",
          "sign_in": "Kirjaudu sisään",
          "sign_in_with_provider": "Kirjaudu sisään (%{provider})",
          "sign_up": "Rekisteröidy"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Uudelleen lähetä lukituksen poisto -ohjeet"
        }
      }
    },
    "ransack": {
      "all": "kaikki",
      "and": "ja",
      "any": "jokin",
      "asc": "nouseva",
      "attribute": "attribuutti",
      "combinator": "kombinaattori",
      "condition": "ehto",
      "desc": "laskeva",
      "or": "tai",
      "predicate": "predikaatti",
      "predicates": {
        "blank": "on tyhjä",
        "cont": "sisältää",
        "cont_all": "sisältää kaikki",
        "cont_any": "sisältää jonkin",
        "does_not_match": "ei täsmää",
        "does_not_match_all": "ei täsmää kaikkien kanssa",
        "does_not_match_any": "ei täsmää minkään kanssa",
        "end": "päättyy",
        "end_all": "päättyy millään",
        "end_any": "päättyy jollakin",
        "eq": "sama kuin",
        "eq_all": "sama kuin kaikki",
        "eq_any": "sama kuin jokin",
        "false": "ei ole tosi",
        "gt": "suurempi kuin",
        "gt_all": "suurempi kuin mikään",
        "gt_any": "suurempi kuin jokin",
        "gteq": "suurempi tai yhtä suuri kuin",
        "gteq_all": "suurempi tai yhtä suuri kuin mikään",
        "gteq_any": "suurempi tai yhtä suuri kuin jokin",
        "in": "kohteessa",
        "in_all": "kaikissa kohteissa",
        "in_any": "jossakin kohteessa",
        "lt": "vähemmän kuin",
        "lt_all": "vähemmän kuin mikään",
        "lt_any": "vähemmän kuin jokin",
        "lteq": "vähemmän tai sama kuin",
        "lteq_all": "vähemmän tai sama kuin mikään",
        "lteq_any": "vähemmän tai sama kuin jokin",
        "matches": "täsmää",
        "matches_all": "täsmää kaikkien kanssa",
        "matches_any": "täsmää jonkun kanssa",
        "not_cont": "ei sisällä",
        "not_cont_all": "ei sisällä mitään",
        "not_cont_any": "ei sisällä jotakin",
        "not_end": "ei pääty",
        "not_end_all": "ei pääty millään",
        "not_end_any": "ei pääty jollakin",
        "not_eq": "eri kuin",
        "not_eq_all": "eri kuin kaikki",
        "not_eq_any": "eri kuin jokin",
        "not_in": "ei kohteessa",
        "not_in_all": "ei missään kohteista",
        "not_in_any": "ei jossakin kohteista",
        "not_null": "on määritetty",
        "not_start": "ei ala",
        "not_start_all": "ei ala millään",
        "not_start_any": "ei ala jollakin",
        "null": "on määrittämätön",
        "present": "on läsnä",
        "start": "alkaa",
        "start_all": "alkaa kaikilla",
        "start_any": "alkaa jollakin",
        "true": "on tosi"
      },
      "search": "haku",
      "sort": "järjestys",
      "value": "arvo"
    }
  },
  "fr": {
    "active_admin": {
      "access_denied": {
        "message": "Vous n'êtes pas autorisé à exécuter cette action"
      },
      "any": "N'importe lequel",
      "batch_actions": {
        "action_label": "%{title} les éléments sélectionnés",
        "button_label": "Actions groupées",
        "default_confirmation": "Voulez-vous vraiment faire cela ?",
        "delete_confirmation": "Voulez-vous vraiment supprimer ces %{plural_model} ?",
        "labels": {
          "destroy": "Supprimer"
        },
        "selection_toggle_explanation": "(Inverser la sélection)",
        "succesfully_destroyed": {
          "one": "1 %{model} supprimé",
          "other": "%{count} %{plural_model} supprimés"
        }
      },
      "blank_slate": {
        "content": "Il n'y a pas encore de %{resource_name}.",
        "link": "Créez en un"
      },
      "cancel": "Annuler",
      "comments": {
        "add": "Ajouter un commentaire",
        "author": "Auteur",
        "author_missing": "Anonyme",
        "author_type": "Profil de l'auteur",
        "body": "Corps",
        "created_at": "Créé le",
        "delete": "Supprimer ce commentaire",
        "delete_confirmation": "Voulez-vous vraiment supprimer ce commentaire ?",
        "errors": {
          "empty_text": "Le commentaire n'a pas été enregistré puisque le texte était vide."
        },
        "no_comments_yet": "Aucun commentaire actuellement",
        "resource": "Ressource",
        "resource_type": "Type de ressource",
        "title_content": "Commentaires (%{count})"
      },
      "create_another": "Créer autre %{model}",
      "dashboard": "Tableau de bord",
      "dashboard_welcome": {
        "call_to_action": "Pour ajouter des sections au tableau de bord, consultez 'app/admin/dashboard.rb'",
        "welcome": "Bienvenue dans Active Admin. Ceci est la page par défaut."
      },
      "delete": "Supprimer",
      "delete_confirmation": "Voulez-vous vraiment supprimer ceci ?",
      "delete_model": "Supprimer %{model}",
      "details": "Détails de %{model}",
      "devise": {
        "change_password": {
          "submit": "Changer mon mot de passe",
          "title": "Changez votre mot de passe"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Vous avez oublié votre mot de passe ?",
          "resend_confirmation_instructions": "Renvoyer les instructions de confirmation",
          "resend_unlock_instructions": "Renvoyer les informations de déverrouillage",
          "sign_in": "Connectez-vous",
          "sign_in_with_omniauth_provider": "Connectez-vous avec %{provider}",
          "sign_up": "Inscrivez-vous"
        },
        "login": {
          "remember_me": "Garder ma session ouverte",
          "submit": "Se connecter",
          "title": "Connexion"
        },
        "password": {
          "title": "Mot de passe"
        },
        "resend_confirmation_instructions": {
          "submit": "Renvoyer les instructions de confirmation",
          "title": "Renvoyer les instructions de confirmation"
        },
        "reset_password": {
          "submit": "Réinitialiser mon mot de passe",
          "title": "Vous avez oublié votre mot de passe ?"
        },
        "sign_up": {
          "submit": "S'inscrire",
          "title": "S'inscrire"
        },
        "subdomain": {
          "title": "Sous-domaine"
        },
        "unlock": {
          "submit": "Renvoyer les informations de déverrouillage",
          "title": "Renvoyer les informations de déverrouillage"
        },
        "username": {
          "title": "Nom d'utilisateur"
        }
      },
      "download": "Télécharger :",
      "dropdown_actions": {
        "button_label": "Actions"
      },
      "edit": "Modifier",
      "edit_model": "Modifier %{model}",
      "empty": "Vide",
      "filters": {
        "buttons": {
          "clear": "Supprimer les filtres",
          "filter": "Filtrer"
        },
        "predicates": {
          "from": "De",
          "to": "À"
        }
      },
      "has_many_delete": "Supprimer",
      "has_many_new": "Ajouter un(e) %{model}",
      "has_many_remove": "Enlever",
      "index_list": {
        "block": "Liste",
        "blog": "Blog",
        "grid": "Grille",
        "table": "Tableau"
      },
      "logout": "Déconnexion",
      "main_content": "Veuillez implémenter %{model}#main_content pour afficher le contenu.",
      "new_model": "Créer %{model}",
      "next": "Suivant",
      "pagination": {
        "empty": "Aucun(e) %{model} trouvé(e)",
        "entry": {
          "one": "entrée",
          "other": "entrées"
        },
        "multiple": "Affichage de %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> sur un total de <b>%{total}</b>",
        "multiple_without_total": "Affichage de %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Affichage de <b>1</b> %{model}",
        "one_page": "Affichage des <b>%{n}</b> %{model}",
        "per_page": "Par page: "
      },
      "powered_by": "Propulsé par %{active_admin} %{version}",
      "previous": "Précédent",
      "search_status": {
        "current_filters": "Filtres actuels :",
        "current_scope": "Périmètre :",
        "headline": "Statut de la recherche :",
        "no_current_filters": "Aucun filtre"
      },
      "sidebars": {
        "filters": "Filtres",
        "search_status": "Statut de la recherche"
      },
      "status_tag": {
        "no": "Non",
        "unset": "Non",
        "yes": "Oui"
      },
      "unsupported_browser": {
        "headline": "Veuillez noter que ActiveAdmin ne supporte plus les versions d'Internet Explorer 8 ou moins.",
        "recommendation": "Nous vous recommandons de <a href=\"http://browsehappy.com/\">mettre à jour votre navigateur</a> pour améliorer votre expérience.",
        "turn_off_compatibility_view": "Si vous utilisez IE 9 ou une version ultérieure, assurez-vous d'<a href=\"https://support.microsoft.com/fr-fr/help/17471\">activer \"Affichage de compatibilité\"</a>."
      },
      "view": "Voir"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Mot de passe actuel",
          "email": "Courriel",
          "password": "Mot de passe",
          "password_confirmation": "Confirmation du mot de passe",
          "remember_me": "Se souvenir de moi"
        }
      },
      "models": {
        "user": "Utilisateur"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Renvoyer les instructions de confirmation"
        }
      },
      "failure": {
        "expired": "Votre compte a expiré pour cause d'inactivité. Veuillez contacter l'administrateur du site",
        "invited": "Vous avez une invitation en attente, acceptez-la pour terminer la création de votre compte.",
        "session_limited": "Vos identifiants de connexion ont été utilisés dans un autre navigateur. Veuillez vous reconnecter pour continuer dans ce navigateur"
      },
      "invalid_captcha": "Le captcha n'est pas valide",
      "invalid_security_question": "La réponse à la question de sécurité est invalide",
      "invitations": {
        "edit": {
          "header": "Définissez votre mot de passe",
          "submit_button": "Définir mon mot de passe"
        },
        "invitation_removed": "Votre invitation a été supprimée.",
        "invitation_token_invalid": "Le jeton d'invitation fourni n'est pas valide !",
        "new": {
          "header": "Nouvel utilisateur",
          "submit_button": "Envoyer"
        },
        "no_invitations_remaining": "Il n'y a plus d'invitations restantes.",
        "send_instructions": "Un e-mail d'invitation a été envoyé à %{email}.",
        "updated": "Votre mot de passe a été défini avec succès. Vous êtes maintenant connecté.",
        "updated_not_active": "Votre mot de passe a été défini avec succès."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmer mon courriel",
          "greeting": "Bienvenue %{recipient}!",
          "instruction": "Vous pouvez confirmer votre courriel grâce au lien ci-dessous:"
        },
        "invitation_instructions": {
          "accept": "Accepter l'invitation",
          "accept_until": "Cette invitation sera valable jusqu'au %{due_date}.",
          "hello": "Bonjour %{email}",
          "ignore": "Si vous ne souhaitez pas accepter cette invitation, veuillez ignorer cet e-mail. Votre compte ne sera pas créé tant que vous n'aurez pas cliqué sur le lien ci-dessous et défini votre mot de passe.",
          "someone_invited_you": "Vous avez été invité à rejoindre %{url}, vous pouvez accepter cette invitation via le lien ci-dessous.",
          "subject": "Vous avez reçu une invitation"
        },
        "reset_password_instructions": {
          "action": "Changer mon mot de passe",
          "greeting": "Bonjour %{recipient}!",
          "instruction": "Quelqu'un a demandé un lien pour changer votre mot de passe, le voici :",
          "instruction_2": "Si vous n'avez pas émis cette demande, merci d'ignorer ce courriel.",
          "instruction_3": "Votre mot de passe ne changera pas tant que vous n'aurez pas cliqué sur ce lien et renseigné un nouveau mot de passe."
        },
        "unlock_instructions": {
          "action": "Débloquer mon compte",
          "greeting": "Bonjour %{recipient}!",
          "instruction": "Suivez ce lien pour débloquer votre compte:",
          "message": "Votre compte a été bloqué suite à un nombre d'essais de connexions manquées trop important"
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Soumettre",
          "submit_verification_code": "Soumettre le code de vérification",
          "verification_code": "Code de vérification"
        },
        "updated": "Code de vérification accepté"
      },
      "paranoid_verify": {
        "code_required": "Veuillez entrer le code fourni par notre équipe de support"
      },
      "password_expired": {
        "change_required": "Votre mot de passe a expiré. Veuillez en choisir un autre",
        "show": {
          "change_my_password": "Changer mon mot de passe",
          "current_password": "Mot de passe actuel",
          "new_password": "Nouveau mot de passe",
          "new_password_confirmation": "Confirmer le nouveau mot de passe",
          "renew_your_password": "Renouveler votre mot de passe"
        },
        "updated": "Votre nouveau mot de passe est enregistré"
      },
      "passwords": {
        "edit": {
          "change_my_password": "Changer mon mot de passe",
          "change_your_password": "Changer votre mot de passe",
          "confirm_new_password": "Confirmez votre nouveau mot de passe",
          "new_password": "Nouveau mot de passe"
        },
        "new": {
          "forgot_your_password": "Mot de passe oublié ?",
          "send_me_reset_password_instructions": "Envoyez-moi des instructions pour réinitialiser mon mot de passe"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Êtes-vous sûr ?",
          "cancel_my_account": "Supprimer mon compte",
          "currently_waiting_confirmation_for_email": "Confirmation en attente pour: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "laissez ce champ vide pour le laisser inchangé",
          "title": "Éditer %{resource}",
          "unhappy": "Pas content ",
          "update": "Modifier",
          "we_need_your_current_password_to_confirm_your_changes": "nous avons besoin de votre mot de passe actuel pour valider ces modifications"
        },
        "new": {
          "sign_up": "Inscription"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Connexion"
        }
      },
      "shared": {
        "links": {
          "back": "Retour",
          "didn_t_receive_confirmation_instructions": "Vous n'avez pas reçu le courriel de confirmation ?",
          "didn_t_receive_unlock_instructions": "Vous n'avez pas reçu le courriel de déblocage ?",
          "forgot_your_password": "Mot de passe oublié ?",
          "sign_in": "Connexion",
          "sign_in_with_provider": "Connexion avec %{provider}",
          "sign_up": "Inscription"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Renvoyer les instructions de déblocage"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "a un rapport d'aspect invalide (les rapports d'aspect valides sont %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "doit être paysage (le fichier actuel est %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "doit être portrait (le fichier actuel est %{width}x%{height}px)",
        "aspect_ratio_not_square": "doit être carré (le fichier actuel est %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "doit être %{authorized_aspect_ratios} (le fichier actuel est %{width}x%{height}px)",
        "attachment_missing": "n'a pas de fichier joint",
        "audio_missing": "doit contenir une piste audio",
        "audio_present": "ne doit pas contenir de piste audio",
        "content_type_invalid": {
          "one": "a un type de contenu invalide (le type de contenu autorisé est %{authorized_human_content_types})",
          "other": "a un type de contenu invalide (les types de contenu autorisés sont %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "a un type de contenu qui n'est pas équivalent à celui qui est détecté par son contenu (le type de contenu autorisé est %{authorized_human_content_types})",
          "other": "a un type de contenu qui n'est pas équivalent à celui qui est détecté par son contenu (les types de contenu autorisés sont %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "la hauteur doit être égale à %{length} pixels",
        "dimension_height_not_greater_than_or_equal_to": "la hauteur doit être supérieure ou égale à %{length} pixels",
        "dimension_height_not_included_in": "la hauteur n'est pas comprise entre %{min} et %{max} pixels",
        "dimension_height_not_less_than_or_equal_to": "la hauteur doit être inférieure ou égale à %{length} pixels",
        "dimension_max_not_included_in": "doit être inférieur ou égal à %{width} x %{height} pixels",
        "dimension_min_not_included_in": "doit être supérieur ou égal à %{width} x %{height} pixels",
        "dimension_width_not_equal_to": "la largeur doit être égale à %{length} pixels",
        "dimension_width_not_greater_than_or_equal_to": "la largeur doit être supérieure ou égale à %{length} pixels",
        "dimension_width_not_included_in": "la largeur n'est pas comprise entre %{min} et %{max} pixels",
        "dimension_width_not_less_than_or_equal_to": "la largeur doit être inférieure ou égale à %{length} pixels",
        "duration_not_between": "la durée doit être comprise entre %{min} et %{max} (la durée actuelle est %{duration})",
        "duration_not_equal_to": "la durée doit être égale à %{exact} (la durée actuelle est %{duration})",
        "duration_not_greater_than": "la durée doit être supérieure à %{min} (la durée actuelle est %{duration})",
        "duration_not_greater_than_or_equal_to": "la durée doit être supérieure ou égale à %{min} (la durée actuelle est %{duration})",
        "duration_not_less_than": "la durée doit être inférieure à %{max} (la durée actuelle est %{duration})",
        "duration_not_less_than_or_equal_to": "la durée doit être inférieure ou égale à %{max} (la durée actuelle est %{duration})",
        "equal_to_current_password": "doit être différent de l'actuel",
        "equal_to_email": "doit être différent de l'e-mail",
        "file_not_processable": "n'est pas identifié comme un fichier média valide",
        "file_size_not_between": "la taille du fichier doit être comprise entre %{min} et %{max} (la taille actuelle est %{file_size})",
        "file_size_not_equal_to": "la taille du fichier doit être égale à %{exact} (la taille actuelle est %{file_size})",
        "file_size_not_greater_than": "la taille du fichier doit être supérieure à %{min} (la taille actuelle est %{file_size})",
        "file_size_not_greater_than_or_equal_to": "la taille du fichier doit être supérieure ou égale à %{min} (la taille actuelle est %{file_size})",
        "file_size_not_less_than": "la taille du fichier doit être inférieure à %{max} (la taille actuelle est %{file_size})",
        "file_size_not_less_than_or_equal_to": "la taille du fichier doit être inférieure ou égale à %{max} (la taille actuelle est %{file_size})",
        "limit_max_exceeded": {
          "one": "trop de fichiers joints (le maximum autorisé est %{max} fichiers, obtenu %{count})",
          "other": "trop de fichiers joints (le maximum autorisé est %{max} fichiers, obtenu %{count})",
          "zero": "pas de fichiers joints (le maximum autorisé est %{max} fichiers)"
        },
        "limit_min_not_reached": {
          "one": "seulement 1 fichier joint (doit avoir au moins %{min} fichiers)",
          "other": "%{count} fichiers attachés (doit avoir au moins %{min} fichiers)",
          "zero": "pas de fichiers joints (doit avoir au moins %{min} fichiers)"
        },
        "limit_out_of_range": {
          "one": "seulement 1 fichier joint (doit avoir entre %{min} et %{max} fichiers)",
          "other": "le nombre total de fichiers doit être compris entre %{min} et %{max} fichiers (il y a %{count} fichiers attachés)",
          "zero": "pas de fichiers joints (doit avoir entre %{min} et %{max} fichiers)"
        },
        "media_metadata_missing": "n'est pas un fichier média valide",
        "pages_not_between": "le nombre de pages doit être compris entre %{min} et %{max} (le nombre actuel est de %{pages})",
        "pages_not_equal_to": "le nombre de pages doit être égal à %{exact} (le nombre actuel est de %{pages})",
        "pages_not_greater_than": "le nombre de pages doit être supérieur à %{min} (le nombre actuel est de %{pages})",
        "pages_not_greater_than_or_equal_to": "le nombre de pages doit être supérieur ou égal à %{min} (le nombre actuel est de %{pages})",
        "pages_not_less_than": "le nombre de pages doit être inférieur à %{max} (le nombre actuel est de %{pages})",
        "pages_not_less_than_or_equal_to": "le nombre de pages doit être inférieur ou égal à %{max} (le nombre actuel est de %{pages})",
        "password_complexity": {
          "digit": {
            "one": "doit contenir au moins un chiffre",
            "other": "doit contenir au moins %{count} chiffres"
          },
          "lower": {
            "one": "doit contenir au moins une lettre minuscule",
            "other": "doit contenir au moins %{count} lettres minuscules"
          },
          "symbol": {
            "one": "doit contenir au moins un signe de ponctuation",
            "other": "doit contenir au moins %{count} signes de ponctuation"
          },
          "upper": {
            "one": "doit contenir au moins une lettre majuscule",
            "other": "doit contenir au moins %{count} lettres majuscules"
          }
        },
        "taken_in_past": "a été utilisé trop récemment. Veuillez en choisir un autre",
        "total_file_size_not_between": "la taille totale des fichiers doit être comprise entre %{min} et %{max} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_equal_to": "la taille totale des fichiers doit être égale à %{exact} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_greater_than": "la taille totale des fichiers doit être supérieure à %{min} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "la taille totale des fichiers doit être supérieure ou égale à %{min} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_less_than": "la taille totale des fichiers doit être inférieure à %{max} (la taille actuelle est %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "la taille totale des fichiers doit être inférieure ou égale à %{max} (la taille actuelle est %{total_file_size})"
      }
    },
    "formtastic": {
      "cancel": "Annuler",
      "create": "Créer un(e) %{model}",
      "no": "Non",
      "required": "requis(e)",
      "reset": "Réinitialiser ce(tte) %{model}",
      "submit": "Enregistrer ce(tte) %{model}",
      "update": "Modifier ce(tte) %{model}",
      "yes": "Oui"
    },
    "numbers": {
      "billions": {
        "one": "milliard",
        "other": "milliards"
      },
      "billionths": {
        "one": "milliardième",
        "other": "milliardièmes"
      },
      "decillions": {
        "one": "quintilliard",
        "other": "quintilliards"
      },
      "decillionths": {
        "one": "quintilliardième",
        "other": "quintilliardièmes"
      },
      "duodecillionths": {
        "one": "sextilliardième",
        "other": "sextilliardièmes"
      },
      "eighty": "quatre-vingts",
      "hundreds": {
        "one": "cent",
        "other": "cents"
      },
      "hundredths": {
        "one": "centième",
        "other": "centièmes"
      },
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillion",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths",
        "quadrillionths",
        "quintillionths",
        "sextillionths",
        "septillionths",
        "octillionths",
        "nonillionths",
        "decillionths",
        "undecillionths",
        "duodecillionths",
        "tredecillionths",
        "quattuordecillionths"
      ],
      "micro_prefix": {
        "hundreds": "cent",
        "tens": "dix",
        "union": "-"
      },
      "micro_separator": "et",
      "millions": {
        "one": "million",
        "other": "millions"
      },
      "millionths": {
        "one": "millionième",
        "other": "millionièmes"
      },
      "nonillions": {
        "one": "quintillion",
        "other": "quintillions"
      },
      "nonillionths": {
        "one": "quintillionième",
        "other": "quintillionièmes"
      },
      "octillions": {
        "one": "quadrilliard",
        "other": "quadrilliards"
      },
      "octillionths": {
        "one": "quadrilliardième",
        "other": "quadrilliardièmes"
      },
      "ones": [
        "zéro",
        "un",
        "deux",
        "trois",
        "quatre",
        "cinq",
        "six",
        "sept",
        "huit",
        "neuf"
      ],
      "quadrillions": {
        "one": "billiard",
        "other": "billiards"
      },
      "quadrillionths": {
        "one": "billiardième",
        "other": "billiardièmes"
      },
      "quattuordecillionths": {
        "one": "septilliardième",
        "other": "septilliardièmes"
      },
      "quintillions": {
        "one": "trillion",
        "other": "trillions"
      },
      "quintillionths": {
        "one": "trillionième",
        "other": "trillionièmes"
      },
      "septillions": {
        "one": "quadrillion",
        "other": "quadrillions"
      },
      "septillionths": {
        "one": "quadrillionième",
        "other": "quadrillionièmes"
      },
      "sextillions": {
        "one": "trilliard",
        "other": "trilliards"
      },
      "sextillionths": {
        "one": "trilliardième",
        "other": "trilliardièmes"
      },
      "teens": [
        "_",
        "onze",
        "douze",
        "treize",
        "quatorze",
        "quinze",
        "seize",
        "dix-sept",
        "dix-huit",
        "dix-neuf"
      ],
      "tens": [
        "_",
        "dix",
        "vingt",
        "trente",
        "quarante",
        "cinquante",
        "soixante",
        "soixante-dix",
        "quatre-vingt",
        "quatre-vingt-dix"
      ],
      "tenths": {
        "one": "dixième",
        "other": "dixièmes"
      },
      "thousands": {
        "one": "mille",
        "other": "mille"
      },
      "thousandths": {
        "one": "millième",
        "other": "millièmes"
      },
      "tredecillionths": {
        "one": "septillionième",
        "other": "septillionièmes"
      },
      "trillions": {
        "one": "billion",
        "other": "billions"
      },
      "trillionths": {
        "one": "billionième",
        "other": "billionièmes"
      },
      "undecillionths": {
        "one": "sextillionième",
        "other": "sextillionièmes"
      },
      "union": "et"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Page",
          "other": "Pages"
        },
        "next": "Suivant",
        "previous": "Précédent"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Affichage des %{item_name} %{from} à %{to} sur %{count} au total",
        "no_count": "Page %{page} sur %{pages}",
        "no_items": "Aucun %{item_name} trouvé",
        "single_page": "Affichage de %{count} %{item_name}"
      },
      "input_nav_js": "Page %{page_input} sur %{pages}",
      "item_name": {
        "one": "élément",
        "other": "éléments"
      },
      "limit_tag_js": "Afficher %{limit_input} %{item_name} par page",
      "next": "&gt;",
      "p11n": "OneUptoTwoOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "tous",
      "and": "et",
      "any": "au moins un",
      "asc": "ascendant",
      "attribute": "attribut",
      "combinator": "combinateur",
      "condition": "condition",
      "desc": "descendant",
      "or": "ou",
      "predicate": "prédicat",
      "predicates": {
        "blank": "est blanc",
        "cont": "contient",
        "cont_all": "contient tous",
        "cont_any": "contient au moins un",
        "does_not_match": "ne correspond pas à",
        "does_not_match_all": "ne correspond à aucun",
        "does_not_match_any": "ne correspond pas à au moins un",
        "end": "finit par",
        "end_all": "finit par tous",
        "end_any": "finit par au moins un",
        "eq": "égal à",
        "eq_all": "égal à tous",
        "eq_any": "égal à au moins un",
        "false": "est faux",
        "gt": "supérieur à",
        "gt_all": "supérieur à tous",
        "gt_any": "supérieur à au moins un",
        "gteq": "supérieur ou égal à",
        "gteq_all": "supérieur ou égal à tous",
        "gteq_any": "supérieur ou égal à au moins un",
        "in": "inclus dans",
        "in_all": "inclus dans tous",
        "in_any": "inclus dans au moins un",
        "lt": "inférieur à",
        "lt_all": "inférieur à tous",
        "lt_any": "inférieur à au moins un",
        "lteq": "inférieur ou égal à",
        "lteq_all": "inférieur ou égal à tous",
        "lteq_any": "inférieur ou égal à au moins un",
        "matches": "correspond à",
        "matches_all": "correspond à tous",
        "matches_any": "correspond à au moins un",
        "not_cont": "ne contient pas",
        "not_cont_all": "ne contient pas tous",
        "not_cont_any": "ne contient pas au moins un",
        "not_end": "ne finit pas par",
        "not_end_all": "ne finit pas par tous",
        "not_end_any": "ne finit pas par au moins un",
        "not_eq": "différent de",
        "not_eq_all": "différent de tous",
        "not_eq_any": "différent d'au moins un",
        "not_in": "non inclus dans",
        "not_in_all": "non inclus dans tous",
        "not_in_any": "non inclus dans au moins un",
        "not_null": "n'est pas null",
        "not_start": "ne commence pas par",
        "not_start_all": "ne commence pas par tous",
        "not_start_any": "ne commence pas par au moins un",
        "null": "est null",
        "present": "est présent",
        "start": "commence par",
        "start_all": "commence par tous",
        "start_any": "commence par au moins un",
        "true": "est vrai"
      },
      "search": "recherche",
      "sort": "tri",
      "value": "valeur"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, nous n'avons pas pu valider votre réponse reCAPTCHA. Veuillez essayer à nouveau.",
        "verification_failed": "La vérification reCAPTCHA a échoué, veuillez essayer à nouveau."
      }
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d %B %Y à %H:%M"
            }
          }
        }
      }
    }
  },
  "fr-CH": {
    "numbers": {
      "billions": {
        "one": "milliard",
        "other": "milliards"
      },
      "billionths": {
        "one": "milliardième",
        "other": "milliardièmes"
      },
      "decillions": {
        "one": "quintilliard",
        "other": "quintilliards"
      },
      "decillionths": {
        "one": "quintilliardième",
        "other": "quintilliardièmes"
      },
      "duodecillionths": {
        "one": "sextilliardième",
        "other": "sextilliardièmes"
      },
      "eighty": "huitante",
      "hundreds": {
        "one": "cent",
        "other": "cents"
      },
      "hundredths": {
        "one": "centième",
        "other": "centièmes"
      },
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillion",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths",
        "quadrillionths",
        "quintillionths",
        "sextillionths",
        "septillionths",
        "octillionths",
        "nonillionths",
        "decillionths",
        "undecillionths",
        "duodecillionths",
        "tredecillionths",
        "quattuordecillionths"
      ],
      "micro_prefix": {
        "hundreds": "cent",
        "tens": "dix",
        "union": "-"
      },
      "micro_separator": "et",
      "millions": {
        "one": "million",
        "other": "millions"
      },
      "millionths": {
        "one": "millionième",
        "other": "millionièmes"
      },
      "nonillions": {
        "one": "quintillion",
        "other": "quintillions"
      },
      "nonillionths": {
        "one": "quintillionième",
        "other": "quintillionièmes"
      },
      "octillions": {
        "one": "quadrilliard",
        "other": "quadrilliards"
      },
      "octillionths": {
        "one": "quadrilliardième",
        "other": "quadrilliardièmes"
      },
      "ones": [
        "zéro",
        "un",
        "deux",
        "trois",
        "quatre",
        "cinq",
        "six",
        "sept",
        "huit",
        "neuf"
      ],
      "quadrillions": {
        "one": "billiard",
        "other": "billiards"
      },
      "quadrillionths": {
        "one": "billiardième",
        "other": "billiardièmes"
      },
      "quattuordecillionths": {
        "one": "septilliardième",
        "other": "septilliardièmes"
      },
      "quintillions": {
        "one": "trillion",
        "other": "trillions"
      },
      "quintillionths": {
        "one": "trillionième",
        "other": "trillionièmes"
      },
      "septillions": {
        "one": "quadrillion",
        "other": "quadrillions"
      },
      "septillionths": {
        "one": "quadrillionième",
        "other": "quadrillionièmes"
      },
      "sextillions": {
        "one": "trilliard",
        "other": "trilliards"
      },
      "sextillionths": {
        "one": "trilliardième",
        "other": "trilliardièmes"
      },
      "teens": [
        "_",
        "onze",
        "douze",
        "treize",
        "quatorze",
        "quinze",
        "seize",
        "dix-sept",
        "dix-huit",
        "dix-neuf"
      ],
      "tens": [
        "_",
        "dix",
        "vingt",
        "trente",
        "quarante",
        "cinquante",
        "soixante",
        "septante",
        "huitante",
        "nonante"
      ],
      "tenths": {
        "one": "dixième",
        "other": "dixièmes"
      },
      "thousands": {
        "one": "mille",
        "other": "mille"
      },
      "thousandths": {
        "one": "millième",
        "other": "millièmes"
      },
      "tredecillionths": {
        "one": "septillionième",
        "other": "septillionièmes"
      },
      "trillions": {
        "one": "billion",
        "other": "billions"
      },
      "trillionths": {
        "one": "billionième",
        "other": "billionièmes"
      },
      "undecillionths": {
        "one": "sextillionième",
        "other": "sextillionièmes"
      },
      "union": "et"
    }
  },
  "he": {
    "active_admin": {
      "access_denied": {
        "message": "אינך רשאי לבצע פעולה זו."
      },
      "any": "Any",
      "batch_actions": {
        "action_label": "%{title} נבחר",
        "button_label": "פעולות מרובות",
        "default_confirmation": "אתה בטוח שאתה רוצה לעשות את זה?",
        "delete_confirmation": "האם הנך בטוח שאתה רוצה למרוח את %{plural_model}?",
        "labels": {
          "destroy": "מחק"
        },
        "selection_toggle_explanation": "(שינוי בחירה)",
        "succesfully_destroyed": {
          "one": "1 %{model} נמחק בהצלחה",
          "other": "%{count} %{plural_model} נמחק בהצלחה"
        }
      },
      "blank_slate": {
        "content": "כרגע אין עוד אף %{resource_name}.",
        "link": "צור אחד"
      },
      "cancel": "ביטול",
      "comments": {
        "add": "הוסף תגובה",
        "author": "נוצר ע\"י",
        "author_missing": "אנונימי",
        "author_type": "סוג מחבר",
        "body": "תוכן",
        "created_at": "נוצר",
        "delete": "מחק תגובה",
        "delete_confirmation": "האם אתה בטוח שברצונך למחוק תגובה זאת?",
        "errors": {
          "empty_text": "התגובה לא נשמרה, שדה התוכן ריק."
        },
        "no_comments_yet": "אין עדיין תגובות.",
        "resource": "רשומה",
        "resource_type": "סוג רישום",
        "title_content": "תגובות (%{count})"
      },
      "create_another": "צור עוד %{model}",
      "dashboard": "פנל ניהול",
      "dashboard_welcome": {
        "call_to_action": "כדי להוסיף אזורים בפנל הניהול, אנא בדוק את,  'app/admin/dashboard.rb'",
        "welcome": "ברוכים הבאים לאקטיב אדמין. זהו פנל הניהול"
      },
      "delete": "מחיקה",
      "delete_confirmation": "האם אתה בטוח שאתה רוצה למחוק את זה?",
      "delete_model": "מחיקת %{model}",
      "details": "פרטים על %{model}",
      "devise": {
        "change_password": {
          "submit": "שנה את הסיסמא שלי",
          "title": "שנה את הסיסמא שלך"
        },
        "email": {
          "title": "כתובת דוא״ל"
        },
        "links": {
          "forgot_your_password": "שכחת את הסיסמא שלך?",
          "resend_confirmation_instructions": "שלח שוב הוראות אישור",
          "resend_unlock_instructions": "שלח שוב הוראות שיחרור",
          "sign_in": "כניסה",
          "sign_in_with_omniauth_provider": "%{provider} היכנס עם",
          "sign_up": "הרשמה"
        },
        "login": {
          "remember_me": "זכור אותי",
          "submit": "הכנס",
          "title": "כניסה"
        },
        "password": {
          "title": "סיסמא"
        },
        "password_confirmation": {
          "title": "אישור סיסמא"
        },
        "resend_confirmation_instructions": {
          "submit": "שלח שוב הוראות אישור",
          "title": "שלח שוב הוראות אישור"
        },
        "reset_password": {
          "submit": "אפס את הסיסמא שלי",
          "title": "שכחת סיסמא?"
        },
        "sign_up": {
          "submit": "הרשמה",
          "title": "הרשמה"
        },
        "subdomain": {
          "title": "תת-דומיין"
        },
        "unlock": {
          "submit": "שלח שוב הוראות שיחרור",
          "title": "שלח שוב הוראות שיחרור"
        },
        "username": {
          "title": "שם משתמש"
        }
      },
      "download": "הורד:",
      "dropdown_actions": {
        "button_label": "פעולו"
      },
      "edit": "עריכה",
      "edit_model": "ערוך %{model}",
      "empty": "ריק",
      "filters": {
        "buttons": {
          "clear": "איפוס שדות",
          "filter": "סינון"
        }
      },
      "has_many_delete": "מחיקה",
      "has_many_new": "הוספת %{model} חדש",
      "has_many_remove": "להסיר",
      "index_list": {
        "block": "רשימה",
        "blog": "בלוג",
        "grid": "גריד",
        "table": "טבלה"
      },
      "logout": "התנתקות",
      "main_content": "אנא הטמע את %{model}#main_content בכדי להציג תוכן.",
      "new_model": "%{model} חדש",
      "next": "הבא",
      "pagination": {
        "empty": "אין %{model} בנמצא",
        "entry": {
          "one": "רשומה בודדה",
          "other": "רשומות"
        },
        "multiple": "מציג %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> מתוך <b>%{total}</b> בסך הכל",
        "multiple_without_total": "מציג %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "מציג <b>1</b> %{model}",
        "one_page": "הצגת <b>כל %{n}</b> %{model}",
        "per_page": "בדף: "
      },
      "powered_by": "ממונע בעזרת %{active_admin} %{version}",
      "previous": "הקודם",
      "search_status": {
        "current_filters": "מסננים:",
        "current_scope": "תחום:",
        "headline": "תוצאות חיפוש:",
        "no_current_filters": "ללא"
      },
      "sidebars": {
        "filters": "סינון",
        "search_status": "מצב החיפוש"
      },
      "status_tag": {
        "no": "לא",
        "unset": "לא",
        "yes": "כן"
      },
      "unsupported_browser": {
        "headline": "שים לב ש-ActiveAdmin אינו תומך יותר ב-Internet Explorer גרסא 8 ומטה.",
        "recommendation": "אנו ממליצים <a href=\"http://browsehappy.com/\">לשדרג את הדפדפן שלך</a> על מנת לשפר את חווית הגלישה.",
        "turn_off_compatibility_view": "אם אתה משתמש ב- IE 9 ואילך, ודא ש<a href=\"https://support.microsoft.com/he-il/help/17471\">כיבית \"תצוגת תאימות\"</a>."
      },
      "view": "צפייה"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "סיסמא נוכחית",
          "email": "אימייל",
          "password": "סיסמא",
          "password_confirmation": "אישור סיסמא",
          "remember_me": "זכור אותי"
        }
      },
      "models": {
        "user": "משתמש"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "שלח מחדש הוראות אישור"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "אשר את החשבון שלי",
          "greeting": "ברוך הבא %{recipient}!",
          "instruction": "אתה יכול לאשר את כתובת האימייל שלך בעזרת הקישור הנֿֿ״ל:"
        },
        "reset_password_instructions": {
          "action": "שנה סיסמא",
          "greeting": "שלום %{recipient}!",
          "instruction": "נתקבלה בקשה לשינוי הסיסמא שלך וביכולתך לעשות זאת בעזרת הקישור המוצג למטה.",
          "instruction_2": "אם אתה לא ביקשת זאת, אנא התעלם מאימייל זה.",
          "instruction_3": "סיסמאתך תוחלף רק אם תלחץ על הקישור המוצג מעל ותיצור סיסמא חדשה."
        },
        "unlock_instructions": {
          "action": "בטל נעילת חשבון",
          "greeting": "שלום %{recipient}!",
          "instruction": "לחץ על הלינק המוצג למטה בכדי לבטל את נעילת חשבונך:",
          "message": "חשבונך ננעל עקב מספר רב של ניסיונות כניסה כושלים."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "שנה סיסמא",
          "change_your_password": "שינוי סיסמא",
          "confirm_new_password": "אישור סיסמא חדשה",
          "new_password": "סיסמא חדשה"
        },
        "new": {
          "forgot_your_password": "שכחת סיסמא?",
          "send_me_reset_password_instructions": "שלח לי הוראות שיחזור סיסמא"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "האם את בטוח?",
          "cancel_my_account": "בטל את החשבון שלי",
          "currently_waiting_confirmation_for_email": "ממתין לאישור של הכתובת: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "השאר ריק אם אין ברצונך לשנותו",
          "title": "ערוך %{resource}",
          "unhappy": "לא מרוצה",
          "update": "עדכן",
          "we_need_your_current_password_to_confirm_your_changes": "אנחנו זקוקים לסיסמאתך הנוכחית על מנת לבצע את השינויים שביקשת"
        },
        "new": {
          "sign_up": "הרשמה"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "כניסה"
        }
      },
      "shared": {
        "links": {
          "back": "חזור",
          "didn_t_receive_confirmation_instructions": "לא קיבלת את הוראות האישור?",
          "didn_t_receive_unlock_instructions": "לא קיבלת את הוראות ביטול הנעילה?",
          "forgot_your_password": "שכחת סיסמא?",
          "sign_in": "כניסה",
          "sign_in_with_provider": "כניסה באמצעות %{provider}",
          "sign_up": "הרשמה"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "שלח שוב הוראות ביטול נעילה"
        }
      }
    }
  },
  "hi": {
    "devise": {
      "failure": {
        "expired": "कोई गतिविधि न होने के कारण खाता बंद हो गया, सिस्टम व्यवस्थापक से संपर्क करें",
        "session_limited": "जानकारी, दूसरे ब्राउज़र में उपयोग की गयी थी जारी रखने फिर से साइन-इन करे"
      },
      "invalid_captcha": "अमान्य कॅप्टचा",
      "invalid_security_question": "अमान्य सुरक्षा उत्तर",
      "paranoid_verification_code": {
        "show": {
          "submit": "सबमिट",
          "submit_verification_code": "वेरिफिकेशन कोड डाले",
          "verification_code": "वेरिफिकेशन कोड"
        },
        "updated": "सत्यापन कोड स्वीकार किया गया"
      },
      "paranoid_verify": {
        "code_required": "सपोर्ट टीम द्वारा दिया गया कोड डाले"
      },
      "password_expired": {
        "change_required": "पासवर्ड अमान्य हो चुका, पासवर्ड बदले",
        "show": {
          "change_my_password": "पासवर्ड बदले",
          "current_password": "वर्तमान पासवर्ड",
          "new_password": "नया पासवर्ड",
          "new_password_confirmation": "नए पासवर्ड की पुष्टि करें",
          "renew_your_password": "पासवर्ड बदले"
        },
        "updated": "पासवर्ड अद्यतन किया गया"
      }
    },
    "errors": {
      "messages": {
        "equal_to_current_password": "नया पासवर्ड, वर्तमान पासवर्ड से भिन्न होना चाहिए",
        "equal_to_email": "ईमेल से अलग होना चाहिए",
        "password_complexity": {
          "digit": {
            "one": "एक अंक होना चाहिए",
            "other": "कम से कम %{count} अंक होने चाहिए"
          },
          "lower": {
            "one": "एक लोअर-केस अक्षर होना चाहिए",
            "other": "कम से कम %{count} अक्षर होने चाहिए"
          },
          "symbol": {
            "one": "एक चिन्ह होना चाहिए",
            "other": "कम से कम %{count} चिन्ह होने चाहिए"
          },
          "upper": {
            "one": "एक अपर-केस अक्षर होना चाहिए",
            "other": "कम से कम %{count} अपर-केस अक्षर होने चाहिए"
          }
        },
        "taken_in_past": "यह पासवर्ड, आपके द्वारा पूर्व मे प्रयोग किया जा चुका है"
      }
    }
  },
  "hr": {
    "active_admin": {
      "access_denied": {
        "message": "Nemaš dopuštenja."
      },
      "any": "Bilo koji",
      "batch_actions": {
        "action_label": "%{title} označene",
        "button_label": "Grupne akcije",
        "default_confirmation": "Jeste li sigurni da želite to učiniti?",
        "delete_confirmation": "Jeste li sigurni da želite obrisati %{plural_model}?",
        "labels": {
          "destroy": "Obriši"
        },
        "selection_toggle_explanation": "(Izmijeni odabir)",
        "succesfully_destroyed": {
          "few": "Uspješno su obrisana %{count} %{plural_model}",
          "many": "Uspješno je obrisano %{count} %{plural_model}",
          "one": "Uspješno je obrisan 1 %{model}",
          "other": "Uspješno je obrisano %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Još uvijek ne postoji niti jedan zapis tipa %{resource_name}.",
        "link": "Izradi jedan"
      },
      "cancel": "Odustani",
      "comments": {
        "add": "Dodaj komentar",
        "author": "Autor",
        "author_missing": "Anoniman",
        "author_type": "Tip autora",
        "body": "Sadržaj",
        "errors": {
          "empty_text": "Komentar nije spremljen, sadržaj je prazan."
        },
        "no_comments_yet": "Još nema komentara.",
        "resource": "Objekt",
        "resource_type": "Tip objekta",
        "title_content": "Komentari (%{count})"
      },
      "dashboard": "Upravljačka ploča",
      "dashboard_welcome": {
        "call_to_action": "Da biste dodali nove odjeljke na upravljačku ploču, pogledajte 'app/admin/dashboard.rb'",
        "welcome": "Dobrodošli u Active Admin. Ovo je početna upravljačka ploča."
      },
      "delete": "Obriši",
      "delete_confirmation": "Jeste li sigurni da želite ovo obrisati?",
      "delete_model": "Obriši %{model}",
      "details": "%{model} detalji",
      "devise": {
        "change_password": {
          "submit": "Izmijeni lozinku",
          "title": "Izmjena lozinke"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Zaboravljena lozinka?",
          "sign_in": "Prijavi se",
          "sign_in_with_omniauth_provider": "Prijavite se za %{provider}"
        },
        "login": {
          "remember_me": "Zapamti me",
          "submit": "Prijavi se",
          "title": "Prijava"
        },
        "password": {
          "title": "Lozinka"
        },
        "resend_confirmation_instructions": {
          "submit": "Pošalji",
          "title": "Ponovno slanje uputstva za potvrdu"
        },
        "reset_password": {
          "submit": "Resetiraj lozinku",
          "title": "Zaboravljena lozinka?"
        },
        "sign_up": {
          "submit": "Registruj",
          "title": "Registracija"
        },
        "subdomain": {
          "title": "Poddomena"
        },
        "unlock": {
          "submit": "Pošalji",
          "title": "Ponovno slanje uputstva za otključavanje"
        },
        "username": {
          "title": "Korisničko ime"
        }
      },
      "download": "Spremi na računalo:",
      "dropdown_actions": {
        "button_label": "Ukrepi"
      },
      "edit": "Uredi",
      "edit_model": "Uredi %{model}",
      "empty": "Prazno",
      "filters": {
        "buttons": {
          "clear": "Očisti filtere",
          "filter": "Filtriraj"
        }
      },
      "has_many_delete": "Obriši",
      "has_many_new": "Dodaj novi %{model}",
      "has_many_remove": "Ukloniti",
      "index_list": {
        "block": "Lista",
        "blog": "Blog",
        "grid": "Rešetka",
        "table": "Tabela"
      },
      "logout": "Odjavi se",
      "main_content": "Molim Vas, implementirajte %{model}#main_content da biste prikazali sadržaj.",
      "new_model": "Novi %{model}",
      "next": "Sljedeći",
      "pagination": {
        "empty": "Nije pronađen niti jedan %{model}.",
        "entry": {
          "few": "zapisa",
          "many": "zapisa",
          "one": "zapis",
          "other": "zapisa"
        },
        "multiple": "Prikazani %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> od ukupno <b>%{total}</b>",
        "multiple_without_total": "Prikazani %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Prikazan <b>1</b> %{model}",
        "one_page": "Prikazano <b>svih %{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Prijašnji",
      "sidebars": {
        "filters": "Filtriranje"
      },
      "status_tag": {
        "no": "Nema",
        "unset": "Nema",
        "yes": "Da"
      },
      "view": "Pregledaj"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Stranice",
          "many": "Stranica",
          "one": "Stranica",
          "other": "Stranice"
        },
        "next": "Sljedeća ",
        "previous": "Prethodna"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Prikaz %{item_name} %{from}-%{to} od %{count} ukupno",
        "no_count": "Stranica %{page_input} od %{pages}",
        "no_items": "Nije pronađena %{item_name}",
        "single_page": "Prikazuje se %{count} %{item_name}"
      },
      "input_nav_js": "Stranica %{page_input} od %{pages}",
      "item_name": {
        "few": "stavke",
        "many": "stavki",
        "one": "stavka",
        "other": "stavki"
      },
      "limit_tag_js": "Prikaži %{limit_input} %{item_name} po stranici",
      "next": "&gt;",
      "p11n": "EastSlavic",
      "previous": "&lt;"
    }
  },
  "hu": {
    "active_admin": {
      "any": "Összes",
      "batch_actions": {
        "action_label": "%{title} kiválasztva",
        "button_label": "Tömeges műveletek",
        "default_confirmation": "Biztos vagy benne, hogy a ön akar-hoz csinál ez?",
        "delete_confirmation": "Biztosan törli ezeket a %{plural_model}?",
        "labels": {
          "destroy": "Törlés"
        },
        "selection_toggle_explanation": "(Kijelölés megfordítása)",
        "succesfully_destroyed": {
          "one": "1 %{model} sikeresen törölve",
          "other": "%{count} %{plural_model} sikeresen törölve"
        }
      },
      "blank_slate": {
        "content": "Még nincs létrehozva %{resource_name}.",
        "link": "Létrehozás most"
      },
      "cancel": "Mégsem",
      "comments": {
        "add": "Új hozzászólás",
        "author": "Szerző",
        "body": "Törzs",
        "errors": {
          "empty_text": "A hozzászólás nem lett mentve, a törzs nem lehet üres."
        },
        "no_comments_yet": "Nincsenek hozzászólások.",
        "resource": "Erőforrás",
        "title_content": "%{count} hozzászólás"
      },
      "dashboard": "Vezérlőpult",
      "dashboard_welcome": {
        "call_to_action": "Elemek hozzáadásához nézze meg a 'app/admin/dashboard.rb' fájlt",
        "welcome": "Üdvözöljük az Active Admin felületén. Ez a vezérlőpult kezdőlapja"
      },
      "delete": "Törlés",
      "delete_confirmation": "Biztosan törli ezt az elemet?",
      "delete_model": "%{model} törlése",
      "details": "%{model} részletei",
      "devise": {
        "change_password": {
          "submit": "Jelszó módosítása",
          "title": "A jelszó módosítása"
        },
        "links": {
          "forgot_your_password": "Elfelejtette a jelszavát?",
          "sign_in": "Bejelentkezés",
          "sign_in_with_omniauth_provider": "Jelentkezzen be a %{provider}"
        },
        "login": {
          "remember_me": "Emlékezz rám",
          "submit": "Belépés",
          "title": "Bejelentkezés"
        },
        "resend_confirmation_instructions": {
          "submit": "Megerősítő levél újraküldése",
          "title": "Megerősítő levél újraküldése"
        },
        "reset_password": {
          "submit": "Jelszó visszaállítása",
          "title": "Elfelejtette a jelszavát?"
        },
        "unlock": {
          "submit": "Újraküldés unlock utasítások",
          "title": "Újraküldés unlock utasítások"
        }
      },
      "download": "Letöltés:",
      "dropdown_actions": {
        "button_label": "Műveletek"
      },
      "edit": "Szerkesztés",
      "edit_model": "%{model} módosítása",
      "empty": "Üres",
      "filters": {
        "buttons": {
          "clear": "Feltételek törlése",
          "filter": "Szűrés"
        },
        "predicates": {
          "from": "-tól",
          "to": "-ig"
        }
      },
      "has_many_delete": "Törlés",
      "has_many_new": "Új %{model} hozzáadása",
      "has_many_remove": "Eltávolít",
      "logout": "Kilépés",
      "main_content": "Kérem, implementálja a %{model}#main_content metódust a tartalom megjelenítéséhez.",
      "new_model": "Új %{model}",
      "next": "Következő",
      "pagination": {
        "empty": "Nincs több %{model}",
        "entry": {
          "one": "elem",
          "other": "elem"
        },
        "multiple": "%{model} listájának megjelenítése, <b>%{from}&nbsp;-&nbsp;%{to}</b>/<b>%{total}</b> ",
        "multiple_without_total": "%{model} listájának megjelenítése, <b>%{from}&nbsp;-&nbsp;%{to}</b> ",
        "one": "<b>Egy</b> %{model} megjelenítése",
        "one_page": "<b>Az összes (%{n} db)</b> %{model} megjelenítése"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Előző",
      "sidebars": {
        "filters": "Szűrők"
      },
      "status_tag": {
        "no": "Nem",
        "unset": "Nem",
        "yes": "Igen"
      },
      "view": "Megtekintés"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Jelenlegi jelszó",
          "email": "E-mail",
          "password": "Jelszó",
          "password_confirmation": "Jelszó megerősítése",
          "remember_me": "Megjegyez"
        }
      },
      "models": {
        "user": "Felhasználó"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Megerősítő levél újraküldése"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Fiók megerősítése",
          "greeting": "Kedves %{recipient}!",
          "instruction": "A fiók megerősítéséhez rá kell kattintani az alábbi linkre:"
        },
        "reset_password_instructions": {
          "action": "Jelszó megváltoztatása",
          "greeting": "Kedves %{recipient}!",
          "instruction": "Ön, vagy valaki más az ön nevében jelszóváltoztatást kérvényezett, mely a lenti linkre kattintva lehetséges.",
          "instruction_2": "Amennyiben ön nem kezdeményezte a jelszavának megváltoztatását, kérem hagyja figyelmen kívül ezt a levelet.",
          "instruction_3": "Amennyiben nem kattint az alábbi linkre, jelszava továbbra is ugyanaz marad, mint eddig."
        },
        "unlock_instructions": {
          "action": "Zárolás feloldása",
          "greeting": "Kedves %{recipient}!",
          "instruction": "A zárolás feloldásához az alábbi linkre kell kattintani:",
          "message": "A felhasználói fiókja zárolva lett túl sok sikertelen belépési kísérlet miatt."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Jelszó megváltoztatása",
          "change_your_password": "Jelszó megváltoztatása",
          "confirm_new_password": "Jelszó megerősítése",
          "new_password": "Új jelszó"
        },
        "new": {
          "forgot_your_password": "Elfelejtette a jelszavát?",
          "send_me_reset_password_instructions": "Jelszóviszaállítási teendők küldése"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Biztos benne?",
          "cancel_my_account": "Fiók megszüntetése",
          "currently_waiting_confirmation_for_email": "Még várjuk a következő e-mail cím megerősítését: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "csak változás esetén kitöltendő",
          "title": "%{resource} módosítása",
          "unhappy": "Szomorú",
          "update": "Módosítás",
          "we_need_your_current_password_to_confirm_your_changes": "a változtatás végrehajtásához szükséges a jelenlegi jelszó"
        },
        "new": {
          "sign_up": "Regisztráció"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Belépés"
        }
      },
      "shared": {
        "links": {
          "back": "Vissza",
          "didn_t_receive_confirmation_instructions": "Nem kapta meg a megerősítő levelet?",
          "didn_t_receive_unlock_instructions": "Nem kapta meg a feloldáshoz a levelet?",
          "forgot_your_password": "Elfelejtette a jelszavát?",
          "sign_in": "Belépés",
          "sign_in_with_provider": "%{provider} belépés",
          "sign_up": "Regisztráció"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Feloldási teendők újraküldése"
        }
      }
    },
    "numbers": {
      "hundreds": "száz",
      "mega": [
        "_",
        "ezer",
        "millió",
        "milliárd",
        "billió",
        "billiárd",
        "trillió",
        "trilliárd",
        "kvadrillió",
        "kvadrilliárd",
        "kvintillió",
        "kvintilliárd"
      ],
      "micro": [
        "_",
        "tized",
        "század",
        "ezred",
        "milliomod",
        "milliárdod",
        "billiomod",
        "billiárdod",
        "trilliomod",
        "trilliárdod",
        "kvadrilliomod",
        "kvadrilliárdod",
        "kvintilliomod",
        "kvintilliárdod"
      ],
      "micro_prefix": {
        "hundreds": "száz",
        "tens": "tíz",
        "union": ""
      },
      "micro_separator": "egész",
      "ones": [
        "nulla",
        "egy",
        "kettő",
        "három",
        "négy",
        "öt",
        "hat",
        "hét",
        "nyolc",
        "kilenc"
      ],
      "ones_with_tens": [
        "_",
        "egy",
        "kettő",
        "három",
        "négy",
        "öt",
        "hat",
        "hét",
        "nyolc",
        "kilenc"
      ],
      "ordinal": {
        "hundreds": "századik",
        "mega": [
          "_",
          "ezredik",
          "milliomodik",
          "milliárdodik",
          "billiomodik",
          "billiárdodik",
          "trilliomodik",
          "trilliárdodik",
          "kvadrilliomodik",
          "kvadrilliárdodik",
          "kvintilliomodik",
          "kvintilliárdodik"
        ],
        "ones": [
          "nulladik",
          "első",
          "második",
          "harmadik",
          "negyedik",
          "ötödik",
          "hatodik",
          "hetedik",
          "nyolcadik",
          "kilencedik"
        ],
        "ones_with_tens": [
          "nulladik",
          "egyedik",
          "kettedik",
          "harmadik",
          "negyedik",
          "ötödik",
          "hatodik",
          "hetedik",
          "nyolcadik",
          "kilencedik"
        ],
        "tens": [
          "_",
          "tizedik",
          "huszadik",
          "harmincadik",
          "negyvenedik",
          "ötvenedik",
          "hatvanadik",
          "hetvenedik",
          "nyolcvanadik",
          "kilencvenedik"
        ]
      },
      "tens": [
        "_",
        "tíz",
        "húsz",
        "harminc",
        "negyven",
        "ötven",
        "hatvan",
        "hetven",
        "nyolcvan",
        "kilencven"
      ],
      "tens_with_ones": [
        "_",
        "tizen",
        "huszon",
        "harminc",
        "negyven",
        "ötven",
        "hatvan",
        "hetven",
        "nyolcvan",
        "kilencven"
      ]
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Oldal",
          "other": "Oldalak"
        },
        "next": "Következő",
        "previous": "Előző"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "%{from}-%{to}. %{item_name} megjelenítve %{count} közül",
        "no_count": "%{page}. oldal / %{pages}",
        "no_items": "Nem található %{item_name}",
        "single_page": "%{count} %{item_name} megjelenítve"
      },
      "input_nav_js": "%{page_input}. oldal / %{pages}",
      "item_name": {
        "one": "tétel",
        "other": "tétel"
      },
      "limit_tag_js": "%{limit_input} %{item_name} oldalanként",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "mindegyik",
      "and": "és",
      "any": "bármely",
      "asc": "növekvő",
      "attribute": "attribute",
      "combinator": "combinator",
      "condition": "feltétel",
      "desc": "csökkenő",
      "or": "vagy",
      "predicate": "állítás",
      "predicates": {
        "blank": "üres",
        "cont": "tartalmazza",
        "cont_all": "mindet tartalmazza",
        "cont_any": "bármelyiket tartalmazza",
        "does_not_match": "nem egyezik",
        "does_not_match_all": "nem egyezik az összessel",
        "does_not_match_any": "nem egyezik semelyikkel",
        "end": "így végződik",
        "end_all": "ezekkel végződik",
        "end_any": "bármelyikkel végződik",
        "eq": "egyenlő",
        "eq_all": "minddel egyenlő",
        "eq_any": "bármelyikkel egyenlő",
        "false": "hamis",
        "gt": "nagyobb, mint",
        "gt_all": "mindegyiknél nagyobb",
        "gt_any": "bármelyiknél nagyobb",
        "gteq": "nagyobb vagy egyenlő, mint",
        "gteq_all": "mindegyiknél nagyobb vagy egyenlő",
        "gteq_any": "bármelyiknél nagyobb vagy egyenlő",
        "in": "értéke",
        "in_all": "értéke mindegyik",
        "in_any": "értéke bármelyik",
        "lt": "kisebb, mint",
        "lt_all": "mindegyiknél kisebb",
        "lt_any": "bármelyiknél kisebb",
        "lteq": "kisebb vagy egyenlő, mint",
        "lteq_all": "mindegyiknél kisebb vagy egyenlő",
        "lteq_any": "bármelyiknél kisebb vagy egyenlő",
        "matches": "egyezik",
        "matches_all": "minddel egyezik",
        "matches_any": "bármelyikkel egyezik",
        "not_cont": "nem tartalmazza",
        "not_cont_all": "nem tartalmazza mindet",
        "not_cont_any": "egyiket sem tartalmazza",
        "not_end": "nem úgy végződik",
        "not_end_all": "nem ezekkel végződik",
        "not_end_any": "nem ezek egyikével végződik",
        "not_eq": "nem egyenlő",
        "not_eq_all": "nem egyenlő egyikkel sem",
        "not_eq_any": "nem egyenlő bármelyikkel",
        "not_in": "nem ez az értéke",
        "not_in_all": "értéke nem ezek az elemek",
        "not_in_any": "értéke egyik sem",
        "not_null": "nem null",
        "not_start": "nem így kezdődik",
        "not_start_all": "nem ezekkel kezdődik",
        "not_start_any": "nem ezek egyikével kezdődik",
        "null": "null",
        "present": "létezik",
        "start": "így kezdődik",
        "start_all": "ezekkel kezdődik",
        "start_any": "bármelyikkel kezdődik",
        "true": "igaz"
      },
      "search": "keresés",
      "sort": "rendezés",
      "value": "érték"
    }
  },
  "hy": {
    "numbers": {
      "hundreds": "հարյուր",
      "mega": [
        "_",
        "հազար",
        "միլիոն",
        "միլիարդ",
        "տրիլիոն",
        "քառակուսի"
      ],
      "ones": [
        "զրո",
        "մեկ",
        "երկու",
        "երեք",
        "չորս",
        "հինգ",
        "վեց",
        "յոթ",
        "ութ",
        "ինը"
      ],
      "teens": [
        "_",
        "տասնմեկ",
        "տասներկու",
        "տասներեք",
        "տասնչորս",
        "տասնհինգ",
        "տասնվեց",
        "տասնյոթ",
        "տասնութ",
        "տասնինը"
      ],
      "tens": [
        "_",
        "տասը",
        "քսան",
        "երեսուն",
        "քառասուն",
        "հիսուն",
        "վաթսուն",
        "յոթանասուն",
        "ութսուն",
        "իննսուն"
      ]
    }
  },
  "id": {
    "active_admin": {
      "access_denied": {
        "message": "Anda tidak diperkenankan melakukan aksi tersebut."
      },
      "any": "Apapun",
      "batch_actions": {
        "action_label": "%{title} terpilih",
        "button_label": "Tindakan Serentak",
        "default_confirmation": "Apakah anda yakin akan melakukan ini?",
        "delete_confirmation": "Apakah anda yakin akan menghapus %{plural_model}?",
        "labels": {
          "destroy": "Hapus"
        },
        "selection_toggle_explanation": "(Tampilkan Pilihan)",
        "succesfully_destroyed": {
          "one": "Berhasil menghapus %{model}",
          "other": "Berhasil menghapus %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "%{resource_name} masih belum ada sama sekali.",
        "link": "Tambah data"
      },
      "cancel": "Batal",
      "comments": {
        "add": "Tambah Komentar",
        "author": "Penulis",
        "author_missing": "Anonim",
        "author_type": "Tipe Penulis",
        "body": "Isi",
        "created_at": "Dibuat",
        "delete": "Hapus Komentar",
        "delete_confirmation": "Apakah anda yakin akan menghapus komentar tersebut?",
        "errors": {
          "empty_text": "Komentar tak bisa disimpan, text tidak boleh dikosongi."
        },
        "no_comments_yet": "Belum ada komentar sama sekali.",
        "resource": "Resource",
        "resource_type": "Jenis Resource",
        "title_content": "Komentar (%{count})"
      },
      "dashboard": "Dashboard",
      "dashboard_welcome": {
        "call_to_action": "Tampilan halaman ini bisa diubah di file 'app/admin/dashboard.rb'",
        "welcome": "Selamat datang di Active Admin. Ini adalah tampilan standar halaman dashboard."
      },
      "delete": "Hapus",
      "delete_confirmation": "Apakah anda yakin ingin menghapus data ini?",
      "delete_model": "Hapus %{model}",
      "details": "Detail %{model}",
      "devise": {
        "change_password": {
          "submit": "Kirimkan instruksi pengaturan ulang password",
          "title": " - Atur Ulang Password"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Lupa password?",
          "resend_confirmation_instructions": "Kirim lagi instruksi konfirmasi akun",
          "resend_unlock_instructions": "Kirim instruksi pengaktifan kembali akun",
          "sign_in": "Masuk",
          "sign_in_with_omniauth_provider": "Daftar melalui %{provider}",
          "sign_up": "Daftar"
        },
        "login": {
          "remember_me": "Ingat saya",
          "submit": "Masuk",
          "title": " - Masuk"
        },
        "password": {
          "title": "Password"
        },
        "resend_confirmation_instructions": {
          "submit": "Kirimkan lagi instruksi konfirmasi akun",
          "title": " - Kirim Lagi Instruksi Konfirmasi Akun"
        },
        "reset_password": {
          "submit": "Atur ulang password",
          "title": " - Form Atur Ulang Password"
        },
        "sign_up": {
          "submit": "Daftar",
          "title": " - Daftar"
        },
        "subdomain": {
          "title": "Subdomain"
        },
        "unlock": {
          "submit": "Kirimkan instruksi pengaktifan kembali akun",
          "title": " - Kirim Instruksi Pengaktifan Kembali Akun"
        },
        "username": {
          "title": "Username"
        }
      },
      "download": "Unduh:",
      "dropdown_actions": {
        "button_label": "Tindakan"
      },
      "edit": "Ubah",
      "edit_model": "Ubah %{model}",
      "empty": "Kosong",
      "filters": {
        "buttons": {
          "clear": "Hapus Filters",
          "filter": "Filter"
        }
      },
      "has_many_delete": "Hapus",
      "has_many_new": "Tambah %{model} baru",
      "has_many_remove": "Hapus",
      "index_list": {
        "block": "Daftar",
        "blog": "Blog",
        "grid": "Grid",
        "table": "Tabel"
      },
      "logout": "Keluar",
      "main_content": "Harap mengimplementasikan %{model}#main_content untuk menampilkan konten.",
      "new_model": "Tambah %{model} baru",
      "next": "Berikutnya",
      "pagination": {
        "empty": "Tidak ada %{model} yang bisa ditemukan",
        "entry": {
          "one": "data",
          "other": "data"
        },
        "multiple": "Menampilkan <b>%{from}&nbsp;-&nbsp;%{to}</b> dari <b>%{total}</b> keseluruhan %{model}",
        "multiple_without_total": "Menampilkan <b>%{from}&nbsp;-&nbsp;%{to} %{model}</b>",
        "one": "Menampilkan <b>1</b> %{model}",
        "one_page": "Menampilkan <b>semua %{n}</b> %{model}"
      },
      "powered_by": "Dibuat dengan %{active_admin} %{version}",
      "previous": "Sebelumnya",
      "search_status": {
        "current_filters": "Filter kini:",
        "current_scope": "Scope:",
        "headline": "Status Pencarian:",
        "no_current_filters": "Tidak ada"
      },
      "sidebars": {
        "filters": "Filter",
        "search_status": "Status Pencarian"
      },
      "status_tag": {
        "no": "Tidak",
        "unset": "Tidak",
        "yes": "Ya"
      },
      "unsupported_browser": {
        "headline": "Harap dicatat bahwa ActiveAdmin sudah tidak mendukung InternetExplorer versi 8 atau versi sebelum itu.",
        "recommendation": "Kami sarankan agar anda mengupgrade ke versi <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, atau <a href=\"https://mozilla.org/firefox/\">Firefox</a> yang terbaru.",
        "turn_off_compatibility_view": "Kalau anda menggunakan IE 9 atau yang lebih baru, pastikan anda <a href=\"https://support.microsoft.com/id-id/help/17471\">mematikan \"Compatibility View\"</a>."
      },
      "view": "Lihat"
    },
    "devise": {
      "failure": {
        "invited": "Anda memiliki undangan yang tertunda, harap terima undangan tersebut untuk menyelesaikan pembuatan akun Anda."
      },
      "invitations": {
        "edit": {
          "header": "Atur kata sandi Anda",
          "submit_button": "Atur kata sandi"
        },
        "invitation_removed": "Undangan Anda telah dihapus.",
        "invitation_token_invalid": "Token undangan yang diberikan tidak valid!",
        "new": {
          "header": "Kirim Undangan",
          "submit_button": "Kirim undangan"
        },
        "no_invitations_remaining": "Tidak ada undangan tersisa.",
        "send_instructions": "Email undangan telah dikirim ke %{email}.",
        "updated": "Kata sandi Anda telah berhasil diatur. Anda sudah masuk.",
        "updated_not_active": "Kata sandi Anda telah berhasil diatur."
      },
      "mailer": {
        "invitation_instructions": {
          "accept": "Terima Undangan",
          "accept_until": "Undangan ini akan berakhir pada %{due_date}.",
          "hello": "Halo %{email}",
          "ignore": "Jika Anda tidak ingin menerima undangan ini, silakan abaikan email ini. Akun Anda tidak akan dibuat sampai Anda mengakses tautan di atas dan mengatur kata sandi Anda.",
          "someone_invited_you": "Seseorang telah mengundang Anda ke %{url}. Anda dapat menerima undangan ini melalui tautan di bawah ini.",
          "subject": "Instruksi Undangan"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": "Halaman",
        "next": "Selanjutnya",
        "previous": "Sebelumnya"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Menampilkan %{item_name} %{from}-%{to} dari total %{count}",
        "no_count": "Halaman %{page} dari %{pages}",
        "no_items": "Tidak ditemukan %{item_name}",
        "single_page": "Menampilkan %{count} %{item_name}"
      },
      "input_nav_js": "Halaman %{page_input} dari %{pages}",
      "item_name": "item",
      "limit_tag_js": "Tampilkan %{limit_input} %{item_name} per halaman",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "semua",
      "and": "dan",
      "any": "apapun",
      "asc": "ascending",
      "attribute": "atribut",
      "combinator": "kombinasi",
      "condition": "kondisi",
      "desc": "descending",
      "or": "atau",
      "predicate": "predikat",
      "predicates": {
        "blank": "kosong",
        "cont": "mengandung",
        "cont_all": "mengandung semua",
        "cont_any": "mengandung beberapa",
        "does_not_match": "tidak mirip dengan",
        "does_not_match_all": "tidak mirip semua dengan",
        "does_not_match_any": "tidak mirip beberapa dengan",
        "end": "diakhiri dengan",
        "end_all": "diakhiri semua dengan",
        "end_any": "diakhiri beberapa dengan",
        "eq": "sama dengan",
        "eq_all": "sama seluruhnya dengan",
        "eq_any": "sama beberapa dengan",
        "false": "bernilai salah",
        "gt": "lebih besar daripada",
        "gt_all": "lebih besar semua dengan",
        "gt_any": "lebih besar beberapa dengan",
        "gteq": "lebih besar atau sama dengan",
        "gteq_all": "semua lebih besar atau sama dengan",
        "gteq_any": "beberapa lebih besar atau sama dengan",
        "in": "di",
        "in_all": "di semua",
        "in_any": "di beberapa",
        "lt": "kurang dari",
        "lt_all": "kurang seluruhnya dengan",
        "lt_any": "kurang beberapa dengan",
        "lteq": "kurang lebih",
        "lteq_all": "kurang lebih semua dengan",
        "lteq_any": "kurang lebih beberapa dengan",
        "matches": "mirip",
        "matches_all": "mirip semua dengan",
        "matches_any": "mirip beberapa dengan",
        "not_cont": "tidak mengandung",
        "not_cont_all": "tidak mengandung semua",
        "not_cont_any": "tidak mengandung beberapa",
        "not_end": "tidak diakhiri dengan",
        "not_end_all": "tidak diakhiri dengan semua",
        "not_end_any": "tidak diakhiri dengan beberapa",
        "not_eq": "tidak sama dengan",
        "not_eq_all": "tidak semua seluruhnya dengan",
        "not_eq_any": "tidak sama beberapa dengan",
        "not_in": "tidak di",
        "not_in_all": "tidak semua di",
        "not_in_any": "tidak di beberapa",
        "not_null": "tidak null",
        "not_start": "tidak diawali dengan",
        "not_start_all": "tidak diawali semua dengan",
        "not_start_any": "tidak diawali beberapa dengan",
        "null": "null",
        "present": "ada",
        "start": "diawali dengan",
        "start_all": "diawali semua dengan",
        "start_any": "diawali beberapa dengan",
        "true": "bernilai benar"
      },
      "search": "cari",
      "sort": "urutan",
      "value": "data"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%d %B %Y %H:%M:%S"
            }
          }
        }
      }
    }
  },
  "it": {
    "active_admin": {
      "access_denied": {
        "message": "Non hai le autorizzazioni necessarie per eseguire questa azione."
      },
      "any": "Qualsiasi",
      "batch_actions": {
        "action_label": "%{title} Selezionati",
        "button_label": "Azioni multiple",
        "default_confirmation": "Sei sicuro di che voler proseguire?",
        "delete_confirmation": "Sei sicuro di volere cancellare %{plural_model}?",
        "labels": {
          "destroy": "Elimina"
        },
        "selection_toggle_explanation": "(cambia selezione)",
        "succesfully_destroyed": {
          "one": "Eliminato con successo 1 %{model}",
          "other": "Eliminati con successo %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Non sono presenti %{resource_name}",
        "link": "Crea nuovo/a"
      },
      "cancel": "Annulla",
      "comments": {
        "add": "Aggiungi Commento",
        "author": "Autore",
        "author_missing": "Anonimo",
        "author_type": "Tipo di Autore",
        "body": "Corpo",
        "created_at": "Creato il",
        "delete": "Cancella Commento",
        "delete_confirmation": "Sei sicuro di voler cancellare questo commento?",
        "errors": {
          "empty_text": "Il commento non può essere salvato, il testo è vuoto."
        },
        "no_comments_yet": "Nessun commento.",
        "resource": "Risorsa",
        "resource_type": "Tipo di risorsa",
        "title_content": "Commenti (%{count})"
      },
      "create_another": "Crea un altro %{model}",
      "dashboard": "Dashboard",
      "dashboard_welcome": {
        "call_to_action": "Per aggiungere sezioni alla dashboard controlla il file 'app/admin/dashboard.rb'",
        "welcome": "Benvenuti in Active Admin. Questa è la pagina dashboard di default."
      },
      "delete": "Rimuovi",
      "delete_confirmation": "Sei sicuro di volerlo rimuovere?",
      "delete_model": "Rimuovi %{model}",
      "details": "Dettagli %{model}",
      "devise": {
        "change_password": {
          "submit": "Cambia la mia password",
          "title": "Cambia la tua password"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Dimenticato la password?",
          "resend_confirmation_instructions": "Invia di nuovo le istruzioni per la conferma",
          "resend_unlock_instructions": "Invia di nuovo le istruzioni per lo sblocco",
          "sign_in": "Entra",
          "sign_in_with_omniauth_provider": "Collegati a %{provider}",
          "sign_up": "Iscriviti"
        },
        "login": {
          "remember_me": "Ricordami",
          "submit": "Entra",
          "title": "Entra"
        },
        "password": {
          "title": "Password"
        },
        "password_confirmation": {
          "title": "Conferma password"
        },
        "resend_confirmation_instructions": {
          "submit": "Invia di nuovo le istruzioni per la conferma",
          "title": "Invia di nuovo le istruzioni per la conferma"
        },
        "reset_password": {
          "submit": "Reimposta la tua password",
          "title": "Dimenticato la password?"
        },
        "sign_up": {
          "submit": "Iscriviti",
          "title": "Iscriviti"
        },
        "subdomain": {
          "title": "Sottodominio"
        },
        "unlock": {
          "submit": "Invia di nuovo le istruzioni per sbloccare",
          "title": "Invia di nuovo le istruzioni per sbloccare"
        },
        "username": {
          "title": "Nome Utente"
        }
      },
      "download": "Scarica:",
      "dropdown_actions": {
        "button_label": "Azioni"
      },
      "edit": "Modifica",
      "edit_model": "Modifica %{model}",
      "empty": "Vuoto",
      "filters": {
        "buttons": {
          "clear": "Rimuovi filtri",
          "filter": "Filtra"
        },
        "predicates": {
          "from": "Da",
          "to": "A"
        }
      },
      "has_many_delete": "Rimuovi",
      "has_many_new": "Aggiungi nuovo/a %{model}",
      "has_many_remove": "Rimuovi",
      "index_list": {
        "block": "Lista",
        "blog": "Blog",
        "grid": "Griglia",
        "table": "Tabella"
      },
      "logout": "Esci",
      "main_content": "Devi implemetare %{model}#main_content per mostrarne il contenuto.",
      "move": "Sposta",
      "new_model": "Aggiungi %{model}",
      "next": "Prossimo",
      "pagination": {
        "empty": "Nessun %{model} trovato",
        "entry": {
          "one": "voce",
          "other": "voci"
        },
        "multiple": "Sto mostrando %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> di <b>%{total}</b> in totale",
        "multiple_without_total": "Sto mostrando %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Sto mostrando <b>1</b> %{model}",
        "one_page": "Sto mostrando <b>%{n}</b> %{model}. Lista completa.",
        "per_page": "Oggetti per pagina: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Precedente",
      "scopes": {
        "all": "Tutti"
      },
      "search_status": {
        "current_filters": "Filtri attivi:",
        "current_scope": "Contesto selezionato:",
        "headline": "Situazione filtri:",
        "no_current_filters": "Nessuno"
      },
      "sidebars": {
        "filters": "Filtri",
        "search_status": "Informazioni sulla ricerca"
      },
      "status_tag": {
        "no": "No",
        "unset": "No",
        "yes": "Sì"
      },
      "unsupported_browser": {
        "headline": "Avviso: ActiveAdmin non supporta Internet Explorer 8 o inferiore",
        "recommendation": "Ti raccomandiamo di aggiornare alla versione più recente di <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, o <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Se stai utilizzando Internet Explorer 9 o successivo, assicurati di <a href=\"https://support.microsoft.com/it-it/help/17471\">disabilitare la \"Modalità Compatibilità\"</a>."
      },
      "view": "Mostra"
    },
    "activerecord": {
      "attributes": {
        "active_admin/comment": {
          "author_type": "Tipo di Autore",
          "body": "Corpo",
          "created_at": "Creato il",
          "namespace": "Namespace",
          "resource_type": "Tipo di risorsa",
          "updated_at": "Aggiornato il"
        },
        "user": {
          "current_password": "Password corrente",
          "email": "Email",
          "password": "Password",
          "password_confirmation": "Conferma password",
          "remember_me": "Ricordami"
        }
      },
      "models": {
        "active_admin/comment": {
          "one": "Commento",
          "other": "Commenti"
        },
        "comment": {
          "one": "Commento",
          "other": "Commenti"
        },
        "user": "Utente"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Invia di nuovo le istruzioni per la conferma"
        }
      },
      "failure": {
        "expired": "Il tuo account è stato bloccato per inattività. Contatta l amministratore del sito.",
        "invited": "Hai un invito in sospeso, accettalo per completare la creazione del tuo account.",
        "session_limited": "Hai effettuato l accesso in un altro browser. Fai nuovamente l accesso per connetterti in questo."
      },
      "invalid_captcha": "Il captcha inserito non è valido!",
      "invalid_security_question": "La risposta alla domanda di sicurezza non è valida.",
      "invitations": {
        "edit": {
          "header": "Imposta la tua password",
          "submit_button": "Imposta la password"
        },
        "invitation_removed": "Il tuo invito è stato rimosso.",
        "invitation_token_invalid": "Il token di invito fornito non è valido!",
        "new": {
          "header": "Inoltra l'invito",
          "submit_button": "Inoltra un invito"
        },
        "no_invitations_remaining": "Non sono più disponibili inviti.",
        "send_instructions": "Un'email di invito è stata inoltrata a %{email}.",
        "updated": "La tua password è stata impostata correttamente. Ora sei connesso.",
        "updated_not_active": "La tua password è stata impostata correttamente."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Conferma il mio account",
          "greeting": "Benvenuto %{recipient}!",
          "instruction": "Puoi confermare il tuo account cliccando sul link qui sotto:"
        },
        "invitation_instructions": {
          "accept": "Accetta l'invito",
          "accept_until": "L'invito sarà valido fino a %{due_date}.",
          "hello": "Buongiorno %{email}",
          "ignore": "Se non si desidera accettare l'invito si prega di ignorare la presente email.<br />L'account non sarà creato finché non verrà impostata la password tramite il link precedente.",
          "someone_invited_you": "Qualcuno ti ha invitato a %{url}, accetta tramite il link qua sotto.",
          "subject": "Istruzioni per l'invito"
        },
        "reset_password_instructions": {
          "action": "Cambia la mia password",
          "greeting": "Ciao %{recipient}!",
          "instruction": "Qualcuno ha richiesto di resettare la tua password, se lo vuoi davvero puoi farlo cliccando sul link qui sotto.",
          "instruction_2": "Se non sei stato tu ad effettuare questa richiesta puoi ignorare questa mail.",
          "instruction_3": "La tua password non cambierà finchè non accederai al link sopra."
        },
        "unlock_instructions": {
          "action": "Sblocca il mio account",
          "greeting": "Ciao %{recipient}!",
          "instruction": "Clicca sul link qui sotto per sbloccare il tuo account:",
          "message": "Il tuo account è stato bloccato a seguito di un numero eccessivo di tentativi di accesso falliti."
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Invia",
          "submit_verification_code": "Invia codice di verifica",
          "verification_code": "Codice di verifica"
        },
        "updated": "Codice di verifica accettato"
      },
      "paranoid_verify": {
        "code_required": "Inserisci il codice fornito dal nostro team di supporto"
      },
      "password_expired": {
        "change_required": "La tua password è scaduta. Si prega di rinnovarla!",
        "show": {
          "change_my_password": "Cambia la mia password",
          "current_password": "Password attuale",
          "new_password": "Nuova password",
          "new_password_confirmation": "Conferma nuova password",
          "renew_your_password": "Rinnova la tua password"
        },
        "updated": "La tua nuova password è stata salvata."
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": "Cambia la tua password",
          "confirm_new_password": "Conferma la nuova password",
          "new_password": "Nuova password"
        },
        "new": {
          "forgot_your_password": "Password dimenticata?",
          "send_me_reset_password_instructions": "Inviami le istruzioni per resettare la password"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Sei sicuro?",
          "cancel_my_account": "Rimuovi il mio account",
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": "lascia in bianco se non vuoi cambiarla",
          "title": "Modifica %{resource}",
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": "abbiamo bisogno della tua password attuale per confermare i cambiamenti"
        },
        "new": {
          "sign_up": "Registrati"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Accedi"
        }
      },
      "shared": {
        "links": {
          "back": "Indietro",
          "didn_t_receive_confirmation_instructions": "Non hai ricevuto le istruzioni per la conferma?",
          "didn_t_receive_unlock_instructions": "Non hai ricevuto le istruzioni per lo sblocco?",
          "forgot_your_password": "Password dimenticata?",
          "sign_in": "Accedi",
          "sign_in_with_provider": "Accedi con %{provider}",
          "sign_up": "Registrati"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Invia di nuovo le istruzioni per lo sblocco"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "ha un formato non valido (i rapporti di aspetto validi sono %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "deve essere orizzontale (il file corrente è %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "deve essere ritratto (il file corrente è %{width}x%{height}px)",
        "aspect_ratio_not_square": "deve essere quadrato (il file corrente è %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "deve essere %{authorized_aspect_ratios} (il file corrente è %{width}x%{height}px)",
        "attachment_missing": "non ha un file allegato",
        "audio_missing": "deve contenere una traccia audio",
        "audio_present": "non deve contenere una traccia audio",
        "content_type_invalid": {
          "one": "ha un tipo di contenuto non valido (il tipo di contenuto autorizzato è %{authorized_human_content_types})",
          "other": "ha un tipo di contenuto non valido (i tipi di contenuto autorizzati sono %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "ha un tipo di contenuto non equivalente a quello rilevato attraverso il suo contenuto (il tipo di contenuto autorizzato è %{authorized_human_content_types})",
          "other": "ha un tipo di contenuto non equivalente a quello rilevato attraverso il suo contenuto (i tipi di contenuto autorizzati sono %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "l’altezza deve essere pari a %{length} pixel",
        "dimension_height_not_greater_than_or_equal_to": "l’altezza deve essere maggiore o uguale a %{length} pixel",
        "dimension_height_not_included_in": "l’altezza deve essere compresa tra %{min} e %{max} pixel",
        "dimension_height_not_less_than_or_equal_to": "l’altezza deve essere minore o uguale a %{length} pixel",
        "dimension_max_not_included_in": "deve essere minore o uguale a %{width} x %{height} pixel",
        "dimension_min_not_included_in": "deve essere maggiore o uguale a %{width} x %{height} pixel",
        "dimension_width_not_equal_to": "la larghezza deve essere pari a %{length} pixel",
        "dimension_width_not_greater_than_or_equal_to": "la larghezza deve essere maggiore o uguale a %{length} pixel",
        "dimension_width_not_included_in": "la larghezza deve essere compresa tra %{min} e %{max} pixel",
        "dimension_width_not_less_than_or_equal_to": "la larghezza deve essere minore o uguale a %{length} pixel",
        "duration_not_between": "la durata deve essere compresa tra %{min} e %{max} (la durata corrente è %{duration})",
        "duration_not_equal_to": "la durata deve essere uguale a %{exact} (la durata corrente è %{duration})",
        "duration_not_greater_than": "la durata deve essere superiore a %{min} (la durata corrente è %{duration})",
        "duration_not_greater_than_or_equal_to": "la durata deve essere maggiore o uguale a %{min} (la durata corrente è %{duration})",
        "duration_not_less_than": "la durata deve essere inferiore a %{max} (la durata corrente è %{duration})",
        "duration_not_less_than_or_equal_to": "la durata deve essere inferiore o uguale a %{max} (la durata corrente è %{duration})",
        "equal_to_current_password": " deve essere differente dalla password corrente!",
        "equal_to_email": "deve essere differente dall'email",
        "file_not_processable": "non è identificato come file multimediale valido",
        "file_size_not_between": "la dimensione del file deve essere compresa tra %{min} e %{max} (la dimensione attuale è %{file_size})",
        "file_size_not_equal_to": "la dimensione del file deve essere uguale a %{exact} (la dimensione attuale è %{file_size})",
        "file_size_not_greater_than": "la dimensione del file deve essere maggiore di %{min} (la dimensione attuale è %{file_size})",
        "file_size_not_greater_than_or_equal_to": "la dimensione del file deve essere maggiore o uguale a %{min} (la dimensione attuale è %{file_size})",
        "file_size_not_less_than": "la dimensione del file deve essere inferiore a %{max} (la dimensione attuale è %{file_size})",
        "file_size_not_less_than_or_equal_to": "la dimensione del file deve essere minore o uguale a %{max} (la dimensione attuale è %{file_size})",
        "limit_max_exceeded": {
          "one": "troppi file allegati (massimo è %{max} file, ottenuto %{count})",
          "other": "troppi file allegati (massimo è %{max} file, ottenuto %{count})",
          "zero": "nessun file allegato (massimo è %{max} file)"
        },
        "limit_min_not_reached": {
          "one": "solo 1 file allegato (deve avere almeno %{min} file)",
          "other": "%{count} file allegati (deve avere almeno %{min} file)",
          "zero": "nessun file allegato (deve avere almeno %{min} file)"
        },
        "limit_out_of_range": {
          "one": "solo 1 file allegato (deve avere tra %{min} e %{max} file)",
          "other": "il numero totale di file deve essere compreso tra %{min} e %{max} file (ci sono %{count} file allegati)",
          "zero": "nessun file allegato (deve avere tra %{min} e %{max} file)"
        },
        "media_metadata_missing": "non è un file multimediale valido",
        "pages_not_between": "il numero di pagine deve essere compreso tra %{min} e %{max} (il numero di pagine corrente è %{pages})",
        "pages_not_equal_to": "il numero di pagine deve essere uguale a %{exact} (il numero di pagine corrente è %{pages})",
        "pages_not_greater_than": "il numero di pagine deve essere maggiore di %{min} (il numero di pagine corrente è %{pages})",
        "pages_not_greater_than_or_equal_to": "il numero di pagine deve essere maggiore o uguale a %{min} (il numero di pagine corrente è %{pages})",
        "pages_not_less_than": "il numero di pagine deve essere inferiore a %{max} (il numero di pagine corrente è %{pages})",
        "pages_not_less_than_or_equal_to": "il numero di pagine deve essere inferiore o uguale a %{max} (il numero di pagine corrente è %{pages})",
        "password_complexity": {
          "digit": {
            "one": "deve contenere almeno una cifra",
            "other": "deve contenere almeno %{count} cifre"
          },
          "lower": {
            "one": "deve contenere almeno una lettera minuscola",
            "other": "deve contenere almeno %{count} lettere minuscole"
          },
          "symbol": {
            "one": "deve contenere almeno un simbolo di punteggiatura o un simbolo speciale",
            "other": "deve contenere almeno %{count} tra simboli di punteggiatura e simboli speciali"
          },
          "upper": {
            "one": "deve contenere almeno una lettera maiuscola",
            "other": "deve contenere almeno %{count} lettere maiuscole"
          }
        },
        "taken_in_past": "è stata gia' utilizzata in passato!",
        "total_file_size_not_between": "la dimensione totale dei file deve essere compresa tra %{min} e %{max} (la dimensione attuale è %{total_file_size})",
        "total_file_size_not_equal_to": "la dimensione totale dei file deve essere uguale a %{exact} (la dimensione attuale è %{total_file_size})",
        "total_file_size_not_greater_than": "la dimensione totale dei file deve essere maggiore di %{min} (la dimensione attuale è %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "la dimensione totale dei file deve essere maggiore o uguale a %{min} (la dimensione attuale è %{total_file_size})",
        "total_file_size_not_less_than": "la dimensione totale dei file deve essere inferiore a %{max} (la dimensione attuale è %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "la dimensione totale dei file deve essere minore o uguale a %{max} (la dimensione attuale è %{total_file_size})"
      }
    },
    "formtastic": {
      "cancel": "Annulla",
      "create": "Crea %{model}",
      "no": "No",
      "required": "obbligatorio",
      "reset": "Ripristina %{model}",
      "submit": "Invia",
      "update": "Aggiorna %{model}",
      "yes": "Sì"
    },
    "numbers": {
      "hundreds": "cento",
      "mega": [
        "_",
        "mille",
        "milione",
        "miliardo",
        "triliardo",
        "quadrillion",
        "quintillion",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
        "decillion"
      ],
      "ones": [
        "zero",
        "uno",
        "due",
        "tre",
        "quattro",
        "cinque",
        "sei",
        "sette",
        "otto",
        "nove"
      ],
      "teens": [
        "_",
        "undici",
        "dodici",
        "tredici",
        "quattordici",
        "quindici",
        "sedici",
        "diciasette",
        "diciotto",
        "diciannove"
      ],
      "tens": [
        "_",
        "dieci",
        "venti",
        "trenta",
        "quaranta",
        "cinquanta",
        "sessanta",
        "settanta",
        "ottanta",
        "novanta"
      ]
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Pagina",
          "other": "Pagine"
        },
        "next": "Seguente",
        "previous": "Precedente"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Visualizzazione %{item_name} %{from}-%{to} di %{count} in totale",
        "no_count": "Pagina %{page} di %{pages}",
        "no_items": "Nessun %{item_name} trovato",
        "single_page": "Visualizzazione di %{count} %{item_name}"
      },
      "input_nav_js": "Pagina %{page_input} di %{pages}",
      "item_name": {
        "one": "elemento",
        "other": "elementi"
      },
      "limit_tag_js": "Mostra %{limit_input} %{item_name} per pagina",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "tutti",
      "and": "e",
      "any": "qualsiasi",
      "asc": "crescente",
      "attribute": "attributo",
      "combinator": "combinatore",
      "condition": "condizione",
      "desc": "decrescente",
      "or": "o",
      "predicate": "predicato",
      "predicates": {
        "blank": "è vuoto",
        "cont": "contiene",
        "cont_all": "contiene tutti",
        "cont_any": "contiene almeno un",
        "does_not_match": "non corrisponde",
        "does_not_match_all": "non corrisponde con nessuno",
        "does_not_match_any": "non corrisponde ad uno qualsiasi",
        "end": "finisce con",
        "end_all": "finisce con tutti",
        "end_any": "finisce con almeno un",
        "eq": "uguale a",
        "eq_all": "uguale ad ognuno",
        "eq_any": "uguale ad almeno un",
        "false": "è falso",
        "gt": "maggiore di",
        "gt_all": "maggiore di tutti",
        "gt_any": "maggiore di almeno un",
        "gteq": "maggiore o uguale a",
        "gteq_all": "maggiore o uguale a tutti",
        "gteq_any": "maggiore o uguale ad almeno un",
        "in": "in",
        "in_all": "in tutti",
        "in_any": "in almeno un",
        "lt": "minore di",
        "lt_all": "minore di tutti",
        "lt_any": "minore di almeno un",
        "lteq": "minore o uguale a",
        "lteq_all": "minore o uguale a tutti",
        "lteq_any": "minore o uguale ad almeno un",
        "matches": "combacia con",
        "matches_all": "combacia con tutti",
        "matches_any": "combacia con almeno un",
        "not_cont": "non contiene",
        "not_cont_all": "non contiene nessuno",
        "not_cont_any": "non contiene un qualsiasi",
        "not_end": "non finisce con",
        "not_end_all": "non finisce con nessuno",
        "not_end_any": "non finisce con uno qualsiasi",
        "not_eq": "diverso da",
        "not_eq_all": "diverso da tutti",
        "not_eq_any": "diverso da uno qualsiasi",
        "not_in": "non in",
        "not_in_all": "non in tutti",
        "not_in_any": "non in almeno un",
        "not_null": "non è nullo",
        "not_start": "non inizia con",
        "not_start_all": "non inizia con nessuno",
        "not_start_any": "non inizia con uno qualsiasi",
        "null": "è nullo",
        "present": "è presente",
        "start": "inizia con",
        "start_all": "inizia con tutti",
        "start_any": "inizia con almeno un",
        "true": "è vero"
      },
      "search": "cerca",
      "sort": "ordinamento",
      "value": "valore"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Ops, non siamo riusciti a convalidare la tua risposta reCAPTCHA. Per favore riprova.",
        "verification_failed": "La verifica reCAPTCHA non è riuscita, si prega di riprovare."
      }
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        }
      }
    }
  },
  "ja": {
    "active_admin": {
      "access_denied": {
        "message": "アクションを実行する権限がありません"
      },
      "any": "任意",
      "batch_actions": {
        "action_label": "選択した行を%{title}",
        "button_label": "一括操作",
        "default_confirmation": "本当によろしいですか？",
        "delete_confirmation": "%{plural_model} を削除してもよろしいですか？",
        "labels": {
          "destroy": "削除する"
        },
        "selection_toggle_explanation": "(選択)",
        "succesfully_destroyed": {
          "one": "1件の %{model} を削除しました",
          "other": "%{count}件の %{plural_model} を削除しました"
        }
      },
      "blank_slate": {
        "content": "%{resource_name} はまだありません。",
        "link": "作成する"
      },
      "cancel": "取り消す",
      "comments": {
        "add": "コメントを追加",
        "author": "作成者",
        "author_missing": "匿名ユーザ",
        "author_type": "作成者種別",
        "body": "本文",
        "created_at": "作成日",
        "delete": "コメントを削除",
        "delete_confirmation": "本当にコメントを削除しますか？",
        "errors": {
          "empty_text": "テキストが空のため、コメントは保存されませんでした。"
        },
        "no_comments_yet": "コメントはまだありません。",
        "resource": "リソース",
        "resource_type": "リソース種別",
        "title_content": "コメント (%{count})"
      },
      "create_another": "%{model} を続けて作成する",
      "dashboard": "ダッシュボード",
      "dashboard_welcome": {
        "call_to_action": "ダッシュボードに項目を追加するために 'app/admin/dashboard.rb' を編集してください。",
        "welcome": "Active Admin へようこそ。ダッシュボードの初期ページを表示しています。"
      },
      "delete": "削除",
      "delete_confirmation": "本当に削除しますか？",
      "delete_model": "%{model} を削除する",
      "details": "%{model} の詳細",
      "devise": {
        "change_password": {
          "submit": "パスワードを変更する",
          "title": "パスワードを変更する"
        },
        "email": {
          "title": "メールアドレス"
        },
        "links": {
          "forgot_your_password": "パスワードをお忘れですか？",
          "resend_confirmation_instructions": "ユーザ確認手順を再送する",
          "resend_unlock_instructions": "ロックの解除方法を再送する",
          "sign_in": "サインイン",
          "sign_in_with_omniauth_provider": "%{provider}のアカウントを使ってログイン",
          "sign_up": "ユーザ登録"
        },
        "login": {
          "remember_me": "次回から自動的にログイン",
          "submit": "ログイン",
          "title": "ログイン"
        },
        "password": {
          "title": "パスワード"
        },
        "resend_confirmation_instructions": {
          "submit": "確認方法を再送信する",
          "title": "確認方法を再送信する"
        },
        "reset_password": {
          "submit": "パスワードをリセットする",
          "title": "パスワードをお忘れですか？"
        },
        "sign_up": {
          "submit": "登録",
          "title": "登録"
        },
        "subdomain": {
          "title": "サブドメイン"
        },
        "unlock": {
          "submit": "ロックの解除方法を送る",
          "title": "ロックの解除方法を送る"
        },
        "username": {
          "title": "ユーザ名"
        }
      },
      "download": "ダウンロード:",
      "dropdown_actions": {
        "button_label": "操作"
      },
      "edit": "編集",
      "edit_model": "%{model} を編集する",
      "empty": "空",
      "filters": {
        "buttons": {
          "clear": "条件を削除する",
          "filter": "絞り込む"
        },
        "predicates": {
          "from": "開始",
          "to": "終了"
        }
      },
      "has_many_delete": "削除する",
      "has_many_new": "%{model} を追加する",
      "has_many_remove": "削除する",
      "index_list": {
        "block": "リスト",
        "blog": "ブログ",
        "grid": "グリッド",
        "table": "テーブル"
      },
      "logout": "ログアウト",
      "main_content": "内容を表示するために %{model}#main_content を実装してください。",
      "new_model": "%{model} を作成する",
      "next": "次",
      "pagination": {
        "empty": "%{model} は見つかりませんでした",
        "entry": {
          "one": "レコード",
          "other": "レコード"
        },
        "multiple": "全 <b>%{total}</b> 件中 <b>%{from}&nbsp;-&nbsp;%{to}</b> 件の %{model} を表示しています",
        "multiple_without_total": "<b>%{from}&nbsp;-&nbsp;%{to}</b> 件の %{model} を表示しています",
        "one": "<b>1</b> 件の %{model} を表示しています",
        "one_page": "<b>全 %{n}</b> 件の %{model} を表示しています",
        "per_page": "表示件数: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "前",
      "search_status": {
        "current_filters": "現在の絞り込み:",
        "current_scope": "範囲:",
        "headline": "検索条件:",
        "no_current_filters": "なし"
      },
      "sidebars": {
        "filters": "検索条件",
        "search_status": "検索状態"
      },
      "status_tag": {
        "no": "いいえ",
        "unset": "いいえ",
        "yes": "はい"
      },
      "unsupported_browser": {
        "headline": "ActiveAdminは、Internet Explorer 8以下はサポートはしていません。",
        "recommendation": "最新版の<a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>、<a href=\"https://chrome.google.com/\">Google Chrome</a>、もしくは<a href=\"https://mozilla.org/firefox/\">Firefox</a>を使うことを推奨します。",
        "turn_off_compatibility_view": "Internet Explorer 9以降を使っている場合、<a href=\"https://support.microsoft.com/ja-jp/help/17471\">互換表示をオフ</a>にしてください。"
      },
      "view": "閲覧"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "現在のパスワード",
          "email": "メールアドレス",
          "password": "パスワード",
          "password_confirmation": "確認用パスワード",
          "remember_me": "ログインを記憶"
        }
      },
      "models": {
        "user": "ユーザ"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "アカウント確認メール再送"
        }
      },
      "failure": {
        "expired": "活動がなかったため、あなたのアカウントは期限切れとなりました。サイト管理者に連絡してください。",
        "invited": "アカウントを作成するには、保留中の招待を承認してください。",
        "session_limited": "他のブラウザでログインされました。このブラウザで続ける場合は、もう一度サインインしてください。"
      },
      "invalid_captcha": "キャプチャ入力が不正です。",
      "invalid_security_question": "セキュリティ質問に対する回答が不正です。",
      "invitations": {
        "edit": {
          "header": "パスワードを設定する",
          "submit_button": "パスワードを設定する"
        },
        "invitation_removed": "招待を取り消しました。",
        "invitation_token_invalid": "招待コードが不正です。",
        "new": {
          "header": "招待する",
          "submit_button": "招待メールを送る"
        },
        "no_invitations_remaining": "これ以上招待できません。",
        "send_instructions": "招待メールが%{email}に送信されました。",
        "updated": "パスワードが設定されました。お使いのアカウントでログインできます。",
        "updated_not_active": "パスワードが設定されました。"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "アカウント確認",
          "greeting": "ようこそ、%{recipient}さん!",
          "instruction": "次のリンクでメールアドレスの確認が完了します:"
        },
        "invitation_instructions": {
          "accept": "招待を承認する",
          "accept_until": "この招待は%{due_date}まで有効です。",
          "hello": "こんにちは、%{email}さん",
          "ignore": "招待を承認しない場合は、このメールを無視してください。<br />あなたのアカウントは上記のリンク先にアクセスしパスワードを設定するまでは作成されません。",
          "someone_invited_you": "%{url}に招待されました。以下のリンクから承認できます。",
          "subject": "招待を承認するには"
        },
        "reset_password_instructions": {
          "action": "パスワード変更",
          "greeting": "こんにちは、%{recipient}さん!",
          "instruction": "誰かがパスワードの再設定を希望しました。次のリンクでパスワードの再設定が出来ます。",
          "instruction_2": "あなたが希望したのではないのなら、このメールは無視してください。",
          "instruction_3": "上のリンクにアクセスして新しいパスワードを設定するまで、パスワードは変更されません。"
        },
        "unlock_instructions": {
          "action": "アカウントのロック解除",
          "greeting": "こんにちは、%{recipient}さん!",
          "instruction": "アカウントのロックを解除するには下のリンクをクリックしてください。",
          "message": "ログイン失敗が繰り返されたため、アカウントはロックされています。"
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "参加する",
          "submit_verification_code": "確認コードを送信する",
          "verification_code": "検証コード"
        },
        "updated": "確認コードを受け入れました"
      },
      "paranoid_verify": {
        "code_required": "サポートチームに提供された認証コードを入力してください。"
      },
      "password_expired": {
        "change_required": "パスワードが期限切れです。パスワードを新しく設定してください。",
        "show": {
          "change_my_password": "パスワードを変更する",
          "current_password": "現在のパスワード",
          "new_password": "新しいパスワード",
          "new_password_confirmation": "新しいパスワードを確認",
          "renew_your_password": "パスワードを更新する"
        },
        "updated": "新しいパスワードが保存されました。"
      },
      "passwords": {
        "edit": {
          "change_my_password": "パスワードを変更する",
          "change_your_password": "パスワードを変更",
          "confirm_new_password": "確認用新しいパスワード",
          "new_password": "新しいパスワード"
        },
        "new": {
          "forgot_your_password": "パスワードを忘れましたか?",
          "send_me_reset_password_instructions": "パスワードの再設定方法を送信する"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "本当に良いですか?",
          "cancel_my_account": "アカウント削除",
          "currently_waiting_confirmation_for_email": "%{email} の確認待ち",
          "leave_blank_if_you_don_t_want_to_change_it": "空欄のままなら変更しません",
          "title": "%{resource}編集",
          "unhappy": "気に入りません",
          "update": "更新",
          "we_need_your_current_password_to_confirm_your_changes": "変更を反映するには現在のパスワードを入力してください"
        },
        "new": {
          "sign_up": "アカウント登録"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "ログイン"
        }
      },
      "shared": {
        "links": {
          "back": "戻る",
          "didn_t_receive_confirmation_instructions": "アカウント確認のメールを受け取っていませんか?",
          "didn_t_receive_unlock_instructions": "アカウントの凍結解除方法のメールを受け取っていませんか?",
          "forgot_your_password": "パスワードを忘れましたか?",
          "sign_in": "ログイン",
          "sign_in_with_provider": "%{provider}でログイン",
          "sign_up": "アカウント登録"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "アカウントの凍結解除方法を再送する"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "のアスペクト比を検出できません (許可されたアスペクト比は%{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "のアスペクト比は横長にしてください (添付されたメディアの解像度は%{width}x%{height})",
        "aspect_ratio_not_portrait": "のアスペクト比は縦長にしてください (添付されたメディアの解像度は%{width}x%{height})",
        "aspect_ratio_not_square": "のアスペクト比は等しくしてください (添付されたメディアの解像度は%{width}x%{height})",
        "aspect_ratio_not_x_y": "のアスペクト比は%{authorized_aspect_ratios}にしてください (添付されたメディアの解像度は%{width}x%{height})",
        "attachment_missing": "にファイルを添付してください",
        "audio_missing": "には音声トラックが必要です",
        "audio_present": "に音声トラックを含めることはできません",
        "content_type_invalid": {
          "one": "のファイルタイプは許可されていません (許可されたファイルタイプは%{authorized_human_content_types})",
          "other": "のファイルタイプは許可されていません (許可されたファイルタイプは%{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "のファイルタイプがファイル内容から検出されたものと異なります (許可されたファイルタイプは%{authorized_human_content_types})",
          "other": "のファイルタイプがファイル内容から検出されたものと異なります (許可されたファイルタイプは%{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "の縦幅は%{length}ピクセルにしてください",
        "dimension_height_not_greater_than_or_equal_to": "の縦幅は%{length}ピクセル以上にしてください",
        "dimension_height_not_included_in": "の縦幅は%{min}ピクセル以上%{max}ピクセル以下にしてください",
        "dimension_height_not_less_than_or_equal_to": "の縦幅は%{length}ピクセル以下にしてください",
        "dimension_max_not_included_in": "の解像度は%{width}x%{height}ピクセル以下にしてください",
        "dimension_min_not_included_in": "の解像度は%{width}x%{height}ピクセル以上にしてください",
        "dimension_width_not_equal_to": "の横幅は%{length}ピクセルにしてください",
        "dimension_width_not_greater_than_or_equal_to": "の横幅は%{length}ピクセル以上にしてください",
        "dimension_width_not_included_in": "の横幅は%{min}ピクセル以上%{max}ピクセル以下にしてください",
        "dimension_width_not_less_than_or_equal_to": "の横幅は%{length}ピクセル以下にしてください",
        "duration_not_between": "の再生時間は%{min}以上%{max}以下にしてください (添付ファイルの再生時間は%{duration})",
        "duration_not_equal_to": "の再生時間は%{exact}にしてください (添付ファイルの再生時間は%{duration})",
        "duration_not_greater_than": "の再生時間は%{min}より大きくしてください (添付ファイルの再生時間は%{duration})",
        "duration_not_greater_than_or_equal_to": "の再生時間は%{min}以上にしてください (添付ファイルの再生時間は%{duration})",
        "duration_not_less_than": "の再生時間は%{max}未満にしてください (添付ファイルの再生時間は%{duration})",
        "duration_not_less_than_or_equal_to": "の再生時間は%{max}以下にしてください (添付ファイルの再生時間は%{duration})",
        "equal_to_current_password": "は現在のパスワードと異なるものである必要があります。",
        "equal_to_email": "メールとは異なる必要があります",
        "file_not_processable": "のメディアを処理できません",
        "file_size_not_between": "のファイルサイズは%{min}以上%{max}以下にしてください (添付ファイルのサイズは%{file_size})",
        "file_size_not_equal_to": "のファイルサイズは%{exact}にしてください (添付ファイルのサイズは%{file_size})",
        "file_size_not_greater_than": "のファイルサイズは%{min}より大きくしてください (添付ファイルのサイズは%{file_size})",
        "file_size_not_greater_than_or_equal_to": "のファイルサイズは%{min}以上にしてください (添付ファイルのサイズは%{file_size})",
        "file_size_not_less_than": "のファイルサイズは%{max}未満にしてください (添付ファイルのサイズは%{file_size})",
        "file_size_not_less_than_or_equal_to": "のファイルサイズは%{max}以下にしてください (添付ファイルのサイズは%{file_size})",
        "limit_max_exceeded": {
          "one": "には%{max}件以下のファイルを添付してください (添付されたファイルは%{count}件)",
          "other": "には%{max}件以下のファイルを添付してください (添付されたファイルは%{count}件)",
          "zero": "には%{max}件以下のファイルを添付してください (添付されたファイルは%{count}件)"
        },
        "limit_min_not_reached": {
          "one": "には%{min}件以上のファイルを添付してください (添付されたファイルは%{count}件)",
          "other": "には%{min}件以上のファイルを添付してください (添付されたファイルは%{count}件)",
          "zero": "には%{min}件以上のファイルを添付してください (添付されたファイルは%{count}件)"
        },
        "limit_out_of_range": {
          "one": "には%{min}件以上%{max}以下のファイルを添付してください (添付されたファイルは%{count}件)",
          "other": "には%{min}件以上%{max}以下のファイルを添付してください (添付されたファイルは%{count}件)",
          "zero": "には%{min}件以上%{max}以下のファイルを添付してください (添付されたファイルは%{count}件)"
        },
        "media_metadata_missing": "のメディアのメタデータを検出できません",
        "pages_not_between": "のページ数は%{min}以上%{max}以下にしてください (添付されたファイルは%{pages}ページ)",
        "pages_not_equal_to": "のページ数は%{exact}にしてください (添付されたファイルは%{pages}ページ)",
        "pages_not_greater_than": "のページ数は%{min}より大きくしてください (添付されたファイルは%{pages}ページ)",
        "pages_not_greater_than_or_equal_to": "のページ数は%{min}以上にしてください (添付されたファイルは%{pages}ページ)",
        "pages_not_less_than": "のページ数は%{max}未満にしてください (添付されたファイルは%{pages}ページ)",
        "pages_not_less_than_or_equal_to": "のページ数は%{max}以下にしてください (添付されたファイルは%{pages}ページ)",
        "password_complexity": {
          "digit": {
            "one": "は最低1つの数字を含む必要があります。",
            "other": "は最低%{count}つの数字を含む必要があります。"
          },
          "lower": {
            "one": "は最低1つの小文字英字を含む必要があります。",
            "other": "は最低%{count}つの小文字英字を含む必要があります。"
          },
          "symbol": {
            "one": "は最低1つの記号を含む必要があります。",
            "other": "は最低%{count}つの記号を含む必要があります。"
          },
          "upper": {
            "one": "は最低1つの大文字英字を含む必要があります。",
            "other": "は最低%{count}つの大文字英字を含む必要があります。"
          }
        },
        "taken_in_past": "は既に使われています。",
        "total_file_size_not_between": "のファイルサイズの合計は%{min}以上%{max}以下にしてください (添付ファイルのサイズは%{total_file_size})",
        "total_file_size_not_equal_to": "のファイルサイズの合計は%{exact}にしてください (添付ファイルのサイズは%{total_file_size})",
        "total_file_size_not_greater_than": "のファイルサイズの合計は%{min}より大きくしてください (添付ファイルのサイズは%{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "のファイルサイズの合計は%{min}以上してください (添付ファイルのサイズは%{total_file_size})",
        "total_file_size_not_less_than": "のファイルサイズの合計は%{max}未満にしてください (添付ファイルのサイズは%{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "のファイルサイズの合計は%{max}以下にしてください (添付ファイルのサイズは%{total_file_size})"
      }
    },
    "formtastic": {
      "cancel": "中止",
      "create": "%{model}を作成",
      "no": "いいえ",
      "required": "必須",
      "reset": "リセット",
      "submit": "送信",
      "update": "%{model}を更新",
      "yes": "はい"
    },
    "pagy": {
      "aria_label": {
        "nav": "ページ",
        "next": "次へ",
        "previous": "前へ"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "%{count} 件中 %{from}-%{to} 件目の%{item_name}を表示中",
        "no_count": "%{page} / %{pages} ページ",
        "no_items": "見つかりませんでした",
        "single_page": "%{count} 件の%{item_name}"
      },
      "input_nav_js": "%{page_input} / %{pages} ページ",
      "item_name": "結果",
      "limit_tag_js": "%{limit_input} 件ずつ表示",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "全て",
      "and": "と",
      "any": "いずれか",
      "asc": "昇順",
      "attribute": "属性",
      "combinator": "組み合わせ",
      "condition": "状態",
      "desc": "降順",
      "or": "あるいは",
      "predicate": "は以下である",
      "predicates": {
        "blank": "空である",
        "cont": "含む",
        "cont_all": "全てを含む",
        "cont_any": "いずれかを含む",
        "does_not_match": "合致していない",
        "does_not_match_all": "全てに合致していない",
        "does_not_match_any": "いずれかに合致していない",
        "end": "終わる",
        "end_all": "全てで終わる",
        "end_any": "いずれかで終わる",
        "eq": "等しい",
        "eq_all": "全てに等しい",
        "eq_any": "いずれかに等しい",
        "false": "偽",
        "gt": "大きい",
        "gt_all": "全てより大きい",
        "gt_any": "いずれかより大きい",
        "gteq": "大きいか等しい",
        "gteq_all": "全てより大きいか等しい",
        "gteq_any": "いずれかより大きいか等しい",
        "in": "範囲内である",
        "in_all": "全ての範囲内である",
        "in_any": "いずれかの範囲内である",
        "lt": "小さい",
        "lt_all": "全てよりも小さい",
        "lt_any": "いずれかより小さい",
        "lteq": "小さいか等しい",
        "lteq_all": "全てより小さいか等しい",
        "lteq_any": "いずれかより小さいか等しい",
        "matches": "合致している",
        "matches_all": "全てと合致している",
        "matches_any": "いずれかと合致している",
        "not_cont": "含まない",
        "not_cont_all": "全てを含まない",
        "not_cont_any": "いずれかを含まない",
        "not_end": "どれでも終わらない",
        "not_end_all": "全てで終わらない",
        "not_end_any": "いずれかで終わらない",
        "not_eq": "等しくない",
        "not_eq_all": "全てと等しくない",
        "not_eq_any": "いずれかに等しくない",
        "not_in": "範囲内でない",
        "not_in_all": "全ての範囲内",
        "not_in_any": "いずれかの範囲内でない",
        "not_null": "無効ではない",
        "not_start": "始まらない",
        "not_start_all": "全てで始まらない",
        "not_start_any": "いずれかで始まらない",
        "null": "無効",
        "present": "存在する",
        "start": "始まる",
        "start_all": "全てで始まる",
        "start_any": "どれかで始まる",
        "true": "真"
      },
      "search": "検索",
      "sort": "分類",
      "value": "値"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "reCAPTCHAのレスポンスを検証できませんでした。もう一度お試しください。",
        "verification_failed": "reCAPTCHA認証に失敗しました。もう一度お試しください。"
      }
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%Y年%m月%d日%H時%M分"
            }
          }
        }
      }
    }
  },
  "ka": {
    "numbers": {
      "hundreds": "ასი",
      "mega": [
        "_",
        "ათასი",
        "მილიონი",
        "მილიარდი"
      ],
      "ones": [
        "ნული",
        "ერთი",
        "ორი",
        "სამი",
        "ოთხი",
        "ხუთი",
        "ექვსი",
        "შვიდი",
        "რვა",
        "ცხრა"
      ],
      "partials": {
        "eighty": "ოთხმოცდა",
        "forty": "ორმოცდა",
        "hundreds": "ას",
        "mega": [
          "_",
          "ათას",
          "მილიონ",
          "მილიარდ"
        ],
        "ones": [
          "ნული",
          "ერთი",
          "ორ",
          "სამ",
          "ოთხ",
          "ხუთ",
          "ექვს",
          "შვიდ",
          "რვა",
          "ცხრა"
        ],
        "sixty": "სამოცდა",
        "twenty": "ოცდა"
      },
      "teens": [
        "_",
        "თერთმეტი",
        "თორმეტი",
        "ცამეტი",
        "თოთხმეტი",
        "თხუთმეტი",
        "თექვსმეტი",
        "ჩვიდმეტი",
        "თვრამეტი",
        "ცხრამეტი"
      ],
      "tens": [
        "_",
        "ათი",
        "ოცი",
        "ოცდაათი",
        "ორმოცი",
        "ორმოცდაათი",
        "სამოცი",
        "სამოცდაათი",
        "ოთხმოცი",
        "ოთხმოცდაათი"
      ]
    }
  },
  "km": {
    "pagy": {
      "aria_label": {
        "nav": "ទំព័រ",
        "next": "បន្ទាប់",
        "previous": "មុន"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "បង្ហាញ %{item_name} %{from}-%{to} នៃ %{count} ជាចំនួនសរុប",
        "no_count": "ទំព័រ %{page} នៃ %{pages}",
        "no_items": "មិនមាន %{item_name} ទេ",
        "single_page": "បង្ហាញ %{count} %{item_name}"
      },
      "input_nav_js": "ទំព័រ %{page_input} នៃ %{pages}",
      "item_name": "ធាតុ",
      "limit_tag_js": "បង្ហាញ %{limit_input} %{item_name} ក្នុង ១ ទំព័រ",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    }
  },
  "ko": {
    "active_admin": {
      "any": "어떤",
      "batch_actions": {
        "action_label": "선택한 항목 %{title}",
        "button_label": "배치 작업",
        "default_confirmation": "확실하십니까?",
        "delete_confirmation": "%{plural_model}을/를 삭제하시겠습니까?",
        "labels": {
          "destroy": "삭제"
        },
        "selection_toggle_explanation": "(선택 항목 바꾸기)",
        "succesfully_destroyed": {
          "one": "성공적으로 1개 %{model}을/를 삭제하였습니다",
          "other": "성공적으로 %{count}개의 %{plural_model}을/를 삭제하였습니다"
        }
      },
      "blank_slate": {
        "content": "아직 %{resource_name} 이/가 없습니다.",
        "link": "추가하기"
      },
      "cancel": "취소",
      "comments": {
        "add": "댓글 추가",
        "author": "글쓴이",
        "author_type": "글쓴이 종류",
        "body": "내용",
        "created_at": "작성시간",
        "errors": {
          "empty_text": "댓글이 저장되지 않았습니다. 내용을 입력해주세요."
        },
        "no_comments_yet": "아직 댓글이 없습니다.",
        "resource": "첨부파일",
        "resource_type": "첨부파일 형태",
        "title_content": "댓글 (%{count})"
      },
      "dashboard": "대시보드",
      "dashboard_welcome": {
        "call_to_action": "대시보드에 섹션을 추가하시려면 'app/admin/dashboard.rb' 파일을 수정하십시오.",
        "welcome": "ActiveAdmin에 오신 것을 환영합니다. 기본 대시보드 페이지 입니다."
      },
      "delete": "삭제",
      "delete_confirmation": "정말로 삭제 하시겠습니까?",
      "delete_model": "%{model} 삭제",
      "details": "%{model} 상세보기",
      "devise": {
        "change_password": {
          "submit": "내 비밀번호 변경",
          "title": "비밀번호 변경"
        },
        "email": {
          "title": "이메일"
        },
        "links": {
          "forgot_your_password": "비밀번호를 잊으셨나요?",
          "resend_confirmation_instructions": "계정 승인 요청하기",
          "resend_unlock_instructions": "계정 잠금 해제하기",
          "sign_in": "로그인",
          "sign_in_with_omniauth_provider": "%{provider} 으로 로그인"
        },
        "login": {
          "remember_me": "내 계정 정보 기억",
          "submit": "로그인",
          "title": "로그인"
        },
        "password": {
          "title": "비밀번호"
        },
        "resend_confirmation_instructions": {
          "submit": "계정 승인 요청하기",
          "title": "계정 승인 요청하기"
        },
        "reset_password": {
          "submit": "비밀번호 재설정",
          "title": "비밀번호를 잊으셨나요?"
        },
        "sign_up": {
          "submit": "가입하기",
          "title": "가입하기"
        },
        "subdomain": {
          "title": "서브도메인"
        },
        "unlock": {
          "submit": "계정 잠금 해제하기",
          "title": "계정 잠금 해제하기"
        },
        "username": {
          "title": "아이디"
        }
      },
      "download": "다운로드:",
      "dropdown_actions": {
        "button_label": "작업"
      },
      "edit": "수정",
      "edit_model": "%{model} 수정",
      "empty": "내용이 없습니다",
      "filters": {
        "buttons": {
          "clear": "필터 초기화",
          "filter": "필터"
        }
      },
      "has_many_delete": "삭제",
      "has_many_new": "%{model} 추가",
      "has_many_remove": "삭제",
      "logout": "로그아웃",
      "main_content": "내용을 보시려면 %{model}#main_content의 코드를 먼저 구현해 주시기 바랍니다.",
      "new_model": "%{model} 추가",
      "next": "다음",
      "pagination": {
        "empty": "%{model} 이/가 없습니다.",
        "entry": {
          "one": "항목",
          "other": "항목들"
        },
        "multiple": "<b>%{total}</b>개 중 <b>%{from}&nbsp;-&nbsp;%{to}</b> %{model} 표시중",
        "multiple_without_total": "<b>%{from}&nbsp;-&nbsp;%{to}</b> %{model} 표시중",
        "one": "<b>1</b>개 %{model} 표시중",
        "one_page": "<b>%{n}</b>개 %{model} 표시중"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "이전",
      "search_status": {
        "current_filters": "적용된 필터:",
        "current_scope": "검색 범위:",
        "headline": "검색 상태:",
        "no_current_filters": "현재 적용된 필터가 없습니다"
      },
      "sidebars": {
        "filters": "필터 목록",
        "search_status": "검색 상태"
      },
      "status_tag": {
        "no": "없음",
        "unset": "없음",
        "yes": "있음"
      },
      "view": "보기"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "현재 비밀번호",
          "email": "이메일",
          "password": "비밀번호",
          "password_confirmation": "비밀번호 확인",
          "remember_me": "로그인 정보를 기억합니다"
        }
      },
      "models": {
        "user": "사용자"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "인증 지침 재발송"
        }
      },
      "failure": {
        "invited": "귀하께로 초대장이 발부되었습니다. 초대를 수락하면 계정을 생성할 수 있습니다. "
      },
      "invitations": {
        "edit": {
          "header": "비밀번호 설정",
          "submit_button": "설정하기"
        },
        "invitation_removed": "귀하께로 온 초대장이 삭제되었습니다.",
        "invitation_token_invalid": "제공된 초대장 토큰이 유효하지 않습니다!",
        "new": {
          "header": "초대장 발송",
          "submit_button": "발송하기"
        },
        "no_invitations_remaining": "남은 초대장이 없습니다.",
        "send_instructions": "초대 이메일이 %{email}에게로 발송되었습니다.",
        "updated": "비밀번호가 성공적으로 설정되었으며, 현재 로그인 상태입니다.",
        "updated_not_active": "비밀번호가 성공적으로 설정되었습니다."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "본인 계정 인증",
          "greeting": "%{recipient}님 환영합니다!",
          "instruction": "아래의 링크를 클릭하시면 이메일 인증이 완료됩니다:"
        },
        "invitation_instructions": {
          "accept": "초대수락",
          "hello": "%{email}님 안녕하세요.",
          "ignore": "초대를 원치 않을 경우 이 이메일을 무시해도 됩니다.<br />위의 링크로 접속하여 귀하의 비밀번호를 설정하여 계정을 생성할 수 있습니다.",
          "someone_invited_you": "귀하는 %{url}로 초대되었습니다. 아래의 링크를 클릭하여 초대를 수락할 수 있습니다.",
          "subject": "초대장 안내메일"
        },
        "reset_password_instructions": {
          "action": "비밀번호 변경",
          "greeting": "%{recipient}님 안녕하세요!",
          "instruction": "누군가 당신의 비밀번호를 변경하는 링크를 요청했으며, 다음의 링크에서 비밀번호 변경이 가능합니다.",
          "instruction_2": "이를 요청하지 않으셨다면, 이 메일을 무시하십시오.",
          "instruction_3": "위 링크에 접속하여 새로운 비밀번호를 생성하기 전까지, 귀하의 비밀번호는 변경되지 않습니다."
        },
        "unlock_instructions": {
          "action": "본인 계정 잠금 해제",
          "greeting": "%{recipient}님 안녕하세요!",
          "instruction": "계정 잠금을 해제하려면 아래 링크를 클릭하세요.",
          "message": "로그인 실패 횟수 초과로 귀하의 계정이 잠금 처리되었습니다."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "내 비밀번호를 변경합니다",
          "change_your_password": "비밀번호 변경",
          "confirm_new_password": "새 비밀번호 확인",
          "new_password": "새 비밀번호"
        },
        "new": {
          "forgot_your_password": "비밀번호를 잊으셨나요?",
          "send_me_reset_password_instructions": "비밀번호 재설정 지침을 요청합니다"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "정말로 탈퇴하시겠습니까?",
          "cancel_my_account": "회원 탈퇴",
          "currently_waiting_confirmation_for_email": "현재 다음 이메일 인증 대기중입니다: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "변경을 원하지 않으시면 빈 칸으로 남겨주세요",
          "title": "%{resource} 정보 수정",
          "unhappy": "회원 탈퇴를 하시겠습니까?",
          "update": "변경",
          "we_need_your_current_password_to_confirm_your_changes": "변경 사항을 반영하려면 현재의 비밀번호를 입력하세요"
        },
        "new": {
          "sign_up": "회원 가입"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "로그인"
        }
      },
      "shared": {
        "links": {
          "back": "돌아가기",
          "didn_t_receive_confirmation_instructions": "인증 이메일을 못받으셨나요?",
          "didn_t_receive_unlock_instructions": "잠금 해제 이메일을 못받으셨나요?",
          "forgot_your_password": "비밀번호를 잊으셨나요?",
          "sign_in": "로그인",
          "sign_in_with_provider": "%{provider}(으)로 로그인",
          "sign_up": "회원 가입"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "계정 잠금 해제 재요청"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": "페이지",
        "next": "다음",
        "previous": "이전"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "총 %{count}개의 %{item_name} 중 %{from}-%{to}",
        "no_count": "총 %{pages} 중 %{page} 페이지",
        "no_items": "%{item_name} 없음",
        "single_page": "%{count}개의 %{item_name} 표시됨"
      },
      "input_nav_js": "총 %{pages} 중 %{page_input} 페이지",
      "item_name": "항목",
      "limit_tag_js": "페이지 당 %{limit_input}개 표시%",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "모두",
      "and": "그리고",
      "any": "어떤 것이든",
      "asc": "오름차순",
      "attribute": "속성",
      "combinator": "조합기",
      "condition": "조건",
      "desc": "내림차순",
      "or": "또는",
      "predicate": "조건",
      "predicates": {
        "blank": "비어있음",
        "cont": "포함함",
        "cont_all": "모두 포함함",
        "cont_any": "어떤 것이든 포함함",
        "does_not_match": "일치하지 않음",
        "does_not_match_all": "모두 일치하지 않음",
        "does_not_match_any": "어떤 것이든 일치하지 않음",
        "end": "끝남",
        "end_all": "모두 끝남",
        "end_any": "어떤 것이든 끝남",
        "eq": "같음",
        "eq_all": "모두 같음",
        "eq_any": "어떤 것이든 같음",
        "false": "거짓",
        "gt": "보다 큼",
        "gt_all": "모두 보다 큼",
        "gt_any": "어떤 것이든 보다 큼",
        "gteq": "보다 크거나 같음",
        "gteq_all": "모두 보다 크거나 같음",
        "gteq_any": "어떤 것이든 보다 크거나 같음",
        "in": "포함됨",
        "in_all": "모두 포함됨",
        "in_any": "어떤 것이든 포함됨",
        "lt": "보다 작음",
        "lt_all": "모두 보다 작음",
        "lt_any": "어떤 것이든 보다 작음",
        "lteq": "보다 작거나 같음",
        "lteq_all": "모두 보다 작거나 같음",
        "lteq_any": "어떤 것이든 보다 작거나 같음",
        "matches": "일치함",
        "matches_all": "모두 일치함",
        "matches_any": "어떤 것이든 일치함",
        "not_cont": "포함하지 않음",
        "not_cont_all": "모두 포함하지 않음",
        "not_cont_any": "어떤 것이든 포함하지 않음",
        "not_end": "끝나지 않음",
        "not_end_all": "모두 끝나지 않음",
        "not_end_any": "어떤 것이든 끝나지 않음",
        "not_eq": "같지 않음",
        "not_eq_all": "모두 같지 않음",
        "not_eq_any": "어떤 것이든 같지 않음",
        "not_in": "포함되지 않음",
        "not_in_all": "모두 포함되지 않음",
        "not_in_any": "어떤 것이든 포함되지 않음",
        "not_null": "널이 아님",
        "not_start": "시작하지 않음",
        "not_start_all": "모두 시작하지 않음",
        "not_start_any": "어떤 것이든 시작하지 않음",
        "null": "널",
        "present": "존재함",
        "start": "시작함",
        "start_all": "모두 시작함",
        "start_any": "어떤 것이든 시작함",
        "true": "참"
      },
      "search": "검색",
      "sort": "정렬",
      "value": "값"
    }
  },
  "kz": {
    "numbers": {
      "hundreds": "жүз",
      "mega": [
        "_",
        "мың",
        "миллион",
        "миллиард",
        "триллион",
        "квадриллион",
        "квинтиллион",
        "секстиллион",
        "септиллион",
        "октиллион",
        "нониллион",
        "дециллион"
      ],
      "ones": [
        "нөл",
        "бiр",
        "екi",
        "үш",
        "төрт",
        "бес",
        "алты",
        "жетi",
        "сегiз",
        "тоғыз"
      ],
      "teens": [
        "_",
        "он бiр",
        "он екi",
        "он үш",
        "он төрт",
        "он бес",
        "он алты",
        "он жетi",
        "он сегiз",
        "он тоғыз"
      ],
      "tens": [
        "_",
        "он",
        "жиырма",
        "отыз",
        "қырық",
        "елу",
        "алпыс",
        "жетпiс",
        "сексен",
        "тоқсан"
      ]
    }
  },
  "lt": {
    "active_admin": {
      "access_denied": {
        "message": "Jūs nesate įgaliotas atlikti šį veiksmą."
      },
      "any": "Bet kokia",
      "batch_actions": {
        "action_label": "%{title} Pasirinkta",
        "button_label": "Veiksmai su pažymėtais",
        "default_confirmation": "Ar jūs tikrai norite tai padaryti?",
        "delete_confirmation": "Ar jūs tikrai norite pašalinti šiuos %{plural_model}?",
        "labels": {
          "destroy": "Šalinti"
        },
        "selection_toggle_explanation": "(Žymėti)",
        "succesfully_destroyed": {
          "one": "Sėkmingai pašalintas 1 %{model}",
          "other": "Sėkmingai pašalinti %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Nėra %{resource_name}.",
        "link": "Sukurti"
      },
      "cancel": "Atšaukti",
      "comments": {
        "add": "Pridėti komentarą",
        "author": "Autorius",
        "author_missing": "Anonimas",
        "author_type": "Autoriaus Tipas",
        "body": "Įrašas",
        "created_at": "Sukurta",
        "delete": "Trinti komentarą",
        "delete_confirmation": "Ar tikrai norite ištrinti šį komentarą?",
        "errors": {
          "empty_text": "Komentaras neišsaugotas, tekstas buvo tuščias."
        },
        "no_comments_yet": "Dar nėra komentarų.",
        "resource": "Išteklių",
        "resource_type": "Resurso Tipas",
        "title_content": "Komentarai (%{count})"
      },
      "dashboard": "Valdymo skydelis",
      "dashboard_welcome": {
        "call_to_action": "Norėdami pridėti skydelyje skyrius, žiūrėkite app/admin/dashboard.rb",
        "welcome": "Sveiki atvykę į Active Admin. Tai yra numatytasis valdymo skydelis."
      },
      "delete": "Šalinti",
      "delete_confirmation": "Ar jūs tikrai norite tai pašalinti?",
      "delete_model": "Pašalinti %{model}",
      "details": "%{model} Informacija",
      "devise": {
        "change_password": {
          "submit": "Pakeisti mano slaptažodį",
          "title": "Slaptažodžio Keitimas"
        },
        "email": {
          "title": "El. paštas"
        },
        "links": {
          "forgot_your_password": "Pamiršote slaptažodį?",
          "resend_confirmation_instructions": "Persiųsti patvirtinimo instrukcijas",
          "resend_unlock_instructions": "Persiųsti pakartotinio atrakinimo instrukcijas",
          "sign_in": "Prisijungti",
          "sign_in_with_omniauth_provider": "Prisijungti su %{provider}",
          "sign_up": "Užsiregistruoti"
        },
        "login": {
          "remember_me": "Prisiminti Mane",
          "submit": "Prisijungti",
          "title": "Prisijungimas"
        },
        "password": {
          "title": "Slaptažodis"
        },
        "password_confirmation": {
          "title": "Pakartokite slaptažodį"
        },
        "resend_confirmation_instructions": {
          "submit": "Siųsti patvirtinimo instrukcijas",
          "title": "Patvirtinimo Instrukcijos"
        },
        "reset_password": {
          "submit": "Sukurti Naują Slaptažodį",
          "title": "Pamiršote slaptažodį?"
        },
        "sign_up": {
          "submit": "Užsiregistruoti",
          "title": "Registracija"
        },
        "subdomain": {
          "title": "Subdomenas"
        },
        "unlock": {
          "submit": "Pakartotinai siųsti atrakinimo instrukcijas",
          "title": "Pakartotinio Atrakinimo Instrukcijos"
        },
        "username": {
          "title": "Vartotojo Vardas"
        }
      },
      "download": "Atsisiųsti",
      "dropdown_actions": {
        "button_label": "Veiksmai"
      },
      "edit": "Redaguoti",
      "edit_model": "Redaguoti %{model}",
      "empty": "Tuščia",
      "filters": {
        "buttons": {
          "clear": "Išvalyti filtrus",
          "filter": "Filtras"
        },
        "predicates": {
          "from": "Nuo",
          "to": "Iki"
        }
      },
      "has_many_delete": "Šalinti",
      "has_many_new": "Pridėti naują %{model}",
      "has_many_remove": "Pašalinti",
      "index_list": {
        "block": "Sąrašas",
        "blog": "Blog",
        "grid": "Tinklelis",
        "table": "Lentelė"
      },
      "logout": "Išeiti",
      "main_content": "Prašome realizuoti %{model}#main_content turiniui vaizduoti.",
      "new_model": "Naujas %{model}",
      "next": "Toliau",
      "pagination": {
        "empty": "%{model} nerastas",
        "entry": {
          "one": "įrašas",
          "other": "įrašai"
        },
        "multiple": "Rodomi %{model} <b>%{from}&nbsp;-&nbsp;%{to} </ b> iš<b>%{total} </ b> iš viso",
        "multiple_without_total": "Rodomi %{model} <b>%{from}&nbsp;-&nbsp;%{to} </ b> ",
        "one": "Rodoma <B> 1 </ b> %{model}",
        "one_page": "Rodoma <b>visi %{n} </ b> %{model}",
        "per_page": "Puslapyje: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Atgal",
      "search_status": {
        "current_filters": "Esami filtrai:",
        "current_scope": "Apimtis:",
        "headline": "Paieškos būsena:",
        "no_current_filters": "nėra"
      },
      "sidebars": {
        "filters": "Filtrai",
        "search_status": "Paieškos būsena"
      },
      "status_tag": {
        "no": "Nėra",
        "unset": "Nėra",
        "yes": "Taip"
      },
      "unsupported_browser": {
        "headline": "Atkreipiame dėmesį, kad ActiveAdmin nebepalaiko Internet Explorer 8 arba žemesnių versijų.",
        "recommendation": "Rekomenduojame atsinaujinti į naujausią <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, arba <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Jei naudojate IE 9 ar vėlesnę versiją, įsitikinkite kad <a href=\"http://windows.microsoft.com/en-US/windows7/webpages-look-incorrect-in-Internet-Explorer\">išjungėte \"Suderinamumo rodinį\"</a>."
      },
      "view": "Žiūrėti"
    },
    "i18n": {
      "plural": {}
    },
    "numbers": {
      "billions": {
        "one": "bilijonas",
        "ones": "bilijonai",
        "other": "bilijonų"
      },
      "decillions": {
        "one": "decilijonas",
        "ones": "decilijonai",
        "other": "decilijonų"
      },
      "hundreds": [
        "_",
        "šimtas",
        "du šimtai",
        "trys šimtai",
        "keturi šimtai",
        "penki šimtai",
        "šeši šimtai",
        "septyni šimtai",
        "aštuoni šimtai",
        "devyni šimtai"
      ],
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillion",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "millions": {
        "one": "milijonas",
        "ones": "milijonai",
        "other": "milijonų"
      },
      "nonillions": {
        "one": "nonilijonas",
        "ones": "nonilijonai",
        "other": "nonilijonų"
      },
      "octillions": {
        "one": "oktilijonas",
        "ones": "oktilijonai",
        "other": "oktilijonų"
      },
      "ones": [
        "nulis",
        "vienas",
        "du",
        "trys",
        "keturi",
        "penki",
        "šeši",
        "septyni",
        "aštuoni",
        "devyni"
      ],
      "quadrillions": {
        "one": "kvadrilijonas",
        "ones": "kvadrilijonai",
        "other": "kvadrilijonų"
      },
      "quintillions": {
        "one": "kvintilijonas",
        "ones": "kvadrilijonai",
        "other": "kvadrilijonų"
      },
      "septillions": {
        "one": "septilijonas",
        "ones": "septilijonai",
        "other": "septilijonų"
      },
      "sextillions": {
        "one": "sekstilijonas",
        "ones": "sekstilijonai",
        "other": "sekstilijonų"
      },
      "teens": [
        "_",
        "vienuolika",
        "dvylika",
        "trylika",
        "keturiolika",
        "penkiolika",
        "šešiolika",
        "septyniolika",
        "aštuoniolika",
        "devyniolika"
      ],
      "tens": [
        "_",
        "dešimt",
        "dvidešimt",
        "trisdešimt",
        "keturiasdešimt",
        "penkiasdešimt",
        "šešiasdešimt",
        "septyniasdešimt",
        "aštuoniasdešimt",
        "devyniasdešimt"
      ],
      "thousands": {
        "one": "tūkstantis",
        "ones": "tūkstančiai",
        "other": "tūkstančių"
      },
      "trillions": {
        "one": "trilijonas",
        "ones": "trilijonai",
        "other": "trilijonų"
      }
    }
  },
  "lv": {
    "active_admin": {
      "any": "Jebkurš",
      "batch_actions": {
        "action_label": "%{title} Selected",
        "button_label": "Batch Actions",
        "default_confirmation": "Vai tiešām vēlaties to darīt?",
        "delete_confirmation": "Vai tiešām vēlaties dzēst šos %{plural_model}?",
        "labels": {
          "destroy": "Delete"
        },
        "selection_toggle_explanation": "(Toggle Selection)",
        "succesfully_destroyed": {
          "one": "Successfully deleted 1 %{model}",
          "other": "Successfully deleted %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Sadaļā '%{resource_name}' nav neviena ieraksta.",
        "link": "Izveidot jaunu"
      },
      "cancel": "Atcelt",
      "comments": {
        "add": "Pievienot komentāru",
        "author": "Autors",
        "body": "Saturs",
        "errors": {
          "empty_text": "Komentārs netika saglabāts - nekas nav ierakstīts"
        },
        "no_comments_yet": "Nav neviena komentāra.",
        "resource": "Resurss",
        "title_content": "Komentāri (%{count})"
      },
      "dashboard": "Panelis",
      "dashboard_welcome": {
        "call_to_action": "Izmantojiet 'app/admin/dashboard.rb', lai pievienotu sadaļas panelim.",
        "welcome": "Laipni lūgti Active Admin."
      },
      "delete": "Dzēst",
      "delete_confirmation": "Vai Tu tiešām vēlies dzēst?",
      "delete_model": "Dzēst '%{model}' ierakstu",
      "details": "Apraksts",
      "devise": {
        "change_password": {
          "submit": "Nomainīt savu paroli",
          "title": "Nomainīt paroli"
        },
        "links": {
          "forgot_your_password": "Aizmirsāt savu paroli?",
          "sign_in": "pierakstīties",
          "sign_in_with_omniauth_provider": "Pierakstieties ar %{provider}"
        },
        "login": {
          "remember_me": "atcerēties mani",
          "submit": "Ielogojaties",
          "title": "Ielogojaties"
        },
        "reset_password": {
          "submit": "Atjaunotu savu paroli",
          "title": "Aizmirsāt savu paroli?"
        }
      },
      "download": "Lejuplādēt:",
      "dropdown_actions": {
        "button_label": "Actions"
      },
      "edit": "Labot",
      "edit_model": "Labot '%{model}' ierakstu",
      "empty": "Tukšs",
      "filters": {
        "buttons": {
          "clear": "Novākt filtrus",
          "filter": "Filtrēt"
        }
      },
      "has_many_delete": "Dzēst",
      "has_many_new": "Pievienot jaunu '%{model}' ierakstu",
      "has_many_remove": "Noņemt",
      "logout": "Iziet",
      "main_content": "Lūdzu implementēt %{model}#main_content, lai rādītos saturs.",
      "new_model": "Pievienot '%{model}' ierakstu",
      "next": "Nākošā",
      "pagination": {
        "empty": "Nav ierakstu",
        "entry": {
          "one": "ieraksts",
          "other": "ieraksti"
        },
        "multiple": "<b>%{from}&nbsp;-&nbsp;%{to}</b> ieraksti no <b>%{total}</b> kopā",
        "multiple_without_total": "<b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "<b>1</b> ieraksts",
        "one_page": "<b>%{n}</b> ieraksti"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Iepriekšējā",
      "sidebars": {
        "filters": "Filtri"
      },
      "status_tag": {
        "no": "Nē",
        "unset": "Nē",
        "yes": "Jā"
      },
      "view": "Apskatīt"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Tagadējā parole",
          "email": "Epasts",
          "password": "Parole",
          "password_confirmation": "Apstiprināt paroli",
          "remember_me": "Atcerēties mani"
        }
      },
      "models": {
        "user": "Lietotājs"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Atkārtoti atsūtīt instrukcijas apstiprinājumu"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Apstiprināt kontu",
          "greeting": "Sveicināti, %{recipient}!",
          "instruction": "Jūs varat apstiprināt, Jūsu konta epastu caur saiti zemāk:"
        },
        "reset_password_instructions": {
          "action": "Veikt paroles maiņu",
          "greeting": "Sveicināti, %{recipient}!",
          "instruction": "Kāds ir nosūtijis pieprasijumu, Jūsu paroles maiņai, to var veikt caur saiti zemāk.",
          "instruction_2": "Ja Jūs neveicāt šo pieprasījumu, lūdzu ignorējiet šo ziņu.",
          "instruction_3": "Jūsu parole netiks mainīta, kamēr Jūs neapstiprināsiet saiti augstāk un neizveidosiet jaunu."
        },
        "unlock_instructions": {
          "action": "Atbloķēt kontu",
          "greeting": "Sveicināti, %{recipient}!",
          "instruction": "Nospiežiet uz saites zemāk, lai atbloķētu kontu:",
          "message": "Jūsu konts tika bloķēts vairāku kļūdainu datu ievadīšanas rezultātā."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Mainīt paroli",
          "change_your_password": "Paroles maiņa",
          "confirm_new_password": "Apstiprināt jauno paroli",
          "new_password": "Jauna parole"
        },
        "new": {
          "forgot_your_password": "Aizmirsāt paroli?",
          "send_me_reset_password_instructions": "Atsūtīt paroles maiņas instrukciju"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Vai Jūs esat pārliecināts/-ta?",
          "cancel_my_account": "Atcelt kontu",
          "currently_waiting_confirmation_for_email": "Pašlaik gaida apstiprinājumu epastam: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "atstājiet tukšu šo lauku, ja nevēlaties veikt izmaiņas",
          "title": "Rediģēt %{resource}",
          "unhappy": "Neapmierināts",
          "update": "Izmainīt",
          "we_need_your_current_password_to_confirm_your_changes": "mums ir nepieciešama Jūsu tagadējā parole, lai veiktu izmaiņas"
        },
        "new": {
          "sign_up": "Reģistrēties"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Pievienoties"
        }
      },
      "shared": {
        "links": {
          "back": "Atpakaļ",
          "didn_t_receive_confirmation_instructions": "Nesaņēmāt apstiprināšanas instrukciju?",
          "didn_t_receive_unlock_instructions": "Nesaņēmāt atbloķēšanas instrukciju?",
          "forgot_your_password": "Aizmirsāt paroli?",
          "sign_in": "Pievienoties",
          "sign_in_with_provider": "Pievienoties ar %{provider}",
          "sign_up": "Reģistrēties"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Atkārtoti atsūtīt atbloķēšanas instrukciju"
        }
      }
    },
    "i18n": {
      "plural": {}
    },
    "numbers": {
      "billions": {
        "one": "miljards",
        "other": "miljardi"
      },
      "decillions": {
        "one": "deciljons",
        "other": "deciljoni"
      },
      "hundreds": [
        "_",
        "viens simts",
        "divi simti",
        "trīs simti",
        "četri simti",
        "pieci simti",
        "seši simti",
        "septiņi simti",
        "astoņi simti",
        "deviņi simti"
      ],
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillion",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "millions": {
        "one": "miljons",
        "other": "miljoni"
      },
      "nonillions": {
        "one": "noniljons",
        "other": "noniljoni"
      },
      "octillions": {
        "one": "oktiljons",
        "other": "oktiljoni"
      },
      "ones": [
        "nulle",
        "viens",
        "divi",
        "trīs",
        "četri",
        "pieci",
        "seši",
        "septiņi",
        "astoņi",
        "deviņi"
      ],
      "quadrillions": {
        "one": "kvadriljons",
        "other": "kvadriljoni"
      },
      "quintillions": {
        "one": "kvintiljons",
        "other": "kvintiljoni"
      },
      "septillions": {
        "one": "septiljons",
        "other": "septiljoni"
      },
      "sextillions": {
        "one": "sekstiljons",
        "other": "sekstiljoni"
      },
      "teens": [
        "_",
        "vienpadsmit",
        "divpadsmit",
        "trīspadsmit",
        "četrpadsmit",
        "piecpadsmit",
        "sešpadsmit",
        "septiņpadsmit",
        "astoņpadsmit",
        "deviņpadsmit"
      ],
      "tens": [
        "_",
        "desmit",
        "divdesmit",
        "trīsdesmit",
        "četrdesmit",
        "piecdesmit",
        "sešdesmit",
        "septiņdesmit",
        "astoņdesmit",
        "deviņdesmit"
      ],
      "thousands": {
        "one": "tūkstotis",
        "other": "tūkstoši"
      },
      "trillions": {
        "one": "triljons",
        "other": "triljoni"
      }
    }
  },
  "mk": {
    "active_admin": {
      "access_denied": {
        "message": "Немате овластување да ја извршите оваа активност."
      },
      "any": "Било кој",
      "batch_actions": {
        "action_label": "%{title} го селектираното",
        "button_label": "Групни активности",
        "default_confirmation": "Дали сте сигурни?",
        "delete_confirmation": "Дали сте сигурни дека сакате да ги избришете %{plural_model}?",
        "labels": {
          "destroy": "Избриши"
        },
        "selection_toggle_explanation": "(Toggle Selection)",
        "succesfully_destroyed": {
          "one": "Успешно е избришан 1 %{model}",
          "other": "Успешно се избришани %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Не се креирани записи од типот на %{resource_name}.",
        "link": "Креирај нов"
      },
      "cancel": "Откажи",
      "create_another": "Креирај нов %{model}",
      "dashboard": "Почетна",
      "dashboard_welcome": {
        "call_to_action": "За да додадете секции на почетната страна, прегледајте го 'app/admin/dashboard.rb'.",
        "welcome": "Добредојдовте во Active Admin. Ова е стандардна верзија на почетната страна."
      },
      "delete": "Избриши",
      "delete_confirmation": "Дали сте сигурни дека сакате да го избришете записот?",
      "delete_model": "Избриши %{model}",
      "details": "Детали за %{model}",
      "devise": {
        "change_password": {
          "submit": "Промени лозинка",
          "title": "Променете ја лозинката"
        },
        "email": {
          "title": "Е-маил"
        },
        "links": {
          "forgot_your_password": "Ја заборавивте Вашата лозинка?",
          "resend_confirmation_instructions": "Повторно испрати инструкции за потврдување на профил",
          "resend_unlock_instructions": "Повторно испрати инструкции за отклучување на профил",
          "sign_in": "Најави се",
          "sign_in_with_omniauth_provider": "Најави се со %{provider}",
          "sign_up": "Креирај профил"
        },
        "login": {
          "remember_me": "Запомни ме",
          "submit": "Најави се",
          "title": "Најави се"
        },
        "password": {
          "title": "Лозинка"
        },
        "password_confirmation": {
          "title": "Потврди Лозинка"
        },
        "resend_confirmation_instructions": {
          "submit": "Инспрати инструкции",
          "title": "Повторно испраќање на инструкции за потврдување на профил"
        },
        "reset_password": {
          "submit": "Промени лозинка",
          "title": "Ја заборавивте Вашата лозинка?"
        },
        "sign_up": {
          "submit": "Креирај",
          "title": "Креирај профил"
        },
        "unlock": {
          "submit": "Испрати инструкции",
          "title": "Повторно испраќање на инструкции за отклучување на профил"
        },
        "username": {
          "title": "Корисничко име"
        }
      },
      "download": "Преземи во понудените формати:",
      "dropdown_actions": {
        "button_label": "Активности"
      },
      "edit": "Измени",
      "edit_model": "Измени %{model}",
      "empty": "Празно",
      "filters": {
        "buttons": {
          "clear": "Исчисти филтри",
          "filter": "Пребарај"
        },
        "predicates": {
          "from": "Од",
          "to": "До"
        }
      },
      "has_many_delete": "Избриши",
      "has_many_new": "Додај нов %{model}",
      "has_many_remove": "Отстрани",
      "index_list": {
        "block": "Листа",
        "blog": "Блог",
        "grid": "Грид",
        "table": "Табела"
      },
      "logout": "Одјави се",
      "main_content": "Ве замолуваме имплементирајте %{model}#main_content за да прикажете содржина.",
      "move": "Премести",
      "new_model": "Додај нов %{model}",
      "next": "Следно",
      "pagination": {
        "empty": "Нема пронајдени записи за %{model}",
        "entry": {
          "one": "запис",
          "other": "записи"
        },
        "multiple": "Прикажани %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> од вкупно <b>%{total}</b>",
        "multiple_without_total": "Прикажани %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Прикажан <b>1</b> %{model}",
        "one_page": "Прикажани <b>сите %{n}</b> %{model}",
        "per_page": "Прикази на записи по страна:"
      },
      "powered_by": "Овозможено од %{active_admin} %{version}",
      "previous": "Претходно",
      "search_status": {
        "current_filters": "Резултати врз основа на следниве филтри:",
        "headline": "Пронајдени резултати:",
        "no_current_filters": "Моментално нема филтри"
      },
      "sidebars": {
        "filters": "Филтри за пребарување",
        "search_status": "Резултати од пребарување"
      },
      "status_tag": {
        "no": "Не",
        "unset": "Не",
        "yes": "Да"
      },
      "unsupported_browser": {
        "headline": "Ве замолуваме, имајте во предвид дека ActiveAdmin не нуди поддршка за Internet Explorer 8 верзијата или претходни верзии.",
        "recommendation": "Ви порачуваме да го <a href=\"http://browsehappy.com/\"> ажурирате Вашиот пребарувач</a> за да си го подобрите пребарувањето.",
        "turn_off_compatibility_view": "Доколку користите IE 9 или понова верзија, Ве замолуваме <a href=\"https://support.microsoft.com/en-us/help/17471\">да исклучите \"Compatibility View\"</a>."
      },
      "view": "Прегледај"
    },
    "activerecord": {
      "models": {
        "active_admin/comment": {
          "one": "Коментар",
          "other": "Коментари"
        },
        "comment": {
          "one": "Коментар",
          "other": "Коментари"
        }
      }
    }
  },
  "nb": {
    "active_admin": {
      "access_denied": {
        "message": "Du er ikke autorisert til å utføre denne handlingen."
      },
      "any": "Alle",
      "batch_actions": {
        "action_label": "%{title} valgt",
        "button_label": "Gruppehandlinger",
        "delete_confirmation": "Er du sikker på at du vil slette disse %{plural_model}? Dette kan ikke reverseres.",
        "labels": {
          "destroy": "Slett"
        },
        "selection_toggle_explanation": "(Toggle Selection)",
        "succesfully_destroyed": {
          "one": "Slettet én %{model}",
          "other": "Slettet %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Her er det ingen %{resource_name} enda.",
        "link": "Opprett en"
      },
      "cancel": "Avbryt",
      "comments": {
        "add": "Legg til kommentar",
        "author": "Forfatter",
        "author_missing": "Anonym",
        "author_type": "Forfattertype",
        "body": "Brødtekst",
        "created_at": "Opprettet",
        "delete": "Slett kommentar",
        "delete_confirmation": "Er du sikker på at du ønsker å slette kommentaren?",
        "errors": {
          "empty_text": "Kommentar ble ikke lagret, teksten var tom."
        },
        "no_comments_yet": "Ingen kommentarer ennå.",
        "resource": "Ressurs",
        "resource_type": "Ressurstype",
        "title_content": "Kommentarer (%{count})"
      },
      "dashboard": "Oversikt",
      "dashboard_welcome": {
        "call_to_action": "Rediger 'app/admin/dashboard.rb' for å legge til elementer i oversikten.",
        "welcome": "Velkommen til Active Admin. Dette er standardoversiktssiden."
      },
      "delete": "Slett",
      "delete_confirmation": "Er du sikker på at du vil slette denne?",
      "delete_model": "Slett %{model}",
      "details": "%{model} Detaljer",
      "devise": {
        "change_password": {
          "submit": "Endre mitt passord",
          "title": "Endre passordet"
        },
        "email": {
          "title": "E-post"
        },
        "links": {
          "forgot_your_password": "Glemt passord?",
          "sign_in": "Logg inn",
          "sign_in_with_omniauth_provider": "Logg på med %{provider}"
        },
        "login": {
          "remember_me": "Husk meg",
          "submit": "Logg inn",
          "title": "Innlogging"
        },
        "password": {
          "title": "Passord"
        },
        "resend_confirmation_instructions": {
          "submit": "Send bekreftelsesinformasjon på nytt",
          "title": "Send bekreftelsesinformasjon på nytt"
        },
        "reset_password": {
          "submit": "Tilbakestille passordet mitt",
          "title": "Glemt passord?"
        },
        "sign_up": {
          "submit": "Opprett",
          "title": "Opprett brukerkonto"
        },
        "subdomain": {
          "title": "Subdomene"
        },
        "unlock": {
          "submit": "Send info om gjenoppretting på nytt",
          "title": "Send info om gjenoppretting på nytt"
        },
        "username": {
          "title": "Brukernavn"
        }
      },
      "download": "Last ned:",
      "dropdown_actions": {
        "button_label": "Handlinger"
      },
      "edit": "Rediger",
      "edit_model": "Rediger %{model}",
      "empty": "Tom",
      "filters": {
        "buttons": {
          "clear": "Fjern filter",
          "filter": "Filter"
        },
        "predicates": {
          "from": "Fra",
          "to": "Til"
        }
      },
      "has_many_delete": "Slett",
      "has_many_new": "Legg til ny %{model}",
      "has_many_remove": "Fjern",
      "index_list": {
        "block": "Liste",
        "blog": "Blogg",
        "grid": "Gitter",
        "table": "Tabell"
      },
      "logout": "Logg ut",
      "main_content": "Vennligst implementer %{model}#main_content for å vise innhold.",
      "new_model": "Ny %{model}",
      "next": "Neste",
      "pagination": {
        "empty": "Fant ingen %{model}",
        "entry": {
          "one": "innslag",
          "other": "innslag"
        },
        "multiple": "Viser %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> av <b>%{total}</b> totalt",
        "multiple_without_total": "Viser %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Viser <b>1</b> %{model}",
        "one_page": "Viser <b>alle %{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Forrige",
      "search_status": {
        "current_filters": "Gjeldende filtre:",
        "current_scope": "Søkeområde:",
        "headline": "Søkestatus:",
        "no_current_filters": "Ingen"
      },
      "sidebars": {
        "filters": "Filtere"
      },
      "status_tag": {
        "no": "Nei",
        "unset": "Nei",
        "yes": "Ja"
      },
      "view": "Vis"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": null,
          "email": null,
          "password": null,
          "password_confirmation": null,
          "remember_me": null
        }
      },
      "models": {
        "user": null
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Send bekreftelsesinstruksjoner på nytt"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Aktiver min konto",
          "greeting": "Velkommen %{recipient}!",
          "instruction": "Du kan aktivere "
        },
        "reset_password_instructions": {
          "action": "Bytt passord",
          "greeting": "Hei, %{recipient}!",
          "instruction": "Noen har bedt om en link for å endre passordet ditt, og dette kan gjøres på linken under.",
          "instruction_2": "Vennligst ignorer denne e-posten hvis du ikke ba om dette.",
          "instruction_3": "Passordet ditt endres ikke før du følger linken over og velger et nytt passord."
        },
        "unlock_instructions": {
          "action": "Gjenåpne min konto",
          "greeting": "Hei, %{recipient}!",
          "instruction": "Trykk på linken under for å gjenåpne din konto:",
          "message": "Kontoen din har blitt låst grunnet et høyt antall mislykkede innloggingsforsøk."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": "Glemt passordet ditt?",
          "send_me_reset_password_instructions": "Send instrukser for nullstilling av passord"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Er du sikker?",
          "cancel_my_account": "Slett min konto",
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": "la være tomt hvis du ikke ønsker å endre dette",
          "title": "Rediger %{resource}",
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": "vi trenger ditt nåværende passord for å bekrefte endringene"
        },
        "new": {
          "sign_up": "Registrer deg"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Logg inn"
        }
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": "Ikke mottatt bekreftelsesinstruksjoner?",
          "didn_t_receive_unlock_instructions": "Ikke mottatt instruksjoner for nullstilling av passord?",
          "forgot_your_password": "Glemt passordet ditt?",
          "sign_in": "Logg inn",
          "sign_in_with_provider": "Logg inn med %{provider}",
          "sign_up": "Registrer deg"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Send instrukser for gjenåpning av konto på nytt"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Side",
          "other": "Sider"
        },
        "next": "Neste",
        "previous": "Forrige"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Viser %{item_name} %{from}-%{to} av totalt %{count}",
        "no_count": "Side %{page} av %{pages}",
        "no_items": "Ingen %{item_name} funnet",
        "single_page": "Viser %{count} %{item_name}"
      },
      "input_nav_js": "Side %{page_input} av %{pages}",
      "item_name": {
        "one": "resultat",
        "other": "resultater"
      },
      "limit_tag_js": "Vis %{limit_input} %{item_name} per side",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    }
  },
  "nl": {
    "active_admin": {
      "access_denied": {
        "message": "U bent niet gemachtigd voor deze actie."
      },
      "any": "Alle",
      "batch_actions": {
        "action_label": "%{title} geselecteerde",
        "button_label": "Batch acties",
        "default_confirmation": "Weet u zeker dat u dit wilt doen?",
        "delete_confirmation": "Weet u zeker dat u deze %{plural_model} wilt verwijderen?",
        "labels": {
          "destroy": "Verwijder"
        },
        "selection_toggle_explanation": "(Toggle selectie)",
        "succesfully_destroyed": {
          "one": "1 %{model} verwijderd.",
          "other": "%{count} %{plural_model} verwijderd."
        }
      },
      "blank_slate": {
        "content": "Er zijn geen %{resource_name} gevonden.",
        "link": "Maak aan"
      },
      "cancel": "Annuleren",
      "comments": {
        "add": "Voeg commentaar toe",
        "author": "Auteur",
        "author_missing": "Anoniem",
        "author_type": "Auteur Type",
        "body": "Tekst",
        "created_at": "Aangemaakt op",
        "delete": "Verwijder commentaar",
        "delete_confirmation": "Weet u zeker dat u dit commentaar wilt verwijderen?",
        "errors": {
          "empty_text": "De reactie is niet opgeslagen, de tekst was leeg."
        },
        "no_comments_yet": "Nog geen reacties.",
        "resource": "Resource",
        "resource_type": "Resource Type",
        "title_content": "Reacties (%{count})"
      },
      "create_another": "Maak nog een %{model}",
      "dashboard": "Dashboard",
      "dashboard_welcome": {
        "call_to_action": "Pas uw eigen dashboard aan in het bestand 'app/admin/dashboard.rb'",
        "welcome": "Welkom bij Active Admin. Dit is de standaard dashboard pagina"
      },
      "delete": "Verwijder",
      "delete_confirmation": "Weet u zeker dat je dit item wilt verwijderen?",
      "delete_model": "Verwijder %{model}",
      "details": "%{model} details",
      "devise": {
        "change_password": {
          "submit": "Mijn wachtwoord wijzigen",
          "title": "Wijzig uw wachtwoord"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Wachtwoord vergeten?",
          "resend_confirmation_instructions": "Bevestigingsinstructies opnieuw versturen",
          "resend_unlock_instructions": "Ontgrendelinstructies opnieuw versturen",
          "sign_in": "Meld u aan",
          "sign_in_with_omniauth_provider": "Log in met %{provider}",
          "sign_up": "Registreren"
        },
        "login": {
          "remember_me": "Onthoud mij",
          "submit": "inloggen",
          "title": "inloggen"
        },
        "password": {
          "title": "Wachtwoord"
        },
        "password_confirmation": {
          "title": "Bevestig password"
        },
        "resend_confirmation_instructions": {
          "submit": "Verstuur bevestigingsinstructies opnieuw",
          "title": "Verstuur bevestigingsinstructies opnieuw"
        },
        "reset_password": {
          "submit": "Reset mijn wachtwoord",
          "title": "Wachtwoord vergeten?"
        },
        "sign_up": {
          "submit": "Registreren",
          "title": "Registreren"
        },
        "subdomain": {
          "title": "Subdomein"
        },
        "unlock": {
          "submit": "Verstuur ontgrendelinstructies opnieuw",
          "title": "Verstuur ontgrendelinstructies opnieuw"
        },
        "username": {
          "title": "Gebruikersnaam"
        }
      },
      "download": "Download",
      "dropdown_actions": {
        "button_label": "Acties"
      },
      "edit": "Wijzig",
      "edit_model": "Wijzig %{model}",
      "empty": "Leeg",
      "filters": {
        "buttons": {
          "clear": "Maak Filters Ongedaan",
          "filter": "Filter"
        },
        "predicates": {
          "from": "Van",
          "to": "Tot"
        }
      },
      "has_many_delete": "Verwijderen",
      "has_many_new": "Voeg nieuwe %{model} toe",
      "has_many_remove": "Verwijderen",
      "index_list": {
        "block": "Lijst",
        "blog": "Blog",
        "grid": "Rooster",
        "table": "Tabel"
      },
      "logout": "Uitloggen",
      "main_content": "Implementeer %{model}#main_content om de content weer te geven.",
      "move": "Verplaats",
      "new_model": "Nieuwe %{model}",
      "next": "Volgende",
      "pagination": {
        "empty": "Geen %{model} gevonden",
        "entry": {
          "one": "entry",
          "other": "entries"
        },
        "multiple": "Geeft %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> van de <b>%{total}</b> weer",
        "multiple_without_total": "Geeft %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Geeft <b>1</b> %{model} weer",
        "one_page": "Geeft <b>%{n}</b> %{model} weer",
        "per_page": "Per pagina: "
      },
      "powered_by": "Mogelijk gemaakt door %{active_admin} %{version}",
      "previous": "Vorige",
      "search_status": {
        "current_filters": "Huidige filters:",
        "current_scope": "Scope:",
        "headline": "Zoek status",
        "no_current_filters": "Geen"
      },
      "sidebars": {
        "filters": "Filters",
        "search_status": "Zoek status"
      },
      "status_tag": {
        "no": "Geen",
        "unset": "Geen",
        "yes": "Ja"
      },
      "unsupported_browser": {
        "headline": "Opgelet, ActiveAdmin bied geen support meer voor Internet Explorer 8 of lager",
        "recommendation": "Wij raden aan om te upgraden naar de nieuwste <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, of <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Als u IE 9 of nieuwer gebruikt, zorg ervoor dat u <a href=\"https://support.microsoft.com/nl-nl/help/17471\"> \"Compatibility View\" uit zet</a>."
      },
      "view": "Bekijk"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Huidig wachtwoord",
          "email": "Email",
          "password": "Wachtwoord",
          "password_confirmation": "Bevestig wachtwoord",
          "remember_me": "Ingelogd blijven"
        }
      },
      "models": {
        "user": "Gebruiker"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Verstuur bevestiging-instructies opnieuw"
        }
      },
      "failure": {
        "expired": "Je account is verlopen. Neem contact op met de site beheerder.",
        "invited": "U bent reeds uitgenodigd, accepteer de uitnodiging die u heeft ontvangen per mail om uw account te accepteren.",
        "session_limited": "Je login is in een andere browser gebruikt. Log hier opnieuw in."
      },
      "invalid_captcha": "De captcha invoer was ongeldig.",
      "invalid_security_question": "Het antwoord op de beveiligingsvraag was niet correct.",
      "invitations": {
        "edit": {
          "header": "Stel Uw wachtwoord in",
          "submit_button": "Stel mijn wachtwoord in"
        },
        "invitation_removed": "Uw uitnodiging is verwijderd.",
        "invitation_token_invalid": "De uitnodigingscode is ongeldig!",
        "new": {
          "header": "Verstuur uitnodiging",
          "submit_button": "Verstuur een uitnodiging"
        },
        "no_invitations_remaining": "Geen uitnodigingen over.",
        "send_instructions": "Een uitnodigingsmail aan %{email} is verstuurd.",
        "updated": "Uw wachtwoord is ingesteld. U bent nu ingelogd.",
        "updated_not_active": "Uw wachtwoord is ingesteld."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Bevestig mijn account",
          "greeting": "Welkom %{recipient}!",
          "instruction": "U kunt uw email bevestigen via onderstaande link:"
        },
        "invitation_instructions": {
          "accept": "Accepteer uitnodiging",
          "accept_until": "Deze uitnodoging vervalt per %{due_date}.",
          "hello": "Beste %{email}",
          "ignore": "Indien U de uitnodiging niet wenst te accepteren, negeer dan alstublieft deze email.<br />\nUw account wordt niet aangemaakt indien U niet via bovenstaande link uw wachtwoord aanmaakt.",
          "someone_invited_you": "Iemand heeft U uitgenodigd voor %{url}, U kunt de uitnodiging accepteren via onderstaande link.",
          "subject": "Instructies voor uitnodigingen"
        },
        "reset_password_instructions": {
          "action": "Verander mijn wachtwoord",
          "greeting": "Hallo %{recipient}!",
          "instruction": "Iemand heeft een link gevraagd om uw wachtwoord te wijzigen; dit kan via onderstaande link.",
          "instruction_2": "Als u dit niet heeft gedaan, negeer deze mail alstublieft.",
          "instruction_3": "Uw wachtwoord zal niet wijzigen totdat u bovenstaande link heeft gevolgd en een nieuw wachtwoord heeft aangevraagd."
        },
        "unlock_instructions": {
          "action": "Ontgrendel mijn account",
          "greeting": "Hallo %{recipient}!",
          "instruction": "U kunt uw account ontgrendelen via onderstaande link:",
          "message": "Uw account is vergrendeld wegens te veel mislukte pogingen in te loggen."
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Verstuur",
          "submit_verification_code": "Verstuur verificatie code",
          "verification_code": "Verificatie code"
        },
        "updated": "Verificatiecode geaccepteerd"
      },
      "paranoid_verify": {
        "code_required": "Voer de aangeleverde code in"
      },
      "password_expired": {
        "change_required": "Het wachtwoord is verlopen. Vernieuw je wachtwoord.",
        "show": {
          "change_my_password": "Verander mijn wachtwoord",
          "current_password": "Huidig wachtwoord",
          "new_password": "Nieuw wachtwoord",
          "new_password_confirmation": "Bevestig het nieuwe wachtwoord",
          "renew_your_password": "Vernieuw je wachtwoord"
        },
        "updated": "Het nieuwe wachtwoord is opgeslagen."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Verander mijn wachtwoord",
          "change_your_password": "Wijzig uw wachtwoord",
          "confirm_new_password": "Bevestig nieuw wachtwoord",
          "new_password": "Nieuw wachtwoord"
        },
        "new": {
          "forgot_your_password": "Wachtwoord vergeten?",
          "send_me_reset_password_instructions": "Stuur me wachtwoord reset instructies"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Weet u het zeker?",
          "cancel_my_account": "Annuleer mijn account",
          "currently_waiting_confirmation_for_email": "Aan het wachten op de bevestiging voor: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "laat leeg als u het niet wilt wijzigen",
          "title": "Bewerk %{resource}",
          "unhappy": "Niet blij",
          "update": "Bijwerken",
          "we_need_your_current_password_to_confirm_your_changes": "we hebben uw huidige wachtwoord nodig om uw veranderingen te bevestigen"
        },
        "new": {
          "sign_up": "Maak account aan"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Inloggen"
        }
      },
      "shared": {
        "links": {
          "back": "Terug",
          "didn_t_receive_confirmation_instructions": "Geen bevestigingsmail ontvangen?",
          "didn_t_receive_unlock_instructions": "Geen ontgrendel-instructies ontvangen?",
          "forgot_your_password": "Wachtwoord vergeten?",
          "sign_in": "Inloggen",
          "sign_in_with_provider": "Inloggen met %{provider}",
          "sign_up": "Maak account aan"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Verstuur ontgrendel-instructies opnieuw"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "heeft een ongeldige beeldverhouding (geldige beeldverhoudingen zijn %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "moet landschap zijn (huidig bestand is %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "moet portret zijn (huidig bestand is %{width}x%{height}px)",
        "aspect_ratio_not_square": "moet vierkant zijn (huidig bestand is %{width}x%{height} px)",
        "aspect_ratio_not_x_y": "moet %{authorized_aspect_ratios} zijn (huidig bestand is %{width}x%{height}px)",
        "attachment_missing": "heeft geen bijgevoegd bestand",
        "audio_missing": "moet een audiotrack bevatten",
        "audio_present": "mag geen audiotrack bevatten",
        "content_type_invalid": {
          "one": "heeft een ongeldig inhoudstype (toegestaan inhoudstype is %{authorized_human_content_types})",
          "other": "heeft een ongeldig inhoudstype (toegestane inhoudstypen zijn %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "heeft een inhoudstype dat niet gelijk is aan het type dat wordt gedetecteerd door de inhoud (geautoriseerd inhoudstype is %{authorized_human_content_types})",
          "other": "heeft een inhoudstype dat niet gelijk is aan het type dat wordt gedetecteerd door de inhoud (geautoriseerde inhoudstypen zijn %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "hoogte moet gelijk zijn aan %{length} pixels",
        "dimension_height_not_greater_than_or_equal_to": "hoogte moet groter of gelijk zijn aan %{length} pixels",
        "dimension_height_not_included_in": "hoogte niet tussen de %{min} en %{max} pixels",
        "dimension_height_not_less_than_or_equal_to": "hoogte moet kleiner of gelijk zijn aan %{length} pixels",
        "dimension_max_not_included_in": "moet kleiner of gelijk zijn aan %{width} x %{height} pixels",
        "dimension_min_not_included_in": "moet groter of gelijk zijn aan %{width} x %{height} pixels",
        "dimension_width_not_equal_to": "breedte moet gelijk zijn aan %{length} pixels",
        "dimension_width_not_greater_than_or_equal_to": "breedte moet groter of gelijk zijn aan %{length} pixels",
        "dimension_width_not_included_in": "breedte niet tussen de %{min} en %{max} pixels",
        "dimension_width_not_less_than_or_equal_to": "breedte moet kleiner of gelijk zijn aan %{length} pixels",
        "duration_not_between": "duur moet tussen %{min} en %{max} zijn (huidige duur is %{duration})",
        "duration_not_equal_to": "duur moet gelijk zijn aan %{exact} (huidige duur is %{duration})",
        "duration_not_greater_than": "duur moet groter zijn dan %{min} (huidige duur is %{duration})",
        "duration_not_greater_than_or_equal_to": "duur moet groter zijn dan of gelijk zijn aan %{min} (huidige duur is %{duration})",
        "duration_not_less_than": "duur moet kleiner zijn dan %{max} (huidige duur is %{duration})",
        "duration_not_less_than_or_equal_to": "duur moet kleiner zijn dan of gelijk zijn aan %{max} (huidige duur is %{duration})",
        "equal_to_current_password": "moet verschillen van het huidige wachtwoord.",
        "equal_to_email": "moet anders zijn dan de e-mail",
        "file_not_processable": "wordt niet geïdentificeerd als een geldig mediabestand",
        "file_size_not_between": "bestandsgrootte moet tussen %{min} en %{max} liggen (huidige grootte is %{file_size})",
        "file_size_not_equal_to": "bestandsgrootte moet gelijk zijn aan %{exact} (huidige grootte is %{file_size})",
        "file_size_not_greater_than": "bestandsgrootte moet groter zijn dan %{min} (huidige grootte is %{file_size})",
        "file_size_not_greater_than_or_equal_to": "bestandsgrootte moet groter zijn dan of gelijk zijn aan %{min} (huidige grootte is %{file_size})",
        "file_size_not_less_than": "bestandsgrootte moet kleiner zijn dan %{max} (huidige grootte is %{file_size})",
        "file_size_not_less_than_or_equal_to": "bestandsgrootte moet kleiner zijn dan of gelijk zijn aan %{max} (huidige grootte is %{file_size})",
        "limit_max_exceeded": {
          "one": "te veel bijgevoegde bestanden (maximaal is %{max} bestanden, kreeg %{count})",
          "other": "te veel bijgevoegde bestanden (maximum is %{max} bestanden, kreeg %{count})",
          "zero": "geen bestanden bijgevoegd (maximaal is %{max} bestanden)"
        },
        "limit_min_not_reached": {
          "one": "slechts 1 bijgevoegd bestand (moet ten minste %{min} bestanden hebben)",
          "other": "%{count} bestanden bijgevoegd (moet ten minste %{min} bestanden hebben)",
          "zero": "geen bestanden bijgevoegd (moet ten minste %{min} bestanden hebben)"
        },
        "limit_out_of_range": {
          "one": "slechts 1 bijgevoegd bestand (moet tussen %{min} en %{max} bestanden hebben)",
          "other": "het totale aantal bestanden moet tussen %{min} en %{max} bestanden liggen (er zijn %{count} bestanden bijgevoegd)",
          "zero": "geen bestanden bijgevoegd (moet tussen %{min} en %{max} bestanden hebben)"
        },
        "media_metadata_missing": "is geen geldig mediabestand",
        "pages_not_between": "het aantal pagina's moet tussen %{min} en %{max} liggen (het huidige aantal pagina's is %{pages})",
        "pages_not_equal_to": "het aantal pagina's moet gelijk zijn aan %{exact} (het huidige aantal pagina's is %{pages})",
        "pages_not_greater_than": "het aantal pagina's moet groter zijn dan %{min} (het huidige aantal pagina's is %{pages})",
        "pages_not_greater_than_or_equal_to": "het aantal pagina's moet groter zijn dan of gelijk zijn aan %{min} (het huidige aantal pagina's is %{pages})",
        "pages_not_less_than": "het aantal pagina's moet kleiner zijn dan %{max} (het huidige aantal pagina's is %{pages})",
        "pages_not_less_than_or_equal_to": "het aantal pagina's moet kleiner zijn dan of gelijk zijn aan %{max} (het huidige aantal pagina's is %{pages})",
        "password_complexity": {
          "digit": {
            "one": "moet minimaal 1 cijfer bevatten",
            "other": "moet minimaal %{count} cijfers bevatten"
          },
          "lower": {
            "one": "moet minimaal 1 kleine letter bevatten",
            "other": "moet minimaal %{count} kleine letters bevatten"
          },
          "symbol": {
            "one": "moet minimaal 1 leesteken of symbool bevatten",
            "other": "moet minimaal %{count} leestekens of symbolen bevatten"
          },
          "upper": {
            "one": "moet minimaal 1 hoofdletter bevatten",
            "other": "moet minimaal %{count} hoofdletters bevatten"
          }
        },
        "taken_in_past": "is eerder gebruikt.",
        "total_file_size_not_between": "totale bestandsgrootte moet tussen %{min} en %{max} liggen (huidige grootte is %{total_file_size})",
        "total_file_size_not_equal_to": "totale bestandsgrootte moet gelijk zijn aan %{exact} (huidige grootte is %{total_file_size})",
        "total_file_size_not_greater_than": "totale bestandsgrootte moet groter zijn dan %{min} (huidige grootte is %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "totale bestandsgrootte moet groter zijn dan of gelijk zijn aan %{min} (huidige grootte is %{total_file_size})",
        "total_file_size_not_less_than": "totale bestandsgrootte moet kleiner zijn dan %{max} (huidige grootte is %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "totale bestandsgrootte moet kleiner zijn dan of gelijk zijn aan %{max} (huidige grootte is %{total_file_size})"
      }
    },
    "numbers": {
      "biljardsten": {
        "one": "biljardste",
        "other": "biljardsten"
      },
      "biljoensten": {
        "one": "biljoenste",
        "other": "biljoensten"
      },
      "decillionsten": {
        "one": "decillionste",
        "other": "decillionsten"
      },
      "duizendsten": {
        "one": "duizendste",
        "other": "duizendsten"
      },
      "honderdsten": {
        "one": "honderdste",
        "other": "honderdsten"
      },
      "hundreds": "honderd",
      "loose_one": "één",
      "mega": [
        "_",
        "duizend",
        "miljoen",
        "miljard",
        "biljoen",
        "biljard",
        "triljoen",
        "triljard",
        "septiljoen",
        "octillion",
        "noniljoen",
        "decillion"
      ],
      "micro": [
        "_",
        "tienden",
        "honderdsten",
        "duizendsten",
        "miljoensten",
        "miljardsten",
        "biljoensten",
        "biljardsten",
        "triljoensten",
        "triljardsten",
        "septiljoensten",
        "octillionsten",
        "noniljoensten",
        "decillionsten"
      ],
      "micro_prefix": {
        "hundreds": "honderd",
        "tens": "tien",
        "union": ""
      },
      "micro_separator": "komma",
      "miljardsten": {
        "one": "miljardste",
        "other": "miljardsten"
      },
      "miljoensten": {
        "one": "miljoenste",
        "other": "miljoensten"
      },
      "noniljoensten": {
        "one": "noniljoenste",
        "other": "noniljoensten"
      },
      "octillionsten": {
        "one": "octillionste",
        "other": "octillionsten"
      },
      "ones": [
        "nul",
        "een",
        "twee",
        "drie",
        "vier",
        "vijf",
        "zes",
        "zeven",
        "acht",
        "negen"
      ],
      "septiljoensten": {
        "one": "septiljoenste",
        "other": "septiljoensten"
      },
      "teens": [
        "_",
        "elf",
        "twaalf",
        "dertien",
        "veertien",
        "vijftien",
        "zestien",
        "zeventien",
        "achttien",
        "negentien"
      ],
      "tens": [
        "_",
        "tien",
        "twintig",
        "dertig",
        "veertig",
        "vijftig",
        "zestig",
        "zeventig",
        "tachtig",
        "negentig"
      ],
      "tienden": {
        "one": "tiende",
        "other": "tienden"
      },
      "triljardsten": {
        "one": "triljardste",
        "other": "triljardsten"
      },
      "triljoensten": {
        "one": "triljoenste",
        "other": "triljoensten"
      },
      "union": "en",
      "union2or3": "ën"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Pagina",
          "other": "Pagina's"
        },
        "next": "Volgende",
        "previous": "Vorige"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Toont %{from}-%{to} %{item_name} van %{count} in totaal",
        "no_count": "Pagina %{page} van %{pages}",
        "no_items": "Geen %{item_name} gevonden",
        "single_page": "Toont %{count} %{item_name}"
      },
      "input_nav_js": "Pagina %{page_input} van %{pages}",
      "item_name": {
        "one": "stuk",
        "other": "stuks"
      },
      "limit_tag_js": "Toont %{limit_input} %{item_name} per pagina",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "alle",
      "and": "en",
      "any": "enig",
      "asc": "oplopend",
      "attribute": "attribuut",
      "combinator": "combinator",
      "condition": "conditie",
      "desc": "aflopend",
      "or": "of",
      "predicate": "eigenschap",
      "predicates": {
        "blank": "is afwezig",
        "cont": "bevat",
        "cont_all": "bevat alle",
        "cont_any": "bevat enig",
        "does_not_match": "evenaart niet",
        "does_not_match_all": "evenaart niet voor alle",
        "does_not_match_any": "evenaart niet voor enig",
        "end": "eindigt met",
        "end_all": "eindigt met alle",
        "end_any": "eindigt met enig",
        "eq": "gelijk",
        "eq_all": "gelijk alle",
        "eq_any": "gelijk enig",
        "false": "is niet waar",
        "gt": "groter dan",
        "gt_all": "groter dan alle",
        "gt_any": "groter dan enig",
        "gteq": "groter dan of gelijk aan",
        "gteq_all": "groter dan of gelijk aan alle",
        "gteq_any": "groter dan of gelijk aan enig",
        "in": "in",
        "in_all": "in alle",
        "in_any": "in enig",
        "lt": "kleiner dan",
        "lt_all": "kleiner dan alle",
        "lt_any": "kleiner dan enig",
        "lteq": "kleiner dan of gelijk aan",
        "lteq_all": "kleiner dan of gelijk aan alle",
        "lteq_any": "kleiner dan of gelijk aan enig",
        "matches": "evenaart",
        "matches_all": "evenaart alle",
        "matches_any": "evenaart enig",
        "not_cont": "bevat niet",
        "not_cont_all": "bevat niet alle",
        "not_cont_any": "bevat niet enig",
        "not_end": "eindigt niet met",
        "not_end_all": "eindigt niet met alle",
        "not_end_any": "eindigt niet met enig",
        "not_eq": "niet gelijk aan",
        "not_eq_all": "niet gelijk aan alle",
        "not_eq_any": "niet gelijk aan enig",
        "not_in": "niet in",
        "not_in_all": "niet in alle",
        "not_in_any": "niet in enig",
        "not_null": "is niet null",
        "not_start": "start niet met",
        "not_start_all": "start niet met alle",
        "not_start_any": "start niet met enig",
        "null": "is null",
        "present": "is aanwezig",
        "start": "start met",
        "start_all": "start met alle",
        "start_any": "start met enig",
        "true": "is waar"
      },
      "search": "zoeken",
      "sort": "sorteren",
      "value": "waarde"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oeps, we hebben uw reCAPTCHA-antwoord niet kunnen valideren. Probeer het opnieuw.",
        "verification_failed": "reCAPTCHA-verificatie mislukt, probeer het opnieuw."
      }
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%a %d %b %Y %H:%M:%S %Z"
            }
          }
        }
      }
    }
  },
  "nn": {
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Side",
          "other": "Sider"
        },
        "next": "Neste",
        "previous": "Førre"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Viser %{item_name} %{from}-%{to} av totalt %{count}",
        "no_count": "Side %{page} av %{pages}",
        "no_items": "Ingen %{item_name} funne",
        "single_page": "Viser %{count} %{item_name}"
      },
      "input_nav_js": "Side %{page_input} av %{pages}",
      "item_name": {
        "one": "resultat",
        "other": "resultat"
      },
      "limit_tag_js": "Vis %{limit_input} %{item_name} per side",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    }
  },
  "no": {
    "devise": {
      "invitations": {
        "edit": {
          "header": "Sett ditt passord",
          "submit_button": "Sett mitt passord"
        },
        "invitation_removed": "Din invitasjon ble fjernet.",
        "invitation_token_invalid": "Autentiseringskoden er ikke gyldig!",
        "new": {
          "header": "Send invitasjon",
          "submit_button": "Send en invitasjon"
        },
        "no_invitations_remaining": "Ingen gjenværende invitasjoner.",
        "send_instructions": "En epost med invitasjon er sent til %{email}.",
        "updated": "Passordet ble oppdatert suksessfullt. Du er nå logget inn."
      },
      "mailer": {
        "invitation_instructions": {
          "subject": "Invitasjonsinstruksjoner"
        }
      }
    }
  },
  "pl": {
    "active_admin": {
      "access_denied": {
        "message": "Nie masz uprawnień wystarczających do wykonania tej akcji."
      },
      "any": "Jakikolwiek",
      "batch_actions": {
        "action_label": "%{title} zaznaczone",
        "button_label": "Akcje na partiach",
        "default_confirmation": "Czy na pewno chcesz to zrobić?",
        "delete_confirmation": "Czy na pewno chcesz usunąć te %{plural_model}?",
        "labels": {
          "destroy": "Usuń"
        },
        "selection_toggle_explanation": "(Przełącz zaznaczenie)",
        "succesfully_destroyed": {
          "few": "Poprawnie usunięto %{count} %{plural_model}",
          "many": "Poprawnie usunięto %{count} %{plural_model}",
          "one": "Poprawnie usunięto 1 %{model}",
          "other": "Poprawnie usunięto %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Nie ma jeszcze zasobu %{resource_name}.",
        "link": "Utwórz go"
      },
      "cancel": "Anuluj",
      "comments": {
        "add": "Dodaj komentarz",
        "author": "Autor",
        "author_missing": "Anonim",
        "author_type": "Typ autora",
        "body": "Treść",
        "created_at": "Utworzony",
        "delete": "Usuń komentarz",
        "delete_confirmation": "Czy na pewno chcesz usunąć ten komentarz?",
        "errors": {
          "empty_text": "Komentarz nie został zapisany, zawartość była pusta."
        },
        "no_comments_yet": "Nie ma jeszcze komentarzy.",
        "resource": "Zasób",
        "resource_type": "Typ zasobu",
        "title_content": "Komentarze (%{count})"
      },
      "create_another": "Utwórz kolejny %{model}",
      "dashboard": "Pulpit",
      "dashboard_welcome": {
        "call_to_action": "Aby dodać sekcje do pulpitu, sprawdź 'app/admin/dashboard.rb'",
        "welcome": "Witaj w Active Adminie. To jest domyślny pulpit."
      },
      "delete": "Usuń",
      "delete_confirmation": "Jesteś pewien, że chcesz to usunąć?",
      "delete_model": "Usuń %{model}",
      "details": "Szczegóły %{model}",
      "devise": {
        "change_password": {
          "submit": "Zmień hasło",
          "title": "Zmień hasło"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Nie pamiętasz hasła?",
          "resend_confirmation_instructions": "Ponownie wyślij instrukcje aktywacji",
          "resend_unlock_instructions": "Ponownie wyślij instrukcję odblokowania konta",
          "sign_in": "Zaloguj się",
          "sign_in_with_omniauth_provider": "Zaloguj się z %{provider}",
          "sign_up": "Zarejestruj się"
        },
        "login": {
          "remember_me": "Zapamiętaj mnie",
          "submit": "Zaloguj się",
          "title": "Logowanie"
        },
        "password": {
          "title": "Hasło"
        },
        "password_confirmation": {
          "title": "Powtórz hasło"
        },
        "resend_confirmation_instructions": {
          "submit": "Ponownie wyślij instrukcje aktywacji",
          "title": "Ponownie wyślij instrukcje aktywacji"
        },
        "reset_password": {
          "submit": "Zresetować hasło",
          "title": "Nie pamiętasz hasła?"
        },
        "sign_up": {
          "submit": "Zarejestruj się",
          "title": "Rejestracja"
        },
        "subdomain": {
          "title": "Subdomena"
        },
        "unlock": {
          "submit": "Ponownie wyślij instrukcję odblokowania konta",
          "title": "Ponownie wyślij instrukcję odblokowania konta"
        },
        "username": {
          "title": "Nazwa użytkownika"
        }
      },
      "download": "Pobierz:",
      "dropdown_actions": {
        "button_label": "Akcje"
      },
      "edit": "Edytuj",
      "edit_model": "Edytuj %{model}",
      "empty": "Pusty",
      "filters": {
        "buttons": {
          "clear": "Wyczyść Filtry",
          "filter": "Filtruj"
        },
        "predicates": {
          "from": "Od",
          "to": "Do"
        }
      },
      "has_many_delete": "Usuń",
      "has_many_new": "Dodaj nowy %{model}",
      "has_many_remove": "Usuń",
      "index_list": {
        "block": "Lista",
        "blog": "Blog",
        "grid": "Siatka",
        "table": "Tabela"
      },
      "logout": "Wyloguj",
      "main_content": "Zaimplementuj %{model}#main_content aby wyświetlić treść.",
      "move": "Przenieś",
      "new_model": "Nowy %{model}",
      "next": "Następna",
      "pagination": {
        "empty": "Nie znaleziono %{model}",
        "entry": {
          "one": null,
          "other": null
        },
        "multiple": "Wyświetlanie %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> z <b>%{total}</b>",
        "multiple_without_total": "Wyświetlanie %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Wyświetlanie <b>1</b> %{model}",
        "one_page": "Wyświetlanie <b>wszystkich %{n}</b> %{model}",
        "per_page": "Na stronę: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Poprzednia",
      "scopes": {
        "all": "Wszystko"
      },
      "search_status": {
        "current_filters": "Aktywne filtry:",
        "current_scope": "Aktywny zakres:",
        "headline": "Status wyszukiwania:",
        "no_current_filters": "Brak"
      },
      "sidebars": {
        "filters": "Filtry",
        "search_status": "Status wyszukiwania"
      },
      "status_tag": {
        "no": "Nie",
        "unset": "Nie",
        "yes": "Tak"
      },
      "unsupported_browser": {
        "headline": "ActiveAdmin nie wspiera przeglądarki Internet Explorer w wersjach 8 i niższych.",
        "recommendation": "Polecamy <a href=\"http://browsehappy.com/\">aktualizację przeglądarki</a>.",
        "turn_off_compatibility_view": "Jeśli używasz Internet Explorera w wersji 9 lub nowszej, upewnij się, że <a href=\"https://support.microsoft.com/en-us/help/17471\">\"tryb zgodności\" został wyłączony.</a>."
      },
      "view": "Podgląd"
    },
    "activerecord": {
      "attributes": {
        "active_admin/comment": {
          "author_type": "Typ autora",
          "body": "Treść",
          "created_at": "Utworzony",
          "namespace": "Namespace",
          "resource_type": "Typ zasobu",
          "updated_at": "Zaktualizowany"
        },
        "user": {
          "current_password": "Aktualne hasło",
          "email": "Adres e-mail",
          "password": "Hasło",
          "password_confirmation": "Potwierdzenie hasła",
          "remember_me": "Zapamiętaj mnie"
        }
      },
      "models": {
        "active_admin/comment": {
          "few": "Komentarze",
          "many": "Komentarzy",
          "one": "Komentarz",
          "other": "Komentarze"
        },
        "comment": {
          "few": "Komentarze",
          "many": "Komentarzy",
          "one": "Komentarz",
          "other": "Komentarze"
        },
        "user": "Użytkownik"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Wyślij ponownie instrukcje aktywacji"
        }
      },
      "failure": {
        "invited": "Posiadasz oczekujące zaproszenie, zaakceptuj je aby ukończyć proces rejestracji."
      },
      "invitations": {
        "edit": {
          "header": "Ustaw swoje hasło",
          "submit_button": "Zapisz moje hasło"
        },
        "invitation_removed": "Twoje zaproszenie zostało usunięte.",
        "invitation_token_invalid": "Kod zaproszenia jest nieprawidłowy.",
        "new": {
          "header": "Wyślij zaproszenie",
          "submit_button": "Wyślij zaproszenie"
        },
        "no_invitations_remaining": "Brak oczekujących zaproszeń",
        "send_instructions": "E-mail z zaproszeniem został wysłany do %{email}.",
        "updated": "Twoje hasło zostało pomyślnie ustawione. Jesteś teraz zalogowany.",
        "updated_not_active": "Twoje hasło zostało ustawione."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Potwierdź swoje konto",
          "greeting": "Witaj %{recipient}!",
          "instruction": "Możesz potwierdzić swoje konto przy pomocy poniższego linku:"
        },
        "invitation_instructions": {
          "accept": "Przyjmij zaproszenie",
          "accept_until": "Zaprosze będzie ważne do %{due_date}.",
          "hello": "Cześć %{email}",
          "ignore": "Jeśli nie chcesz przyjąć zaproszenia, zignoruj tę wiadomość.<br />Twoje konto nie zostanie utworzone do momentu ustawienia przez Ciebie hasła.",
          "someone_invited_you": "Ktoś zaprosił Cię do %{url}. Zaproszenie możesz zaakceptować przez podany link.",
          "subject": "Instrukcja do zaproszenia"
        },
        "reset_password_instructions": {
          "action": "Zmień swoje hasło",
          "greeting": "Cześć %{recipient}!",
          "instruction": "Ktoś zażądał zmiany hasła do Twojego konta. Hasło możesz zmienić wchodząc na poniższy link.",
          "instruction_2": "Jeśli to nie Ty zażądałeś zmiany hasła, proszę zignoruj tę wiadomość.",
          "instruction_3": "Twoje hasło nie ulegnie zmianie dopóki nie wejdziesz na poniższy link i nie ustawisz nowego."
        },
        "unlock_instructions": {
          "action": "Odblokuj swoje konto",
          "greeting": "Cześć %{recipient}!",
          "instruction": "Kliknij poniższy link, aby odblokować swoje konto:",
          "message": "Twoje konto zostało zablokowane z powodu zbyt dużej ilości nieprawidłowych prób zalogowania się na nie."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Zmień moje hasło",
          "change_your_password": "Zmień swoje hasło",
          "confirm_new_password": "Powtórz nowe hasło",
          "new_password": "Nowe hasło"
        },
        "new": {
          "forgot_your_password": "Zapomniałeś swoje hasło?",
          "send_me_reset_password_instructions": "Wyślij instrukcje zmiany hasła"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Jesteś pewny?",
          "cancel_my_account": "Anuluj moje konto",
          "currently_waiting_confirmation_for_email": "Aktualnie oczekujemy na potwierdzenie z: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "pozostaw puste, jeśli nie chcesz wprowadzać zmian",
          "title": "Edytuj %{resource}",
          "unhappy": "Niezadowolony",
          "update": "Zaktualizuj",
          "we_need_your_current_password_to_confirm_your_changes": "potrzebujemy Twojego bieżącego hasła, aby potwierdzić zmiany"
        },
        "new": {
          "sign_up": "Zarejestruj się"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Zaloguj się"
        }
      },
      "shared": {
        "links": {
          "back": "Powrót",
          "didn_t_receive_confirmation_instructions": "Nie otrzymałeś instrukcji aktywacji konta?",
          "didn_t_receive_unlock_instructions": "Nie otrzymałeś instrukcji odblokowania konta?",
          "forgot_your_password": "Zapomniałeś hasło?",
          "sign_in": "Zaloguj się",
          "sign_in_with_provider": "Zaloguj się przez %{provider}",
          "sign_up": "Zarejestruj się"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Wyślij instrukcje odblokowania konta"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "ma nieprawidłowy współczynnik kształtu (ważne współczynniki kształtu wynoszą %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "musi być krajobrazem (bieżący plik to %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "musi być portret (bieżący plik to %{width}x%{height}px)",
        "aspect_ratio_not_square": "musi być kwadratowy (bieżący plik to %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "musi być %{authorized_aspect_ratios} (bieżący plik to %{width}x%{height}px)",
        "attachment_missing": "nie ma załączonego pliku",
        "audio_missing": "musi zawierać ścieżkę dźwiękową",
        "audio_present": "nie może zawierać ścieżki dźwiękowej",
        "content_type_invalid": {
          "one": "ma nieprawidłowy typ zawartości (autoryzowany typ zawartości to %{authorized_human_content_types})",
          "other": "ma nieprawidłowy typ zawartości (autoryzowane typy treści to %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "ma typ zawartości, który nie jest równoważny z tym, który jest wykrywany przez jego zawartość (autoryzowany typ zawartości to %{authorized_human_content_types})",
          "other": "ma typ zawartości, który nie jest równoważny z tym, który jest wykrywany przez jego zawartość (autoryzowane typy treści to %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "wysokość musi wynosić %{length} pixeli",
        "dimension_height_not_greater_than_or_equal_to": "wysokość musi mieć co najmniej %{length} pixeli",
        "dimension_height_not_included_in": "wysokość musi wynosić od %{min} do %{max} pixeli",
        "dimension_height_not_less_than_or_equal_to": "wysokość musi mieć co najwyżej %{length} pixeli",
        "dimension_max_not_included_in": "musi być równe lub mniejsze od %{width} x %{height} pixeli",
        "dimension_min_not_included_in": "musi być równe lub większe od %{width} x %{height} pixeli",
        "dimension_width_not_equal_to": "szerokość musi wynosić %{length} pixeli",
        "dimension_width_not_greater_than_or_equal_to": "szerokość musi mieć co najmniej %{length} pixeli",
        "dimension_width_not_included_in": "szerokość musi wynosić od %{min} do %{max} pixeli",
        "dimension_width_not_less_than_or_equal_to": "szerokość musi mieć co najwyżej %{length} pixeli",
        "duration_not_between": "czas trwania musi wynosić między %{min} a %{max} (obecny czas trwania wynosi %{duration})",
        "duration_not_equal_to": "czas trwania musi być równy %{exact} (obecny czas trwania wynosi %{duration})",
        "duration_not_greater_than": "czas trwania musi być większy niż %{min} (obecny czas trwania wynosi %{duration})",
        "duration_not_greater_than_or_equal_to": "czas trwania musi być większy lub równy %{min} (obecny czas trwania wynosi %{duration})",
        "duration_not_less_than": "czas trwania musi być mniejszy niż %{max} (obecny czas trwania wynosi %{duration})",
        "duration_not_less_than_or_equal_to": "czas trwania musi być mniejszy lub równy %{max} (obecny czas trwania wynosi %{duration})",
        "file_not_processable": "nie jest identyfikowany jako prawidłowy plik multimedialny",
        "file_size_not_between": "rozmiar pliku musi mieścić się w przedziale od %{min} do %{max} (obecny rozmiar to %{file_size})",
        "file_size_not_equal_to": "rozmiar pliku musi być równy %{exact} (obecny rozmiar to %{file_size})",
        "file_size_not_greater_than": "rozmiar pliku musi być większy niż %{min} (obecny rozmiar to %{file_size})",
        "file_size_not_greater_than_or_equal_to": "rozmiar pliku musi być większy lub równy %{min} (obecny rozmiar to %{file_size})",
        "file_size_not_less_than": "rozmiar pliku musi być mniejszy niż %{max} (obecny rozmiar to %{file_size})",
        "file_size_not_less_than_or_equal_to": "rozmiar pliku musi być mniejszy lub równy %{max} (obecny rozmiar to %{file_size})",
        "limit_max_exceeded": {
          "one": "zbyt wiele dołączonych plików (maksymalnie jest to %{max} pliki, otrzymano %{count})",
          "other": "zbyt wiele dołączonych plików (maksymalnie jest to %{max} pliki, otrzymano %{count})",
          "zero": "brak dołączonych plików (maksymalnie jest to %{max} pliki)"
        },
        "limit_min_not_reached": {
          "one": "dołączony tylko 1 plik (musi mieć co najmniej %{min} pliki)",
          "other": "%{count} pliki dołączone (musi mieć co najmniej %{min} pliki)",
          "zero": "brak dołączonych plików (musi mieć co najmniej %{min} pliki)"
        },
        "limit_out_of_range": {
          "one": "załączony tylko 1 plik (musi mieć między %{min} a %{max} pliki)",
          "other": "całkowita liczba plików musi wynosić między %{min} a %{max} pliki (dołączone są %{count} pliki)",
          "zero": "brak dołączonych plików (musi mieć między %{min} a %{max} pliki)"
        },
        "media_metadata_missing": "nie jest prawidłowym plikiem multimedialnym",
        "pages_not_between": "liczba stron musi być między %{min} a %{max} (bieżąca liczba stron to %{pages})",
        "pages_not_equal_to": "liczba stron musi być równa %{exact} (bieżąca liczba stron to %{pages})",
        "pages_not_greater_than": "liczba stron musi być większa niż %{min} (bieżąca liczba stron to %{pages})",
        "pages_not_greater_than_or_equal_to": "liczba stron musi być większa lub równa %{min} (bieżąca liczba stron to %{pages})",
        "pages_not_less_than": "liczba stron musi być mniejsza niż %{max} (bieżąca liczba stron to %{pages})",
        "pages_not_less_than_or_equal_to": "liczba stron musi być mniejsza lub równa %{max} (bieżąca liczba stron to %{pages})",
        "total_file_size_not_between": "całkowity rozmiar pliku musi mieścić się w przedziale od %{min} do %{max} (obecny rozmiar to %{total_file_size})",
        "total_file_size_not_equal_to": "całkowity rozmiar pliku musi być równy %{exact} (obecny rozmiar to %{total_file_size})",
        "total_file_size_not_greater_than": "całkowity rozmiar pliku musi być większy niż %{min} (obecny rozmiar to %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "całkowity rozmiar pliku musi być większy lub równy %{min} (obecny rozmiar to %{total_file_size})",
        "total_file_size_not_less_than": "całkowity rozmiar pliku musi być mniejszy niż %{max} (obecny rozmiar to %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "całkowity rozmiar pliku musi być mniejszy lub równy %{max} (obecny rozmiar to %{total_file_size})"
      }
    },
    "formtastic": {
      "create": "Utwórz %{model}",
      "update": "Aktualizuj %{model}"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Strony",
          "many": "Stron",
          "one": "Strona",
          "other": "Strony"
        },
        "next": "Następna",
        "previous": "Poprzednia"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Wyświetlono %{item_name} %{from}-%{to} z wszystkich %{count}",
        "no_count": "Strona %{page} z %{pages}",
        "no_items": "Nie znaleziono %{item_name}",
        "single_page": "Wyświetlono %{count} %{item_name}"
      },
      "input_nav_js": "Strona %{page_input} z %{pages}",
      "item_name": {
        "few": "elementy",
        "many": "elementów",
        "one": "element",
        "other": "elementów"
      },
      "limit_tag_js": "Pokaż %{limit_input} %{item_name} na stronie",
      "next": "&gt;",
      "p11n": "Polish",
      "previous": "&lt;"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        }
      }
    }
  },
  "pt": {
    "devise": {
      "failure": {
        "expired": "Sua conta expirou por inatividade. Por favor contate o administrador do site.",
        "invited": "Você tem um convite pendente, aceite para finalizar sua conta.",
        "session_limited": "Seu login foi utilizado em outro local. Faça o login novamente para continuar."
      },
      "invalid_captcha": "O captcha está errado.",
      "invalid_security_question": "A resposta da pergunta de segurança está errada.",
      "invitations": {
        "edit": {
          "header": "Escolha sua senha",
          "submit_button": "Atualizar minha senha"
        },
        "invitation_removed": "Seu convite foi removido.",
        "invitation_token_invalid": "O código do convite não é válido!",
        "new": {
          "header": "Enviar convite",
          "submit_button": "Enviar um convite"
        },
        "no_invitations_remaining": "Sem convites pendentes",
        "send_instructions": "Um email de convite foi enviado para %{email}.",
        "updated": "Sua senha foi atualizada com sucesso. Você está autenticado agora."
      },
      "mailer": {
        "invitation_instructions": {
          "accept": "Aceitar convite",
          "hello": "Olá %{email}",
          "ignore": "Se você não quer aceitar esse convite, por favor ignore esse e-mail.<br />Sua conta não será criada até você acessar o link abaixo e escolher sua senha.",
          "someone_invited_you": "Alguém convidou você para acessar %{url}, você pode aceitar o convite através do link abaixo.",
          "subject": "Instruções do convite"
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Enviar",
          "submit_verification_code": "Enviar código de verificação",
          "verification_code": "Código de verificação"
        },
        "updated": "Código de verificação aceito"
      },
      "paranoid_verify": {
        "code_required": "Por favor entre o código que a equipe de suporte enviou"
      },
      "password_expired": {
        "change_required": "Sua senha expirou. Renove sua senha por favor.",
        "show": {
          "change_my_password": "Mudar minha senha",
          "current_password": "Senha atual",
          "new_password": "Senha nova",
          "new_password_confirmation": "Confirmar senha nova",
          "renew_your_password": "Renove sua senha"
        },
        "updated": "A nova senha foi salva."
      }
    },
    "errors": {
      "messages": {
        "equal_to_current_password": "deve ser diferente da senha atual.",
        "equal_to_email": "deve ser diferente do e-mail.",
        "password_complexity": {
          "digit": {
            "one": "deve conter ao menos um dígito",
            "other": "deve conter ao menos %{count} dígitos"
          },
          "lower": {
            "one": "deve conter ao menos uma letra minúscula",
            "other": "deve conter ao menos %{count} letras minúsculas"
          },
          "symbol": {
            "one": "deve conter ao menos um símbolo",
            "other": "deve conter ao menos %{count} símbolos"
          },
          "upper": {
            "one": "deve conter ao menos uma letra maiúscula",
            "other": "deve conter ao menos %{count} letras maiúsculas"
          }
        },
        "taken_in_past": "foi usada anteriormente."
      }
    },
    "formtastic": {
      "cancel": "Cancelar %{model}",
      "create": "Criar %{model}",
      "no": "Não",
      "required": "obrigatório",
      "reset": "Resetar %{model}",
      "submit": "Salvar %{model}",
      "update": "Atualizar %{model}",
      "yes": "Sim"
    },
    "numbers": {
      "billions": {
        "one": "bilhão",
        "other": "bilhões"
      },
      "hundreds": [
        "_",
        "cento",
        "duzentos",
        "trezentos",
        "quatrocentos",
        "quinhentos",
        "seiscentos",
        "setecentos",
        "oitocentos",
        "novecentos"
      ],
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillions"
      ],
      "millions": {
        "one": "milhão",
        "other": "milhões"
      },
      "one_hundred": "cem",
      "ones": [
        "zero",
        "um",
        "dois",
        "três",
        "quatro",
        "cinco",
        "seis",
        "sete",
        "oito",
        "nove"
      ],
      "quadrillions": {
        "one": "quadrilhão",
        "other": "quadrilhões"
      },
      "quintillions": {
        "one": "quinquilhão",
        "other": "quinquilhões"
      },
      "teens": [
        "_",
        "onze",
        "doze",
        "treze",
        "quatorze",
        "quinze",
        "dezesseis",
        "dezessete",
        "dezoito",
        "dezenove"
      ],
      "tens": [
        "_",
        "dez",
        "vinte",
        "trinta",
        "quarenta",
        "cinquenta",
        "sessenta",
        "setenta",
        "oitenta",
        "noventa"
      ],
      "thousands": "mil",
      "trillions": {
        "one": "trilhão",
        "other": "trilhões"
      },
      "union": "e"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Página",
          "other": "Páginas"
        },
        "next": "Próximo",
        "previous": "Anterior"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Mostrando %{item_name} %{from}-%{to} de um total de %{count}",
        "no_count": "Página %{page} de %{pages}",
        "no_items": "Sem resultados",
        "single_page": "Mostrando %{count} %{item_name}"
      },
      "input_nav_js": "Página %{page_input} de %{pages}",
      "item_name": {
        "one": "item",
        "other": "itens"
      },
      "limit_tag_js": "Mostrar %{limit_input} %{item_name} por página",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, não conseguimos validar sua resposta do reCAPTCHA. Por favor, tente novamente.",
        "verification_failed": "A verificação do reCAPTCHA falhou, por favor, tente novamente."
      }
    }
  },
  "pt-BR": {
    "active_admin": {
      "access_denied": {
        "message": "Você não tem permissão para realizar o solicitado"
      },
      "any": "Qualquer",
      "batch_actions": {
        "action_label": "%{title} Selecionado",
        "button_label": "Ações em lote",
        "default_confirmation": "Tem certeza que quer fazer isso?",
        "delete_confirmation": "Tem certeza que deseja excluir estes %{plural_model}?",
        "labels": {
          "destroy": "Excluir"
        },
        "selection_toggle_explanation": "(Alternar Seleção)",
        "succesfully_destroyed": {
          "one": "Excluiu com sucesso 1 %{model}",
          "other": "Excluiu com sucesso %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Não existem %{resource_name} ainda.",
        "link": "Novo"
      },
      "cancel": "Cancelar",
      "comments": {
        "add": "Adicionar Comentário",
        "author": "Autor",
        "author_missing": "Anônimo",
        "author_type": "Tipo de Autor",
        "body": "Conteúdo",
        "created_at": "Criado em",
        "delete": "Deletar comentário",
        "delete_confirmation": "Tem certeza que deseja excluir este comentário?",
        "errors": {
          "empty_text": "O comentário não foi salvo porque o texto estava vazio."
        },
        "no_comments_yet": "Nenhum comentário.",
        "resource": "Objeto",
        "resource_type": "Tipo de Objeto",
        "title_content": "Comentários: %{count}"
      },
      "create_another": "Criar outro %{model}",
      "dashboard": "Painel Administrativo",
      "dashboard_welcome": {
        "call_to_action": "Para adicionar seções ao painel, verifique 'app/admin/dashboard.rb'",
        "welcome": "Bem vindo ao Active Admin. Esta é a página de painéis padrão."
      },
      "delete": "Remover",
      "delete_confirmation": "Você tem certeza que deseja remover este item?",
      "delete_model": "Remover %{model}",
      "details": "Detalhes do(a) %{model}",
      "devise": {
        "change_password": {
          "submit": "Troque minha senha",
          "title": "Troque sua senha"
        },
        "email": {
          "title": "E-mail"
        },
        "links": {
          "forgot_your_password": "Esqueceu sua senha?",
          "resend_confirmation_instructions": "Reenviar instruções de confirmação",
          "resend_unlock_instructions": "Reenviar instruções de desbloqueio",
          "sign_in": "Entrar",
          "sign_in_with_omniauth_provider": "Entre com o %{provider}",
          "sign_up": "Criar conta"
        },
        "login": {
          "remember_me": "Lembrar da senha",
          "submit": "Entrar",
          "title": "Conta"
        },
        "password": {
          "title": "Senha"
        },
        "password_confirmation": {
          "title": "Confirmação de senha"
        },
        "resend_confirmation_instructions": {
          "submit": "Reenviar instruções de confirmação",
          "title": "Reenviar instruções de confirmação"
        },
        "reset_password": {
          "submit": "Reinicie minha senha",
          "title": "Esqueceu sua senha?"
        },
        "sign_up": {
          "submit": "Continuar",
          "title": "Cadastre-se"
        },
        "subdomain": {
          "title": "Subdomínio"
        },
        "unlock": {
          "submit": "Reenviar instruções de desbloqueio",
          "title": "Reenviar instruções de desbloqueio"
        },
        "username": {
          "title": "Nome de Usuário"
        }
      },
      "download": "Baixar:",
      "dropdown_actions": {
        "button_label": "Ações"
      },
      "edit": "Editar",
      "edit_model": "Editar %{model}",
      "empty": "Vazio",
      "filters": {
        "buttons": {
          "clear": "Limpar Filtros",
          "filter": "Filtrar"
        },
        "predicates": {
          "from": "A partir de",
          "to": "Até"
        }
      },
      "has_many_delete": "Remover",
      "has_many_new": "Adicionar Novo(a) %{model}",
      "has_many_remove": "Remover",
      "index_list": {
        "block": "Lista",
        "blog": "Blog",
        "grid": "Grid",
        "table": "Tabela"
      },
      "logout": "Sair",
      "main_content": "Por favor implemente %{model}#main_content para exibir conteúdo.",
      "new_model": "Novo(a) %{model}",
      "next": "Próximo",
      "pagination": {
        "empty": "Nenhum(a) %{model} encontrado(a)",
        "entry": {
          "one": "registro",
          "other": "registros"
        },
        "multiple": "Exibindo %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> de um total de <b>%{total}</b>",
        "multiple_without_total": "Exibindo %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Exibindo <b>1</b> %{model}",
        "one_page": "Exibindo <b>todos(as) os(as) %{n}</b> %{model}",
        "per_page": "Por página: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Anterior",
      "search_status": {
        "current_filters": "Filtros escolhidos:",
        "current_scope": "Em:",
        "headline": "Buscou:",
        "no_current_filters": "Nenhum"
      },
      "sidebars": {
        "filters": "Filtros",
        "search_status": "Buscou"
      },
      "status_tag": {
        "no": "Não",
        "unset": "Não",
        "yes": "Sim"
      },
      "unsupported_browser": {
        "headline": "O ActiveAdmin não oferece suporte ao Internet Explorer versão 8 ou inferior.",
        "recommendation": "Nós recomendamos atualizar para a última versão do <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, ou <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Se você está usando o IE 9 ou superior, <a href=\"https://support.microsoft.com/pt-br/help/17471\">desligue o \"Modo de Exibição de Compatibilidade\"</a>."
      },
      "view": "Visualizar"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Senha atual",
          "email": "Email",
          "password": "Senha",
          "password_confirmation": "Confirme sua senha",
          "remember_me": "Lembre-se de mim"
        }
      },
      "models": {
        "user": "Usuário"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Reenviar instruções de confirmação"
        }
      },
      "failure": {
        "invited": "Você tem um convite pendente, aceite para finalizar sua conta."
      },
      "invitations": {
        "edit": {
          "header": "Escolha sua senha",
          "submit_button": "Atualizar minha senha"
        },
        "invitation_removed": "Seu convite foi removido.",
        "invitation_token_invalid": "O código do convite não é válido!",
        "new": {
          "header": "Enviar convite",
          "submit_button": "Enviar um convite"
        },
        "no_invitations_remaining": "Sem convites pendentes",
        "send_instructions": "Um email de convite foi enviado para %{email}.",
        "updated": "Sua senha foi atualizada com sucesso. Você está autenticado agora."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar minha conta",
          "greeting": "Bem-vindo %{recipient}!",
          "instruction": "Você pode confirmar sua conta através do link abaixo:"
        },
        "invitation_instructions": {
          "accept": "Aceitar convite",
          "hello": "Olá %{email}",
          "ignore": "Se você não quer aceitar esse convite, por favor ignore esse e-mail.<br />Sua conta não será criada até você acessar o link abaixo e escolher sua senha.",
          "someone_invited_you": "Alguém convidou você para acessar %{url}, você pode aceitar o convite através do link abaixo.",
          "subject": "Instruções do convite"
        },
        "reset_password_instructions": {
          "action": "Redefinir minha senha",
          "greeting": "Olá %{recipient}!",
          "instruction": "Alguém fez o pedido para redefinir sua senha, e você pode fazer isso clicando no link abaixo.",
          "instruction_2": "Se você não fez este pedido, por favor ignore este e-mail.",
          "instruction_3": "Sua senha não será alterada até que você acesse o link abaixo e crie uma nova."
        },
        "unlock_instructions": {
          "action": "Desbloquear minha conta",
          "greeting": "Olá %{recipient}!",
          "instruction": "Clique no link abaixo para desbloquear sua conta:",
          "message": "Sua conta foi bloqueada devido ao excessivo número de tentativas acesso inválidas."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Alterar minha senha",
          "change_your_password": "Alterar sua senha",
          "confirm_new_password": "Confirme sua nova senha",
          "new_password": "Nova senha"
        },
        "new": {
          "forgot_your_password": "Esqueceu sua senha?",
          "send_me_reset_password_instructions": "Enviar instruções para redefinição da senha"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Você tem certeza?",
          "cancel_my_account": "Cancelar minha conta",
          "currently_waiting_confirmation_for_email": "No momento esperando por: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "deixe em branco caso não queira alterá-la",
          "title": "Editar %{resource}",
          "unhappy": "Não está contente",
          "update": "Atualizar",
          "we_need_your_current_password_to_confirm_your_changes": "precisamos da sua senha atual para confirmar suas mudanças"
        },
        "new": {
          "sign_up": "Inscrever-se"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Login"
        }
      },
      "shared": {
        "links": {
          "back": "Voltar",
          "didn_t_receive_confirmation_instructions": "Não recebeu instruções de confirmação?",
          "didn_t_receive_unlock_instructions": "Não recebeu instruções de desbloqueio?",
          "forgot_your_password": "Esqueceu sua senha?",
          "sign_in": "Login",
          "sign_in_with_provider": "Entrar com %{provider}",
          "sign_up": "Inscrever-se"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Reenviar instruções de desbloqueio"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "tem uma proporção inválida (as proporções válidas são %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "deve ser paisagem (o arquivo atual é %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "deve ser portrait (o arquivo atual é %{width}x%{height}px)",
        "aspect_ratio_not_square": "deve ser quadrado (o arquivo atual é %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "deve ser %{authorized_aspect_ratios} (o arquivo atual é %{width}x%{height}px)",
        "attachment_missing": "não tem nenhum arquivo anexado",
        "audio_missing": "deve ter uma faixa de áudio",
        "audio_present": "não deve ter uma faixa de áudio",
        "content_type_invalid": {
          "one": "tem um tipo de conteúdo inválido (o tipo de conteúdo autorizado é %{authorized_human_content_types})",
          "other": "tem um tipo de conteúdo inválido (os tipos de conteúdo autorizados são %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "tem um tipo de conteúdo que não é equivalente ao que é detectado através do seu conteúdo (tipo de conteúdo autorizado é %{authorized_human_content_types})",
          "other": "tem um tipo de conteúdo que não é equivalente ao que é detectado através do seu conteúdo (tipos de conteúdo autorizados são %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "deve ter altura igual a %{length} pixels",
        "dimension_height_not_greater_than_or_equal_to": "deve ter altura maior ou igual a %{length} pixels",
        "dimension_height_not_included_in": "deve ter altura entre %{min} e %{max} pixels",
        "dimension_height_not_less_than_or_equal_to": "deve ter altura menor ou igual a %{length} pixels",
        "dimension_max_not_included_in": "deve ser menor ou igual a %{width} x %{height} pixels",
        "dimension_min_not_included_in": "deve ser maior ou igual a %{width} x %{height} pixels",
        "dimension_width_not_equal_to": "deve ter largura igual a %{length} pixels",
        "dimension_width_not_greater_than_or_equal_to": "deve ter largura maior ou igual a %{length} pixels",
        "dimension_width_not_included_in": "deve ter largura entre %{min} e %{max} pixels",
        "dimension_width_not_less_than_or_equal_to": "deve ter largura menor ou igual a %{length} pixels",
        "duration_not_between": "a duração deve estar entre %{min} e %{max} (a duração atual é %{duration})",
        "duration_not_equal_to": "a duração deve ser igual a %{exact} (a duração atual é %{duration})",
        "duration_not_greater_than": "a duração tem de ser superior a %{min} (a duração atual é %{duration})",
        "duration_not_greater_than_or_equal_to": "a duração deve ser maior ou igual a %{min} (a duração atual é %{duration})",
        "duration_not_less_than": "a duração deve ser inferior a %{max} (a duração atual é %{duration})",
        "duration_not_less_than_or_equal_to": "a duração deve ser inferior ou igual a %{max} (a duração atual é %{duration})",
        "file_not_processable": "não é identificado como um arquivo de mídia válido",
        "file_size_not_between": "o tamanho do arquivo deve estar entre %{min} e %{max} (o tamanho atual é %{file_size})",
        "file_size_not_equal_to": "o tamanho do arquivo deve ser igual a %{exact} (o tamanho atual é %{file_size})",
        "file_size_not_greater_than": "o tamanho do arquivo deve ser maior que %{min} (o tamanho atual é %{file_size})",
        "file_size_not_greater_than_or_equal_to": "o tamanho do arquivo deve ser maior ou igual a %{min} (o tamanho atual é %{file_size})",
        "file_size_not_less_than": "o tamanho do arquivo deve ser menor que %{max} (o tamanho atual é %{file_size})",
        "file_size_not_less_than_or_equal_to": "o tamanho do arquivo deve ser menor ou igual a %{max} (o tamanho atual é %{file_size})",
        "limit_max_exceeded": {
          "one": "muitos arquivos anexados (o máximo é %{max}, obteve %{count})",
          "other": "muitos arquivos anexados (o máximo é %{max}, obteve %{count})",
          "zero": "sem arquivos anexados (o máximo é %{max})"
        },
        "limit_min_not_reached": {
          "one": "apenas 1 arquivo anexado (deve ter pelo menos %{min} arquivos)",
          "other": "%{count} arquivos anexados (deve ter pelo menos %{min} arquivos)",
          "zero": "sem arquivos anexados (deve ter pelo menos %{min})"
        },
        "limit_out_of_range": {
          "one": "apenas 1 arquivo anexado (deve ter entre %{min} e %{max})",
          "other": "o número total de arquivos deve estar entre os arquivos %{min} e %{max} (há arquivos %{count} anexados)",
          "zero": "nenhum arquivo anexado (deve ter entre %{min} e %{max})"
        },
        "media_metadata_missing": "não é um arquivo de mídia válido",
        "pages_not_between": "a contagem de páginas deve estar entre %{min} e %{max} (a contagem atual de páginas é %{pages})",
        "pages_not_equal_to": "a contagem de páginas deve ser igual a %{exact} (a contagem atual de páginas é %{pages})",
        "pages_not_greater_than": "a contagem de páginas deve ser maior que %{min} (a contagem atual de páginas é %{pages})",
        "pages_not_greater_than_or_equal_to": "a contagem de páginas deve ser maior ou igual a %{min} (a contagem atual de páginas é %{pages})",
        "pages_not_less_than": "a contagem de páginas deve ser menor que %{max} (a contagem atual de páginas é %{pages})",
        "pages_not_less_than_or_equal_to": "a contagem de páginas deve ser menor ou igual a %{max} (a contagem atual de páginas é %{pages})",
        "total_file_size_not_between": "o tamanho total do arquivo deve estar entre %{min} e %{max} (o tamanho atual é %{total_file_size})",
        "total_file_size_not_equal_to": "o tamanho total do arquivo deve ser igual a %{exact} (o tamanho atual é %{total_file_size})",
        "total_file_size_not_greater_than": "o tamanho total do arquivo deve ser maior que %{min} (o tamanho atual é %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "o tamanho total do arquivo deve ser maior ou igual a %{min} (o tamanho atual é %{total_file_size})",
        "total_file_size_not_less_than": "o tamanho total do arquivo deve ser menor que %{max} (o tamanho atual é %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "o tamanho total do arquivo deve ser menor ou igual a %{max} (o tamanho atual é %{total_file_size})"
      }
    },
    "formtastic": {
      "cancel": "Cancelar %{model}",
      "create": "Criar %{model}",
      "no": "Não",
      "required": "obrigatório",
      "reset": "Voltar %{model}",
      "submit": "Salvar %{model}",
      "update": "Atualizar %{model}",
      "yes": "Sim"
    },
    "numbers": {
      "billions": {
        "one": "bilhão",
        "other": "bilhões"
      },
      "billionths": {
        "one": "bilionésimo",
        "other": "bilionésimos"
      },
      "decillions": {
        "one": "decilhão",
        "other": "decilhões"
      },
      "decillionths": {
        "one": "decilionésimo",
        "other": "decilionésimos"
      },
      "duodecillionths": {
        "one": "duodecilionésimo",
        "other": "duodecilionésimos"
      },
      "hundreds": {
        "female": [
          "_",
          "cento",
          "duzentas",
          "trezentas",
          "quatrocentas",
          "quinhentas",
          "seiscentas",
          "setecentas",
          "oitocentas",
          "novecentas"
        ],
        "male": [
          "_",
          "cento",
          "duzentos",
          "trezentos",
          "quatrocentos",
          "quinhentos",
          "seiscentos",
          "setecentos",
          "oitocentos",
          "novecentos"
        ]
      },
      "hundredths": {
        "one": "centésimo",
        "other": "centésimos"
      },
      "integral": {
        "one": "inteiro",
        "other": "inteiros"
      },
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillions",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths",
        "quadrillionths",
        "quintillionths",
        "sextillionths",
        "septillionths",
        "octillionths",
        "nonillionths",
        "decillionths",
        "undecillionths",
        "duodecillionths",
        "tredecillionths",
        "quattuordecillionths"
      ],
      "micro_prefix": {
        "hundreds": {
          "one": "centésimo",
          "other": "centésimos"
        },
        "tens": {
          "one": "décimo",
          "other": "décimos"
        },
        "union": " de "
      },
      "micro_separator": "e",
      "millions": {
        "one": "milhão",
        "other": "milhões"
      },
      "millionths": {
        "one": "milionésimo",
        "other": "milionésimos"
      },
      "nonillions": {
        "one": "nonilhão",
        "other": "nonilhões"
      },
      "nonillionths": {
        "one": "nonilionésimo",
        "other": "nonilionésimos"
      },
      "octillions": {
        "one": "octilhão",
        "other": "octilhões"
      },
      "octillionths": {
        "one": "octilionésimo",
        "other": "octilionésimos"
      },
      "one_hundred": "cem",
      "ones": {
        "female": [
          "zero",
          "uma",
          "duas",
          "três",
          "quatro",
          "cinco",
          "seis",
          "sete",
          "oito",
          "nove"
        ],
        "male": [
          "zero",
          "um",
          "dois",
          "três",
          "quatro",
          "cinco",
          "seis",
          "sete",
          "oito",
          "nove"
        ]
      },
      "ordinal": {
        "hundreds": {
          "female": [
            "_",
            "centésima",
            "ducentésima",
            "trecentésima",
            "quadringentésima",
            "quingentésima",
            "sexcentésima",
            "septingentésima",
            "octingentésima",
            "noningentésima"
          ],
          "male": [
            "_",
            "centésimo",
            "ducentésimo",
            "trecentésimo",
            "quadringentésimo",
            "quingentésimo",
            "sexcentésimo",
            "septingentésimo",
            "octingentésimo",
            "noningentésimo"
          ]
        },
        "mega": {
          "female": [
            "_",
            "milésima",
            "milionésima",
            "bilionésima",
            "trilionésima",
            "quadrilionésima",
            "sextilionésima",
            "septilionésima",
            "octilionésima",
            "nonilionésima"
          ],
          "male": [
            "_",
            "milésimo",
            "milionésimo",
            "bilionésimo",
            "trilionésimo",
            "quadrilionésimo",
            "sextilionésimo",
            "septilionésimo",
            "octilionésimo",
            "nonilionésimo"
          ]
        },
        "ones": {
          "female": [
            "zera",
            "primeira",
            "segunda",
            "terceira",
            "quarta",
            "quinta",
            "sexta",
            "sétima",
            "oitava",
            "nona"
          ],
          "male": [
            "zero",
            "primeiro",
            "segundo",
            "terceiro",
            "quarto",
            "quinto",
            "sexto",
            "sétimo",
            "oitavo",
            "nono"
          ]
        },
        "tens": {
          "female": [
            "_",
            "décima",
            "vigésima",
            "trigésima",
            "quadragésima",
            "quinquagésima",
            "sexagésima",
            "septuagésima",
            "octogésima",
            "nonagésima"
          ],
          "male": [
            "_",
            "décimo",
            "vigésimo",
            "trigésimo",
            "quadragésimo",
            "quinquagésimo",
            "sexagésimo",
            "septuagésimo",
            "octogésimo",
            "nonagésimo"
          ]
        }
      },
      "quadrillions": {
        "one": "quadrilhão",
        "other": "quadrilhões"
      },
      "quadrillionths": {
        "one": "quadrilionésimo",
        "other": "quadrilionésimos"
      },
      "quattuordecillionths": {
        "one": "quadringentilionésimo",
        "other": "quadringentilionésimos"
      },
      "quintillions": {
        "one": "quintilhão",
        "other": "quintilhões"
      },
      "quintillionths": {
        "one": "quintilionésimo",
        "other": "quintilionésimos"
      },
      "septillions": {
        "one": "septilhão",
        "other": "septilhões"
      },
      "septillionths": {
        "one": "septilionésimo",
        "other": "septilionésimos"
      },
      "sextillions": {
        "one": "sextilhão",
        "other": "sextilhões"
      },
      "sextillionths": {
        "one": "sextilionésimo",
        "other": "sextilionésimos"
      },
      "teens": [
        "_",
        "onze",
        "doze",
        "treze",
        "quatorze",
        "quinze",
        "dezesseis",
        "dezessete",
        "dezoito",
        "dezenove"
      ],
      "tens": [
        "_",
        "dez",
        "vinte",
        "trinta",
        "quarenta",
        "cinquenta",
        "sessenta",
        "setenta",
        "oitenta",
        "noventa"
      ],
      "tenths": {
        "one": "décimo",
        "other": "décimos"
      },
      "thousands": "mil",
      "thousandths": {
        "one": "milésimo",
        "other": "milésimos"
      },
      "tredecillionths": {
        "one": "trecentilionésimo",
        "other": "trecentilionésimos"
      },
      "trillions": {
        "one": "trilhão",
        "other": "trilhões"
      },
      "trillionths": {
        "one": "trilionésimo",
        "other": "trilionésimo"
      },
      "undecillionths": {
        "one": "undecilionésimo",
        "other": "undecilionésimos"
      },
      "union": "e"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Página",
          "other": "Páginas"
        },
        "next": "Próximo",
        "previous": "Anterior"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Mostrando %{item_name} %{from}-%{to} do total de %{count}",
        "no_count": "Página %{page} de %{pages}",
        "no_items": "Sem resultados",
        "single_page": "Mostrando %{count} %{item_name}"
      },
      "input_nav_js": "Página %{page_input} de %{pages}",
      "item_name": {
        "one": "item",
        "other": "itens"
      },
      "limit_tag_js": "Mostrar %{limit_input} %{item_name} por página",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "todos",
      "and": "e",
      "any": "algum",
      "asc": "ascendente",
      "attribute": "atributo",
      "combinator": "combinador",
      "condition": "condição",
      "desc": "descendente",
      "or": "ou",
      "predicate": "predicado",
      "predicates": {
        "blank": "está em branco",
        "cont": "contém",
        "cont_all": "contém todos",
        "cont_any": "contém algum",
        "does_not_match": "não corresponde",
        "does_not_match_all": "não corresponde a todos",
        "does_not_match_any": "não corresponde a algum",
        "end": "termina com",
        "end_all": "termina com todos",
        "end_any": "termina com algum",
        "eq": "igual",
        "eq_all": "igual a todos",
        "eq_any": "igual a algum",
        "false": "é falso",
        "gt": "maior que",
        "gt_all": "maior que todos",
        "gt_any": "maior que algum",
        "gteq": "maior que ou igual a",
        "gteq_all": "maior que ou igual a todos",
        "gteq_any": "maior que ou igual a algum",
        "in": "em",
        "in_all": "em todos",
        "in_any": "em algum",
        "lt": "menor que",
        "lt_all": "menor que todos",
        "lt_any": "menor que algum",
        "lteq": "menor ou igual a",
        "lteq_all": "menor ou igual a todos",
        "lteq_any": "menor ou igual a algum",
        "matches": "corresponde",
        "matches_all": "corresponde a todos",
        "matches_any": "corresponde a algum",
        "not_cont": "não contém",
        "not_cont_all": "não contém todos",
        "not_cont_any": "não contém algum",
        "not_end": "não termina com",
        "not_end_all": "não termina com todos",
        "not_end_any": "não termina com algum",
        "not_eq": "não é igual a",
        "not_eq_all": "não é igual a todos",
        "not_eq_any": "não é igual a algum",
        "not_in": "não em",
        "not_in_all": "não em todos",
        "not_in_any": "não em algum",
        "not_null": "não é nulo",
        "not_start": "não começa com",
        "not_start_all": "não começa com algum",
        "not_start_any": "não começa com algum",
        "null": "é nulo",
        "present": "está presente",
        "start": "começa com",
        "start_all": "começa com todos",
        "start_any": "começa com algum",
        "true": "é verdadeiro"
      },
      "search": "pesquisar",
      "sort": "classificar",
      "value": "valor"
    },
    "recaptcha": {
      "errors": {
        "recaptcha_unreachable": "Oops, não conseguimos validar sua resposta do reCAPTCHA. Por favor, tente novamente.",
        "verification_failed": "A verificação do reCAPTCHA falhou, por favor, tente novamente."
      }
    }
  },
  "pt-PT": {
    "active_admin": {
      "any": "Qualquer",
      "batch_actions": {
        "action_label": "%{title} Selecionado",
        "button_label": "Ações em quantidade",
        "default_confirmation": "Tem a certeza que quer fazer isso?",
        "delete_confirmation": "Tem a certeza de que deseja excluir estes %{plural_model}?",
        "labels": {
          "destroy": "Excluir"
        },
        "selection_toggle_explanation": "(Alternar Seleção)",
        "succesfully_destroyed": {
          "one": "Excluiu com sucesso 1 %{model}",
          "other": "Excluiu com sucesso %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Ainda não existem %{resource_name}.",
        "link": "Novo"
      },
      "cancel": "Cancelar",
      "comments": {
        "add": "Adicionar Comentário",
        "author": "Autor",
        "body": "Conteúdo",
        "errors": {
          "empty_text": "O comentário não foi guardado porque o texto estava vazio."
        },
        "no_comments_yet": "Nenhum comentário.",
        "resource": "Objeto",
        "title_content": "Comentários: %{count}"
      },
      "dashboard": "Painel de Administração",
      "dashboard_welcome": {
        "call_to_action": "Se pretende adicionar seções ao painel, consulte 'app/admin/dashboard.rb'",
        "welcome": "Bem-vindo ao Active Admin. Esta é a página padrão."
      },
      "delete": "Remover",
      "delete_confirmation": "Não tem a certeza de que deseja remover este ítem?",
      "delete_model": "Remover %{model}",
      "details": "Detalhes do(a) %{model}",
      "devise": {
        "change_password": {
          "submit": "Trocar a minha senha",
          "title": "Troque a sua senha"
        },
        "links": {
          "forgot_your_password": "Esqueceu-se da sua senha?",
          "sign_in": "Entrar",
          "sign_in_with_omniauth_provider": "Entre com o %{provider}"
        },
        "login": {
          "remember_me": "Lembrar-me",
          "submit": "Entrar",
          "title": "Conta"
        },
        "reset_password": {
          "submit": "Reiniciar a minha senha",
          "title": "Esqueceu-de da sua senha?"
        }
      },
      "download": "Baixar:",
      "dropdown_actions": {
        "button_label": "Ações"
      },
      "edit": "Editar",
      "edit_model": "Editar %{model}",
      "empty": "Vazio",
      "filters": {
        "buttons": {
          "clear": "Limpar Filtros",
          "filter": "Filtrar"
        }
      },
      "has_many_delete": "Remover",
      "has_many_new": "Adicionar Novo(a) %{model}",
      "has_many_remove": "Remover",
      "logout": "Sair",
      "main_content": "Por favor implemente %{model}#main_content para mostrar o conteúdo.",
      "new_model": "Novo(a) %{model}",
      "next": "Próximo",
      "pagination": {
        "empty": "Nenhum(a) %{model} encontrado(a)",
        "entry": {
          "one": "registro",
          "other": "registros"
        },
        "multiple": "Mostrando %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> de um total de <b>%{total}</b>",
        "multiple_without_total": "Mostrando %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Mostrando <b>1</b> %{model}",
        "one_page": "Mostrando <b>todos(as) os(as) %{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Anterior",
      "sidebars": {
        "filters": "Filtros"
      },
      "status_tag": {
        "no": "Não",
        "unset": "Não",
        "yes": "Sim"
      },
      "view": "Visualizar"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": null,
          "email": null,
          "password": null,
          "password_confirmation": null,
          "remember_me": null
        }
      },
      "models": {
        "user": null
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Reenviar instruções de confirmação"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirmar a minha conta",
          "greeting": "Bem-vindo %{recipient}!",
          "instruction": "Pode confirmar a sua conta através do link:"
        },
        "reset_password_instructions": {
          "action": "Repor a minha senha",
          "greeting": "Olá %{recipient}!",
          "instruction": "Foi efectuado um pedido para repor a sua palavra-passe. Para o fazer click no link abaixo.",
          "instruction_2": "Se não fez este pedido, por favor ignore este e-mail.",
          "instruction_3": "A sua palavra-passe só será alterada quando aceder ao link abaixo para a alterar."
        },
        "unlock_instructions": {
          "action": "Desbloquear a minha conta",
          "greeting": "Olá %{recipient}!",
          "instruction": "Clique no seguinte link para desbloquear a sua conta:",
          "message": "A sua conta foi bloqueada devido a um número excessivo de tentativas de acesso inválidas."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": null,
          "change_your_password": null,
          "confirm_new_password": null,
          "new_password": null
        },
        "new": {
          "forgot_your_password": "Esqueceu a sua senha?",
          "send_me_reset_password_instructions": "Enviar-me instruções para repor a senha"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Tem a certeza?",
          "cancel_my_account": "Cancelar a minha conta",
          "currently_waiting_confirmation_for_email": null,
          "leave_blank_if_you_don_t_want_to_change_it": "deixe em branco caso não queira alterar",
          "title": "Editar %{resource}",
          "unhappy": null,
          "update": null,
          "we_need_your_current_password_to_confirm_your_changes": "precisamos da sua senha actual para confirmar as alterações"
        },
        "new": {
          "sign_up": "Criar Conta"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Entrar"
        }
      },
      "shared": {
        "links": {
          "back": null,
          "didn_t_receive_confirmation_instructions": "Não recebeu instruções de confirmação?",
          "didn_t_receive_unlock_instructions": "Não recebeu instruções de desbloqueio?",
          "forgot_your_password": "Equeceu a palavra-passe?",
          "sign_in": "Login",
          "sign_in_with_provider": "Entrar com %{provider}",
          "sign_up": "Criar conta"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Renviar instruções de desbloqueio"
        }
      }
    }
  },
  "ro": {
    "active_admin": {
      "any": "Oricare",
      "batch_actions": {
        "action_label": "%{title} Selectat",
        "button_label": "Grupare Actiuni",
        "default_confirmation": "Sunteţi sigur că doriţi să faceţi acest lucru?",
        "delete_confirmation": "Sunteţi sigur că doriţi să stergeţi aceste %{plural_model}?",
        "labels": {
          "destroy": "Sterge"
        },
        "selection_toggle_explanation": "(Modifica Selectia)",
        "succesfully_destroyed": {
          "few": "%{count} %{plural_model} sterse",
          "one": "1 %{model} sters",
          "other": "%{count} %{plural_model} sterse"
        }
      },
      "blank_slate": {
        "content": "Momentan nu exista %{resource_name}.",
        "link": "Creati un"
      },
      "cancel": "Renuntati",
      "comments": {
        "add": "Adaugati comentariu",
        "author": "Autor",
        "body": "Text",
        "errors": {
          "empty_text": "Comentariul nu a fost salvat, textul lipseste."
        },
        "no_comments_yet": "Nu exista comentarii.",
        "resource": "Resursa",
        "title_content": "Comentarii (%{count})"
      },
      "dashboard": "Pagina Principala",
      "dashboard_welcome": {
        "call_to_action": "Pentru a adauga sectiuni, vedeti 'app/admin/dashboard.rb'",
        "welcome": "Bine ati venit pe Active Admin. Aceasta este pagina principala."
      },
      "delete": "Stergeti",
      "delete_confirmation": "Sigur vreti sa stergeti?",
      "delete_model": "Stergeti %{model}",
      "details": "Detalii %{model}",
      "devise": {
        "change_password": {
          "submit": "Schimbă parola",
          "title": "Schimbați parola"
        },
        "links": {
          "forgot_your_password": "Ați uitat parola?",
          "sign_in": "Autentificare",
          "sign_in_with_omniauth_provider": "Conectați-vă cu %{provider}"
        },
        "login": {
          "remember_me": "Tine-ma minte",
          "submit": "Autentificare",
          "title": "Autentificare"
        },
        "reset_password": {
          "submit": "Reseta parola",
          "title": "Ați uitat parola?"
        },
        "unlock": {
          "submit": "Retrimite instrucțiunile de deblocare",
          "title": "Retrimite instrucțiunile de deblocare"
        }
      },
      "download": "Descarcati:",
      "dropdown_actions": {
        "button_label": "Actiuni"
      },
      "edit": "Modificati",
      "edit_model": "Modificati %{model}",
      "empty": "Gol",
      "filters": {
        "buttons": {
          "clear": "Stergeti filtrele",
          "filter": "Cautati"
        }
      },
      "has_many_delete": "Stergeti",
      "has_many_new": "Adaugati un nou %{model}",
      "has_many_remove": "Scoate",
      "logout": "Iesire",
      "main_content": "Va rugam sa implementati %{model}#main_content pentru a afisa continut.",
      "new_model": "Un nou %{model}",
      "next": "Inainte",
      "pagination": {
        "empty": "Nu am gasit nici un %{model}",
        "entry": {
          "few": "înregistrări",
          "one": "înregistrăre",
          "other": "înregistrări"
        },
        "multiple": "Sunt afisate <b>%{from}&nbsp;-&nbsp;%{to}</b> din <b>%{total}</b> inregistrari",
        "multiple_without_total": "Sunt afisate <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Afisare <b>1</b> %{model}",
        "one_page": "Sunt afisate <b>toate %{n}</b> inregistrarile"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Inapoi",
      "sidebars": {
        "filters": "Filtre"
      },
      "status_tag": {
        "no": "Nu",
        "unset": "Nu",
        "yes": "Da"
      },
      "view": "Vizualizati"
    },
    "ransack": {
      "all": "toate",
      "and": "și",
      "any": "oricare",
      "asc": "crescător",
      "attribute": "atribut",
      "combinator": "combinator",
      "condition": "condiție",
      "desc": "descrescător",
      "or": "sau",
      "predicate": "predicat",
      "predicates": {
        "blank": "este gol",
        "cont": "conține",
        "cont_all": "conține toate",
        "cont_any": "conține unul din",
        "does_not_match": "nu corespunde",
        "does_not_match_all": "nu corespunde cu toate",
        "does_not_match_any": "nu corespunde cu nici un",
        "end": "se termină cu",
        "end_all": "se termină cu toate",
        "end_any": "se termină cu unul din",
        "eq": "egal cu",
        "eq_all": "egal cu toate",
        "eq_any": "egal cu unul din",
        "false": "este fals",
        "gt": "mai mare de",
        "gt_all": "mai mare decât toate",
        "gt_any": "mai mare decât cel puțin unul din",
        "gteq": "mai mare sau egal decât",
        "gteq_all": "mai mare sau egal decât toate",
        "gteq_any": "mai mare sau egal decât cel puțin unul din",
        "in": "inclus în",
        "in_all": "inclus în toate",
        "in_any": "inclus într-unul din",
        "lt": "mai mic de",
        "lt_all": "mai mic decât toate",
        "lt_any": "mai mic decât cel puțin unul din",
        "lteq": "mai mic sau egal decât",
        "lteq_all": "mai mic sau egal decât toate",
        "lteq_any": "mai mic sau egal decât cel puțin unul din",
        "matches": "corespunde",
        "matches_all": "corespunde cu toate",
        "matches_any": "corespunde cu unul din",
        "not_cont": "nu conține",
        "not_cont_all": "nu conține toate",
        "not_cont_any": "nu conține unul din",
        "not_end": "nu se termină cu",
        "not_end_all": "nu se termină cu toate",
        "not_end_any": "nu se termină cu unul din",
        "not_eq": "diferit de",
        "not_eq_all": "nu este egal cu toate",
        "not_eq_any": "diferit de toate",
        "not_in": "nu este inclus în",
        "not_in_all": "nu este inclus în toate",
        "not_in_any": "nu este inclus într-unul din",
        "not_null": "nu este nul",
        "not_start": "nu începe",
        "not_start_all": "nu începe cu toate",
        "not_start_any": "nu începe cu unul din",
        "null": "este nul",
        "present": "este prezent",
        "start": "începe cu",
        "start_all": "începe cu toate",
        "start_any": "începe cu unul din",
        "true": "este adevărat"
      },
      "search": "caută",
      "sort": "sortează",
      "value": "valoare"
    }
  },
  "ru": {
    "active_admin": {
      "access_denied": {
        "message": "Вы не авторизованы для выполнения данного действия."
      },
      "any": "Любой",
      "batch_actions": {
        "action_label": "%{title} выбранное",
        "button_label": "Групповые операции",
        "default_confirmation": "Вы уверены, что вы хотите это сделать?",
        "delete_confirmation": "Вы уверены, что хотите удалить %{plural_model}?",
        "labels": {
          "destroy": "Удалить"
        },
        "selection_toggle_explanation": "(Отметить всё / Снять выделение)",
        "succesfully_destroyed": {
          "few": "Успешно удалено: %{count} %{plural_model}",
          "many": "Успешно удалено: %{count} %{plural_model}",
          "one": "Успешно удалено: 1 %{model}",
          "other": "Успешно удалено: %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Пока нет %{resource_name}.",
        "link": "Создать"
      },
      "cancel": "Отмена",
      "comments": {
        "add": "Добавить Комментарий",
        "author": "Автор",
        "author_missing": "Аноним",
        "author_type": "Тип автора",
        "body": "Текст",
        "created_at": "Дата создания",
        "delete": "Удалить Комментарий",
        "delete_confirmation": "Вы уверены, что хотите удалить этот комментарий?",
        "errors": {
          "empty_text": "Комментарий не сохранен, текст не должен быть пустым."
        },
        "no_comments_yet": "Пока нет комментариев.",
        "resource": "Ресурс",
        "resource_type": "Тип ресурса",
        "title_content": "Комментарии (%{count})"
      },
      "dashboard": "Панель управления",
      "dashboard_welcome": {
        "call_to_action": "Чтобы добавить сюда что-нибудь загляните в 'app/admin/dashboard.rb'",
        "welcome": "Добро пожаловать в Active Admin. Это стандартная страница управления сайтом."
      },
      "delete": "Удалить",
      "delete_confirmation": "Вы уверены, что хотите удалить это?",
      "delete_model": "Удалить %{model}",
      "details": "%{model} подробнее",
      "devise": {
        "change_password": {
          "submit": "Изменение пароля",
          "title": "Изменение пароля"
        },
        "email": {
          "title": "Эл. почта"
        },
        "links": {
          "forgot_your_password": "Забыли пароль?",
          "resend_confirmation_instructions": "Повторная отправка инструкций подтверждения",
          "resend_unlock_instructions": "Повторная отправка инструкций разблокировки",
          "sign_in": "Войти",
          "sign_in_with_omniauth_provider": "Войти с помощью %{provider}",
          "sign_up": "Зарегистрироваться"
        },
        "login": {
          "remember_me": "Запомнить меня",
          "submit": "Войти",
          "title": "Войти"
        },
        "password": {
          "title": "Пароль"
        },
        "resend_confirmation_instructions": {
          "submit": "Выслать повторно письмо с активацией",
          "title": "Выслать повторно письмо с активацией"
        },
        "reset_password": {
          "submit": "Сбросить пароль",
          "title": "Забыли пароль?"
        },
        "sign_up": {
          "submit": "Зарегистрироваться",
          "title": "Зарегистрироваться"
        },
        "subdomain": {
          "title": "Поддомен"
        },
        "unlock": {
          "submit": "Повторно отправить инструкции по разблокировке",
          "title": "Повторно отправить инструкции по разблокировке"
        },
        "username": {
          "title": "Имя пользователя"
        }
      },
      "download": "Загрузка:",
      "dropdown_actions": {
        "button_label": "Oперации"
      },
      "edit": "Изменить",
      "edit_model": "Изменить %{model}",
      "empty": "Пусто",
      "filters": {
        "buttons": {
          "clear": "Очистить",
          "filter": "Фильтровать"
        },
        "predicates": {
          "from": "От",
          "to": "До"
        }
      },
      "has_many_delete": "Удалить",
      "has_many_new": "Добавить %{model}",
      "has_many_remove": "Убрать",
      "index_list": {
        "block": "Список",
        "blog": "Блог",
        "grid": "Сетка",
        "table": "Таблица"
      },
      "logout": "Выйти",
      "main_content": "Создайте %{model}#main_content для отображения содержимого.",
      "new_model": "Создать %{model}",
      "next": "След.",
      "pagination": {
        "empty": "%{model} не найдено",
        "entry": {
          "few": "записи",
          "many": "записей",
          "one": "запись",
          "other": "записей"
        },
        "multiple": "Результат: %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> из <b>%{total}</b>",
        "multiple_without_total": "Результат: %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Результат: <b>1</b> %{model}",
        "one_page": "Результат: <b>%{n}</b> %{model}"
      },
      "powered_by": "Работает на %{active_admin} %{version}",
      "previous": "Пред.",
      "search_status": {
        "current_filters": "Текущий фильтр:",
        "current_scope": "Область:",
        "headline": "Статус поиска:",
        "no_current_filters": "Ни один"
      },
      "sidebars": {
        "filters": "Фильтры",
        "search_status": "Статус поиска"
      },
      "status_tag": {
        "no": "Нет",
        "unset": "Нет",
        "yes": "Да"
      },
      "unsupported_browser": {
        "headline": "Пожалуйста, обратите внимание, что Active Admin больше не поддерживает старые версии Internet Explorer начиная с версии IE 8",
        "recommendation": "Мы рекомендуем обновить версию вашего браузера (<a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, или <a href=\"https://mozilla.org/firefox/\">Firefox</a>).",
        "turn_off_compatibility_view": "Если вы используете IE 9 или новее, убедитесь, что <a href=\"https://support.microsoft.com/ru-ru/help/17471\">вы выключили опцию \"Просмотр в режиме совместимости\"</a>."
      },
      "view": "Открыть"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Текущий пароль",
          "email": null,
          "password": "Пароль",
          "password_confirmation": "Подтверждение пароля",
          "remember_me": "Запомнить меня"
        }
      },
      "models": {
        "user": "Пользователь"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Выслать повторно письмо с активацией"
        }
      },
      "failure": {
        "expired": "Ваш аккаунт устарел из-за неактивности. Пожалуйста, свяжитесь с администратором.",
        "invited": "У вас есть непринятое приглашение, подтвердите его чтобы продолжить создание аккаунта.",
        "session_limited": "Ваши параметры входа используются в другом браузере. Пожалуйста, авторизуйтесь снова, чтобы продолжить в этом браузере."
      },
      "invalid_captcha": "Введен неправильный код капчи.",
      "invalid_security_question": "Ответ на секретный вопрос был неверным.",
      "invitations": {
        "edit": {
          "header": "Создание пароля",
          "submit_button": "Сохранить"
        },
        "invitation_removed": "Выше приглашение было удалено.",
        "invitation_token_invalid": "Неверный токен приглашения.",
        "new": {
          "header": "Отправить приглашение",
          "submit_button": "Отправить приглашение"
        },
        "no_invitations_remaining": "Приглашений нет",
        "send_instructions": "Письмо с приглашением было отправлено на %{email}.",
        "updated": "Ваш пароль успешно сохранен. Вы вошли в систему."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Активировать",
          "greeting": "Привет %{recipient}!",
          "instruction": "Вы можете активировать свою учетную запись, нажав ссылку снизу:"
        },
        "invitation_instructions": {
          "accept": "Создать аккаунт",
          "hello": "Здравствуйте, %{email}",
          "ignore": "Если вы не хотите создавать аккаунт, проигнорируйте это письмо. <br /> Учетная запись не будет создана, пока вы не пройдете по ссылке и не установите пароль.",
          "someone_invited_you": "Это письмо - приглашение стать пользователем сайта %{url}, вы можете создать аккаунт, кликнув по ссылке ниже.",
          "subject": "Инструкции по созданию учетной записи"
        },
        "reset_password_instructions": {
          "action": "Изменить пароль",
          "greeting": "Привет, %{recipient}!",
          "instruction": "Вы (или кто-то еще) запросили изменение пароля. Для изменение пароля нажимите ссылку ниже:",
          "instruction_2": "Если вы не запрашивали изменение пароля - проигнорируйте это сообщение",
          "instruction_3": "Ваш пароль не изменится пока вы не нажмете на ссылку и не введете новый."
        },
        "unlock_instructions": {
          "action": "Разблокировать учетную запись",
          "greeting": "Привет, %{recipient}!",
          "instruction": "Нажмите ссылку для активации учетной записи:",
          "message": "Ваша учетная запись была заблокирована в связи с превышением лимита неудачных попыток входа."
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Отправить",
          "submit_verification_code": "Ввод кода подтверждения",
          "verification_code": "Код подверждения"
        },
        "updated": "Код подтверждения принят"
      },
      "paranoid_verify": {
        "code_required": "Пожалуйста введите код, полученный от нашей команды поддержки"
      },
      "password_expired": {
        "change_required": "Ваш пароль устарел. Пожалуйста, установите новый.",
        "show": {
          "change_my_password": "Поменять пароль",
          "current_password": "Текущий пароль",
          "new_password": "Новый пароль",
          "new_password_confirmation": "Подтвердите новый пароль",
          "renew_your_password": "Смена пароля"
        },
        "updated": "Ваш новый пароль сохранен."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Изменить мой пароль",
          "change_your_password": "Изменить пароль",
          "confirm_new_password": "Повторите новый пароль",
          "new_password": "Новый пароль"
        },
        "new": {
          "forgot_your_password": "Забыли пароль?",
          "send_me_reset_password_instructions": "Выслать новый пароль"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Вы уверены?",
          "cancel_my_account": "Удалить учетную запись",
          "currently_waiting_confirmation_for_email": "Ожидается подтверждение адреса E-mail: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "оставьте поле пустым, если не хотите ничего менять",
          "title": "Редактировать %{resource}",
          "unhappy": "Разочарованы",
          "update": "Обновить",
          "we_need_your_current_password_to_confirm_your_changes": "введите текущий пароль для подтверждения изменений"
        },
        "new": {
          "sign_up": "Регистрация"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Войти"
        }
      },
      "shared": {
        "links": {
          "back": "Назад",
          "didn_t_receive_confirmation_instructions": "Не получили подтверждение?",
          "didn_t_receive_unlock_instructions": "Не получили код разблокировки?",
          "forgot_your_password": "Забыли пароль?",
          "sign_in": "Войти",
          "sign_in_with_provider": "Войти с помощью: %{provider}",
          "sign_up": "Регистрация"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Выслать подтверждение заново"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "имеет недействительное соотношение сторон (действительные соотношения сторон %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "должен быть ландшафт (текущий файл %{width}x%{height} пикселей)",
        "aspect_ratio_not_portrait": "должен быть портрет (текущий файл %{width}x%{height} пикселей)",
        "aspect_ratio_not_square": "должен быть квадратным (текущий файл %{width}x%{height} пикселей)",
        "aspect_ratio_not_x_y": "должно быть %{authorized_aspect_ratios} (текущий файл %{width}x%{height} пикселей)",
        "attachment_missing": "не имеет прикрепленного файла",
        "audio_missing": "должен содержать аудиодорожку",
        "audio_present": "не должен содержать аудиодорожку",
        "content_type_invalid": {
          "one": "имеет недействительный тип контента (авторизованный тип контента %{authorized_human_content_types})",
          "other": "имеет недействительный тип контента (авторизованные типы контента %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "имеет тип контента, который не эквивалентен тому, который обнаруживается через его контент (авторизованный тип контента %{authorized_human_content_types})",
          "other": "имеет тип контента, который не эквивалентен тому, который обнаруживается через его контент (авторизованные типы контента %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "высота должна быть равна %{length} пикселям",
        "dimension_height_not_greater_than_or_equal_to": "высота должна быть больше или равна %{length} пикселям",
        "dimension_height_not_included_in": "высота не включена между %{min} и %{max}  пикселям",
        "dimension_height_not_less_than_or_equal_to": "высота должна быть меньше или равна %{length} пикселям",
        "dimension_max_not_included_in": "должно быть меньше или равно %{width} x %{height} пикселям",
        "dimension_min_not_included_in": "должен быть больше или равно %{width} x %{height} пикселям",
        "dimension_width_not_equal_to": "ширина должна быть равна %{length} пикселям",
        "dimension_width_not_greater_than_or_equal_to": "ширина должна быть больше или равна %{length} пикселям",
        "dimension_width_not_included_in": "ширина не включена между %{min} и %{max} пикселям",
        "dimension_width_not_less_than_or_equal_to": "ширина должна быть меньше или равна %{length} пикселям",
        "duration_not_between": "длительность должна быть между %{min} и %{max} (текущая продолжительность составляет %{duration})",
        "duration_not_equal_to": "длительность должна быть равна %{exact} (текущая продолжительность составляет %{duration})",
        "duration_not_greater_than": "длительность должна быть больше %{min} (текущая продолжительность составляет %{duration})",
        "duration_not_greater_than_or_equal_to": "длительность должна быть больше или равна %{min} (текущая продолжительность составляет %{duration})",
        "duration_not_less_than": "длительность должна быть меньше %{max} (текущая продолжительность составляет %{duration})",
        "duration_not_less_than_or_equal_to": "длительность должна быть меньше или равна %{max} (текущая продолжительность составляет %{duration})",
        "equal_to_current_password": "должен отличаться от текущего пароля.",
        "equal_to_email": "должно отличаться от адреса электронной почты.",
        "file_not_processable": "не идентифицируется как действительный медиафайл",
        "file_size_not_between": "размер файла должен быть между %{min} и %{max} (текущий размер %{file_size})",
        "file_size_not_equal_to": "размер файла должен быть равен %{exact} (текущий размер %{file_size})",
        "file_size_not_greater_than": "размер файла должен быть больше %{min} (текущий размер %{file_size})",
        "file_size_not_greater_than_or_equal_to": "размер файла должен быть больше или равен %{min} (текущий размер %{file_size})",
        "file_size_not_less_than": "размер файла должен быть меньше %{max} (текущий размер %{file_size})",
        "file_size_not_less_than_or_equal_to": "размер файла должен быть меньше или равен %{max} (текущий размер %{file_size})",
        "limit_max_exceeded": {
          "one": "слишком много файлов прикреплено (максимум составляет %{max} файлов, получил %{count})",
          "other": "слишком много файлов прикреплено (максимум составляет %{max} файлов, получил %{count})",
          "zero": "никаких файлов не прилагается (максимум составляет %{max} файлов)"
        },
        "limit_min_not_reached": {
          "one": "прилагается только 1 файл (должно иметь не менее %{min} файлов)",
          "other": "%{count} файлы прилагаются (должно иметь не менее %{min} файлов)",
          "zero": "не прилагается никаких файлов (должно иметь не менее %{min} файлов)"
        },
        "limit_out_of_range": {
          "one": "прилагается только 1 файл (должно иметь от %{min} до %{max} файлов)",
          "other": "общее количество файлов должно быть от %{min} до %{max} файлов (прилагается %{count} файлов)",
          "zero": "никаких файлов не прилагается (должно иметь от %{min} до %{max} файлов)"
        },
        "media_metadata_missing": "не является действительным медиафайлом",
        "pages_not_between": "количество страниц должно быть между %{min} и %{max} (текущее количество страниц %{pages})",
        "pages_not_equal_to": "количество страниц должно быть равно %{exact} (текущее количество страниц %{pages})",
        "pages_not_greater_than": "количество страниц должно быть больше %{min} (текущее количество страниц %{pages})",
        "pages_not_greater_than_or_equal_to": "количество страниц должно быть больше или равно %{min} (текущее количество страниц %{pages})",
        "pages_not_less_than": "количество страниц должно быть меньше %{max} (текущее количество страниц %{pages})",
        "pages_not_less_than_or_equal_to": "количество страниц должно быть меньше или равно %{max} (текущее количество страниц %{pages})",
        "password_complexity": {
          "digit": {
            "few": "должен содержать хотя бы %{count} цифры",
            "many": "должен содержать хотя бы %{count} цифр",
            "one": "должен содержать хотя бы одну цифру",
            "other": "должен содержать хотя бы %{count} цифры"
          },
          "lower": {
            "few": "должен содержать хотя бы %{count} строчные буквы",
            "many": "должен содержать хотя бы %{count} строчных букв",
            "one": "должен содержать хотя бы одну строчную букву",
            "other": "должен содержать хотя бы %{count} строчных букв"
          },
          "symbol": {
            "few": "должен содержать хотя бы %{count} знака пунктуации или символа",
            "many": "должен содержать хотя бы %{count} знаков пунктуации или символов",
            "one": "должен содержать хотя бы один знак пунктуации или символ",
            "other": "должен содержать хотя бы %{count} знаков пунктуации или символов"
          },
          "upper": {
            "few": "должен содержать хотя бы %{count} прописные буквы",
            "many": "должен содержать хотя бы %{count} прописных букв",
            "one": "должен содержать хотя бы одну прописную букву",
            "other": "должен содержать хотя бы %{count} прописных букв"
          }
        },
        "taken_in_past": "уже ранее использовался.",
        "total_file_size_not_between": "общий размер файла должен быть между %{min} и %{max} (текущий размер %{total_file_size})",
        "total_file_size_not_equal_to": "общий размер файла должен быть равен %{exact} (текущий размер %{total_file_size})",
        "total_file_size_not_greater_than": "общий размер файла должен быть больше %{min} (текущий размер %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "общий размер файла должен быть больше или равен %{min} (текущий размер %{total_file_size})",
        "total_file_size_not_less_than": "общий размер файла должен быть меньше %{max} (текущий размер %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "общий размер файла должен быть меньше или равен %{max} (текущий размер %{total_file_size})"
      }
    },
    "i18n": {
      "plural": {}
    },
    "numbers": {
      "billions": {
        "few": "миллиарда",
        "many": "миллиардов",
        "one": "миллиард"
      },
      "billionths": {
        "few": "миллиардных",
        "many": "миллиардных",
        "one": "миллиардная"
      },
      "decillions": {
        "few": "дециллиона",
        "many": "дециллионов",
        "one": "дециллион"
      },
      "hundreds": [
        "_",
        "сто",
        "двести",
        "триста",
        "четыреста",
        "пятьсот",
        "шестьсот",
        "семьсот",
        "восемьсот",
        "девятьсот"
      ],
      "hundredths": {
        "few": "сотых",
        "many": "сотых",
        "one": "сотая"
      },
      "integral": {
        "few": "целых",
        "many": "целых",
        "one": "целая"
      },
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillions",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths"
      ],
      "micro_prefix": {
        "hundreds": "сто",
        "tens": "десяти",
        "union": " "
      },
      "micro_separator": "и",
      "millions": {
        "few": "миллиона",
        "many": "миллионов",
        "one": "миллион"
      },
      "millionths": {
        "few": "миллионных",
        "many": "миллионных",
        "one": "миллионная"
      },
      "nonillions": {
        "few": "нониллиона",
        "many": "нониллионов",
        "one": "нониллион"
      },
      "octillions": {
        "few": "октиллиона",
        "many": "октиллионов",
        "one": "октиллион"
      },
      "ones": {
        "female": [
          "ноль",
          "одна",
          "двe",
          "три",
          "четыре",
          "пять",
          "шесть",
          "семь",
          "восемь",
          "девять"
        ],
        "male": [
          "ноль",
          "один",
          "два",
          "три",
          "четыре",
          "пять",
          "шесть",
          "семь",
          "восемь",
          "девять"
        ],
        "neuter": [
          "ноль",
          "одно",
          "два",
          "три",
          "четыре",
          "пять",
          "шесть",
          "семь",
          "восемь",
          "девять"
        ]
      },
      "quadrillions": {
        "few": "квадриллиона",
        "many": "квадриллионов",
        "one": "квадриллион"
      },
      "quintillions": {
        "few": "квинтиллиона",
        "many": "квинтиллионов",
        "one": "квинтиллион"
      },
      "septillions": {
        "few": "секстиллиона",
        "many": "секстиллионов",
        "one": "септиллион"
      },
      "sextillions": {
        "few": "секстиллиона",
        "many": "секстиллионов",
        "one": "секстиллион"
      },
      "teens": [
        "_",
        "одиннадцать",
        "двенадцать",
        "тринадцать",
        "четырнадцать",
        "пятнадцать",
        "шестнадцать",
        "семнадцать",
        "восемнадцать",
        "девятнадцать"
      ],
      "tens": [
        "_",
        "десять",
        "двадцать",
        "тридцать",
        "сорок",
        "пятьдесят",
        "шестьдесят",
        "семьдесят",
        "восемьдесят",
        "девяносто"
      ],
      "tenths": {
        "few": "десятых",
        "many": "десятых",
        "one": "десятая"
      },
      "thousands": {
        "few": "тысячи",
        "many": "тысяч",
        "one": "тысяча"
      },
      "thousandths": {
        "few": "тысячных",
        "many": "тысячных",
        "one": "тысячная"
      },
      "trillions": {
        "few": "триллионa",
        "many": "триллионов",
        "one": "триллион"
      },
      "trillionths": {
        "few": "триллионных",
        "many": "триллионных",
        "one": "триллионная"
      },
      "union": "и"
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Страницы",
          "many": "Страниц",
          "one": "Страница",
          "other": "Страниц"
        },
        "next": "Вперёд",
        "previous": "Назад"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Всего %{count} %{item_name}, показаны с %{from} по %{to}",
        "no_count": "Страница %{page} из %{pages}",
        "no_items": "Пока %{item_name} нет",
        "single_page": "%{count} %{item_name}"
      },
      "input_nav_js": "Страница %{page_input} из %{pages}",
      "item_name": {
        "few": "записи",
        "many": "записей",
        "one": "запись",
        "other": "записей"
      },
      "limit_tag_js": "Показать %{limit_input} %{item_name} на странице",
      "next": "&gt;",
      "p11n": "EastSlavic",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "все",
      "and": "и",
      "any": "любое",
      "asc": "по возрастанию",
      "attribute": "аттрибут",
      "combinator": "combinator",
      "condition": "условие",
      "desc": "по убыванию",
      "or": "или",
      "predicate": "predicate",
      "predicates": {
        "blank": "пусто",
        "cont": "содержит",
        "cont_all": "содержит все",
        "cont_any": "содержит любое",
        "does_not_match": "не совпадение",
        "does_not_match_all": "не совпадение всем",
        "does_not_match_any": "не совпадение любому",
        "end": "кончается с",
        "end_all": "кончается со всего",
        "end_any": "кончается с любого",
        "eq": "равный",
        "eq_all": "равный всем",
        "eq_any": "равный любому",
        "false": "не верно",
        "gt": "больше чем",
        "gt_all": "больше чем все",
        "gt_any": "больше чем любое",
        "gteq": "больше чем или равен",
        "gteq_all": "больше чем или равен всем",
        "gteq_any": "больше чем или равен любому",
        "in": "в",
        "in_all": "во всех",
        "in_any": "в любом из",
        "lt": "меньше чем",
        "lt_all": "меньше чем все",
        "lt_any": "меньше чем любое",
        "lteq": "меньше чем или равен",
        "lteq_all": "меньше чем или равен всем",
        "lteq_any": "меньше чем или равен любому",
        "matches": "совпадение",
        "matches_all": "совпадение всем",
        "matches_any": "совпадение любому",
        "not_cont": "не содержит",
        "not_cont_all": "не содержит все",
        "not_cont_any": "не содержит любое",
        "not_end": "не кончается с",
        "not_end_all": "не кончается со всего",
        "not_end_any": "не кончается с любого",
        "not_eq": "не равный любому",
        "not_eq_all": "не равный всем",
        "not_eq_any": "не равный любому",
        "not_in": "нет в",
        "not_in_all": "нет во всех",
        "not_in_any": "не в каком из",
        "not_null": "не нулевой",
        "not_start": "не начинается с",
        "not_start_all": "не начинается со всего",
        "not_start_any": "не начинается с любого",
        "null": "нулевой",
        "present": "настоящее",
        "start": "начинается с",
        "start_all": "начинается с всего",
        "start_any": "начинается с любого",
        "true": "верно"
      },
      "search": "Поиск",
      "sort": "сортировка",
      "value": "значение"
    }
  },
  "se": {
    "numbers": {
      "hundreds": "hundra",
      "mega": [
        "_",
        "tusen",
        "miljoner",
        "miljarder",
        "biljoner",
        "kvadriljon",
        "kvintiljon",
        "sextillion",
        "septillion",
        "octillion",
        "nonillion",
        "decillion"
      ],
      "ones": [
        "noll",
        "en",
        "två",
        "tre",
        "fyra",
        "fem",
        "sex",
        "sju",
        "åtta",
        "nio"
      ],
      "teens": [
        "_",
        "elva",
        "tolv",
        "tretton",
        "fjorton",
        "femton",
        "sexton",
        "sjutton",
        "arton",
        "nitton"
      ],
      "tens": [
        "_",
        "tio",
        "tjugo",
        "trettio",
        "fyrtio",
        "femtio",
        "sextio",
        "sjuttio",
        "åttio",
        "nittio"
      ]
    }
  },
  "sk": {
    "active_admin": {
      "access_denied": {
        "message": "Nemáte oprávnenie k vykonaniu tejto akcie."
      },
      "any": "Akákoľvek",
      "batch_actions": {
        "action_label": "%{title}",
        "button_label": "Hromadné akcie",
        "default_confirmation": "Ste si istí, že to chcete spraviť?",
        "delete_confirmation": "Ste si istí, že chcete zmazať tieto %{plural_model}?",
        "labels": {
          "destroy": "Vymazať"
        },
        "selection_toggle_explanation": "(Zmeniť výber)",
        "succesfully_destroyed": {
          "few": "Úspešne zmazané %{count} %{plural_model}",
          "one": "Úspešne zmazaný %{model}",
          "other": "Úspešne zmazaných %{count} %{plural_model}",
          "zero": "Nebol zmazaný žiaden %{model}"
        }
      },
      "blank_slate": {
        "content": "Zatiaľ tu nie je žiadny obsah.",
        "link": "Vytvoriť"
      },
      "cancel": "Zrušiť",
      "comments": {
        "add": "Pridať komentár",
        "author": "Autor",
        "author_missing": "Anonymný",
        "author_type": "Typ autora",
        "body": "Telo",
        "created_at": "Vytvorený",
        "delete": "Zmazať komentár",
        "delete_confirmation": "Naozaj chcete zmazať tento komentár?",
        "errors": {
          "empty_text": "Komentár nebol uložený, je prázdny."
        },
        "no_comments_yet": "Žiadny komentár",
        "resource": "Zdroj",
        "resource_type": "Typ zdroja",
        "title_content": "Komentáre administrátorov (%{count})"
      },
      "create_another": "Vytvoriť ďalší %{model}",
      "dashboard": "Úvod",
      "dashboard_welcome": {
        "call_to_action": "Pre pridanie sekcie na nástenku se pozrite do súboru 'app/admin/dashboard.rb'",
        "welcome": "Vitajte v Active Admin. Toto je nástenka."
      },
      "delete": "Zmazať",
      "delete_confirmation": "Ste si istí, že chcete túto položku zmazať?",
      "delete_model": "Zmazať",
      "details": "Detaily",
      "devise": {
        "change_password": {
          "submit": "Zmeniť svoje heslo",
          "title": "Zmeniť heslo"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Zabudli ste heslo?",
          "resend_confirmation_instructions": "Preposlať potvrdzovacie inštrukcie",
          "resend_unlock_instructions": "Poslať znovu inštrukcie na odomknutie účtu",
          "sign_in": "Prihlásiť sa",
          "sign_in_with_omniauth_provider": "Prihlásiť sa cez %{provider}",
          "sign_up": "Registrovať sa"
        },
        "login": {
          "remember_me": "Zapamätať si ma",
          "submit": "Prihlásiť",
          "title": "Prihlásenie"
        },
        "password": {
          "title": "Heslo"
        },
        "password_confirmation": {
          "title": "Potvrdenie hesla"
        },
        "resend_confirmation_instructions": {
          "submit": "Preposlať potvrdzovacie inštrukcie",
          "title": "Preposlanie potvrdzovacie inštrukcie"
        },
        "reset_password": {
          "submit": "Obnoviť heslo",
          "title": "Zabudli ste heslo?"
        },
        "sign_up": {
          "submit": "Registrovať",
          "title": "Registrácia"
        },
        "subdomain": {
          "title": "Subdoména"
        },
        "unlock": {
          "submit": "Zaslať inštrukcií k odomknutiu účtu",
          "title": "Zaslanie inštrukcií k odomknutiu účtu"
        },
        "username": {
          "title": "Užívateľské meno"
        }
      },
      "download": "Stiahnúť:",
      "dropdown_actions": {
        "button_label": "Akcie"
      },
      "edit": "Upraviť",
      "edit_model": "Upraviť",
      "empty": "Prázdne",
      "filters": {
        "buttons": {
          "clear": "Vyčistiť filtre",
          "filter": "Filtrovať"
        },
        "predicates": {
          "from": "Od",
          "to": "Do"
        }
      },
      "has_many_delete": "Zmazať",
      "has_many_new": "Pridať nový",
      "has_many_remove": "Odstrániť",
      "index_list": {
        "block": "Zoznam",
        "blog": "Blog",
        "grid": "Tabuľka",
        "table": "Tabuľka"
      },
      "logout": "Odhlásiť",
      "main_content": "Implementujte prosím %{model}#main_content pre zobrazenie obsahu.",
      "move": "Presunúť",
      "new_model": "Vytvoriť",
      "next": "Nasledujúce",
      "pagination": {
        "empty": "Nenájdený.",
        "entry": {
          "few": "položky",
          "one": "položka",
          "other": "položky"
        },
        "multiple": "<b>%{from}&nbsp;-&nbsp;%{to}</b> z <b>%{total}</b>",
        "multiple_without_total": "<b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Zobrazená  <b>1</b> položka",
        "one_page": "Počet zobrazených položiek %{n}"
      },
      "powered_by": "%{active_admin} %{version}",
      "previous": "Predchádzajúce",
      "scopes": {
        "all": "Všetko"
      },
      "search_status": {
        "current_filters": "Filtre:",
        "current_scope": "Scope:",
        "headline": "Stav vyhľadávania:",
        "no_current_filters": "Žiadne"
      },
      "sidebars": {
        "filters": "Filtre",
        "search_status": "Stav vyhľadávania"
      },
      "status_tag": {
        "no": "Nie",
        "unset": "Nie",
        "yes": "Áno"
      },
      "unsupported_browser": {
        "headline": "ActiveAdmin nepodporuje Internet Explorer vo verzii <= 8.",
        "recommendation": "Odporúčame <a href=\"http://browsehappy.com/\">aktualizovať Váš prehliadač</a>.",
        "turn_off_compatibility_view": "Ak používate Internet Explorer vo verzii >= 9, uistite sa, že <a href=\"https://support.microsoft.com/en-us/help/17471\">\"režim kompatibility\" je vypnutý</a>"
      },
      "view": "Zobraziť"
    },
    "activerecord": {
      "attributes": {
        "active_admin/comment": {
          "author_type": "Typ autora",
          "body": "Telo",
          "created_at": "Vytvorený",
          "namespace": "Namespace",
          "resource_type": "Typ komentovanej položky",
          "updated_at": "Upravený"
        },
        "user": {
          "current_password": "Súčasné heslo",
          "email": "Email",
          "password": "Heslo",
          "password_confirmation": "Potvrdenie hesla",
          "remember_me": "Zapamätať si ma"
        }
      },
      "models": {
        "active_admin/comment": {
          "few": "Komentáre",
          "many": "Komentárov",
          "one": "Komentár",
          "other": "Komentáre"
        },
        "comment": {
          "few": "Komentáre",
          "many": "Komentárov",
          "one": "Komentár",
          "other": "Komentáre"
        },
        "user": "Používateľ"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Preposlať potvrdzovacie inštrukcie"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Potvrdiť môj účet",
          "greeting": "Vitaj %{recipient}!",
          "instruction": "Môžete potvrdiť emailovú adresu vášho účtu pomocou odkazu nižšie:"
        },
        "reset_password_instructions": {
          "action": "Zmeniť moje heslo",
          "greeting": "Ahoj %{recipient}!",
          "instruction": "Niekto požiadal o zmenu vášho hesla a môžete to spraviť pomocou odkazu nižšie.",
          "instruction_2": "Ak ste o toto nepožiadali, prosím ignorujte tento email.",
          "instruction_3": "Vaše heslo sa nezmení, pokým nenavštívite odkaz vyššie a nezadáte nové."
        },
        "unlock_instructions": {
          "action": "Odomknúť môj účet",
          "greeting": "Ahoj %{recipient}!",
          "instruction": "Pre odomknutie vášho účtu kliknite na odkaz nižšie:",
          "message": "Vaše konto bolo zamknuté kvôli nadmernému počtu neúspešných prihlásení."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Zmeniť moje heslo",
          "change_your_password": "Zmeniť vaše heslo",
          "confirm_new_password": "Potvrdiť nové heslo",
          "new_password": "Nové heslo"
        },
        "new": {
          "forgot_your_password": "Zabudli ste heslo?",
          "send_me_reset_password_instructions": "Pošlite mi inštrukcie na obnovu hesla"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Ste si istý?",
          "cancel_my_account": "Zrušiť môj účet",
          "currently_waiting_confirmation_for_email": "Momentálne sa čaká na potvrdenie pre: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "nechajte prázdne ak to nechcete zmeniť",
          "title": "Upraviť %{resource}",
          "unhappy": "Nešťastný",
          "update": "Aktualizovať",
          "we_need_your_current_password_to_confirm_your_changes": "na potvrdenie vašich zmien potrebujeme vaše súčasné heslo"
        },
        "new": {
          "sign_up": "Zaregistrovať sa"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Prihlásiť sa"
        }
      },
      "shared": {
        "links": {
          "back": "Späť",
          "didn_t_receive_confirmation_instructions": "Nedostali ste potvrdzovacie inštrukcie?",
          "didn_t_receive_unlock_instructions": "Nedostali ste inštrukcie na odomknutie účtu?",
          "forgot_your_password": "Zabudli ste heslo?",
          "sign_in": "Prihlásiť sa",
          "sign_in_with_provider": "Prihlásiť sa cez %{provider}",
          "sign_up": "Zaregistrovať sa"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Poslať znovu inštrukcie na odomknutie účtu"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Stránky",
          "one": "Stránka",
          "other": "Stránky"
        },
        "next": "Ďalšia",
        "previous": "Predchádzajúca"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Zobrazené položky %{from}-%{to} z %{count} celkom",
        "no_count": "Strana %{page} z %{pages}",
        "no_items": "Nič nebolo nájdené",
        "single_page": "Zobrazené %{count} %{item_name}"
      },
      "input_nav_js": "Strana %{page_input} z %{pages}",
      "item_name": {
        "few": "položky",
        "one": "položka",
        "other": "položiek"
      },
      "limit_tag_js": "Zobraziť %{limit_input} %{item_name} na stránke",
      "next": "&gt;",
      "p11n": "WestSlavic",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "každý",
      "and": "a",
      "any": "akýkoľvek",
      "asc": "vzostupne",
      "attribute": "atribút",
      "combinator": "kombinátor",
      "condition": "podmienka",
      "desc": "zostupne",
      "or": "alebo",
      "predicate": "predikát",
      "predicates": {
        "blank": "je prázdne",
        "cont": "obsahuje",
        "cont_all": "obsahuje všetky",
        "cont_any": "obsahuje akúkoľvek",
        "does_not_match": "nezodpovedá",
        "does_not_match_all": "nezodpovedá všetkým",
        "does_not_match_any": "nezodpovedá akémukoľvek",
        "end": "končí s",
        "end_all": "končí so všetkými",
        "end_any": "končí s akoukoľvek",
        "eq": "sa rovná",
        "eq_all": "sa rovná všetkým",
        "eq_any": "sa rovná akémukoľvek",
        "false": "nie je pravdivé",
        "gt": "väčší ako",
        "gt_all": "väčší ako všetky",
        "gt_any": "väčší ako akýkoľvek",
        "gteq": "väčší alebo rovný",
        "gteq_all": "väčší alebo rovný všetkým",
        "gteq_any": "väčší alebo rovný akémukoľvek",
        "in": "v",
        "in_all": "vo všetkých",
        "in_any": "v akejkoľvek",
        "lt": "menší ako",
        "lt_all": "menší ako všetky",
        "lt_any": "menší ako akýkoľvek",
        "lteq": "menší alebo rovný",
        "lteq_all": "menší alebo rovný všetkým",
        "lteq_any": "menší alebo rovný akémukoľvek",
        "matches": "zodpovedá",
        "matches_all": "zodpovedá všetkým",
        "matches_any": "zodpovedá akémukoľvek",
        "not_cont": "neobsahuje",
        "not_cont_all": "neobsahuje všetky",
        "not_cont_any": "neobsahuje akúkoľvek",
        "not_end": "nekončí s",
        "not_end_all": "nekončí so všetkými",
        "not_end_any": "nekončí s akoukoľvek",
        "not_eq": "sa nerovná",
        "not_eq_all": "sa nerovná všetkým",
        "not_eq_any": "sa nerovná akémukoľvek",
        "not_in": "nie je v",
        "not_in_all": "nie je vo všetkých",
        "not_in_any": "nie je v akejkoľvek",
        "not_null": "nie je null",
        "not_start": "nezačíná s",
        "not_start_all": "nezačíná so všetkými",
        "not_start_any": "nezačíná s akoukoľvek",
        "null": "je null",
        "present": "je vyplnené",
        "start": "začína na",
        "start_all": "začína so všetkými",
        "start_any": "začína s akoukoľvek",
        "true": "je pravdivé"
      },
      "search": "vyhľadávanie",
      "sort": "poradie",
      "value": "hodnota"
    }
  },
  "sr": {
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Странице",
          "many": "Страница",
          "one": "Страница",
          "other": "Странице"
        },
        "next": "Следећa ",
        "previous": "Претходна"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Приказ %{item_name} %{from}-%{to} од %{count} укупно",
        "no_count": "Страниca %{page} од %{pages}",
        "no_items": "Нema пронађених %{item_name}",
        "single_page": "Приказује се %{count} %{item_name}"
      },
      "input_nav_js": "Страниca %{page_input} од %{pages}",
      "item_name": {
        "few": "ставкe",
        "many": "ставки",
        "one": "ставка",
        "other": "ставки"
      },
      "limit_tag_js": "Прикажи %{limit_input} %{item_name} по страниcи",
      "next": "&gt;",
      "p11n": "EastSlavic",
      "previous": "&lt;"
    }
  },
  "sv": {
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "har ett ogiltigt bildförhållande (giltiga bildförhållanden är %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "måste vara landskap (nuvarande fil är %{width}x%{height} pixlar)",
        "aspect_ratio_not_portrait": "måste vara porträtt (nuvarande fil är %{width}x%{height} pixlar)",
        "aspect_ratio_not_square": "måste vara kvadratisk (nuvarande fil är %{width}x%{height} pixlar)",
        "aspect_ratio_not_x_y": "måste vara %{authorized_aspect_ratios} (nuvarande fil är %{width}x%{height} pixlar)",
        "attachment_missing": "har ingen bifogad fil",
        "audio_missing": "måste innehålla ett ljudspår",
        "audio_present": "får inte innehålla ett ljudspår",
        "content_type_invalid": {
          "one": "har en ogiltig innehållstyp (auktoriserad innehållstyp är %{authorized_human_content_types})",
          "other": "har en ogiltig innehållstyp (auktoriserade innehållstyper är %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "har en innehållstyp som inte motsvarar den som upptäcks genom dess innehåll (auktoriserad innehållstyp är %{authorized_human_content_types})",
          "other": "har en innehållstyp som inte motsvarar den som upptäcks genom dess innehåll (auktoriserade innehållstyper är %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "höjden måste vara %{length} pixlar",
        "dimension_height_not_greater_than_or_equal_to": "höjden måste minst vara %{length} pixlar",
        "dimension_height_not_included_in": "höjden är utanför %{min} till %{max} pixlar",
        "dimension_height_not_less_than_or_equal_to": "höjden får max vara %{length} pixlar",
        "dimension_max_not_included_in": "måste vara mindre eller lika med %{width} x %{height} pixlar",
        "dimension_min_not_included_in": "måste minst vara %{width} x %{height} pixlar",
        "dimension_width_not_equal_to": "bredden måste vara %{length} pixlar",
        "dimension_width_not_greater_than_or_equal_to": "bredden måste minst vara %{length} pixlar",
        "dimension_width_not_included_in": "bredden är utanför %{min} till %{max} pixlar",
        "dimension_width_not_less_than_or_equal_to": "bredden får max vara %{length} pixlar",
        "duration_not_between": "varaktigheten måste vara mellan %{min} och %{max} (nuvarande varaktighet är %{duration})",
        "duration_not_equal_to": "varaktigheten måste vara lika med %{exact} (nuvarande varaktighet är %{duration})",
        "duration_not_greater_than": "varaktigheten måste vara större än %{min} (nuvarande varaktighet är %{duration})",
        "duration_not_greater_than_or_equal_to": "varaktigheten måste vara större än eller lika med %{min} (nuvarande varaktighet är %{duration})",
        "duration_not_less_than": "varaktigheten måste vara mindre än %{max} (nuvarande varaktighet är %{duration})",
        "duration_not_less_than_or_equal_to": "varaktigheten måste vara mindre än eller lika med %{max} (nuvarande varaktighet är %{duration})",
        "file_not_processable": "identifieras inte som en giltig mediefil",
        "file_size_not_between": "filstorleken måste vara mellan %{min} och %{max} (nuvarande storlek är %{file_size})",
        "file_size_not_equal_to": "filstorleken måste vara lika med %{exact} (nuvarande storlek är %{file_size})",
        "file_size_not_greater_than": "filstorleken måste vara större än %{min} (nuvarande storlek är %{file_size})",
        "file_size_not_greater_than_or_equal_to": "filstorleken måste vara större än eller lika med %{min} (nuvarande storlek är %{file_size})",
        "file_size_not_less_than": "filstorleken måste vara mindre än %{max} (nuvarande storlek är %{file_size})",
        "file_size_not_less_than_or_equal_to": "filstorleken måste vara mindre än eller lika med %{max} (nuvarande storlek är %{file_size})",
        "limit_max_exceeded": {
          "one": "för många filer bifogade (maximalt är %{max} -filer, fick %{count})",
          "other": "för många filer bifogade (maximalt är %{max} -filer, fick %{count})",
          "zero": "inga filer bifogade (maximalt är %{max} filer)"
        },
        "limit_min_not_reached": {
          "one": "endast en fil bifogad (måste ha minst %{min} filer)",
          "other": "%{count} filer bifogade (måste ha minst %{min} filer)",
          "zero": "inga filer bifogade (måste ha minst %{min} filer)"
        },
        "limit_out_of_range": {
          "one": "endast en fil bifogad (måste ha mellan %{min} och %{max} filer)",
          "other": "totalt antal filer måste vara mellan %{min} och %{max} filer (det finns %{count} filer bifogade)",
          "zero": "inga filer bifogade (måste ha mellan %{min} och %{max} filer)"
        },
        "media_metadata_missing": "är inte en giltig mediefil",
        "pages_not_between": "sidantal måste vara mellan %{min} och %{max} (nuvarande antal sidor är %{pages})",
        "pages_not_equal_to": "sidantal måste vara lika med %{exact} (nuvarande sidantal är %{pages})",
        "pages_not_greater_than": "sidantal måste vara större än %{min} (nuvarande sidantal är %{pages})",
        "pages_not_greater_than_or_equal_to": "sidantal måste vara större än eller lika med %{min} (nuvarande antal sidor är %{pages})",
        "pages_not_less_than": "sidantal måste vara mindre än %{max} (nuvarande sidantal är %{pages})",
        "pages_not_less_than_or_equal_to": "sidantal måste vara mindre än eller lika med %{max} (nuvarande antal sidor är %{pages})",
        "total_file_size_not_between": "total filstorlek måste vara mellan %{min} och %{max} (nuvarande storlek är %{total_file_size})",
        "total_file_size_not_equal_to": "total filstorlek måste vara lika med %{exact} (nuvarande storlek är %{total_file_size})",
        "total_file_size_not_greater_than": "total filstorlek måste vara större än %{min} (nuvarande storlek är %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "total filstorlek måste vara större än eller lika med %{min} (nuvarande storlek är %{total_file_size})",
        "total_file_size_not_less_than": "total filstorlek måste vara mindre än %{max} (nuvarande storlek är %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "total filstorlek måste vara mindre än eller lika med %{max} (nuvarande storlek är %{total_file_size})"
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Sida",
          "other": "Sidor"
        },
        "next": "Nästa",
        "previous": "Föregående"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Visar %{item_name} %{from}-%{to} av %{count} totalt",
        "no_count": "Sida %{page} av %{pages}",
        "no_items": "Inga %{item_name} hittade",
        "single_page": "Visar %{count} %{item_name}"
      },
      "input_nav_js": "Sida %{page_input} av %{pages}",
      "item_name": {
        "one": "resultat",
        "other": "resultat"
      },
      "limit_tag_js": "Visa %{limit_input} %{item_name} per sida",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "alla",
      "and": "och",
      "any": "vilken som",
      "asc": "stigande",
      "attribute": "attribut",
      "combinator": "kombinator",
      "condition": "villkor",
      "desc": "fallande",
      "or": "eller",
      "predicate": "predikat",
      "predicates": {
        "blank": "är tom",
        "cont": "innehåller",
        "cont_all": "innehåller alla",
        "cont_any": "innehåller någon",
        "does_not_match": "matchar inte",
        "does_not_match_all": "matchar inte alla",
        "does_not_match_any": "matchar inte någon",
        "end": "slutar med",
        "end_all": "slutar med alla",
        "end_any": "slutar med någon",
        "eq": "lika med",
        "eq_all": "lika med alla",
        "eq_any": "lika med vilket som",
        "false": "är falskt",
        "gt": "större än",
        "gt_all": "större än alla",
        "gt_any": "större än någon",
        "gteq": "större än eller lika med",
        "gteq_all": "större än eller lika med alla",
        "gteq_any": "större än eller lika med någon",
        "in": "i",
        "in_all": "i alla",
        "in_any": "i någon",
        "lt": "mindre än",
        "lt_all": "mindre än alla",
        "lt_any": "mindre än någon",
        "lteq": "mindre än eller lika med",
        "lteq_all": "mindre än eller lika med alla",
        "lteq_any": "mindre än eller lika med någon",
        "matches": "matchar",
        "matches_all": "matchar alla",
        "matches_any": "matchar någon",
        "not_cont": "innehåller inte",
        "not_cont_all": "innehåller inte alla",
        "not_cont_any": "innehåller inte någon",
        "not_end": "slutar inte med",
        "not_end_all": "slutar inte med alla",
        "not_end_any": "slutar inte med någon",
        "not_eq": "inte lika med",
        "not_eq_all": "inte lika med alla",
        "not_eq_any": "inte lika med någon",
        "not_in": "inte i",
        "not_in_all": "inte i alla",
        "not_in_any": "inte i någon",
        "not_null": "är inte null",
        "not_start": "börjar inte med",
        "not_start_all": "börjar inte med alla",
        "not_start_any": "börjar inte med någon",
        "null": "är null",
        "present": "existerar",
        "start": "börjar med",
        "start_all": "börjar med alla",
        "start_any": "börjar med någon",
        "true": "är sant"
      },
      "search": "sök",
      "sort": "sortera",
      "value": "värde"
    }
  },
  "sv-SE": {
    "active_admin": {
      "access_denied": {
        "message": "Du har inte behörighet att utföra denna åtgärd."
      },
      "any": "Alla",
      "batch_actions": {
        "action_label": "%{title} markerad",
        "button_label": "Batch-åtgärder",
        "default_confirmation": "Är du säker på att du vill göra detta?",
        "delete_confirmation": "Är du säker på att du vill radera dessa %{plural_model}?",
        "labels": {
          "destroy": "Radera"
        },
        "selection_toggle_explanation": "(Byt markering)",
        "succesfully_destroyed": {
          "one": "Lyckades radera 1 %{model}",
          "other": "Lyckades radera %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Det finns inga %{resource_name} än.",
        "link": "Skapa en"
      },
      "cancel": "Avbryt",
      "comments": {
        "add": "Lägg till kommentar",
        "author": "Författare",
        "author_missing": "Anonym",
        "author_type": "Författartyp",
        "body": "Innehåll",
        "created_at": "Skapad",
        "delete": "Radera kommentar",
        "delete_confirmation": "Är du säker på att du vill radera dessa kommentarer?",
        "errors": {
          "empty_text": "Kommentaren sparades inte. Textfältet får inte vara tomt."
        },
        "no_comments_yet": "Inga kommentarer än.",
        "resource": "Resurs",
        "resource_type": "Resurstyp",
        "title_content": "Kommentarer (%{count})"
      },
      "create_another": "Skapa en till %{model}",
      "dashboard": "Skrivbord",
      "dashboard_welcome": {
        "call_to_action": "För att lägga till sektioner, gå till 'app/admin/dashboard.rb'",
        "welcome": "Välkommen till Active Admin. Detta är ditt standardskrivbord."
      },
      "delete": "Ta bort",
      "delete_confirmation": "Är du säker på att du vill ta bort detta?",
      "delete_model": "Ta bort %{model}",
      "details": "%{model}-detaljer",
      "devise": {
        "change_password": {
          "submit": "Ändra mitt lösenord",
          "title": "Ändra ditt lösenord"
        },
        "email": {
          "title": "E-post"
        },
        "links": {
          "forgot_your_password": "Glömt ditt lösenord?",
          "resend_confirmation_instructions": "Skicka bekräftningsinstruktioner igen",
          "resend_unlock_instructions": "Skicka upplåsningsinstruktioner igen",
          "sign_in": "Logga in",
          "sign_in_with_omniauth_provider": "Logga in med %{provider}",
          "sign_up": "Registera"
        },
        "login": {
          "remember_me": "Kom ihåg mig",
          "submit": "Inloggning",
          "title": "Inloggning"
        },
        "password": {
          "title": "Lösenord"
        },
        "password_confirmation": {
          "title": "Bekräfta lösenord"
        },
        "resend_confirmation_instructions": {
          "submit": "Skicka bekräftelseinstruktioner",
          "title": "Skicka bekräftelseinstruktioner"
        },
        "reset_password": {
          "submit": "Återställ mitt lösenord",
          "title": "Glömt ditt lösenord?"
        },
        "sign_up": {
          "submit": "Registera",
          "title": "Registera"
        },
        "subdomain": {
          "title": "Subdomän"
        },
        "unlock": {
          "submit": "Skicka upplåsningsinstruktioner",
          "title": "Skicka upplåsningsinstruktioner"
        },
        "username": {
          "title": "Användarnamn"
        }
      },
      "download": "Ladda ner:",
      "dropdown_actions": {
        "button_label": "Åtgärder"
      },
      "edit": "Redigera",
      "edit_model": "Redigera %{model}",
      "empty": "Tom",
      "filters": {
        "buttons": {
          "clear": "Rensa filter",
          "filter": "Filtrera"
        },
        "predicates": {
          "from": "Från",
          "to": "Till"
        }
      },
      "has_many_delete": "Ta bort",
      "has_many_new": "Skapa en ny %{model}",
      "has_many_remove": "Ta bort",
      "index_list": {
        "block": "Lista",
        "blog": "Blogg",
        "grid": "Rutnät",
        "table": "Tabell"
      },
      "logout": "Logga ut",
      "main_content": "Implementera %{model}#main_content för att visa innehåll.",
      "move": "Flytta",
      "new_model": "Ny %{model}",
      "next": "Nästa",
      "pagination": {
        "empty": "Ingen %{model} hittades",
        "entry": {
          "one": "inlägg",
          "other": "inlägg"
        },
        "multiple": "Visar %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> av <b>%{total}</b> totalt",
        "multiple_without_total": "Visar %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Visar <b>1</b> %{model}",
        "one_page": "Visar <b>alla %{n}</b> %{model}",
        "per_page": "Per sida: "
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Föregående",
      "scopes": {
        "all": "Alla"
      },
      "search_status": {
        "current_filters": "Aktiva filter:",
        "current_scope": "Omfattning:",
        "headline": "Sökstatus:",
        "no_current_filters": "Inga"
      },
      "sidebars": {
        "filters": "Filter",
        "search_status": "Sökstatus"
      },
      "status_tag": {
        "no": "Nej",
        "unset": "Nej",
        "yes": "Ja"
      },
      "unsupported_browser": {
        "headline": "Observera att ActiveAdmin inte längre stödjer Internet Explorer version 8 eller lägre.",
        "recommendation": "Vi rekommenderar att du uppgraderar till den senaste versionen av <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, eller <a href=\"https://mozilla.org/firefox/\">Firefox</a>.",
        "turn_off_compatibility_view": "Om du använder IE 9 eller senare, se till att <a href=\"https://support.microsoft.com/sv-se/help/17471\">stänga av \"Compatibility View\"</a>."
      },
      "view": "Visa"
    },
    "activerecord": {
      "attributes": {
        "active_admin/comment": {
          "author_type": "Författartyp",
          "body": "Innehåll",
          "created_at": "Skapad",
          "namespace": "Namnrymd",
          "resource_type": "Resurstyp",
          "updated_at": "Aktualiserad"
        }
      },
      "models": {
        "active_admin/comment": {
          "one": "Kommentar",
          "other": "Kommentarer"
        },
        "comment": {
          "one": "Kommentar",
          "other": "Kommentarer"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Sida",
          "other": "Sidor"
        },
        "next": "Nästa",
        "previous": "Föregående"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Visar %{item_name} %{from}-%{to} av %{count} totalt",
        "no_count": "Sida %{page} av %{pages}",
        "no_items": "Inga %{item_name} hittade",
        "single_page": "Visar %{count} %{item_name}"
      },
      "input_nav_js": "Sida %{page_input} av %{pages}",
      "item_name": {
        "one": "resultat",
        "other": "resultat"
      },
      "limit_tag_js": "Visa %{limit_input} %{item_name} per sida",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    }
  },
  "sw": {
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Ukurasa",
          "other": "Kurasa"
        },
        "next": "Ifuatayo",
        "previous": "Awali"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Inaonyesha %{item_name} %{from}-%{to} ya %{count} kwa jumla",
        "no_count": "Kurasa %{page} ya %{pages}",
        "no_items": "Hamna %{item_name} vilivyopatikana",
        "single_page": "Inaonyesha %{item_name} %{count}"
      },
      "input_nav_js": "Kurasa %{page_input} ya %{pages}",
      "item_name": {
        "one": "kifaa",
        "other": "vifaa"
      },
      "limit_tag_js": "Onyesha %{limit_input} %{item_name} kwa kila ukurasa",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    }
  },
  "ta": {
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "பக்கம்",
          "other": "பக்கங்கள்"
        },
        "next": "அடுத்தது",
        "previous": "முந்தையது"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "மொத்தம் %{count} %{item_name}, காட்டப்படுபவை %{from}-%{to}",
        "no_count": "%{pages}-இல் %{page}-வது பக்கம்",
        "no_items": "%{item_name} கிடைக்கவில்லை",
        "single_page": "%{count} %{item_name} காட்டப்படுகின்றது"
      },
      "input_nav_js": "%{pages}-இல் %{page_input}-வது பக்கம்",
      "item_name": {
        "one": "பதிவு",
        "other": "பதிவுகள்"
      },
      "limit_tag_js": "ஒரு பக்கத்திற்கு %{limit_input} %{item_name} காட்டு",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    }
  },
  "th": {
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "รหัสผ่านปัจจุบัน",
          "email": "อีเมล์",
          "password": "รหัสผ่าน",
          "password_confirmation": "ยืนยันรหัสผ่าน",
          "remember_me": "จำชื่อผู้ใช้"
        }
      },
      "models": {
        "user": "ผู้ใช้งาน"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "ส่งยืนยันคำขออีกครั้ง"
        }
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "ยืนยันบัญชีของฉัน",
          "greeting": "ยินดีต้อนรับคุณ %{recipient}!",
          "instruction": "คุณสามารถยืนยันอีเมล์ที่ใช้สมัครสมาชิกได้จากลิงค์ข้างล่างนี้:"
        },
        "reset_password_instructions": {
          "action": "เปลี่ยนรหัสผ่านของฉัน",
          "greeting": "สวัสดีคุณ%{recipient}!",
          "instruction": "ทางเวบได้รับคำขอเปลี่ยนรหัสผ่านของคุณ และคุณสามารถตั้งรหัสผ่านใหม่จากลิงค์ข้างล่างนี้",
          "instruction_2": "ถ้าคุณไม่ได้ขอเปลี่ยนรหัสผ่าน กรุณาเพิกเฉยต่อเมล์ฉบับนี้",
          "instruction_3": "รหัสผ่านของคุณยังไม่ได้ถูกเปลี่ยนแปลง จนกว่าคุณจะเข้าลิงค์ด้านบนนี้และตั้งรหัสผ่านใหม่"
        },
        "unlock_instructions": {
          "action": "ปลดล็อคบัญชีของฉัน",
          "greeting": "สวัสดีคุณ%{recipient}!",
          "instruction": "คลิกลิงค์ทางด้านล่างนี้เพื่อปลดล็อคบัญชีของคุณ:",
          "message": "บัญชีของคุณโดนล็อค เนื่องจากคุณใส่รหัสผ่านผิดเกินจำนวนครั้งที่ทางเรากำหนด"
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "เปลี่ยนรหัสผ่านของคุณ",
          "change_your_password": "เปลี่ยนรหัสผ่านของคุณ",
          "confirm_new_password": "ยืนยันรหัสผ่านใหม่",
          "new_password": "รหัสผ่านใหม่"
        },
        "new": {
          "forgot_your_password": "ลืมรหัสผ่าน?",
          "send_me_reset_password_instructions": "ส่งคำขอตั้งรหัสผ่านใหม่"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "คุณแน่ใจหรือไม่?",
          "cancel_my_account": "ยกเลิกบัญชีของฉัน",
          "currently_waiting_confirmation_for_email": "ขณะนี้ ระบบรอการยืนยันอีเมล์ %{email} อยู่",
          "leave_blank_if_you_don_t_want_to_change_it": "เว้นว่างไว้ถ้าคุณไม่ต้องการจะเปลี่ยนแปลง",
          "title": "แก้ไข%{resource}",
          "unhappy": "ไม่พอใจ",
          "update": "ปรับข้อมูล",
          "we_need_your_current_password_to_confirm_your_changes": "เราต้องการรหัสผ่านปัจจุบันเพื่อยืนยันการเปลี่ยนรหัสของคุณ"
        },
        "new": {
          "sign_up": "ออกจากระบบ"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "เข้าสู่ระบบ"
        }
      },
      "shared": {
        "links": {
          "back": "กลับ",
          "didn_t_receive_confirmation_instructions": "ไม่ได้รับการยืนยันคำขอ?",
          "didn_t_receive_unlock_instructions": "ไม่ได้รับคำขอปลดล็อค?",
          "forgot_your_password": "ลืมรหัสผ่าน?",
          "sign_in": "เข้าสู่ระบบ",
          "sign_in_with_provider": "เข้าสู่ระบบด้วย%{provider}",
          "sign_up": "ออกจากระบบ"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "ส่งคำขอปลดล็อคอีกครั้ง"
        }
      }
    }
  },
  "tr": {
    "active_admin": {
      "access_denied": {
        "message": "Bu işlemi gerçekleştirmek için yetkiniz yok."
      },
      "any": "Herhangi biri",
      "batch_actions": {
        "action_label": "Seçilenleri %{title}",
        "button_label": "Toplu İşlemler",
        "default_confirmation": "Bunu yapmak istediğinizden emin misiniz?",
        "delete_confirmation": "Bu %{plural_model} kayıtlarını silmek istediğinizden emin misiniz?",
        "labels": {
          "destroy": "Sil"
        },
        "selection_toggle_explanation": "(Seçimi Değiştir)",
        "succesfully_destroyed": {
          "one": "1 %{model} başarıyla silindi",
          "other": "Toplam %{count} %{plural_model} başarıyla silindi"
        }
      },
      "blank_slate": {
        "content": "Henüz %{resource_name} yok.",
        "link": "Bir tane oluşturun"
      },
      "cancel": "İptal",
      "comments": {
        "add": "Yorum Ekle",
        "author": "Yazar",
        "author_missing": "Anonim",
        "author_type": "Yazar Tipi",
        "body": "Ayrıntı",
        "created_at": "Oluşturma Tarihi",
        "delete": "Yorumu Sil",
        "delete_confirmation": "Bu yorumları silmek istediğinizden emin misiniz?",
        "errors": {
          "empty_text": "Yorum boş olarak kaydedilemez."
        },
        "no_comments_yet": "Henüz yorum yok.",
        "resource": "Kayıt",
        "resource_type": "Kayıt Tipi",
        "title_content": "Yorumlar (%{count})"
      },
      "create_another": "Başka bir %{model} oluştur",
      "dashboard": "Gösterge Paneli",
      "dashboard_welcome": {
        "call_to_action": "Buraya bölümler eklemek için 'app/admin/dashboard.rb' dosyasına bakabilirsiniz.",
        "welcome": "Active Admin'e hoş geldiniz. Burası varsayılan gösterge paneli sayfasıdır."
      },
      "delete": "Sil",
      "delete_confirmation": "Bu kaydı silmek istediğinizden emin misiniz?",
      "delete_model": "%{model} Kaydını Sil",
      "details": "%{model} Ayrıntıları",
      "devise": {
        "change_password": {
          "submit": "Şifremi değiştir",
          "title": "Şifrenizi değiştirin"
        },
        "email": {
          "title": "E-posta adresi"
        },
        "links": {
          "forgot_your_password": "Şifrenizi mi unuttunuz?",
          "resend_confirmation_instructions": "Onaylama talimatlarını tekrar gönder",
          "resend_unlock_instructions": "Hesap geri açma talimatlarını tekrar gönder",
          "sign_in": "Giriş yap",
          "sign_in_with_omniauth_provider": "%{provider} ile giriş yapın",
          "sign_up": "Kaydol"
        },
        "login": {
          "remember_me": "Beni hatırla",
          "submit": "Giriş yap",
          "title": "Giriş yap"
        },
        "password": {
          "title": "Şifre"
        },
        "password_confirmation": {
          "title": "Şifreyi Tekrarla"
        },
        "resend_confirmation_instructions": {
          "submit": "Onaylama talimatlarını tekrar gönder",
          "title": "Onaylama talimatlarını tekrar gönder"
        },
        "reset_password": {
          "submit": "Şifremi sıfırla",
          "title": "Şifrenizi mi unuttunuz?"
        },
        "sign_up": {
          "submit": "Kaydol",
          "title": "Kaydol"
        },
        "subdomain": {
          "title": "Alt alan adı"
        },
        "unlock": {
          "submit": "Hesap geri açma talimatlarını tekrar gönder",
          "title": "Hesap geri açma talimatlarını tekrar gönder"
        },
        "username": {
          "title": "Kullanıcı adı"
        }
      },
      "download": "İndir:",
      "dropdown_actions": {
        "button_label": "İşlemler"
      },
      "edit": "Düzenle",
      "edit_model": "%{model} Kaydını Düzenle",
      "empty": "Boş",
      "filters": {
        "buttons": {
          "clear": "Filtreleri Temizle",
          "filter": "Filtrele"
        }
      },
      "has_many_delete": "Sil",
      "has_many_new": "Yeni %{model} Ekle",
      "has_many_remove": "Çıkar",
      "index_list": {
        "block": "Liste",
        "blog": "Blog",
        "grid": "Izgara",
        "table": "Tablo"
      },
      "logout": "Çıkış Yap",
      "main_content": "İçeriği görüntülemek için lütfen %{model}#main_content metodunu ekleyin.",
      "move": "Taşı",
      "new_model": "Yeni %{model}",
      "next": "Sonraki",
      "pagination": {
        "empty": "Hiç %{model} yok",
        "entry": {
          "one": "kayıt",
          "other": "kayıtlar"
        },
        "multiple": "<b>%{from}&nbsp;-&nbsp;%{to}</b> arası %{model} görüntüleniyor (toplam %{total} kayıt)",
        "multiple_without_total": "<b>%{from}&nbsp;-&nbsp;%{to}</b> arası %{model} görüntüleniyor",
        "one": "<b>1</b> %{model} görüntüleniyor",
        "one_page": "<b>%{n}</b> %{model} kaydının tamamı görüntüleniyor",
        "per_page": "Sayfa Başına: "
      },
      "powered_by": "%{active_admin} %{version} tarafından desteklenmektedir.",
      "previous": "Önceki",
      "search_status": {
        "current_filters": "Seçili filtreler:",
        "current_scope": "Kapsam:",
        "headline": "Arama",
        "no_current_filters": "Yok"
      },
      "sidebars": {
        "filters": "Filtreler",
        "search_status": "Arama Durumu"
      },
      "status_tag": {
        "no": "Hayır",
        "unset": "Hayır",
        "yes": "Evet"
      },
      "unsupported_browser": {
        "headline": "ActiveAdmin Internet Explorer 8 ve altı artık desteklememektedir.",
        "recommendation": "Son sürüm <a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, ya da <a href=\"https://mozilla.org/firefox/\">Firefox</a> tarayıcılarından birine geçmenizi tavsiye ederiz.",
        "turn_off_compatibility_view": "IE 9 ya da üstünü kullanıyorsanız, <a href=\"http://windows.microsoft.com/tr-tr/internet-explorer/use-compatibility-view\">\"Uyumluluk Görünümü\"</a>nü kapatmayı unutmayın."
      },
      "view": "Görüntüle"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Geçerli Parola",
          "email": "E-Posta",
          "password": "Parola",
          "password_confirmation": "Parola Doğrulama",
          "remember_me": "Beni Hatırla"
        }
      },
      "models": {
        "user": "Kullanıcı"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Onaylama talimatlarını tekrar gönder"
        }
      },
      "failure": {
        "expired": "Hesabınız aktif olarak kullanılmadığı için artık geçerli değil. Lütfen yönetici ile irtibata geçin.",
        "invited": "Hesap oluşturmak için bekleyen davetiyenizi kabul edin",
        "session_limited": "Hesabınıza başka bir tarayıcıdan giriş yapılmış. Lütfen devam etmek için yeniden giriş yapın."
      },
      "invalid_captcha": "Captcha hatalı.",
      "invalid_security_question": "Güvenlik sorusunun cevabı yanlış.",
      "invitations": {
        "edit": {
          "header": "Şifre oluştur",
          "submit_button": "Şifremi oluştur"
        },
        "invitation_removed": "Davetiyeniz silindi",
        "invitation_token_invalid": "Davetiye tokenı geçerli değil!",
        "new": {
          "header": "Davetiye gönderildi",
          "submit_button": "Davetiye gönder"
        },
        "no_invitations_remaining": "Davetiye kalmadı",
        "send_instructions": "%{email} adresine davetiye maili gönderildi.",
        "updated": "Şifreniz başarıyla oluşturuldu ve giriş yaptınız",
        "updated_not_active": "Şifreniz başarıyla oluşturuldu."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Hesabımı onayla",
          "greeting": "Hoşgeldiniz %{recipient}!",
          "instruction": "E-postanızı aşağıdaki bağlantıyı takip ederek onaylayabilirsiniz:"
        },
        "invitation_instructions": {
          "accept": "Daveti kabul et",
          "hello": "Merhaba %{email}",
          "ignore": "Daveti kabul etmek istemiyorsanız bu maili yoksayabilirsiniz.<br />Aşağıdaki linke tıklayıp şifrenizi oluşturmadan hesabınız oluşturulmayacaktır.",
          "someone_invited_you": "%{url} adresine davet edildiniz. Kabul etmek için aşağıdaki linke tıklayınız.",
          "subject": "Davetiye adımları"
        },
        "reset_password_instructions": {
          "action": "Parolamı değiştir",
          "greeting": "Merhaba %{recipient}!",
          "instruction": "Birisi parolanızı değiştirmek için bir istek gönderdi, aşağıdaki bağlantıyı kullanarak bunu yapabilirsiniz.",
          "instruction_2": "Eğer bu isteği siz yapmadıysanız, bu e-postayı görmezden gelebilirsiniz.",
          "instruction_3": "Parolanız yukarıdaki bağlantıyı kullanıp, yeni bir parola oluşturmadığınız sürece değişmeyecektir."
        },
        "unlock_instructions": {
          "action": "Hesabımı geri aç",
          "greeting": "Merhaba %{recipient}!",
          "instruction": "Hesabınızı geri açmak için aşağıdaki bağlantıyı tıklayınız:",
          "message": "Hesabınız çok fazla başarısız giriş denemesinden dolayı kilitlenmiştir."
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Gönder",
          "submit_verification_code": "Doğrulama kodunu gönder",
          "verification_code": "Doğrulama kodu"
        },
        "updated": "Doğrulama kodu kabul edildi"
      },
      "paranoid_verify": {
        "code_required": "Destek ekibimizden aldığınız kodu girin."
      },
      "password_expired": {
        "change_required": "Parolanızın geçerlilik süresi dolmuş. Lütfen parolanızı yenileyin.",
        "show": {
          "change_my_password": "Şifremi Değiştir",
          "current_password": "Mevcut Şifre",
          "new_password": "Yeni Şifre",
          "new_password_confirmation": "Yeni şifreyi onayla",
          "renew_your_password": "Şifrenizi yenileyin"
        },
        "updated": "Yeni parolanız kaydedildi."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Şifremi değiştir",
          "change_your_password": "Şifreni değiştir",
          "confirm_new_password": "Yeni parolanı doğrula",
          "new_password": "Yeni Parola"
        },
        "new": {
          "forgot_your_password": "Parolanızı mı unuttunuz?",
          "send_me_reset_password_instructions": "Parola yenileme talimatlarını gönder"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Emin misiniz?",
          "cancel_my_account": "Hesabımı iptal et",
          "currently_waiting_confirmation_for_email": "Doğrulama için bekleniyor : %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "değiştirmek istemiyorsanız boş bırakın",
          "title": "%{resource} düzenle",
          "unhappy": "Mutsuz",
          "update": "Güncelle",
          "we_need_your_current_password_to_confirm_your_changes": "değişikleri onaylamak için şu anki parolanız gerekli"
        },
        "new": {
          "sign_up": "Kaydol"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Giriş yap"
        }
      },
      "shared": {
        "links": {
          "back": "Geri",
          "didn_t_receive_confirmation_instructions": "Onaylama talimatlarını almadınız mı?",
          "didn_t_receive_unlock_instructions": "Hesap geri açma talimatlarını almadınız mı?",
          "forgot_your_password": "Parolanızı mı unuttunuz?",
          "sign_in": "Giriş yap",
          "sign_in_with_provider": "%{provider} ile giriş yap",
          "sign_up": "Kaydol"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Hesap geri açma talimatlarını tekrar gönder"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "geçersiz bir en boy oranına sahiptir (geçerli en boy oranları %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "yatay olmalıdır (geçerli dosya %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "portre olmalı (geçerli dosya %{width}x%{height}px)",
        "aspect_ratio_not_square": "kare olmalı (geçerli dosya %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "%{authorized_aspect_ratios} olmalıdır (geçerli dosya %{width}x%{height}px)",
        "attachment_missing": "ekli dosya yok",
        "audio_missing": "bir ses parçası içermelidir",
        "audio_present": "bir ses parçası içermemelidir",
        "content_type_invalid": {
          "one": "geçersiz içerik türüne sahip (yetkili içerik türü %{authorized_human_content_types})",
          "other": "geçersiz içerik türüne sahip (yetkili içerik türleri %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "içeriği aracılığıyla algılanan içerik türüne eşdeğer olmayan bir içerik türüne sahiptir (yetkili içerik türü %{authorized_human_content_types})",
          "other": "içeriği aracılığıyla algılanan içerik türüne eşdeğer olmayan bir içerik türüne sahiptir (yetkili içerik türleri %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "boy %{length} piksele eşit olmalı",
        "dimension_height_not_greater_than_or_equal_to": "boy %{length} piksele eşit ya da büyük olmalı",
        "dimension_height_not_included_in": "boy %{min} ve %{max} piksel aralığı dışında",
        "dimension_height_not_less_than_or_equal_to": "boy %{length} piksele eşit ya da küçük olmalı",
        "dimension_max_not_included_in": "%{width} x %{height} piksele eşit ya da küçük olmalı",
        "dimension_min_not_included_in": "%{width} x %{height} piksele eşit ya da büyük olmalı",
        "dimension_width_not_equal_to": "en %{length} piksele eşit olmalı",
        "dimension_width_not_greater_than_or_equal_to": "en %{length} piksele eşit ya da büyük olmalı",
        "dimension_width_not_included_in": "en %{min} ve %{max} piksel aralığı dışında",
        "dimension_width_not_less_than_or_equal_to": "en %{length} piksele eşit ya da küçük olmalı",
        "duration_not_between": "süre %{min} ile %{max} arasında olmalıdır (geçerli süre %{duration})",
        "duration_not_equal_to": "süre %{exact} değerine eşit olmalıdır (geçerli süre %{duration})",
        "duration_not_greater_than": "süre %{min} değerinden büyük olmalıdır (geçerli süre %{duration})",
        "duration_not_greater_than_or_equal_to": "süre %{min} değerine eşit veya daha büyük olmalıdır (geçerli süre %{duration})",
        "duration_not_less_than": "süre %{max} değerinden az olmalıdır (geçerli süre %{duration})",
        "duration_not_less_than_or_equal_to": "süre %{max} değerine eşit veya daha düşük olmalıdır (geçerli süre %{duration})",
        "equal_to_current_password": "mevcut paroladan farklı olmalı.",
        "equal_to_email": "e-postadan farklı olmalı.",
        "file_not_processable": "geçerli bir medya dosyası olarak tanımlanmadı",
        "file_size_not_between": "dosya boyutu %{min} ile %{max} arasında olmalıdır (geçerli boyut %{file_size}'dir)",
        "file_size_not_equal_to": "dosya boyutu %{exact} değerine eşit olmalıdır (geçerli boyut %{file_size}'dir)",
        "file_size_not_greater_than": "dosya boyutu %{min} boyutundan büyük olmalıdır (geçerli boyut %{file_size}'dir)",
        "file_size_not_greater_than_or_equal_to": "dosya boyutu %{min} değerinden büyük veya eşit olmalıdır (geçerli boyut %{file_size}'dir)",
        "file_size_not_less_than": "dosya boyutu %{max} boyutundan küçük olmalıdır (geçerli boyut %{file_size}'dir)",
        "file_size_not_less_than_or_equal_to": "dosya boyutu %{max} değerinden küçük veya ona eşit olmalıdır (geçerli boyut %{file_size}'dir)",
        "limit_max_exceeded": {
          "one": "çok fazla dosya eklendi (maksimum %{max} dosyaları, %{count})",
          "other": "çok fazla dosya eklendi (maksimum %{max} dosyaları, %{count} var)",
          "zero": "dosya eklenmedi (maksimum %{max} dosyaları)"
        },
        "limit_min_not_reached": {
          "one": "yalnızca 1 dosya eklenmiş (en az %{min} dosyalarına sahip olmalıdır)",
          "other": "%{count} dosyaları eklenmiş (en az %{min} dosyaları olmalıdır)",
          "zero": "dosya eklenmedi (en az %{min} dosyaları olmalıdır)"
        },
        "limit_out_of_range": {
          "one": "yalnızca 1 dosya eklenmiş ( %{min} ve %{max} dosyaları arasında olmalıdır)",
          "other": "toplam dosya sayısı %{min} ve %{max} dosyaları arasında olmalıdır ( %{count} dosyaları ektedir)",
          "zero": "dosya eklenmedi ( %{min} ve %{max} dosyaları arasında olmalıdır)"
        },
        "media_metadata_missing": "geçerli bir medya dosyası değil",
        "pages_not_between": "sayfa sayısı %{min} ile %{max} arasında olmalıdır (geçerli sayfa sayısı %{pages})",
        "pages_not_equal_to": "sayfa sayısı %{exact} değerine eşit olmalıdır (geçerli sayfa sayısı %{pages})",
        "pages_not_greater_than": "sayfa sayısı %{min} değerinden fazla olmalıdır (geçerli sayfa sayısı %{pages})",
        "pages_not_greater_than_or_equal_to": "sayfa sayısı %{min} değerinden fazla veya eşit olmalıdır (geçerli sayfa sayısı %{pages})",
        "pages_not_less_than": "sayfa sayısı %{max} değerinden az olmalıdır (geçerli sayfa sayısı %{pages})",
        "pages_not_less_than_or_equal_to": "sayfa sayısı %{max} değerinden az veya eşit olmalıdır (geçerli sayfa sayısı %{pages})",
        "password_complexity": {
          "digit": {
            "one": "en az bir rakam içermelidir",
            "other": "en az %{count} basamak içermelidir"
          },
          "lower": {
            "one": "en az bir küçük harf içermelidir",
            "other": "en az %{count} küçük harf içermelidir"
          },
          "symbol": {
            "one": "en az bir noktalama işareti veya sembolü içermelidir",
            "other": "en az %{count} noktalama işareti veya sembolü içermelidir"
          },
          "upper": {
            "one": "en az bir büyük harf içermelidir",
            "other": "en az %{count} büyük harf içermelidir"
          }
        },
        "taken_in_past": "daha önce kullanıldı.",
        "total_file_size_not_between": "toplam dosya boyutu %{min} ile %{max} arasında olmalıdır (geçerli boyut %{total_file_size}'dir)",
        "total_file_size_not_equal_to": "toplam dosya boyutu %{exact} değerine eşit olmalıdır (geçerli boyut %{total_file_size}'dir)",
        "total_file_size_not_greater_than": "toplam dosya boyutu %{min} boyutundan büyük olmalıdır (geçerli boyut %{total_file_size}'dir)",
        "total_file_size_not_greater_than_or_equal_to": "toplam dosya boyutu %{min} değerinden büyük veya eşit olmalıdır (geçerli boyut %{total_file_size}'dir)",
        "total_file_size_not_less_than": "toplam dosya boyutu %{max} boyutundan küçük olmalıdır (geçerli boyut %{total_file_size}'dir)",
        "total_file_size_not_less_than_or_equal_to": "toplam dosya boyutu %{max} değerinden küçük veya ona eşit olmalıdır (geçerli boyut %{total_file_size}'dir)"
      }
    },
    "formtastic": {
      "cancel": "İptal",
      "create": "%{model} oluştur",
      "no": "Hayır",
      "required": "Zorunlu",
      "reset": "%{model} sıfırla",
      "submit": "Gönder",
      "update": "%{model} güncelle",
      "yes": "Evet"
    },
    "numbers": {
      "hundreds": "yüz",
      "mega": [
        "_",
        "bin",
        "milyon",
        "milyar",
        "trilyon",
        "katrilyon",
        "kentilyon",
        "seksilyon",
        "septilyon",
        "oktilyon",
        "nonilyon",
        "desilyon"
      ],
      "ones": [
        "sıfır",
        "bir",
        "iki",
        "üç",
        "dört",
        "beş",
        "altı",
        "yedi",
        "sekiz",
        "dokuz"
      ],
      "teens": [
        "_",
        "on bir",
        "on iki",
        "on üç",
        "on dört",
        "on beş",
        "on altı",
        "on yedi",
        "on sekiz",
        "on dokuz"
      ],
      "tens": [
        "_",
        "on",
        "yirmi",
        "otuz",
        "kırk",
        "elli",
        "altmış",
        "yetmiş",
        "seksen",
        "doksan"
      ]
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "one": "Sayfa",
          "other": "Sayfalar"
        },
        "next": "Sonraki",
        "previous": "Önceki"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Toplam %{count} %{item_name} arasından %{from}-%{to} arası gösteriliyor",
        "no_count": "Sayfa %{page} / %{pages}",
        "no_items": "Hiç %{item_name} bulunamadı",
        "single_page": "%{count} %{item_name} gösteriliyor"
      },
      "input_nav_js": "Sayfa %{page_input} / %{pages}",
      "item_name": {
        "one": "kayıt",
        "other": "kayıtlar"
      },
      "limit_tag_js": "Sayfa başına %{limit_input} %{item_name} göster",
      "next": "&gt;",
      "p11n": "OneOther",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "hepsi",
      "and": "ve",
      "any": "herhangi",
      "asc": "artan",
      "attribute": "nitelik",
      "combinator": "birleştirici",
      "condition": "şart",
      "desc": "azalan",
      "or": "veya",
      "predicate": "doğrula",
      "predicates": {
        "blank": "boş",
        "cont": "içeren",
        "cont_all": "hepsini içeren",
        "cont_any": "herhangi birini içeren",
        "does_not_match": "eşleşmeyen",
        "does_not_match_all": "hiçbiri ile eşleşmeyen",
        "does_not_match_any": "herhangi biri ile eşleşmeyen",
        "end": "ile biten",
        "end_all": "hepsi ile biten",
        "end_any": "herhangi biriyle biten",
        "eq": "eşit",
        "eq_all": "hepsine eşit",
        "eq_any": "herhangi birine eşit",
        "false": "yanlış",
        "gt": "daha büyük ",
        "gt_all": "hepsinden daha büyük",
        "gt_any": "herhangi birinden daha büyük",
        "gteq": "daha büyük veya eşit",
        "gteq_all": "daha büyük veya hepsine eşit",
        "gteq_any": "daha büyük veya herhangi birine eşit",
        "in": "içinde",
        "in_all": "hepsinde",
        "in_any": "herhangi birinde",
        "lt": "daha küçük",
        "lt_all": "hepsinden küçük",
        "lt_any": "herhangi birinden küçük",
        "lteq": "daha küçük veya eşit",
        "lteq_all": "daha küçük veya hepsine eşit",
        "lteq_any": "daha küçük veya herhangi birine eşit",
        "matches": "eşleşen",
        "matches_all": "hepsi ile eşleşen",
        "matches_any": "herhangi biri ile eşleşen",
        "not_cont": "içermeyen",
        "not_cont_all": "hiçbirini birini içermeyen",
        "not_cont_any": "herhangi birini içermeyen",
        "not_end": "ile bitmeyen",
        "not_end_all": "hiçbiriyle bitmeyen",
        "not_end_any": "herhangi biriyle bitmeyen",
        "not_eq": "eşit değil",
        "not_eq_all": "hiçbirine eşit değil",
        "not_eq_any": "herhangi birine eşit değil",
        "not_in": "içinde değil",
        "not_in_all": "hiçbirinde değil",
        "not_in_any": "herhangi birinde değil",
        "not_null": "geçerli",
        "not_start": "ile başlamayan",
        "not_start_all": "hiçbiriyle başlamayan",
        "not_start_any": "herhangi biriyle başlamayan",
        "null": "geçersiz",
        "present": "mevcut",
        "start": "ile başlayan",
        "start_all": "hepsiyle başlayan",
        "start_any": "herhangi biriyle başlayan",
        "true": "doğru"
      },
      "search": "ara",
      "sort": "sırala",
      "value": "değer"
    }
  },
  "ua": {
    "devise": {
      "failure": {
        "invited": "Вас очікує ще не прийняте запрошення, прийміть його, щоб завершити створення облікового запису."
      },
      "invitations": {
        "edit": {
          "header": "Встановіть ваш пароль",
          "submit_button": "Встановити мій пароль"
        },
        "invitation_removed": "Ваше запрошення було видалено.",
        "invitation_token_invalid": "Передано неправильний токен запрошення!",
        "new": {
          "header": "Надсилання запрошення",
          "submit_button": "Надіслати запрошення"
        },
        "no_invitations_remaining": "Не лишилось запрошень",
        "send_instructions": "Лист з запрошенням було відправлено на %{email}.",
        "updated": "Пароль успішно встановлено. Ви успішно увійшли.",
        "updated_not_active": "Ваш пароль успішно встановлено."
      },
      "mailer": {
        "invitation_instructions": {
          "accept": "Прийняти запрошення",
          "accept_until": "Це запрошення дійсне до %{due_date}.",
          "hello": "Вітаємо, %{email}",
          "ignore": "Якщо ви не хочете приймати запрошення, будь ласка, ігноруйте цього листа.<br />Ваш акаунт не буде створено, доти, доки ви не перейдете за посиланням вище і не встановите свій пароль.",
          "someone_invited_you": "Дехто запросив вас на %{url}, ви можете прийняти запрошення за посиланням нижче.",
          "subject": "Інструкції для запрошення"
        }
      }
    },
    "i18n": {
      "plural": {}
    },
    "numbers": {
      "billions": {
        "few": "мiльярда",
        "many": "мiльярдiв",
        "one": "мiльярд"
      },
      "billionths": {
        "few": "мiльярдних",
        "many": "мiльярдних",
        "one": "мiльярдна"
      },
      "decillions": {
        "few": "децильйона",
        "many": "децильйонiв",
        "one": "децильйон"
      },
      "hundreds": [
        "_",
        "сто",
        "двiстi",
        "триста",
        "чотириста",
        "п’ятсот",
        "шiстсот",
        "сiмсот",
        "вiсiмсот",
        "дев’ятсот"
      ],
      "hundredths": {
        "few": "сотих",
        "many": "сотих",
        "one": "сота"
      },
      "integral": {
        "few": "цiлих",
        "many": "цiлих",
        "one": "цiла"
      },
      "mega": [
        "_",
        "thousands",
        "millions",
        "billions",
        "trillions",
        "quadrillions",
        "quintillion",
        "sextillions",
        "septillions",
        "octillions",
        "nonillions",
        "decillions"
      ],
      "micro": [
        "_",
        "tenths",
        "hundredths",
        "thousandths",
        "millionths",
        "billionths",
        "trillionths"
      ],
      "micro_prefix": {
        "hundreds": "сто",
        "tens": "десяти",
        "union": " "
      },
      "micro_separator": "i",
      "millions": {
        "few": "мiльйона",
        "many": "мiльйонiв",
        "one": "мiльйон"
      },
      "millionths": {
        "few": "мiльйонних",
        "many": "мiльйонних",
        "one": "мiльйонна"
      },
      "nonillions": {
        "few": "нонильйона",
        "many": "нонильйонiв",
        "one": "нонильйон"
      },
      "octillions": {
        "few": "октильйона",
        "many": "октильйонiв",
        "one": "октильйон"
      },
      "ones": {
        "female": [
          "нуль",
          "одна",
          "двi",
          "три",
          "чотири",
          "п’ять",
          "шiсть",
          "сiм",
          "вiсiм",
          "дев’ять"
        ],
        "male": [
          "нуль",
          "один",
          "два",
          "три",
          "чотири",
          "п’ять",
          "шiсть",
          "сiм",
          "вiсiм",
          "дев’ять"
        ],
        "neuter": [
          "нуль",
          "одне",
          "два",
          "три",
          "чотири",
          "п’ять",
          "шiсть",
          "сiм",
          "вiсiм",
          "дев’ять"
        ]
      },
      "quadrillions": {
        "few": "квадрильйона",
        "many": "квадрильйонiв",
        "one": "квадрильйон"
      },
      "quintillions": {
        "few": "квiнтильйона",
        "many": "квiнтильйонiв",
        "one": "квiнтильйон"
      },
      "septillions": {
        "few": "септильйона",
        "many": "септильйонiв",
        "one": "септильйон"
      },
      "sextillions": {
        "few": "секстильйона",
        "many": "секстильйонiв",
        "one": "секстильйон"
      },
      "teens": [
        "_",
        "одинадцять",
        "дванадцять",
        "тринадцять",
        "чотирнадцять",
        "п’ятнадцять",
        "шiстнадцять",
        "сiмнадцять",
        "вiсiмнадцять",
        "дев’ятнадцять"
      ],
      "tens": [
        "_",
        "десять",
        "двадцять",
        "тридцять",
        "сорок",
        "п’ятдесят",
        "шiстдесят",
        "сiмдесят",
        "вiсiмдесят",
        "дев’яносто"
      ],
      "tenths": {
        "few": "десятих",
        "many": "десятих",
        "one": "десята"
      },
      "thousands": {
        "few": "тисячi",
        "many": "тисяч",
        "one": "тисяча"
      },
      "thousandths": {
        "few": "тисячних",
        "many": "тисячних",
        "one": "тысячна"
      },
      "trillions": {
        "few": "трильйона",
        "many": "трильйонiв",
        "one": "трильйон"
      },
      "trillionths": {
        "few": "трильйонних",
        "many": "трильйонних",
        "one": "трильйонна"
      },
      "union": "i"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%I:%M %p %B %d, %Y"
            }
          }
        }
      }
    }
  },
  "uk": {
    "active_admin": {
      "access_denied": {
        "message": "Ви не авторизовані для виконання даної дії."
      },
      "any": "Будь-який",
      "batch_actions": {
        "action_label": "%{title} вибране",
        "button_label": "Групові операції",
        "default_confirmation": "Ви справді бажаєте це зробити?",
        "delete_confirmation": "Ви впевнені, що хочете видалити %{plural_model}?",
        "labels": {
          "destroy": "Видалити"
        },
        "selection_toggle_explanation": "(Скасувати все / Зняти виділення)",
        "succesfully_destroyed": {
          "few": "Успішно видалено: %{count} %{plural_model}",
          "many": "Успішно видалено: %{count} %{plural_model}",
          "one": "Успішно видалено: 1 %{model}",
          "other": "Успішно видалено: %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Поки-що немає %{resource_name}.",
        "link": "Створити"
      },
      "cancel": "Скасувати",
      "comments": {
        "add": "Додати Коментар",
        "author": "Автор",
        "author_missing": "Анонім",
        "author_type": "Тип автора",
        "body": "Текст",
        "errors": {
          "empty_text": "Коментар не збережено, текст не повинен бути пустим."
        },
        "no_comments_yet": "Поки-що немає коментарів.",
        "resource": "Ресурс",
        "resource_type": "Тип ресурса",
        "title_content": "Коментарі (%{count})"
      },
      "dashboard": "Панель керування",
      "dashboard_welcome": {
        "call_to_action": "Щоб додати сюди що-небудь, зазирніть у 'app/admin/dashboard.rb'",
        "welcome": "Ласкаво просимо до Active Admin. Це стандартна сторінка керування сайтом."
      },
      "delete": "Видалити",
      "delete_confirmation": "Ви впевнені, що хочете це видалити?",
      "delete_model": "Видалити %{model}",
      "details": "%{model} детальніше",
      "devise": {
        "change_password": {
          "submit": "Змінити пароль",
          "title": "Зміна паролю"
        },
        "email": {
          "title": "Електронна пошта"
        },
        "links": {
          "forgot_your_password": "Забули пароль?",
          "resend_confirmation_instructions": "Повторна відправка інструкцій підтвердження",
          "resend_unlock_instructions": "Повторна відправка інструкцій розблокування",
          "sign_in": "Увійти",
          "sign_in_with_omniauth_provider": "Увійти з допомогою %{provider}",
          "sign_up": "Зареєструватись"
        },
        "login": {
          "remember_me": "Запам'ятати мене",
          "submit": "Увійти",
          "title": "Вхід"
        },
        "password": {
          "title": "Пароль"
        },
        "resend_confirmation_instructions": {
          "submit": "Відправити повторно листа з активацією",
          "title": "Відправити повторно листа з активацією"
        },
        "reset_password": {
          "submit": "Скинути пароль",
          "title": "Забули пароль?"
        },
        "sign_up": {
          "submit": "Зареєструватися",
          "title": "Зареєструватися"
        },
        "subdomain": {
          "title": "Піддомен"
        },
        "unlock": {
          "submit": "Відправити повторно інструкції з розблокування",
          "title": "Відправити повторно інструкції з розблокування"
        },
        "username": {
          "title": "Ім'я користувача"
        }
      },
      "download": "Завантаження:",
      "dropdown_actions": {
        "button_label": "Oперації"
      },
      "edit": "Змінити",
      "edit_model": "Змінити %{model}",
      "empty": "Пусто",
      "filters": {
        "buttons": {
          "clear": "Очистити",
          "filter": "Фільтрувати"
        },
        "predicates": {
          "from": "від",
          "to": "до"
        }
      },
      "has_many_delete": "Прибрати",
      "has_many_new": "Додати %{model}",
      "has_many_remove": "Видалити",
      "index_list": {
        "block": "Список",
        "blog": "Блог",
        "grid": "Сітка",
        "table": "Таблиця"
      },
      "logout": "Вийти",
      "main_content": "Створіть %{model}#main_content для відображення вмісту.",
      "new_model": "Створити %{model}",
      "next": "Наст.",
      "pagination": {
        "empty": "%{model} не знайдено",
        "entry": {
          "few": "записи",
          "many": "записів",
          "one": "запис",
          "other": "записів"
        },
        "multiple": "Результат: %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> з <b>%{total}</b>",
        "multiple_without_total": "Результат: %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>",
        "one": "Результат: <b>1</b> %{model}",
        "one_page": "Результат: <b>%{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "Поперед.",
      "search_status": {
        "current_filters": "Поточний фільтр:",
        "current_scope": "Область:",
        "headline": "Статус пошуку:",
        "no_current_filters": "Жоден"
      },
      "sidebars": {
        "filters": "Фільтри",
        "search_status": "Статус пошуку"
      },
      "status_tag": {
        "no": "Ні",
        "unset": "Ні",
        "yes": "Так"
      },
      "unsupported_browser": {
        "headline": "Зверніть, будь-ласка, увагу, що ActiveAdmin більше не підтримує Internet Explorer 8 версії і нижче",
        "recommendation": "Ми рекомендуємо оновити версію вашого браузеру (<a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>, <a href=\"https://chrome.google.com/\">Google Chrome</a>, або <a href=\"https://mozilla.org/firefox/\">Firefox</a>).",
        "turn_off_compatibility_view": "Якщо ви використовуєте IE 9 і вище, переконайтесь, що <a href=\"https://support.microsoft.com/uk-ua/help/17471\">ви вимкнули опцію \"Перегляд в режимі сумісності\"</a>."
      },
      "view": "Переглянути"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "Поточний пароль",
          "email": "Email",
          "password": "Пароль",
          "password_confirmation": "Підтвердження пароля",
          "remember_me": "Запам'ятати мене"
        }
      },
      "models": {
        "user": "Користувач"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Повторно надіслати інструкцію з підтвердженням"
        }
      },
      "failure": {
        "expired": "Ваш аккаунт застарів через неактивність. Будь ласка, зв'яжіться з адміністратором.",
        "session_limited": "Ваші облікові дані були використані в іншому браузері. Будь ласка, авторизуйтесь знову щоб продовжити в цьому браузері."
      },
      "invalid_captcha": "Введення капчі недійсне.",
      "invalid_security_question": "Неправильна відповідь на секретне питання.",
      "mailer": {
        "confirmation_instructions": {
          "action": "Підтвердити мій аккаунт",
          "greeting": "Ласкаво просимо %{recipient}!",
          "instruction": "Ви можете підтвердити свою електронну пошту через посилання нижче:"
        },
        "reset_password_instructions": {
          "action": "Зміна паролю",
          "greeting": "Доброго дня %{recipient}!",
          "instruction": "Хтось подав запит на зміну вашого паролю, ви можете підтвердити зміну через посилання нижче.",
          "instruction_2": "Якщо вам цього не потрібно, не звертайте увагу на це повідомлення.",
          "instruction_3": "Ваш пароль не мінятиметься доки ви не перейдете за посиланням вище і створите новий."
        },
        "unlock_instructions": {
          "action": "Розблокувати мій обліковий запис",
          "greeting": "Доброго дня %{recipient}!",
          "instruction": "Натисніть на посилання нижче, щоб розблокувати обліковий запис:",
          "message": "Ваш обліковий запис був заблокований через велику кількості невдалих спроб входу."
        }
      },
      "paranoid_verification_code": {
        "show": {
          "submit": "Відправити",
          "submit_verification_code": "Відправити код підтвердження",
          "verification_code": "Код підтвердження"
        },
        "updated": "Код підтвердження прийнято"
      },
      "paranoid_verify": {
        "code_required": "Введіть, будь ласка, код від нашої команди підтримки"
      },
      "password_expired": {
        "change_required": "Ваш пароль застарілий. Будь ласка, оновіть пароль.",
        "show": {
          "change_my_password": "Змінити пароль",
          "current_password": "Теперішній пароль",
          "new_password": "Новий пароль",
          "new_password_confirmation": "Підтвердити новий пароль",
          "renew_your_password": "Оновити свій пароль"
        },
        "updated": "Ваш новий пароль збережено."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Змінити мій пароль",
          "change_your_password": "Змінити ваш пароль",
          "confirm_new_password": "Підтвердіть новий пароль",
          "new_password": "Новий пароль"
        },
        "new": {
          "forgot_your_password": "Забули пароль?",
          "send_me_reset_password_instructions": "Відправити мені інструкції скидання паролів"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Ви впевнені?",
          "cancel_my_account": "Скасувати мій обліковий запис",
          "currently_waiting_confirmation_for_email": "В даний час очікуємо підтвердження від: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "залиште порожнім, якщо ви не хочете змінити його",
          "title": "Редагувати %{resource}",
          "unhappy": "Нещасний",
          "update": "Оновити",
          "we_need_your_current_password_to_confirm_your_changes": "введіть свій поточний пароль для підтвердження змін"
        },
        "new": {
          "sign_up": "Зареєструватись"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Увійти"
        }
      },
      "shared": {
        "links": {
          "back": "Назад",
          "didn_t_receive_confirmation_instructions": "Не отримали лист з підтвердженням?",
          "didn_t_receive_unlock_instructions": "Не отримали інструкції розблокування?",
          "forgot_your_password": "Забули пароль?",
          "sign_in": "Увійти",
          "sign_in_with_provider": "Увійти за допомогою %{provider}",
          "sign_up": "Зареєструватись"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Повторно надіслати інструкції з розблокування"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "має недійсне співвідношення сторін (дійсні співвідношення сторін %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "повинен бути пейзажним (поточний файл %{width}x%{height} пікселям)",
        "aspect_ratio_not_portrait": "повинен бути портретним (поточний файл %{width}x%{height} пікселям)",
        "aspect_ratio_not_square": "повинен бути квадратним (поточний файл %{width}x%{height} пікселям)",
        "aspect_ratio_not_x_y": "повинен бути %{authorized_aspect_ratios} (поточний файл становить %{width}x%{height} пікселям)",
        "attachment_missing": "не має доданого файлу",
        "audio_missing": "має містити аудіодоріжку",
        "audio_present": "не має містити аудіодоріжку",
        "content_type_invalid": {
          "one": "має недійсний тип вмісту (уповноважений тип вмісту становить %{authorized_human_content_types})",
          "other": "має недійсний тип вмісту (дозволені типи вмісту %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "має тип вмісту, який не еквівалентний тому, який виявляється через його вміст (уповноважений тип вмісту становить %{authorized_human_content_types})",
          "other": "має тип вмісту, який не еквівалентний тому, який виявляється через його вміст (дозволені типи вмісту %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "висота мусить дорівнювати %{length} пікселям",
        "dimension_height_not_greater_than_or_equal_to": "висота мусить бути більше або дорівнювати %{length} пікселям",
        "dimension_height_not_included_in": "висота не включена між %{min} і %{max} пікселям",
        "dimension_height_not_less_than_or_equal_to": "висота мусить бути менше або дорівнювати %{length} пікселям",
        "dimension_max_not_included_in": "мусить бути менше або дорівнювати %{width} x %{height} пікселям",
        "dimension_min_not_included_in": "мусить бути більше або дорівнювати %{width} x %{height} пікселям",
        "dimension_width_not_equal_to": "ширина мусить дорівнювати %{length} пікселям",
        "dimension_width_not_greater_than_or_equal_to": "ширина мусить бути більше або дорівнювати %{length} пікселям",
        "dimension_width_not_included_in": "ширина не включена між %{min} і %{max} пікселям",
        "dimension_width_not_less_than_or_equal_to": "ширина мусить бути менше або дорівнювати %{length} пікселям",
        "duration_not_between": "тривалість повинна бути між %{min} і %{max} (поточна тривалість становить %{duration})",
        "duration_not_equal_to": "тривалість повинна бути рівна %{exact} (поточна тривалість становить %{duration})",
        "duration_not_greater_than": "тривалість повинна бути більше %{min} (поточна тривалість становить %{duration})",
        "duration_not_greater_than_or_equal_to": "тривалість повинна бути більшою або дорівнює %{min} (поточна тривалість становить %{duration})",
        "duration_not_less_than": "тривалість повинна бути меншою ніж %{max} (поточна тривалість становить %{duration})",
        "duration_not_less_than_or_equal_to": "тривалість повинна бути меншою або дорівнює %{max} (поточна тривалість становить %{duration})",
        "equal_to_current_password": "має відрізнятися від поточного паролю.",
        "equal_to_email": "має відрізнятися від електронної пошти.",
        "file_not_processable": "не ідентифікується як дійсний медіа-файл",
        "file_size_not_between": "розмір файлу має бути від %{min} до %{max} (поточний розмір %{file_size})",
        "file_size_not_equal_to": "розмір файлу має бути рівний %{exact} (поточний розмір %{file_size})",
        "file_size_not_greater_than": "розмір файлу має бути більшим ніж %{min} (поточний розмір %{file_size})",
        "file_size_not_greater_than_or_equal_to": "розмір файлу має бути більшим або дорівнювати %{min} (поточний розмір %{file_size})",
        "file_size_not_less_than": "розмір файлу має бути менше %{max} (поточний розмір %{file_size})",
        "file_size_not_less_than_or_equal_to": "розмір файлу має бути меншим або дорівнювати %{max} (поточний розмір %{file_size})",
        "limit_max_exceeded": {
          "one": "занадто багато доданих файлів (максимум -%{max} файлів, отримав %{count})",
          "other": "занадто багато доданих файлів (максимум -%{max} файлів, отримав %{count})",
          "zero": "не додано файлів (максимум -%{max} файли)"
        },
        "limit_min_not_reached": {
          "one": "додається лише 1 файл (повинен мати принаймні %{min} файли)",
          "other": "%{count} додані файли (повинні мати принаймні %{min} файли)",
          "zero": "немає доданих файлів (повинен мати принаймні %{min} файлів)"
        },
        "limit_out_of_range": {
          "one": "додається лише 1 файл (повинен мати між %{min} і %{max} файли)",
          "other": "загальна кількість файлів повинна бути між %{min} і %{max} файлами (є %{count} файли)",
          "zero": "немає доданих файлів (повинно мати між %{min} і %{max} файли)"
        },
        "media_metadata_missing": "не є допустимим зображенням",
        "pages_not_between": "кількість сторінок має бути від %{min} до %{max} (поточна кількість сторінок становить %{pages})",
        "pages_not_equal_to": "кількість сторінок має дорівнювати %{exact} (поточна кількість сторінок - %{pages})",
        "pages_not_greater_than": "кількість сторінок має бути більшою за %{min} (поточна кількість сторінок становить %{pages})",
        "pages_not_greater_than_or_equal_to": "кількість сторінок має бути більшою або дорівнювати %{min} (поточна кількість сторінок становить %{pages})",
        "pages_not_less_than": "кількість сторінок має бути менше %{max} (поточна кількість сторінок %{pages})",
        "pages_not_less_than_or_equal_to": "кількість сторінок має бути меншою або дорівнювати %{max} (поточна кількість сторінок становить %{pages})",
        "password_complexity": {
          "digit": {
            "few": "повинен включати хоча б %{count} цифри",
            "many": "повинен включати хоча б %{count} цифр",
            "one": "повинен включати хоча б одну цифру",
            "other": "повинен включати хоча б %{count} цифри"
          },
          "lower": {
            "few": "повинен включати хоча б %{count} малі букви",
            "many": "повинен включати хоча б %{count} малих букв",
            "one": "повинен включати хоча б одну малу букву",
            "other": "повинен включати хоча б %{count} малі букви"
          },
          "symbol": {
            "few": "повинен включати хоча б %{count} розділові знаки або символи",
            "many": "повинен включати хоча б %{count} розділових знаків або символів",
            "one": "повинен включати хоча б один розділовий знак або символ",
            "other": "повинен включати хоча б %{count} розділові знаки або символи"
          },
          "upper": {
            "few": "повинен включати хоча б %{count} прописні букви",
            "many": "повинен включати хоча б %{count} прописних букв",
            "one": "повинен включати хоча б одну прописну букву",
            "other": "повинен включати хоча б %{count} прописні букви"
          }
        },
        "taken_in_past": "раніше використовувався.",
        "total_file_size_not_between": "загальний розмір файлу має бути від %{min} до %{max} (поточний розмір %{total_file_size})",
        "total_file_size_not_equal_to": "загальний розмір файлу має бути рівний %{exact} (поточний розмір %{total_file_size})",
        "total_file_size_not_greater_than": "загальний розмір файлу має бути більшим ніж %{min} (поточний розмір %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "загальний розмір файлу має бути більшим або дорівнювати %{min} (поточний розмір %{total_file_size})",
        "total_file_size_not_less_than": "загальний розмір файлу має бути менше %{max} (поточний розмір %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "загальний розмір файлу має бути меншим або дорівнювати %{max} (поточний розмір %{total_file_size})"
      }
    },
    "pagy": {
      "aria_label": {
        "nav": {
          "few": "Сторінки",
          "many": "Сторінок",
          "one": "Сторінка",
          "other": "Сторінки"
        },
        "next": "Далі",
        "previous": "Назад"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Загалом %{count} %{item_name}, показані з %{from} по %{to}",
        "no_count": "Сторінка %{page} з %{pages}",
        "no_items": "Більше %{item_name} немає",
        "single_page": "%{count} %{item_name}"
      },
      "input_nav_js": "Сторінка %{page_input} з %{pages}",
      "item_name": {
        "few": "записів",
        "many": "записів",
        "one": "запис",
        "other": "записів"
      },
      "limit_tag_js": "Показати %{limit_input} %{item_name} на сторінці",
      "next": "&gt;",
      "p11n": "EastSlavic",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "усі",
      "and": "і",
      "any": "будь-який",
      "asc": "за зростанням",
      "attribute": "атрибут",
      "combinator": "комбінатор",
      "condition": "умова",
      "desc": "за спаданням",
      "or": "або",
      "predicate": "предикат",
      "predicates": {
        "blank": "порожній",
        "cont": "містить",
        "cont_all": "містить усі",
        "cont_any": "містить будь-який",
        "does_not_match": "не збігається",
        "does_not_match_all": "не збігається з усіма",
        "does_not_match_any": "не збігається з будь-яким",
        "end": "закінчується на",
        "end_all": "закінчується на всі",
        "end_any": "закінчується на будь-який",
        "eq": "рівний",
        "eq_all": "рівний усім",
        "eq_any": "рівний будь-якому",
        "false": "ні",
        "gt": "більше ніж",
        "gt_all": "більше ніж усі",
        "gt_any": "більше ніж будь-який",
        "gteq": "більше або рівне",
        "gteq_all": "більше або рівне всім",
        "gteq_any": "більше або рівне будь-якому",
        "in": "міститься у",
        "in_all": "міститься в усіх",
        "in_any": "міститься в будь-якому",
        "lt": "менше ніж",
        "lt_all": "менше за всі",
        "lt_any": "менше за будь-який",
        "lteq": "менше або рівне",
        "lteq_all": "менше або рівне всім",
        "lteq_any": "менше або рівне будь-якому",
        "matches": "збігається",
        "matches_all": "збігається з усіма",
        "matches_any": "збігається з будь-яким",
        "not_cont": "не містить",
        "not_cont_all": "не містить усіх",
        "not_cont_any": "не містить жодного",
        "not_end": "не закінчується на",
        "not_end_all": "не закінчується на всі",
        "not_end_any": "не закінчується на будь-який",
        "not_eq": "не рівний",
        "not_eq_all": "не рівний усім",
        "not_eq_any": "не рівний будь-якому",
        "not_in": "не міститься у",
        "not_in_all": "не міститься в усіх",
        "not_in_any": "не міститься в будь-якому",
        "not_null": "не нульовий",
        "not_start": "не починається з",
        "not_start_all": "не починається з усіх",
        "not_start_any": "не починається з будь-якого",
        "null": "нульовий",
        "present": "присутній",
        "start": "починається з",
        "start_all": "починається з усіх",
        "start_any": "починається з будь-якого",
        "true": "так"
      },
      "search": "пошук",
      "sort": "сортування",
      "value": "значення"
    }
  },
  "vi": {
    "active_admin": {
      "access_denied": {
        "message": "Bạn không có quyền thực hiện tính năng này"
      },
      "any": "Bất kỳ",
      "batch_actions": {
        "action_label": "%{title} đã được chọn",
        "button_label": "Hành động hàng loạt",
        "default_confirmation": "Bạn có chắc bạn muốn làm điều này?",
        "delete_confirmation": "Bạn có chắc chắn muốn xóa những %{plural_model}?",
        "labels": {
          "destroy": "Xóa"
        },
        "selection_toggle_explanation": "(Thay đổi lựa chọn)",
        "succesfully_destroyed": {
          "one": "Đã xóa thành công 1 %{model}",
          "other": "Đã xóa thành công %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "Chưa có %{resource_name}.",
        "link": "Tạo mới"
      },
      "cancel": "Hủy",
      "comments": {
        "add": "Thêm bình luận",
        "author": "Tác giả",
        "author_missing": "Vô danh",
        "author_type": "Loại tác giả",
        "body": "Nội dung",
        "created_at": "Đã tạo",
        "delete": "Xoá bình luận",
        "delete_confirmation": "Bạn có chắc chắn muốn xóa những bình luận này?",
        "errors": {
          "empty_text": "Lời bình luận chưa được lưu, vì nội dung còn trống."
        },
        "no_comments_yet": "Chưa có bình luận.",
        "resource": "Resource",
        "resource_type": "Resource Type",
        "title_content": "Bình luận (%{count})"
      },
      "create_another": "Tạo thêm %{model}",
      "dashboard": "Bảng điều khiển",
      "dashboard_welcome": {
        "call_to_action": "Để thêm thành phần cho trang điều khiển hãy chỉnh sửa 'app/admin/dashboard.rb'",
        "welcome": "Chào mừng bạn đến với Active Admin. Đây là trang điều khiển mặc định."
      },
      "delete": "Xóa",
      "delete_confirmation": "Bạn có chắc chắn rằng mình muốn xóa không?",
      "delete_model": "Xóa %{model}",
      "details": "%{model} Chi tiết",
      "devise": {
        "change_password": {
          "submit": "Thay đổi mật khẩu của tôi",
          "title": "Thay đổi mật khẩu của bạn"
        },
        "email": {
          "title": "Email"
        },
        "links": {
          "forgot_your_password": "Quên mật khẩu của bạn?",
          "resend_confirmation_instructions": "Gửi lại hướng dẫn xác nhận",
          "resend_unlock_instructions": "Gửi lại hướng dẫn mở khoá",
          "sign_in": "Đăng nhập",
          "sign_in_with_omniauth_provider": "Đăng nhập với %{provider}",
          "sign_up": "Đăng ký"
        },
        "login": {
          "remember_me": "Ghi nhớ tôi",
          "submit": "Đăng nhập",
          "title": "Đăng nhập"
        },
        "password": {
          "title": "Mật khẩu"
        },
        "password_confirmation": {
          "title": "Mật khẩu xác nhận"
        },
        "resend_confirmation_instructions": {
          "submit": "Gửi lại hướng dẫn xác nhận",
          "title": "Gửi lại hướng dẫn xác nhận"
        },
        "reset_password": {
          "submit": "Thiết lập lại mật khẩu của tôi",
          "title": "Quên mật khẩu của bạn?"
        },
        "sign_up": {
          "submit": "Đăng ký",
          "title": "Đăng ký"
        },
        "subdomain": {
          "title": "Tên miền phụ"
        },
        "unlock": {
          "submit": "Gửi lại hướng dẫn mở khoá",
          "title": "Gửi lại hướng dẫn mở khoá"
        },
        "username": {
          "title": "Tên người dùng"
        }
      },
      "download": "Tải về:",
      "dropdown_actions": {
        "button_label": "Hành động"
      },
      "edit": "Chỉnh sửa",
      "edit_model": "Chỉnh sửa %{model}",
      "empty": "Trống",
      "filters": {
        "buttons": {
          "clear": "Xóa dữ liệu lọc",
          "filter": "Lọc"
        },
        "predicates": {
          "from": "Từ",
          "to": "Đến"
        }
      },
      "has_many_delete": "Xóa",
      "has_many_new": "Thêm mới %{model}",
      "has_many_remove": "Hủy bỏ",
      "index_list": {
        "block": "Danh sách",
        "blog": "Blog",
        "grid": "Lưới",
        "table": "Bảng"
      },
      "logout": "Đăng xuất",
      "main_content": "Xin bổ sung %{model}#main_content để hiển thị nội dung.",
      "move": "Di chuyển",
      "new_model": "Tạo mới %{model}",
      "next": "Sau",
      "pagination": {
        "empty": "Không có %{model} nào được tìm thấy",
        "entry": {
          "one": "entry",
          "other": "entries"
        },
        "multiple": "Đang hiển thị %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b> of <b>%{total}</b> trong tất cả.",
        "multiple_without_total": "Đang hiển thị %{model} <b>%{from}&nbsp;-&nbsp;%{to}</b>.",
        "one": "Đang hiển thị <b>1</b> %{model}",
        "one_page": "Đang hiển thị <b>tất cả %{n}</b> %{model}",
        "per_page": "Mỗi trang: "
      },
      "powered_by": "Bản quyền bởi %{active_admin} %{version}",
      "previous": "Trước",
      "scopes": {
        "all": "Tất cả"
      },
      "search_status": {
        "current_filters": "Bộ lọc hiện tại:",
        "current_scope": "Phạm vi:",
        "headline": "Danh sách tìm kiếm:",
        "no_current_filters": "Không có"
      },
      "sidebars": {
        "filters": "Bộ Lọc",
        "search_status": "Trạng thái tìm kiếm"
      },
      "status_tag": {
        "no": "Không Có",
        "unset": "Không Có",
        "yes": "Có"
      },
      "unsupported_browser": {
        "headline": "Vui lòng lưu ý rằng ActiveAdmin không còn hỗ trợ trên Internet Explorer các phiên bản 8 và thấp hơn.",
        "recommendation": "Chúng tôi khuyên bạn hãy vào <a href=\"http://browsehappy.com/\">nâng cấp trình duyệt của bạn </a> để cải thiện trải nghiệm của bạn.",
        "turn_off_compatibility_view": "Nếu bạn đang sử dụng IE 9 hoặc mới hơn, hãy chắc chắn bạn <a href=\"https://support.microsoft.com/en-us/help/17471\">tắt \"Compatibility View\"</a>."
      },
      "view": "Xem"
    },
    "activerecord": {
      "attributes": {
        "active_admin/comment": {
          "author_type": "Loại tác giả",
          "body": "Nội dung",
          "created_at": "Đã tạo",
          "namespace": "Namespace",
          "resource_type": "Resource type",
          "updated_at": "Đã cập nhật"
        },
        "user": {
          "current_password": "Mật khẩu hiện tại",
          "email": "Email",
          "password": "Mật khẩu",
          "password_confirmation": "Xác nhận mật khẩu",
          "remember_me": "Ghi nhớ đăng nhập"
        }
      },
      "models": {
        "active_admin/comment": {
          "one": "Bình luận",
          "other": "Các bình luận"
        },
        "comment": {
          "one": "Bình luận",
          "other": "Các bình luận"
        },
        "user": "Người dùng"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "Gửi lại hướng dẫn xác nhận tài khoản"
        }
      },
      "failure": {
        "invited": "Bạn có một lời mời đang ở trạng thái chờ, hãy xác nhận nó để tạo tài khoản của bạn."
      },
      "invitations": {
        "edit": {
          "header": "Thiết lập mật khẩu",
          "mess": "Hãy thiết lập mật khẩu của bạn để sử dụng dịch vụ",
          "submit_button": "Đặt mật khẩu"
        },
        "invitation_removed": "Lời mời của bạn đã bị xóa.",
        "invitation_token_invalid": "Mã xác nhận không chính xác!",
        "new": {
          "header": "Gửi lời mời",
          "submit_button": "Gửi thư mời"
        },
        "no_invitations_remaining": "Không còn lời mời nào.",
        "send_instructions": "Một thư mời đã được gửi đến cho   %{email}.",
        "updated": "Mật khẩu của bạn đã được thiết lập thành công. Bạn hiện đang đăng nhập.",
        "updated_not_active": "Mật khẩu của bạn đã được thiết lập thành công."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Xác nhận tài khoản",
          "greeting": "Chào mừng %{recipient}!",
          "instruction": "Bạn có thể xác nhận tài khoản email bằng liên kết dưới đây:"
        },
        "invitation_instructions": {
          "accept": "Chấp nhận lời mời",
          "hello": "Xin chào %{email}",
          "ignore": "Nếu bạn không muốn chấp nhận lời mời, xin vui lòng bỏ qua email này.<br />Tài khoản của bạn sẽ không được khởi tạo cho đến khi bạn truy cập vào đường dẫn ở trên và đặt mật khẩu cho tài khoản của bạn.",
          "someone_invited_you": "Có một ai đó đã mời bạn ghé thăm %{url}, Bạn có thể chấp nhận lời mời này thông qua đường dẫn bên dưới.",
          "subject": "Hướng dẫn"
        },
        "reset_password_instructions": {
          "action": "Thay đổi mật khẩu",
          "greeting": "Xin chào %{recipient}!",
          "instruction": "Có ai đó yêu cầu liên kết thay đổi mật khẩu, bạn có thể thay đổi mật khẩu bằng liên kết dưới đây.",
          "instruction_2": "Nếu bạn không yêu cầu, vui lòng bỏ qua email này.",
          "instruction_3": "Mật khẩu của bạn sẽ không thay đổi cho đến khi bạn ấn vào liên kết trên và tạo mật khẩu mới."
        },
        "unlock_instructions": {
          "action": "Mở khoá tài khoản",
          "greeting": "Xin chào %{recipient}!",
          "instruction": "Hãy nhấn vào liên kết dưới đây để mở khoá tài khoản:",
          "message": "Tài khoản của bạn đã bị khoá do vượt quá giới hạn số lần đăng nhập không thành công."
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "Thay đổi mật khẩu",
          "change_your_password": "Thay đổi mật khẩu",
          "confirm_new_password": "Xác nhận mật khẩu mới",
          "new_password": "Mật khẩu mới"
        },
        "new": {
          "forgot_your_password": "Quên mật khẩu?",
          "send_me_reset_password_instructions": "Gửi cho tôi hướng dẫn cài đặt lại mật khẩu"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "Bạn có chắc?",
          "cancel_my_account": "Xoá tài khoản",
          "currently_waiting_confirmation_for_email": "Đang đợi xác nhận tài khoản email: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "để trống nếu bạn không muốn thay đổi mật khẩu",
          "title": "Cập nhật %{resource}",
          "unhappy": "Không hài lòng",
          "update": "Cập nhật",
          "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
        },
        "new": {
          "sign_up": "Đăng ký"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "Đăng nhập"
        }
      },
      "shared": {
        "links": {
          "back": "Trở về",
          "didn_t_receive_confirmation_instructions": "Không nhận được hướng dẫn xác nhận tài khoản?",
          "didn_t_receive_unlock_instructions": "Không nhận được hướng dẫn mở khoá tài khoản?",
          "forgot_your_password": "Quên mật khẩu?",
          "sign_in": "Đăng nhập",
          "sign_in_with_provider": "Đăng nhập với %{provider}",
          "sign_up": "Đăng ký"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Gửi lại hướng dẫn mở khoá tài khoản"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "có tỷ lệ khung hình không hợp lệ (tỷ lệ khung hình hợp lệ là %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "phải là ngang (tệp hiện tại là %{width}x%{height}px)",
        "aspect_ratio_not_portrait": "phải là chân dung (tệp hiện tại là %{width}x%{height}px)",
        "aspect_ratio_not_square": "phải là hình vuông (tệp hiện tại là %{width}x%{height}px)",
        "aspect_ratio_not_x_y": "phải là %{authorized_aspect_ratios} (tệp hiện tại là %{width}x%{height}px)",
        "attachment_missing": "không có tập tin đính kèm",
        "audio_missing": "phải có một bản âm thanh",
        "audio_present": "không được chứa bản âm thanh",
        "content_type_invalid": {
          "one": "có loại nội dung không hợp lệ (loại nội dung được ủy quyền là %{authorized_human_content_types})",
          "other": "có loại nội dung không hợp lệ (các loại nội dung được ủy quyền là %{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "có một loại nội dung không tương đương với loại được phát hiện thông qua nội dung của nó (loại nội dung được ủy quyền là %{authorized_human_content_types})",
          "other": "có một loại nội dung không tương đương với loại được phát hiện thông qua nội dung của nó (các loại nội dung được ủy quyền là %{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "chiều cao phải bằng %{length} pixel",
        "dimension_height_not_greater_than_or_equal_to": "chiều cao phải lớn hơn hoặc bằng %{length} pixel",
        "dimension_height_not_included_in": "chiều cao không nằm trong %{min} và %{max} pixel",
        "dimension_height_not_less_than_or_equal_to": "chiều cao phải nhỏ hơn hoặc bằng %{length} pixel",
        "dimension_max_not_included_in": "phải nhỏ hơn hoặc bằng %{width} x %{height} pixel",
        "dimension_min_not_included_in": "phải lớn hơn hoặc bằng %{width} x %{height} pixel",
        "dimension_width_not_equal_to": "chiều rộng phải bằng %{length} pixel",
        "dimension_width_not_greater_than_or_equal_to": "chiều rộng phải lớn hơn hoặc bằng %{length} pixel",
        "dimension_width_not_included_in": "chiều rộng không nằm trong %{min} và %{max} pixel",
        "dimension_width_not_less_than_or_equal_to": "chiều rộng phải nhỏ hơn hoặc bằng %{length} pixel",
        "duration_not_between": "thời lượng phải nằm trong khoảng từ %{min} và %{max} (thời lượng hiện tại là %{duration})",
        "duration_not_equal_to": "thời lượng phải bằng %{exact} (thời lượng hiện tại là %{duration})",
        "duration_not_greater_than": "thời lượng phải lớn hơn %{min} (thời lượng hiện tại là %{duration})",
        "duration_not_greater_than_or_equal_to": "thời lượng phải lớn hơn hoặc bằng %{min} (thời lượng hiện tại là %{duration})",
        "duration_not_less_than": "thời lượng phải nhỏ hơn %{max} (thời lượng hiện tại là %{duration})",
        "duration_not_less_than_or_equal_to": "thời lượng phải nhỏ hơn hoặc bằng %{max} (thời lượng hiện tại là %{duration})",
        "file_not_processable": "không được xác định là tệp phương tiện hợp lệ",
        "file_size_not_between": "kích thước tệp phải nằm trong khoảng từ %{min} đến %{max} (kích thước hiện tại là %{file_size})",
        "file_size_not_equal_to": "kích thước tệp phải bằng %{exact} (kích thước hiện tại là %{file_size})",
        "file_size_not_greater_than": "kích thước tệp phải lớn hơn %{min} (kích thước hiện tại là %{file_size})",
        "file_size_not_greater_than_or_equal_to": "kích thước tệp phải lớn hơn hoặc bằng %{min} (kích thước hiện tại là %{file_size})",
        "file_size_not_less_than": "kích thước tệp phải nhỏ hơn %{max} (kích thước hiện tại là %{file_size})",
        "file_size_not_less_than_or_equal_to": "kích thước tệp phải nhỏ hơn hoặc bằng %{max} (kích thước hiện tại là %{file_size})",
        "limit_max_exceeded": {
          "one": "quá nhiều tệp được đính kèm (tối đa là các tệp %{max}, có %{count})",
          "other": "quá nhiều tệp được đính kèm (tối đa là các tệp %{max}, có %{count})",
          "zero": "không có tệp nào được đính kèm (tối đa là các tệp %{max})"
        },
        "limit_min_not_reached": {
          "one": "chỉ có 1 tệp được đính kèm (phải có ít nhất %{min} tệp)",
          "other": "các tệp %{count} được đính kèm (phải có ít nhất %{min} tệp)",
          "zero": "không có tệp nào được đính kèm (phải có ít nhất %{min} tệp)"
        },
        "limit_out_of_range": {
          "one": "chỉ có 1 tệp được đính kèm (phải có giữa các tệp %{min} và %{max})",
          "other": "tổng số tệp phải nằm trong khoảng từ %{min} và %{max} tệp (có các tệp %{count} được đính kèm)",
          "zero": "không có tệp nào được đính kèm (phải có giữa các tệp %{min} và %{max})"
        },
        "media_metadata_missing": "không phải là ảnh",
        "pages_not_between": "số trang phải nằm trong khoảng từ %{min} đến %{max} (số trang hiện tại là %{pages})",
        "pages_not_equal_to": "số trang phải bằng %{exact} (số trang hiện tại là %{pages})",
        "pages_not_greater_than": "số trang phải lớn hơn %{min} (số trang hiện tại là %{pages})",
        "pages_not_greater_than_or_equal_to": "số trang phải lớn hơn hoặc bằng %{min} (số trang hiện tại là %{pages})",
        "pages_not_less_than": "số trang phải nhỏ hơn %{max} (số trang hiện tại là %{pages})",
        "pages_not_less_than_or_equal_to": "số trang phải nhỏ hơn hoặc bằng %{max} (số trang hiện tại là %{pages})",
        "total_file_size_not_between": "tổng kích thước tệp phải nằm trong khoảng từ %{min} đến %{max} (kích thước hiện tại là %{total_file_size})",
        "total_file_size_not_equal_to": "tổng kích thước tệp phải bằng %{exact} (kích thước hiện tại là %{total_file_size})",
        "total_file_size_not_greater_than": "tổng kích thước tệp phải lớn hơn %{min} (kích thước hiện tại là %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "tổng kích thước tệp phải lớn hơn hoặc bằng %{min} (kích thước hiện tại là %{total_file_size})",
        "total_file_size_not_less_than": "tổng kích thước tệp phải nhỏ hơn %{max} (kích thước hiện tại là %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "tổng kích thước tệp phải nhỏ hơn hoặc bằng %{max} (kích thước hiện tại là %{total_file_size})"
      }
    },
    "numbers": {
      "hundreds": "trăm",
      "mega": [
        "_",
        "nghìn",
        "triệu",
        "tỷ",
        "nghìn tỷ",
        "triệu tỷ"
      ],
      "micro_separator": "phẩy",
      "ones": [
        "không",
        "một",
        "hai",
        "ba",
        "bốn",
        "năm",
        "sáu",
        "bảy",
        "tám",
        "chín"
      ],
      "ones_union": "linh",
      "teens": [
        "_",
        "mười một",
        "mười hai",
        "mười ba",
        "mười bốn",
        "mười lăm",
        "mười sáu",
        "mười bảy",
        "thứ mười tám",
        "mười chín"
      ],
      "tens": [
        "_",
        "mười",
        "hai mươi",
        "ba mươi",
        "bốn mươi",
        "năm mươi",
        "sáu mươi",
        "bảy mươi",
        "tám mươi",
        "chín mươi"
      ],
      "units": {
        "tens": {
          "five": "lăm",
          "one": "mốt"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": "Trang",
        "next": "Trang sau",
        "previous": "Trang trước"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "Đang hiển thị %{from}-%{to} trong tổng số %{count} %{item_name}",
        "no_count": "Trang %{page} trên %{pages}",
        "no_items": "Không tìm thấy %{item_name} nào",
        "single_page": "%{count} %{item_name}"
      },
      "input_nav_js": "Trang %{page_input} trên %{pages}",
      "item_name": "kết quả",
      "limit_tag_js": "Hiển thị %{limit_input} %{item_name} mỗi trang",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    }
  },
  "zh-CN": {
    "active_admin": {
      "access_denied": {
        "message": "您无权处理此操作"
      },
      "any": "任何",
      "batch_actions": {
        "action_label": "%{title} 被选中",
        "button_label": "批处理",
        "default_confirmation": "你确定要这样做？",
        "delete_confirmation": "你确定要删除这些%{plural_model}？",
        "labels": {
          "destroy": "删除"
        },
        "selection_toggle_explanation": "(切换选择)",
        "succesfully_destroyed": {
          "one": "成功删除 1 %{model}",
          "other": "成功删除 %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "暂时还没有%{resource_name}。",
        "link": "新增一个"
      },
      "cancel": "取消",
      "comments": {
        "add": "添加评论",
        "author": "作者",
        "author_missing": "匿名",
        "author_type": "作者类型",
        "body": "内容",
        "created_at": "创建于",
        "delete": "删除评论",
        "delete_confirmation": "你确定删除这些评论？",
        "errors": {
          "empty_text": "评论保存失败，内空不能为空。"
        },
        "no_comments_yet": "暂时没有评论",
        "resource": "资源",
        "resource_type": "资源类型",
        "title_content": "(%{count})条评论"
      },
      "create_another": "新增另一个%{model}",
      "dashboard": "控制面板",
      "dashboard_welcome": {
        "call_to_action": "若要添加新的面板内容, 请修改 'app/admin/dashboard.rb'",
        "welcome": "欢迎使用Active Admin. 这是默认的控制面板页."
      },
      "delete": "删除",
      "delete_confirmation": "确定删除?",
      "delete_model": "删除%{model}",
      "details": "%{model}详情",
      "devise": {
        "change_password": {
          "submit": "修改密码",
          "title": "修改密码"
        },
        "email": {
          "title": "邮箱"
        },
        "links": {
          "forgot_your_password": "忘记了密码？",
          "resend_confirmation_instructions": "重发确认邮件",
          "resend_unlock_instructions": "重发解锁邮件",
          "sign_in": "登录",
          "sign_in_with_omniauth_provider": "通过%{provider}登录",
          "sign_up": "注册"
        },
        "login": {
          "remember_me": "记住我",
          "submit": "登录",
          "title": "登录"
        },
        "password": {
          "title": "密码"
        },
        "password_confirmation": {
          "title": "确认密码"
        },
        "resend_confirmation_instructions": {
          "submit": " 重新发送确认说明",
          "title": " 重新发送确认说明"
        },
        "reset_password": {
          "submit": "重置我的密码",
          "title": "忘记了密码？"
        },
        "sign_up": {
          "submit": "注册",
          "title": "注册"
        },
        "subdomain": {
          "title": "子域"
        },
        "unlock": {
          "submit": "重新发送送解锁命令",
          "title": "重新发送送解锁命令"
        },
        "username": {
          "title": "用户名"
        }
      },
      "download": "下载：",
      "dropdown_actions": {
        "button_label": "操作"
      },
      "edit": "编辑",
      "edit_model": "编辑%{model}",
      "empty": "未定义",
      "filters": {
        "buttons": {
          "clear": "清除条件",
          "filter": "过滤"
        },
        "predicates": {
          "from": "起",
          "to": "止"
        }
      },
      "has_many_delete": "删除",
      "has_many_new": "新增一个%{model}",
      "has_many_remove": "清除",
      "index_list": {
        "block": "列表",
        "blog": "博客",
        "grid": "网格",
        "table": "表格"
      },
      "logout": "退出",
      "main_content": "请执行 %{model}#main_content 来显示内容。",
      "move": "移动",
      "new_model": "新增%{model}",
      "next": "下一个",
      "pagination": {
        "empty": "暂时没有%{model}",
        "entry": {
          "one": "条目",
          "other": "条目"
        },
        "multiple": "显示所有 <b>%{total}</b> %{model}中的<b>%{from}&nbsp;-&nbsp;%{to}</b> 条",
        "multiple_without_total": "%{model}中的<b>%{from}&nbsp;-&nbsp;%{to}</b> 条",
        "one": "显示 <b>1</b> %{model}",
        "one_page": "显示 <b>所有 %{n}</b> %{model}",
        "per_page": "每页："
      },
      "powered_by": "构建程序为 %{active_admin} %{version}",
      "previous": "上一个",
      "scopes": {
        "all": "所有"
      },
      "search_status": {
        "current_filters": "过滤条件：",
        "current_scope": "范围：",
        "headline": "搜索条件：",
        "no_current_filters": "无"
      },
      "sidebars": {
        "filters": "所有条件",
        "search_status": "搜索条件"
      },
      "status_tag": {
        "no": "否",
        "unset": "否",
        "yes": "是"
      },
      "unsupported_browser": {
        "headline": "很抱歉，ActiveAdmin 已不再支持 Internet Explorer 8 以下版本的浏览器。",
        "recommendation": "建议您升级到最新版本的<a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>，<a href=\"https://chrome.google.com/\">Google Chrome</a>，或是 <a href=\"https://mozilla.org/firefox/\">Firefox</a>。",
        "turn_off_compatibility_view": "如果您使用的是 IE 9 或更新的版本，请确认<a href=\"https://support.microsoft.com/zh-cn/help/17472/windows-internet-explorer-11-fix-site-display-problems-compatibility-view\">已关闭“兼容性视图”</a>。"
      },
      "view": "查看"
    },
    "activerecord": {
      "attributes": {
        "active_admin/comment": {
          "author_type": "作者类型",
          "body": "内容",
          "created_at": "创建",
          "namespace": "Namespace",
          "resource_type": "Resource 类型",
          "updated_at": "更新"
        },
        "user": {
          "current_password": "当前密码",
          "email": "电子邮箱",
          "password": "密码",
          "password_confirmation": "密码确认",
          "remember_me": "记住登录信息"
        }
      },
      "models": {
        "active_admin/comment": {
          "one": "评论",
          "other": "评论"
        },
        "comment": {
          "one": "评论",
          "other": "评论"
        },
        "user": "用户"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "重新发送确认邮件"
        }
      },
      "failure": {
        "invited": "您有一封待处理的帐号邀请，请接受邀请完成创建您的帐号。"
      },
      "invitations": {
        "edit": {
          "header": "设置您的密码",
          "submit_button": "设置密码"
        },
        "invitation_removed": "您的邀请被删除了。",
        "invitation_token_invalid": "所提供的邀请验证无效！",
        "new": {
          "header": "发送邀请",
          "submit_button": "发送邀请"
        },
        "no_invitations_remaining": "没有待处理的邀请",
        "send_instructions": "邀请电子邮件已发送至 %{email}。",
        "updated": "您的密码已设置成功，。现在您已经登入了。",
        "updated_not_active": "您的密码已设置成功。"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "确认我的帐户",
          "greeting": "欢迎 %{recipient}!",
          "instruction": "您可以通过下面的链接确认您的帐户的电子邮件:"
        },
        "invitation_instructions": {
          "accept": "接受邀请",
          "accept_until": "这封邀请将于 %{due_date} 到期。",
          "hello": "%{email} 您好",
          "ignore": "如果您不想接受邀请，请忽略这封电子邮件。只要未选取上述“接受邀请”的链接并且设置密码，您的帐号就不会成立。",
          "someone_invited_you": "邀请您加入 %{url}，您可以通过以下的网页链接接受邀请，并创设帐号：",
          "subject": "邀请"
        },
        "reset_password_instructions": {
          "action": "更改我的密码",
          "greeting": "你好 %{recipient}!",
          "instruction": "有人要求更改密码的链接，您可以通过下面的链接更改密码：",
          "instruction_2": "如果您没有要求请求更改密码，请忽略此电子邮件。",
          "instruction_3": "如果你没有访问上面的链接并更改密码，你的密码就不会被改变。"
        },
        "unlock_instructions": {
          "action": "帐户解锁",
          "greeting": "你好 %{recipient}!",
          "instruction": "点击下面的链接到您的帐户解锁:",
          "message": "由于多次的不成功的登入尝试，您的帐户已被锁定。"
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "更改我的密码",
          "change_your_password": "更改您的密码",
          "confirm_new_password": "确认新密码",
          "new_password": "新密码"
        },
        "new": {
          "forgot_your_password": "忘记密码？",
          "send_me_reset_password_instructions": "请给我发送重设密码的邮件"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "你确定吗？",
          "cancel_my_account": "取消我的帐户",
          "currently_waiting_confirmation_for_email": "等待 %{email} 的确认",
          "leave_blank_if_you_don_t_want_to_change_it": "你不想去改变它，不需要填写",
          "title": "修改 %{resource}",
          "unhappy": "不喜欢",
          "update": "更新",
          "we_need_your_current_password_to_confirm_your_changes": "我们需要您的当前密码以确认您的更改"
        },
        "new": {
          "sign_up": "注册"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "登录"
        }
      },
      "shared": {
        "links": {
          "back": "返回",
          "didn_t_receive_confirmation_instructions": "没有收到确认邮件？",
          "didn_t_receive_unlock_instructions": "没有收到解锁邮件？",
          "forgot_your_password": "忘记密码？",
          "sign_in": "登录",
          "sign_in_with_provider": "用 %{provider} 登录",
          "sign_up": "注册"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "重发解锁邮件"
        }
      }
    },
    "errors": {
      "messages": {
        "aspect_ratio_invalid": "具有无效的长宽比（有效长宽比为 %{authorized_aspect_ratios})",
        "aspect_ratio_not_landscape": "必须是横向（当前文件为 %{width} x%{height} 像素)",
        "aspect_ratio_not_portrait": "必须是纵向的（当前文件为 %{width} x%{height} 像素)",
        "aspect_ratio_not_square": "必须为正方形（当前文件为 %{width} x%{height} 像素)",
        "aspect_ratio_not_x_y": "必须为 %{authorized_aspect_ratios}（当前文件为 %{width} x%{height} 像素)",
        "attachment_missing": "没有附件",
        "audio_missing": "必须包含音轨",
        "audio_present": "不得包含音轨",
        "content_type_invalid": {
          "one": "具有无效的内容类型（授权的内容类型为%{authorized_human_content_types})",
          "other": "具有无效的内容类型（授权的内容类型为%{authorized_human_content_types})"
        },
        "content_type_spoofed": {
          "one": "其内容类型不等于通过其内容检测到的内容类型（授权内容类型为%{authorized_human_content_types})",
          "other": "其内容类型与通过其内容检测到的内容类型不等效（授权内容类型为%{authorized_human_content_types})"
        },
        "dimension_height_not_equal_to": "高度必须等于 %{length} 像素",
        "dimension_height_not_greater_than_or_equal_to": "高度必须大于或等于 %{length} 像素",
        "dimension_height_not_included_in": "高度不在 %{min} 和 %{max} 像素之间",
        "dimension_height_not_less_than_or_equal_to": "高度必须小于或等于 %{length} 像素",
        "dimension_max_not_included_in": "必须小于或等于 %{width} x %{height} 像素",
        "dimension_min_not_included_in": "必须大于或等于 %{width} x %{height} 像素",
        "dimension_width_not_equal_to": "宽度必须等于 %{length} 像素",
        "dimension_width_not_greater_than_or_equal_to": "宽度必须大于或等于 %{length} 像素",
        "dimension_width_not_included_in": "宽度不在 %{min} 和 %{max} 像素之间",
        "dimension_width_not_less_than_or_equal_to": "宽度必须小于或等于 %{length} 像素",
        "duration_not_between": "持续时间必须在%{min}和%{max}之间（当前持续时间为%{duration})",
        "duration_not_equal_to": "持续时间必须等于%{exact}（当前持续时间为%{duration})",
        "duration_not_greater_than": "持续时间必须大于%{min}（当前持续时间为%{duration})",
        "duration_not_greater_than_or_equal_to": "持续时间必须大于或等于%{min}（当前持续时间为%{duration})",
        "duration_not_less_than": "持续时间必须小于%{max}（当前持续时间为%{duration})",
        "duration_not_less_than_or_equal_to": "持续时间必须小于或等于%{max}（当前持续时间为%{duration})",
        "file_not_processable": "未标识为有效的媒体文件",
        "file_size_not_between": "文件大小必须介于 %{min} 和 %{max} 之间（当前大小为 %{file_size})",
        "file_size_not_equal_to": "文件大小必须等于 %{exact}（当前大小为 %{file_size})",
        "file_size_not_greater_than": "文件大小必须大于 %{min}（当前大小为 %{file_size})",
        "file_size_not_greater_than_or_equal_to": "文件大小必须大于或等于 %{min}（当前大小为 %{file_size})",
        "file_size_not_less_than": "文件大小必须小于 %{max}（当前大小为 %{file_size})",
        "file_size_not_less_than_or_equal_to": "文件大小必须小于或等于 %{max}（当前大小为 %{file_size})",
        "limit_max_exceeded": {
          "one": "附加的文件太多（最大为%{max}文件,得到%{count})",
          "other": "附加的文件太多（最大为%{max}文件,得到%{count})",
          "zero": "未附加文件（最大为%{max}文件)"
        },
        "limit_min_not_reached": {
          "one": "仅附加1个文件（必须至少具有%{min}文件)",
          "other": "%{count}文件已连接（必须至少具有%{min}文件)",
          "zero": "未附加文件（必须至少具有%{min}文件)"
        },
        "limit_out_of_range": {
          "one": "仅附加1个文件（必须具有%{min}和%{max}文件之间)",
          "other": "文件总数必须在%{min}和%{max}文件之间（已连接%{count}文件)",
          "zero": "未附加文件（必须具有%{min}和%{max}文件之间)"
        },
        "media_metadata_missing": "不是有效的媒体文件",
        "pages_not_between": "页数必须介于 %{min} 和 %{max} 之间（当前页数为 %{pages})",
        "pages_not_equal_to": "页数必须等于 %{exact}（当前页数为%{pages})",
        "pages_not_greater_than": "页数必须大于 %{min}（当前页数为 %{pages})",
        "pages_not_greater_than_or_equal_to": "页数必须大于或等于 %{min}（当前页数为 %{pages})",
        "pages_not_less_than": "页数必须小于 %{max}（当前页数为 %{pages})",
        "pages_not_less_than_or_equal_to": "页数必须小于或等于 %{max}（当前页数为 %{pages})",
        "total_file_size_not_between": "总文件大小必须介于 %{min} 和 %{max} 之间（当前大小为 %{total_file_size})",
        "total_file_size_not_equal_to": "总文件大小必须等于 %{exact}（当前大小为 %{total_file_size})",
        "total_file_size_not_greater_than": "总文件大小必须大于 %{min}（当前大小为 %{total_file_size})",
        "total_file_size_not_greater_than_or_equal_to": "文件总大小必须大于或等于 %{min}（当前大小为 %{total_file_size})",
        "total_file_size_not_less_than": "总文件大小必须小于 %{max}（当前大小为 %{total_file_size})",
        "total_file_size_not_less_than_or_equal_to": "文件总大小必须小于或等于 %{max}（当前大小为 %{total_file_size})"
      }
    },
    "formtastic": {
      "cancel": "取消",
      "create": "新建%{model}",
      "no": "NO",
      "required": "必须的",
      "reset": "重置%{model}",
      "submit": "确认",
      "update": "更新%{model}",
      "yes": "YES"
    },
    "pagy": {
      "aria_label": {
        "nav": "页",
        "next": "下一页",
        "previous": "上一页"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "共 %{count} 项 %{item_name}，显示第 %{from}-%{to} 项",
        "no_count": "第 %{page} 页，共 %{pages} 页",
        "no_items": "未找到任何 %{item_name}",
        "single_page": "显示 %{count} 项 %{item_name}"
      },
      "input_nav_js": "第 %{page_input} 页，共 %{pages} 页",
      "item_name": "项",
      "limit_tag_js": "每页显示 %{limit_input} 项 %{item_name}",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "所有",
      "and": "并且",
      "any": "任意",
      "asc": "升序",
      "attribute": "属性",
      "combinator": "条件组合(combinator)",
      "condition": "条件",
      "desc": "降序",
      "or": "或者",
      "predicate": "基于(predicate)",
      "predicates": {
        "blank": "为空",
        "cont": "包含",
        "cont_all": "包含所有值",
        "cont_any": "包含任意一个值",
        "does_not_match": "不符合",
        "does_not_match_all": "不符合所有条件",
        "does_not_match_any": "符合任意条件",
        "end": "止于",
        "end_all": "止于任意值",
        "end_any": "止于任一值",
        "eq": "等于",
        "eq_all": "等于所有值",
        "eq_any": "等于任意值",
        "false": "等于false",
        "gt": "大于",
        "gt_all": "大于所有值",
        "gt_any": "大于任意一个值",
        "gteq": "大于等于",
        "gteq_all": "大于等于所有值",
        "gteq_any": "大于等于任意一个值",
        "in": "被包含",
        "in_all": "被所有值包含",
        "in_any": "被任意值包含",
        "lt": "小于",
        "lt_all": "小于所有值",
        "lt_any": "小于任意一个值",
        "lteq": "小于等于",
        "lteq_all": "小于等于所有值",
        "lteq_any": "小于等于任意一个值",
        "matches": "符合",
        "matches_all": "符合所有条件",
        "matches_any": "符合任意条件",
        "not_cont": "不包含",
        "not_cont_all": "不包含所有值",
        "not_cont_any": "不包含任意一个值",
        "not_end": "非止于",
        "not_end_all": "非止于任意值",
        "not_end_any": "非止于任一值",
        "not_eq": "不等于",
        "not_eq_all": "不等于所有值",
        "not_eq_any": "不等于任意值",
        "not_in": "不被包含",
        "not_in_all": "不被所有值包含",
        "not_in_any": "不被任意值包含",
        "not_null": "不是null",
        "not_start": "非始于",
        "not_start_all": "非始于任意值",
        "not_start_any": "非始于任一值",
        "null": "是null",
        "present": "有值",
        "start": "始于",
        "start_all": "始于任意值",
        "start_any": "始于任一值",
        "true": "等于true"
      },
      "search": "搜索",
      "sort": "排序",
      "value": "数值"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        }
      }
    }
  },
  "zh-HK": {
    "devise": {
      "failure": {
        "invited": "你有一個待處理的邀請, 請接受它以完成創建您的帳戶。"
      },
      "invitations": {
        "edit": {
          "header": "設置密碼",
          "submit_button": "設置密碼"
        },
        "invitation_removed": "你嘅邀請已被刪除。",
        "invitation_token_invalid": "提供嘅邀請令牌無效!",
        "new": {
          "header": "發送邀請",
          "submit_button": "發送邀請"
        },
        "no_invitations_remaining": "冇剩餘邀請",
        "send_instructions": "邀請電子郵件已發送到%{email)。",
        "updated": "你嘅密碼設置成功。 你而家已經登錄。",
        "updated_not_active": "你嘅密碼設置成功。"
      },
      "mailer": {
        "invitation_instructions": {
          "accept": "接受邀請",
          "accept_until": "此邀請就喺%{due_date} 中到期。",
          "hello": "你好%{email}",
          "ignore": "如果你唔想接受邀請, 請忽略此電子郵件。 系你訪問上面的連結並設置密碼之前, 不會創建您的帳戶。",
          "someone_invited_you": "有人邀請你去%{url}, 你可以通過下面嘅連結接受它。",
          "subject": "邀請指示"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": "頁",
        "next": "下一頁",
        "previous": "上一頁"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "總共 %{count} 項 %{item_name}，顯示第 %{from} 至 %{to} 項",
        "no_count": "第 %{page} 頁，共 %{pages} 頁",
        "no_items": "搵唔到任何 %{item_name}",
        "single_page": "顯示 %{count} 項 %{item_name}"
      },
      "input_nav_js": "第 %{page_input} 頁，共 %{pages} 頁",
      "item_name": "項",
      "limit_tag_js": "每頁顯示 %{limit_input} 項 %{item_name}",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        }
      }
    }
  },
  "zh-TW": {
    "active_admin": {
      "access_denied": {
        "message": "您沒有權限執行此項操作"
      },
      "any": "任何",
      "batch_actions": {
        "action_label": "%{title} 已選取",
        "button_label": "批次作業",
        "default_confirmation": "你確定你要這樣做？",
        "delete_confirmation": "你確定要刪除這些 %{plural_model} 嗎？",
        "labels": {
          "destroy": "刪除"
        },
        "selection_toggle_explanation": "（切換選取）",
        "succesfully_destroyed": {
          "one": "成功刪除 1 %{model}",
          "other": "成功刪除 %{count} %{plural_model}"
        }
      },
      "blank_slate": {
        "content": "尚無 %{resource_name}",
        "link": "建立一筆"
      },
      "cancel": "取消",
      "comments": {
        "add": "新增評論",
        "author": "作者",
        "author_missing": "匿名",
        "author_type": "作者身份",
        "body": "內文",
        "created_at": "建立",
        "delete": "刪除評論",
        "delete_confirmation": "你確定要刪除這些評論嗎？",
        "errors": {
          "empty_text": "評論儲存失敗，不允許空白的內容。"
        },
        "no_comments_yet": "尚無評論",
        "resource": "資源",
        "resource_type": "資源種類",
        "title_content": "(%{count}) 則評論"
      },
      "dashboard": "儀表板",
      "dashboard_welcome": {
        "call_to_action": "要新增儀表板內容，請查看 'app/admin/dashboard.rb'",
        "welcome": "歡迎來到 Active Admin，這是預設的儀表板頁面。"
      },
      "delete": "刪除",
      "delete_confirmation": "你確定要刪除嗎？",
      "delete_model": "刪除 %{model}",
      "details": "%{model} 明細",
      "devise": {
        "change_password": {
          "submit": "更改我的密碼",
          "title": "更改你的密碼"
        },
        "email": {
          "title": "電子郵件信箱"
        },
        "links": {
          "forgot_your_password": "忘記密碼？",
          "resend_confirmation_instructions": "重新發送確認信",
          "resend_unlock_instructions": "重新發送解鎖指示",
          "sign_in": "登入",
          "sign_in_with_omniauth_provider": "使用 %{provider} 登入",
          "sign_up": "註冊"
        },
        "login": {
          "remember_me": "記住我",
          "submit": "登入",
          "title": "登入"
        },
        "password": {
          "title": "密碼"
        },
        "resend_confirmation_instructions": {
          "submit": "重新發送確認信",
          "title": "重新發送確認信"
        },
        "reset_password": {
          "submit": "重置密碼",
          "title": "忘記密碼？"
        },
        "sign_up": {
          "submit": "註冊",
          "title": "註冊"
        },
        "subdomain": {
          "title": "子網域"
        },
        "unlock": {
          "submit": "重新發送解鎖指示",
          "title": "重新發送解鎖指示"
        },
        "username": {
          "title": "帳號"
        }
      },
      "download": "下載:",
      "dropdown_actions": {
        "button_label": "操作"
      },
      "edit": "編輯",
      "edit_model": "編輯 %{model}",
      "empty": "空的",
      "filters": {
        "buttons": {
          "clear": "清除篩選條件",
          "filter": "篩選"
        }
      },
      "has_many_delete": "刪除",
      "has_many_new": "增加新的 %{model}",
      "has_many_remove": "清除",
      "index_list": {
        "block": "清單",
        "blog": "部落格",
        "grid": "格狀",
        "table": "表格"
      },
      "logout": "登出",
      "main_content": "請實作 %{model}#main_content 以顯示內容。",
      "new_model": "新增 %{model}",
      "next": "下一個",
      "pagination": {
        "empty": "找不到 %{model} ",
        "entry": {
          "one": "筆",
          "other": "筆"
        },
        "multiple": "總計 <b>%{total}</b> 顯示 %{model} 中<b>%{from}&nbsp;-&nbsp;%{to}</b> 筆",
        "multiple_without_total": "顯示 %{model} 中<b>%{from}&nbsp;-&nbsp;%{to}</b> 筆",
        "one": "顯示 <b>1</b> %{model}",
        "one_page": "顯示 <b>全部 %{n}</b> %{model}"
      },
      "powered_by": "Powered by %{active_admin} %{version}",
      "previous": "前一個",
      "search_status": {
        "current_filters": "目前篩選條件：",
        "current_scope": "子集：",
        "headline": "搜尋條件:",
        "no_current_filters": "無"
      },
      "sidebars": {
        "filters": "篩選條件",
        "search_status": "搜尋條件"
      },
      "status_tag": {
        "no": "否",
        "unset": "否",
        "yes": "是"
      },
      "unsupported_browser": {
        "headline": "很抱歉，ActiveAdmin 已不再支援 Internet Explorer 8 以下版本的瀏覽器。",
        "recommendation": "建議您升級到最新版本的<a href=\"http://windows.microsoft.com/ie\">Internet Explorer</a>，<a href=\"https://chrome.google.com/\">Google Chrome</a>，或是 <a href=\"https://mozilla.org/firefox/\">Firefox</a>。",
        "turn_off_compatibility_view": "若您是使用 IE 9 或更新的版本，請確認<a href=\"https://support.microsoft.com/zh-tw/help/17471\">「相容性檢視」是關閉的</a>。"
      },
      "view": "檢視"
    },
    "activerecord": {
      "attributes": {
        "user": {
          "current_password": "當前密碼",
          "email": "電子郵箱",
          "password": "密碼",
          "password_confirmation": "密碼確認",
          "remember_me": "記憶登入訊息"
        }
      },
      "models": {
        "user": "用戶"
      }
    },
    "devise": {
      "confirmations": {
        "new": {
          "resend_confirmation_instructions": "重新發送確認信"
        }
      },
      "failure": {
        "invited": "你有一封設立帳號的邀請，請接受邀請來創建你的帳號。"
      },
      "invitations": {
        "edit": {
          "header": "設置密碼",
          "submit_button": "設置密碼"
        },
        "invitation_removed": "你的邀請被刪除了",
        "invitation_token_invalid": "所提供的邀請驗證無效！",
        "new": {
          "header": "發送邀請",
          "submit_button": "發送邀請"
        },
        "no_invitations_remaining": "邀請名額已用盡",
        "send_instructions": "邀請已發送至%{email)",
        "updated": "你的密碼已設置成功，現在你已經登入了。",
        "updated_not_active": "密碼設置成功"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "確認帳號",
          "greeting": "%{recipient} 你好!",
          "instruction": "您可以利用下面的連結確認您的帳戶的電子郵件:"
        },
        "invitation_instructions": {
          "accept": "接受邀請",
          "accept_until": "這封邀請將於 %{due_date} 到期。",
          "hello": "%{email} 你好，",
          "ignore": "如果你不想接受邀請, 請忽略這封電子郵件。只要未選取上述“接受邀請”的連結並且設置密碼，你的帳號就不會成立。",
          "someone_invited_you": "“邀請你加入%{url}。你可以通過以下的網頁連結接受邀請，並創設帳號：\"",
          "subject": "邀請"
        },
        "reset_password_instructions": {
          "action": "更改我的密碼",
          "greeting": "你好 %{recipient}!",
          "instruction": "有人要求更改密碼的連結，你可以利用下面的連結更改密碼。",
          "instruction_2": "如果你沒有要求，請忽略此電子郵件。",
          "instruction_3": "如果你沒有進入上面的連結，並建立新的密碼，你的密碼不會被改變。"
        },
        "unlock_instructions": {
          "action": "帳戶解鎖",
          "greeting": "你好 %{recipient}!",
          "instruction": "點擊下面的連結到您的帳戶進行解鎖:",
          "message": "由於多次的不成功的登入嘗試，您的帳戶已被鎖定。"
        }
      },
      "passwords": {
        "edit": {
          "change_my_password": "更改我的密碼",
          "change_your_password": "更改您的密碼",
          "confirm_new_password": "確認新密碼",
          "new_password": "新密碼"
        },
        "new": {
          "forgot_your_password": "忘記密碼？",
          "send_me_reset_password_instructions": "請寄重設密碼的說明信件給我"
        }
      },
      "registrations": {
        "edit": {
          "are_you_sure": "你確定嗎？",
          "cancel_my_account": "取消我的帳戶",
          "currently_waiting_confirmation_for_email": "等待 %{email} 的確認",
          "leave_blank_if_you_don_t_want_to_change_it": "不想修改的話就不需要填寫這個欄位",
          "title": "修改 %{resource}",
          "unhappy": "不喜歡",
          "update": "更新",
          "we_need_your_current_password_to_confirm_your_changes": "我們需要您的目前的密碼以確認您的更改"
        },
        "new": {
          "sign_up": "註冊"
        }
      },
      "sessions": {
        "new": {
          "sign_in": "登入"
        }
      },
      "shared": {
        "links": {
          "back": "返回",
          "didn_t_receive_confirmation_instructions": "沒有收到確認信件？",
          "didn_t_receive_unlock_instructions": "沒有收到解鎖信件？",
          "forgot_your_password": "忘記密碼？",
          "sign_in": "登入",
          "sign_in_with_provider": "用 %{provider} 登入",
          "sign_up": "註冊"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "重發解鎖說明信件"
        }
      }
    },
    "pagy": {
      "aria_label": {
        "nav": "頁",
        "next": "下一頁",
        "previous": "上一頁"
      },
      "gap": "&hellip;",
      "info_tag": {
        "multiple_pages": "共 %{count} 項 %{item_name}，顯示第 %{from} 至 %{to} 項",
        "no_count": "第 %{page} 頁，共 %{pages} 頁",
        "no_items": "未找到任何 %{item_name}",
        "single_page": "顯示 %{count} 項 %{item_name}"
      },
      "input_nav_js": "第 %{page_input} 頁，共 %{pages} 頁",
      "item_name": "項",
      "limit_tag_js": "每頁顯示 %{limit_input} 項 %{item_name}",
      "next": "&gt;",
      "p11n": "Other",
      "previous": "&lt;"
    },
    "ransack": {
      "all": "所有",
      "and": "而且",
      "any": "任何",
      "asc": "升冪排序",
      "attribute": "屬性",
      "combinator": "條件組合",
      "condition": "條件",
      "desc": "降冪排序",
      "or": "或者",
      "predicate": "基於",
      "predicates": {
        "blank": "為空",
        "cont": "包含",
        "cont_all": "包含所有值",
        "cont_any": "包含任何一個值",
        "does_not_match": "不符合",
        "does_not_match_all": "不符合所有條件",
        "does_not_match_any": "不符合任何一個條件",
        "end": "以某個值結尾",
        "end_all": "以所有值結尾",
        "end_any": "以任何一個值結尾",
        "eq": "等於",
        "eq_all": "等於所有值",
        "eq_any": "等於任何一個值",
        "false": "為假",
        "gt": "大於",
        "gt_all": "大於所有值",
        "gt_any": "大於任何一個值",
        "gteq": "大於或等於",
        "gteq_all": "大於或等於所有值",
        "gteq_any": "大於或等於任何一個值",
        "in": "被包含於",
        "in_all": "被包含於所有值",
        "in_any": "被包含於任何一個值",
        "lt": "小於",
        "lt_all": "小於所有值",
        "lt_any": "小於任何一個值",
        "lteq": "小於或等於",
        "lteq_all": "小於或等於所有值",
        "lteq_any": "小於或等於任何一個值",
        "matches": "符合",
        "matches_all": "符合所有條件",
        "matches_any": "符合任何一個條件",
        "not_cont": "不包含",
        "not_cont_all": "不包含所有值",
        "not_cont_any": "不包含任何一個值",
        "not_end": "不以某個值結尾",
        "not_end_all": "不以所有值結尾",
        "not_end_any": "不以任何一個值結尾",
        "not_eq": "不等於",
        "not_eq_all": "不等於所有值",
        "not_eq_any": "不等於任何一個值",
        "not_in": "不被包含於",
        "not_in_all": "不被包含於所有值",
        "not_in_any": "不被包含於任何一個值",
        "not_null": "不為 null",
        "not_start": "不以某個值開始",
        "not_start_all": "不以所有值開始",
        "not_start_any": "不以任何一值開始",
        "null": "為 null",
        "present": "有值",
        "start": "以某個值開始",
        "start_all": "以所有值開始",
        "start_any": "以任何一個值開始",
        "true": "為真"
      },
      "search": "搜尋",
      "sort": "排序",
      "value": "數值"
    },
    "time": {
      "formats": {
        "devise": {
          "mailer": {
            "invitation_instructions": {
              "accept_until_format": "%B %d, %Y %I:%M %p"
            }
          }
        }
      }
    }
  },
  "zh_CN": {
    "devise": {
      "failure": {
        "expired": "由于不活跃，你的账户已过期。请联系站点管理员。",
        "session_limited": "你的登录凭据已在另一个浏览器上被使用。请重新登录以在此浏览器继续。"
      },
      "invalid_captcha": "验证码无效。",
      "invalid_security_question": "安全问题答案无效。",
      "paranoid_verification_code": {
        "show": {
          "submit": "提交",
          "submit_verification_code": "提交验证码",
          "verification_code": "验证码"
        },
        "updated": "接受验证码"
      },
      "paranoid_verify": {
        "code_required": "请输入我们支持团队提供的代码"
      },
      "password_expired": {
        "change_required": "你的密码已过期，请更新密码。",
        "show": {
          "change_my_password": "更改密码",
          "current_password": "当前密码",
          "new_password": "新密码",
          "new_password_confirmation": "确认新密码",
          "renew_your_password": "更新你的密码"
        },
        "updated": "你的新密码已保存。"
      }
    },
    "errors": {
      "messages": {
        "equal_to_current_password": "必须与当前密码不同。",
        "equal_to_email": "必须与电子邮件地址不同。",
        "password_complexity": {
          "digit": {
            "one": "必须包含至少1个数字",
            "other": "必须包含至少%{count}个数字"
          },
          "lower": {
            "one": "必须包含至少1个小写字母",
            "other": "必须包含至少%{count}个小写字母"
          },
          "symbol": {
            "one": "必须包含至少1个特殊符号（!\"#$%&'()*+,-./:;<=>?@[\\]^_‘{|}~)",
            "other": "必须包含至少%{count}个特殊符号（!\"#$%&'()*+,-./:;<=>?@[\\]^_‘{|}~）"
          },
          "upper": {
            "one": "必须包含至少1个大写字母",
            "other": "必须包含至少%{count}个大写字母"
          }
        },
        "taken_in_past": "曾被使用过。"
      }
    }
  },
  "zh_TW": {
    "devise": {
      "failure": {
        "expired": "你的帳號因過久沒使用而已經過期，請洽網站管理員。",
        "session_limited": "你的登入憑證已在另一個瀏覽器上被使用，請重新登入以在此瀏覽器繼續使用。"
      },
      "invalid_captcha": "輸入的驗證碼無效。",
      "invalid_security_question": "安全問題答案無效。",
      "paranoid_verification_code": {
        "show": {
          "submit": "送出",
          "submit_verification_code": "送出驗證碼",
          "verification_code": "驗證碼"
        },
        "updated": "接受驗證碼"
      },
      "paranoid_verify": {
        "code_required": "請輸入由我們客服團隊提供的代碼"
      },
      "password_expired": {
        "change_required": "你的密碼已經過期，請更新密碼。",
        "show": {
          "change_my_password": "更改我的密碼",
          "current_password": "目前密碼",
          "new_password": "新密碼",
          "new_password_confirmation": "確認新密碼",
          "renew_your_password": "更新你的密碼"
        },
        "updated": "你的新密碼已儲存"
      }
    },
    "errors": {
      "messages": {
        "equal_to_current_password": "必須與目前密碼不同。",
        "equal_to_email": "必須與電子郵件地址不同。",
        "password_complexity": {
          "digit": {
            "one": "必須包含至少一個數字",
            "other": "必須包含至少 %{count} 個數字"
          },
          "lower": {
            "one": "必須包含至少一個小寫字母",
            "other": "必須包含至少 %{count} 個小寫字母"
          },
          "symbol": {
            "one": "必須包含至少一個特殊符號",
            "other": "必須包含至少 %{count} 個特殊符號"
          },
          "upper": {
            "one": "必須包含至少一個大寫字母",
            "other": "必須包含至少 %{count} 個大寫字母"
          }
        },
        "taken_in_past": "曾被使用過。"
      }
    }
  }
}